var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// <define:process.env>
var define_process_env_default;
var init_define_process_env = __esm({
  "<define:process.env>"() {
    define_process_env_default = { GITHUB_STATE: "/home/runner/work/_temp/_runner_file_commands/save_state_359a797f-6fb6-4afd-83c1-7eda730bc17a", npm_package_devDependencies_ts_node: "^10.4.0", npm_package_devDependencies__types_node: "^16.11.17", npm_package_exports___index_css: "./dist/index.css", npm_package_exports___require: "./dist/index.cjs.js", STATS_TRP: "true", DEPLOYMENT_BASEPATH: "/opt/runner", DOTNET_NOLOGO: "1", npm_package_dependencies_screenfull: "^5.1.0", npm_package_dependencies_react_draggable: "^4.4.5", npm_package_dependencies__radix_ui_react_switch: "1.0.0", npm_package_dependencies__100mslive_hms_whiteboard: "0.0.23", USER: "runner", npm_package_devDependencies_jest: "26.6.0", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v18.20.7 linux x64", npm_config_always_auth: "", NX_WORKSPACE_ROOT: "/home/runner/work/web-sdks/web-sdks", npm_package_scripts_babel: "npx storybook@latest babelrc", CI: "true", npm_package_devDependencies__size_limit_file: "^5.0.3", npm_config_bin_links: "true", npm_config_wrap_output: "", npm_package_dependencies__radix_ui_react_tabs: "1.0.0", npm_package_dependencies__100mslive_react_sdk: "0.10.33", RUNNER_ENVIRONMENT: "github-hosted", GITHUB_ENV: "/home/runner/work/_temp/_runner_file_commands/set_env_359a797f-6fb6-4afd-83c1-7eda730bc17a", PIPX_HOME: "/opt/pipx", npm_node_execpath: "/opt/hostedtoolcache/node/18.20.7/x64/bin/node", npm_config_init_version: "1.0.0", npm_package_dependencies__emoji_mart_react: "^1.0.1", npm_package_dependencies__emoji_mart_data: "^1.0.6", npm_package_dependencies__100mslive_hms_virtual_background: "1.13.33", JAVA_HOME_8_X64: "/usr/lib/jvm/temurin-8-jdk-amd64", NODE_AUTH_TOKEN: "XXXXX-XXXXX-XXXXX-XXXXX", SHLVL: "1", npm_package_dependencies__radix_ui_react_tooltip: "1.0.6", npm_package_dependencies__radix_ui_react_popover: "1.0.6", npm_package_dependencies__100mslive_types_prebuilt: "0.12.12", npm_package_peerDependencies_react: ">=17.0.2 <19.0.0", npm_package_devDependencies__storybook_addon_links: "^7.0.27", npm_package_files_0: "dist", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^5.4.0", npm_package_dependencies__radix_ui_react_dialog: "1.0.4", npm_package_devDependencies__types_react_window: "^1.8.5", npm_package_files_1: "src", npm_package_repository_directory: "packages/roomkit-react", RUNNER_TEMP: "/home/runner/work/_temp", GITHUB_EVENT_PATH: "/home/runner/work/_temp/_github_workflow/event.json", npm_package_scripts_controller: "cd packages/hls-controller && yarn start", npm_package_dependencies__stitches_react: "1.3.1-1", JAVA_HOME_11_X64: "/usr/lib/jvm/temurin-11-jdk-amd64", PIPX_BIN_DIR: "/opt/pipx_bin", GITHUB_REPOSITORY_OWNER: "100mslive", npm_package_engines_node: ">=16", npm_package_devDependencies_typedoc_plugin_markdown: "^3.14.0", npm_config_init_license: "MIT", GRADLE_HOME: "/usr/share/gradle-8.13", ANDROID_NDK_LATEST_HOME: "/usr/local/lib/android/sdk/ndk/28.0.13004108", JAVA_HOME_21_X64: "/usr/lib/jvm/temurin-21-jdk-amd64", STATS_RDCL: "true", GITHUB_RETENTION_DAYS: "90", YARN_WRAP_OUTPUT: "false", npm_config_version_tag_prefix: "v", GITHUB_REPOSITORY_OWNER_ID: "73883131", POWERSHELL_DISTRIBUTION_CHANNEL: "GitHub-Actions-ubuntu24", AZURE_EXTENSION_DIR: "/opt/az/azcliextensions", GITHUB_HEAD_REF: "", npm_package_scripts_lint_fix: "yarn lint --fix", npm_config_userconfig: "/home/runner/work/_temp/.npmrc", npm_package_devDependencies__storybook_addon_a11y: "^7.0.27", SYSTEMD_EXEC_PID: "840", npm_package_scripts_postinstall: "husky install && lerna bootstrap", npm_package_devDependencies_husky: "^6.0.0", npm_package_dependencies_recordrtc: "^5.6.2", npm_package_dependencies_eventemitter2: "^6.4.9", npm_package_dependencies__radix_ui_react_label: "1.0.0", npm_package_dependencies__radix_ui_react_dropdown_menu: "2.0.5", npm_package_keywords_0: "100mslive", GITHUB_GRAPHQL_URL: "https://api.github.com/graphql", npm_package_description: "100ms Room Kit provides simple & easy to use UI components to build Live Streaming & Video Conferencing experiences in your apps.", npm_package_devDependencies_typescript: "~4.7.4", npm_package_devDependencies_typedoc: "^0.24.8", npm_package_devDependencies_babel_loader: "^8.2.5", npm_package_keywords_1: "react", NVM_DIR: "/home/runner/.nvm", npm_package_readmeFilename: "README.md", npm_package_devDependencies_react: "^18.1.0", npm_package_devDependencies__babel_preset_env: "^7.22.5", npm_package_keywords_2: "prebuilt", DOTNET_SKIP_FIRST_TIME_EXPERIENCE: "1", GOROOT_1_21_X64: "/opt/hostedtoolcache/go/1.21.13/x64", JAVA_HOME_17_X64: "/usr/lib/jvm/temurin-17-jdk-amd64", ImageVersion: "20250309.1.0", npm_package_devDependencies_prettier: "^2.4.1", npm_package_devDependencies_babel_jest: "^26.6.0", npm_package_scripts_dev: "node ../../scripts/dev", npm_package_keywords_3: "roomkit", RUNNER_OS: "Linux", GITHUB_API_URL: "https://api.github.com", GOROOT_1_22_X64: "/opt/hostedtoolcache/go/1.22.12/x64", SWIFT_PATH: "/usr/share/swift/usr/bin", FORCE_COLOR: "true", npm_package_dependencies__radix_ui_react_toast: "1.0.0", npm_package_dependencies__radix_ui_react_radio_group: "1.0.0", npm_package_dependencies__100mslive_hms_noise_cancellation: "0.0.1", npm_package_devDependencies__babel_preset_typescript: "^7.22.5", npm_package_exports___default: "./dist/index.js", RUNNER_USER: "runner", STATS_V3PS: "true", CHROMEWEBDRIVER: "/usr/local/share/chromedriver-linux64", GOROOT_1_23_X64: "/opt/hostedtoolcache/go/1.23.7/x64", JOURNAL_STREAM: "8:4995", GITHUB_WORKFLOW: "Publish Packages", _: "/usr/local/bin/yarn", npm_package_devDependencies_ts_jest: "26.5.6", npm_package_devDependencies_lerna: "^5.6.2", npm_package_devDependencies__types_jest: "^27.0.3", npm_package_devDependencies__commitlint_config_conventional: "^19.6.0", npm_package_private: "true", npm_package_dependencies__radix_ui_react_accordion: "1.0.0", npm_package_devDependencies__babel_preset_react: "^7.22.5", npm_package_module: "dist/index.js", MEMORY_PRESSURE_WATCH: "/sys/fs/cgroup/system.slice/runner-provisioner.service/memory.pressure", npm_package_scripts_lint: "eslint -c .eslintrc --no-error-on-unmatched-pattern src --ext .js --ext .jsx --ext .ts --ext .tsx", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^5.4.0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_dependencies_react_window: "^1.8.7", npm_package_dependencies__100mslive_hls_player: "0.3.33", npm_package_devDependencies__types_lodash_merge: "^4.6.6", npm_package_devDependencies__storybook_cli: "^7.0.27", ACTIONS_RUNNER_ACTION_ARCHIVE_CACHE: "/opt/actionarchivecache", STATS_D: "false", GITHUB_RUN_ID: "13923170479", STATS_VMFE: "true", npm_package_workspaces_0: "packages/*", npm_package_scripts_store: "cd packages/hms-video-store && yarn start", npm_package_devDependencies__babel_core: "^7.18.2", npm_package_dependencies_ts_pattern: "4.3.0", npm_package_devDependencies__storybook_addon_interactions: "^7.0.27", npm_package_devDependencies__storybook_addon_actions: "^7.0.27", GITHUB_REF_TYPE: "branch", BOOTSTRAP_HASKELL_NONINTERACTIVE: "1", GITHUB_WORKFLOW_SHA: "6a043f0362fdbf8e5d643ee56845714aff509c5b", GITHUB_BASE_REF: "", ImageOS: "ubuntu24", npm_package_workspaces_1: "examples/*", npm_package_scripts_start: 'concurrently "yarn dev" "yarn types"', npm_config_ignore_scripts: "", NX_TASK_HASH: "0fbf038b481b3daf66db14d6a591f319c6c654f63e27f58aee963bec0a76ea33", npm_package_exports___import: "./dist/index.js", GITHUB_WORKFLOW_REF: "100mslive/web-sdks/.github/workflows/publish.yml@refs/heads/main", PERFLOG_LOCATION_SETTING: "RUNNER_PERFLOG", GITHUB_ACTION_REPOSITORY: "", npm_package_scripts_prebuilt: "cd packages/roomkit-react && yarn start", npm_package_devDependencies_postcss_loader: "^6.2.1", npm_package_devDependencies_esbuild_loader: "^4.0.2", PATH: "/tmp/yarn--1742300939357-0.965242875943193:/home/runner/work/web-sdks/web-sdks/packages/roomkit-react/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/web-sdks/web-sdks/node_modules/.bin:/opt/hostedtoolcache/node/18.20.7/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1742300939168-0.437013717274068:/home/runner/work/web-sdks/web-sdks/packages/roomkit-react/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/web-sdks/web-sdks/node_modules/.bin:/opt/hostedtoolcache/node/18.20.7/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1742300913208-0.07399086307132263:/home/runner/work/web-sdks/web-sdks/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/web-sdks/web-sdks/node_modules/.bin:/opt/hostedtoolcache/node/18.20.7/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1742300913037-0.3026164258994417:/home/runner/work/web-sdks/web-sdks/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/web-sdks/web-sdks/node_modules/.bin:/opt/hostedtoolcache/node/18.20.7/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/18.20.7/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/18.20.7/x64/bin/node", ANT_HOME: "/usr/share/ant", DOTNET_MULTILEVEL_LOOKUP: "0", RUNNER_TRACKING_ID: "github_9a70939f-76cb-4f33-9d1d-a572bbe3da0d", INVOCATION_ID: "2571637f93354e258c04183c35280e7d", NPM_CONFIG_USERCONFIG: "/home/runner/work/_temp/.npmrc", RUNNER_TOOL_CACHE: "/opt/hostedtoolcache", npm_package_scripts_size: "size-limit", npm_package_devDependencies_size_limit: "^5.0.3", npm_package_name: "@100mslive/roomkit-react", npm_package_devDependencies__storybook_react_webpack5: "^7.0.27", npm_package_repository_type: "git", GITHUB_ACTION: "__run_3", GITHUB_RUN_NUMBER: "746", GITHUB_TRIGGERING_ACTOR: "raviteja83", RUNNER_ARCH: "X64", XDG_RUNTIME_DIR: "/run/user/1001", AGENT_TOOLSDIRECTORY: "/opt/hostedtoolcache", npm_package_lint_staged____js_ts_jsx_tsx_: "eslint", npm_package_devDependencies_babel_plugin_istanbul: "^6.1.1", LERNA_PACKAGE_NAME: "@100mslive/roomkit-react", npm_package_dependencies__radix_ui_react_select: "1.0.0", npm_package_size_limit_0_limit: "20 KB", npm_package_devDependencies__commitlint_cli: "^19.6.0", LANG: "C.UTF-8", VCPKG_INSTALLATION_ROOT: "/usr/local/share/vcpkg", npm_package_size_limit_1_limit: "20 KB", npm_package_devDependencies_eslint_plugin_simple_import_sort: "^8.0.0", npm_package_devDependencies_eslint: "^8.9.0", npm_package_dependencies_react_intersection_observer: "^9.4.3", npm_package_dependencies_react_dom: "^18.2.0", npm_package_devDependencies__types_mdx: "2.0.2", CONDA: "/usr/share/miniconda", RUNNER_NAME: "GitHub Actions 397", XDG_CONFIG_HOME: "/home/runner/.config", STATS_VMD: "true", GITHUB_REF_NAME: "main", GITHUB_REPOSITORY: "100mslive/web-sdks", STATS_D_D: "false", npm_lifecycle_script: "rm -rf dist && node ../../scripts/build-webapp", npm_package_size_limit_2_limit: "400 KB", npm_package_resolutions_loader_utils: "^2.0.4", npm_package_devDependencies_dotenv: "^14.2.0", npm_package_dependencies__radix_ui_react_slider: "1.0.0", npm_package_scripts_types_build: "tsc -p tsconfig.json", npm_package_main: "dist/index.cjs.js", STATS_UE: "true", ANDROID_NDK_ROOT: "/usr/local/lib/android/sdk/ndk/27.2.12479018", GITHUB_ACTION_REF: "", DEBIAN_FRONTEND: "noninteractive", npm_package_size_limit_3_limit: "20 KB", npm_package_size_limit_0_path: "packages/hms-video-store/dist/index.cjs.js", npm_package_scripts_cypress_open: "cypress open", npm_package_scripts_lerna_publish: "lerna publish from-package --dist-tag $PUBLISH_FLAG --yes --no-verify-access", npm_package_scripts_test: "yarn build --no-private && lerna run test", npm_package_devDependencies_concurrently: "^6.4.0", npm_config_version_git_message: "v%s", npm_package_dependencies__radix_ui_react_checkbox: "1.0.0", npm_package_dependencies__100mslive_react_icons: "0.10.33", npm_package_scripts_types: "tsc -w", GITHUB_REPOSITORY_ID: "429826515", GITHUB_ACTIONS: "true", STATS_PIP: "false", npm_lifecycle_event: "build:only", npm_package_version: "0.3.33", npm_package_size_limit_4_limit: "20 KB", npm_package_size_limit_1_path: "packages/hms-video-store/dist/index.js", npm_package_resolutions_axios: "^1.7.4", npm_package_scripts_build_only: "rm -rf dist && node ../../scripts/build-webapp", npm_package_devDependencies__types_react: "^18.1.0", npm_package_sideEffects: "false", npm_package_repository_url: "https://github.com/100mslive/web-sdks.git", npm_package_source: "src/index.ts", GITHUB_REF_PROTECTED: "true", npm_config_argv: '{"remain":[],"cooked":["run","test"],"original":["test"]}', npm_package_size_limit_5_limit: "20 KB", npm_package_size_limit_2_path: "packages/roomkit-react/dist/index.cjs.js", npm_package_scripts_build: "yarn build:only && yarn types:build", npm_package_devDependencies_tslib: "^2.2.0", npm_package_devDependencies_nx: "^14.5.1", npm_package_devDependencies_lint_staged: "^12.0.3", NX_CLI_SET: "true", npm_package_dependencies_uuid: "^8.3.2", npm_package_dependencies_react_virtualized_auto_sizer: "^1.0.7", npm_package_dependencies_lodash_merge: "^4.6.2", npm_package_dependencies_emoji_mart: "^5.2.2", GITHUB_WORKSPACE: "/home/runner/work/web-sdks/web-sdks", ACCEPT_EULA: "Y", GITHUB_JOB: "publish_packages", RUNNER_PERFLOG: "/home/runner/perflog", npm_package_size_limit_6_limit: "150 KB", npm_package_size_limit_3_path: "packages/roomkit-react/dist/index.js", npm_package_devDependencies_cypress: "^9.5.2", GITHUB_SHA: "6a043f0362fdbf8e5d643ee56845714aff509c5b", GITHUB_RUN_ATTEMPT: "1", STATS_D_TC: "true", npm_package_size_limit_7_limit: "100 KB", npm_package_size_limit_4_path: "packages/hms-virtual-background/dist/index.cjs.js", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_dependencies_qrcode_react: "^3.1.0", GITHUB_REF: "refs/heads/main", GITHUB_ACTOR: "raviteja83", ANDROID_SDK_ROOT: "/usr/local/lib/android/sdk", npm_package_license: "MIT", npm_package_size_limit_5_path: "packages/hms-virtual-background/dist/index.js", npm_config_strict_ssl: "true", npm_package_size_limit_6_path: "packages/react-icons/dist/index.cjs.js", npm_package_scripts_format: "prettier -w src/**", npm_package_devDependencies_eslint_plugin_prettier: "^4.0.0", npm_package_devDependencies_eslint_config_react_app: "^7.0.0", NX_TASK_TARGET_PROJECT: "@100mslive/roomkit-react", GITHUB_PATH: "/home/runner/work/_temp/_runner_file_commands/add_path_359a797f-6fb6-4afd-83c1-7eda730bc17a", JAVA_HOME: "/usr/lib/jvm/temurin-17-jdk-amd64", PWD: "/home/runner/work/web-sdks/web-sdks/packages/roomkit-react", GITHUB_ACTOR_ID: "6763261", RUNNER_WORKSPACE: "/home/runner/work/web-sdks", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_size_limit_7_path: "packages/react-icons/dist/index.js", npm_package_scripts_ybys: "yarn && yarn build --no-private && yarn storybook", npm_package_dependencies__radix_ui_react_progress: "1.0.0", HOMEBREW_CLEANUP_PERIODIC_FULL_DAYS: "3650", STATS_TIS: "mining", GITHUB_EVENT_NAME: "workflow_dispatch", HOMEBREW_NO_AUTO_UPDATE: "1", ANDROID_HOME: "/usr/local/lib/android/sdk", GITHUB_SERVER_URL: "https://github.com", GECKOWEBDRIVER: "/usr/local/share/gecko_driver", GHCUP_INSTALL_BASE_PREFIX: "/usr/local", GITHUB_OUTPUT: "/home/runner/work/_temp/_runner_file_commands/set_output_359a797f-6fb6-4afd-83c1-7eda730bc17a", npm_package_scripts_prestart: "rm -rf dist && yarn types:build", npm_package_author_name: "100ms", EDGEWEBDRIVER: "/usr/local/share/edge_driver", STATS_EXT: "true", npm_package_scripts_build_storybook: "sb build", npm_package_devDependencies_postcss: "^8.4.5", npm_package_devDependencies_esbuild: "^0.18.13", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_dependencies_worker_timers: "^7.0.40", npm_package_typings: "dist/index.d.ts", ANDROID_NDK: "/usr/local/lib/android/sdk/ndk/27.2.12479018", SGX_AESM_ADDR: "1", CHROME_BIN: "/usr/bin/google-chrome", npm_package_scripts_storybook: "sb dev -p 6006", npm_package_devDependencies_esbuild_plugin_postcss2: "0.1.1", npm_package_dependencies_react_swipeable: "^7.0.1", npm_package_devDependencies_babel_plugin_react_require: "3.1.3", npm_package_devDependencies__storybook_testing_library: "^0.2.0", npm_package_devDependencies__storybook_addon_essentials: "^7.0.27", SELENIUM_JAR_PATH: "/usr/share/java/selenium-server.jar", MEMORY_PRESSURE_WRITE: "c29tZSAyMDAwMDAgMjAwMDAwMAA=", STATS_EXTP: "https://provjobdprod.z13.web.core.windows.net/settings/provjobdsettings-latest/provjobd.data", npm_package_scripts_reactsdk: "cd packages/react-sdk && yarn start", npm_package_dependencies_react_use: "^17.4.0", npm_package_dependencies__radix_ui_react_collapsible: "1.0.0", npm_package_devDependencies_storybook_dark_mode: "^3.0.0", npm_package_devDependencies_knip: "^5.11.0", npm_package_devDependencies__storybook_react: "^7.0.27", INIT_CWD: "/home/runner/work/web-sdks/web-sdks", ANDROID_NDK_HOME: "/usr/local/lib/android/sdk/ndk/27.2.12479018", GITHUB_STEP_SUMMARY: "/home/runner/work/_temp/_runner_file_commands/step_summary_359a797f-6fb6-4afd-83c1-7eda730bc17a" };
  }
});

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    init_define_process_env();
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data3, result = [];
        while (!(data3 = iterator.next()).done) {
          result.push(data3.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data3 = iteratees[iterIndex], iteratee2 = data3.iteratee, type = data3.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data3 = this.__data__;
          if (nativeCreate) {
            var result2 = data3[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data3, key) ? data3[key] : undefined2;
        }
        function hashHas(key) {
          var data3 = this.__data__;
          return nativeCreate ? data3[key] !== undefined2 : hasOwnProperty.call(data3, key);
        }
        function hashSet(key, value) {
          var data3 = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data3[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data3 = this.__data__, index = assocIndexOf(data3, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data3.length - 1;
          if (index == lastIndex) {
            data3.pop();
          } else {
            splice.call(data3, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data3 = this.__data__, index = assocIndexOf(data3, key);
          return index < 0 ? undefined2 : data3[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data3 = this.__data__, index = assocIndexOf(data3, key);
          if (index < 0) {
            ++this.size;
            data3.push([key, value]);
          } else {
            data3[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data3 = getMapData(this, key), size2 = data3.size;
          data3.set(key, value);
          this.size += data3.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data3 = this.__data__ = new ListCache(entries);
          this.size = data3.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data3 = this.__data__, result2 = data3["delete"](key);
          this.size = data3.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data3 = this.__data__;
          if (data3 instanceof ListCache) {
            var pairs = data3.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data3.size;
              return this;
            }
            data3 = this.__data__ = new MapCache(pairs);
          }
          data3.set(key, value);
          this.size = data3.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer2, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer2) {
            result2 = object ? customizer2(value, key, object, stack) : customizer2(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray2(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer2, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer2, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer2, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout3(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer2, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer2, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer2, equalFunc, stack) {
          var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer2, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer2, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer2, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer2, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer2) {
          var index = matchData.length, length = index, noCustomizer = !customizer2;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data3 = matchData[index];
            if (noCustomizer && data3[2] ? data3[1] !== object[data3[0]] : !(data3[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data3 = matchData[index];
            var key = data3[0], objValue = object[key], srcValue = data3[1];
            if (noCustomizer && data3[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer2) {
                var result2 = customizer2(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer2, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject2(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer2, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer2, stack);
            } else {
              var newValue = customizer2 ? customizer2(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer2, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer2 ? customizer2(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray2(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer2, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray2(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer2) {
          if (!isObject2(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer2 ? customizer2(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data3) {
          metaMap.set(func, data3);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray2(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer2) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer2);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray2(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout3 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer2) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer2 ? customizer2(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer2 = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer2 = assigner.length > 3 && typeof customizer2 == "function" ? (length--, customizer2) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer2 = length < 3 ? undefined2 : customizer2;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer2);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject2(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data3 = funcName == "wrapper" ? getData(func) : undefined2;
              if (data3 && isLaziable(data3[0]) && data3[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data3[4].length && data3[9] == 1) {
                wrapper = wrapper[getFuncName(data3[0])].apply(wrapper, data3[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray2(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data3 = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data3) {
            mergeData(newData, data3);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data3 ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer2, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer2) {
              var compared = isPartial ? customizer2(othValue, arrValue, index, other, array, stack) : customizer2(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer2, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer2, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer2, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer2, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer2, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer2) {
              var compared = isPartial ? customizer2(othValue, objValue, key, other, object, stack) : customizer2(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer2, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data3 = array[length], otherFunc = data3.func;
            if (otherFunc == null || otherFunc == func) {
              return data3.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data3 = map2.__data__;
          return isKeyable(key) ? data3[typeof key == "string" ? "string" : "hash"] : data3.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data3 = transforms[index], size2 = data3.size;
            switch (data3.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match18 = source.match(reWrapDetails);
          return match18 ? match18[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray2(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject2(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray2(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data3 = getData(other);
          return !!data3 && func === data3[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data3, source) {
          var bitmask = data3[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data3[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data3;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data3[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data3[3];
            data3[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data3[4] = partials ? replaceHolders(data3[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data3[5];
            data3[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data3[6] = partials ? replaceHolders(data3[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data3[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data3[8] = data3[8] == null ? source[8] : nativeMin(data3[8], source[8]);
          }
          if (data3[9] == null) {
            data3[9] = source[9];
          }
          data3[0] = source[0];
          data3[1] = newBitmask;
          return data3;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout3 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match18, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match18);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray2(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray2(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray2(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray2(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray2(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray2(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray2(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray2(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray2(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray2(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray2(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout3(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout3(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout3(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout3(timerId);
                timerId = setTimeout3(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout3(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray2(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer2) {
          customizer2 = typeof customizer2 == "function" ? customizer2 : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer2);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer2) {
          customizer2 = typeof customizer2 == "function" ? customizer2 : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer2);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt2 = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray2 = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer2) {
          customizer2 = typeof customizer2 == "function" ? customizer2 : undefined2;
          var result2 = customizer2 ? customizer2(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer2) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite2(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer2) {
          customizer2 = typeof customizer2 == "function" ? customizer2 : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer2);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer2) {
          copyObject(source, keysIn(source), object, customizer2);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer2) {
          copyObject(source, keys(source), object, customizer2);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith2, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge2 = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith2 = createAssigner(function(object, source, srcIndex, customizer2) {
          baseMerge(object, source, srcIndex, customizer2);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer2) {
          customizer2 = typeof customizer2 == "function" ? customizer2 : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer2);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray2(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer2) {
          customizer2 = typeof customizer2 == "function" ? customizer2 : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer2);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match18, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match18.length;
            return match18;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match18, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match18 = separator.exec(substring)) {
                var newEnd = match18.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray2(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge2;
        lodash.mergeWith = mergeWith2;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt2;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray2;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite2;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject2;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray2(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray2(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports);
  }
});

// ../../node_modules/ua-parser-js/src/ua-parser.js
var require_ua_parser = __commonJS({
  "../../node_modules/ua-parser-js/src/ua-parser.js"(exports, module) {
    init_define_process_env();
    (function(window2, undefined2) {
      "use strict";
      var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
      var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
      var extend = function(regexes2, extensions) {
        var mergedRegexes = {};
        for (var i in regexes2) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes2[i]);
          } else {
            mergedRegexes[i] = regexes2[i];
          }
        }
        return mergedRegexes;
      }, enumerize = function(arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
          enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
      }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      }, lowerize = function(str) {
        return str.toLowerCase();
      }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined2;
      }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };
      var rgxMapper = function(ua, arrays) {
        var i = 0, j2, k2, p, q, matches, match18;
        while (i < arrays.length && !matches) {
          var regex = arrays[i], props = arrays[i + 1];
          j2 = k2 = 0;
          while (j2 < regex.length && !matches) {
            if (!regex[j2]) {
              break;
            }
            matches = regex[j2++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match18 = matches[++k2];
                q = props[p];
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length === 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      this[q[0]] = q[1].call(this, match18);
                    } else {
                      this[q[0]] = q[1];
                    }
                  } else if (q.length === 3) {
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      this[q[0]] = match18 ? q[1].call(this, match18, q[2]) : undefined2;
                    } else {
                      this[q[0]] = match18 ? match18.replace(q[1], q[2]) : undefined2;
                    }
                  } else if (q.length === 4) {
                    this[q[0]] = match18 ? q[3].call(this, match18.replace(q[1], q[2])) : undefined2;
                  }
                } else {
                  this[q] = match18 ? match18 : undefined2;
                }
              }
            }
          }
          i += 2;
        }
      }, strMapper = function(str, map) {
        for (var i in map) {
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j2 = 0; j2 < map[i].length; j2++) {
              if (has(map[i][j2], str)) {
                return i === UNKNOWN ? undefined2 : i;
              }
            }
          } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined2 : i;
          }
        }
        return str;
      };
      var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": ["NT 5.1", "NT 5.2"],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": ["NT 6.4", "NT 10.0"],
        "RT": "ARM"
      };
      var regexes = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [VERSION, [NAME, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [VERSION, [NAME, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [NAME, VERSION],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [VERSION, [NAME, OPERA + " Mini"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [VERSION, [NAME, OPERA]],
          [
            // Mixed
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
            // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
            // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,
            // Heytap/Ovi
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [NAME, VERSION],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [VERSION, [NAME, "UC" + BROWSER]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i
          ],
          [VERSION, [NAME, "WeChat(Win) Desktop"]],
          [
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [VERSION, [NAME, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [VERSION, [NAME, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [VERSION, [NAME, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [VERSION, [NAME, "Yandex"]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [VERSION, [NAME, FIREFOX + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [VERSION, [NAME, OPERA + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [VERSION, [NAME, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [VERSION, [NAME, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [VERSION, [NAME, OPERA + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [VERSION, [NAME, "MIUI " + BROWSER]],
          [
            /fxios\/([-\w\.]+)/i
            // Firefox for iOS
          ],
          [VERSION, [NAME, FIREFOX]],
          [
            /\bqihu|(qi?ho?o?|360)browser/i
            // 360
          ],
          [[NAME, "360 " + BROWSER]],
          [
            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
          ],
          [[NAME, /(.+)/, "$1 " + BROWSER], VERSION],
          [
            // Oculus/Samsung/Sailfish/Huawei Browser
            /(comodo_dragon)\/([\w\.]+)/i
            // Comodo Dragon
          ],
          [[NAME, /_/g, " "], VERSION],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
            // QQBrowser/Baidu App/2345 Browser
          ],
          [NAME, VERSION],
          [
            /(metasr)[\/ ]?([\w\.]+)/i,
            // SouGouBrowser
            /(lbbrowser)/i,
            // LieBao Browser
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [NAME],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[NAME, FACEBOOK], VERSION],
          [
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram
          ],
          [NAME, VERSION],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [VERSION, [NAME, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [VERSION, [NAME, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [VERSION, [NAME, CHROME + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[NAME, CHROME + " WebView"], VERSION],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [VERSION, [NAME, "Android " + BROWSER]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [NAME, VERSION],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [VERSION, [NAME, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [VERSION, NAME],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [NAME, [VERSION, strMapper, oldSafariMap]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [NAME, VERSION],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[NAME, "Netscape"], VERSION],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [VERSION, [NAME, FIREFOX + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,
            // Links
            /panasonic;(viera)/i
            // Panasonic Viera
          ],
          [NAME, VERSION],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [NAME, [VERSION, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            // AMD64 (x64)
          ],
          [[ARCHITECTURE, "amd64"]],
          [
            /(ia32(?=;))/i
            // IA32 (quicktime)
          ],
          [[ARCHITECTURE, lowerize]],
          [
            /((?:i[346]|x)86)[;\)]/i
            // IA32 (x86)
          ],
          [[ARCHITECTURE, "ia32"]],
          [
            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            // ARM64
          ],
          [[ARCHITECTURE, "arm64"]],
          [
            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[ARCHITECTURE, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
          ],
          [[ARCHITECTURE, "arm"]],
          [
            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            // PowerPC
          ],
          [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
          [
            /(sun4\w)[;\)]/i
            // SPARC
          ],
          [[ARCHITECTURE, "sparc"]],
          [
            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[ARCHITECTURE, lowerize]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
          [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
          [
            /(macintosh);/i
          ],
          [MODEL, [VENDOR, APPLE]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
          [
            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
          ],
          [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
          [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
          [
            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            // Xiaomi Mi
          ],
          [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
          [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
          [
            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
          ],
          [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [MODEL, [VENDOR, LG], [TYPE, TABLET]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
          [
            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
          ],
          [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
          [
            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
          ],
          [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]],
          [
            // Google
            /(pixel c)\b/i
            // Google Pixel C
          ],
          [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
          [
            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [MODEL, VENDOR, [TYPE, TABLET]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
          [
            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(asus)-?(\w+)/i,
            // Asus
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,
            // Lenovo
            /(jolla)/i,
            // Jolla
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [VENDOR, MODEL, [TYPE, MOBILE]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(archos) (gamepad2?)/i,
            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [VENDOR, MODEL, [TYPE, TABLET]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
          [
            /(shield[\w ]+) b/i
            // Nvidia Shield Tablets
          ],
          [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [VENDOR, MODEL, [TYPE, MOBILE]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [VENDOR, [TYPE, SMARTTV]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[VENDOR, LG], [TYPE, SMARTTV]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
          [
            /droid.+aft(\w)( bui|\))/i
            // Fire TV
          ],
          [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
          [
            /(mitv-\w{5}) bui/i
            // Xiaomi
          ],
          [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [VENDOR, MODEL, [TYPE, SMARTTV]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            // SmartTV from Unidentified Vendors
          ],
          [[TYPE, SMARTTV]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [VENDOR, MODEL, [TYPE, CONSOLE]],
          [
            /droid.+; (shield) bui/i
            // Nvidia
          ],
          [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
          [
            /(playstation [345portablevi]+)/i
            // Playstation
          ],
          [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /((pebble))app/i
            // Pebble
          ],
          [VENDOR, MODEL, [TYPE, WEARABLE]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
          [
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
          [
            /(quest( 2| pro)?)/i
            // Oculus Quest
          ],
          [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [VENDOR, [TYPE, EMBEDDED]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [MODEL, [TYPE, MOBILE]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [MODEL, [TYPE, TABLET]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[TYPE, TABLET]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[TYPE, MOBILE]],
          [
            /(android[-\w\. ]{0,9});.+buil/i
            // Generic Android Device
          ],
          [MODEL, [VENDOR, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [VERSION, [NAME, EDGE + "HTML"]],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [VERSION, [NAME, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
          ],
          [NAME, VERSION],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [VERSION, NAME]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [NAME, VERSION],
          [
            /(windows) nt 6\.2; (arm)/i,
            // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
          ],
          [NAME, [VERSION, strMapper, windowsVersionMap]],
          [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[NAME, "Windows"], [VERSION, strMapper, windowsVersionMap]],
          [
            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /ios;fbsv\/([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[VERSION, /_/g, "."], [NAME, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[NAME, MAC_OS], [VERSION, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [VERSION, NAME],
          [
            // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,
            // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,
            // Tizen/KaiOS
            /\((series40);/i
            // Series 40
          ],
          [NAME, VERSION],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [VERSION, [NAME, BLACKBERRY]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [VERSION, [NAME, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [VERSION, [NAME, FIREFOX + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [VERSION, [NAME, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [VERSION, [NAME, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [VERSION, [NAME, CHROME + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[NAME, CHROMIUM_OS], VERSION],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [NAME, VERSION],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[NAME, "Solaris"], VERSION],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [NAME, VERSION]
        ]
      };
      var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
          extensions = ua;
          ua = undefined2;
        }
        if (!(this instanceof UAParser)) {
          return new UAParser(ua, extensions).getResult();
        }
        var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined2;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined2;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
          var _browser = {};
          _browser[NAME] = undefined2;
          _browser[VERSION] = undefined2;
          rgxMapper.call(_browser, _ua, _rgxmap.browser);
          _browser[MAJOR] = majorize(_browser[VERSION]);
          if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
            _browser[NAME] = "Brave";
          }
          return _browser;
        };
        this.getCPU = function() {
          var _cpu = {};
          _cpu[ARCHITECTURE] = undefined2;
          rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
          return _cpu;
        };
        this.getDevice = function() {
          var _device = {};
          _device[VENDOR] = undefined2;
          _device[MODEL] = undefined2;
          _device[TYPE] = undefined2;
          rgxMapper.call(_device, _ua, _rgxmap.device);
          if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
            _device[TYPE] = MOBILE;
          }
          if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
            _device[MODEL] = "iPad";
            _device[TYPE] = TABLET;
          }
          return _device;
        };
        this.getEngine = function() {
          var _engine = {};
          _engine[NAME] = undefined2;
          _engine[VERSION] = undefined2;
          rgxMapper.call(_engine, _ua, _rgxmap.engine);
          return _engine;
        };
        this.getOS = function() {
          var _os = {};
          _os[NAME] = undefined2;
          _os[VERSION] = undefined2;
          rgxMapper.call(_os, _ua, _rgxmap.os);
          if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") {
            _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
          }
          return _os;
        };
        this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        };
        this.getUA = function() {
          return _ua;
        };
        this.setUA = function(ua2) {
          _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim(ua2, UA_MAX_LENGTH) : ua2;
          return this;
        };
        this.setUA(_ua);
        return this;
      };
      UAParser.VERSION = LIBVERSION;
      UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
      UAParser.CPU = enumerize([ARCHITECTURE]);
      UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
      UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
      if (typeof exports !== UNDEF_TYPE) {
        if (typeof module !== UNDEF_TYPE && module.exports) {
          exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
      } else {
        if (typeof define === FUNC_TYPE && define.amd) {
          define(function() {
            return UAParser;
          });
        } else if (typeof window2 !== UNDEF_TYPE) {
          window2.UAParser = UAParser;
        }
      }
      var $ = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
      if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
          return parser.getUA();
        };
        $.ua.set = function(ua) {
          parser.setUA(ua);
          var result = parser.getResult();
          for (var prop in result) {
            $.ua[prop] = result[prop];
          }
        };
      }
    })(typeof window === "object" ? window : exports);
  }
});

// ../../node_modules/lodash.isequal/index.js
var require_lodash2 = __commonJS({
  "../../node_modules/lodash.isequal/index.js"(exports, module) {
    init_define_process_env();
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var asyncTag = "[object AsyncFunction]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var nullTag = "[object Null]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var proxyTag = "[object Proxy]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var undefinedTag = "[object Undefined]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arrayFilter(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayPush(array, values) {
      var index = -1, length = values.length, offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arraySome(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function mapToArray(map) {
      var index = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var Symbol2 = root.Symbol;
    var Uint8Array2 = root.Uint8Array;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var nativeKeys = overArg(Object.keys, Object);
    var DataView = getNative(root, "DataView");
    var Map2 = getNative(root, "Map");
    var Promise2 = getNative(root, "Promise");
    var Set2 = getNative(root, "Set");
    var WeakMap2 = getNative(root, "WeakMap");
    var nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data3 = this.__data__;
      if (nativeCreate) {
        var result = data3[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data3, key) ? data3[key] : void 0;
    }
    function hashHas(key) {
      var data3 = this.__data__;
      return nativeCreate ? data3[key] !== void 0 : hasOwnProperty.call(data3, key);
    }
    function hashSet(key, value) {
      var data3 = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data3[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data3 = this.__data__, index = assocIndexOf(data3, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data3.length - 1;
      if (index == lastIndex) {
        data3.pop();
      } else {
        splice.call(data3, index, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data3 = this.__data__, index = assocIndexOf(data3, key);
      return index < 0 ? void 0 : data3[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data3 = this.__data__, index = assocIndexOf(data3, key);
      if (index < 0) {
        ++this.size;
        data3.push([key, value]);
      } else {
        data3[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      var data3 = getMapData(this, key), size = data3.size;
      data3.set(key, value);
      this.size += data3.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index = -1, length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      var data3 = this.__data__ = new ListCache(entries);
      this.size = data3.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data3 = this.__data__, result = data3["delete"](key);
      this.size = data3.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var data3 = this.__data__;
      if (data3 instanceof ListCache) {
        var pairs = data3.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data3.size;
          return this;
        }
        data3 = this.__data__ = new MapCache(pairs);
      }
      data3.set(key, value);
      this.size = data3.size;
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsEqual(value, other, bitmask, customizer2, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer2, baseIsEqual, stack);
    }
    function baseIsEqualDeep(object, other, bitmask, customizer2, equalFunc, stack) {
      var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer2, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer2, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer2, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer2, equalFunc, stack);
    }
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function equalArrays(array, other, bitmask, customizer2, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index < arrLength) {
        var arrValue = array[index], othValue = other[index];
        if (customizer2) {
          var compared = isPartial ? customizer2(othValue, arrValue, index, other, array, stack) : customizer2(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer2, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer2, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    function equalByTag(object, other, tag, bitmask, customizer2, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer2, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    function equalObjects(object, other, bitmask, customizer2, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer2) {
          var compared = isPartial ? customizer2(othValue, objValue, key, other, object, stack) : customizer2(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer2, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    function getMapData(map, key) {
      var data3 = map.__data__;
      return isKeyable(key) ? data3[typeof key == "string" ? "string" : "hash"] : data3.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments = baseIsArguments(function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray2 = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }
    function isFunction(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function stubArray() {
      return [];
    }
    function stubFalse() {
      return false;
    }
    module.exports = isEqual;
  }
});

// ../../node_modules/sdp/sdp.js
var require_sdp = __commonJS({
  "../../node_modules/sdp/sdp.js"(exports, module) {
    "use strict";
    init_define_process_env();
    var SDPUtils2 = {};
    SDPUtils2.generateIdentifier = function() {
      return Math.random().toString(36).substring(2, 12);
    };
    SDPUtils2.localCName = SDPUtils2.generateIdentifier();
    SDPUtils2.splitLines = function(blob) {
      return blob.trim().split("\n").map((line) => line.trim());
    };
    SDPUtils2.splitSections = function(blob) {
      const parts = blob.split("\nm=");
      return parts.map((part, index) => (index > 0 ? "m=" + part : part).trim() + "\r\n");
    };
    SDPUtils2.getDescription = function(blob) {
      const sections = SDPUtils2.splitSections(blob);
      return sections && sections[0];
    };
    SDPUtils2.getMediaSections = function(blob) {
      const sections = SDPUtils2.splitSections(blob);
      sections.shift();
      return sections;
    };
    SDPUtils2.matchPrefix = function(blob, prefix) {
      return SDPUtils2.splitLines(blob).filter((line) => line.indexOf(prefix) === 0);
    };
    SDPUtils2.parseCandidate = function(line) {
      let parts;
      if (line.indexOf("a=candidate:") === 0) {
        parts = line.substring(12).split(" ");
      } else {
        parts = line.substring(10).split(" ");
      }
      const candidate = {
        foundation: parts[0],
        component: { 1: "rtp", 2: "rtcp" }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        // address is an alias for ip.
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
      };
      for (let i = 8; i < parts.length; i += 2) {
        switch (parts[i]) {
          case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
          case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
          case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
          case "ufrag":
            candidate.ufrag = parts[i + 1];
            candidate.usernameFragment = parts[i + 1];
            break;
          default:
            if (candidate[parts[i]] === void 0) {
              candidate[parts[i]] = parts[i + 1];
            }
            break;
        }
      }
      return candidate;
    };
    SDPUtils2.writeCandidate = function(candidate) {
      const sdp2 = [];
      sdp2.push(candidate.foundation);
      const component = candidate.component;
      if (component === "rtp") {
        sdp2.push(1);
      } else if (component === "rtcp") {
        sdp2.push(2);
      } else {
        sdp2.push(component);
      }
      sdp2.push(candidate.protocol.toUpperCase());
      sdp2.push(candidate.priority);
      sdp2.push(candidate.address || candidate.ip);
      sdp2.push(candidate.port);
      const type = candidate.type;
      sdp2.push("typ");
      sdp2.push(type);
      if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp2.push("raddr");
        sdp2.push(candidate.relatedAddress);
        sdp2.push("rport");
        sdp2.push(candidate.relatedPort);
      }
      if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp2.push("tcptype");
        sdp2.push(candidate.tcpType);
      }
      if (candidate.usernameFragment || candidate.ufrag) {
        sdp2.push("ufrag");
        sdp2.push(candidate.usernameFragment || candidate.ufrag);
      }
      return "candidate:" + sdp2.join(" ");
    };
    SDPUtils2.parseIceOptions = function(line) {
      return line.substring(14).split(" ");
    };
    SDPUtils2.parseRtpMap = function(line) {
      let parts = line.substring(9).split(" ");
      const parsed = {
        payloadType: parseInt(parts.shift(), 10)
        // was: id
      };
      parts = parts[0].split("/");
      parsed.name = parts[0];
      parsed.clockRate = parseInt(parts[1], 10);
      parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
      parsed.numChannels = parsed.channels;
      return parsed;
    };
    SDPUtils2.writeRtpMap = function(codec) {
      let pt = codec.payloadType;
      if (codec.preferredPayloadType !== void 0) {
        pt = codec.preferredPayloadType;
      }
      const channels = codec.channels || codec.numChannels || 1;
      return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
    };
    SDPUtils2.parseExtmap = function(line) {
      const parts = line.substring(9).split(" ");
      return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1],
        attributes: parts.slice(2).join(" ")
      };
    };
    SDPUtils2.writeExtmap = function(headerExtension) {
      return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + (headerExtension.attributes ? " " + headerExtension.attributes : "") + "\r\n";
    };
    SDPUtils2.parseFmtp = function(line) {
      const parsed = {};
      let kv;
      const parts = line.substring(line.indexOf(" ") + 1).split(";");
      for (let j2 = 0; j2 < parts.length; j2++) {
        kv = parts[j2].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
      }
      return parsed;
    };
    SDPUtils2.writeFmtp = function(codec) {
      let line = "";
      let pt = codec.payloadType;
      if (codec.preferredPayloadType !== void 0) {
        pt = codec.preferredPayloadType;
      }
      if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param) => {
          if (codec.parameters[param] !== void 0) {
            params.push(param + "=" + codec.parameters[param]);
          } else {
            params.push(param);
          }
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
      }
      return line;
    };
    SDPUtils2.parseRtcpFb = function(line) {
      const parts = line.substring(line.indexOf(" ") + 1).split(" ");
      return {
        type: parts.shift(),
        parameter: parts.join(" ")
      };
    };
    SDPUtils2.writeRtcpFb = function(codec) {
      let lines = "";
      let pt = codec.payloadType;
      if (codec.preferredPayloadType !== void 0) {
        pt = codec.preferredPayloadType;
      }
      if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
        codec.rtcpFeedback.forEach((fb) => {
          lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
        });
      }
      return lines;
    };
    SDPUtils2.parseSsrcMedia = function(line) {
      const sp = line.indexOf(" ");
      const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
      };
      const colon = line.indexOf(":", sp);
      if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
      } else {
        parts.attribute = line.substring(sp + 1);
      }
      return parts;
    };
    SDPUtils2.parseSsrcGroup = function(line) {
      const parts = line.substring(13).split(" ");
      return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc) => parseInt(ssrc, 10))
      };
    };
    SDPUtils2.getMid = function(mediaSection) {
      const mid = SDPUtils2.matchPrefix(mediaSection, "a=mid:")[0];
      if (mid) {
        return mid.substring(6);
      }
    };
    SDPUtils2.parseFingerprint = function(line) {
      const parts = line.substring(14).split(" ");
      return {
        algorithm: parts[0].toLowerCase(),
        // algorithm is case-sensitive in Edge.
        value: parts[1].toUpperCase()
        // the definition is upper-case in RFC 4572.
      };
    };
    SDPUtils2.getDtlsParameters = function(mediaSection, sessionpart) {
      const lines = SDPUtils2.matchPrefix(
        mediaSection + sessionpart,
        "a=fingerprint:"
      );
      return {
        role: "auto",
        fingerprints: lines.map(SDPUtils2.parseFingerprint)
      };
    };
    SDPUtils2.writeDtlsParameters = function(params, setupType) {
      let sdp2 = "a=setup:" + setupType + "\r\n";
      params.fingerprints.forEach((fp) => {
        sdp2 += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
      });
      return sdp2;
    };
    SDPUtils2.parseCryptoLine = function(line) {
      const parts = line.substring(9).split(" ");
      return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
      };
    };
    SDPUtils2.writeCryptoLine = function(parameters) {
      return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? SDPUtils2.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
    };
    SDPUtils2.parseCryptoKeyParams = function(keyParams) {
      if (keyParams.indexOf("inline:") !== 0) {
        return null;
      }
      const parts = keyParams.substring(7).split("|");
      return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : void 0,
        mkiLength: parts[2] ? parts[2].split(":")[1] : void 0
      };
    };
    SDPUtils2.writeCryptoKeyParams = function(keyParams) {
      return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
    };
    SDPUtils2.getCryptoParameters = function(mediaSection, sessionpart) {
      const lines = SDPUtils2.matchPrefix(
        mediaSection + sessionpart,
        "a=crypto:"
      );
      return lines.map(SDPUtils2.parseCryptoLine);
    };
    SDPUtils2.getIceParameters = function(mediaSection, sessionpart) {
      const ufrag = SDPUtils2.matchPrefix(
        mediaSection + sessionpart,
        "a=ice-ufrag:"
      )[0];
      const pwd = SDPUtils2.matchPrefix(
        mediaSection + sessionpart,
        "a=ice-pwd:"
      )[0];
      if (!(ufrag && pwd)) {
        return null;
      }
      return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
      };
    };
    SDPUtils2.writeIceParameters = function(params) {
      let sdp2 = "a=ice-ufrag:" + params.usernameFragment + "\r\na=ice-pwd:" + params.password + "\r\n";
      if (params.iceLite) {
        sdp2 += "a=ice-lite\r\n";
      }
      return sdp2;
    };
    SDPUtils2.parseRtpParameters = function(mediaSection) {
      const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
      };
      const lines = SDPUtils2.splitLines(mediaSection);
      const mline = lines[0].split(" ");
      description.profile = mline[2];
      for (let i = 3; i < mline.length; i++) {
        const pt = mline[i];
        const rtpmapline = SDPUtils2.matchPrefix(
          mediaSection,
          "a=rtpmap:" + pt + " "
        )[0];
        if (rtpmapline) {
          const codec = SDPUtils2.parseRtpMap(rtpmapline);
          const fmtps = SDPUtils2.matchPrefix(
            mediaSection,
            "a=fmtp:" + pt + " "
          );
          codec.parameters = fmtps.length ? SDPUtils2.parseFmtp(fmtps[0]) : {};
          codec.rtcpFeedback = SDPUtils2.matchPrefix(
            mediaSection,
            "a=rtcp-fb:" + pt + " "
          ).map(SDPUtils2.parseRtcpFb);
          description.codecs.push(codec);
          switch (codec.name.toUpperCase()) {
            case "RED":
            case "ULPFEC":
              description.fecMechanisms.push(codec.name.toUpperCase());
              break;
            default:
              break;
          }
        }
      }
      SDPUtils2.matchPrefix(mediaSection, "a=extmap:").forEach((line) => {
        description.headerExtensions.push(SDPUtils2.parseExtmap(line));
      });
      const wildcardRtcpFb = SDPUtils2.matchPrefix(mediaSection, "a=rtcp-fb:* ").map(SDPUtils2.parseRtcpFb);
      description.codecs.forEach((codec) => {
        wildcardRtcpFb.forEach((fb) => {
          const duplicate = codec.rtcpFeedback.find((existingFeedback) => {
            return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
          });
          if (!duplicate) {
            codec.rtcpFeedback.push(fb);
          }
        });
      });
      return description;
    };
    SDPUtils2.writeRtpDescription = function(kind, caps) {
      let sdp2 = "";
      sdp2 += "m=" + kind + " ";
      sdp2 += caps.codecs.length > 0 ? "9" : "0";
      sdp2 += " " + (caps.profile || "UDP/TLS/RTP/SAVPF") + " ";
      sdp2 += caps.codecs.map((codec) => {
        if (codec.preferredPayloadType !== void 0) {
          return codec.preferredPayloadType;
        }
        return codec.payloadType;
      }).join(" ") + "\r\n";
      sdp2 += "c=IN IP4 0.0.0.0\r\n";
      sdp2 += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
      caps.codecs.forEach((codec) => {
        sdp2 += SDPUtils2.writeRtpMap(codec);
        sdp2 += SDPUtils2.writeFmtp(codec);
        sdp2 += SDPUtils2.writeRtcpFb(codec);
      });
      let maxptime = 0;
      caps.codecs.forEach((codec) => {
        if (codec.maxptime > maxptime) {
          maxptime = codec.maxptime;
        }
      });
      if (maxptime > 0) {
        sdp2 += "a=maxptime:" + maxptime + "\r\n";
      }
      if (caps.headerExtensions) {
        caps.headerExtensions.forEach((extension) => {
          sdp2 += SDPUtils2.writeExtmap(extension);
        });
      }
      return sdp2;
    };
    SDPUtils2.parseRtpEncodingParameters = function(mediaSection) {
      const encodingParameters = [];
      const description = SDPUtils2.parseRtpParameters(mediaSection);
      const hasRed = description.fecMechanisms.indexOf("RED") !== -1;
      const hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
      const ssrcs = SDPUtils2.matchPrefix(mediaSection, "a=ssrc:").map((line) => SDPUtils2.parseSsrcMedia(line)).filter((parts) => parts.attribute === "cname");
      const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
      let secondarySsrc;
      const flows = SDPUtils2.matchPrefix(mediaSection, "a=ssrc-group:FID").map((line) => {
        const parts = line.substring(17).split(" ");
        return parts.map((part) => parseInt(part, 10));
      });
      if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
        secondarySsrc = flows[0][1];
      }
      description.codecs.forEach((codec) => {
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
          let encParam = {
            ssrc: primarySsrc,
            codecPayloadType: parseInt(codec.parameters.apt, 10)
          };
          if (primarySsrc && secondarySsrc) {
            encParam.rtx = { ssrc: secondarySsrc };
          }
          encodingParameters.push(encParam);
          if (hasRed) {
            encParam = JSON.parse(JSON.stringify(encParam));
            encParam.fec = {
              ssrc: primarySsrc,
              mechanism: hasUlpfec ? "red+ulpfec" : "red"
            };
            encodingParameters.push(encParam);
          }
        }
      });
      if (encodingParameters.length === 0 && primarySsrc) {
        encodingParameters.push({
          ssrc: primarySsrc
        });
      }
      let bandwidth = SDPUtils2.matchPrefix(mediaSection, "b=");
      if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) {
          bandwidth = parseInt(bandwidth[0].substring(7), 10);
        } else if (bandwidth[0].indexOf("b=AS:") === 0) {
          bandwidth = parseInt(bandwidth[0].substring(5), 10) * 1e3 * 0.95 - 50 * 40 * 8;
        } else {
          bandwidth = void 0;
        }
        encodingParameters.forEach((params) => {
          params.maxBitrate = bandwidth;
        });
      }
      return encodingParameters;
    };
    SDPUtils2.parseRtcpParameters = function(mediaSection) {
      const rtcpParameters = {};
      const remoteSsrc = SDPUtils2.matchPrefix(mediaSection, "a=ssrc:").map((line) => SDPUtils2.parseSsrcMedia(line)).filter((obj) => obj.attribute === "cname")[0];
      if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
      }
      const rsize = SDPUtils2.matchPrefix(mediaSection, "a=rtcp-rsize");
      rtcpParameters.reducedSize = rsize.length > 0;
      rtcpParameters.compound = rsize.length === 0;
      const mux = SDPUtils2.matchPrefix(mediaSection, "a=rtcp-mux");
      rtcpParameters.mux = mux.length > 0;
      return rtcpParameters;
    };
    SDPUtils2.writeRtcpParameters = function(rtcpParameters) {
      let sdp2 = "";
      if (rtcpParameters.reducedSize) {
        sdp2 += "a=rtcp-rsize\r\n";
      }
      if (rtcpParameters.mux) {
        sdp2 += "a=rtcp-mux\r\n";
      }
      if (rtcpParameters.ssrc !== void 0 && rtcpParameters.cname) {
        sdp2 += "a=ssrc:" + rtcpParameters.ssrc + " cname:" + rtcpParameters.cname + "\r\n";
      }
      return sdp2;
    };
    SDPUtils2.parseMsid = function(mediaSection) {
      let parts;
      const spec = SDPUtils2.matchPrefix(mediaSection, "a=msid:");
      if (spec.length === 1) {
        parts = spec[0].substring(7).split(" ");
        return { stream: parts[0], track: parts[1] };
      }
      const planB = SDPUtils2.matchPrefix(mediaSection, "a=ssrc:").map((line) => SDPUtils2.parseSsrcMedia(line)).filter((msidParts) => msidParts.attribute === "msid");
      if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return { stream: parts[0], track: parts[1] };
      }
    };
    SDPUtils2.parseSctpDescription = function(mediaSection) {
      const mline = SDPUtils2.parseMLine(mediaSection);
      const maxSizeLine = SDPUtils2.matchPrefix(mediaSection, "a=max-message-size:");
      let maxMessageSize;
      if (maxSizeLine.length > 0) {
        maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
      }
      if (isNaN(maxMessageSize)) {
        maxMessageSize = 65536;
      }
      const sctpPort = SDPUtils2.matchPrefix(mediaSection, "a=sctp-port:");
      if (sctpPort.length > 0) {
        return {
          port: parseInt(sctpPort[0].substring(12), 10),
          protocol: mline.fmt,
          maxMessageSize
        };
      }
      const sctpMapLines = SDPUtils2.matchPrefix(mediaSection, "a=sctpmap:");
      if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(" ");
        return {
          port: parseInt(parts[0], 10),
          protocol: parts[1],
          maxMessageSize
        };
      }
    };
    SDPUtils2.writeSctpDescription = function(media, sctp) {
      let output = [];
      if (media.protocol !== "DTLS/SCTP") {
        output = [
          "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
          "c=IN IP4 0.0.0.0\r\n",
          "a=sctp-port:" + sctp.port + "\r\n"
        ];
      } else {
        output = [
          "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
          "c=IN IP4 0.0.0.0\r\n",
          "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
        ];
      }
      if (sctp.maxMessageSize !== void 0) {
        output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
      }
      return output.join("");
    };
    SDPUtils2.generateSessionId = function() {
      return Math.random().toString().substr(2, 22);
    };
    SDPUtils2.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
      let sessionId;
      const version = sessVer !== void 0 ? sessVer : 2;
      if (sessId) {
        sessionId = sessId;
      } else {
        sessionId = SDPUtils2.generateSessionId();
      }
      const user = sessUser || "thisisadapterortc";
      return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\ns=-\r\nt=0 0\r\n";
    };
    SDPUtils2.getDirection = function(mediaSection, sessionpart) {
      const lines = SDPUtils2.splitLines(mediaSection);
      for (let i = 0; i < lines.length; i++) {
        switch (lines[i]) {
          case "a=sendrecv":
          case "a=sendonly":
          case "a=recvonly":
          case "a=inactive":
            return lines[i].substring(2);
          default:
        }
      }
      if (sessionpart) {
        return SDPUtils2.getDirection(sessionpart);
      }
      return "sendrecv";
    };
    SDPUtils2.getKind = function(mediaSection) {
      const lines = SDPUtils2.splitLines(mediaSection);
      const mline = lines[0].split(" ");
      return mline[0].substring(2);
    };
    SDPUtils2.isRejected = function(mediaSection) {
      return mediaSection.split(" ", 2)[1] === "0";
    };
    SDPUtils2.parseMLine = function(mediaSection) {
      const lines = SDPUtils2.splitLines(mediaSection);
      const parts = lines[0].substring(2).split(" ");
      return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
      };
    };
    SDPUtils2.parseOLine = function(mediaSection) {
      const line = SDPUtils2.matchPrefix(mediaSection, "o=")[0];
      const parts = line.substring(2).split(" ");
      return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
      };
    };
    SDPUtils2.isValidSDP = function(blob) {
      if (typeof blob !== "string" || blob.length === 0) {
        return false;
      }
      const lines = SDPUtils2.splitLines(blob);
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") {
          return false;
        }
      }
      return true;
    };
    if (typeof module === "object") {
      module.exports = SDPUtils2;
    }
  }
});

// ../../node_modules/sdp-transform/lib/grammar.js
var require_grammar = __commonJS({
  "../../node_modules/sdp-transform/lib/grammar.js"(exports, module) {
    init_define_process_env();
    var grammar = module.exports = {
      v: [{
        name: "version",
        reg: /^(\d*)$/
      }],
      o: [{
        // o=- 20518 0 IN IP4 203.0.113.1
        // NB: sessionId will be a String in most cases because it is huge
        name: "origin",
        reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
        names: ["username", "sessionId", "sessionVersion", "netType", "ipVer", "address"],
        format: "%s %s %d %s IP%d %s"
      }],
      // default parsing of these only (though some of these feel outdated)
      s: [{ name: "name" }],
      i: [{ name: "description" }],
      u: [{ name: "uri" }],
      e: [{ name: "email" }],
      p: [{ name: "phone" }],
      z: [{ name: "timezones" }],
      // TODO: this one can actually be parsed properly...
      r: [{ name: "repeats" }],
      // TODO: this one can also be parsed properly
      // k: [{}], // outdated thing ignored
      t: [{
        // t=0 0
        name: "timing",
        reg: /^(\d*) (\d*)/,
        names: ["start", "stop"],
        format: "%d %d"
      }],
      c: [{
        // c=IN IP4 10.47.197.26
        name: "connection",
        reg: /^IN IP(\d) (\S*)/,
        names: ["version", "ip"],
        format: "IN IP%d %s"
      }],
      b: [{
        // b=AS:4000
        push: "bandwidth",
        reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
        names: ["type", "limit"],
        format: "%s:%s"
      }],
      m: [{
        // m=video 51744 RTP/AVP 126 97 98 34 31
        // NB: special - pushes to session
        // TODO: rtp/fmtp should be filtered by the payloads found here?
        reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
        names: ["type", "port", "protocol", "payloads"],
        format: "%s %d %s %s"
      }],
      a: [
        {
          // a=rtpmap:110 opus/48000/2
          push: "rtp",
          reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
          names: ["payload", "codec", "rate", "encoding"],
          format: function(o) {
            return o.encoding ? "rtpmap:%d %s/%s/%s" : o.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
          }
        },
        {
          // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
          // a=fmtp:111 minptime=10; useinbandfec=1
          push: "fmtp",
          reg: /^fmtp:(\d*) ([\S| ]*)/,
          names: ["payload", "config"],
          format: "fmtp:%d %s"
        },
        {
          // a=control:streamid=0
          name: "control",
          reg: /^control:(.*)/,
          format: "control:%s"
        },
        {
          // a=rtcp:65179 IN IP4 193.84.77.194
          name: "rtcp",
          reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
          names: ["port", "netType", "ipVer", "address"],
          format: function(o) {
            return o.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
          }
        },
        {
          // a=rtcp-fb:98 trr-int 100
          push: "rtcpFbTrrInt",
          reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
          names: ["payload", "value"],
          format: "rtcp-fb:%s trr-int %d"
        },
        {
          // a=rtcp-fb:98 nack rpsi
          push: "rtcpFb",
          reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
          names: ["payload", "type", "subtype"],
          format: function(o) {
            return o.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
          }
        },
        {
          // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
          // a=extmap:1/recvonly URI-gps-string
          // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
          push: "ext",
          reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
          names: ["value", "direction", "encrypt-uri", "uri", "config"],
          format: function(o) {
            return "extmap:%d" + (o.direction ? "/%s" : "%v") + (o["encrypt-uri"] ? " %s" : "%v") + " %s" + (o.config ? " %s" : "");
          }
        },
        {
          // a=extmap-allow-mixed
          name: "extmapAllowMixed",
          reg: /^(extmap-allow-mixed)/
        },
        {
          // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
          push: "crypto",
          reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
          names: ["id", "suite", "config", "sessionConfig"],
          format: function(o) {
            return o.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
          }
        },
        {
          // a=setup:actpass
          name: "setup",
          reg: /^setup:(\w*)/,
          format: "setup:%s"
        },
        {
          // a=connection:new
          name: "connectionType",
          reg: /^connection:(new|existing)/,
          format: "connection:%s"
        },
        {
          // a=mid:1
          name: "mid",
          reg: /^mid:([^\s]*)/,
          format: "mid:%s"
        },
        {
          // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
          name: "msid",
          reg: /^msid:(.*)/,
          format: "msid:%s"
        },
        {
          // a=ptime:20
          name: "ptime",
          reg: /^ptime:(\d*(?:\.\d*)*)/,
          format: "ptime:%d"
        },
        {
          // a=maxptime:60
          name: "maxptime",
          reg: /^maxptime:(\d*(?:\.\d*)*)/,
          format: "maxptime:%d"
        },
        {
          // a=sendrecv
          name: "direction",
          reg: /^(sendrecv|recvonly|sendonly|inactive)/
        },
        {
          // a=ice-lite
          name: "icelite",
          reg: /^(ice-lite)/
        },
        {
          // a=ice-ufrag:F7gI
          name: "iceUfrag",
          reg: /^ice-ufrag:(\S*)/,
          format: "ice-ufrag:%s"
        },
        {
          // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
          name: "icePwd",
          reg: /^ice-pwd:(\S*)/,
          format: "ice-pwd:%s"
        },
        {
          // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
          name: "fingerprint",
          reg: /^fingerprint:(\S*) (\S*)/,
          names: ["type", "hash"],
          format: "fingerprint:%s %s"
        },
        {
          // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
          // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
          // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
          // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
          // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
          push: "candidates",
          reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
          names: ["foundation", "component", "transport", "priority", "ip", "port", "type", "raddr", "rport", "tcptype", "generation", "network-id", "network-cost"],
          format: function(o) {
            var str = "candidate:%s %d %s %d %s %d typ %s";
            str += o.raddr != null ? " raddr %s rport %d" : "%v%v";
            str += o.tcptype != null ? " tcptype %s" : "%v";
            if (o.generation != null) {
              str += " generation %d";
            }
            str += o["network-id"] != null ? " network-id %d" : "%v";
            str += o["network-cost"] != null ? " network-cost %d" : "%v";
            return str;
          }
        },
        {
          // a=end-of-candidates (keep after the candidates line for readability)
          name: "endOfCandidates",
          reg: /^(end-of-candidates)/
        },
        {
          // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
          name: "remoteCandidates",
          reg: /^remote-candidates:(.*)/,
          format: "remote-candidates:%s"
        },
        {
          // a=ice-options:google-ice
          name: "iceOptions",
          reg: /^ice-options:(\S*)/,
          format: "ice-options:%s"
        },
        {
          // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
          push: "ssrcs",
          reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
          names: ["id", "attribute", "value"],
          format: function(o) {
            var str = "ssrc:%d";
            if (o.attribute != null) {
              str += " %s";
              if (o.value != null) {
                str += ":%s";
              }
            }
            return str;
          }
        },
        {
          // a=ssrc-group:FEC 1 2
          // a=ssrc-group:FEC-FR 3004364195 1080772241
          push: "ssrcGroups",
          // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
          reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
          names: ["semantics", "ssrcs"],
          format: "ssrc-group:%s %s"
        },
        {
          // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
          name: "msidSemantic",
          reg: /^msid-semantic:\s?(\w*) (\S*)/,
          names: ["semantic", "token"],
          format: "msid-semantic: %s %s"
          // space after ':' is not accidental
        },
        {
          // a=group:BUNDLE audio video
          push: "groups",
          reg: /^group:(\w*) (.*)/,
          names: ["type", "mids"],
          format: "group:%s %s"
        },
        {
          // a=rtcp-mux
          name: "rtcpMux",
          reg: /^(rtcp-mux)/
        },
        {
          // a=rtcp-rsize
          name: "rtcpRsize",
          reg: /^(rtcp-rsize)/
        },
        {
          // a=sctpmap:5000 webrtc-datachannel 1024
          name: "sctpmap",
          reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
          names: ["sctpmapNumber", "app", "maxMessageSize"],
          format: function(o) {
            return o.maxMessageSize != null ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
          }
        },
        {
          // a=x-google-flag:conference
          name: "xGoogleFlag",
          reg: /^x-google-flag:([^\s]*)/,
          format: "x-google-flag:%s"
        },
        {
          // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
          push: "rids",
          reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
          names: ["id", "direction", "params"],
          format: function(o) {
            return o.params ? "rid:%s %s %s" : "rid:%s %s";
          }
        },
        {
          // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
          // a=imageattr:* send [x=800,y=640] recv *
          // a=imageattr:100 recv [x=320,y=240]
          push: "imageattrs",
          reg: new RegExp(
            // a=imageattr:97
            "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"
          ),
          names: ["pt", "dir1", "attrs1", "dir2", "attrs2"],
          format: function(o) {
            return "imageattr:%s %s %s" + (o.dir2 ? " %s %s" : "");
          }
        },
        {
          // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
          // a=simulcast:recv 1;4,5 send 6;7
          name: "simulcast",
          reg: new RegExp(
            // a=simulcast:
            "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"
          ),
          names: ["dir1", "list1", "dir2", "list2"],
          format: function(o) {
            return "simulcast:%s %s" + (o.dir2 ? " %s %s" : "");
          }
        },
        {
          // old simulcast draft 03 (implemented by Firefox)
          //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
          // a=simulcast: recv pt=97;98 send pt=97
          // a=simulcast: send rid=5;6;7 paused=6,7
          name: "simulcast_03",
          reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
          names: ["value"],
          format: "simulcast: %s"
        },
        {
          // a=framerate:25
          // a=framerate:29.97
          name: "framerate",
          reg: /^framerate:(\d+(?:$|\.\d+))/,
          format: "framerate:%s"
        },
        {
          // RFC4570
          // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
          name: "sourceFilter",
          reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
          names: ["filterMode", "netType", "addressTypes", "destAddress", "srcList"],
          format: "source-filter: %s %s %s %s %s"
        },
        {
          // a=bundle-only
          name: "bundleOnly",
          reg: /^(bundle-only)/
        },
        {
          // a=label:1
          name: "label",
          reg: /^label:(.+)/,
          format: "label:%s"
        },
        {
          // RFC version 26 for SCTP over DTLS
          // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
          name: "sctpPort",
          reg: /^sctp-port:(\d+)$/,
          format: "sctp-port:%s"
        },
        {
          // RFC version 26 for SCTP over DTLS
          // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
          name: "maxMessageSize",
          reg: /^max-message-size:(\d+)$/,
          format: "max-message-size:%s"
        },
        {
          // RFC7273
          // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
          push: "tsRefClocks",
          reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
          names: ["clksrc", "clksrcExt"],
          format: function(o) {
            return "ts-refclk:%s" + (o.clksrcExt != null ? "=%s" : "");
          }
        },
        {
          // RFC7273
          // a=mediaclk:direct=963214424
          name: "mediaClk",
          reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
          names: ["id", "mediaClockName", "mediaClockValue", "rateNumerator", "rateDenominator"],
          format: function(o) {
            var str = "mediaclk:";
            str += o.id != null ? "id=%s %s" : "%v%s";
            str += o.mediaClockValue != null ? "=%s" : "";
            str += o.rateNumerator != null ? " rate=%s" : "";
            str += o.rateDenominator != null ? "/%s" : "";
            return str;
          }
        },
        {
          // a=keywds:keywords
          name: "keywords",
          reg: /^keywds:(.+)$/,
          format: "keywds:%s"
        },
        {
          // a=content:main
          name: "content",
          reg: /^content:(.+)/,
          format: "content:%s"
        },
        // BFCP https://tools.ietf.org/html/rfc4583
        {
          // a=floorctrl:c-s
          name: "bfcpFloorCtrl",
          reg: /^floorctrl:(c-only|s-only|c-s)/,
          format: "floorctrl:%s"
        },
        {
          // a=confid:1
          name: "bfcpConfId",
          reg: /^confid:(\d+)/,
          format: "confid:%s"
        },
        {
          // a=userid:1
          name: "bfcpUserId",
          reg: /^userid:(\d+)/,
          format: "userid:%s"
        },
        {
          // a=floorid:1
          name: "bfcpFloorId",
          reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
          names: ["id", "mStream"],
          format: "floorid:%s mstrm:%s"
        },
        {
          // any a= that we don't understand is kept verbatim on media.invalid
          push: "invalid",
          names: ["value"]
        }
      ]
    };
    Object.keys(grammar).forEach(function(key) {
      var objs = grammar[key];
      objs.forEach(function(obj) {
        if (!obj.reg) {
          obj.reg = /(.*)/;
        }
        if (!obj.format) {
          obj.format = "%s";
        }
      });
    });
  }
});

// ../../node_modules/sdp-transform/lib/parser.js
var require_parser = __commonJS({
  "../../node_modules/sdp-transform/lib/parser.js"(exports) {
    init_define_process_env();
    var toIntIfInt = function(v) {
      return String(Number(v)) === v ? Number(v) : v;
    };
    var attachProperties = function(match18, location, names, rawName) {
      if (rawName && !names) {
        location[rawName] = toIntIfInt(match18[1]);
      } else {
        for (var i = 0; i < names.length; i += 1) {
          if (match18[i + 1] != null) {
            location[names[i]] = toIntIfInt(match18[i + 1]);
          }
        }
      }
    };
    var parseReg = function(obj, location, content) {
      var needsBlank = obj.name && obj.names;
      if (obj.push && !location[obj.push]) {
        location[obj.push] = [];
      } else if (needsBlank && !location[obj.name]) {
        location[obj.name] = {};
      }
      var keyLocation = obj.push ? {} : (
        // blank object that will be pushed
        needsBlank ? location[obj.name] : location
      );
      attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
      if (obj.push) {
        location[obj.push].push(keyLocation);
      }
    };
    var grammar = require_grammar();
    var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
    exports.parse = function(sdp2) {
      var session = {}, media = [], location = session;
      sdp2.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function(l2) {
        var type = l2[0];
        var content = l2.slice(2);
        if (type === "m") {
          media.push({ rtp: [], fmtp: [] });
          location = media[media.length - 1];
        }
        for (var j2 = 0; j2 < (grammar[type] || []).length; j2 += 1) {
          var obj = grammar[type][j2];
          if (obj.reg.test(content)) {
            return parseReg(obj, location, content);
          }
        }
      });
      session.media = media;
      return session;
    };
    var paramReducer = function(acc, expr) {
      var s = expr.split(/=(.+)/, 2);
      if (s.length === 2) {
        acc[s[0]] = toIntIfInt(s[1]);
      } else if (s.length === 1 && expr.length > 1) {
        acc[s[0]] = void 0;
      }
      return acc;
    };
    exports.parseParams = function(str) {
      return str.split(/;\s?/).reduce(paramReducer, {});
    };
    exports.parseFmtpConfig = exports.parseParams;
    exports.parsePayloads = function(str) {
      return str.toString().split(" ").map(Number);
    };
    exports.parseRemoteCandidates = function(str) {
      var candidates = [];
      var parts = str.split(" ").map(toIntIfInt);
      for (var i = 0; i < parts.length; i += 3) {
        candidates.push({
          component: parts[i],
          ip: parts[i + 1],
          port: parts[i + 2]
        });
      }
      return candidates;
    };
    exports.parseImageAttributes = function(str) {
      return str.split(" ").map(function(item) {
        return item.substring(1, item.length - 1).split(",").reduce(paramReducer, {});
      });
    };
    exports.parseSimulcastStreamList = function(str) {
      return str.split(";").map(function(stream) {
        return stream.split(",").map(function(format) {
          var scid, paused = false;
          if (format[0] !== "~") {
            scid = toIntIfInt(format);
          } else {
            scid = toIntIfInt(format.substring(1, format.length));
            paused = true;
          }
          return {
            scid,
            paused
          };
        });
      });
    };
  }
});

// ../../node_modules/sdp-transform/lib/writer.js
var require_writer = __commonJS({
  "../../node_modules/sdp-transform/lib/writer.js"(exports, module) {
    init_define_process_env();
    var grammar = require_grammar();
    var formatRegExp = /%[sdv%]/g;
    var format = function(formatStr) {
      var i = 1;
      var args = arguments;
      var len = args.length;
      return formatStr.replace(formatRegExp, function(x) {
        if (i >= len) {
          return x;
        }
        var arg = args[i];
        i += 1;
        switch (x) {
          case "%%":
            return "%";
          case "%s":
            return String(arg);
          case "%d":
            return Number(arg);
          case "%v":
            return "";
        }
      });
    };
    var makeLine = function(type, obj, location) {
      var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
      var args = [type + "=" + str];
      if (obj.names) {
        for (var i = 0; i < obj.names.length; i += 1) {
          var n = obj.names[i];
          if (obj.name) {
            args.push(location[obj.name][n]);
          } else {
            args.push(location[obj.names[i]]);
          }
        }
      } else {
        args.push(location[obj.name]);
      }
      return format.apply(null, args);
    };
    var defaultOuterOrder = [
      "v",
      "o",
      "s",
      "i",
      "u",
      "e",
      "p",
      "c",
      "b",
      "t",
      "r",
      "z",
      "a"
    ];
    var defaultInnerOrder = ["i", "c", "b", "a"];
    module.exports = function(session, opts) {
      opts = opts || {};
      if (session.version == null) {
        session.version = 0;
      }
      if (session.name == null) {
        session.name = " ";
      }
      session.media.forEach(function(mLine) {
        if (mLine.payloads == null) {
          mLine.payloads = "";
        }
      });
      var outerOrder = opts.outerOrder || defaultOuterOrder;
      var innerOrder = opts.innerOrder || defaultInnerOrder;
      var sdp2 = [];
      outerOrder.forEach(function(type) {
        grammar[type].forEach(function(obj) {
          if (obj.name in session && session[obj.name] != null) {
            sdp2.push(makeLine(type, obj, session));
          } else if (obj.push in session && session[obj.push] != null) {
            session[obj.push].forEach(function(el) {
              sdp2.push(makeLine(type, obj, el));
            });
          }
        });
      });
      session.media.forEach(function(mLine) {
        sdp2.push(makeLine("m", grammar.m[0], mLine));
        innerOrder.forEach(function(type) {
          grammar[type].forEach(function(obj) {
            if (obj.name in mLine && mLine[obj.name] != null) {
              sdp2.push(makeLine(type, obj, mLine));
            } else if (obj.push in mLine && mLine[obj.push] != null) {
              mLine[obj.push].forEach(function(el) {
                sdp2.push(makeLine(type, obj, el));
              });
            }
          });
        });
      });
      return sdp2.join("\r\n") + "\r\n";
    };
  }
});

// ../../node_modules/sdp-transform/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/sdp-transform/lib/index.js"(exports) {
    init_define_process_env();
    var parser = require_parser();
    var writer = require_writer();
    exports.write = writer;
    exports.parse = parser.parse;
    exports.parseParams = parser.parseParams;
    exports.parseFmtpConfig = parser.parseFmtpConfig;
    exports.parsePayloads = parser.parsePayloads;
    exports.parseRemoteCandidates = parser.parseRemoteCandidates;
    exports.parseImageAttributes = parser.parseImageAttributes;
    exports.parseSimulcastStreamList = parser.parseSimulcastStreamList;
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    init_define_process_env();
    var b2 = "function" === typeof Symbol && Symbol.for;
    var c2 = b2 ? Symbol.for("react.element") : 60103;
    var d = b2 ? Symbol.for("react.portal") : 60106;
    var e = b2 ? Symbol.for("react.fragment") : 60107;
    var f = b2 ? Symbol.for("react.strict_mode") : 60108;
    var g = b2 ? Symbol.for("react.profiler") : 60114;
    var h = b2 ? Symbol.for("react.provider") : 60109;
    var k2 = b2 ? Symbol.for("react.context") : 60110;
    var l2 = b2 ? Symbol.for("react.async_mode") : 60111;
    var m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b2 ? Symbol.for("react.forward_ref") : 60112;
    var p = b2 ? Symbol.for("react.suspense") : 60113;
    var q = b2 ? Symbol.for("react.suspense_list") : 60120;
    var r = b2 ? Symbol.for("react.memo") : 60115;
    var t = b2 ? Symbol.for("react.lazy") : 60116;
    var v = b2 ? Symbol.for("react.block") : 60121;
    var w = b2 ? Symbol.for("react.fundamental") : 60117;
    var x = b2 ? Symbol.for("react.responder") : 60118;
    var y2 = b2 ? Symbol.for("react.scope") : 60119;
    function z2(a2) {
      if ("object" === typeof a2 && null !== a2) {
        var u = a2.$$typeof;
        switch (u) {
          case c2:
            switch (a2 = a2.type, a2) {
              case l2:
              case m2:
              case e:
              case g:
              case f:
              case p:
                return a2;
              default:
                switch (a2 = a2 && a2.$$typeof, a2) {
                  case k2:
                  case n:
                  case t:
                  case r:
                  case h:
                    return a2;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a2) {
      return z2(a2) === m2;
    }
    exports.AsyncMode = l2;
    exports.ConcurrentMode = m2;
    exports.ContextConsumer = k2;
    exports.ContextProvider = h;
    exports.Element = c2;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a2) {
      return A(a2) || z2(a2) === l2;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a2) {
      return z2(a2) === k2;
    };
    exports.isContextProvider = function(a2) {
      return z2(a2) === h;
    };
    exports.isElement = function(a2) {
      return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
    };
    exports.isForwardRef = function(a2) {
      return z2(a2) === n;
    };
    exports.isFragment = function(a2) {
      return z2(a2) === e;
    };
    exports.isLazy = function(a2) {
      return z2(a2) === t;
    };
    exports.isMemo = function(a2) {
      return z2(a2) === r;
    };
    exports.isPortal = function(a2) {
      return z2(a2) === d;
    };
    exports.isProfiler = function(a2) {
      return z2(a2) === g;
    };
    exports.isStrictMode = function(a2) {
      return z2(a2) === f;
    };
    exports.isSuspense = function(a2) {
      return z2(a2) === p;
    };
    exports.isValidElementType = function(a2) {
      return "string" === typeof a2 || "function" === typeof a2 || a2 === e || a2 === m2 || a2 === g || a2 === f || a2 === p || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t || a2.$$typeof === r || a2.$$typeof === h || a2.$$typeof === k2 || a2.$$typeof === n || a2.$$typeof === w || a2.$$typeof === x || a2.$$typeof === y2 || a2.$$typeof === v);
    };
    exports.typeOf = z2;
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    init_define_process_env();
    if (define_process_env_default.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment13 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal4 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment13;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal4;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/index.js"(exports, module) {
    "use strict";
    init_define_process_env();
    if (define_process_env_default.NODE_ENV === "production") {
      module.exports = require_react_is_production_min();
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    init_define_process_env();
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    init_define_process_env();
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    init_define_process_env();
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    init_define_process_env();
    var printWarning = function() {
    };
    if (define_process_env_default.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (define_process_env_default.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (define_process_env_default.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    init_define_process_env();
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (define_process_env_default.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y2) {
        if (x === y2) {
          return x !== 0 || 1 / x === 1 / y2;
        } else {
          return x !== x && y2 !== y2;
        }
      }
      function PropTypeError(message, data3) {
        this.message = message;
        this.data = data3 && typeof data3 === "object" ? data3 : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (define_process_env_default.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (define_process_env_default.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (define_process_env_default.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          define_process_env_default.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module) {
    "use strict";
    init_define_process_env();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    init_define_process_env();
    if (define_process_env_default.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// src/index.ts
init_define_process_env();

// src/Button/index.tsx
init_define_process_env();

// src/Button/Button.tsx
init_define_process_env();
import React3 from "react";

// src/Layout/index.tsx
init_define_process_env();

// src/Layout/Flex.tsx
init_define_process_env();

// src/Theme/stitches.config.ts
init_define_process_env();
import { createStitches } from "@stitches/react";
import merge from "lodash.merge";

// src/Theme/base.config.ts
init_define_process_env();
import { defaultThemeMap as defaultStitchesThemeMap } from "@stitches/react";
var baseConfig = {
  theme: {
    colors: {
      primary_default: "#2572ED",
      primary_bright: "#538DFF",
      primary_dim: "#002D6D",
      primary_disabled: "#004299",
      on_primary_high: "rgba(245, 249, 255, 0.95)",
      on_primary_medium: "rgba(224, 236, 255, 0.8)",
      on_primary_low: "rgba(194, 208, 229, 0.5)",
      secondary_default: "#444954",
      secondary_bright: "#70778B",
      secondary_dim: "#293042",
      secondary_disabled: "#404759",
      on_secondary_high: "#FFFFFF",
      on_secondary_medium: "#D3D9F0",
      on_secondary_low: "#A4ABC0",
      background_default: "#0B0E15",
      background_dim: "#000000",
      surface_default: "#191B23",
      surface_bright: "#272A31",
      surface_brighter: "#2E3038",
      surface_dim: "#11131A",
      on_surface_high: "#EFF0FA",
      on_surface_medium: "#C5C6D0",
      on_surface_low: "#8F9099",
      border_default: "#1D1F27",
      border_bright: "#272A31",
      alert_success: "#36B37E",
      alert_warning: "#FFAB00",
      alert_error_default: "#C74E5B",
      alert_error_bright: "#FFB2B6",
      alert_error_brighter: "#FFEDEC",
      alert_error_dim: "#270005"
    },
    shadows: {
      sm: "0 0 4px 0 #0000004D",
      md: "0 0 8px 0 #0000004D"
    },
    fonts: {
      sans: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif"
    },
    fontSizes: {
      h1: "6rem",
      h2: "3.75rem",
      h3: "3rem",
      h4: "2.125rem",
      h5: "1.5rem",
      h6: "1.25rem",
      tiny: "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem"
    },
    fontWeights: {
      semiBold: 600,
      medium: 500,
      regular: 400
    },
    lineHeights: {
      h1: "5.75rem",
      h2: "3.5rem",
      h3: "3.25rem",
      h4: "2.5rem",
      h5: "2rem",
      h6: "1.5rem",
      tiny: "1rem",
      xs: "1rem",
      sm: "1.25rem",
      md: "1.5rem"
    },
    radii: {
      "0": "0.25rem",
      "1": "0.5rem",
      "2": "0.75rem",
      "3": "1rem",
      "4": "1.5rem",
      round: "100rem"
    },
    space: {
      0: "0rem",
      xs: "0.5rem",
      sm: "0.75rem",
      md: "1rem",
      lg: "1.25rem",
      xl: "2.25rem",
      px: "1px",
      1: "0.125rem",
      2: "0.25rem",
      3: "0.375rem",
      4: "0.5rem",
      5: "0.625rem",
      6: "0.75rem",
      7: "0.875rem",
      8: "1rem",
      9: "1.25rem",
      10: "1.5rem",
      11: "1.75rem",
      12: "2rem",
      13: "2.25rem",
      14: "2.5rem",
      15: "2.75rem",
      16: "3rem",
      17: "3.5rem",
      18: "4rem",
      19: "4.25rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem",
      100: "25rem"
    },
    borderWidths: {
      light: "1px",
      normal: "2px",
      bold: "3px",
      extrabold: "4px",
      black: "5px"
    }
  }
};
var defaultUtils = {
  bg: (value) => ({
    backgroundColor: value
  }),
  c: (value) => ({
    color: value
  }),
  r: (value) => ({
    borderRadius: value
  }),
  fs: (value) => ({
    fontSize: value
  }),
  size: (value) => ({
    height: value,
    width: value
  }),
  w: (value) => ({
    width: value
  }),
  h: (value) => ({
    height: value
  }),
  p: (value) => ({
    padding: value
  }),
  pt: (value) => ({
    paddingTop: value
  }),
  pr: (value) => ({
    paddingRight: value
  }),
  pb: (value) => ({
    paddingBottom: value
  }),
  pl: (value) => ({
    paddingLeft: value
  }),
  px: (value) => ({
    paddingLeft: value,
    paddingRight: value
  }),
  py: (value) => ({
    paddingTop: value,
    paddingBottom: value
  }),
  m: (value) => ({
    margin: value
  }),
  mt: (value) => ({
    marginTop: value
  }),
  mr: (value) => ({
    marginRight: value
  }),
  mb: (value) => ({
    marginBottom: value
  }),
  ml: (value) => ({
    marginLeft: value
  }),
  mx: (value) => ({
    marginLeft: value,
    marginRight: value
  }),
  my: (value) => ({
    marginTop: value,
    marginBottom: value
  })
};
var defaultMedia = {
  allowMotion: "(prefers-reduced-motion: no-preference)",
  sm: "(max-width: 640px)",
  md: "(max-width: 768px)",
  lg: "(max-width: 1024px)",
  xl: "(max-width: 1280px)",
  "2xl": "(max-width: 1536px)",
  ls: "(max-width: 1024px) and (orientation: landscape)"
};
var defaultThemeMap = __spreadProps(__spreadValues({}, defaultStitchesThemeMap), {
  width: "space",
  height: "space",
  minWidth: "space",
  maxWidth: "space",
  minHeight: "space",
  maxHeight: "space",
  flexBasis: "space",
  gridTemplateColumns: "space",
  gridTemplateRows: "space",
  blockSize: "space",
  minBlockSize: "space",
  maxBlockSize: "space",
  inlineSize: "space",
  minInlineSize: "space",
  maxInlineSize: "space"
});

// src/Prebuilt/common/constants.ts
init_define_process_env();
import { parsedUserAgent } from "@100mslive/react-sdk";
var QUERY_PARAM_PREVIEW_AS_ROLE = "preview_as_role";
var UI_MODE_GRID = "grid";
var MAX_TOASTS = 5;
var RTMP_RECORD_RESOLUTION_MIN = 480;
var RTMP_RECORD_RESOLUTION_MAX = 1280;
var RTMP_RECORD_DEFAULT_RESOLUTION = {
  width: 1280,
  height: 720
};
var EMOJI_REACTION_TYPE = "EMOJI_REACTION";
var CHAT_SELECTOR = {
  PEER: "peer",
  ROLE: "role",
  EVERYONE: "Everyone"
};
var APP_DATA = {
  uiSettings: "uiSettings",
  chatOpen: "chatOpen",
  chatSelector: "chatSelector",
  chatDraft: "chatDraft",
  appConfig: "appConfig",
  sidePane: "sidePane",
  hlsStats: "hlsStats",
  subscribedNotifications: "subscribedNotifications",
  logo: "logo",
  hlsStarted: "hlsStarted",
  rtmpStarted: "rtmpStarted",
  recordingStarted: "recordingStarted",
  embedConfig: "embedConfig",
  pinnedTrackId: "pinnedTrackId",
  dropdownList: "dropdownList",
  authToken: "authToken",
  pdfConfig: "pdfConfig",
  minimiseInset: "minimiseInset",
  activeScreensharePeerId: "activeScreensharePeerId",
  disableNotifications: "disableNotifications",
  pollState: "pollState",
  background: "background",
  sheet: "sheet",
  caption: "caption",
  loadingEffects: "loadingEffects",
  noiseCancellation: "noiseCancellation"
};
var UI_SETTINGS = {
  isAudioOnly: "isAudioOnly",
  maxTileCount: "maxTileCount",
  uiViewMode: "uiViewMode",
  layoutMode: "layoutMode",
  showStatsOnTiles: "showStatsOnTiles",
  enableAmbientMusic: "enableAmbientMusic",
  mirrorLocalVideo: "mirrorLocalVideo"
};
var SIDE_PANE_OPTIONS = {
  PARTICIPANTS: "Participants",
  CHAT: "Chat",
  STREAMING: "STREAMING",
  POLLS: "POLLS",
  VB: "VB",
  ROOM_DETAILS: "ROOM_DETAILS"
};
var SHEET_OPTIONS = {
  ROOM_DETAILS: "ROOM_DETAILS"
};
var POLL_STATE = {
  pollInView: "pollInView",
  view: "view"
};
var POLL_VIEWS = {
  CREATE_POLL_QUIZ: "CREATE_POLL_QUIZ",
  CREATE_QUESTIONS: "CREATE_QUESTIONS",
  VOTE: "VOTE",
  RESULTS: "RESULTS"
};
var CAPTION_TOAST = {
  captionToast: "captionToast"
};
var SUBSCRIBED_NOTIFICATIONS = {
  PEER_JOINED: "PEER_JOINED",
  PEER_LEFT: "PEER_LEFT",
  METADATA_UPDATED: "METADATA_UPDATED",
  NEW_MESSAGE: "NEW_MESSAGE",
  ERROR: "ERROR"
};
var REMOTE_STOP_SCREENSHARE_TYPE = "REMOTE_STOP_SCREENSHARE";
var _a, _b;
var isChrome = ((_b = (_a = parsedUserAgent.getBrowser()) == null ? void 0 : _a.name) == null ? void 0 : _b.toLowerCase()) === "chrome";
var _a2, _b2;
var isFirefox = ((_b2 = (_a2 = parsedUserAgent.getBrowser()) == null ? void 0 : _a2.name) == null ? void 0 : _b2.toLowerCase()) === "firefox";
var _a3, _b3;
var isSafari = ((_b3 = (_a3 = parsedUserAgent.getBrowser()) == null ? void 0 : _a3.name) == null ? void 0 : _b3.toLowerCase()) === "safari";
var _a4, _b4;
var isIOS = ((_b4 = (_a4 = parsedUserAgent.getOS()) == null ? void 0 : _a4.name) == null ? void 0 : _b4.toLowerCase()) === "ios";
var _a5, _b5;
var isMacOS = ((_b5 = (_a5 = parsedUserAgent.getOS()) == null ? void 0 : _a5.name) == null ? void 0 : _b5.toLowerCase()) === "mac os";
var _a6, _b6;
var isAndroid = ((_b6 = (_a6 = parsedUserAgent.getOS()) == null ? void 0 : _a6.name) == null ? void 0 : _b6.toLowerCase()) === "android";
var QUESTION_TYPE_TITLE = /* @__PURE__ */ ((QUESTION_TYPE_TITLE2) => {
  QUESTION_TYPE_TITLE2["single-choice"] = "Single Choice";
  QUESTION_TYPE_TITLE2["multiple-choice"] = "Multiple Choice";
  return QUESTION_TYPE_TITLE2;
})(QUESTION_TYPE_TITLE || {});
var ROLE_CHANGE_DECLINED = "role_change_declined";
var DEFAULT_PORTAL_CONTAINER = ".prebuilt-container";
var TEST_AUDIO_URL = "https://100ms.live/test-audio.wav";

// src/Theme/stitches.config.ts
var HmsStitches = createStitches({
  prefix: "hms-ui",
  theme: __spreadProps(__spreadValues({}, baseConfig.theme), {
    colors: __spreadValues({}, baseConfig.theme.colors)
  }),
  media: defaultMedia,
  utils: defaultUtils,
  themeMap: defaultThemeMap
});
var {
  theme,
  createTheme: createThemeBase,
  styled,
  globalCss,
  keyframes,
  css,
  getCssText,
  config
} = HmsStitches;
var globalStyles = globalCss({
  [`${DEFAULT_PORTAL_CONTAINER} *`]: {
    fontFamily: "$sans",
    boxSizing: "border-box"
  },
  "::-webkit-scrollbar-track": {
    WebkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
    boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
    backgroundColor: "transparent"
  },
  "::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
    backgroundColor: "transparent"
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: "#657080",
    borderRadius: "5px"
  },
  /**
   * needed for safari. Safari
   * adds background color on its own
   * on hls-viewer on fullscreen
   */
  "#hls-viewer-dark:fullscreen": {
    backgroundColor: "black !important"
  },
  "#hls-viewer-light:fullscreen": {
    backgroundColor: "white !important"
  }
});
var createTheme = ({
  themeType,
  theme: theme2,
  className
}) => {
  if (!themeType) {
    throw new Error("Theme type is required");
  }
  const mergedTheme = merge(baseConfig.theme, theme2 || {});
  return createThemeBase(className || `${themeType}-theme`, mergedTheme);
};

// src/Theme/ThemeProvider.tsx
init_define_process_env();
import React, { useCallback, useEffect as useEffect2, useMemo, useRef, useState as useState2 } from "react";

// src/Theme/useSSR.tsx
init_define_process_env();
import { useEffect, useState } from "react";
var isBrowser = () => {
  return Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
};
var useSSR = () => {
  const [browser, setBrowser] = useState(false);
  useEffect(() => {
    setBrowser(isBrowser());
  }, []);
  return {
    isBrowser: browser,
    isServer: !browser
  };
};
var useSSR_default = useSSR;

// src/Theme/ThemeProvider.tsx
var defaultAspectRatio = {
  width: 1,
  height: 1
};
var ThemeTypes = /* @__PURE__ */ ((ThemeTypes2) => {
  ThemeTypes2["default"] = "default";
  return ThemeTypes2;
})(ThemeTypes || {});
var defaultContext = {
  themeType: "default" /* default */,
  theme,
  aspectRatio: { width: 1, height: 1 },
  toggleTheme: (_themeToUpdateTo) => {
    return;
  }
};
var ThemeContext = React.createContext(defaultContext);
var HMSThemeProvider = ({
  themeType,
  theme: userTheme,
  aspectRatio = defaultAspectRatio,
  children
}) => {
  const systemTheme = "default" /* default */;
  const [currentTheme, setCurrentTheme] = useState2(themeType || systemTheme);
  const previousClassName = useRef("");
  const { isBrowser: isBrowser2 } = useSSR_default();
  const updatedTheme = useMemo(() => {
    const updatedTheme2 = createTheme({ themeType: currentTheme, theme: userTheme || {} });
    if (!isBrowser2) {
      return updatedTheme2;
    }
    if (previousClassName.current) {
      document.documentElement.classList.remove(previousClassName.current);
    }
    previousClassName.current = updatedTheme2.className;
    document.documentElement.classList.add(updatedTheme2);
    return updatedTheme2;
  }, [userTheme, currentTheme, isBrowser2]);
  const toggleTheme = useCallback((themeToUpdateTo) => {
    if (themeToUpdateTo) {
      setCurrentTheme(themeToUpdateTo);
      return;
    }
    setCurrentTheme("default" /* default */);
  }, []);
  useEffect2(() => {
    if (themeType) {
      setCurrentTheme(themeType);
    }
  }, [themeType]);
  return /* @__PURE__ */ React.createElement(
    ThemeContext.Provider,
    {
      value: { themeType: currentTheme, theme: updatedTheme, aspectRatio, toggleTheme }
    },
    children
  );
};
var useTheme = () => React.useContext(ThemeContext);

// src/Layout/Flex.tsx
var gapStyles = (value) => {
  return {
    "& > * + *": {
      marginRight: "0",
      marginLeft: `${0.25 * value}rem`
    }
  };
};
var Flex = styled("div", {
  display: "flex",
  variants: {
    justify: {
      start: {
        justifyContent: "flex-start"
      },
      end: {
        justifyContent: "flex-end"
      },
      center: {
        justifyContent: "center"
      },
      between: {
        justifyContent: "space-between"
      },
      around: {
        justifyContent: "space-around"
      },
      evenly: {
        justifyContent: "space-evenly"
      }
    },
    align: {
      start: {
        alignItems: "flex-start"
      },
      end: {
        alignItems: "flex-end"
      },
      center: {
        alignItems: "center"
      },
      baseline: {
        alignItems: "baseline"
      },
      stretch: {
        alignItems: "stretch"
      }
    },
    direction: {
      row: {
        flexDirection: "row"
      },
      column: {
        flexDirection: "column"
      },
      rowReverse: {
        flexDirection: "row-reverse"
      },
      columnReverse: {
        flexDirection: "column-reverse"
      }
    },
    gap: {
      1: gapStyles(1),
      2: gapStyles(2),
      3: gapStyles(3),
      4: gapStyles(4)
    }
  }
});

// src/Layout/Box.tsx
init_define_process_env();
var Box = styled("div", {});

// src/Loading/index.ts
init_define_process_env();

// src/Loading/Loading.tsx
init_define_process_env();
import React2 from "react";
var Loading = (_a8) => {
  var _b7 = _a8, { size = 24, color = "white" } = _b7, props = __objRest(_b7, ["size", "color"]);
  return /* @__PURE__ */ React2.createElement("svg", __spreadValues({ width: size, height: size, viewBox: "0 0 50 50", fill: color, xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React2.createElement("circle", { cx: "25", cy: "25", r: "20", stroke: color, strokeWidth: "4", strokeDasharray: "70 30", fill: "none" }, /* @__PURE__ */ React2.createElement(
    "animateTransform",
    {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 25 25",
      to: "360 25 25",
      dur: "1s",
      repeatCount: "indefinite"
    }
  )));
};

// src/utils/styles.ts
init_define_process_env();
var flexCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
var textEllipsis = (width) => ({
  maxWidth: width,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0
});

// src/Button/Button.tsx
var getOutlinedVariants = (base, hover, active, disabled, text, textDisabled, textHover) => {
  return {
    bg: "transparent",
    border: `solid $space$px $colors${base}`,
    c: text,
    "&[disabled]": {
      c: textDisabled,
      bg: "transparent",
      border: `solid $space$px $colors${disabled}`,
      cursor: "not-allowed"
    },
    "&:not([disabled]):hover": {
      c: textHover,
      border: `solid $space$px $colors${hover}`,
      bg: "transparent"
    },
    "&:not([disabled]):active": {
      border: `solid $space$px $colors${active}`,
      bg: "transparent"
    },
    "&:not([disabled]):focus-visible": {
      boxShadow: `0 0 0 3px $colors${base}`
    }
  };
};
var getButtonVariants = (base, hover, active, disabled, text, textDisabled, textHover) => {
  return {
    bg: base,
    border: `1px solid ${base}`,
    c: text,
    "&[disabled]": {
      c: textDisabled,
      cursor: "not-allowed",
      bg: disabled,
      border: `1px solid ${disabled}`
    },
    "&:not([disabled]):hover": {
      c: textHover,
      bg: hover,
      border: `1px solid ${hover}`
    },
    "&:not([disabled]):active": {
      bg: active,
      border: `1px solid ${active}`
    },
    "&:not([disabled]):focus-visible": {
      boxShadow: `0 0 0 3px $colors${hover}`
    }
  };
};
var StyledButton = styled("button", __spreadProps(__spreadValues({}, flexCenter), {
  cursor: "pointer",
  fontFamily: "$sans",
  lineHeight: "inherit",
  textTransform: "none",
  position: "relative",
  outline: "none",
  border: "none",
  fs: "$md",
  r: "$1",
  backgroundColor: "$primary_default",
  fontWeight: "500",
  whiteSpace: "nowrap",
  p: "$4 $8",
  "-webkit-appearance": "button",
  "&:focus": {
    outline: "none"
  },
  "&:not([disabled]):focus-visible": {
    boxShadow: "0 0 0 3px $colors$primary_default"
  },
  transition: "all 0.2s  ease",
  compoundVariants: [
    {
      variant: "standard",
      outlined: true,
      css: getOutlinedVariants(
        "$secondary_default",
        "$secondary_bright",
        "$secondary_dim",
        "$secondary_disabled",
        "$on_surface_high",
        "$on_surface_low"
      )
    },
    {
      variant: "danger",
      outlined: true,
      css: getOutlinedVariants(
        "$alert_error_default",
        "$alert_error_bright",
        "$alert_error_dim",
        "$alert_error_brighter",
        "$on_surface_high",
        "$on_surface_low",
        "$on_surface_high"
      )
    },
    {
      variant: "primary",
      outlined: true,
      css: getOutlinedVariants(
        "$primary_default",
        "$primary_bright",
        "$primary_dim",
        "$primary_disabled",
        "$on_surface_high",
        "$on_surface_low"
      )
    }
  ],
  variants: {
    variant: {
      standard: getButtonVariants(
        "$secondary_default",
        "$secondary_bright",
        "$secondary_dim",
        "$secondary_disabled",
        "$on_secondary_high",
        "$on_secondary_low"
      ),
      danger: getButtonVariants(
        "$alert_error_default",
        "$alert_error_bright",
        "$alert_error_dim",
        "$alert_error_dim",
        "$alert_error_brighter",
        "$on_primary_low",
        "$on_primary_high"
      ),
      primary: getButtonVariants(
        "$primary_default",
        "$primary_bright",
        "$primary_dim",
        "$primary_disabled",
        "$on_primary_high",
        "$on_primary_low"
      )
    },
    outlined: {
      true: {}
    },
    icon: {
      true: {}
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}));
var Button = React3.forwardRef((_a8, ref) => {
  var _b7 = _a8, { children, loading = false, icon } = _b7, buttonProps = __objRest(_b7, ["children", "loading", "icon"]);
  return /* @__PURE__ */ React3.createElement(StyledButton, __spreadProps(__spreadValues({}, buttonProps), { ref }), /* @__PURE__ */ React3.createElement(React3.Fragment, null, loading && /* @__PURE__ */ React3.createElement(
    Flex,
    {
      align: "center",
      justify: "center",
      css: { w: "100%", position: "absolute", left: "0", color: "$on_primary_low" }
    },
    /* @__PURE__ */ React3.createElement(Loading, { color: "currentColor" })
  ), /* @__PURE__ */ React3.createElement(
    Flex,
    {
      align: "center",
      justify: "center",
      css: { visibility: loading ? "hidden" : "visible", gap: icon ? "$4" : "0" }
    },
    children
  )));
});

// src/Text/index.tsx
init_define_process_env();

// src/Text/Text.tsx
init_define_process_env();
var textVariants = {
  h1: {
    fontWeight: "$semiBold",
    letterSpacing: "-1.5px",
    fontSize: "$h1",
    lineHeight: "$h1",
    "@md": {
      fontSize: "4.5rem",
      lineHeight: "4.75rem"
    }
  },
  h2: {
    fontSize: "$h2",
    lineHeight: "$h2",
    fontWeight: "$semiBold",
    letterSpacing: "-0.5px",
    "@md": {
      fontSize: "3rem",
      lineHeight: "3.25rem"
    }
  },
  h3: {
    fontSize: "$h3",
    lineHeight: "$h3",
    fontWeight: "$semiBold",
    "@md": {
      fontSize: "2.5rem",
      lineHeight: "2.75rem"
    }
  },
  h4: {
    fontSize: "$h4",
    lineHeight: "$h4",
    fontWeight: "$semiBold",
    letterSpacing: "0.25px",
    "@md": {
      fontSize: "1.75rem",
      lineHeight: "2rem"
    }
  },
  h5: {
    fontSize: "$h5",
    lineHeight: "$h5",
    fontWeight: "$semiBold",
    "@md": {
      fontSize: "1.5rem",
      lineHeight: "1.75rem"
    }
  },
  h6: {
    fontSize: "$h6",
    lineHeight: "$h6",
    fontWeight: "$semiBold",
    letterSpacing: "0.15px",
    "@md": {
      fontSize: "1.25rem",
      lineHeight: "1.5rem"
    }
  },
  sub1: {
    fontSize: "$md",
    lineHeight: "$h5",
    fontWeight: "$medium",
    letterSpacing: "0.15px"
  },
  sub2: {
    fontSize: "$sm",
    lineHeight: "$sm",
    fontWeight: "$medium",
    letterSpacing: "0.1px"
  },
  body1: {
    fontSize: "$md",
    lineHeight: "$h6",
    fontWeight: "$medium",
    letterSpacing: "0.1px"
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    fontWeight: "$medium",
    letterSpacing: "0.25px"
  },
  button: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: "$semiBold",
    letterSpacing: "0.5px"
  },
  caption: {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    letterSpacing: "0.4px",
    fontWeight: "$regular"
  },
  overline: {
    fontSize: "0.625rem",
    lineHeight: "1rem",
    letterSpacing: "1.5px",
    fontWeight: "$medium"
  },
  tiny: {
    fontSize: "$tiny",
    lineHeight: "$tiny"
  },
  xs: {
    fontSize: "$xs",
    lineHeight: "$xs"
  },
  sm: {
    fontSize: "$sm",
    lineHeight: "$sm"
  },
  md: {
    fontSize: "$md",
    lineHeight: "$md"
  },
  lg: {
    fontSize: "$lg",
    lineHeight: "$md",
    fontWeight: "$semiBold",
    letterSpacing: "0.15px"
  }
};
var Text = styled("p", {
  fontFamily: "$sans",
  fontWeight: "$regular",
  margin: 0,
  color: "$on_surface_high",
  variants: {
    variant: textVariants,
    color: {
      white: {
        color: "$on_surface_high"
      }
    },
    inline: {
      true: {
        display: "inline"
      }
    }
  },
  defaultVariants: {
    variant: "md"
  }
});

// src/IconButton/index.tsx
init_define_process_env();

// src/IconButton/IconButton.tsx
init_define_process_env();
var IconButton = styled("button", __spreadProps(__spreadValues({}, flexCenter), {
  alignItems: "center",
  outline: "none",
  border: "none",
  padding: "$2",
  r: "$0",
  cursor: "pointer",
  backgroundColor: "transparent",
  color: "$on_surface_high",
  "&:not([disabled]):focus-visible": {
    boxShadow: "0 0 0 3px $colors$primary_default"
  },
  "&:not([disabled]):focus": {
    outline: "none"
  },
  "@media (hover: hover)": {
    "&:not([disabled]):hover": {
      backgroundColor: "$on_surface_low"
    }
  },
  "&[disabled]": {
    opacity: 0.5,
    cursor: "not-allowed",
    backgroundColor: "$secondary_dim",
    color: "$on_primary_high"
  },
  "&:focus": {
    outline: "none"
  },
  variants: {
    active: {
      true: {
        "&:not([disabled]):hover": {
          backgroundColor: "$on_surface_low"
        }
      }
    }
  }
}));

// src/Avatar/index.ts
init_define_process_env();

// src/Avatar/Avatar.tsx
init_define_process_env();
import React4 from "react";
import { PersonIcon } from "@100mslive/react-icons";

// src/Avatar/getAvatarBg.ts
init_define_process_env();
var getInitials = (name) => {
  var _a8, _b7, _c;
  if (!name) {
    return void 0;
  } else {
    return (_c = (_b7 = (_a8 = name.trim().replace(/[^a-zA-Z0-9]/g, "").match(/(^\S\S?|\b\S)?/g)) == null ? void 0 : _a8.join("")) == null ? void 0 : _b7.match(/(^\S|\S$)?/g)) == null ? void 0 : _c.join("").toUpperCase();
  }
};
var getAvatarBg = (name) => {
  const initials = getInitials(name);
  const indexFactor = 20;
  const colorIndex = ((initials == null ? void 0 : initials.codePointAt(0)) || 0) % indexFactor + 1;
  return { initials: initials || "", color: colorsList[colorIndex - 1] };
};
var colorsList = [
  "#616161",
  "#F44336",
  "#3F51B5",
  "#4CAF50",
  "#FFA000",
  "#795548",
  "#E91E63",
  "#2F80FF",
  "#8BC34A",
  "#F57C00",
  "#4E342E",
  "#9C27B0",
  "#00BCD4",
  "#C0CA33",
  "#F4511E",
  "#673AB7",
  "#009688",
  "#FBC02D",
  "#BF360C",
  "#455A64"
];

// src/Avatar/Avatar.tsx
var getAvatarShape = (radii) => ({
  borderRadius: radii
});
var StyledAvatar = styled("div", __spreadProps(__spreadValues({}, flexCenter), {
  color: "$colors$on_primary_high",
  fontFamily: "$sans",
  aspectRatio: "1",
  fontWeight: 600,
  fontSize: "$space$9",
  variants: {
    shape: {
      circle: getAvatarShape("$round"),
      square: getAvatarShape("$1")
    },
    size: {
      small: {
        height: "$16 !important",
        fontSize: "$space$6"
      },
      medium: {
        height: "$18 !important",
        fontSize: "$space$10"
      },
      large: {
        height: "$20 !important",
        fontSize: "$space$12"
      }
    }
  },
  defaultVariants: {
    shape: "circle"
  }
}));
var Avatar = (_a8) => {
  var _b7 = _a8, { name, css: css2 } = _b7, props = __objRest(_b7, ["name", "css"]);
  const info = getAvatarBg(name);
  let { color } = info;
  if (!name) {
    color = "#7E47EB";
  }
  return /* @__PURE__ */ React4.createElement(StyledAvatar, __spreadValues({ css: __spreadValues({ bg: color }, css2) }, props), info.initials || /* @__PURE__ */ React4.createElement(PersonIcon, { height: 40, width: 40 }));
};

// src/Divider/index.ts
init_define_process_env();

// src/Divider/Divider.tsx
init_define_process_env();
var getVerticalSpace = (space) => ({
  marginLeft: space,
  marginRight: space
});
var getHorizontalSpace = (space) => ({
  marginTop: space,
  marginBottom: space
});
var VerticalDivider = styled("span", {
  height: "25px",
  width: "1px",
  backgroundColor: "$border_bright",
  variants: {
    space: {
      1: getVerticalSpace("$1"),
      2: getVerticalSpace("$2"),
      3: getVerticalSpace("$3"),
      4: getVerticalSpace("$4")
    }
  },
  defaultVariants: {
    space: 1
  }
});
var HorizontalDivider = styled("span", {
  height: "1px",
  width: "100%",
  display: "block",
  backgroundColor: "$border_bright",
  variants: {
    space: {
      1: getHorizontalSpace("$1"),
      2: getHorizontalSpace("$2"),
      3: getHorizontalSpace("$3"),
      4: getHorizontalSpace("$4")
    }
  },
  defaultVariants: {
    space: 1
  }
});

// src/Switch/index.ts
init_define_process_env();

// src/Switch/Switch.tsx
init_define_process_env();
import React5 from "react";
import * as BaseSwitch from "@radix-ui/react-switch";
var SwitchRoot = styled(BaseSwitch.Root, {
  all: "unset",
  width: "30px",
  height: "14px",
  border: "solid $space$px $secondary_default",
  borderRadius: "$3",
  p: "$2",
  position: "relative",
  cursor: "pointer",
  '&[data-state="checked"]': {
    backgroundColor: "$primary_default",
    border: "solid $space$px $primary_default"
  },
  "&:focus": {
    outline: "none"
  },
  "&[disabled]": {
    opacity: 0.5,
    cursor: "not-allowed"
  }
});
var SwitchThumb = styled(BaseSwitch.Thumb, {
  display: "block",
  top: "3px",
  position: "absolute",
  width: "$md",
  height: "$md",
  backgroundColor: "$secondary_default",
  borderRadius: "$round",
  transition: "right 500ms ease-in",
  left: "$2",
  '&[data-state="checked"]': {
    left: "unset",
    right: "$2",
    backgroundColor: "$on_primary_high"
  }
});
var Switch = (props) => /* @__PURE__ */ React5.createElement(SwitchRoot, __spreadValues({}, props), /* @__PURE__ */ React5.createElement(SwitchThumb, null));
Switch.displayName = "Switch";

// src/Tooltip/index.ts
init_define_process_env();

// src/Tooltip/Tooltip.tsx
init_define_process_env();
import React6, { useState as useState3 } from "react";
import * as BaseTooltip from "@radix-ui/react-tooltip";

// src/utils/animations.ts
init_define_process_env();
var slideDown = (controller) => keyframes({
  from: { height: 0 },
  to: { height: `var(${controller})` }
});
var slideUp = (controller) => keyframes({
  from: { height: `var(${controller})` },
  to: { height: 0 }
});
var translateAcross = ({ xFrom = "0", yFrom = "0", zFrom = "0", xTo = "0", yTo = "0", zTo = "0" }) => keyframes({
  from: { transform: `translate3d(${xFrom}, ${yFrom}, ${zFrom})` },
  to: { transform: `translate3d(${xTo}, ${yTo}, ${zTo}` }
});
var dialogOpen = keyframes({
  "0%": { opacity: 0, transform: "translate(-50%, -48%) scale(.90)" },
  "100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" }
});
var dialogClose = keyframes({
  "0%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
  "100%": { opacity: 0, transform: "translate(-50%, -48%) scale(.90)" }
});
var slideUpAndFade = (start = "2px") => keyframes({
  "0%": { opacity: 0, transform: `translateY(${start})` },
  "100%": { opacity: 1, transform: "translateY(0)" }
});
var slideRightAndFade = (start = "-2px") => keyframes({
  "0%": { opacity: 0, transform: `translateX(${start})` },
  "100%": { opacity: 1, transform: "translateX(0)" }
});
var sheetSlideIn = keyframes({
  from: { transform: "$$transformValue" },
  to: { transform: "translate3d(0,0,0)" }
});
var sheetSlideOut = keyframes({
  from: { transform: "translate3d(0,0,0)" },
  to: { transform: "$$transformValue" }
});
var sheetFadeIn = keyframes({
  from: { opacity: "0" },
  to: { opacity: "1" }
});
var sheetFadeOut = keyframes({
  from: { opacity: "1" },
  to: { opacity: "0" }
});
var slideDownAndFade = (start = "-2px") => keyframes({
  "0%": { opacity: 0, transform: `translateY(${start})` },
  "100%": { opacity: 1, transform: "translateY(0)" }
});
var slideLeftAndFade = (start = "2px") => keyframes({
  "0%": { opacity: 0, transform: `translateX(${start})` },
  "100%": { opacity: 1, transform: "translateX(0)" }
});
var slideLeftAndFadeOut = (end = "-100%") => keyframes({
  "0%": { opacity: 1, transform: `translateX(0)` },
  "100%": { opacity: 0, transform: `translateX(${end})` }
});
var popoverAnimation = {
  "@media (prefers-reduced-motion: no-preference)": {
    animationDuration: "400ms",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    willChange: "transform, opacity",
    '&[data-state="open"]': {
      '&[data-side="top"]': { animationName: slideDownAndFade() },
      '&[data-side="right"]': { animationName: slideLeftAndFade() },
      '&[data-side="bottom"]': { animationName: slideUpAndFade() },
      '&[data-side="left"]': { animationName: slideRightAndFade() }
    }
  }
};
var toastAnimation = {
  "@media (prefers-reduced-motion: no-preference)": {
    animationDuration: "500ms",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    willChange: "transform, opacity",
    animationName: slideLeftAndFadeOut(),
    '&[data-state="open"]': {
      animationName: slideRightAndFade("-100%")
    },
    '&[data-swipe="move"]': {
      transform: "translateX(var(--radix-toast-swipe-move-x))"
    },
    '&[data-swipe="cancel"]': {
      transform: "translateX(0)",
      transition: "transform 200ms ease-out"
    },
    '&[data-swipe="end"]': {
      animation: `${slideLeftAndFadeOut()} 100ms ease-out forwards`
    }
  }
};

// src/Tooltip/Tooltip.tsx
var TooltipBox = styled(BaseTooltip.Content, {
  fontFamily: "$sans",
  borderRadius: "$2",
  padding: "$2 $4",
  fontSize: "$xs",
  zIndex: 11,
  color: "$on_surface_high",
  backgroundColor: "$surface_bright",
  "@media (prefers-reduced-motion: no-preference)": {
    animationDuration: "400ms",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    willChange: "transform, opacity",
    '&[data-state="delayed-open"]': {
      '&[data-side="top"]': { animationName: slideDownAndFade() },
      '&[data-side="right"]': { animationName: slideLeftAndFade() },
      '&[data-side="bottom"]': { animationName: slideUpAndFade() },
      '&[data-side="left"]': { animationName: slideRightAndFade() }
    }
  },
  variants: {
    outlined: {
      true: {
        backgroundColor: "$background_dim",
        border: "solid $space$px $border_bright"
      }
    }
  }
});
var TooltipTrigger = styled(BaseTooltip.Trigger, {
  fontFamily: "$sans"
});
var TooltipRoot = BaseTooltip.Root;
var Tooltip = ({
  children,
  title,
  triggerCss,
  boxCss,
  outlined = true,
  side = "bottom",
  align = "center",
  disabled = false,
  delayDuration = 200
}) => {
  const [open, setOpen] = useState3(false);
  return /* @__PURE__ */ React6.createElement(BaseTooltip.Provider, null, /* @__PURE__ */ React6.createElement(TooltipRoot, { delayDuration, open: open && !disabled, onOpenChange: setOpen }, /* @__PURE__ */ React6.createElement(TooltipTrigger, { css: __spreadValues({}, triggerCss), asChild: true }, children), /* @__PURE__ */ React6.createElement(TooltipBox, { sideOffset: 10, side, align, outlined, css: __spreadValues({}, boxCss) }, title)));
};

// src/Select/index.ts
init_define_process_env();

// src/Select/Select.tsx
init_define_process_env();
import React7 from "react";
import { ChevronDownIcon } from "@100mslive/react-icons";
var Root3 = styled("div", {
  color: "$on_primary_high",
  display: "inline-flex",
  position: "relative",
  outline: "none",
  overflow: "hidden",
  borderRadius: "$1",
  backgroundColor: "$surface_default",
  maxWidth: "100%"
});
var SelectRoot = styled("select", {
  h: "$16",
  fontSize: "$md",
  fontWeight: "500",
  lineHeight: "inherit",
  textTransform: "none",
  appearance: "none",
  color: "$on_secondary_high",
  padding: "5px",
  paddingLeft: "12px",
  paddingRight: "30px",
  border: "none",
  borderRadius: "8px",
  backgroundColor: "$secondary_default",
  "&:not([disabled]):focus-visible": {
    boxShadow: "0 0 0 3px $colors$primary_default"
  },
  "&[disabled]": {
    opacity: 0.5,
    cursor: "not-allowed"
  }
});
var Arrow = styled("span", {
  color: "$on_secondary_high",
  width: "30px",
  height: "100%",
  position: "absolute",
  right: 0,
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  transition: "border .2s ease 0s"
});
var DefaultDownIcon = (_a8) => {
  var props = __objRest(_a8, []);
  return /* @__PURE__ */ React7.createElement(Arrow, __spreadValues({}, props), /* @__PURE__ */ React7.createElement(ChevronDownIcon, null));
};
var Select = {
  Root: Root3,
  DownIcon: Arrow,
  DefaultDownIcon,
  Select: SelectRoot
};

// src/Slider/index.ts
init_define_process_env();

// src/Slider/Slider.tsx
init_define_process_env();
import React8 from "react";
import * as BaseSlider from "@radix-ui/react-slider";
var Root5 = styled(BaseSlider.Root, {
  position: "relative",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  touchAction: "none",
  width: "100%",
  '&[data-orientation="horizontal"]': {
    height: 20
  }
});
var Track2 = styled(BaseSlider.Track, {
  backgroundColor: "$surface_bright",
  position: "relative",
  flexGrow: 1,
  borderRadius: "$round",
  cursor: "pointer",
  '&[data-orientation="horizontal"]': { height: 3 }
});
var Range2 = styled(BaseSlider.Range, {
  position: "absolute",
  backgroundColor: "$primary_default",
  borderRadius: "$round",
  height: "100%"
});
var Thumb3 = styled(BaseSlider.Thumb, {
  all: "unset",
  display: "block",
  width: "$8",
  height: "$8",
  backgroundColor: "$primary_default",
  cursor: "pointer",
  boxShadow: `0 2px 10px $colors$surface_default`,
  borderRadius: 10,
  "&:hover": { backgroundColor: "$primary_default" },
  "&:focus": { boxShadow: "none" }
});
var Slider = (_a8) => {
  var _b7 = _a8, {
    showTooltip = true,
    thumbStyles
  } = _b7, props = __objRest(_b7, [
    "showTooltip",
    "thumbStyles"
  ]);
  var _a9;
  return /* @__PURE__ */ React8.createElement(Root5, __spreadValues({}, props), /* @__PURE__ */ React8.createElement(Track2, null, /* @__PURE__ */ React8.createElement(Range2, null)), showTooltip ? /* @__PURE__ */ React8.createElement(Tooltip, { title: String((_a9 = props.value) == null ? void 0 : _a9[0]) }, /* @__PURE__ */ React8.createElement(Thumb3, { css: thumbStyles })) : /* @__PURE__ */ React8.createElement(Thumb3, { css: thumbStyles }));
};

// src/Modal/index.ts
init_define_process_env();

// src/Modal/Dialog.tsx
init_define_process_env();
import React11, { useEffect as useEffect3, useRef as useRef2 } from "react";
import { Root as Root6 } from "@radix-ui/react-dialog";
import { styled as styled2 } from "@stitches/react";

// src/Modal/DialogContent.tsx
init_define_process_env();
import React9 from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { CrossIcon } from "@100mslive/react-icons";
var DialogClose = styled(DialogPrimitive.Close, {
  backgroundColor: "transparent",
  padding: "0",
  margin: "0",
  border: "none",
  backgroundImage: "none"
});
var StyledDialogTrigger = styled(DialogPrimitive.Trigger, {
  appearance: "none !important"
  // Needed for safari it shows white overlay
});
var CustomDialogOverlay = styled(DialogPrimitive.Overlay, {
  backgroundColor: "rgba(0, 0, 0, 0.5);",
  position: "absolute",
  inset: 0
});
var StyledDialogPortal = styled(DialogPrimitive.Portal, {});
var CustomDialogContent = styled(DialogPrimitive.Content, {
  color: "$on_surface_medium",
  backgroundColor: "$surface_dim",
  borderRadius: "8px",
  position: "absolute",
  top: "50%",
  left: "50%",
  maxHeight: "95%",
  overflowY: "auto",
  border: "$space$px solid $border_bright",
  boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  transform: "translate(-50%, -50%)",
  zIndex: 999,
  padding: "$12",
  "@allowMotion": {
    '&[data-state="open"]': {
      animation: `${dialogOpen} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
    },
    '&[data-state="closed"]': {
      animation: `${dialogClose} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
    }
  },
  "&:focus": { outline: "none" }
});
var DialogTitle = styled(DialogPrimitive.Title, {
  margin: 0
});
var DialogDescription = styled(DialogPrimitive.Description, {});
var DialogDefaultCloseIcon = (props) => /* @__PURE__ */ React9.createElement(DialogClose, { asChild: true }, /* @__PURE__ */ React9.createElement(IconButton, __spreadValues({}, props), /* @__PURE__ */ React9.createElement(CrossIcon, null)));

// src/hooks/useDialogContainerSelector.tsx
init_define_process_env();
import { useContext } from "react";

// src/context/DialogContext.tsx
init_define_process_env();
import React10, { createContext } from "react";
var DialogContainerContext = createContext("");
function DialogContainerProvider({
  children,
  dialogContainerSelector
}) {
  return /* @__PURE__ */ React10.createElement(DialogContainerContext.Provider, { value: dialogContainerSelector }, children);
}

// src/hooks/useDialogContainerSelector.tsx
function useDialogContainerSelector() {
  const dialogContainerSelector = useContext(DialogContainerContext);
  return dialogContainerSelector;
}

// src/Modal/Dialog.tsx
var StyledDialog = styled2(Root6, {});
var DialogRoot = (props) => {
  useEffect3(() => {
    return () => {
      if (document)
        setTimeout(() => document.body.style.pointerEvents = "auto", 0);
    };
  }, []);
  return /* @__PURE__ */ React11.createElement(StyledDialog, __spreadValues({}, props));
};
var CustomDialogPortal = ({ children, container }) => {
  const dialogContainerSelector = useDialogContainerSelector();
  const containerRef = useRef2(null);
  if (container) {
    containerRef.current = container;
  } else if (dialogContainerSelector && !containerRef.current) {
    containerRef.current = document.querySelector(dialogContainerSelector);
  } else if (!containerRef.current) {
    containerRef.current = document.body;
  }
  return /* @__PURE__ */ React11.createElement(StyledDialogPortal, { container: containerRef.current }, /* @__PURE__ */ React11.createElement(React11.Fragment, null, children));
};
var Dialog = {
  Root: DialogRoot,
  Trigger: StyledDialogTrigger,
  Overlay: CustomDialogOverlay,
  Content: CustomDialogContent,
  Title: DialogTitle,
  Description: DialogDescription,
  Close: DialogClose,
  DefaultClose: DialogDefaultCloseIcon,
  Portal: CustomDialogPortal
};

// src/Input/Input.tsx
init_define_process_env();
import React12 from "react";
import { CopyIcon, EyeCloseIcon, EyeOpenIcon } from "@100mslive/react-icons";
var Input = styled("input", {
  fontFamily: "$sans",
  lineHeight: "inherit",
  backgroundColor: "$surface_default",
  borderRadius: "8px",
  outline: "none",
  border: "1px solid $border_default",
  padding: "0.5rem 0.75rem",
  minHeight: "30px",
  color: "$on_surface_high",
  fontSize: "$md",
  "&:disabled": {
    cursor: "not-allowed"
  },
  "&:focus": {
    boxShadow: "0 0 0 1px $colors$primary_default",
    border: "1px solid transparent"
  },
  "&::placeholder": {
    color: "$on_surface_medium"
  },
  variants: {
    error: {
      true: {
        "&:focus": {
          boxShadow: "0 0 0 3px $colors$alert_error_default"
        }
      }
    }
  }
});
var PasswordRoot = styled("div", {
  w: "100%",
  position: "relative",
  display: "flex"
});
var PasswordShowIcon = (_a8) => {
  var _b7 = _a8, {
    showPassword,
    css: css2
  } = _b7, props = __objRest(_b7, [
    "showPassword",
    "css"
  ]);
  return /* @__PURE__ */ React12.createElement(Flex, __spreadValues({ css: __spreadValues({}, css2) }, props), showPassword ? /* @__PURE__ */ React12.createElement(EyeOpenIcon, null) : /* @__PURE__ */ React12.createElement(EyeCloseIcon, null));
};
var PasswordCopyIcon = (_a8) => {
  var _b7 = _a8, { css: css2 } = _b7, props = __objRest(_b7, ["css"]);
  return /* @__PURE__ */ React12.createElement(Flex, __spreadValues({ css: __spreadValues({}, css2) }, props), /* @__PURE__ */ React12.createElement(CopyIcon, null));
};
var PasswordIcons = React12.forwardRef(
  (_a8, ref) => {
    var _b7 = _a8, { css: css2 } = _b7, props = __objRest(_b7, ["css"]);
    return /* @__PURE__ */ React12.createElement(
      Flex,
      __spreadValues({
        css: __spreadValues({
          position: "absolute",
          top: 0,
          height: "100%",
          zIndex: 10,
          right: "$4",
          bg: "$surface_bright",
          alignItems: "center"
        }, css2),
        ref
      }, props),
      props.children
    );
  }
);
var ReactInput = React12.forwardRef((_a8, ref) => {
  var _b7 = _a8, { showPassword = false, css: css2 } = _b7, props = __objRest(_b7, ["showPassword", "css"]);
  return /* @__PURE__ */ React12.createElement(
    Input,
    __spreadProps(__spreadValues({
      css: __spreadValues({ flexGrow: 1, width: "100%" }, css2),
      type: showPassword ? "text" : "password"
    }, props), {
      ref
    })
  );
});
var PasswordInput = {
  Root: PasswordRoot,
  Icons: PasswordIcons,
  Input: ReactInput,
  ShowIcon: PasswordShowIcon,
  CopyIcon: PasswordCopyIcon
};

// src/VideoTile/index.tsx
init_define_process_env();

// src/VideoTile/StyledVideoTile.tsx
init_define_process_env();
var Root7 = styled("div", {
  padding: "0.75rem"
});
var Container = styled("div", {
  width: "100%",
  height: "100%",
  position: "relative",
  overflow: "hidden",
  borderRadius: "$2",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "$background_default",
  variants: {
    transparentBg: {
      true: {
        background: "transparent"
      }
    },
    noRadius: {
      true: {
        borderRadius: 0
      }
    }
  }
});
var Overlay2 = styled("div", {
  position: "absolute",
  width: "100%",
  height: "100%"
});
var Info = styled("div", {
  color: "$on_primary_high",
  position: "absolute",
  bottom: "5px",
  left: "50%",
  fontSize: "$sm",
  transform: "translateX(-50%)",
  textAlign: "center",
  width: "80%",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  fontFamily: "$sans"
});
var AttributeBox = styled("div", __spreadProps(__spreadValues({
  position: "absolute",
  top: "$4",
  color: "$on_secondary_high",
  bg: "$secondary_dim",
  borderRadius: "$round",
  width: "$14",
  height: "$14",
  mb: "5px"
}, flexCenter), {
  variants: {
    size: {
      small: {
        width: "$10",
        height: "$10",
        "& > svg": {
          width: "$8",
          height: "$8"
        }
      },
      medium: {
        width: "$13",
        height: "$13"
      }
    },
    position: {
      left: { left: "$4" },
      right: { right: "$4" }
    }
  },
  defaultVariants: {
    size: "medium",
    position: "left"
  }
}));
var AudioIndicator = styled(AttributeBox, { defaultVariants: { position: "right" } });
var FullScreenButton = styled("button", {
  height: "$14",
  p: "$2 $4",
  color: "$on_surface_high",
  borderRadius: "$1",
  border: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "$2",
  right: "$2",
  zIndex: 5,
  "&:not([disabled]):focus": {
    outline: "none",
    boxShadow: "0 0 0 3px $colors$primary_bright"
  }
});
var AvatarContainer = styled(Box, __spreadProps(__spreadValues({}, flexCenter), {
  flexDirection: "column",
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translateX(-50%) translateY(-50%)",
  width: "40%",
  height: "40%",
  "& > div": {
    maxHeight: "$20",
    height: "100%"
  }
}));
var StyledVideoTile = {
  Root: Root7,
  Container,
  Overlay: Overlay2,
  Info,
  AvatarContainer,
  AttributeBox,
  AudioIndicator,
  FullScreenButton
};

// src/VideoList/index.tsx
init_define_process_env();

// src/VideoList/videoListUtils.tsx
init_define_process_env();
var getLeft = (index, currentPageIndex) => {
  if (index === currentPageIndex) {
    return 0;
  }
  if (index + 1 === currentPageIndex) {
    return "-100%";
  }
  if (index - 1 === currentPageIndex) {
    return "100%";
  }
  if (index < currentPageIndex) {
    return "-200%";
  }
  return "200%";
};

// src/VideoList/StyledVideoList.tsx
init_define_process_env();
var Root8 = styled("div", {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column"
});
var Container2 = styled("div", {
  height: "100%",
  width: "100%",
  position: "relative",
  display: "flex",
  alignItems: "center",
  overflow: "hidden"
});
var View = styled("div", {
  height: "100%",
  width: "100%",
  position: "absolute",
  display: "flex",
  placeContent: "center",
  flexWrap: "wrap",
  alignItems: "center"
});
var StyledVideoList = {
  Root: Root8,
  Container: Container2,
  View
};

// src/Pagination/index.tsx
init_define_process_env();

// src/Pagination/StyledPagination.tsx
init_define_process_env();
var Root9 = styled("div", {
  height: "2rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  "& > * + *": {
    marginRight: "0",
    marginLeft: "0.5rem"
  }
});
var Chevron = styled("button", {
  color: "$on_surface_high",
  border: "none",
  "&:focus": {
    outline: "none"
  },
  "&[disabled]": {
    color: "$on_surface_low",
    cursor: "not-allowed"
  },
  backgroundColor: "transparent",
  display: "flex"
});
var Dots = styled("div", {
  display: "flex",
  alignItems: "center",
  "& > * + *": {
    marginRight: "0",
    marginLeft: "0.5rem"
  }
});
var Dot = styled("button", {
  "&:focus": {
    outline: "none"
  },
  borderRadius: "9999px",
  width: "0.5rem",
  height: "0.5rem",
  backgroundColor: "$on_surface_low",
  padding: "0px",
  border: "none",
  cursor: "pointer",
  variants: {
    active: {
      true: {
        backgroundColor: "$on_surface_high"
      }
    }
  }
});
var StyledPagination = {
  Root: Root9,
  Chevron,
  Dots,
  Dot
};

// src/Dropdown/Dropdown.tsx
init_define_process_env();
import {
  CheckboxItem,
  Content as Content3,
  Group,
  Item,
  ItemIndicator,
  Label,
  Portal as Portal2,
  Root as Root10,
  Separator,
  Sub,
  SubContent,
  SubTrigger,
  Trigger as Trigger3
} from "@radix-ui/react-dropdown-menu";
var DropdownRoot = styled(Root10, {});
var DropdownTrigger = styled(Trigger3, {
  cursor: "pointer",
  appearance: "none !important",
  '&[data-state="open"]': {
    backgroundColor: "$surface_bright",
    c: "$on_surface_high"
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: "0 0 0 3px $colors$primary_default"
  }
});
var DropdownTriggerItem = styled(SubTrigger, {
  w: "100%",
  color: "$on_surface_high",
  p: "$8",
  display: "flex",
  alignItems: "center",
  "&:hover": {
    cursor: "pointer",
    bg: "$surface_brighter"
  },
  "&:focus-visible": {
    bg: "$surface_brighter",
    outline: "none"
  }
});
var DropdownItem = styled(Item, {
  color: "$on_surface_high",
  p: "$8",
  display: "flex",
  alignItems: "center",
  outline: "none",
  backgroundColor: "$surface_dim",
  "&:hover": {
    cursor: "pointer",
    bg: "$surface_bright"
  },
  "&:focus-visible": {
    bg: "$surface_bright"
  }
});
var DropdownItemSeparator = styled(Separator, {
  h: 1,
  backgroundColor: "$border_bright",
  m: "$4 $8"
});
var DropdownContent = styled(Content3, {
  w: "$80",
  maxHeight: "$64",
  r: "$1",
  py: "$4",
  backgroundColor: "$surface_dim",
  overflowY: "auto",
  boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  zIndex: 20,
  fontFamily: "$sans"
});
var DropdownLabel = styled(Label, {
  display: "flex",
  alignItems: "center",
  h: "$12",
  w: "100%",
  p: "$8 $4"
});
var DropdownGroup = styled(Group, {});
var DropdownSubMenu = styled(Sub, {});
var DropdownSubMenuContent = styled(SubContent, {
  w: "$80",
  maxHeight: "$64",
  r: "$1",
  py: "$4",
  backgroundColor: "$surface_bright",
  overflowY: "auto",
  boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  zIndex: 20
});
var DropdownCheckboxItem = styled(CheckboxItem, {
  color: "$on_surface_high",
  p: "$8",
  display: "flex",
  alignItems: "center",
  outline: "none",
  "&:hover": {
    cursor: "pointer",
    bg: "$surface_brighter"
  },
  "&:focus-visible": {
    bg: "$surface_brighter"
  },
  gap: "$2"
});
var DropdownItemIndicator = styled(ItemIndicator, {
  w: "$10",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
});
var Dropdown = {
  Root: DropdownRoot,
  Trigger: DropdownTrigger,
  TriggerItem: DropdownTriggerItem,
  Content: DropdownContent,
  Portal: Portal2,
  SubMenu: DropdownSubMenu,
  SubMenuContent: DropdownSubMenuContent,
  Item: DropdownItem,
  Label: DropdownLabel,
  Group: DropdownGroup,
  ItemSeparator: DropdownItemSeparator,
  CheckboxItem: DropdownCheckboxItem,
  ItemIndicator: DropdownItemIndicator
};

// src/Video/index.tsx
init_define_process_env();

// src/Video/Video.tsx
init_define_process_env();
import React13 from "react";
import { useVideo } from "@100mslive/react-sdk";
var StyledVideo = styled("video", {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$2",
  objectFit: "cover",
  background: "$background_default",
  variants: {
    mirror: {
      true: {
        transform: "scaleX(-1)"
      }
    },
    screenShare: {
      true: {
        objectFit: "contain"
      }
    },
    degraded: {
      // send the video behind when it's degraded so avatar can show on top of it. Video will be stuck frame in this case.
      // not hiding by using display none, because it will lead it to be detached as it will no longer be in view.
      true: {
        zIndex: -100
      }
    },
    noRadius: {
      true: {
        borderRadius: 0
      }
    }
  },
  defaultVariants: {
    mirror: false
  }
});
var Video = (_a8) => {
  var _b7 = _a8, { trackId, attach } = _b7, props = __objRest(_b7, ["trackId", "attach"]);
  const { videoRef } = useVideo({ trackId, attach });
  return /* @__PURE__ */ React13.createElement(StyledVideo, __spreadValues({ ref: videoRef }, props));
};

// src/TileMenu/index.tsx
init_define_process_env();

// src/TileMenu/StyledMenuTile.tsx
init_define_process_env();
import * as Popover from "@radix-ui/react-popover";
var Root12 = Popover.Root;
var StyledTrigger = styled(Popover.Trigger, __spreadProps(__spreadValues({
  position: "absolute",
  bottom: "$2",
  right: "$2",
  zIndex: 10,
  width: "$13",
  height: "$13",
  color: "$on_surface_high",
  borderRadius: "$2",
  backgroundColor: "$surface_bright",
  cursor: "pointer",
  border: "none"
}, flexCenter), {
  "&:not([disabled]):focus": {
    outline: "none",
    boxShadow: "0 0 0 3px $colors$primary_bright"
  }
}));
var StyledContent = styled(Popover.Content, __spreadValues({
  fontFamily: "$sans",
  backgroundColor: "$surface_dim",
  padding: "$5 0",
  display: "flex",
  flexDirection: "column",
  borderRadius: "$space$6",
  zIndex: 11,
  width: "$60"
}, popoverAnimation));
var styledItem = {
  fontSize: "$sm",
  color: "$on_surface_high",
  display: "flex",
  alignItems: "center",
  padding: "$4 $6",
  width: "100%",
  backgroundColor: "$menuBg"
};
var StyledItemButton = styled("button", __spreadProps(__spreadValues({}, styledItem), {
  height: "$14",
  border: "none",
  "&:hover": {
    backgroundColor: "$surface_brighter"
  },
  cursor: "pointer",
  // TODO: default focus applied cause issues with this style
  "&:focus": {
    outline: "none"
    // backgroundColor: '$grey3',
  },
  "& > * + *": {
    marginRight: "0",
    marginLeft: "$4"
  }
}));
var StyledVolumeItem = styled("div", __spreadProps(__spreadValues({}, styledItem), {
  alignItems: "start",
  flexDirection: "column",
  marginBottom: "0"
}));
var Flex2 = styled("div", {
  display: "flex",
  "& > * + *": {
    marginRight: "0",
    marginLeft: "$4"
  }
});
var RemoveMenuItem = styled(StyledItemButton, {
  color: "$alert_error_default",
  borderTop: "1px solid $border_bright"
});
var StyledMenuTile = {
  Root: Root12,
  Trigger: StyledTrigger,
  Content: StyledContent,
  ItemButton: StyledItemButton,
  VolumeItem: StyledVolumeItem,
  RemoveItem: RemoveMenuItem
};

// src/AudioLevel/index.ts
init_define_process_env();

// src/AudioLevel/useBorderAudioLevel.tsx
init_define_process_env();
import { useCallback as useCallback2, useRef as useRef3 } from "react";
import { useAudioLevelStyles } from "@100mslive/react-sdk";
function useBorderAudioLevel(audioTrackId) {
  const { theme: theme2 } = useTheme();
  const color = theme2.colors.primary_default.value;
  const getStyle = useCallback2(
    (level) => {
      const style = {
        transition: "outline 0.4s ease-in-out"
      };
      style["outline"] = level ? `${sigmoid(level) * 4}px solid ${color}` : "0px solid transparent";
      return style;
    },
    [color]
  );
  const ref = useRef3(null);
  useAudioLevelStyles({
    trackId: audioTrackId,
    getStyle,
    ref
  });
  return ref;
}
var sigmoid = (z2) => {
  return 1 / (1 + Math.exp(-z2));
};

// src/AudioLevel/AudioLevel.tsx
init_define_process_env();
import React14, { useEffect as useEffect4, useRef as useRef4 } from "react";
import { selectTrackAudioByID, useHMSVanillaStore } from "@100mslive/react-sdk";
import bg from "./audio-level.png";
var positionValues = new Array(101).fill(0).reduce((acc, _, index) => {
  acc[index] = Math.round(index / 100 * 4) / 4;
  return acc;
}, {});
var barAnimation = keyframes({
  from: {
    maskSize: "4em .8em",
    "-webkit-mask-position-y": ".1em",
    maskPosition: "initial .1em"
  },
  "50%": {
    maskSize: "4em 1em",
    "-webkit-mask-position-y": 0,
    maskPosition: "initial 0"
  },
  to: {
    maskSize: "4em .8em",
    "-webkit-mask-position-y": ".1em",
    maskPosition: "initial 0.1em"
  }
});
var AudioBar = () => {
  return /* @__PURE__ */ React14.createElement(
    Box,
    {
      css: {
        width: ".25em",
        height: "1em",
        maskImage: `url(${bg})`,
        "-webkit-mask-repeat": "no-repeat",
        backgroundColor: "$on_primary_high",
        maskSize: "4em 1em"
      }
    }
  );
};
var AudioLevel = ({ trackId, size }) => {
  const ref = useRef4(null);
  const vanillaStore = useHMSVanillaStore();
  useEffect4(() => {
    const unsubscribe = vanillaStore.subscribe((audioLevel) => {
      if (ref.current) {
        let index = 0;
        for (const child of ref.current.children) {
          const positionX = `-${positionValues[audioLevel] * (index === 1 ? 2.5 : 1.25)}em`;
          child.style["-webkit-mask-position-x"] = positionX;
          child.style["mask-position"] = `${positionX} 0`;
          child.style["animation"] = positionValues[audioLevel] > 0 ? `${barAnimation} 0.6s steps(3,jump-none) 0s infinite` : "none";
          index++;
        }
      }
    }, selectTrackAudioByID(trackId));
    return unsubscribe;
  }, [vanillaStore, trackId]);
  return /* @__PURE__ */ React14.createElement(
    Flex,
    {
      ref,
      css: {
        fontSize: size === "small" ? "0.75rem" : "1rem",
        gap: size === "small" ? "$1" : "$2"
      }
    },
    /* @__PURE__ */ React14.createElement(AudioBar, null),
    /* @__PURE__ */ React14.createElement(AudioBar, null),
    /* @__PURE__ */ React14.createElement(AudioBar, null)
  );
};

// src/Popover/index.tsx
init_define_process_env();
import { Arrow as Arrow2, Close as Close2, Content as Content5, Popover as Root13, Portal as Portal3, Trigger as Trigger5 } from "@radix-ui/react-popover";
var StyledContent2 = styled(Content5, __spreadValues({
  padding: "$6",
  borderRadius: "$2",
  backgroundColor: "$background_default",
  boxShadow: "$sm",
  zIndex: 12
}, popoverAnimation));
var StyledArrow = styled(Arrow2, __spreadValues({}, popoverAnimation));
var StyledTrigger2 = styled(Trigger5, {
  "&:hover": {
    cursor: "pointer"
  },
  "&:focus-visible": {
    boxShadow: "0 0 0 3px $colors$primary_default"
  }
});
var Popover2 = {
  Root: Root13,
  Content: StyledContent2,
  Trigger: StyledTrigger2,
  Portal: Portal3,
  Arrow: StyledArrow,
  Close: Close2
};

// src/Stats/index.tsx
init_define_process_env();

// src/Stats/Stats.tsx
init_define_process_env();
import React15, { Fragment } from "react";
import {
  selectConnectionQualityByPeerID,
  selectHMSStats as selectHMSStats2,
  simulcastMapping,
  useHMSStatsStore as useHMSStatsStore2,
  useHMSStore
} from "@100mslive/react-sdk";

// src/Stats/formatBytes.ts
init_define_process_env();
var formatBytes = (bytes, unit = "B", decimals = 2) => {
  if (bytes === 0) {
    return `0 ${unit}`;
  }
  if (!bytes) {
    return "-";
  }
  const k2 = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["", "K", "M", "G", "T", "P", "E", "Z", "Y"].map((size) => size + unit);
  let i = Math.floor(Math.log(bytes) / Math.log(k2));
  i === 0 && i++;
  return `${parseFloat((bytes / Math.pow(k2, i)).toFixed(dm))} ${sizes[i]}`;
};

// src/Stats/StyledStats.tsx
init_define_process_env();
var Root14 = styled("div", {
  backgroundColor: "rgba(0,0,0,0.75)",
  position: "absolute",
  top: "$3",
  left: "$3",
  zIndex: 7,
  borderRadius: "$2",
  padding: "$2",
  fontSize: "$xs",
  overflowY: "auto",
  maxHeight: "75%",
  maxWidth: "85%"
});
var Table = styled("table", {});
var Row = styled("tr", {
  width: "100%",
  "& > * + *": {
    px: "$4"
  },
  whiteSpace: "nowrap",
  textAlign: "left"
});
var Label2 = styled("td", {
  color: "$on_primary_high",
  fontWeight: "$regular"
});
var Value = styled("td", {
  color: "$on_primary_high"
});
var Gap = styled("tr", {
  height: "$4"
});
var Stats = {
  Root: Root14,
  Row,
  Label: Label2,
  Value,
  Table,
  Gap
};

// src/Stats/useQoE.ts
init_define_process_env();
import { useRef as useRef5 } from "react";
import { usePrevious } from "react-use";
import { selectHMSStats, useHMSStatsStore } from "@100mslive/react-sdk";
var EXPECTED_RESOLUTION = 1280 * 720;
var clip = (value, min_value, max_value) => {
  return Math.max(Math.min(value, max_value), min_value);
};
var useQoE = ({ videoTrackID, audioTrackID, isLocal = false }) => {
  const audioTrackStats = useHMSStatsStore(selectHMSStats.trackStatsByID(audioTrackID));
  const videoTrackStats = useHMSStatsStore(selectHMSStats.trackStatsByID(videoTrackID));
  const prevVideoTrackStats = usePrevious(videoTrackStats);
  const prevAudioTrackStats = usePrevious(audioTrackStats);
  const prevJitterBufferDelayMs = useRef5(0);
  if (isLocal || videoTrackID && !videoTrackStats || audioTrackID && !audioTrackStats) {
    return;
  }
  const resolutionNorm = ((videoTrackStats == null ? void 0 : videoTrackStats.frameWidth) || 0) * ((videoTrackStats == null ? void 0 : videoTrackStats.frameHeight) || 0) / EXPECTED_RESOLUTION;
  const framesDecodedInLastSec = (videoTrackStats == null ? void 0 : videoTrackStats.framesDecoded) && (prevVideoTrackStats == null ? void 0 : prevVideoTrackStats.framesDecoded) ? videoTrackStats.framesDecoded - prevVideoTrackStats.framesDecoded : 0;
  let freezeDurationNorm = 1 - (((videoTrackStats == null ? void 0 : videoTrackStats.totalFreezesDuration) || 0) - ((prevVideoTrackStats == null ? void 0 : prevVideoTrackStats.totalFreezesDuration) || 0));
  freezeDurationNorm = freezeDurationNorm < 0 ? 0.5 : freezeDurationNorm;
  freezeDurationNorm = framesDecodedInLastSec === 0 ? 0 : freezeDurationNorm;
  const fpsNorm = framesDecodedInLastSec / 30;
  const prevJBDelay = (prevVideoTrackStats == null ? void 0 : prevVideoTrackStats.jitterBufferDelay) || 0;
  const prevJBEmittedCount = (prevVideoTrackStats == null ? void 0 : prevVideoTrackStats.jitterBufferEmittedCount) || 0;
  const currentJBDelay = ((videoTrackStats == null ? void 0 : videoTrackStats.jitterBufferDelay) || 0) - prevJBDelay;
  const currentJBEmittedCount = ((videoTrackStats == null ? void 0 : videoTrackStats.jitterBufferEmittedCount) || 0) - prevJBEmittedCount;
  const jitterBufferDelayMs = currentJBEmittedCount > 0 ? currentJBDelay * 1e3 / currentJBEmittedCount : prevJitterBufferDelayMs.current;
  prevJitterBufferDelayMs.current = jitterBufferDelayMs;
  const delayNorm = 1 - Math.min(1, jitterBufferDelayMs / 2e3);
  const prevConcealedSamples = ((prevAudioTrackStats == null ? void 0 : prevAudioTrackStats.concealedSamples) || 0) - ((prevAudioTrackStats == null ? void 0 : prevAudioTrackStats.silentConcealedSamples) || 0);
  const currentConcealedSamples = ((audioTrackStats == null ? void 0 : audioTrackStats.concealedSamples) || 0) - ((audioTrackStats == null ? void 0 : audioTrackStats.silentConcealedSamples) || 0) - prevConcealedSamples;
  const audioConcealedNorm = 1 - currentConcealedSamples / 48e3;
  return (5 * __pow(clip(freezeDurationNorm, 0, 1), 3) * __pow(clip(resolutionNorm, 0, 1), 0.3) * __pow(clip(fpsNorm, 0, 1), 0.2) * __pow(clip(delayNorm, 0, 1), 0.5) * __pow(clip(audioConcealedNorm, 0, 1), 2)).toFixed(2);
};

// src/Stats/Stats.tsx
function VideoTileStats({ videoTrackID, audioTrackID, peerID, isLocal = false }) {
  var _a8, _b7, _c;
  const audioSelector = isLocal ? selectHMSStats2.localAudioTrackStatsByID : selectHMSStats2.trackStatsByID;
  const audioTrackStats = useHMSStatsStore2(audioSelector(audioTrackID));
  const localVideoTrackStats = useHMSStatsStore2(selectHMSStats2.localVideoTrackStatsByID(videoTrackID));
  const remoteVideoTrackStats = useHMSStatsStore2(selectHMSStats2.trackStatsByID(videoTrackID));
  const videoTrackStats = isLocal ? localVideoTrackStats == null ? void 0 : localVideoTrackStats[0] : remoteVideoTrackStats;
  const downlinkScore = (_a8 = useHMSStore(selectConnectionQualityByPeerID(peerID))) == null ? void 0 : _a8.downlinkQuality;
  const availableOutgoingBitrate = useHMSStatsStore2(selectHMSStats2.availablePublishBitrate);
  const qoe = useQoE({ videoTrackID, audioTrackID, isLocal });
  if (!(audioTrackStats || videoTrackStats)) {
    return null;
  }
  return /* @__PURE__ */ React15.createElement(Stats.Root, null, /* @__PURE__ */ React15.createElement("table", null, /* @__PURE__ */ React15.createElement("tbody", null, isLocal ? /* @__PURE__ */ React15.createElement(Fragment, null, /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullishAndNot0(availableOutgoingBitrate),
      label: "AOBR",
      tooltip: "Available Outgoing Bitrate",
      value: formatBytes(availableOutgoingBitrate, "b/s")
    }
  ), localVideoTrackStats == null ? void 0 : localVideoTrackStats.map((stat) => {
    var _a9, _b8;
    if (!stat) {
      return null;
    }
    const layer = stat.rid ? simulcastMapping[stat.rid] : "";
    return /* @__PURE__ */ React15.createElement(Fragment, { key: `${stat.id}${stat.rid}` }, layer && /* @__PURE__ */ React15.createElement(StatsRow, { label: layer.toUpperCase(), value: "" }), /* @__PURE__ */ React15.createElement(
      StatsRow,
      {
        show: isNotNullishAndNot0(stat.frameWidth),
        label: "Width",
        value: (_a9 = stat.frameWidth) == null ? void 0 : _a9.toString()
      }
    ), /* @__PURE__ */ React15.createElement(
      StatsRow,
      {
        show: isNotNullishAndNot0(stat.frameHeight),
        label: "Height",
        value: (_b8 = stat.frameHeight) == null ? void 0 : _b8.toString()
      }
    ), /* @__PURE__ */ React15.createElement(
      StatsRow,
      {
        show: isNotNullishAndNot0(stat.framesPerSecond),
        label: "FPS",
        value: `${stat.framesPerSecond} ${isNotNullishAndNot0(stat.framesDropped) ? `(${stat.framesDropped} dropped)` : ""}`
      }
    ), /* @__PURE__ */ React15.createElement(
      StatsRow,
      {
        show: isNotNullish(stat.bitrate),
        label: "Bitrate(V)",
        value: formatBytes(stat.bitrate, "b/s")
      }
    ), /* @__PURE__ */ React15.createElement(Stats.Gap, null));
  })) : /* @__PURE__ */ React15.createElement(Fragment, null, /* @__PURE__ */ React15.createElement(StatsRow, { show: isNotNullish(qoe), label: "QoE", value: qoe }), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullishAndNot0(videoTrackStats == null ? void 0 : videoTrackStats.frameWidth),
      label: "Width",
      value: (_b7 = videoTrackStats == null ? void 0 : videoTrackStats.frameWidth) == null ? void 0 : _b7.toString()
    }
  ), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullishAndNot0(videoTrackStats == null ? void 0 : videoTrackStats.frameHeight),
      label: "Height",
      value: (_c = videoTrackStats == null ? void 0 : videoTrackStats.frameHeight) == null ? void 0 : _c.toString()
    }
  ), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullishAndNot0(videoTrackStats == null ? void 0 : videoTrackStats.framesPerSecond),
      label: "FPS",
      value: `${videoTrackStats == null ? void 0 : videoTrackStats.framesPerSecond} ${isNotNullishAndNot0(videoTrackStats == null ? void 0 : videoTrackStats.framesDropped) ? `(${videoTrackStats == null ? void 0 : videoTrackStats.framesDropped} dropped)` : ""}`
    }
  ), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullish(videoTrackStats == null ? void 0 : videoTrackStats.totalPausesDuration),
      label: "Pauses Duration",
      value: videoTrackStats == null ? void 0 : videoTrackStats.totalPausesDuration
    }
  ), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullish(videoTrackStats == null ? void 0 : videoTrackStats.totalFreezesDuration),
      label: "Freezes Duration",
      value: videoTrackStats == null ? void 0 : videoTrackStats.totalFreezesDuration
    }
  ), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullish(videoTrackStats == null ? void 0 : videoTrackStats.bitrate),
      label: "Bitrate(V)",
      value: formatBytes(videoTrackStats == null ? void 0 : videoTrackStats.bitrate, "b/s")
    }
  )), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullish(audioTrackStats == null ? void 0 : audioTrackStats.bitrate),
      label: "Bitrate(A)",
      value: formatBytes(audioTrackStats == null ? void 0 : audioTrackStats.bitrate, "b/s")
    }
  ), /* @__PURE__ */ React15.createElement(StatsRow, { show: isNotNullish(downlinkScore), label: "CQS", value: downlinkScore }), /* @__PURE__ */ React15.createElement(StatsRow, { show: isNotNullish(videoTrackStats == null ? void 0 : videoTrackStats.codec), label: "Codec(V)", value: videoTrackStats == null ? void 0 : videoTrackStats.codec }), /* @__PURE__ */ React15.createElement(StatsRow, { show: isNotNullish(audioTrackStats == null ? void 0 : audioTrackStats.codec), label: "Codec(A)", value: audioTrackStats == null ? void 0 : audioTrackStats.codec }), /* @__PURE__ */ React15.createElement(PacketLostAndJitter, { audioTrackStats, videoTrackStats }))));
}
var PacketLostAndJitter = ({
  audioTrackStats,
  videoTrackStats
}) => {
  var _a8, _b7;
  const isLocalPeer = (audioTrackStats == null ? void 0 : audioTrackStats.type.includes("outbound")) || (videoTrackStats == null ? void 0 : videoTrackStats.type.includes("outbound"));
  const audioStats = isLocalPeer ? audioTrackStats == null ? void 0 : audioTrackStats.remote : audioTrackStats;
  const videoStats = isLocalPeer ? videoTrackStats == null ? void 0 : videoTrackStats.remote : videoTrackStats;
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(TrackPacketsLostRow, { label: "Packet Loss(V)", stats: videoStats }), /* @__PURE__ */ React15.createElement(TrackPacketsLostRow, { label: "Packet Loss(A)", stats: audioStats }), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullish(videoStats == null ? void 0 : videoStats.jitter),
      label: "Jitter(V)",
      value: `${(((_a8 = videoStats == null ? void 0 : videoStats.jitter) != null ? _a8 : 0) * 1e3).toFixed(2)} ms`
    }
  ), /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullish(audioStats == null ? void 0 : audioStats.jitter),
      label: "Jitter(A)",
      value: `${(((_b7 = audioStats == null ? void 0 : audioStats.jitter) != null ? _b7 : 0) * 1e3).toFixed(2)} ms`
    }
  ));
};
var TrackPacketsLostRow = ({
  stats,
  label
}) => {
  const packetsLostRate = `${(stats == null ? void 0 : stats.packetsLostRate) ? stats.packetsLostRate.toFixed(2) : 0}/s`;
  return /* @__PURE__ */ React15.createElement(
    StatsRow,
    {
      show: isNotNullishAndNot0(stats == null ? void 0 : stats.packetsLost),
      label,
      value: `${stats == null ? void 0 : stats.packetsLost}(${packetsLostRate})`
    }
  );
};
var RawStatsRow = ({
  label = "",
  value = "",
  tooltip = "",
  show = true
}) => {
  const statsLabel = /* @__PURE__ */ React15.createElement(Stats.Label, null, label);
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, show ? /* @__PURE__ */ React15.createElement(Stats.Row, null, tooltip ? /* @__PURE__ */ React15.createElement(Tooltip, { side: "top", title: tooltip }, statsLabel) : statsLabel, value === "" ? /* @__PURE__ */ React15.createElement(Stats.Value, null) : /* @__PURE__ */ React15.createElement(Stats.Value, null, value)) : null);
};
var StatsRow = React15.memo(RawStatsRow);
function isNotNullishAndNot0(value) {
  return isNotNullish(value) && value !== 0;
}
function isNotNullish(value) {
  return value !== void 0 && value !== null;
}

// src/Checkbox/Checkbox.tsx
init_define_process_env();
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
var CheckboxRoot = styled(CheckboxPrimitive.Root, {
  all: "unset",
  border: "1px solid $primary_default",
  backgroundColor: "$on_primary_high",
  width: "$8",
  height: "$8",
  borderRadius: "$0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "none",
  outline: "none",
  cursor: "pointer",
  "&:focus": {
    boxShadow: "none",
    outline: "none"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$primary_default"
  }
});
var CheckboxIndicator = styled(CheckboxPrimitive.Indicator, {
  color: "$on_primary_high",
  // center check svg within button box
  lineHeight: 0
});
var Checkbox = {
  Root: CheckboxRoot,
  Indicator: CheckboxIndicator
};

// src/Label/Label.tsx
init_define_process_env();
import * as LabelPrimitive from "@radix-ui/react-label";
var Label3 = styled(LabelPrimitive.Root, {
  fontFamily: "$sans",
  fontSize: "$md",
  color: "$on_primary_high"
});

// src/RadioGroup/RadioGroup.tsx
init_define_process_env();
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
var RadioGroupRoot = styled(RadioGroupPrimitive.Root, {
  display: "flex",
  alignItems: "center"
});
var RadioGroupItem = styled(RadioGroupPrimitive.Item, {
  bg: "$on_primary_high",
  width: "$8",
  height: "$8",
  border: "1px solid $primary_default",
  cursor: "pointer",
  borderRadius: "$round",
  "&:focus": {
    boxShadow: "none",
    outline: "none"
  },
  '&[data-state="checked"]': {
    borderWidth: "$space$2",
    p: "$1"
  }
});
var RadioGroupIndicator = styled(RadioGroupPrimitive.Indicator, {
  bg: "$primary_default"
});
var RadioGroup = {
  Root: RadioGroupRoot,
  Item: RadioGroupItem,
  Indicator: RadioGroupIndicator
};

// src/Toast/Toast.tsx
init_define_process_env();
import React16 from "react";
import * as ToastPrimitives from "@radix-ui/react-toast";
import { CrossIcon as CrossIcon2 } from "@100mslive/react-icons";
var getToastVariant = (base) => {
  return {
    borderLeftColor: base,
    borderLeft: 0,
    "&:before": {
      position: "absolute",
      top: "-1px",
      left: "-$4",
      width: "$8",
      borderLeft: `solid $space$px ${base}`,
      borderTop: `solid $space$px ${base}`,
      borderBottom: `solid $space$px ${base}`,
      borderTopLeftRadius: "$3",
      borderBottomLeftRadius: "$3",
      bg: base,
      content: " ",
      height: "100%",
      zIndex: 10
    },
    "@sm": {
      "&:before": {
        content: "none"
      },
      border: `solid $space$px ${base}`
    }
  };
};
var ToastRoot = styled(ToastPrimitives.Root, __spreadProps(__spreadValues({
  r: "$3",
  bg: "$surface_default",
  p: "$10",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  fontFamily: "$sans",
  border: "solid $space$px $border_bright",
  overflow: "hidden"
}, toastAnimation), {
  "@sm": {
    p: "$8 $11"
  },
  variants: {
    variant: {
      standard: getToastVariant("$secondary_default"),
      warning: getToastVariant("$alert_warning"),
      error: getToastVariant("$alert_error_default"),
      success: getToastVariant("$alert_success")
    }
  },
  defaultVariants: {
    variant: "standard"
  }
}));
var ToastTitle = styled(ToastPrimitives.Title, {
  fontSize: "$md",
  color: "$on_surface_high",
  fontWeight: "$semiBold",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});
var ToastDescription = styled(ToastPrimitives.Description, {
  color: "$on_surface_medium"
});
var ToastClose = styled(ToastPrimitives.Close, {});
var ToastAction = styled(ToastPrimitives.Action, {
  cursor: "pointer",
  background: "none",
  border: "none"
});
var ToastViewport = styled(ToastPrimitives.Viewport, {
  position: "fixed",
  bottom: 0,
  left: 0,
  display: "flex",
  flexDirection: "column",
  padding: "$8",
  gap: 10,
  width: 390,
  "@sm": {
    width: "100%",
    padding: "$6"
  },
  maxWidth: "100vw",
  margin: 0,
  listStyle: "none",
  zIndex: 1e3
});
var DefaultClose = ({ css: css2 }) => {
  return /* @__PURE__ */ React16.createElement(ToastClose, { css: css2, asChild: true }, /* @__PURE__ */ React16.createElement(IconButton, null, /* @__PURE__ */ React16.createElement(CrossIcon2, null)));
};
var HMSToast = (_a8) => {
  var _b7 = _a8, {
    title,
    description,
    isClosable = true,
    icon,
    action,
    inlineAction = false
  } = _b7, props = __objRest(_b7, [
    "title",
    "description",
    "isClosable",
    "icon",
    "action",
    "inlineAction"
  ]);
  return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(ToastRoot, __spreadValues({}, props), /* @__PURE__ */ React16.createElement(ToastTitle, null, /* @__PURE__ */ React16.createElement(Flex, { align: "center", css: { gap: "$4", flex: "1 1 0", minWidth: 0 } }, icon ? /* @__PURE__ */ React16.createElement(Box, { css: { w: "$10", h: "$10", alignSelf: "start", mt: "$2" } }, icon) : null, /* @__PURE__ */ React16.createElement(Text, { variant: "sub1", css: { c: "inherit", wordBreak: "break-word" } }, title)), isClosable ? /* @__PURE__ */ React16.createElement(DefaultClose, null) : null, !isClosable && inlineAction && action ? /* @__PURE__ */ React16.createElement(ToastAction, { altText: `${title}Action` }, action) : null), description ? /* @__PURE__ */ React16.createElement(ToastDescription, null, /* @__PURE__ */ React16.createElement(Text, { variant: "body1", css: { fontWeight: "$regular", c: "$on_surface_medium" } }, description)) : null, !inlineAction && action ? /* @__PURE__ */ React16.createElement(ToastAction, { altText: `${title}Action`, css: { mt: "$10" } }, action) : null));
};
var Toast = {
  Provider: ToastPrimitives.Provider,
  Root: ToastRoot,
  Title: ToastTitle,
  Description: ToastDescription,
  Close: DefaultClose,
  Action: ToastAction,
  Viewport: ToastViewport,
  HMSToast
};

// src/Accordion/index.ts
init_define_process_env();

// src/Accordion/Accordion.tsx
init_define_process_env();
import React17 from "react";
import * as BaseAccordion from "@radix-ui/react-accordion";
import { ChevronUpIcon } from "@100mslive/react-icons";
var StyledAccordion = styled(BaseAccordion.Root, {});
var StyledItem = styled(BaseAccordion.Item, {
  marginTop: "$px",
  display: "block",
  "&:first-child": {
    marginTop: 0,
    borderTopLeftRadius: "$0",
    borderTopRightRadius: "$0"
  },
  "&:last-child": {
    borderBottomLeftRadius: "$4",
    borderBottomRightRadius: "$4"
  }
});
var StyledHeader = styled(BaseAccordion.Header, {
  all: "unset",
  display: "flex",
  fontFamily: "$sans"
});
var StyledTrigger3 = styled(BaseAccordion.Trigger, {
  all: "unset",
  fontFamily: "$sans",
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: "$md",
  lineHeight: "$md",
  color: "$on_surface_high"
});
var StyledContent3 = styled(BaseAccordion.Content, {
  display: "contents",
  fontSize: "$md",
  fontFamily: "$sans",
  color: "$on_surface_medium",
  '&[data-state="open"]': {
    animation: `${slideDown("--radix-accordion-content-height")} 300ms cubic-bezier(0.87, 0, 0.13, 1) forwards`
  },
  '&[data-state="closed"]': {
    animation: `${slideUp("--radix-accordion-content-height")} 300ms cubic-bezier(0.87, 0, 0.13, 1) forwards`
  }
});
var StyledChevron = styled(ChevronUpIcon, {
  color: "$on_primary_high",
  transition: "transform 300ms cubic-bezier(0.87, 0, 0.13, 1)",
  "[data-state=closed] &": { transform: "rotate(180deg)" }
});
var AccordionRoot = StyledAccordion;
var AccordionItem = StyledItem;
var AccordionHeader = React17.forwardRef((_a8, forwardedRef) => {
  var _b7 = _a8, { children, iconStyles, css: css2, chevronID } = _b7, props = __objRest(_b7, ["children", "iconStyles", "css", "chevronID"]);
  return /* @__PURE__ */ React17.createElement(StyledHeader, { css: css2 }, /* @__PURE__ */ React17.createElement(StyledTrigger3, __spreadProps(__spreadValues({}, props), { ref: forwardedRef }), children, /* @__PURE__ */ React17.createElement(StyledChevron, { "data-testid": chevronID, "aria-hidden": true, css: iconStyles })));
});
var AccordionContent = React17.forwardRef(
  (_a8, forwardedRef) => {
    var _b7 = _a8, { children, contentStyles } = _b7, props = __objRest(_b7, ["children", "contentStyles"]);
    return /* @__PURE__ */ React17.createElement(StyledContent3, __spreadProps(__spreadValues({}, props), { ref: forwardedRef }), /* @__PURE__ */ React17.createElement(Box, { css: contentStyles }, children));
  }
);

// src/Accordion/index.ts
var Accordion = {
  Root: AccordionRoot,
  Item: AccordionItem,
  Content: AccordionContent,
  Header: AccordionHeader
};

// src/Fieldset/Fieldset.tsx
init_define_process_env();
var StyledFieldset = styled("fieldset", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "none",
  backgroundColor: "transparent"
});
var Fieldset = StyledFieldset;

// src/Footer/index.tsx
init_define_process_env();

// src/Footer/Footer.tsx
init_define_process_env();
var Root20 = styled(Flex, {
  justifyContent: "space-between",
  alignItems: "center",
  py: "$4",
  position: "relative",
  height: "100%",
  "@md": { flexWrap: "wrap", gap: "$4" }
});
var Left = styled(Flex, {
  alignItems: "center",
  position: "absolute",
  left: "$10",
  gap: "$8",
  "@md": {
    position: "unset",
    justifyContent: "center",
    w: "100%"
  }
});
var Center = styled(Flex, {
  w: "100%",
  justifyContent: "center",
  alignItems: "center",
  gap: "$8"
});
var Right = styled(Flex, {
  alignItems: "center",
  position: "absolute",
  right: "$10",
  gap: "$8",
  "@md": {
    display: "none"
  }
});
var Footer = {
  Root: Root20,
  Left,
  Center,
  Right
};

// src/ReactSelect/index.ts
var ReactSelect_exports = {};
__export(ReactSelect_exports, {
  Select: () => Select2
});
init_define_process_env();

// src/ReactSelect/ReactSelect.tsx
init_define_process_env();
import * as SelectPrimitive from "@radix-ui/react-select";
var StyledRoot = styled(SelectPrimitive.Root, {});
var StyledTrigger4 = styled(SelectPrimitive.SelectTrigger, {
  all: "unset",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "$2",
  padding: "$8",
  lineHeight: "$px",
  gap: "$8",
  backgroundColor: "$secondary_default",
  color: "$on_primary_high",
  fontSize: "$8",
  cursor: "pointer",
  r: "$1"
});
var StyledContent4 = styled(SelectPrimitive.Content, {
  overflow: "hidden",
  backgroundColor: "$surface_bright",
  r: "$1",
  h: "$80"
});
var StyledViewport = styled(SelectPrimitive.Viewport, {
  padding: "$3"
});
var StyledItem2 = styled(SelectPrimitive.Item, {
  all: "unset",
  fontSize: "$7",
  r: "$1",
  display: "flex",
  p: "$4 $8",
  w: "$52",
  position: "relative",
  userSelect: "none",
  cursor: "pointer"
});
var StyledLabel = styled(SelectPrimitive.Label, {
  p: "$4 $8",
  lineHeight: "$10",
  color: "$on_primary_high"
});
var StyledSeparator = styled(SelectPrimitive.Separator, {
  height: "$px",
  backgroundColor: "$on_primary_high",
  margin: "$4",
  opacity: 0.4
});
var StyledItemIndicator = styled(SelectPrimitive.ItemIndicator, {
  position: "absolute",
  right: "$8",
  width: "$8",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: "$on_primary_high"
});
var scrollButtonStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: "$4",
  backgroundColor: "$surface_bright",
  color: "$on_primary_high",
  cursor: "default"
};
var StyledScrollUpButton = styled(SelectPrimitive.ScrollUpButton, scrollButtonStyles);
var StyledScrollDownButton = styled(SelectPrimitive.ScrollDownButton, scrollButtonStyles);
var Select2 = {
  Root: StyledRoot,
  Trigger: StyledTrigger4,
  Content: StyledContent4,
  Viewport: StyledViewport,
  Item: StyledItem2,
  Label: StyledLabel,
  Separator: StyledSeparator,
  ItemIndicator: StyledItemIndicator,
  ScrollUpButton: StyledScrollUpButton,
  ScrollDownButton: StyledScrollDownButton,
  Value: SelectPrimitive.Value,
  Icon: SelectPrimitive.Icon,
  ItemText: SelectPrimitive.ItemText,
  Group: SelectPrimitive.Group
};

// src/Tabs/Tabs.tsx
init_define_process_env();
import * as TabsPrimitive from "@radix-ui/react-tabs";
var StyledTabsRoot = styled(TabsPrimitive.Root, {
  display: "flex"
});
var StyledList = styled(TabsPrimitive.List, {
  flexShrink: 0,
  display: "flex"
});
var StyledTrigger5 = styled(TabsPrimitive.Trigger, {
  all: "unset",
  fontFamily: "$sans",
  p: "$8",
  display: "flex",
  alignItems: "center",
  fontSize: "$sm",
  lineHeight: "$sm",
  color: "$on_surface_high",
  userSelect: "none",
  cursor: "pointer",
  '&[data-state="active"]': {
    bg: "$surface_brighter",
    r: "$1"
  }
});
var StyledContent5 = styled(TabsPrimitive.Content, {
  flex: "1 1 0",
  padding: "$10",
  outline: "none"
});
var Tabs = {
  Root: StyledTabsRoot,
  List: StyledList,
  Content: StyledContent5,
  Trigger: StyledTrigger5
};

// src/QRCode/QRCode.tsx
init_define_process_env();
import React18 from "react";
import { QRCodeSVG } from "qrcode.react";
var QRCode = (props) => {
  return /* @__PURE__ */ React18.createElement(QRCodeSVG, __spreadValues({ style: { width: "100%", height: "100%" } }, props));
};

// src/Link/index.tsx
init_define_process_env();

// src/Link/Link.tsx
init_define_process_env();
import React19 from "react";
import * as icons from "@100mslive/react-icons";
var LinkComponent = styled("a", {
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  gap: "$5",
  variants: {
    color: {
      highEmp: {
        color: "$on_surface_high",
        "&:hover": {
          color: "$on_surface_medium"
        }
      },
      primary: {
        color: "$primary_default",
        "&:hover": {
          color: "$primary_bright"
        }
      }
    }
  }
});
var Link = (_a8) => {
  var _b7 = _a8, { iconSide = "left", icon, color = "primary", children } = _b7, rest = __objRest(_b7, ["iconSide", "icon", "color", "children"]);
  const Icon4 = icon ? icons[icon] : React19.Fragment;
  const renderedIcon = icon ? /* @__PURE__ */ React19.createElement(Flex, { as: "span" }, /* @__PURE__ */ React19.createElement(Icon4, { height: 13.33, width: 13.33 }), " ") : null;
  return /* @__PURE__ */ React19.createElement(LinkComponent, __spreadProps(__spreadValues({}, rest), { color }), iconSide === "left" && renderedIcon, /* @__PURE__ */ React19.createElement(Text, { as: "span", variant: "body2", css: { color: "inherit" } }, children), iconSide === "right" && renderedIcon);
};

// src/Collapsible/Collapsible.tsx
init_define_process_env();
import { Content as Content9, Root as Root23, Trigger as Trigger8 } from "@radix-ui/react-collapsible";
var CollapsibleRoot = styled(Root23, {});
var CollapsibleTrigger = styled(Trigger8, {
  cursor: "pointer",
  appearance: "none !important",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: "0 0 0 3px $colors$primary_default"
  }
});
var CollapsibleContent = styled(Content9, {
  w: "$80",
  r: "$1",
  overflowY: "auto",
  '&[data-state="open"]': {
    animation: `${slideDown("--radix-collapsible-content-height")} 300ms cubic-bezier(0.87, 0, 0.13, 1) forwards`
  },
  '&[data-state="closed"]': {
    animation: `${slideUp("--radix-collapsible-content-height")} 300ms cubic-bezier(0.87, 0, 0.13, 1) forwards`
  }
});
var Collapsible = {
  Root: CollapsibleRoot,
  Trigger: CollapsibleTrigger,
  Content: CollapsibleContent
};

// src/Prebuilt/App.tsx
init_define_process_env();
import React204, { useEffect as useEffect88, useRef as useRef36 } from "react";
import { match as match17 } from "ts-pattern";
import {
  HMSReactiveStore,
  HMSRoomProvider,
  selectIsConnectedToRoom as selectIsConnectedToRoom13,
  useHMSActions as useHMSActions60,
  useHMSStore as useHMSStore99
} from "@100mslive/react-sdk";

// src/Prebuilt/components/AppData/AppData.tsx
init_define_process_env();
import React23, { useEffect as useEffect6, useMemo as useMemo4, useRef as useRef7 } from "react";
import { useMedia } from "react-use";
import {
  HMSRoomState,
  selectFullAppData,
  selectHLSState as selectHLSState2,
  selectRoomState,
  selectRTMPState,
  useAVToggle,
  useHMSActions as useHMSActions4,
  useHMSStore as useHMSStore6,
  useRecordingStreaming as useRecordingStreaming2
} from "@100mslive/react-sdk";

// src/Prebuilt/components/Settings/LayoutSettings.tsx
init_define_process_env();
import React21, { useCallback as useCallback4 } from "react";
import { selectIsLocalScreenShared, selectIsLocalVideoEnabled, useHMSActions as useHMSActions2, useHMSStore as useHMSStore3 } from "@100mslive/react-sdk";
import { GalleryIcon, PersonRectangleIcon, SidebarIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Settings/SwitchWithLabel.tsx
init_define_process_env();
import React20 from "react";
var SwitchWithLabel = ({
  label,
  icon,
  id,
  onChange,
  checked,
  hide = false
}) => {
  return /* @__PURE__ */ React20.createElement(
    Flex,
    {
      align: "center",
      css: {
        my: "$2",
        py: "$8",
        w: "100%",
        borderBottom: "1px solid $border_default",
        display: hide ? "none" : "flex"
      }
    },
    /* @__PURE__ */ React20.createElement(
      Label3,
      {
        htmlFor: id,
        css: {
          fontSize: "$md",
          fontWeight: "$semiBold",
          color: checked ? "$on_surface_high" : "$on_surface_low",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "$8",
          flex: "1 1 0"
        }
      },
      icon,
      label
    ),
    /* @__PURE__ */ React20.createElement(Switch, { id, checked, onCheckedChange: onChange })
  );
};
var SwitchWithLabel_default = SwitchWithLabel;

// src/Prebuilt/components/AppData/useUISettings.js
init_define_process_env();
import { useCallback as useCallback3, useMemo as useMemo2 } from "react";
import {
  selectAppData,
  selectAppDataByPath,
  selectAudioTrackByPeerID,
  selectPermissions,
  selectPolls,
  selectSessionStore,
  selectTrackByID,
  selectVideoTrackByPeerID,
  useHMSActions,
  useHMSStore as useHMSStore2,
  useHMSVanillaStore as useHMSVanillaStore2
} from "@100mslive/react-sdk";

// src/Prebuilt/components/hooks/useUserPreferences.jsx
init_define_process_env();
import { useState as useState4 } from "react";
import { useLocalStorage } from "react-use";
var UserPreferencesKeys = {
  PREVIEW: "preview",
  NOTIFICATIONS: "notifications",
  UI_SETTINGS: "uiSettings",
  RTMP_URLS: "rtmpUrls",
  USER_ID: "userId"
};
var defaultPreviewPreference = {
  name: "",
  isAudioMuted: false,
  isVideoMuted: false
};
var useUserPreferences = (key, defaultPreference) => {
  const [localStorageValue, setStorageValue] = useLocalStorage(key, defaultPreference);
  const [preference, setPreference] = useState4(localStorageValue || defaultPreference);
  const changePreference = (value) => {
    setPreference(value);
    setStorageValue(value);
  };
  return [preference, changePreference];
};

// src/Prebuilt/components/AppData/useUISettings.js
var useUISettings = (uiSettingKey) => {
  const uiSettings = useHMSStore2(selectAppDataByPath(APP_DATA.uiSettings, uiSettingKey));
  return uiSettings;
};
var useSetUiSettings = (uiSettingKey) => {
  const value = useUISettings(uiSettingKey);
  const setValue = useSetAppData({
    key1: APP_DATA.uiSettings,
    key2: uiSettingKey
  });
  return [value, setValue];
};
var useAuthToken = () => {
  return useHMSStore2(selectAppData(APP_DATA.authToken));
};
var useUrlToEmbed = () => {
  var _a8;
  return (_a8 = useHMSStore2(selectAppData(APP_DATA.embedConfig))) == null ? void 0 : _a8.url;
};
var usePDFConfig = () => {
  return useHMSStore2(selectAppData(APP_DATA.pdfConfig));
};
var useResetPDFConfig = () => {
  const [, setPDFConfig] = useSetAppDataByKey(APP_DATA.pdfConfig);
  return useCallback3(() => setPDFConfig(), [setPDFConfig]);
};
var useResetEmbedConfig = () => {
  const [, setEmbedConfig] = useSetAppDataByKey(APP_DATA.embedConfig);
  return () => setEmbedConfig();
};
var usePinnedTrack = () => {
  var _a8, _b7;
  const pinnedTrackId = useHMSStore2(selectAppData(APP_DATA.pinnedTrackId));
  const spotlightPeerId = useHMSStore2(selectSessionStore("spotlight" /* SPOTLIGHT */));
  const spotlightVideoTrackId = (_a8 = useHMSStore2(selectVideoTrackByPeerID(spotlightPeerId))) == null ? void 0 : _a8.id;
  const spotlightAudioTrackId = (_b7 = useHMSStore2(selectAudioTrackByPeerID(spotlightPeerId))) == null ? void 0 : _b7.id;
  return useHMSStore2(selectTrackByID(pinnedTrackId || spotlightVideoTrackId || spotlightAudioTrackId));
};
var useSubscribedNotifications = (notificationKey) => {
  const notificationPreference = useHMSStore2(selectAppDataByPath(APP_DATA.subscribedNotifications, notificationKey));
  return notificationPreference;
};
var useIsNotificationDisabled = () => {
  const notificationPreference = useHMSStore2(selectAppDataByPath(APP_DATA.disableNotifications));
  return notificationPreference;
};
var useSetSubscribedNotifications = (notificationKey) => {
  const value = useSubscribedNotifications(notificationKey);
  const setValue = useSetAppData({
    key1: APP_DATA.subscribedNotifications,
    key2: notificationKey
  });
  return [value, setValue];
};
var useIsCaptionEnabled = () => {
  const isCaptionEnabled = useHMSStore2(selectAppDataByPath(APP_DATA.caption));
  return isCaptionEnabled;
};
var useSetIsCaptionEnabled = () => {
  const [value, setValue] = useSetAppDataByKey(APP_DATA.caption);
  return [value, setValue];
};
var useSubscribeChatSelector = (chatSelectorKey) => {
  const chatSelectorPreference = useHMSStore2(selectAppDataByPath(APP_DATA.chatSelector, chatSelectorKey));
  return chatSelectorPreference;
};
var useSetSubscribedChatSelector = (chatSelectorKey) => {
  const value = useSubscribeChatSelector(chatSelectorKey);
  const setValue = useSetAppData({
    key1: APP_DATA.chatSelector,
    key2: chatSelectorKey
  });
  return [value, setValue];
};
var useSetAppDataByKey = (appDataKey) => {
  const value = useHMSStore2(selectAppData(appDataKey));
  const actions = useHMSActions();
  const setValue = useCallback3(
    (value2) => {
      actions.setAppData(appDataKey, value2);
    },
    [actions, appDataKey]
  );
  return [value, setValue];
};
var useSetAppData = ({ key1, key2 }) => {
  const actions = useHMSActions();
  const store = useHMSVanillaStore2();
  const [, setPreferences] = useUserPreferences(UserPreferencesKeys.UI_SETTINGS);
  const setValue = useCallback3(
    (value) => {
      if (!key1) {
        return;
      }
      actions.setAppData(
        key1,
        key2 ? {
          [key2]: value
        } : value,
        true
      );
      const appData = store.getState(selectAppData());
      setPreferences(__spreadProps(__spreadValues({}, appData.uiSettings), {
        [UI_SETTINGS.isAudioOnly]: void 0,
        subscribedNotifications: appData.subscribedNotifications
      }));
    },
    [actions, key1, key2, store, setPreferences]
  );
  return setValue;
};
var useShowPolls = () => {
  const permissions = useHMSStore2(selectPermissions);
  const polls = useHMSStore2(selectPolls);
  const showPolls = useMemo2(() => {
    return (permissions == null ? void 0 : permissions.pollWrite) || (permissions == null ? void 0 : permissions.pollRead) && (polls == null ? void 0 : polls.length) > 0;
  }, [permissions == null ? void 0 : permissions.pollRead, permissions == null ? void 0 : permissions.pollWrite, polls == null ? void 0 : polls.length]);
  return { showPolls };
};
var usePollViewState = () => {
  const [pollState, setPollState] = useSetAppDataByKey(APP_DATA.pollState);
  const setPollView = useCallback3(
    (view) => {
      setPollState({
        [POLL_STATE.pollInView]: pollState == null ? void 0 : pollState.pollInView,
        [POLL_STATE.view]: view
      });
    },
    [pollState == null ? void 0 : pollState.pollInView, setPollState]
  );
  return {
    setPollState,
    setPollView,
    pollInView: pollState == null ? void 0 : pollState.pollInView,
    view: pollState == null ? void 0 : pollState.view
  };
};
var useIsNoiseCancellationEnabled = () => {
  const isNoiseCancellationEnabled = useHMSStore2(selectAppDataByPath(APP_DATA.noiseCancellation));
  return isNoiseCancellationEnabled;
};
var useSetNoiseCancellation = () => {
  const [isNoiseCancellationEnabled, setNoiseCancellationEnabled] = useSetAppDataByKey(APP_DATA.noiseCancellation);
  return [isNoiseCancellationEnabled, setNoiseCancellationEnabled];
};

// src/Prebuilt/components/Settings/common.ts
init_define_process_env();
var settingOverflow = css({
  flex: "1 1 0",
  pr: "$12",
  mr: "-$12",
  overflowY: "auto"
});
var settingContent = css({
  display: "flex",
  flexDirection: "column",
  "&[hidden]": {
    display: "none"
  }
});

// src/Prebuilt/components/Settings/LayoutSettings.tsx
var LayoutMode = {
  SIDEBAR: "Sidebar",
  GALLERY: "Gallery",
  SPOTLIGHT: "Spotlight"
};
var LayoutModeIconMapping = {
  [LayoutMode.GALLERY]: /* @__PURE__ */ React21.createElement(GalleryIcon, null),
  [LayoutMode.SIDEBAR]: /* @__PURE__ */ React21.createElement(SidebarIcon, null),
  [LayoutMode.SPOTLIGHT]: /* @__PURE__ */ React21.createElement(PersonRectangleIcon, null)
};
var LayoutSettings = () => {
  const hmsActions = useHMSActions2();
  const isLocalVideoEnabled = useHMSStore3(selectIsLocalVideoEnabled);
  const isLocalScreenShared = useHMSStore3(selectIsLocalScreenShared);
  const [{ isAudioOnly, maxTileCount, mirrorLocalVideo }, setUISettings] = useSetUiSettings();
  const toggleIsAudioOnly = useCallback4(
    (isAudioOnlyModeOn) => __async(void 0, null, function* () {
      if (isAudioOnlyModeOn) {
        isLocalVideoEnabled && (yield hmsActions.setLocalVideoEnabled(false));
        isLocalScreenShared && (yield hmsActions.setScreenShareEnabled(false));
      }
      setUISettings({ [UI_SETTINGS.isAudioOnly]: isAudioOnlyModeOn });
    }),
    [hmsActions, isLocalVideoEnabled, isLocalScreenShared, setUISettings]
  );
  return /* @__PURE__ */ React21.createElement(Box, { className: settingOverflow() }, /* @__PURE__ */ React21.createElement(Flex, { align: "center", css: { w: "100%", my: "$2", py: "$8", "@md": { display: "none" } } }, /* @__PURE__ */ React21.createElement(Text, { variant: "md", css: { fontWeight: "$semiBold" } }, "Tiles In View(", maxTileCount, ")"), /* @__PURE__ */ React21.createElement(Flex, { justify: "end", css: { flex: "1 1 0" } }, /* @__PURE__ */ React21.createElement(
    Slider,
    {
      step: 1,
      value: [maxTileCount],
      min: 1,
      max: 49,
      onValueChange: (e) => {
        setUISettings({ [UI_SETTINGS.maxTileCount]: e[0] });
      },
      css: { w: "70%" }
    }
  ))), /* @__PURE__ */ React21.createElement(SwitchWithLabel_default, { label: "Audio Only Mode", id: "audioOnlyMode", checked: isAudioOnly, onChange: toggleIsAudioOnly }), /* @__PURE__ */ React21.createElement(
    SwitchWithLabel_default,
    {
      label: "Mirror Local Video",
      id: "mirrorMode",
      checked: mirrorLocalVideo,
      onChange: (value) => {
        setUISettings({
          [UI_SETTINGS.mirrorLocalVideo]: value
        });
      }
    }
  ));
};

// src/Prebuilt/provider/roomLayoutProvider/hooks/useRoomLayoutScreen.ts
init_define_process_env();
import { useMemo as useMemo3 } from "react";
import {
  selectHLSState,
  selectPeerCount,
  selectRoomStartTime,
  useHMSStore as useHMSStore4,
  useRecordingStreaming
} from "@100mslive/react-sdk";

// src/Prebuilt/provider/roomLayoutProvider/index.tsx
init_define_process_env();
var import_lodash2 = __toESM(require_lodash());
import React22 from "react";

// src/Prebuilt/provider/roomLayoutProvider/hooks/useFetchRoomLayout.ts
init_define_process_env();
import { useCallback as useCallback5, useEffect as useEffect5, useRef as useRef6, useState as useState5 } from "react";

// src/Prebuilt/provider/roomLayoutProvider/constants/index.ts
init_define_process_env();
import { JoinForm_JoinBtnType } from "@100mslive/types-prebuilt/elements/join_form";
var defaultLayout = {
  id: "",
  role_id: "",
  template_id: "",
  app_id: "",
  typography: {
    font_family: "Inter"
  },
  themes: [],
  options: {},
  screens: {
    preview: {
      default: {
        elements: {
          preview_header: {
            title: "Get Started",
            sub_title: "Setup your audio and video before joining"
          },
          join_form: {
            join_btn_type: JoinForm_JoinBtnType.JOIN_BTN_TYPE_JOIN_ONLY,
            join_btn_label: "Join Now",
            go_live_btn_label: "Go Live"
          }
        }
      }
    },
    conferencing: {
      default: {
        elements: {
          chat: {
            public_chat_enabled: true,
            private_chat_enabled: true,
            chat_title: "Chat",
            allow_pinning_messages: true,
            message_placeholder: "Send a message...",
            roles_whitelist: [],
            real_time_controls: {
              can_disable_chat: true,
              can_block_user: true,
              can_hide_message: true
            }
          },
          participant_list: {},
          video_tile_layout: {
            grid: {
              enable_local_tile_inset: true,
              prominent_roles: [],
              enable_spotlighting_peer: true
            }
          },
          emoji_reactions: {}
        }
      }
    },
    leave: {}
  }
};

// src/Prebuilt/provider/roomLayoutProvider/hooks/useFetchRoomLayout.ts
var fetchWithRetry = (..._0) => __async(void 0, [..._0], function* (url = "", options = {}) {
  const MAX_RETRIES = 4;
  let error = Error("something went wrong");
  for (let i = 0; i < MAX_RETRIES; i++) {
    try {
      return yield fetch(url, options);
    } catch (err) {
      error = err;
    }
  }
  console.error("Fetch failed after max retries", { url, options });
  throw error;
});
var useFetchRoomLayout = ({
  endpoint = "",
  authToken = ""
}) => {
  const [layout, setLayout] = useState5(void 0);
  const layoutResp = useRef6();
  const originalLayout = useRef6();
  const isFetchInProgress = useRef6(false);
  const setOriginalLayout = useCallback5(() => setLayout(originalLayout.current), []);
  const updateRoomLayoutForRole = useCallback5((role) => {
    var _a8;
    if (!layoutResp.current) {
      return;
    }
    const [layout2] = (((_a8 = layoutResp.current) == null ? void 0 : _a8.data) || []).filter((layout3) => layout3.role === role);
    if (layout2) {
      setLayout(layout2);
    }
  }, []);
  useEffect5(() => {
    (() => __async(void 0, null, function* () {
      var _a8, _b7;
      if (isFetchInProgress.current || !authToken) {
        return;
      }
      isFetchInProgress.current = true;
      try {
        const resp = yield fetchWithRetry(endpoint || "https://api.100ms.live/v2/layouts/ui", {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        });
        layoutResp.current = yield resp.json();
      } catch (e) {
        console.error("[Room Layout API]: Failed to fetch / process room layout. Resorting to default layout.", e);
        layoutResp.current = {
          data: [defaultLayout]
        };
      }
      let layoutForRole = (_b7 = (_a8 = layoutResp.current) == null ? void 0 : _a8.data) == null ? void 0 : _b7[0];
      if (!layoutForRole) {
        console.error(
          "[Room Layout API]: Unable to figure out room layout from API response. Resorting to default layout."
        );
        layoutForRole = defaultLayout;
      }
      const layout2 = layoutForRole;
      if (!originalLayout.current) {
        originalLayout.current = layout2;
      }
      setLayout(layout2);
      isFetchInProgress.current = false;
    }))();
  }, [authToken, endpoint]);
  return { layout, updateRoomLayoutForRole, setOriginalLayout };
};

// src/Prebuilt/provider/roomLayoutProvider/index.tsx
var RoomLayoutContext = React22.createContext(void 0);
function customizer(objValue, srcValue) {
  if ((0, import_lodash2.isArray)(objValue) || (0, import_lodash2.isArray)(srcValue)) {
    return srcValue;
  }
  return void 0;
}
var RoomLayoutProvider = ({
  children,
  roomLayoutEndpoint,
  overrideLayout
}) => {
  const authToken = useAuthToken();
  const { layout, updateRoomLayoutForRole, setOriginalLayout } = useFetchRoomLayout({
    authToken,
    endpoint: roomLayoutEndpoint
  });
  const mergedLayout = authToken && layout ? (0, import_lodash2.mergeWith)(layout, overrideLayout, customizer) : layout;
  return /* @__PURE__ */ React22.createElement(RoomLayoutContext.Provider, { value: { layout: mergedLayout, updateRoomLayoutForRole, setOriginalLayout } }, children);
};
var useRoomLayout = () => {
  var _a8;
  return (_a8 = React22.useContext(RoomLayoutContext)) == null ? void 0 : _a8.layout;
};
var useUpdateRoomLayout = () => {
  var _a8;
  return (_a8 = React22.useContext(RoomLayoutContext)) == null ? void 0 : _a8.updateRoomLayoutForRole;
};
var useSetOriginalLayout = () => {
  var _a8;
  return (_a8 = React22.useContext(RoomLayoutContext)) == null ? void 0 : _a8.setOriginalLayout;
};

// src/Prebuilt/common/utils.js
init_define_process_env();
var getMetadata = (metadataString) => {
  try {
    return !metadataString ? {} : JSON.parse(metadataString);
  } catch (error) {
    return {};
  }
};
var isScreenshareSupported = () => {
  return typeof navigator.mediaDevices.getDisplayMedia !== "undefined";
};
var getFormattedCount = (num) => {
  const formatter = new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 2 });
  const formattedNum = formatter.format(num);
  return formattedNum;
};
var formatTime = (timeInSeconds) => {
  timeInSeconds = Math.floor(timeInSeconds / 1e3);
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor(timeInSeconds % 3600 / 60);
  const seconds = timeInSeconds % 60;
  const hour = hours !== 0 ? `${hours < 10 ? "0" : ""}${hours}:` : "";
  return `${hour}${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};
var compareArrays = (a2, b2) => {
  if (a2.length !== b2.length)
    return false;
  else {
    for (var i = 0; i < a2.length; i++) {
      if (a2[i] !== b2[i]) {
        return false;
      }
    }
    return true;
  }
};
var checkCorrectAnswer = (answer, localPeerResponse, type) => {
  if (type === "single-choice" /* SINGLE_CHOICE */) {
    return (answer == null ? void 0 : answer.option) === (localPeerResponse == null ? void 0 : localPeerResponse.option);
  } else if (type === "multiple-choice" /* MULTIPLE_CHOICE */) {
    return (answer == null ? void 0 : answer.options) && (localPeerResponse == null ? void 0 : localPeerResponse.options) && compareArrays(answer == null ? void 0 : answer.options, localPeerResponse == null ? void 0 : localPeerResponse.options);
  }
};
var isValidTextInput = (text, minLength = 1, maxLength = 1024) => {
  return text && text.length >= minLength && text.length <= maxLength;
};
var calculateAvatarAndAttribBoxSize = (calculatedWidth, calculatedHeight) => {
  if (!calculatedWidth || !calculatedHeight) {
    return [void 0, void 0];
  }
  let avatarSize = "large";
  if (calculatedWidth <= 150 || calculatedHeight <= 150) {
    avatarSize = "small";
  } else if (calculatedWidth <= 300 || calculatedHeight <= 300) {
    avatarSize = "medium";
  }
  let attribBoxSize = "medium";
  if (calculatedWidth <= 180 || calculatedHeight <= 180) {
    attribBoxSize = "small";
  }
  return [avatarSize, attribBoxSize];
};
var isMobileUserAgent = /Mobi|Android|iPhone/i.test(navigator.userAgent);
var getPeerResponses = (questions, peerid, userid) => {
  return questions.map(
    (question) => {
      var _a8;
      return (_a8 = question.responses) == null ? void 0 : _a8.filter(
        (response) => {
          var _a9, _b7;
          return response && (((_a9 = response.peer) == null ? void 0 : _a9.peerid) === peerid || ((_b7 = response.peer) == null ? void 0 : _b7.userid) === userid) && !response.skipped;
        }
      );
    }
  );
};
var getIndexToShow = (responses) => {
  let lastAttemptedIndex = 0;
  Object.keys(responses).forEach((key) => {
    const keyNum = parseInt(key);
    if (keyNum > lastAttemptedIndex && responses[key]) {
      lastAttemptedIndex = keyNum;
    }
  });
  return lastAttemptedIndex + 1;
};

// src/Prebuilt/provider/roomLayoutProvider/hooks/useRoomLayoutScreen.ts
function useRoomLayoutScreen({
  screen
}) {
  var _a8;
  const roomLayout = useRoomLayout();
  const screenProps = (_a8 = roomLayout == null ? void 0 : roomLayout.screens) == null ? void 0 : _a8[screen];
  return screenProps;
}
function useRoomLayoutPreviewScreen() {
  var _a8;
  const screenProps = useRoomLayoutScreen({ screen: "preview" });
  const isPreviewScreenEnabled = !!screenProps && !(screenProps == null ? void 0 : screenProps.skip_preview_screen);
  let elements;
  let screenType;
  if (isPreviewScreenEnabled) {
    screenType = Object.keys(screenProps).filter((key) => key !== "skip_preview_screen")[0];
    elements = (_a8 = screenProps[screenType]) == null ? void 0 : _a8.elements;
  }
  return {
    isPreviewScreenEnabled,
    elements,
    screenType
  };
}
function useRoomLayoutConferencingScreen() {
  var _a8, _b7;
  const screenProps = useRoomLayoutScreen({ screen: "conferencing" }) || {};
  const screenType = Object.keys(screenProps)[0];
  const elements = (_a8 = screenProps[screenType]) == null ? void 0 : _a8.elements;
  const hideSections = ((_b7 = screenProps[screenType]) == null ? void 0 : _b7.hideSections) || [];
  return {
    hideSections,
    elements,
    screenType
  };
}
function useRoomLayoutLeaveScreen() {
  var _a8, _b7;
  const screenProps = useRoomLayoutScreen({ screen: "leave" });
  const isLeaveScreenEnabled = !!screenProps;
  return {
    isLeaveScreenEnabled,
    feedback: (_b7 = (_a8 = screenProps == null ? void 0 : screenProps.default) == null ? void 0 : _a8.elements) == null ? void 0 : _b7.feedback
  };
}
function useRoomLayoutHeader() {
  var _a8, _b7;
  const { elements } = useRoomLayoutConferencingScreen();
  const { isRecordingOn } = useRecordingStreaming();
  const peerCount = useHMSStore4(selectPeerCount);
  const sessionStartedAt = useHMSStore4(selectRoomStartTime);
  const hlsState = useHMSStore4(selectHLSState);
  const details = useMemo3(() => {
    var _a9;
    const details2 = [];
    if ((_a9 = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _a9["startedAt"]) {
      details2.push(`${getFormattedCount(peerCount)} watching`);
      details2.push(hlsState.variants[0]["startedAt"]);
    } else if (sessionStartedAt) {
      details2.push(sessionStartedAt);
    }
    if (isRecordingOn) {
      details2.push("Recording");
    }
    return details2;
  }, [hlsState == null ? void 0 : hlsState.variants, isRecordingOn, peerCount, sessionStartedAt]);
  return {
    title: ((_a8 = elements.header) == null ? void 0 : _a8.title) || "",
    description: ((_b7 = elements.header) == null ? void 0 : _b7.description) || "",
    details
  };
}

// src/Prebuilt/components/AppData/useSidepane.js
init_define_process_env();
import { useCallback as useCallback6 } from "react";
import { match, P } from "ts-pattern";
import { selectAppData as selectAppData2, useHMSActions as useHMSActions3, useHMSStore as useHMSStore5, useHMSVanillaStore as useHMSVanillaStore3 } from "@100mslive/react-sdk";
var useIsSidepaneTypeOpen = (sidepaneType) => {
  if (!sidepaneType) {
    throw Error("Pass one of the side pane options");
  }
  return useHMSStore5(selectAppData2(APP_DATA.sidePane)) === sidepaneType;
};
var useSidepaneState = () => {
  const sidePane = useHMSStore5(selectAppData2(APP_DATA.sidePane));
  return sidePane;
};
var useSidepaneToggle = (sidepaneType) => {
  const hmsActions = useHMSActions3();
  const vanillaStore = useHMSVanillaStore3();
  const toggleSidepane = useCallback6(() => {
    const isOpen = vanillaStore.getState(selectAppData2(APP_DATA.sidePane)) === sidepaneType;
    hmsActions.setAppData(APP_DATA.sidePane, !isOpen ? sidepaneType : "");
  }, [vanillaStore, hmsActions, sidepaneType]);
  return toggleSidepane;
};
var usePollViewToggle = () => {
  const hmsActions = useHMSActions3();
  const { view, setPollState } = usePollViewState();
  const isOpen = useSidepaneState() === SIDE_PANE_OPTIONS.POLLS;
  const togglePollView = useCallback6(
    (id) => {
      match({ id, isOpen, view }).with(
        {
          id: P.string
        },
        () => {
          setPollState({
            [POLL_STATE.pollInView]: id,
            [POLL_STATE.view]: POLL_VIEWS.VOTE
          });
          hmsActions.setAppData(APP_DATA.sidePane, SIDE_PANE_OPTIONS.POLLS);
        }
      ).with(
        {
          isOpen: true,
          view: P.when((view2) => !!view2)
        },
        () => {
          setPollState({
            [POLL_STATE.pollInView]: void 0,
            [POLL_STATE.view]: null
          });
          hmsActions.setAppData(APP_DATA.sidePane, "");
        }
      ).otherwise(() => {
        setPollState({
          [POLL_STATE.pollInView]: void 0,
          [POLL_STATE.view]: POLL_VIEWS.CREATE_POLL_QUIZ
        });
        hmsActions.setAppData(APP_DATA.sidePane, SIDE_PANE_OPTIONS.POLLS);
      });
    },
    [hmsActions, view, setPollState, isOpen]
  );
  return togglePollView;
};
var useSidepaneReset = () => {
  const hmsActions = useHMSActions3();
  const resetSidepane = useCallback6(() => {
    hmsActions.setAppData(APP_DATA.sidePane, "");
    hmsActions.setAppData(APP_DATA.pollInView, "");
  }, [hmsActions]);
  return resetSidepane;
};

// src/Prebuilt/components/MoreSettings/constants.ts
init_define_process_env();
var trackSourceOptions = [
  { label: "All Track Sources", value: "" },
  { label: "regular", value: "regular" },
  { label: "screen", value: "screen" },
  { label: "audioplaylist", value: "audioplaylist" },
  { label: "videoplaylist", value: "videoplaylist" }
];
var trackTypeOptions = [
  { label: "All Track Types", value: "" },
  { label: "audio", value: "audio" },
  { label: "video", value: "video" }
];
var DEFAULT_TILES_IN_VIEW = { MWEB: 4, DESKTOP: 9 };

// src/Prebuilt/components/AppData/AppData.tsx
var initialAppData = {
  [APP_DATA.uiSettings]: {
    [UI_SETTINGS.isAudioOnly]: false,
    [UI_SETTINGS.maxTileCount]: 9,
    [UI_SETTINGS.showStatsOnTiles]: false,
    [UI_SETTINGS.enableAmbientMusic]: false,
    [UI_SETTINGS.uiViewMode]: UI_MODE_GRID,
    [UI_SETTINGS.mirrorLocalVideo]: true,
    [UI_SETTINGS.layoutMode]: LayoutMode.GALLERY
  },
  [APP_DATA.subscribedNotifications]: {
    PEER_JOINED: false,
    PEER_LEFT: false,
    NEW_MESSAGE: true,
    ERROR: true,
    METADATA_UPDATED: true
  },
  [APP_DATA.chatOpen]: false,
  [APP_DATA.chatSelector]: {
    [CHAT_SELECTOR.ROLE]: "",
    [CHAT_SELECTOR.PEER]: {}
  },
  [APP_DATA.chatDraft]: "",
  [APP_DATA.sidePane]: "",
  [APP_DATA.sheet]: "",
  [APP_DATA.hlsStarted]: false,
  [APP_DATA.rtmpStarted]: false,
  [APP_DATA.recordingStarted]: false,
  [APP_DATA.dropdownList]: [],
  [APP_DATA.authToken]: "",
  [APP_DATA.minimiseInset]: false,
  [APP_DATA.activeScreensharePeerId]: "",
  [APP_DATA.disableNotifications]: false,
  [APP_DATA.loadingEffects]: false,
  [APP_DATA.background]: "none",
  [APP_DATA.pollState]: {
    [POLL_STATE.pollInView]: "",
    [POLL_STATE.view]: ""
  },
  // by default on because of on demand now, for beam disabled
  [APP_DATA.caption]: false,
  [APP_DATA.noiseCancellation]: false
};
var AppData = React23.memo(() => {
  var _a8, _b7, _c, _d;
  const hmsActions = useHMSActions4();
  const [preferences = {}] = useUserPreferences(UserPreferencesKeys.UI_SETTINGS);
  const appData = useHMSStore6(selectFullAppData);
  const { elements } = useRoomLayoutConferencingScreen();
  const toggleVB = useSidepaneToggle(SIDE_PANE_OPTIONS.VB);
  const { isLocalVideoEnabled } = useAVToggle();
  const sidepaneOpenedRef = useRef7(false);
  const [, setNoiseCancellationEnabled] = useSetNoiseCancellation();
  const isMobile = useMedia(config.media.md);
  useEffect6(() => {
    var _a9;
    if ((_a9 = elements == null ? void 0 : elements.noise_cancellation) == null ? void 0 : _a9.enabled_by_default) {
      setNoiseCancellationEnabled(true);
    }
  }, [(_a8 = elements == null ? void 0 : elements.noise_cancellation) == null ? void 0 : _a8.enabled_by_default, setNoiseCancellationEnabled]);
  const defaultMediaURL = useMemo4(() => {
    var _a9;
    const media = ((_a9 = elements == null ? void 0 : elements.virtual_background) == null ? void 0 : _a9.background_media) || [];
    for (let i = 0; i < media.length; i++) {
      if (media[i].default && media[i].url) {
        return media[i].url;
      }
    }
    return "";
  }, [(_b7 = elements == null ? void 0 : elements.virtual_background) == null ? void 0 : _b7.background_media]);
  useEffect6(() => {
    hmsActions.initAppData(__spreadValues(__spreadValues({}, initialAppData), appData));
    hmsActions.setFrameworkInfo({
      type: "react-web",
      isPrebuilt: true,
      version: React23.version
    });
  }, [hmsActions]);
  useEffect6(() => {
    const uiSettings = preferences || {};
    const updatedSettings = __spreadProps(__spreadValues({}, uiSettings), {
      [UI_SETTINGS.isAudioOnly]: void 0,
      [UI_SETTINGS.uiViewMode]: uiSettings.uiViewMode || UI_MODE_GRID
    });
    hmsActions.setAppData(APP_DATA.uiSettings, updatedSettings, true);
  }, [hmsActions, preferences]);
  useEffect6(() => {
    var _a9, _b8;
    hmsActions.setAppData(
      APP_DATA.uiSettings,
      {
        [UI_SETTINGS.maxTileCount]: isMobile ? DEFAULT_TILES_IN_VIEW.MWEB : Number((_b8 = (_a9 = elements == null ? void 0 : elements.video_tile_layout) == null ? void 0 : _a9.grid) == null ? void 0 : _b8.tiles_in_view) || DEFAULT_TILES_IN_VIEW.DESKTOP
      },
      true
    );
  }, [hmsActions, isMobile, (_d = (_c = elements == null ? void 0 : elements.video_tile_layout) == null ? void 0 : _c.grid) == null ? void 0 : _d.tiles_in_view]);
  useEffect6(() => {
    if (!preferences.subscribedNotifications) {
      return;
    }
    hmsActions.setAppData(APP_DATA.subscribedNotifications, preferences.subscribedNotifications, true);
  }, [preferences.subscribedNotifications, hmsActions]);
  useEffect6(() => {
    if (defaultMediaURL && !sidepaneOpenedRef.current && isLocalVideoEnabled) {
      hmsActions.setAppData(APP_DATA.background, defaultMediaURL);
      sidepaneOpenedRef.current = true;
      toggleVB();
    }
  }, [hmsActions, toggleVB, isLocalVideoEnabled, defaultMediaURL]);
  return /* @__PURE__ */ React23.createElement(ResetStreamingStart, null);
});
var ResetStreamingStart = () => {
  const { isHLSRunning, isRTMPRunning, isBrowserRecordingOn } = useRecordingStreaming2();
  const hlsError = useHMSStore6(selectHLSState2).error;
  const rtmpError = useHMSStore6(selectRTMPState).error;
  const roomState = useHMSStore6(selectRoomState);
  const [hlsStarted, setHLSStarted] = useSetAppDataByKey(APP_DATA.hlsStarted);
  const [recordingStarted, setRecordingStarted] = useSetAppDataByKey(APP_DATA.recordingStarted);
  const [rtmpStarted, setRTMPStarted] = useSetAppDataByKey(APP_DATA.rtmpStarted);
  const toggleStreaming = useSidepaneToggle(SIDE_PANE_OPTIONS.STREAMING);
  const isStreamingOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.STREAMING);
  useEffect6(() => {
    if (isBrowserRecordingOn && recordingStarted) {
      setRecordingStarted(false);
    }
  }, [isBrowserRecordingOn, recordingStarted, setRecordingStarted]);
  useEffect6(() => {
    if (roomState === HMSRoomState.Disconnected) {
      setHLSStarted(false);
      setRecordingStarted(false);
      setRTMPStarted(false);
    }
  }, [roomState, setHLSStarted, setRTMPStarted, setRecordingStarted]);
  useEffect6(() => {
    if (isHLSRunning || hlsError) {
      if (hlsStarted) {
        setHLSStarted(false);
        if (isStreamingOpen) {
          toggleStreaming();
        }
      }
    }
  }, [isHLSRunning, hlsStarted, setHLSStarted, hlsError, isStreamingOpen, toggleStreaming]);
  useEffect6(() => {
    if (isRTMPRunning || rtmpError || isBrowserRecordingOn) {
      if (rtmpStarted) {
        setRTMPStarted(false);
        if (isStreamingOpen) {
          toggleStreaming();
        }
      }
    }
  }, [isRTMPRunning, setRTMPStarted, rtmpStarted, rtmpError, isBrowserRecordingOn, isStreamingOpen, toggleStreaming]);
  return null;
};

// src/Prebuilt/components/AuthToken.tsx
init_define_process_env();
import React26, { useEffect as useEffect8, useRef as useRef8, useState as useState6 } from "react";
import { useSessionStorage } from "react-use";
import { match as match3 } from "ts-pattern";
import { v4 as uuid } from "uuid";
import { useHMSActions as useHMSActions6 } from "@100mslive/react-sdk";

// src/Prebuilt/AppContext.tsx
init_define_process_env();
import React24, { useContext as useContext2 } from "react";
var HMSPrebuiltContext = React24.createContext({
  roomCode: "",
  userName: "",
  userId: "",
  containerSelector: DEFAULT_PORTAL_CONTAINER,
  endpoints: {},
  onLeave: void 0,
  onJoin: void 0
});
HMSPrebuiltContext.displayName = "HMSPrebuiltContext";
var useHMSPrebuiltContext = () => {
  const context = useContext2(HMSPrebuiltContext);
  if (!context) {
    throw Error("Make sure HMSPrebuiltContext.Provider is present at the top level of your application");
  }
  return context;
};

// src/Prebuilt/AppStateContext.tsx
init_define_process_env();
import React25, { useContext as useContext3, useEffect as useEffect7 } from "react";
import { usePreviousDistinct } from "react-use";
import { HMSVirtualBackgroundTypes as HMSVirtualBackgroundTypes2 } from "@100mslive/hms-virtual-background";
import { match as match2, P as P2 } from "ts-pattern";
import { HMSRoomState as HMSRoomState2, selectRoomState as selectRoomState2, useHMSActions as useHMSActions5, useHMSStore as useHMSStore7 } from "@100mslive/react-sdk";

// src/Prebuilt/components/VirtualBackground/VBHandler.tsx
init_define_process_env();
import { HMSVBPlugin, HMSVirtualBackgroundTypes } from "@100mslive/hms-virtual-background/hmsvbplugin";
import { parsedUserAgent as parsedUserAgent2 } from "@100mslive/react-sdk";
var VBPlugin = class {
  constructor() {
    this.initialisePlugin = (effectsSDKKey, onInit) => __async(this, null, function* () {
      if (this.getVBObject()) {
        return;
      }
      if (effectsSDKKey) {
        try {
          const effects = yield import("@100mslive/hms-virtual-background/hmseffectsplugin");
          this.effectsPlugin = new effects.HMSEffectsPlugin(effectsSDKKey, onInit);
        } catch (error) {
          console.error("Failed to initialise HMSEffectsPlugin:", error, "Using HMSVBPlugin");
          this.hmsPlugin = new HMSVBPlugin(HMSVirtualBackgroundTypes.NONE, HMSVirtualBackgroundTypes.NONE);
        }
      } else {
        this.hmsPlugin = new HMSVBPlugin(HMSVirtualBackgroundTypes.NONE, HMSVirtualBackgroundTypes.NONE);
      }
    });
    this.getBackground = () => {
      var _a8, _b7;
      if (this.effectsPlugin) {
        return (_a8 = this.effectsPlugin) == null ? void 0 : _a8.getBackground();
      } else {
        const background = (_b7 = this.hmsPlugin) == null ? void 0 : _b7.getBackground();
        return (background == null ? void 0 : background.src) || background;
      }
    };
    this.getBlurAmount = () => {
      var _a8;
      if (this.effectsPlugin) {
        return this.effectsPlugin.getBlurAmount();
      } else {
        return ((_a8 = this.hmsPlugin) == null ? void 0 : _a8.getBackground()) === HMSVirtualBackgroundTypes.BLUR ? 1 : 0;
      }
    };
    this.getVBObject = () => {
      return this.effectsPlugin || this.hmsPlugin;
    };
    this.getName = () => {
      var _a8, _b7;
      return this.effectsPlugin ? (_a8 = this.effectsPlugin) == null ? void 0 : _a8.getName() : (_b7 = this.hmsPlugin) == null ? void 0 : _b7.getName();
    };
    this.setBlur = (blurPower) => __async(this, null, function* () {
      var _a8, _b7;
      if (this.effectsPlugin) {
        (_a8 = this.effectsPlugin) == null ? void 0 : _a8.setBlur(blurPower);
      } else {
        yield (_b7 = this.hmsPlugin) == null ? void 0 : _b7.setBackground(HMSVirtualBackgroundTypes.BLUR, HMSVirtualBackgroundTypes.BLUR);
      }
    });
    this.setBackground = (mediaURL) => __async(this, null, function* () {
      var _a8, _b7, _c;
      if (this.effectsPlugin) {
        (_a8 = this.effectsPlugin) == null ? void 0 : _a8.setBackground(mediaURL);
      } else {
        const img = document.createElement("img");
        let retries = 0;
        const MAX_RETRIES = 3;
        img.alt = "VB";
        img.src = mediaURL;
        try {
          yield (_b7 = this.hmsPlugin) == null ? void 0 : _b7.setBackground(img, HMSVirtualBackgroundTypes.IMAGE);
        } catch (e) {
          console.error(e);
          if (retries++ < MAX_RETRIES) {
            yield (_c = this.hmsPlugin) == null ? void 0 : _c.setBackground(img, HMSVirtualBackgroundTypes.IMAGE);
          }
        }
      }
    });
    this.setPreset = (preset) => __async(this, null, function* () {
      if (this.effectsPlugin) {
        yield this.effectsPlugin.setPreset(preset);
      }
    });
    this.getPreset = () => {
      var _a8;
      return ((_a8 = this.effectsPlugin) == null ? void 0 : _a8.getPreset()) || "";
    };
    this.removeEffects = () => __async(this, null, function* () {
      var _a8, _b7;
      if (this.effectsPlugin) {
        (_a8 = this.effectsPlugin) == null ? void 0 : _a8.removeEffects();
      } else {
        yield (_b7 = this.hmsPlugin) == null ? void 0 : _b7.setBackground(HMSVirtualBackgroundTypes.NONE, HMSVirtualBackgroundTypes.NONE);
      }
    });
    this.reset = () => {
      this.effectsPlugin = void 0;
      this.hmsPlugin = void 0;
    };
    this.isBlurSupported = () => {
      if ((isSafari || isIOS) && this.hmsPlugin) {
        return false;
      }
      if (this.effectsPlugin) {
        return true;
      }
      return false;
    };
    this.isEffectsSupported = () => {
      var _a8, _b7;
      if (!isSafari) {
        return true;
      }
      const browserVersion = ((_b7 = (_a8 = parsedUserAgent2) == null ? void 0 : _a8.getBrowser()) == null ? void 0 : _b7.version) || "16";
      if (browserVersion && parseInt(browserVersion.split(".")[0]) < 17) {
        return false;
      }
      return true;
    };
  }
};
var VBHandler = new VBPlugin();

// src/Prebuilt/components/hooks/useRedirectToLeave.tsx
init_define_process_env();
import { useCallback as useCallback7 } from "react";

// src/Prebuilt/components/PIP/PIPManager.ts
init_define_process_env();
import * as workerTimers from "worker-timers";

// src/Prebuilt/components/PIP/pipUtils.js
init_define_process_env();
var CANVAS_FILL_COLOR;
var CANVAS_STROKE_COLOR;
function setPIPCanvasColors() {
  if (!CANVAS_FILL_COLOR) {
    CANVAS_FILL_COLOR = window.getComputedStyle(document.documentElement).getPropertyValue("--hms-ui-colors-surface_bright");
  }
  if (!CANVAS_STROKE_COLOR) {
    CANVAS_STROKE_COLOR = window.getComputedStyle(document.documentElement).getPropertyValue("--hms-ui-colors-border_bright");
  }
}
function resetPIPCanvasColors() {
  CANVAS_FILL_COLOR = "";
  CANVAS_STROKE_COLOR = "";
}
function drawVideoElementsOnCanvas(videoElements, canvas) {
  let videoTiles = videoElements.filter((videoElement) => videoElement.srcObject !== null);
  const ctx = canvas.getContext("2d");
  setPIPCanvasColors();
  ctx.fillStyle = CANVAS_FILL_COLOR;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (videoTiles.length === 0) {
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    return;
  }
  fillGridTiles(videoTiles.slice(0, 4), ctx, canvas);
}
function dummyChangeInCanvas(canvas) {
  const ctx = canvas.getContext("2d");
  setPIPCanvasColors();
  ctx.fillStyle = CANVAS_FILL_COLOR;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
}
function fillGridTiles(videoElements, ctx, canvas) {
  const offset = 8;
  canvas.width = 480;
  canvas.height = 320;
  ctx.fillStyle = CANVAS_FILL_COLOR;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  if (videoElements.length > 0) {
    ctx.strokeStyle = CANVAS_STROKE_COLOR;
    ctx.lineWidth = offset / 2;
    ctx.strokeRect(0, 0, canvas.width, canvas.height);
  }
  if (videoElements.length === 1) {
    const video = videoElements[0];
    const { width, height } = getRenderDimensions(video, canvas.width - offset, canvas.height - offset);
    const xOffset = (canvas.width - width) / 2;
    const yOffset = (canvas.height - height) / 2;
    ctx.drawImage(video, xOffset, yOffset, width, height);
  }
  if (videoElements.length === 2) {
    videoElements.forEach((video, index) => {
      const { width, height } = getRenderDimensions(
        video,
        canvas.width / 2 - offset,
        // This will be the max available width for each tile
        canvas.height - offset
      );
      const xOffset = (canvas.width / 2 - width) / 2 + canvas.width / 2 * index;
      const yOffset = (canvas.height - height) / 2;
      ctx.drawImage(video, xOffset, yOffset, width, height);
    });
    const path = new Path2D();
    path.moveTo(canvas.width / 2, 0);
    path.lineTo(canvas.width / 2, canvas.height);
    ctx.stroke(path);
  }
  if (videoElements.length === 3) {
    videoElements.forEach((video, index) => {
      const { width, height } = getRenderDimensions(video, canvas.width / 2 - offset, canvas.height / 2 - offset);
      const xOffset = index < 2 ? (canvas.width / 2 - width) / 2 + canvas.width / 2 * index : canvas.width / 2 - width / 2;
      const yOffset = (index < 2 ? 0 : canvas.height / 2) + (canvas.height / 2 - height) / 2;
      ctx.drawImage(video, xOffset, yOffset, width, height);
    });
    const path = new Path2D();
    path.moveTo(canvas.width / 2, 0);
    path.lineTo(canvas.width / 2, canvas.height / 2);
    ctx.stroke(path);
    path.moveTo(0, canvas.height / 2);
    path.lineTo(canvas.width, canvas.height / 2);
    ctx.stroke(path);
  }
  if (videoElements.length === 4) {
    videoElements.forEach((video, index) => {
      const { width, height } = getRenderDimensions(video, canvas.width / 2 - offset, canvas.height / 2 - offset);
      const xOffset = (canvas.width / 2 - width) / 2 + canvas.width / 2 * (index % 2);
      const yOffset = (index < 2 ? 0 : canvas.height / 2) + (canvas.height / 2 - height) / 2;
      ctx.drawImage(video, xOffset, yOffset, width, height);
    });
    const path = new Path2D();
    path.moveTo(canvas.width / 2, 0);
    path.lineTo(canvas.width / 2, canvas.height);
    ctx.stroke(path);
    path.moveTo(0, canvas.height / 2);
    path.lineTo(canvas.width, canvas.height / 2);
    ctx.stroke(path);
  }
}
function getRenderDimensions(video, width, height) {
  let finalWidth = video.videoWidth / video.videoHeight * height;
  let finalHeight = height;
  if (finalWidth > width) {
    finalWidth = width;
    finalHeight = video.videoHeight / video.videoWidth * width;
  }
  return { width: finalWidth, height: finalHeight };
}

// src/Prebuilt/components/PIP/PIPManager.ts
var MAX_NUMBER_OF_TILES_IN_PIP = 4;
var DEFAULT_FPS = 30;
var DEFAULT_CANVAS_WIDTH = 480;
var DEFAULT_CANVAS_HEIGHT = 320;
var LEAVE_EVENT_NAME = "leavepictureinpicture";
var PipManager = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set();
    this.canvas = null;
    this.pipVideo = null;
    this.hmsActions = null;
    this.timeoutRef = 0;
    this.videoElements = [];
    this.onStateChange = null;
    this.tracksToShow = [];
    this.state = "stopped" /* stopped */;
    this.stop = () => __async(this, null, function* () {
      var _a8, _b7;
      if (this.state === "stopped" /* stopped */) {
        return;
      }
      this.state = "stopping" /* stopping */;
      (_a8 = this.pipVideo) == null ? void 0 : _a8.removeEventListener(LEAVE_EVENT_NAME, this.stop);
      if (this.timeoutRef) {
        workerTimers.clearTimeout(this.timeoutRef);
        this.timeoutRef = 0;
      }
      if (this.isOn()) {
        this.exitPIP();
      }
      yield this.detachOldAttachNewTracks(this.tracksToShow, []);
      (_b7 = this.onStateChange) == null ? void 0 : _b7.call(this, false);
      this.callListeners(false);
      this.reset();
      this.state = "stopped" /* stopped */;
    });
    // ------- Private function --------------
    /**
     * @private {boolean} on - whether pip is on/off
     */
    this.callListeners = (on2) => {
      this.listeners.forEach((listener) => listener == null ? void 0 : listener(on2));
    };
    this.reset();
  }
  listenToStateChange(cb) {
    this.listeners.add(cb);
  }
  /**
   * @private
   */
  reset() {
    console.debug("resetting PIP state");
    resetPIPCanvasColors();
    this.canvas = null;
    this.pipVideo = null;
    this.timeoutRef = 0;
    this.hmsActions = null;
    this.videoElements = [];
    this.tracksToShow = [];
    this.onStateChange = null;
    this.state = "stopped" /* stopped */;
  }
  /**
   * check if PIP is supported in this browser env
   */
  isSupported() {
    return !!document.pictureInPictureEnabled && !isIOS && !(isMacOS && isSafari);
  }
  /**
   * check if pip is currently turned on
   */
  isOn() {
    return !!document.pictureInPictureElement;
  }
  /**
   * request browser to start pip and start the render loop updating the pip
   * video element with peer tracks.
   * @param hmsActions
   * @param onStateChangeFn {function(bool):void} callback called to notify change in pip state
   */
  start(hmsActions, onStateChangeFn) {
    return __async(this, null, function* () {
      var _a8, _b7;
      if (!this.isSupported()) {
        throw new Error("pip is not supported on this browser");
      }
      console.debug("starting PIP, current state", this.state);
      if (this.state === "started" /* started */) {
        yield this.stop();
      } else if (this.state === "starting" /* starting */) {
        return;
      }
      this.state = "starting" /* starting */;
      try {
        yield this.init(hmsActions, onStateChangeFn);
        (_a8 = this.pipVideo) == null ? void 0 : _a8.addEventListener(LEAVE_EVENT_NAME, this.stop);
        this.renderLoop();
        if (!this.isOn()) {
          yield this.requestPIP();
        }
        console.debug("pip started");
        this.state = "started" /* started */;
        (_b7 = this.onStateChange) == null ? void 0 : _b7.call(this, true);
        this.callListeners(true);
      } catch (err) {
        console.error("error in request pip", err);
        this.state = "stopped" /* stopped */;
      }
    });
  }
  /**
   * @param peers {Array} All Remote Peers present in call.
   * @param tracksMap {Object} map of track id to track
   * */
  updatePeersAndTracks(peers, tracksMap) {
    return __async(this, null, function* () {
      if (!this.canvas) {
        console.log("no canvas to render video to");
        return;
      }
      const newTracksToShowUnordered = this.pickTracksToShow(peers, tracksMap);
      const currentTracksShowing = this.tracksToShow;
      this.tracksToShow = this.orderNewTracksToShow(newTracksToShowUnordered, currentTracksShowing);
      try {
        yield this.detachOldAttachNewTracks(currentTracksShowing, this.tracksToShow, tracksMap);
      } catch (error) {
        console.error("error in detaching/attaching tracks", error);
      }
    });
  }
  /**
   * @private
   */
  init(hmsActions, onStateChangeFn) {
    return __async(this, null, function* () {
      yield this.initMediaElements();
      this.hmsActions = hmsActions;
      this.onStateChange = onStateChangeFn;
    });
  }
  initMediaElements() {
    return __async(this, null, function* () {
      if (!this.canvas) {
        const { canvas, pipVideo } = this.initializeCanvasAndVideoElement();
        this.canvas = canvas;
        this.pipVideo = pipVideo;
        this.videoElements = this.initializeVideoElements();
        const videoPlayPromise = this.pipVideo.play();
        dummyChangeInCanvas(this.canvas);
        yield videoPlayPromise;
      }
    });
  }
  initializeCanvasAndVideoElement() {
    const canvas = document.createElement("canvas");
    canvas.width = DEFAULT_CANVAS_WIDTH;
    canvas.height = DEFAULT_CANVAS_HEIGHT;
    const pipVideo = document.createElement("video");
    pipVideo.width = DEFAULT_CANVAS_WIDTH;
    pipVideo.height = DEFAULT_CANVAS_HEIGHT;
    pipVideo.muted = true;
    pipVideo.srcObject = canvas.captureStream();
    return { canvas, pipVideo };
  }
  initializeVideoElements() {
    const videoElements = [];
    for (let i = 0; i < MAX_NUMBER_OF_TILES_IN_PIP; i++) {
      const videoElement = document.createElement("video");
      videoElement.autoplay = true;
      videoElement.playsInline = true;
      videoElements.push(videoElement);
    }
    return videoElements;
  }
  /**
   * render loop is responsible for rendering the video elements on canvas/pip.
   * in each loop current video elements are stitched and painted on canvas
   */
  renderLoop() {
    const delay = 1e3 / DEFAULT_FPS;
    this.timeoutRef = workerTimers.setTimeout(() => {
      if (this.state === "stopping" /* stopping */ || this.state === "stopped" /* stopped */) {
        return;
      }
      if (this.state === "started" /* started */) {
        drawVideoElementsOnCanvas(this.videoElements, this.canvas);
      }
      this.renderLoop();
    }, delay);
  }
  requestPIP() {
    return __async(this, null, function* () {
      try {
        if (this.isOn()) {
          this.exitPIP();
        }
        if (!this.pipVideo) {
          return;
        }
        yield this.pipVideo.requestPictureInPicture();
      } catch (error) {
        console.error("error in requestpip", error, "state", this.state);
        throw error;
      }
    });
  }
  exitPIP() {
    document.exitPictureInPicture();
  }
  /**
   * Logic - pick only enabled video tracks
   * @param peers {Array<any>}
   * @param tracksMap {Record<string, any>}
   */
  pickTracksToShow(peers, tracksMap) {
    const tracksToShow = /* @__PURE__ */ new Set();
    for (const peer of peers) {
      if (tracksToShow.size === MAX_NUMBER_OF_TILES_IN_PIP) {
        break;
      } else if (peer.videoTrack && this.showTrack(tracksMap[peer.videoTrack])) {
        tracksToShow.add(peer.videoTrack);
      }
    }
    return Array.from(tracksToShow);
  }
  /**
   * there has to be a smart reordering of new tracks based on currently showing
   * ones to reduce unnecessary displacement. If someone was showing up both
   * earlier and now, it's a better UX to keep their position same instead
   * of letting it change.
   * The returned array is a shuffled version of newTracks with position of
   * tracks present in the old tracks intact.
   * eg. old = [1,5,9,3], new = [3,8,2,9], result = [8,2,9,3]
   * @param oldTracks {Array}
   * @param newTracks {Array}
   * @return {Array}
   */
  orderNewTracksToShow(newTracks, oldTracks) {
    const betterNewTracks = new Array(newTracks.length);
    const leftOvers = [];
    newTracks.forEach((track) => {
      const oldPosition = oldTracks.indexOf(track);
      if (oldPosition !== -1 && oldPosition < newTracks.length) {
        betterNewTracks[oldPosition] = track;
      } else {
        leftOvers.push(track);
      }
    });
    for (let i = 0; i < newTracks.length; i++) {
      if (!betterNewTracks[i]) {
        const newEntry = leftOvers.shift();
        if (newEntry) {
          betterNewTracks[i] = newEntry;
        }
      }
    }
    return Array.from(new Set(betterNewTracks));
  }
  showTrack(track) {
    return track && track.enabled && !track.degraded;
  }
  /**
   * call detach for tracks which no longer need to be shown and attach for
   * new ones which are to be shown now.
   * Note: oldTracks and newTracks are not necessarily of same length
   * @param oldTracks {Array<String>}
   * @param newTracks {Array<String>}
   * @param tracksMap {Record<String, any>}
   */
  // eslint-disable-next-line complexity
  detachOldAttachNewTracks(oldTracks, newTracks, tracksMap = null) {
    return __async(this, null, function* () {
      var _a8, _b7;
      const numTracks = Math.max(oldTracks.length, newTracks.length);
      for (let i = 0; i < numTracks; i++) {
        if (oldTracks[i] === newTracks[i]) {
          continue;
        } else if (oldTracks[i]) {
          if (!tracksMap || tracksMap[oldTracks[i]]) {
            yield (_a8 = this.hmsActions) == null ? void 0 : _a8.detachVideo(oldTracks[i], this.videoElements[i]);
          }
          if (this.videoElements[i]) {
            this.videoElements[i].srcObject = null;
          }
        }
        if (newTracks[i]) {
          yield (_b7 = this.hmsActions) == null ? void 0 : _b7.attachVideo(newTracks[i], this.videoElements[i]);
        }
      }
    });
  }
};
var PictureInPicture = new PipManager();

// src/Prebuilt/components/Toast/ToastManager.js
init_define_process_env();
import { v4 } from "uuid";
var ToastManager = {
  toasts: /* @__PURE__ */ new Map(),
  listeners: /* @__PURE__ */ new Map(),
  addToast(toast) {
    const id = toast.id ? toast.id : v4();
    this.toasts.set(id, __spreadProps(__spreadValues({}, toast), { id }));
    this.onChange();
    return id;
  },
  clearAllToast() {
    this.toasts.clear();
    this.onChange();
  },
  removeToast(id) {
    this.toasts.delete(id);
    this.onChange();
  },
  replaceToast(id, toast) {
    if (this.isActive(id)) {
      this.toasts.set(id, __spreadValues(__spreadValues({}, this.toasts.get(id)), toast));
      this.onChange();
      return id;
    } else {
      return this.addToast(toast);
    }
  },
  addListener(cb) {
    this.listeners.set(cb, cb);
  },
  removeListener(cb) {
    this.listeners.delete(cb);
  },
  isActive(id) {
    return this.toasts.has(id);
  },
  onChange() {
    const toasts = Array.from(this.toasts.values());
    this.listeners.forEach((listener) => listener(toasts));
  }
};

// src/Prebuilt/components/hooks/useRedirectToLeave.tsx
var useRedirectToLeave = () => {
  const { onLeave } = useHMSPrebuiltContext();
  const redirect = useCallback7(
    (timeout = 0) => {
      setTimeout(() => {
        PictureInPicture.stop().catch(() => console.error("stopping pip"));
        ToastManager.clearAllToast();
        onLeave == null ? void 0 : onLeave();
      }, timeout);
    },
    [onLeave]
  );
  return { redirectToLeave: redirect };
};

// src/Prebuilt/AppStateContext.tsx
var AppStateContext = React25.createContext({
  rejoin: () => {
    console.log("Rejoin");
  }
});
AppStateContext.displayName = "AppStateContext";
var useHMSAppStateContext = () => {
  const context = useContext3(AppStateContext);
  if (!context) {
    throw Error("Make sure AppStateContext.Provider is present at the top level of your application");
  }
  return context;
};
var useAppStateManager = () => {
  const roomLayout = useRoomLayout();
  const setOriginalLayout = useSetOriginalLayout();
  const [activeState, setActiveState] = React25.useState();
  const roomState = useHMSStore7(selectRoomState2);
  const prevRoomState = usePreviousDistinct(roomState);
  const hmsActions = useHMSActions5();
  const { isLeaveScreenEnabled } = useRoomLayoutLeaveScreen();
  const { isPreviewScreenEnabled } = useRoomLayoutPreviewScreen();
  const { redirectToLeave } = useRedirectToLeave();
  const rejoin = () => {
    setOriginalLayout == null ? void 0 : setOriginalLayout();
    hmsActions.setAppData(APP_DATA.authToken, "");
    setActiveState(isPreviewScreenEnabled ? "preview" /* PREVIEW */ : "meeting" /* MEETING */);
  };
  useEffect7(() => {
    if (!roomLayout) {
      return;
    }
    match2([roomState, prevRoomState]).with([HMSRoomState2.Connected, P2.any], () => setActiveState("meeting" /* MEETING */)).with(
      [HMSRoomState2.Disconnecting, HMSRoomState2.Connected],
      [HMSRoomState2.Disconnecting, HMSRoomState2.Connecting],
      [HMSRoomState2.Disconnecting, HMSRoomState2.Reconnecting],
      [HMSRoomState2.Disconnected, HMSRoomState2.Connected],
      [HMSRoomState2.Disconnected, HMSRoomState2.Connecting],
      [HMSRoomState2.Disconnected, HMSRoomState2.Reconnecting],
      [HMSRoomState2.Disconnected, HMSRoomState2.Preview],
      () => {
        setActiveState((prevState) => {
          return match2({ isLeaveScreenEnabled, isPreviewScreenEnabled, prevState }).when(
            ({ isLeaveScreenEnabled: isLeaveScreenEnabled2, prevState: prevState2 }) => isLeaveScreenEnabled2 && prevState2 !== "leave" /* LEAVE */,
            () => "leave" /* LEAVE */
          ).with({ isPreviewScreenEnabled: true }, () => "preview" /* PREVIEW */).otherwise(() => "meeting" /* MEETING */);
        });
        VBHandler.reset();
        hmsActions.setAppData(APP_DATA.background, HMSVirtualBackgroundTypes2.NONE);
        redirectToLeave(1e3);
      }
    ).with([HMSRoomState2.Disconnected, P2.nullish], () => {
      setActiveState(isPreviewScreenEnabled ? "preview" /* PREVIEW */ : "meeting" /* MEETING */);
    }).otherwise(() => {
    });
  }, [roomLayout, roomState, isLeaveScreenEnabled, isPreviewScreenEnabled, prevRoomState, redirectToLeave, hmsActions]);
  return { activeState, rejoin };
};

// src/Prebuilt/components/AuthToken.tsx
import errorImage from "./transaction_error.svg";
var AuthToken = React26.memo(({ authTokenByRoomCodeEndpoint, defaultAuthToken, activeState }) => {
  const hmsActions = useHMSActions6();
  const { roomCode, userId } = useHMSPrebuiltContext();
  const [error, setError] = useState6({ title: "", body: "" });
  const authToken = defaultAuthToken;
  const [tokenInAppData, setAuthTokenInAppData] = useSetAppDataByKey(APP_DATA.authToken);
  const [savedUserId, setSavedUserId] = useSessionStorage(UserPreferencesKeys.USER_ID);
  const progressRef = useRef8(null);
  useEffect8(() => {
    if (authToken) {
      setAuthTokenInAppData(authToken);
      return;
    }
    if (tokenInAppData || progressRef.current || activeState === "leave" /* LEAVE */) {
      return;
    }
    if (!roomCode) {
      console.error("room code not provided");
      return;
    }
    let userIdForAuthToken = userId || savedUserId;
    if (!userIdForAuthToken) {
      userIdForAuthToken = uuid();
      setSavedUserId(userIdForAuthToken);
    }
    progressRef.current = true;
    hmsActions.getAuthTokenByRoomCode({ roomCode, userId: userIdForAuthToken }, { endpoint: authTokenByRoomCodeEndpoint }).then((token) => setAuthTokenInAppData(token)).catch((error2) => setError(convertError(error2))).finally(() => {
      progressRef.current = false;
    });
  }, [
    hmsActions,
    authToken,
    authTokenByRoomCodeEndpoint,
    setAuthTokenInAppData,
    roomCode,
    userId,
    savedUserId,
    tokenInAppData,
    setSavedUserId,
    activeState
  ]);
  if (error.title) {
    return /* @__PURE__ */ React26.createElement(Dialog.Root, { open: true }, /* @__PURE__ */ React26.createElement(
      Dialog.Content,
      {
        css: {
          maxWidth: "$100",
          boxSizing: "border-box",
          p: "$10 $12",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      },
      /* @__PURE__ */ React26.createElement("img", { src: errorImage, height: 80, width: 80, alt: "Token Error" }),
      /* @__PURE__ */ React26.createElement(Text, { variant: "h4", css: { textAlign: "center", mb: "$4", mt: "$10" } }, error.title),
      /* @__PURE__ */ React26.createElement(Text, { css: { c: "$on_surface_medium", textAlign: "center" } }, error.body)
    ));
  }
  return null;
});
var convertError = (error) => {
  console.error("[error]", { error });
  console.warn(
    "If you think this is a mistake on our side, please reach out to us on Dashboard:",
    "https://dashboard.100ms.live/dashboard"
  );
  return match3([error.action, error.code]).with(["GET_TOKEN", 403], () => ({
    title: "Psst! This room is currently inactive.",
    body: "Please feel free to join another open room for more conversations. Thanks for stopping by!"
  })).with(["GET_TOKEN", 404], () => ({
    title: "Room code does not exist",
    body: "We could not find a room code corresponding to this link."
  })).with(["GET_TOKEN", 2003], () => ({
    title: "Endpoint is not reachable",
    body: `Endpoint is not reachable. ${error.description}.`
  })).otherwise(
    () => {
      var _a8;
      return (
        // @ts-ignore
        match3((_a8 = error.response) == null ? void 0 : _a8.status).with(404, () => ({
          title: "Room does not exist",
          body: "We could not find a room corresponding to this link."
        })).with(403, () => ({
          title: "Accessing room using this link format is disabled",
          body: "You can re-enable this from the developer section in Dashboard."
        })).otherwise(() => {
          console.error("Token API Error", error);
          return {
            title: "Error fetching token",
            body: "An error occurred while fetching the app token. Please look into logs for more details."
          };
        })
      );
    }
  );
};
var AuthToken_default = AuthToken;

// src/Prebuilt/components/ConferenceScreen.tsx
init_define_process_env();
import React176, { useEffect as useEffect64, useRef as useRef33 } from "react";
import { v4 as uuid3 } from "uuid";
import {
  HMSRoomState as HMSRoomState9,
  selectIsConnectedToRoom as selectIsConnectedToRoom10,
  selectRoomState as selectRoomState9,
  useAwayNotifications as useAwayNotifications3,
  useHMSActions as useHMSActions51,
  useHMSStore as useHMSStore87
} from "@100mslive/react-sdk";

// src/Prebuilt/components/Footer/Footer.tsx
init_define_process_env();
import React86, { useEffect as useEffect28 } from "react";
import { useMedia as useMedia15 } from "react-use";
import { Chat_ChatState } from "@100mslive/types-prebuilt/elements/chat";

// src/Prebuilt/components/AudioVideoToggle.tsx
init_define_process_env();
import React34, { Fragment as Fragment3, useCallback as useCallback9, useEffect as useEffect11, useState as useState10 } from "react";
import { HMSKrispPlugin } from "@100mslive/hms-noise-cancellation";
import {
  DeviceType as DeviceType2,
  HMSRoomState as HMSRoomState3,
  selectIsLocalAudioPluginPresent,
  selectLocalAudioTrackID,
  selectLocalPeer,
  selectLocalVideoTrackID as selectLocalVideoTrackID2,
  selectRoom,
  selectRoomState as selectRoomState3,
  selectVideoTrackByID as selectVideoTrackByID2,
  useAVToggle as useAVToggle2,
  useDevices as useDevices2,
  useHMSActions as useHMSActions7,
  useHMSStore as useHMSStore9,
  useHMSVanillaStore as useHMSVanillaStore4
} from "@100mslive/react-sdk";
import {
  AudioLevelIcon,
  CameraFlipIcon,
  CheckIcon,
  MicOffIcon,
  MicOnIcon as MicOnIcon2,
  SettingsIcon as SettingsIcon2,
  SpeakerIcon as SpeakerIcon2,
  VideoOffIcon,
  VideoOnIcon as VideoOnIcon2
} from "@100mslive/react-icons";

// src/Prebuilt/components/IconButtonWithOptions/IconButtonWithOptions.tsx
init_define_process_env();
import React27 from "react";
import { VerticalMenuIcon } from "@100mslive/react-icons";

// src/Prebuilt/IconButton.tsx
init_define_process_env();
var IconButton2 = styled(IconButton, {
  width: "$14",
  height: "$14",
  border: "1px solid $border_bright",
  bg: "$background_dim",
  r: "$1",
  "&[disabled]": {
    opacity: 0.5,
    cursor: "not-allowed",
    backgroundColor: "$secondary_dim",
    color: "$on_primary_high"
  },
  variants: {
    active: {
      true: {
        color: "$on_surface_high",
        backgroundColor: "transparent"
      }
    }
  }
});
var IconButton_default = IconButton2;

// src/Prebuilt/components/IconButtonWithOptions/IconButtonWithOptions.tsx
var variants = {
  disabled: {
    true: {
      bg: "$surface_brighter"
    }
  },
  active: {
    false: {
      bg: "$secondary_dim"
    }
  }
};
var IconSection = styled(IconButton_default, {
  w: "unset",
  h: "$14",
  p: "$4",
  r: "$1",
  bg: "transparent",
  borderTopRightRadius: "0 !important",
  borderColor: "$border_bright",
  borderBottomRightRadius: "0 !important",
  position: "relative",
  "&:not([disabled]):focus-visible": {
    zIndex: 1
  },
  "@md": {
    mx: 0,
    borderTopRightRadius: "$1 !important",
    borderBottomRightRadius: "$1 !important"
  },
  variants: __spreadProps(__spreadValues({}, variants), {
    hideOptions: {
      true: {
        borderTopRightRadius: "$1 !important",
        borderBottomRightRadius: "$1 !important"
      }
    }
  })
});
var OptionsSection = styled(IconButton_default, {
  w: "unset",
  h: "$14",
  p: "$4 $2",
  r: "$1",
  borderTopLeftRadius: "0 !important",
  borderColor: "$border_bright",
  borderBottomLeftRadius: "0 !important",
  borderLeftWidth: "0 !important",
  position: "relative",
  "&:not([disabled]):focus-visible": {
    zIndex: 1
  },
  "@md": {
    display: "none"
  },
  variants
});
var Icon2 = styled(Flex, {
  alignItems: "center",
  justifyContent: "center",
  color: "$on_primary_high",
  variants: {
    disabled: {
      true: {
        color: "$on_surface_low"
      }
    },
    active: {
      true: {
        color: "$on_surface_high"
      }
    }
  }
});
var IconButtonWithOptions = ({
  disabled = false,
  onDisabledClick = () => {
    return;
  },
  testid = "",
  tooltipMessage = "",
  icon,
  children,
  active,
  hideOptions = false,
  onClick = () => {
    return;
  }
}) => {
  const commonProps = { disabled, active };
  return /* @__PURE__ */ React27.createElement(Flex, null, /* @__PURE__ */ React27.createElement(
    IconSection,
    __spreadProps(__spreadValues({
      "data-testid": testid
    }, commonProps), {
      onClick,
      hideOptions,
      className: "__cancel-drag-event"
    }),
    /* @__PURE__ */ React27.createElement(Tooltip, { disabled: !tooltipMessage, title: tooltipMessage }, /* @__PURE__ */ React27.createElement(Icon2, __spreadValues({}, commonProps), icon))
  ), !hideOptions && children ? /* @__PURE__ */ React27.createElement(Dropdown.Root, null, /* @__PURE__ */ React27.createElement(
    Dropdown.Trigger,
    {
      asChild: true,
      onPointerDown: (e) => {
        if (disabled) {
          e.preventDefault();
          onDisabledClick();
        }
      }
    },
    /* @__PURE__ */ React27.createElement(OptionsSection, __spreadValues({}, commonProps), /* @__PURE__ */ React27.createElement(Tooltip, { title: "View Options" }, /* @__PURE__ */ React27.createElement(Icon2, __spreadValues({}, commonProps), /* @__PURE__ */ React27.createElement(VerticalMenuIcon, null))))
  ), /* @__PURE__ */ React27.createElement(
    Dropdown.Content,
    {
      sideOffset: 5,
      alignOffset: -44,
      align: "start",
      side: "top",
      css: {
        w: 344,
        maxWidth: "100%",
        maxHeight: "unset",
        p: 0,
        border: "none",
        bg: "$surface_dim"
      }
    },
    children
  )) : null);
};

// src/Prebuilt/components/MoreSettings/ActionTile.jsx
init_define_process_env();
import React28 from "react";
var ActionTileRoot = (_a8) => {
  var _b7 = _a8, { active, disabled = false, children, onClick } = _b7, props = __objRest(_b7, ["active", "disabled", "children", "onClick"]);
  return /* @__PURE__ */ React28.createElement(
    Flex,
    __spreadProps(__spreadValues({}, props), {
      css: {
        flexDirection: "column",
        alignItems: "center",
        p: "$4 $2",
        position: "relative",
        bg: active ? "$surface_bright" : "",
        color: disabled ? "$on_surface_low" : "$on_surface_high",
        gap: "$4",
        r: "$1",
        "&:hover": {
          bg: "$surface_bright"
        }
      },
      onClick: () => {
        if (!disabled) {
          onClick();
        }
      }
    }),
    children
  );
};
var ActionTileCount = styled(Text, {
  position: "absolute",
  top: 0,
  right: 0,
  fontWeight: "$semiBold",
  color: "$on_surface_high",
  p: "$1 $2",
  minWidth: "$9",
  textAlign: "center",
  boxSizing: "border-box",
  bg: "$surface_bright",
  r: "$round",
  letterSpacing: "1.5px",
  fontSize: "$tiny !important",
  lineHeight: "$tiny !important"
});
var ActionTileTitle = styled(Text, {
  fontWeight: "$semiBold",
  color: "inherit",
  textAlign: "center",
  fontSize: "$xs !important"
});
var ActionTile = {
  Root: ActionTileRoot,
  Title: ActionTileTitle,
  Count: ActionTileCount
};

// src/Prebuilt/components/Settings/SettingsModal.jsx
init_define_process_env();
import React33, { useCallback as useCallback8, useEffect as useEffect10, useState as useState9 } from "react";
import { useMedia as useMedia2 } from "react-use";
import { ChevronLeftIcon, CrossIcon as CrossIcon3, GridFourIcon, NotificationsIcon, SettingsIcon } from "@100mslive/react-icons";

// src/Sheet/index.ts
init_define_process_env();

// src/Sheet/Sheet.tsx
init_define_process_env();
import React29 from "react";
import * as DialogPrimitive2 from "@radix-ui/react-dialog";
var SheetRoot = styled(DialogPrimitive2.Root, {
  minHeight: "240px",
  maxWidth: "100%"
});
var SheetTrigger = styled(DialogPrimitive2.Trigger, {
  appearance: "none !important"
  // Needed for safari it shows white overlay
});
var StyledOverlay = styled(Dialog.Overlay, {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  '&[data-state="open"]': {
    animation: `${sheetFadeIn} 150ms cubic-bezier(0.22, 1, 0.36, 1)`
  },
  '&[data-state="closed"]': {
    animation: `${sheetFadeOut} 150ms cubic-bezier(0.22, 1, 0.36, 1)`
  }
});
var StyledContent6 = styled(DialogPrimitive2.Content, {
  color: "$on_surface_medium",
  backgroundColor: "$surface_default",
  borderTopLeftRadius: "$3",
  borderTopRightRadius: "$3",
  boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  position: "fixed",
  zIndex: 22,
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  maxHeight: "96%",
  // Among other things, prevents text alignment inconsistencies when dialog can't be centered in the viewport evenly.
  // Affects animated and non-animated dialogs alike.
  willChange: "transform",
  "&:focus": {
    outline: "none"
  },
  "@allowMotion": {
    '&[data-state="open"]': {
      animation: `${sheetSlideIn} 150ms cubic-bezier(0.22, 1, 0.36, 1)`
    },
    '&[data-state="closed"]': {
      animation: `${sheetSlideOut} 150ms cubic-bezier(0.22, 1, 0.36, 1)`
    }
  },
  "@ls": {
    maxWidth: "50%",
    margin: "0 auto"
  },
  variants: {
    side: {
      top: {
        $$transformValue: "translate3d(0,-100%,0)",
        bottom: "auto"
      },
      right: {
        $$transformValue: "translate3d(100%,0,0)",
        right: 0
      },
      bottom: {
        $$transformValue: "translate3d(0,100%,0)",
        bottom: 0,
        top: "auto"
      },
      left: {
        $$transformValue: "translate3d(-100%,0,0)",
        left: 0
      }
    }
  },
  defaultVariants: {
    side: "bottom"
  }
});
var SheetContent = React29.forwardRef(
  (_a8, forwardedRef) => {
    var _b7 = _a8, { children, container } = _b7, props = __objRest(_b7, ["children", "container"]);
    return /* @__PURE__ */ React29.createElement(Dialog.Portal, { container }, /* @__PURE__ */ React29.createElement(StyledOverlay, null), /* @__PURE__ */ React29.createElement(StyledContent6, __spreadProps(__spreadValues({}, props), { ref: forwardedRef }), children));
  }
);
var SheetClose = Dialog.Close;
var SheetTitle = styled(DialogPrimitive2.Title, {
  margin: 0
});
var SheetDescription = Dialog.Description;
var SheetDefaultCloseIcon = Dialog.DefaultClose;
var Sheet = {
  Root: SheetRoot,
  Trigger: SheetTrigger,
  Content: SheetContent,
  Description: SheetDescription,
  Title: SheetTitle,
  Close: SheetClose,
  DefaultClose: SheetDefaultCloseIcon
};

// src/Prebuilt/components/Settings/DeviceSettings.jsx
init_define_process_env();
import React31, { Fragment as Fragment2, useRef as useRef10, useState as useState8 } from "react";
import {
  DeviceType,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled2,
  selectLocalVideoTrackID,
  selectVideoTrackByID,
  useDevices,
  useHMSStore as useHMSStore8
} from "@100mslive/react-sdk";
import { MicOnIcon, SpeakerIcon, VideoOnIcon } from "@100mslive/react-icons";

// src/Prebuilt/primitives/DropdownTrigger.jsx
init_define_process_env();
import React30 from "react";
import { ChevronDownIcon as ChevronDownIcon2, ChevronUpIcon as ChevronUpIcon2 } from "@100mslive/react-icons";
var DialogDropdownTrigger = React30.forwardRef(({ title, css: css2, open, icon, titleCSS = {} }, ref) => {
  return /* @__PURE__ */ React30.createElement(
    Dropdown.Trigger,
    {
      asChild: true,
      "data-testid": `${title}_selector`,
      css: __spreadValues({
        border: "1px solid $border_bright",
        bg: "$surface_bright",
        r: "$1",
        p: "$6 $9",
        zIndex: 10
      }, css2),
      ref
    },
    /* @__PURE__ */ React30.createElement(
      Flex,
      {
        css: {
          display: "flex",
          justifyContent: "space-between",
          color: "$on_surface_high",
          w: "100%"
        }
      },
      icon,
      /* @__PURE__ */ React30.createElement(
        Text,
        {
          css: __spreadValues(__spreadProps(__spreadValues({
            color: "inherit"
          }, textEllipsis("90%")), {
            flex: "1 1 0",
            mx: icon ? "$6" : "0"
          }), titleCSS)
        },
        title
      ),
      open ? /* @__PURE__ */ React30.createElement(ChevronUpIcon2, null) : /* @__PURE__ */ React30.createElement(ChevronDownIcon2, null)
    )
  );
});

// src/Prebuilt/components/hooks/useAudioOutputTest.tsx
init_define_process_env();
import { useEffect as useEffect9, useRef as useRef9, useState as useState7 } from "react";
var useAudioOutputTest = ({ deviceId }) => {
  const audioRef = useRef9(null);
  const [playing, setPlaying] = useState7(false);
  useEffect9(() => {
    if (audioRef.current && deviceId) {
      try {
        if (typeof audioRef.current.setSinkId !== "undefined") {
          audioRef.current.setSinkId(deviceId);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [deviceId]);
  return { playing, setPlaying, audioRef };
};

// src/Prebuilt/components/hooks/useDropdownSelection.jsx
init_define_process_env();
var useDropdownSelection = () => {
  return "$surface_bright";
};

// src/Prebuilt/components/Settings/DeviceSettings.jsx
var Settings = ({ setHide }) => {
  var _a8;
  const { allDevices, selectedDeviceIDs, updateDevice } = useDevices();
  const { videoInput, audioInput, audioOutput } = allDevices;
  const videoTrackId = useHMSStore8(selectLocalVideoTrackID);
  const isVideoOn = useHMSStore8(selectIsLocalVideoEnabled2);
  const shouldShowAudioOutput = "setSinkId" in HTMLMediaElement.prototype;
  const mirrorLocalVideo = useUISettings(UI_SETTINGS.mirrorLocalVideo);
  const trackSelector = selectVideoTrackByID(videoTrackId);
  const track = useHMSStore8(trackSelector);
  const audioOutputFiltered = (_a8 = audioOutput == null ? void 0 : audioOutput.filter((item) => !!item.label)) != null ? _a8 : [];
  if (!(videoInput == null ? void 0 : videoInput.length) && !(audioInput == null ? void 0 : audioInput.length) && !(audioOutputFiltered == null ? void 0 : audioOutputFiltered.length)) {
    setHide(true);
  }
  return /* @__PURE__ */ React31.createElement(Box, { className: settingOverflow() }, (videoInput == null ? void 0 : videoInput.length) ? /* @__PURE__ */ React31.createElement(Fragment2, null, isVideoOn && /* @__PURE__ */ React31.createElement(
    StyledVideoTile.Container,
    {
      css: {
        w: "90%",
        px: "$10",
        height: "$48",
        bg: "transparent",
        m: "$10 auto"
      }
    },
    /* @__PURE__ */ React31.createElement(Video, { trackId: videoTrackId, mirror: (track == null ? void 0 : track.facingMode) !== "environment" && mirrorLocalVideo })
  ), /* @__PURE__ */ React31.createElement(
    DeviceSelector,
    {
      title: "Video",
      devices: videoInput,
      icon: /* @__PURE__ */ React31.createElement(VideoOnIcon, null),
      selection: selectedDeviceIDs.videoInput,
      onChange: (deviceId) => updateDevice({
        deviceId,
        deviceType: DeviceType.videoInput
      })
    }
  )) : null, (audioInput == null ? void 0 : audioInput.length) ? /* @__PURE__ */ React31.createElement(
    DeviceSelector,
    {
      title: shouldShowAudioOutput ? "Microphone" : "Audio",
      icon: /* @__PURE__ */ React31.createElement(MicOnIcon, null),
      devices: audioInput,
      selection: selectedDeviceIDs.audioInput,
      onChange: (deviceId) => updateDevice({
        deviceId,
        deviceType: DeviceType.audioInput
      })
    }
  ) : null, (audioOutputFiltered == null ? void 0 : audioOutputFiltered.length) && shouldShowAudioOutput ? /* @__PURE__ */ React31.createElement(
    DeviceSelector,
    {
      title: "Speaker",
      icon: /* @__PURE__ */ React31.createElement(SpeakerIcon, null),
      devices: audioOutput,
      selection: selectedDeviceIDs.audioOutput,
      onChange: (deviceId) => updateDevice({
        deviceId,
        deviceType: DeviceType.audioOutput
      })
    },
    /* @__PURE__ */ React31.createElement(TestAudio, { id: selectedDeviceIDs.audioOutput })
  ) : null);
};
var DeviceSelector = ({ title, devices, selection, onChange, icon, children = null }) => {
  var _a8, _b7;
  const [open, setOpen] = useState8(false);
  const selectionBg = useDropdownSelection();
  const ref = useRef10(null);
  return /* @__PURE__ */ React31.createElement(Box, { css: { mb: "$10" } }, /* @__PURE__ */ React31.createElement(Text, { css: { mb: "$4" } }, title), /* @__PURE__ */ React31.createElement(
    Flex,
    {
      align: "center",
      css: {
        gap: "$4",
        "@md": {
          flexDirection: children ? "column" : "row",
          alignItems: children ? "start" : "center"
        }
      }
    },
    /* @__PURE__ */ React31.createElement(
      Box,
      {
        css: {
          position: "relative",
          flex: "1 1 0",
          minWidth: 0,
          w: "100%",
          maxWidth: "100%",
          "@md": {
            mb: children ? "$8" : 0
          }
        }
      },
      /* @__PURE__ */ React31.createElement(Dropdown.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React31.createElement(
        DialogDropdownTrigger,
        {
          ref,
          icon,
          title: ((_a8 = devices.find(({ deviceId }) => deviceId === selection)) == null ? void 0 : _a8.label) || "Select device from list",
          open
        }
      ), /* @__PURE__ */ React31.createElement(Dropdown.Portal, null, /* @__PURE__ */ React31.createElement(Dropdown.Content, { align: "start", sideOffset: 8, css: { w: (_b7 = ref.current) == null ? void 0 : _b7.clientWidth, zIndex: 1001 } }, devices.map((device) => {
        return /* @__PURE__ */ React31.createElement(
          Dropdown.Item,
          {
            key: device.label,
            onSelect: () => onChange(device.deviceId),
            css: {
              px: "$9",
              bg: device.deviceId === selection ? selectionBg : void 0
            }
          },
          device.label
        );
      }))))
    ),
    children
  ));
};
var TestAudio = ({ id }) => {
  const { playing, setPlaying, audioRef } = useAudioOutputTest({ deviceId: id });
  return /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(
    Button,
    {
      variant: "standard",
      css: {
        flexShrink: 0,
        p: "$6 $9",
        "@md": {
          w: "100%"
        }
      },
      onClick: () => {
        var _a8;
        return (_a8 = audioRef.current) == null ? void 0 : _a8.play();
      },
      disabled: playing
    },
    /* @__PURE__ */ React31.createElement(SpeakerIcon, null),
    "\xA0Test",
    " ",
    /* @__PURE__ */ React31.createElement(Text, { as: "span", css: { display: "none", "@md": { display: "inline" } } }, "\xA0 speaker")
  ), /* @__PURE__ */ React31.createElement(
    "audio",
    {
      ref: audioRef,
      src: TEST_AUDIO_URL,
      onEnded: () => setPlaying(false),
      onPlay: () => setPlaying(true),
      css: { display: "none" }
    }
  ));
};
var DeviceSettings_default = Settings;

// src/Prebuilt/components/Settings/NotificationSettings.tsx
init_define_process_env();
import React32 from "react";
import { AlertOctagonIcon, HandIcon, PeopleAddIcon, PeopleRemoveIcon } from "@100mslive/react-icons";
var NotificationItem = ({
  type,
  label,
  icon,
  checked
}) => {
  const [, setSubscribedNotifications] = useSetSubscribedNotifications(type);
  return /* @__PURE__ */ React32.createElement(
    SwitchWithLabel_default,
    {
      label,
      id: type,
      icon,
      checked,
      onChange: (value) => {
        setSubscribedNotifications(value);
      }
    }
  );
};
var NotificationSettings = () => {
  const subscribedNotifications = useSubscribedNotifications();
  return /* @__PURE__ */ React32.createElement(Box, { className: settingOverflow() }, /* @__PURE__ */ React32.createElement(
    NotificationItem,
    {
      label: "Peer Joined",
      type: SUBSCRIBED_NOTIFICATIONS.PEER_JOINED,
      icon: /* @__PURE__ */ React32.createElement(PeopleAddIcon, null),
      checked: subscribedNotifications.PEER_JOINED
    }
  ), /* @__PURE__ */ React32.createElement(
    NotificationItem,
    {
      label: "Peer Leave",
      type: SUBSCRIBED_NOTIFICATIONS.PEER_LEFT,
      icon: /* @__PURE__ */ React32.createElement(PeopleRemoveIcon, null),
      checked: subscribedNotifications.PEER_LEFT
    }
  ), /* @__PURE__ */ React32.createElement(
    NotificationItem,
    {
      label: "Hand Raised",
      type: SUBSCRIBED_NOTIFICATIONS.METADATA_UPDATED,
      icon: /* @__PURE__ */ React32.createElement(HandIcon, null),
      checked: subscribedNotifications.METADATA_UPDATED
    }
  ), /* @__PURE__ */ React32.createElement(
    NotificationItem,
    {
      label: "Error",
      type: SUBSCRIBED_NOTIFICATIONS.ERROR,
      icon: /* @__PURE__ */ React32.createElement(AlertOctagonIcon, null),
      checked: subscribedNotifications.ERROR
    }
  ));
};

// src/Prebuilt/components/Settings/SettingsModal.jsx
var settingsList = [
  {
    tabName: "devices",
    title: "Device Settings",
    icon: SettingsIcon,
    content: DeviceSettings_default
  },
  {
    tabName: "notifications",
    title: "Notifications",
    icon: NotificationsIcon,
    content: NotificationSettings
  },
  {
    tabName: "layout",
    title: "Layout",
    icon: GridFourIcon,
    content: LayoutSettings
  }
];
var SettingsModal = ({ open, onOpenChange, screenType, children = /* @__PURE__ */ React33.createElement(React33.Fragment, null) }) => {
  const mediaQueryLg = config.media.md;
  const isMobile = useMedia2(mediaQueryLg);
  const [showSetting, setShowSetting] = useState9(
    () => settingsList.reduce((obj, { tabName }) => __spreadProps(__spreadValues({}, obj), { [tabName]: true }), {})
  );
  const hideSettingByTabName = useCallback8(
    (key) => (hide) => setShowSetting((prev) => __spreadProps(__spreadValues({}, prev), { [key]: !hide })),
    [setShowSetting]
  );
  useEffect10(() => {
    if (screenType === "hls_live_streaming") {
      hideSettingByTabName("layout")(true);
    }
  }, [screenType, hideSettingByTabName]);
  const [selection, setSelection] = useState9(() => {
    var _a8;
    return (_a8 = Object.keys(showSetting).find((key) => showSetting[key])) != null ? _a8 : "";
  });
  const resetSelection = useCallback8(() => {
    setSelection("");
  }, []);
  useEffect10(() => {
    var _a8;
    if (isMobile) {
      setSelection("");
    } else {
      const firstNotHiddenTabName = (_a8 = Object.keys(showSetting).find((key) => showSetting[key])) != null ? _a8 : "";
      setSelection(firstNotHiddenTabName);
    }
  }, [isMobile, showSetting]);
  return isMobile ? /* @__PURE__ */ React33.createElement(
    MobileSettingModal,
    {
      open,
      onOpenChange,
      selection,
      setSelection,
      showSetting,
      hideSettingByTabName,
      resetSelection
    },
    children
  ) : /* @__PURE__ */ React33.createElement(
    DesktopSettingModal,
    {
      open,
      onOpenChange,
      selection,
      setSelection,
      showSetting,
      hideSettingByTabName,
      resetSelection
    },
    children
  );
};
var MobileSettingModal = ({
  open,
  onOpenChange,
  selection,
  setSelection,
  showSetting,
  hideSettingByTabName,
  resetSelection,
  children = /* @__PURE__ */ React33.createElement(React33.Fragment, null)
}) => {
  return /* @__PURE__ */ React33.createElement(Sheet.Root, { open, onOpenChange }, /* @__PURE__ */ React33.createElement(Sheet.Trigger, { asChild: true }, children), /* @__PURE__ */ React33.createElement(
    Sheet.Content,
    {
      css: {
        bg: "$surface_dim",
        overflowY: "auto"
      }
    },
    /* @__PURE__ */ React33.createElement(Sheet.Title, { css: { py: "$10", px: "$8", alignItems: "center" } }, /* @__PURE__ */ React33.createElement(Flex, { direction: "row", justify: "between", css: { w: "100%" } }, !selection ? /* @__PURE__ */ React33.createElement(Text, { variant: "h6", css: { display: "flex" } }, "Settings") : /* @__PURE__ */ React33.createElement(Text, { variant: "h6", css: { display: "flex" } }, /* @__PURE__ */ React33.createElement(Box, { as: "span", css: { r: "$round", mr: "$2" }, onClick: resetSelection }, /* @__PURE__ */ React33.createElement(ChevronLeftIcon, null)), (selection == null ? void 0 : selection.charAt(0).toUpperCase()) + selection.slice(1)), /* @__PURE__ */ React33.createElement(Sheet.Close, null, /* @__PURE__ */ React33.createElement(IconButton, { as: "div", "data-testid": "dialog_cross_icon" }, /* @__PURE__ */ React33.createElement(CrossIcon3, null))))),
    /* @__PURE__ */ React33.createElement(HorizontalDivider, null),
    !selection ? /* @__PURE__ */ React33.createElement(
      Flex,
      {
        direction: "column",
        css: {
          pb: "$8",
          overflowY: "auto"
        }
      },
      settingsList.filter(({ tabName }) => showSetting[tabName]).map(({ icon: Icon4, tabName, title }) => {
        return /* @__PURE__ */ React33.createElement(
          Box,
          {
            key: tabName,
            value: tabName,
            onClick: () => {
              setSelection(tabName);
            },
            as: "div",
            css: {
              all: "unset",
              fontFamily: "$sans",
              p: "$10 $8",
              display: "flex",
              alignItems: "center",
              fontSize: "$sm",
              lineHeight: "$sm",
              color: "$on_surface_high",
              userSelect: "none",
              gap: "$8",
              cursor: "pointer",
              "&:hover": {
                bg: "$surface_brighter",
                r: "$1",
                gap: "$8",
                border: "none"
              },
              borderBottom: "1px solid $border_default"
            }
          },
          /* @__PURE__ */ React33.createElement(Icon4, null),
          title
        );
      })
    ) : /* @__PURE__ */ React33.createElement(
      Box,
      {
        direction: "column",
        css: { overflowY: "scroll", px: "$8", py: "$10", maxHeight: "70vh", overflowX: "hidden" }
      },
      settingsList.filter(({ tabName }) => showSetting[tabName] && selection === tabName).map(({ content: Content11, title, tabName }) => {
        return /* @__PURE__ */ React33.createElement(Content11, { key: title, setHide: hideSettingByTabName(tabName) });
      })
    )
  ));
};
var DesktopSettingModal = ({
  open,
  onOpenChange,
  selection,
  setSelection,
  showSetting,
  hideSettingByTabName,
  resetSelection,
  children = /* @__PURE__ */ React33.createElement(React33.Fragment, null)
}) => {
  return /* @__PURE__ */ React33.createElement(Dialog.Root, { open, onOpenChange }, /* @__PURE__ */ React33.createElement(Dialog.Trigger, { asChild: true }, children), /* @__PURE__ */ React33.createElement(Dialog.Portal, null, /* @__PURE__ */ React33.createElement(Dialog.Overlay, null), /* @__PURE__ */ React33.createElement(
    Dialog.Content,
    {
      css: {
        w: "min(800px, 90%)",
        height: "min(656px, 90%)",
        p: 0,
        r: "$4"
      }
    },
    /* @__PURE__ */ React33.createElement(
      Tabs.Root,
      {
        value: selection,
        activationMode: "automatic",
        onValueChange: setSelection,
        css: { size: "100%", position: "relative" }
      },
      /* @__PURE__ */ React33.createElement(
        Tabs.List,
        {
          css: {
            w: "18.625rem",
            flexDirection: "column",
            bg: "$background_default",
            p: "$14 $10",
            borderTopLeftRadius: "$4",
            borderBottomLeftRadius: "$4"
          }
        },
        /* @__PURE__ */ React33.createElement(Text, { variant: "h5" }, "Settings "),
        /* @__PURE__ */ React33.createElement(Flex, { direction: "column", css: { mx: 0, overflowY: "auto", pt: "$10" } }, settingsList.filter(({ tabName }) => showSetting[tabName]).map(({ icon: Icon4, tabName, title }) => {
          return /* @__PURE__ */ React33.createElement(Tabs.Trigger, { key: tabName, value: tabName, css: { gap: "$8" } }, /* @__PURE__ */ React33.createElement(Icon4, null), title);
        }))
      ),
      selection && /* @__PURE__ */ React33.createElement(
        Flex,
        {
          direction: "column",
          css: {
            flex: "1 1 0",
            minWidth: 0,
            mr: "$4"
          }
        },
        settingsList.filter(({ tabName }) => showSetting[tabName]).map(({ content: Content11, title, tabName }) => {
          return /* @__PURE__ */ React33.createElement(Tabs.Content, { key: tabName, value: tabName, className: settingContent() }, /* @__PURE__ */ React33.createElement(SettingsContentHeader, { onBack: resetSelection, isMobile: false }, title), /* @__PURE__ */ React33.createElement(Content11, { setHide: hideSettingByTabName(tabName) }));
        })
      )
    ),
    /* @__PURE__ */ React33.createElement(Dialog.Close, { css: { position: "absolute", right: "$10", top: "$10" } }, /* @__PURE__ */ React33.createElement(IconButton, { as: "div", "data-testid": "dialog_cross_icon" }, /* @__PURE__ */ React33.createElement(CrossIcon3, null)))
  )));
};
var SettingsContentHeader = ({ children, isMobile, onBack }) => {
  return /* @__PURE__ */ React33.createElement(Text, { variant: "h6", css: { mb: "$12", display: "flex", alignItems: "center" } }, isMobile && /* @__PURE__ */ React33.createElement(Box, { as: "span", css: { bg: "$surface_bright", mr: "$4", r: "$round", p: "$2" }, onClick: onBack }, /* @__PURE__ */ React33.createElement(ChevronLeftIcon, null)), children);
};
var SettingsModal_default = SettingsModal;

// src/Prebuilt/components/AudioVideoToggle.tsx
var krispPlugin = new HMSKrispPlugin();
var Options = ({
  options,
  selectedDeviceId,
  onClick
}) => {
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, options == null ? void 0 : options.map((option) => /* @__PURE__ */ React34.createElement(
    Dropdown.Item,
    {
      key: option.label,
      css: {
        backgroundColor: "$surface_dim",
        p: "$4 $8",
        h: "$15",
        fontSize: "$xs",
        justifyContent: "space-between",
        color: selectedDeviceId === option.deviceId ? "$primary_bright" : ""
      },
      onClick: () => {
        onClick(option.deviceId);
      }
    },
    option.label,
    selectedDeviceId === option.deviceId ? /* @__PURE__ */ React34.createElement(CheckIcon, { width: 16, height: 16 }) : null
  )));
};
var OptionLabel = ({ children, icon }) => {
  return /* @__PURE__ */ React34.createElement(
    Dropdown.Label,
    {
      css: {
        h: "$16",
        p: "$4 $8",
        color: "$on_surface_medium",
        bg: "transparent",
        fontSize: "$xs",
        gap: "$4",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React34.createElement(Flex, { css: { alignItems: "center", justifyContent: "center", "& svg": { size: "$8" } } }, icon),
    " ",
    children
  );
};
var useNoiseCancellationWithPlugin = () => {
  var _a8;
  const actions = useHMSActions7();
  const [inProgress, setInProgress] = useState10(false);
  const [, setNoiseCancellationEnabled] = useSetNoiseCancellation();
  const isEnabledForRoom = (_a8 = useHMSStore9(selectRoom)) == null ? void 0 : _a8.isNoiseCancellationEnabled;
  const setNoiseCancellationWithPlugin = useCallback9(
    (enabled) => __async(void 0, null, function* () {
      if (!isEnabledForRoom || inProgress) {
        return;
      }
      if (!krispPlugin.checkSupport().isSupported) {
        throw Error("Krisp plugin is not supported");
      }
      setInProgress(true);
      if (enabled) {
        yield actions.addPluginToAudioTrack(krispPlugin);
      } else {
        yield actions.removePluginFromAudioTrack(krispPlugin);
      }
      setNoiseCancellationEnabled(enabled);
      setInProgress(false);
    }),
    [actions, inProgress, isEnabledForRoom, setNoiseCancellationEnabled]
  );
  return {
    setNoiseCancellationWithPlugin,
    inProgress
  };
};
var NoiseCancellation = ({
  actionTile,
  iconOnly,
  setOpenOptionsSheet
}) => {
  const localPeerAudioTrackID = useHMSStore9(selectLocalAudioTrackID);
  const isNoiseCancellationEnabled = useIsNoiseCancellationEnabled();
  const { setNoiseCancellationWithPlugin, inProgress } = useNoiseCancellationWithPlugin();
  const room = useHMSStore9(selectRoom);
  const isKrispPluginAdded = useHMSStore9(selectIsLocalAudioPluginPresent(krispPlugin.getName()));
  if (!krispPlugin.isSupported() || !room.isNoiseCancellationEnabled || !localPeerAudioTrackID) {
    return null;
  }
  if (actionTile) {
    return /* @__PURE__ */ React34.createElement(
      ActionTile.Root,
      {
        active: isNoiseCancellationEnabled && isKrispPluginAdded,
        disabled: inProgress,
        onClick: () => __async(void 0, null, function* () {
          yield setNoiseCancellationWithPlugin(!isNoiseCancellationEnabled);
          setOpenOptionsSheet == null ? void 0 : setOpenOptionsSheet(false);
        })
      },
      /* @__PURE__ */ React34.createElement(AudioLevelIcon, null),
      /* @__PURE__ */ React34.createElement(ActionTile.Title, null, isNoiseCancellationEnabled ? "Noise Reduced" : "Reduce Noise")
    );
  }
  if (iconOnly) {
    return /* @__PURE__ */ React34.createElement(Tooltip, { title: isNoiseCancellationEnabled ? "Noise Reduced" : "Reduce Noise" }, /* @__PURE__ */ React34.createElement(
      IconButton_default,
      {
        onClick: () => __async(void 0, null, function* () {
          yield setNoiseCancellationWithPlugin(!isNoiseCancellationEnabled);
        }),
        disabled: inProgress,
        css: {
          bg: isNoiseCancellationEnabled && isKrispPluginAdded ? "$surface_brighter" : "$background_dim",
          borderColor: isNoiseCancellationEnabled && isKrispPluginAdded ? "$border_brighter" : "$border_bright"
        }
      },
      /* @__PURE__ */ React34.createElement(AudioLevelIcon, null)
    ));
  }
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(Dropdown.ItemSeparator, { css: { mx: 0 } }), /* @__PURE__ */ React34.createElement(
    Dropdown.Item,
    {
      css: {
        p: "$4 $8",
        h: "$15",
        fontSize: "$xs",
        justifyContent: "space-between"
      },
      onClick: (e) => __async(void 0, null, function* () {
        e.preventDefault();
        yield setNoiseCancellationWithPlugin(!isNoiseCancellationEnabled);
      })
    },
    /* @__PURE__ */ React34.createElement(Text, { css: { display: "flex", alignItems: "center", gap: "$2", fontSize: "$xs", "& svg": { size: "$8" } } }, /* @__PURE__ */ React34.createElement(AudioLevelIcon, null), "Reduce Noise"),
    /* @__PURE__ */ React34.createElement(
      Switch,
      {
        id: "noise_cancellation",
        checked: isNoiseCancellationEnabled && isKrispPluginAdded,
        disabled: inProgress,
        onClick: (e) => e.stopPropagation(),
        onCheckedChange: (value) => __async(void 0, null, function* () {
          yield setNoiseCancellationWithPlugin(value);
        })
      }
    )
  ), /* @__PURE__ */ React34.createElement(Dropdown.ItemSeparator, { css: { mx: 0 } }));
};
var AudioOutputLabel = ({ deviceId }) => {
  const { playing, setPlaying, audioRef } = useAudioOutputTest({ deviceId });
  return /* @__PURE__ */ React34.createElement(OptionLabel, { icon: /* @__PURE__ */ React34.createElement(SpeakerIcon2, null) }, /* @__PURE__ */ React34.createElement(Box, { css: { flex: "1 1 0" } }, "Speakers"), /* @__PURE__ */ React34.createElement(
    Text,
    {
      variant: "xs",
      css: { color: "$primary_bright", "&:hover": { cursor: "pointer" } },
      onClick: () => __async(void 0, null, function* () {
        var _a8;
        if (playing) {
          return;
        }
        yield (_a8 = audioRef.current) == null ? void 0 : _a8.play();
      })
    },
    /* @__PURE__ */ React34.createElement(
      "audio",
      {
        ref: audioRef,
        src: TEST_AUDIO_URL,
        onEnded: () => setPlaying(false),
        onPlay: () => setPlaying(true),
        style: { display: "none" }
      }
    ),
    playing ? "Playing Sound..." : "Play Test Sound"
  ));
};
var AudioSettings = ({ onClick }) => {
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(
    Dropdown.Item,
    {
      css: {
        backgroundColor: "$surface_dim",
        p: "$4 $8",
        h: "$15",
        alignItems: "center",
        gap: "$2",
        fontSize: "$xs",
        "& svg": { size: "$8" }
      },
      onClick
    },
    /* @__PURE__ */ React34.createElement(SettingsIcon2, null),
    " Audio Settings"
  ));
};
var AudioVideoToggle = ({ hideOptions = false }) => {
  const { allDevices, selectedDeviceIDs, updateDevice } = useDevices2((error) => {
    ToastManager.addToast({
      title: error.message,
      variant: "error",
      duration: 2e3
    });
  });
  const { videoInput, audioInput, audioOutput } = allDevices;
  const localPeer = useHMSStore9(selectLocalPeer);
  const { isLocalVideoEnabled, isLocalAudioEnabled, toggleAudio, toggleVideo } = useAVToggle2();
  const actions = useHMSActions7();
  const vanillaStore = useHMSVanillaStore4();
  const videoTrackId = useHMSStore9(selectLocalVideoTrackID2);
  const localVideoTrack = useHMSStore9(selectVideoTrackByID2(videoTrackId));
  const roomState = useHMSStore9(selectRoomState3);
  const hasAudioDevices = Number(audioInput == null ? void 0 : audioInput.length) > 0;
  const hasVideoDevices = Number(videoInput == null ? void 0 : videoInput.length) > 0;
  const shouldShowAudioOutput = "setSinkId" in HTMLMediaElement.prototype && Number(audioOutput == null ? void 0 : audioOutput.length) > 0;
  const { screenType } = useRoomLayoutConferencingScreen();
  const [showSettings, setShowSettings] = useState10(false);
  const isKrispPluginAdded = useHMSStore9(selectIsLocalAudioPluginPresent(krispPlugin.getName()));
  const isNoiseCancellationEnabled = useIsNoiseCancellationEnabled();
  const { setNoiseCancellationWithPlugin, inProgress } = useNoiseCancellationWithPlugin();
  const showMuteIcon = !isLocalAudioEnabled || !toggleAudio;
  useEffect11(() => {
    (() => __async(void 0, null, function* () {
      var _a8;
      const isEnabledForRoom = (_a8 = vanillaStore.getState(selectRoom)) == null ? void 0 : _a8.isNoiseCancellationEnabled;
      if (isEnabledForRoom && isNoiseCancellationEnabled && !isKrispPluginAdded && !inProgress && (localPeer == null ? void 0 : localPeer.audioTrack)) {
        try {
          yield setNoiseCancellationWithPlugin(true);
          ToastManager.addToast({
            title: `Noise Reduction Enabled`,
            variant: "standard",
            duration: 2e3,
            icon: /* @__PURE__ */ React34.createElement(AudioLevelIcon, null)
          });
        } catch (error) {
          console.error(error);
        }
      }
    }))();
  }, [isNoiseCancellationEnabled, localPeer == null ? void 0 : localPeer.audioTrack, inProgress]);
  if (!toggleAudio && !toggleVideo) {
    return null;
  }
  return /* @__PURE__ */ React34.createElement(Fragment3, null, toggleAudio ? /* @__PURE__ */ React34.createElement(
    IconButtonWithOptions,
    {
      disabled: !toggleAudio,
      hideOptions: hideOptions || !hasAudioDevices,
      onDisabledClick: toggleAudio,
      testid: "audio_toggle_btn",
      tooltipMessage: `Turn ${isLocalAudioEnabled ? "off" : "on"} audio (${isMacOS ? "\u2318" : "ctrl"} + d)`,
      icon: !isLocalAudioEnabled ? /* @__PURE__ */ React34.createElement(MicOffIcon, null) : /* @__PURE__ */ React34.createElement(MicOnIcon2, null),
      active: isLocalAudioEnabled,
      onClick: toggleAudio,
      key: "toggleAudio"
    },
    /* @__PURE__ */ React34.createElement(Dropdown.Group, null, /* @__PURE__ */ React34.createElement(OptionLabel, { icon: /* @__PURE__ */ React34.createElement(MicOnIcon2, null) }, /* @__PURE__ */ React34.createElement(Box, { css: { flex: "1 1 0" } }, !shouldShowAudioOutput ? "Audio" : "Microphone"), !showMuteIcon && /* @__PURE__ */ React34.createElement(AudioLevel, { trackId: localPeer == null ? void 0 : localPeer.audioTrack })), /* @__PURE__ */ React34.createElement(
      Options,
      {
        options: audioInput,
        selectedDeviceId: selectedDeviceIDs.audioInput,
        onClick: (deviceId) => updateDevice({ deviceId, deviceType: DeviceType2.audioInput })
      }
    )),
    /* @__PURE__ */ React34.createElement(Dropdown.ItemSeparator, { css: { mx: 0 } }),
    shouldShowAudioOutput && /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(AudioOutputLabel, { deviceId: selectedDeviceIDs.audioOutput || "" }), /* @__PURE__ */ React34.createElement(Dropdown.Group, null, /* @__PURE__ */ React34.createElement(
      Options,
      {
        options: audioOutput,
        selectedDeviceId: selectedDeviceIDs.audioOutput,
        onClick: (deviceId) => updateDevice({ deviceId, deviceType: DeviceType2.audioOutput })
      }
    ))),
    /* @__PURE__ */ React34.createElement(NoiseCancellation, null),
    /* @__PURE__ */ React34.createElement(AudioSettings, { onClick: () => setShowSettings(true) })
  ) : null, toggleVideo ? /* @__PURE__ */ React34.createElement(
    IconButtonWithOptions,
    {
      disabled: !toggleVideo,
      hideOptions: hideOptions || !hasVideoDevices,
      onDisabledClick: toggleVideo,
      tooltipMessage: `Turn ${isLocalVideoEnabled ? "off" : "on"} video (${isMacOS ? "\u2318" : "ctrl"} + e)`,
      testid: "video_toggle_btn",
      icon: !isLocalVideoEnabled ? /* @__PURE__ */ React34.createElement(VideoOffIcon, null) : /* @__PURE__ */ React34.createElement(VideoOnIcon2, null),
      key: "toggleVideo",
      active: isLocalVideoEnabled,
      onClick: toggleVideo
    },
    /* @__PURE__ */ React34.createElement(
      Options,
      {
        options: videoInput,
        selectedDeviceId: selectedDeviceIDs.videoInput,
        onClick: (deviceId) => updateDevice({ deviceId, deviceType: DeviceType2.videoInput })
      }
    )
  ) : null, (localVideoTrack == null ? void 0 : localVideoTrack.facingMode) && roomState === HMSRoomState3.Preview && (isIOS || isAndroid) ? /* @__PURE__ */ React34.createElement(Tooltip, { title: "Switch Camera", key: "switchCamera" }, /* @__PURE__ */ React34.createElement(
    IconButton_default,
    {
      onClick: () => __async(void 0, null, function* () {
        try {
          yield actions.switchCamera();
        } catch (e) {
          ToastManager.addToast({
            title: `Error while flipping camera ${e.message || ""}`,
            variant: "error"
          });
        }
      })
    },
    /* @__PURE__ */ React34.createElement(CameraFlipIcon, null)
  )) : null, showSettings && /* @__PURE__ */ React34.createElement(SettingsModal_default, { open: showSettings, onOpenChange: () => setShowSettings(false), screenType }));
};

// src/Prebuilt/components/CaptionIcon.tsx
init_define_process_env();
import React35 from "react";
import { selectIsTranscriptionEnabled, useHMSStore as useHMSStore10 } from "@100mslive/react-sdk";
import { ClosedCaptionIcon, OpenCaptionIcon } from "@100mslive/react-icons";
var CaptionIcon = () => {
  const isCaptionPresent = useHMSStore10(selectIsTranscriptionEnabled);
  const [isCaption, setIsCaption] = useSetIsCaptionEnabled();
  const onClick = () => {
    setIsCaption(!isCaption);
  };
  if (!isCaptionPresent) {
    return null;
  }
  return /* @__PURE__ */ React35.createElement(Tooltip, { title: isCaption ? "Hide closed captions" : "Show closed captions" }, /* @__PURE__ */ React35.createElement(IconButton_default, { "data-testid": "caption_btn", onClick }, isCaption ? /* @__PURE__ */ React35.createElement(ClosedCaptionIcon, { width: "20", height: "20px" }) : /* @__PURE__ */ React35.createElement(OpenCaptionIcon, { width: "20", height: "20px" })));
};

// src/Prebuilt/components/EmojiReaction.jsx
init_define_process_env();
import React37, { useState as useState12 } from "react";
import { useMedia as useMedia4 } from "react-use";
import data from "@emoji-mart/data/sets/14/apple.json";
import { init } from "emoji-mart";
import {
  selectAvailableRoleNames as selectAvailableRoleNames2,
  selectIsConnectedToRoom as selectIsConnectedToRoom2,
  selectLocalPeerID,
  useCustomEvent,
  useHMSStore as useHMSStore12
} from "@100mslive/react-sdk";
import { EmojiIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Footer/EmojiCard.jsx
init_define_process_env();
import React36 from "react";
var emojiReactionList = [
  [{ emojiId: "+1" }, { emojiId: "-1" }, { emojiId: "wave" }, { emojiId: "clap" }, { emojiId: "fire" }],
  [{ emojiId: "tada" }, { emojiId: "heart_eyes" }, { emojiId: "joy" }, { emojiId: "open_mouth" }, { emojiId: "sob" }]
];
var EmojiCard = ({ sendReaction }) => {
  return emojiReactionList.map((emojiLine, index) => /* @__PURE__ */ React36.createElement(Flex, { key: index, justify: "between", css: { mb: "$8" } }, emojiLine.map((emoji) => /* @__PURE__ */ React36.createElement(EmojiContainer, { key: emoji.emojiId, onClick: () => sendReaction(emoji.emojiId) }, /* @__PURE__ */ React36.createElement("em-emoji", { id: emoji.emojiId, size: "100%", set: "apple" })))));
};
var EmojiContainer = styled("span", {
  position: "relative",
  cursor: "pointer",
  width: "$16",
  height: "$16",
  p: "$4",
  "&:hover": {
    p: "7px",
    bg: "$surface_brighter",
    borderRadius: "$1"
  }
});

// src/Prebuilt/components/hooks/useDropdownList.ts
init_define_process_env();
import { useEffect as useEffect12 } from "react";
var useDropdownList = ({ name, open }) => {
  const [dropdownList = [], setDropdownList] = useSetAppDataByKey(APP_DATA.dropdownList);
  useEffect12(() => {
    if (open) {
      if (!dropdownList.includes(name)) {
        setDropdownList([...dropdownList, name]);
      }
    } else {
      const index = dropdownList.indexOf(name);
      if (index >= 0) {
        const newDropdownList = [...dropdownList];
        newDropdownList.splice(index, 1);
        setDropdownList(newDropdownList);
      }
    }
  }, [open, name]);
};

// src/Prebuilt/common/hooks.ts
init_define_process_env();
import { useCallback as useCallback10, useEffect as useEffect13, useMemo as useMemo5, useRef as useRef11, useState as useState11 } from "react";
import { useMedia as useMedia3 } from "react-use";
import { JoinForm_JoinBtnType as JoinForm_JoinBtnType2 } from "@100mslive/types-prebuilt/elements/join_form";
import {
  parsedUserAgent as parsedUserAgent3,
  selectAvailableRoleNames,
  selectIsAllowedToPublish,
  selectIsConnectedToRoom,
  selectLocalPeerRole,
  selectPeerCount as selectPeerCount2,
  selectPeerMetadata,
  selectPeers,
  selectPeersByRoles,
  selectRecordingState,
  selectRemotePeers,
  selectRolesMap,
  useHMSActions as useHMSActions8,
  useHMSStore as useHMSStore11,
  useHMSVanillaStore as useHMSVanillaStore5
} from "@100mslive/react-sdk";
var useFilteredRoles = () => {
  var _a8;
  const { elements } = useRoomLayoutConferencingScreen();
  return ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.roles_whitelist) || [];
};
var useDefaultChatSelection = () => {
  var _a8;
  const { elements } = useRoomLayoutConferencingScreen();
  const roles = useFilteredRoles();
  if ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.public_chat_enabled) {
    return CHAT_SELECTOR.EVERYONE;
  }
  if (roles.length > 0) {
    return roles[0];
  }
  return "";
};
var useShowStreamingUI = () => {
  var _a8, _b7, _c;
  const layout = useRoomLayout();
  const { join_form } = ((_c = (_b7 = (_a8 = layout == null ? void 0 : layout.screens) == null ? void 0 : _a8.preview) == null ? void 0 : _b7.default) == null ? void 0 : _c.elements) || {};
  return (join_form == null ? void 0 : join_form.join_btn_type) === JoinForm_JoinBtnType2.JOIN_BTN_TYPE_JOIN_AND_GO_LIVE;
};
var useParticipants = (params) => {
  var _a8;
  const isConnected = useHMSStore11(selectIsConnectedToRoom);
  const peerCount = useHMSStore11(selectPeerCount2);
  const availableRoles = useHMSStore11(selectAvailableRoleNames);
  let participantList = useHMSStore11(isConnected ? selectPeers : selectRemotePeers);
  const rolesWithParticipants = Array.from(new Set(participantList.map((peer) => peer.roleName)));
  const vanillaStore = useHMSVanillaStore5();
  if ((_a8 = params == null ? void 0 : params.metadata) == null ? void 0 : _a8.isHandRaised) {
    participantList = participantList.filter((peer) => {
      return vanillaStore.getState(selectPeerMetadata(peer.id)).isHandRaised;
    });
  }
  if ((params == null ? void 0 : params.role) && availableRoles.includes(params.role)) {
    participantList = participantList.filter((peer) => peer.roleName === params.role);
  }
  if (params == null ? void 0 : params.search) {
    const search = params.search;
    participantList = participantList.filter((peer) => peer.name.toLowerCase().includes(search));
  }
  return { participants: participantList, isConnected, peerCount, rolesWithParticipants };
};
var useIsLandscape = () => {
  const isMobile = parsedUserAgent3.getDevice().type === "mobile";
  const isLandscape = useMedia3(config.media.ls);
  return isMobile && isLandscape;
};
var useLandscapeHLSStream = () => {
  const isLandscape = useIsLandscape();
  const { screenType } = useRoomLayoutConferencingScreen();
  return isLandscape && screenType === "hls_live_streaming";
};
var useMobileHLSStream = () => {
  const isMobile = useMedia3(config.media.md);
  const { screenType } = useRoomLayoutConferencingScreen();
  return isMobile && screenType === "hls_live_streaming";
};
var useKeyboardHandler = (isPaused, hlsPlayer2) => {
  const handleKeyEvent = useCallback10(
    (event) => __async(void 0, null, function* () {
      switch (event.key) {
        case " ":
          if (isPaused) {
            yield hlsPlayer2 == null ? void 0 : hlsPlayer2.play();
          } else {
            hlsPlayer2 == null ? void 0 : hlsPlayer2.pause();
          }
          break;
        case "ArrowRight":
          hlsPlayer2 == null ? void 0 : hlsPlayer2.seekTo((hlsPlayer2 == null ? void 0 : hlsPlayer2.getVideoElement().currentTime) + 10);
          break;
        case "ArrowLeft":
          hlsPlayer2 == null ? void 0 : hlsPlayer2.seekTo((hlsPlayer2 == null ? void 0 : hlsPlayer2.getVideoElement().currentTime) - 10);
          break;
      }
    }),
    [hlsPlayer2, isPaused]
  );
  return handleKeyEvent;
};
var useRecordingHandler = () => {
  const hmsActions = useHMSActions8();
  const recordingState = useHMSStore11(selectRecordingState);
  const [isRecordingLoading, setIsRecordingLoading] = useState11(false);
  const [recordingStarted, setRecordingState] = useSetAppDataByKey(APP_DATA.recordingStarted);
  useEffect13(() => {
    if (recordingState.browser.error && recordingStarted) {
      setRecordingState(false);
    }
  }, [recordingStarted, recordingState.browser.error, setRecordingState]);
  const startRecording = useCallback10(
    (resolution = null) => __async(void 0, null, function* () {
      try {
        setRecordingState(true);
        setIsRecordingLoading(true);
        yield hmsActions.startRTMPOrRecording({
          resolution: getResolution(resolution),
          record: true
        });
      } catch (error) {
        const err = error;
        if (err.message.includes("stream already running")) {
          ToastManager.addToast({
            title: "Recording already running",
            variant: "error"
          });
        } else {
          ToastManager.addToast({
            title: err.message,
            variant: "error"
          });
        }
        setRecordingState(false);
      }
      setIsRecordingLoading(false);
    }),
    [hmsActions, setRecordingState]
  );
  return {
    recordingStarted,
    startRecording,
    isRecordingLoading
  };
};
function getResolution(recordingResolution) {
  if (!recordingResolution) {
    return void 0;
  }
  const resolution = RTMP_RECORD_DEFAULT_RESOLUTION;
  if (recordingResolution.width) {
    resolution.width = recordingResolution.width;
  }
  if (recordingResolution.height) {
    resolution.height = recordingResolution.height;
  }
  return resolution;
}
function useWaitingRoomInfo() {
  const localPeerRole = useHMSStore11(selectLocalPeerRole);
  const { video, audio, screen } = useHMSStore11(selectIsAllowedToPublish);
  const isScreenShareAllowed = isScreenshareSupported();
  const roles = useHMSStore11(selectRolesMap);
  const peersByRoles = useHMSStore11(selectPeersByRoles((localPeerRole == null ? void 0 : localPeerRole.subscribeParams.subscribeToRoles) || []));
  const isNotAllowedToPublish = !(video || audio || screen && isScreenShareAllowed);
  const isScreenOnlyPublishParams = screen && !(video || audio);
  const hasSubscribedRolePublishing = useMemo5(() => {
    return peersByRoles.some((peer) => {
      var _a8;
      if (peer.roleName && roles[peer.roleName] && !peer.isLocal) {
        return !!((_a8 = roles[peer.roleName].publishParams) == null ? void 0 : _a8.allowed.length);
      }
      return false;
    });
  }, [peersByRoles, roles]);
  return {
    isNotAllowedToPublish,
    isScreenOnlyPublishParams,
    hasSubscribedRolePublishing
  };
}

// src/Prebuilt/components/EmojiReaction.jsx
init({ data });
var EmojiReaction = ({ showCard = false }) => {
  const [open, setOpen] = useState12(false);
  const isConnected = useHMSStore12(selectIsConnectedToRoom2);
  const { elements } = useRoomLayoutConferencingScreen();
  useDropdownList({ open, name: "EmojiReaction" });
  const roles = useHMSStore12(selectAvailableRoleNames2);
  const localPeerId = useHMSStore12(selectLocalPeerID);
  const isMobile = useMedia4(config.media.md);
  const isLandscape = useMedia4(config.media.ls);
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeStream = useLandscapeHLSStream();
  const { sendEvent } = useCustomEvent({
    type: EMOJI_REACTION_TYPE
  });
  const sendReaction = (emojiId) => __async(void 0, null, function* () {
    var _a8;
    const data3 = {
      type: EMOJI_REACTION_TYPE,
      emojiId,
      senderId: localPeerId
    };
    sendEvent(data3, { roleNames: roles });
    (_a8 = window.showFlyingEmoji) == null ? void 0 : _a8.call(window, { emojiId, senderId: localPeerId });
  });
  if (!isConnected || !elements.emoji_reactions) {
    return null;
  }
  if (showCard) {
    return /* @__PURE__ */ React37.createElement(EmojiCard, { sendReaction });
  }
  return /* @__PURE__ */ React37.createElement(Dropdown.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React37.createElement(Dropdown.Trigger, { asChild: true, "data-testid": "emoji_reaction_btn" }, /* @__PURE__ */ React37.createElement(
    IconButton_default,
    {
      css: isMobile || isLandscape ? { bg: "$surface_default", r: "$round", border: "1px solid $border_bright" } : {}
    },
    /* @__PURE__ */ React37.createElement(Tooltip, { title: "Emoji reaction" }, /* @__PURE__ */ React37.createElement(Box, null, /* @__PURE__ */ React37.createElement(EmojiIcon, null)))
  )), /* @__PURE__ */ React37.createElement(
    Dropdown.Content,
    {
      sideOffset: 5,
      align: isMobileHLSStream || isLandscapeStream ? "end" : "center",
      css: { p: "$8", bg: "$surface_default" }
    },
    /* @__PURE__ */ React37.createElement(EmojiCard, { sendReaction })
  ));
};

// src/Prebuilt/components/Leave/LeaveRoom.tsx
init_define_process_env();
import React43 from "react";
import { useMedia as useMedia5 } from "react-use";
import {
  selectHLSState as selectHLSState3,
  selectIsConnectedToRoom as selectIsConnectedToRoom5,
  selectPeersByCondition,
  selectPermissions as selectPermissions4,
  selectRolesMap as selectRolesMap2,
  useHMSActions as useHMSActions9,
  useHMSStore as useHMSStore15
} from "@100mslive/react-sdk";

// src/Prebuilt/components/Leave/DesktopLeaveRoom.tsx
init_define_process_env();
import React41, { Fragment as Fragment4, useState as useState13 } from "react";
import { selectIsConnectedToRoom as selectIsConnectedToRoom3, selectPermissions as selectPermissions2, useHMSStore as useHMSStore13, useRecordingStreaming as useRecordingStreaming3 } from "@100mslive/react-sdk";
import { ExitIcon, StopIcon, VerticalMenuIcon as VerticalMenuIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/Leave/EndSessionContent.tsx
init_define_process_env();
import React38 from "react";
import { AlertTriangleIcon, CrossIcon as CrossIcon4 } from "@100mslive/react-icons";
var EndSessionContent = ({
  setShowEndStreamAlert,
  leaveRoom,
  isModal = false,
  isStreamingOn = false
}) => {
  return /* @__PURE__ */ React38.createElement(Box, null, /* @__PURE__ */ React38.createElement(
    Flex,
    {
      css: {
        color: "$alert_error_default",
        display: "flex",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React38.createElement(AlertTriangleIcon, { style: { marginRight: "0.5rem" } }),
    /* @__PURE__ */ React38.createElement(Text, { variant: "lg", css: { color: "inherit", fontWeight: "$semiBold" } }, "End ", isStreamingOn ? "Stream" : "Session"),
    isModal ? null : /* @__PURE__ */ React38.createElement(Box, { css: { color: "$on_surface_high", ml: "auto" }, onClick: () => setShowEndStreamAlert(false) }, /* @__PURE__ */ React38.createElement(CrossIcon4, null))
  ), /* @__PURE__ */ React38.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", mb: "$8", mt: "$4" } }, "The ", isStreamingOn ? "stream" : "session", " will end for everyone. You can't undo this action."), /* @__PURE__ */ React38.createElement(Flex, { align: "center", justify: "between", css: { w: "100%", gap: "$8" } }, /* @__PURE__ */ React38.createElement(
    Button,
    {
      outlined: true,
      variant: "standard",
      css: { w: "100%", "@md": { display: "none" } },
      onClick: () => setShowEndStreamAlert(false)
    },
    "Cancel"
  ), /* @__PURE__ */ React38.createElement(
    Button,
    {
      variant: "danger",
      css: { w: "100%" },
      onClick: () => __async(void 0, null, function* () {
        yield leaveRoom({ endStream: true });
        setShowEndStreamAlert(false);
      }),
      id: "stopStream",
      "data-testid": "stop_stream_btn"
    },
    "End ",
    isStreamingOn ? "Stream" : "Session"
  )));
};

// src/Prebuilt/components/Leave/LeaveAtoms.tsx
init_define_process_env();
var LeaveIconButton = styled(IconButton, {
  color: "$on_primary_high",
  h: "$14",
  px: "$4",
  r: "$1",
  bg: "$alert_error_default",
  "&:not([disabled]):hover": {
    bg: "$alert_error_bright"
  },
  "&:not([disabled]):active": {
    bg: "$alert_error_default"
  },
  "@md": {
    mx: 0
  }
});
var MenuTriggerButton = styled(LeaveIconButton, {
  borderLeft: "1px solid $alert_error_dim",
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  px: "$2"
});

// src/Prebuilt/components/Leave/LeaveCard.tsx
init_define_process_env();
import React39 from "react";
var LeaveCard = ({
  icon,
  title,
  subtitle,
  onClick,
  bg: bg2,
  titleColor,
  css: css2 = {}
}) => {
  return /* @__PURE__ */ React39.createElement(Flex, { css: __spreadValues({ p: "$10", flexGrow: 1, gap: "$8", bg: bg2 }, css2), onClick }, /* @__PURE__ */ React39.createElement(Box, { css: { color: titleColor } }, icon), /* @__PURE__ */ React39.createElement(Box, { css: { gap: "$2" } }, /* @__PURE__ */ React39.createElement(Text, { variant: "lg", css: { color: titleColor } }, title), /* @__PURE__ */ React39.createElement(Text, { variant: "sm", css: { c: "inherit" } }, subtitle)));
};

// src/Prebuilt/components/Leave/LeaveSessionContent.tsx
init_define_process_env();
import React40 from "react";
import { AlertTriangleIcon as AlertTriangleIcon2, CrossIcon as CrossIcon5 } from "@100mslive/react-icons";
var LeaveSessionContent = ({
  setShowLeaveRoomAlert,
  leaveRoom,
  isModal = false
}) => {
  return /* @__PURE__ */ React40.createElement(Box, null, /* @__PURE__ */ React40.createElement(
    Flex,
    {
      css: {
        color: "$alert_error_default",
        display: "flex",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React40.createElement(AlertTriangleIcon2, { style: { marginRight: "0.5rem" } }),
    /* @__PURE__ */ React40.createElement(Text, { variant: "lg", css: { color: "inherit", fontWeight: "$semiBold" } }, "Leave"),
    isModal ? null : /* @__PURE__ */ React40.createElement(Box, { css: { color: "$on_surface_high", ml: "auto" }, onClick: () => setShowLeaveRoomAlert(false) }, /* @__PURE__ */ React40.createElement(CrossIcon5, null))
  ), /* @__PURE__ */ React40.createElement(Text, { variant: "sm", css: { color: "$on_surface_low", mb: "$8", mt: "$4" } }, "Others will continue after you leave. You can join the session again."), /* @__PURE__ */ React40.createElement(Flex, { align: "center", justify: "between", css: { w: "100%", gap: "$8" } }, /* @__PURE__ */ React40.createElement(
    Button,
    {
      outlined: true,
      variant: "standard",
      css: { w: "100%", "@md": { display: "none" } },
      onClick: () => setShowLeaveRoomAlert(false)
    },
    "Cancel"
  ), /* @__PURE__ */ React40.createElement(
    Button,
    {
      variant: "danger",
      css: { w: "100%" },
      onClick: () => __async(void 0, null, function* () {
        yield leaveRoom();
      }),
      id: "leaveRoom",
      "data-testid": "leave_room"
    },
    "Leave Session"
  )));
};

// src/Prebuilt/components/Leave/DesktopLeaveRoom.tsx
var DesktopLeaveRoom = ({
  leaveRoom,
  screenType,
  endRoom,
  container
}) => {
  const [open, setOpen] = useState13(false);
  const [showLeaveRoomAlert, setShowLeaveRoomAlert] = useState13(false);
  const [showEndStreamAlert, setShowEndStreamAlert] = useState13(false);
  const isConnected = useHMSStore13(selectIsConnectedToRoom3);
  const permissions = useHMSStore13(selectPermissions2);
  const { isStreamingOn } = useRecordingStreaming3();
  const showStream = screenType !== "hls_live_streaming" && isStreamingOn && (permissions == null ? void 0 : permissions.hlsStreaming);
  const showLeaveOptions = (permissions == null ? void 0 : permissions.hlsStreaming) && isStreamingOn || (permissions == null ? void 0 : permissions.endRoom);
  useDropdownList({ open: open || showEndStreamAlert || showLeaveRoomAlert, name: "LeaveRoom" });
  if (!permissions || !isConnected) {
    return null;
  }
  return /* @__PURE__ */ React41.createElement(Fragment4, null, showLeaveOptions ? /* @__PURE__ */ React41.createElement(Flex, null, /* @__PURE__ */ React41.createElement(
    LeaveIconButton,
    {
      key: "LeaveRoom",
      "data-testid": "leave_room_btn",
      css: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      onClick: () => setShowLeaveRoomAlert(true)
    },
    /* @__PURE__ */ React41.createElement(Tooltip, { title: "Leave Room" }, /* @__PURE__ */ React41.createElement(Box, null, /* @__PURE__ */ React41.createElement(ExitIcon, { style: { transform: "rotate(180deg)" } })))
  ), /* @__PURE__ */ React41.createElement(Dropdown.Root, { open, onOpenChange: setOpen, modal: false }, /* @__PURE__ */ React41.createElement(
    Dropdown.Trigger,
    {
      asChild: true,
      css: {
        '&[data-state="open"]': {
          bg: "$alert_error_dim"
        }
      }
    },
    /* @__PURE__ */ React41.createElement(MenuTriggerButton, { "data-testid": "leave_end_dropdown_trigger" }, /* @__PURE__ */ React41.createElement(VerticalMenuIcon2, null))
  ), /* @__PURE__ */ React41.createElement(Dropdown.Portal, { container }, /* @__PURE__ */ React41.createElement(Dropdown.Content, { css: { p: 0, w: "$100" }, alignOffset: -50, sideOffset: 10 }, /* @__PURE__ */ React41.createElement(
    Dropdown.Item,
    {
      css: {
        bg: "$surface_dim",
        color: "$on_surface_medium",
        "&:hover": { bg: "$surface_default", color: "$on_surface_high" },
        p: "0"
      },
      "data-testid": "just_leave_btn"
    },
    /* @__PURE__ */ React41.createElement(
      LeaveCard,
      {
        title: showStream ? "Leave Stream" : "Leave Session",
        subtitle: `Others will continue after you leave. You can join the ${showStream ? "stream" : "session"} again.`,
        bg: "",
        titleColor: "$on_surface_high",
        icon: /* @__PURE__ */ React41.createElement(ExitIcon, { height: 24, width: 24, style: { transform: "rotate(180deg)" } }),
        onClick: () => __async(void 0, null, function* () {
          return yield leaveRoom();
        }),
        css: { p: "$8 $4" }
      }
    )
  ), /* @__PURE__ */ React41.createElement(
    Dropdown.Item,
    {
      css: {
        bg: "$alert_error_dim",
        color: "$alert_error_bright",
        "&:hover": { bg: "$alert_error_dim", color: "$alert_error_brighter" },
        p: "0"
      },
      "data-testid": "end_room_btn"
    },
    /* @__PURE__ */ React41.createElement(
      LeaveCard,
      {
        title: showStream ? "End Stream" : "End Session",
        subtitle: `The ${showStream ? "stream" : "session"} will end for everyone. You can't undo this action.`,
        bg: "",
        titleColor: "$alert_error_brighter",
        icon: /* @__PURE__ */ React41.createElement(StopIcon, { height: 24, width: 24 }),
        onClick: () => {
          setOpen(false);
          setShowEndStreamAlert(true);
        },
        css: { p: "$8 $4" }
      }
    )
  ))))) : /* @__PURE__ */ React41.createElement(
    LeaveIconButton,
    {
      onClick: () => {
        setShowLeaveRoomAlert(true);
      },
      key: "LeaveRoom",
      "data-testid": "leave_room_btn"
    },
    /* @__PURE__ */ React41.createElement(Tooltip, { title: "Leave Room" }, /* @__PURE__ */ React41.createElement(Box, null, /* @__PURE__ */ React41.createElement(ExitIcon, { style: { transform: "rotate(180deg)" } })))
  ), /* @__PURE__ */ React41.createElement(Dialog.Root, { open: showEndStreamAlert, modal: false }, /* @__PURE__ */ React41.createElement(Dialog.Portal, null, /* @__PURE__ */ React41.createElement(Dialog.Overlay, null), /* @__PURE__ */ React41.createElement(Dialog.Content, { css: { w: "min(420px, 90%)", p: "$8", bg: "$surface_dim" } }, /* @__PURE__ */ React41.createElement(
    EndSessionContent,
    {
      setShowEndStreamAlert,
      leaveRoom: isStreamingOn ? () => leaveRoom({ endStream: true }) : endRoom,
      isStreamingOn,
      isModal: true
    }
  )))), /* @__PURE__ */ React41.createElement(Dialog.Root, { open: showLeaveRoomAlert, modal: false }, /* @__PURE__ */ React41.createElement(Dialog.Portal, null, /* @__PURE__ */ React41.createElement(Dialog.Overlay, null), /* @__PURE__ */ React41.createElement(Dialog.Content, { css: { w: "min(420px, 90%)", p: "$8", bg: "$surface_dim" } }, /* @__PURE__ */ React41.createElement(LeaveSessionContent, { setShowLeaveRoomAlert, leaveRoom, isModal: true })))));
};

// src/Prebuilt/components/Leave/MwebLeaveRoom.tsx
init_define_process_env();
import React42, { Fragment as Fragment5, useState as useState14 } from "react";
import { selectIsConnectedToRoom as selectIsConnectedToRoom4, selectPermissions as selectPermissions3, useHMSStore as useHMSStore14, useRecordingStreaming as useRecordingStreaming4 } from "@100mslive/react-sdk";
import { CrossIcon as CrossIcon6, ExitIcon as ExitIcon2, StopIcon as StopIcon2 } from "@100mslive/react-icons";
var MwebLeaveRoom = ({
  leaveRoom,
  endRoom,
  container
}) => {
  const [open, setOpen] = useState14(false);
  const { screenType } = useRoomLayoutConferencingScreen();
  const [showLeaveRoomAlert, setShowLeaveRoomAlert] = useState14(false);
  const [showEndStreamAlert, setShowEndStreamAlert] = useState14(false);
  const isConnected = useHMSStore14(selectIsConnectedToRoom4);
  const permissions = useHMSStore14(selectPermissions3);
  const { isStreamingOn } = useRecordingStreaming4();
  const showStream = screenType !== "hls_live_streaming" && isStreamingOn && (permissions == null ? void 0 : permissions.hlsStreaming);
  const showLeaveOptions = (permissions == null ? void 0 : permissions.hlsStreaming) && isStreamingOn || (permissions == null ? void 0 : permissions.endRoom);
  useDropdownList({ open, name: "LeaveRoom" });
  if (!permissions || !isConnected) {
    return null;
  }
  return /* @__PURE__ */ React42.createElement(Fragment5, null, showLeaveOptions ? /* @__PURE__ */ React42.createElement(Sheet.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React42.createElement(Sheet.Trigger, { asChild: true }, /* @__PURE__ */ React42.createElement(
    LeaveButton,
    {
      onClick: () => {
        setOpen((open2) => !open2);
      }
    }
  )), /* @__PURE__ */ React42.createElement(Sheet.Content, { container }, /* @__PURE__ */ React42.createElement(
    LeaveCard,
    {
      title: showStream ? "Leave Stream" : "Leave Session",
      subtitle: `Others will continue after you leave. You can join the ${showStream ? "stream" : "session"} again.`,
      bg: "$surface_default",
      titleColor: "$on_surface_high",
      icon: /* @__PURE__ */ React42.createElement(ExitIcon2, { height: 24, width: 24, style: { transform: "rotate(180deg)" } }),
      onClick: () => __async(void 0, null, function* () {
        return yield leaveRoom();
      }),
      css: { pt: 0, mt: "$10", color: "$on_surface_low", "&:hover": { color: "$on_surface_high" } }
    }
  ), /* @__PURE__ */ React42.createElement(
    LeaveCard,
    {
      title: showStream ? "End Stream" : "End Session",
      subtitle: `The will end the ${showStream ? "stream" : "session"} for everyone. You can't undo this action.`,
      bg: "$alert_error_dim",
      titleColor: "$alert_error_brighter",
      css: { color: "$alert_error_bright", "&:hover": { color: "$alert_error_brighter" } },
      icon: /* @__PURE__ */ React42.createElement(StopIcon2, { height: 24, width: 24 }),
      onClick: () => {
        setOpen(false);
        setShowEndStreamAlert(true);
      }
    }
  ))) : /* @__PURE__ */ React42.createElement(LeaveButton, { onClick: () => setShowLeaveRoomAlert(true) }), /* @__PURE__ */ React42.createElement(Sheet.Root, { open: showEndStreamAlert, onOpenChange: setShowEndStreamAlert }, /* @__PURE__ */ React42.createElement(Sheet.Content, { css: { bg: "$surface_dim", p: "$10", pb: "$12" }, container }, /* @__PURE__ */ React42.createElement(
    EndSessionContent,
    {
      setShowEndStreamAlert,
      leaveRoom: isStreamingOn ? leaveRoom : endRoom,
      isStreamingOn
    }
  ))), /* @__PURE__ */ React42.createElement(Sheet.Root, { open: showLeaveRoomAlert, onOpenChange: setShowLeaveRoomAlert }, /* @__PURE__ */ React42.createElement(Sheet.Content, { css: { bg: "$surface_dim", p: "$10", pb: "$12" }, container }, /* @__PURE__ */ React42.createElement(LeaveSessionContent, { setShowLeaveRoomAlert, leaveRoom }))));
};
var LeaveButton = ({ onClick }) => {
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeHLSStream = useLandscapeHLSStream();
  return isMobileHLSStream || isLandscapeHLSStream ? /* @__PURE__ */ React42.createElement(IconButton, { key: "LeaveRoom", "data-testid": "leave_room_btn", onClick }, /* @__PURE__ */ React42.createElement(Tooltip, { title: "Leave Room" }, /* @__PURE__ */ React42.createElement(Box, null, /* @__PURE__ */ React42.createElement(CrossIcon6, null)))) : /* @__PURE__ */ React42.createElement(
    LeaveIconButton,
    {
      key: "LeaveRoom",
      "data-testid": "leave_room_btn",
      css: {
        borderTopRightRadius: "$1",
        borderBottomRightRadius: "$1"
      },
      onClick
    },
    /* @__PURE__ */ React42.createElement(Tooltip, { title: "Leave Room" }, /* @__PURE__ */ React42.createElement(Box, null, /* @__PURE__ */ React42.createElement(ExitIcon2, { style: { transform: "rotate(180deg)" } })))
  );
};

// src/Prebuilt/components/Leave/LeaveRoom.tsx
var LeaveRoom = ({
  screenType,
  container
}) => {
  const isConnected = useHMSStore15(selectIsConnectedToRoom5);
  const permissions = useHMSStore15(selectPermissions4);
  const isMobile = useMedia5(config.media.md);
  const rolesMap = useHMSStore15(selectRolesMap2);
  const streamingPermissionRoles = Object.keys(rolesMap).filter((roleName) => {
    const roleObj = rolesMap[roleName];
    return roleObj.permissions.hlsStreaming;
  });
  const peersWithStreamingRights = useHMSStore15(
    selectPeersByCondition((peer) => streamingPermissionRoles.includes(peer.roleName || ""))
  );
  const hlsState = useHMSStore15(selectHLSState3);
  const hmsActions = useHMSActions9();
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeHLSStream = useLandscapeHLSStream();
  const stopStream = () => __async(void 0, null, function* () {
    try {
      if (permissions == null ? void 0 : permissions.hlsStreaming) {
        console.log("Stopping HLS stream");
        yield hmsActions.stopHLSStreaming();
        ToastManager.addToast({ title: "Stopping the stream" });
      }
    } catch (e) {
      console.error("Error stopping stream", e);
      ToastManager.addToast({ title: "Error in stopping the stream", type: "error" });
    }
  });
  const endRoom = () => __async(void 0, null, function* () {
    yield hmsActions.endRoom(false, "End Room");
  });
  const leaveRoom = (..._0) => __async(void 0, [..._0], function* (options = { endStream: false }) {
    if (options.endStream || hlsState.running && peersWithStreamingRights.length === 1) {
      yield stopStream();
    }
    yield hmsActions.leave();
  });
  if (!permissions || !isConnected) {
    return null;
  }
  if (isMobileHLSStream || isLandscapeHLSStream) {
    return /* @__PURE__ */ React43.createElement(MwebLeaveRoom, { leaveRoom, endRoom, container });
  }
  return isMobile ? /* @__PURE__ */ React43.createElement(MwebLeaveRoom, { leaveRoom, endRoom, container }) : /* @__PURE__ */ React43.createElement(DesktopLeaveRoom, { leaveRoom, screenType, endRoom, container });
};

// src/Prebuilt/components/MoreSettings/MoreSettings.tsx
init_define_process_env();
import React68 from "react";
import { useMedia as useMedia13 } from "react-use";

// src/Prebuilt/components/MoreSettings/SplitComponents/DesktopOptions.tsx
init_define_process_env();
import React63, { Fragment as Fragment7, useState as useState27 } from "react";
import { HMSHLSPlayer } from "@100mslive/hls-player";
import { match as match5 } from "ts-pattern";
import {
  HMSTranscriptionMode as HMSTranscriptionMode2,
  selectAppData as selectAppData3,
  selectIsTranscriptionAllowedByMode,
  selectIsTranscriptionEnabled as selectIsTranscriptionEnabled3,
  selectLocalPeerID as selectLocalPeerID6,
  useHMSActions as useHMSActions23,
  useHMSStore as useHMSStore28
} from "@100mslive/react-sdk";
import {
  BrbIcon,
  CheckIcon as CheckIcon4,
  HamburgerMenuIcon,
  InfoIcon as InfoIcon2,
  OpenCaptionIcon as OpenCaptionIcon2,
  PipIcon as PipIcon2,
  SettingsIcon as SettingsIcon3
} from "@100mslive/react-icons";

// src/Prebuilt/components/PIP/index.jsx
init_define_process_env();
import React45 from "react";

// src/Prebuilt/components/PIP/PIPComponent.tsx
init_define_process_env();
import React44, { useCallback as useCallback11, useEffect as useEffect14, useState as useState15 } from "react";
import { selectPeers as selectPeers2, selectTracksMap, useHMSActions as useHMSActions10, useHMSVanillaStore as useHMSVanillaStore6 } from "@100mslive/react-sdk";
import { PipIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/PIP/SetupMediaSession.js
init_define_process_env();
import { selectIsLocalAudioEnabled, selectIsLocalVideoEnabled as selectIsLocalVideoEnabled3 } from "@100mslive/react-sdk";
var SetupMediaSession = class {
  constructor() {
    __publicField(this, "setup", (actions, store) => {
      this.actions = actions;
      this.store = store;
      this.initState();
      this.setUpHandlers();
    });
    __publicField(this, "initState", () => {
      var _a8, _b7, _c, _d;
      const isMicActive = this.store.getState(selectIsLocalAudioEnabled);
      const isCamActive = this.store.getState(selectIsLocalVideoEnabled3);
      (_b7 = (_a8 = navigator.mediaSession) == null ? void 0 : _a8.setMicrophoneActive) == null ? void 0 : _b7.call(_a8, isMicActive);
      (_d = (_c = navigator.mediaSession) == null ? void 0 : _c.setCameraActive) == null ? void 0 : _d.call(_c, isCamActive);
      this.store.subscribe((isMicActive2) => {
        var _a9, _b8;
        (_b8 = (_a9 = navigator.mediaSession) == null ? void 0 : _a9.setMicrophoneActive) == null ? void 0 : _b8.call(_a9, isMicActive2);
      }, selectIsLocalAudioEnabled);
      this.store.subscribe((isCamActive2) => {
        var _a9, _b8;
        (_b8 = (_a9 = navigator.mediaSession) == null ? void 0 : _a9.setCameraActive) == null ? void 0 : _b8.call(_a9, isCamActive2);
      }, selectIsLocalVideoEnabled3);
    });
    __publicField(this, "toggleMic", () => __async(this, null, function* () {
      console.log("toggle mic clicked in pip");
      const current = this.store.getState(selectIsLocalAudioEnabled);
      yield this.actions.setLocalAudioEnabled(!current);
    }));
    __publicField(this, "toggleCam", () => __async(this, null, function* () {
      console.log("toggle cam clicked in pip");
      const current = this.store.getState(selectIsLocalVideoEnabled3);
      yield this.actions.setLocalVideoEnabled(!current);
    }));
    __publicField(this, "leave", () => {
      console.log("leave called from pip");
      this.actions.leave();
    });
    __publicField(this, "setUpHandlers", () => {
      if (navigator.mediaSession) {
        try {
          navigator.mediaSession.setActionHandler("togglemicrophone", this.toggleMic);
          navigator.mediaSession.setActionHandler("togglecamera", this.toggleCam);
          navigator.mediaSession.setActionHandler("hangup", this.leave);
        } catch (err) {
          console.error("error in setting media session handlers", err);
        }
      }
    });
  }
};
var MediaSession = new SetupMediaSession();

// src/Prebuilt/components/PIP/PIPComponent.tsx
var PIPComponent = ({ content = null }) => {
  const [isPipOn, setIsPipOn] = useState15(PictureInPicture.isOn());
  const hmsActions = useHMSActions10();
  const store = useHMSVanillaStore6();
  const onPipToggle = useCallback11(() => {
    if (!isPipOn) {
      PictureInPicture.start(hmsActions, setIsPipOn).catch((err) => console.error("error in starting pip", err));
      MediaSession.setup(hmsActions, store);
    } else {
      PictureInPicture.stop().catch((err) => console.error("error in stopping pip", err));
    }
  }, [hmsActions, isPipOn, store]);
  if (!PictureInPicture.isSupported()) {
    return null;
  }
  return /* @__PURE__ */ React44.createElement(React44.Fragment, null, content ? /* @__PURE__ */ React44.createElement(Flex, { css: { w: "100%" }, onClick: () => onPipToggle(), "data-testid": "pip_btn" }, content) : /* @__PURE__ */ React44.createElement(Tooltip, { title: `${isPipOn ? "Deactivate" : "Activate"} picture in picture view` }, /* @__PURE__ */ React44.createElement(IconButton_default, { active: !isPipOn, key: "pip", onClick: () => onPipToggle(), "data-testid": "pip_btn" }, /* @__PURE__ */ React44.createElement(PipIcon, null))));
};
var ActivatedPIP = () => {
  const store = useHMSVanillaStore6();
  const pinnedTrack = usePinnedTrack();
  useEffect14(() => {
    function subscribeToStore() {
      return store.subscribe((tracksMap) => {
        let pipPeers = store.getState(selectPeers2);
        if (pinnedTrack) {
          pipPeers = pipPeers.filter((peer) => pinnedTrack.peerId === peer.id);
        }
        PictureInPicture.updatePeersAndTracks(pipPeers, tracksMap).catch((err) => {
          console.error("error in updating pip", err);
        });
      }, selectTracksMap);
    }
    let unsubscribe = PictureInPicture.isOn() ? subscribeToStore() : void 0;
    PictureInPicture.listenToStateChange((isOn) => {
      if (isOn) {
        if (!unsubscribe) {
          unsubscribe = subscribeToStore();
        }
      } else {
        unsubscribe == null ? void 0 : unsubscribe();
        unsubscribe = void 0;
      }
    });
    return () => {
      unsubscribe == null ? void 0 : unsubscribe();
      unsubscribe = void 0;
    };
  }, [pinnedTrack, store]);
  return /* @__PURE__ */ React44.createElement(React44.Fragment, null);
};
var PIPComponent_default = PIPComponent;

// src/Prebuilt/components/PIP/index.jsx
var PIP = ({ content = null }) => {
  return /* @__PURE__ */ React45.createElement(PIPComponent_default, { content });
};

// src/Prebuilt/components/PIP/PIPChat.tsx
init_define_process_env();
import React50, { useCallback as useCallback16, useEffect as useEffect17, useMemo as useMemo7, useState as useState19 } from "react";
import {
  selectHMSMessages as selectHMSMessages2,
  selectLocalPeerID as selectLocalPeerID3,
  selectPeerNameByID as selectPeerNameByID3,
  selectSessionStore as selectSessionStore6,
  selectUnreadHMSMessagesCount as selectUnreadHMSMessagesCount2,
  useHMSStore as useHMSStore20
} from "@100mslive/react-sdk";
import { SendIcon } from "@100mslive/react-icons";

// src/TextArea/index.tsx
init_define_process_env();

// src/TextArea/TextArea.tsx
init_define_process_env();
var TextArea = styled("textarea", {
  fontFamily: "$sans",
  lineHeight: "inherit",
  backgroundColor: "$surface_default",
  borderRadius: "8px",
  outline: "none",
  border: "1px solid $border_default",
  padding: "0.5rem 0.75rem",
  minHeight: "30px",
  color: "$on_surface_high",
  fontSize: "$md",
  "&:focus": {
    boxShadow: "0 0 0 1px $colors$primary_default",
    border: "1px solid transparent"
  },
  "&::placeholder": {
    color: "$on_surface_medium"
  },
  variants: {
    error: {
      true: {
        "&:focus": {
          boxShadow: "0 0 0 3px $colors$alert_error_default"
        }
      }
    }
  }
});

// src/Prebuilt/components/Chat/ChatBody.tsx
init_define_process_env();
import React49, { Fragment as Fragment6, useCallback as useCallback15, useEffect as useEffect16, useLayoutEffect, useMemo as useMemo6, useRef as useRef12, useState as useState18 } from "react";
import { useMedia as useMedia7 } from "react-use";
import AutoSizer from "react-virtualized-auto-sizer";
import { VariableSizeList } from "react-window";
import {
  selectHMSMessages,
  selectLocalPeerID as selectLocalPeerID2,
  selectLocalPeerName as selectLocalPeerName2,
  selectLocalPeerRoleName,
  selectPeerNameByID as selectPeerNameByID2,
  selectSessionStore as selectSessionStore5,
  selectUnreadHMSMessagesCount,
  useHMSActions as useHMSActions14,
  useHMSStore as useHMSStore19,
  useHMSVanillaStore as useHMSVanillaStore8
} from "@100mslive/react-sdk";
import { SolidPinIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/ChatActions.tsx
init_define_process_env();
import React47, { useCallback as useCallback14, useState as useState16 } from "react";
import { selectLocalPeerName, selectPermissions as selectPermissions5, useHMSActions as useHMSActions13, useHMSStore as useHMSStore17 } from "@100mslive/react-sdk";
import {
  CopyIcon as CopyIcon2,
  CrossCircleIcon,
  CrossIcon as CrossIcon7,
  EyeCloseIcon as EyeCloseIcon2,
  PeopleRemoveIcon as PeopleRemoveIcon2,
  PinIcon,
  ReplyGroupIcon,
  ReplyIcon,
  VerticalMenuIcon as VerticalMenuIcon3
} from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/MwebChatOption.tsx
init_define_process_env();
import React46 from "react";
var MwebChatOption = ({
  icon,
  text,
  onClick,
  color = "$on_surface_high"
}) => {
  return /* @__PURE__ */ React46.createElement(Flex, { align: "center", css: { w: "100%", color, cursor: "pointer", gap: "$4", p: "$8" }, onClick }, icon, /* @__PURE__ */ React46.createElement(Text, { variant: "sm", css: { color, fontWeight: "$semiBold" } }, text));
};

// src/Prebuilt/components/hooks/useChatBlacklist.ts
init_define_process_env();
import { useCallback as useCallback12 } from "react";
import { selectLocalPeer as selectLocalPeer2, selectSessionStore as selectSessionStore2, useHMSActions as useHMSActions11, useHMSStore as useHMSStore16 } from "@100mslive/react-sdk";
var useChatBlacklist = (sessionStoreKey) => {
  const hmsActions = useHMSActions11();
  const blacklistedIDs = useHMSStore16(selectSessionStore2(sessionStoreKey));
  const blacklistItem = useCallback12(
    (blacklistID) => __async(void 0, null, function* () {
      yield hmsActions.sessionStore.set(sessionStoreKey, [...blacklistedIDs || [], blacklistID]).catch((err) => ToastManager.addToast({ title: err.description }));
    }),
    [hmsActions, sessionStoreKey, blacklistedIDs]
  );
  return { blacklistItem, blacklistedIDs };
};
var useIsPeerBlacklisted = ({ local = false, peerCustomerUserId = "" }) => {
  const localPeer = useHMSStore16(selectLocalPeer2);
  const blacklistedPeerIDs = useHMSStore16(selectSessionStore2("chatPeerBlacklist" /* CHAT_PEER_BLACKLIST */)) || [];
  return blacklistedPeerIDs == null ? void 0 : blacklistedPeerIDs.includes(local ? localPeer == null ? void 0 : localPeer.customerUserId : peerCustomerUserId);
};

// src/Prebuilt/components/hooks/usePinnedMessages.ts
init_define_process_env();
import { useCallback as useCallback13 } from "react";
import {
  selectPeerNameByID,
  selectSessionStore as selectSessionStore3,
  useHMSActions as useHMSActions12,
  useHMSVanillaStore as useHMSVanillaStore7
} from "@100mslive/react-sdk";
var usePinnedMessages = () => {
  const hmsActions = useHMSActions12();
  const vanillaStore = useHMSVanillaStore7();
  const setPinnedMessages = useCallback13(
    (message, pinnedBy) => __async(void 0, null, function* () {
      const peerName = vanillaStore.getState(selectPeerNameByID(message == null ? void 0 : message.sender)) || (message == null ? void 0 : message.senderName);
      const newPinnedMessage = { text: "", id: message.id, pinnedBy };
      if (message && peerName) {
        newPinnedMessage["text"] = `${peerName}: ${message.message}`;
      } else if (message) {
        newPinnedMessage["text"] = message.message;
      }
      const pinnedMessages = vanillaStore.getState(selectSessionStore3("pinnedMessages" /* PINNED_MESSAGES */)) || [];
      if (!(pinnedMessages == null ? void 0 : pinnedMessages.find((pinnedMessage) => pinnedMessage.id === newPinnedMessage.id))) {
        yield hmsActions.sessionStore.set("pinnedMessages" /* PINNED_MESSAGES */, [...pinnedMessages, newPinnedMessage].slice(-3)).catch((err) => ToastManager.addToast({ title: err.description }));
      }
    }),
    [hmsActions, vanillaStore]
  );
  const removePinnedMessage = useCallback13(
    (indexToRemove) => __async(void 0, null, function* () {
      const pinnedMessages = vanillaStore.getState(selectSessionStore3("pinnedMessages" /* PINNED_MESSAGES */)) || [];
      if (pinnedMessages[indexToRemove]) {
        yield hmsActions.sessionStore.set(
          "pinnedMessages" /* PINNED_MESSAGES */,
          pinnedMessages.filter((_, index) => index !== indexToRemove)
        ).catch((err) => ToastManager.addToast({ title: err.description }));
      }
    }),
    [hmsActions, vanillaStore]
  );
  const unpinBlacklistedMessages = useCallback13(
    (blacklistedMessageIDSet) => __async(void 0, null, function* () {
      const pinnedMessages = vanillaStore.getState(selectSessionStore3("pinnedMessages" /* PINNED_MESSAGES */)) || [];
      const filteredPinnedMessages = pinnedMessages == null ? void 0 : pinnedMessages.filter(
        (pinnedMessage) => !(blacklistedMessageIDSet == null ? void 0 : blacklistedMessageIDSet.has(pinnedMessage.id))
      );
      yield hmsActions.sessionStore.set("pinnedMessages" /* PINNED_MESSAGES */, filteredPinnedMessages).catch((err) => ToastManager.addToast({ title: err.description }));
    }),
    [hmsActions, vanillaStore]
  );
  return { setPinnedMessages, removePinnedMessage, unpinBlacklistedMessages };
};

// src/Prebuilt/components/Chat/ChatActions.tsx
var iconStyle = { height: "1.125rem", width: "1.125rem" };
var tooltipBoxCSS = {
  fontSize: "$xs",
  backgroundColor: "$surface_default",
  p: "$1 $5",
  fontWeight: "$regular",
  borderRadius: "$3"
};
var ChatActions = ({
  showPinAction,
  onReply,
  onReplyGroup,
  showReply,
  message,
  sentByLocalPeer,
  isMobile,
  openSheet,
  setOpenSheet
}) => {
  var _a8, _b7;
  const { elements } = useRoomLayoutConferencingScreen();
  const { can_hide_message = false, can_block_user = false } = ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.real_time_controls) || {};
  const { roles_whitelist = [] } = (elements == null ? void 0 : elements.chat) || {};
  const [open, setOpen] = useState16(false);
  const actions = useHMSActions13();
  const canRemoveOthers = (_b7 = useHMSStore17(selectPermissions5)) == null ? void 0 : _b7.removeOthers;
  const { blacklistItem: blacklistPeer } = useChatBlacklist("chatPeerBlacklist" /* CHAT_PEER_BLACKLIST */);
  const localPeerName = useHMSStore17(selectLocalPeerName);
  const { setPinnedMessages, unpinBlacklistedMessages } = usePinnedMessages();
  const { blacklistItem: blacklistMessage, blacklistedIDs: blacklistedMessageIDs } = useChatBlacklist(
    "chatMessageBlacklist" /* CHAT_MESSAGE_BLACKLIST */
  );
  const isSenderBlocked = useIsPeerBlacklisted({ peerCustomerUserId: message.senderUserId });
  const updatePinnedMessages = useCallback14(
    (messageID = "") => {
      const blacklistedMessageIDSet = /* @__PURE__ */ new Set([...blacklistedMessageIDs || [], messageID]);
      unpinBlacklistedMessages(blacklistedMessageIDSet);
    },
    [blacklistedMessageIDs, unpinBlacklistedMessages]
  );
  const copyMessageContent = useCallback14(() => {
    try {
      navigator == null ? void 0 : navigator.clipboard.writeText(message.message);
      ToastManager.addToast({
        title: "Message copied successfully"
      });
    } catch (e) {
      console.log(e);
      ToastManager.addToast({
        title: "Could not copy message"
      });
    }
  }, [message]);
  const options = {
    reply: {
      text: "Reply privately",
      tooltipText: "Reply privately",
      icon: /* @__PURE__ */ React47.createElement(ReplyIcon, { style: iconStyle }),
      onClick: onReply,
      show: showReply
    },
    replyGroup: {
      text: "Reply to group",
      tooltipText: "Reply to group",
      icon: /* @__PURE__ */ React47.createElement(ReplyGroupIcon, { style: iconStyle }),
      onClick: onReplyGroup,
      show: !!message.senderRole && roles_whitelist.includes(message.senderRole)
    },
    pin: {
      text: "Pin message",
      tooltipText: "Pin",
      icon: /* @__PURE__ */ React47.createElement(PinIcon, { style: iconStyle }),
      onClick: () => setPinnedMessages(message, localPeerName || ""),
      show: showPinAction
    },
    copy: {
      text: "Copy text",
      tooltipText: "Copy",
      icon: /* @__PURE__ */ React47.createElement(CopyIcon2, { style: iconStyle }),
      onClick: copyMessageContent,
      show: true
    },
    hide: {
      text: message.recipientPeer ? "Hide for both" : "Hide for everyone",
      icon: /* @__PURE__ */ React47.createElement(EyeCloseIcon2, { style: iconStyle }),
      onClick: () => __async(void 0, null, function* () {
        blacklistMessage(message.id);
        updatePinnedMessages(message.id);
      }),
      show: !!can_hide_message
    },
    block: {
      text: "Block from chat",
      icon: /* @__PURE__ */ React47.createElement(CrossCircleIcon, { style: iconStyle }),
      onClick: () => __async(void 0, null, function* () {
        if (message.senderUserId) {
          blacklistPeer(message.senderUserId);
        }
      }),
      color: "$alert_error_default",
      show: !!can_block_user && !sentByLocalPeer && !isSenderBlocked
    },
    remove: {
      text: "Remove participant",
      icon: /* @__PURE__ */ React47.createElement(PeopleRemoveIcon2, { style: iconStyle }),
      color: "$alert_error_default",
      show: !!canRemoveOthers && !sentByLocalPeer,
      onClick: () => __async(void 0, null, function* () {
        if (!message.sender) {
          return;
        }
        try {
          yield actions.removePeer(message.sender, "");
        } catch (error) {
          ToastManager.addToast({ title: error.message, variant: "error" });
        }
      })
    }
  };
  if (isMobile) {
    return /* @__PURE__ */ React47.createElement(Sheet.Root, { open: openSheet, onOpenChange: setOpenSheet }, /* @__PURE__ */ React47.createElement(Sheet.Content, { css: { bg: "$surface_default", pb: "$14" }, onClick: (e) => setOpenSheet(false, e) }, /* @__PURE__ */ React47.createElement(
      Sheet.Title,
      {
        css: {
          display: "flex",
          color: "$on_surface_high",
          w: "100%",
          justifyContent: "space-between",
          mt: "$8",
          fontSize: "$md",
          px: "$10",
          pb: "$8",
          borderBottom: "1px solid $border_bright",
          alignItems: "center"
        }
      },
      "Message options",
      /* @__PURE__ */ React47.createElement(Sheet.Close, { css: { color: "$on_surface_high" }, onClick: (e) => setOpenSheet(false, e) }, /* @__PURE__ */ React47.createElement(CrossIcon7, null))
    ), Object.keys(options).map((optionKey) => {
      const option = options[optionKey];
      return option.show ? /* @__PURE__ */ React47.createElement(
        MwebChatOption,
        {
          key: optionKey,
          text: option.text,
          icon: option.icon,
          onClick: option.onClick,
          color: option == null ? void 0 : option.color
        }
      ) : null;
    })));
  }
  return /* @__PURE__ */ React47.createElement(Dropdown.Root, { open, onOpenChange: setOpen, css: { "@md": { display: "none" } } }, /* @__PURE__ */ React47.createElement(
    Flex,
    {
      className: "chat_actions",
      css: {
        background: "$surface_bright",
        borderRadius: "$1",
        p: "$2",
        opacity: open ? 1 : 0,
        position: "absolute",
        top: 0,
        right: 0,
        zIndex: 1,
        "@md": { opacity: 1 }
      }
    },
    options.reply.show ? /* @__PURE__ */ React47.createElement(Tooltip, { boxCss: tooltipBoxCSS, title: options.reply.tooltipText }, /* @__PURE__ */ React47.createElement(IconButton, { "data-testid": "reply_message_btn", onClick: options.reply.onClick }, options.reply.icon)) : null,
    options.replyGroup.show ? /* @__PURE__ */ React47.createElement(Tooltip, { boxCss: tooltipBoxCSS, title: options.replyGroup.tooltipText }, /* @__PURE__ */ React47.createElement(IconButton, { "data-testid": "reply_group_message_btn", onClick: options.replyGroup.onClick }, options.replyGroup.icon)) : null,
    options.pin.show ? /* @__PURE__ */ React47.createElement(Tooltip, { boxCss: tooltipBoxCSS, title: options.pin.tooltipText }, /* @__PURE__ */ React47.createElement(IconButton, { "data-testid": "pin_message_btn", onClick: options.pin.onClick }, options.pin.icon)) : null,
    options.copy.show ? /* @__PURE__ */ React47.createElement(Tooltip, { boxCss: tooltipBoxCSS, title: options.copy.tooltipText }, /* @__PURE__ */ React47.createElement(IconButton, { onClick: options.copy.onClick, "data-testid": "copy_message_btn" }, /* @__PURE__ */ React47.createElement(CopyIcon2, { style: iconStyle }))) : null,
    options.block.show || options.hide.show || options.remove.show ? /* @__PURE__ */ React47.createElement(Tooltip, { boxCss: tooltipBoxCSS, title: "More actions" }, /* @__PURE__ */ React47.createElement(Dropdown.Trigger, { asChild: true }, /* @__PURE__ */ React47.createElement(IconButton, null, /* @__PURE__ */ React47.createElement(VerticalMenuIcon3, { style: iconStyle })))) : null
  ), /* @__PURE__ */ React47.createElement(Dropdown.Portal, null, /* @__PURE__ */ React47.createElement(
    Dropdown.Content,
    {
      sideOffset: 5,
      align: "end",
      css: { width: "$48", backgroundColor: "$surface_bright", py: "$0", border: "1px solid $border_bright" }
    },
    options.hide.show ? /* @__PURE__ */ React47.createElement(Dropdown.Item, { "data-testid": "hide_message_btn", onClick: options.hide.onClick }, options.hide.icon, /* @__PURE__ */ React47.createElement(Text, { variant: "sm", css: { ml: "$4", fontWeight: "$semiBold" } }, options.hide.text)) : null,
    options.block.show ? /* @__PURE__ */ React47.createElement(
      Dropdown.Item,
      {
        "data-testid": "block_peer_btn",
        onClick: options.block.onClick,
        css: { color: options.block.color }
      },
      options.block.icon,
      /* @__PURE__ */ React47.createElement(Text, { variant: "sm", css: { ml: "$4", color: "inherit", fontWeight: "$semiBold" } }, options.block.text)
    ) : null,
    options.remove.show ? /* @__PURE__ */ React47.createElement(
      Dropdown.Item,
      {
        "data-testid": "remove_peer_btn",
        onClick: options.remove.onClick,
        css: { color: options.remove.color }
      },
      options.remove.icon,
      /* @__PURE__ */ React47.createElement(Text, { variant: "sm", css: { ml: "$4", color: "inherit", fontWeight: "$semiBold" } }, options.remove.text)
    ) : null
  )));
};

// src/Prebuilt/components/Chat/EmptyChat.tsx
init_define_process_env();
import React48 from "react";
import { useMedia as useMedia6 } from "react-use";
import emptyChat from "./empty-chat.svg";
var EmptyChat = () => {
  var _a8;
  const { elements } = useRoomLayoutConferencingScreen();
  const isLocalPeerBlacklisted = useIsPeerBlacklisted({ local: true });
  const isMobile = useMedia6(config.media.md);
  const canSendMessages = elements.chat && (elements.chat.public_chat_enabled || elements.chat.private_chat_enabled || elements.chat.roles_whitelist && elements.chat.roles_whitelist.length) && !isLocalPeerBlacklisted;
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeStream = useLandscapeHLSStream();
  const streaming = isMobileHLSStream || isLandscapeStream;
  if (isMobile && ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.is_overlay) && !streaming)
    return /* @__PURE__ */ React48.createElement(React48.Fragment, null);
  return /* @__PURE__ */ React48.createElement(
    Flex,
    {
      css: {
        width: "100%",
        flex: "1 1 0",
        textAlign: "center",
        px: "$4"
      },
      align: "center",
      justify: "center"
    },
    /* @__PURE__ */ React48.createElement(Box, null, /* @__PURE__ */ React48.createElement(Box, { css: { m: "0 auto", mt: "$4", "@media (max-height: 575px)": { display: "none" } } }, /* @__PURE__ */ React48.createElement("img", { src: emptyChat, style: { display: "inline" }, alt: "Empty Chat", height: 132, width: 185 })), /* @__PURE__ */ React48.createElement(Text, { variant: "h5", css: { mt: "$8", c: "$on_surface_high" } }, canSendMessages ? "Start a conversation" : "No messages yet"), canSendMessages ? /* @__PURE__ */ React48.createElement(
      Text,
      {
        variant: "sm",
        css: { mt: "$4", maxWidth: "80%", textAlign: "center", mx: "auto", c: "$on_surface_medium" }
      },
      "There are no messages here yet. Start a conversation by sending a message."
    ) : null)
  );
};

// src/Prebuilt/components/hooks/usePinnedBy.tsx
init_define_process_env();
import { useEffect as useEffect15, useState as useState17 } from "react";
import { selectSessionStore as selectSessionStore4, useHMSStore as useHMSStore18 } from "@100mslive/react-sdk";
var usePinnedBy = (messageId) => {
  const pinnedMessages = useHMSStore18(selectSessionStore4("pinnedMessages" /* PINNED_MESSAGES */));
  const [pinnedBy, setPinnedBy] = useState17("");
  useEffect15(() => {
    let match18 = "";
    pinnedMessages == null ? void 0 : pinnedMessages.forEach((pinnedMessage) => {
      if (pinnedMessage.id === messageId) {
        match18 = pinnedMessage.pinnedBy;
      }
    });
    setPinnedBy(match18);
  }, [messageId, pinnedMessages]);
  return pinnedBy;
};

// src/Prebuilt/components/Chat/utils.ts
init_define_process_env();
var formatTime2 = (date) => {
  if (!(date instanceof Date)) {
    return "";
  }
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const suffix = hours > 11 ? "PM" : "AM";
  return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""}${minutes} ${suffix}`;
};
var CHAT_MESSAGE_LIMIT = 2e3;

// src/Prebuilt/components/Chat/ChatBody.tsx
var rowHeights = {};
var listInstance = null;
function getRowHeight(index) {
  var _a8;
  return ((_a8 = rowHeights[index]) == null ? void 0 : _a8.size) || 72;
}
var setRowHeight = (index, id, size) => {
  var _a8, _b7;
  if (((_a8 = rowHeights[index]) == null ? void 0 : _a8.id) === id && ((_b7 = rowHeights[index]) == null ? void 0 : _b7.size) === size) {
    return;
  }
  listInstance == null ? void 0 : listInstance.resetAfterIndex(Math.max(index - 1, 0));
  Object.assign(rowHeights, { [index]: { size, id } });
};
var getMessageBackgroundColor = (messageType, selectedPeerID, selectedRole, isOverlay) => {
  if (messageType && !(selectedPeerID || selectedRole)) {
    return isOverlay ? "rgba(0, 0, 0, 0.64)" : "$surface_default";
  }
  return "";
};
var MessageTypeContainer = ({ left, right }) => {
  return /* @__PURE__ */ React49.createElement(
    Flex,
    {
      align: "center",
      css: {
        ml: "$2",
        mr: "$4",
        gap: "$space$2",
        flexWrap: "nowrap"
      }
    },
    left && /* @__PURE__ */ React49.createElement(
      Text,
      {
        variant: "xs",
        as: "span",
        css: {
          color: "$on_surface_medium",
          textTransform: "capitalize",
          fontWeight: "$regular",
          whiteSpace: "nowrap"
        }
      },
      left
    ),
    right && /* @__PURE__ */ React49.createElement(
      Text,
      {
        as: "span",
        variant: "overline",
        css: {
          color: "$on_surface_medium",
          fontWeight: "$regular",
          whiteSpace: "nowrap"
        }
      },
      right
    )
  );
};
var MessageType = ({
  roles,
  hasCurrentUserSent,
  receiver
}) => {
  const peerName = useHMSStore19(selectPeerNameByID2(receiver));
  const localPeerRoleName = useHMSStore19(selectLocalPeerRoleName);
  if (receiver) {
    return /* @__PURE__ */ React49.createElement(MessageTypeContainer, { left: hasCurrentUserSent ? `${peerName ? `to ${peerName}` : ""}` : "to You", right: "(DM)" });
  }
  if (roles && roles.length) {
    return /* @__PURE__ */ React49.createElement(MessageTypeContainer, { left: `to ${hasCurrentUserSent ? roles[0] : localPeerRoleName}`, right: "(Group)" });
  }
  return null;
};
var URL_REGEX = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
var Link2 = styled("a", {
  color: "$primary_default",
  wordBreak: "break-word",
  "&:hover": {
    textDecoration: "underline"
  }
});
var AnnotisedMessage = ({ message, length }) => {
  if (!message) {
    return /* @__PURE__ */ React49.createElement(Fragment6, null);
  }
  return /* @__PURE__ */ React49.createElement(Fragment6, null, message.trim().split(/(\s)/).map(
    (part) => URL_REGEX.test(part) ? /* @__PURE__ */ React49.createElement(Link2, { href: part, key: part, target: "_blank", rel: "noopener noreferrer" }, part.slice(0, length)) : part.slice(0, length)
  ));
};
var getMessageType = ({ roles, receiver }) => {
  if (roles && roles.length > 0) {
    return "role";
  }
  return receiver ? "private" : "";
};
var SenderName = styled(Text, {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: "100%",
  minWidth: 0,
  color: "$on_surface_high",
  fontWeight: "$semiBold"
});
var ChatMessage = React49.memo(
  ({ index, style = {}, message }) => {
    var _a8, _b7, _c;
    const { elements } = useRoomLayoutConferencingScreen();
    const rowRef = useRef12(null);
    const isMobile = useMedia7(config.media.md);
    const isPrivateChatEnabled = !!((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.private_chat_enabled);
    const isOverlay = ((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.is_overlay) && isMobile;
    const localPeerId = useHMSStore19(selectLocalPeerID2);
    const [selectedRole, setRoleSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.ROLE);
    const [selectedPeer, setPeerSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.PEER);
    const messageType = getMessageType({
      roles: message.recipientRoles,
      receiver: message.recipientPeer
    });
    const [openSheet, setOpenSheetBare] = useState18(false);
    const showPinAction = !!((_c = elements == null ? void 0 : elements.chat) == null ? void 0 : _c.allow_pinning_messages);
    const showReply = message.sender !== selectedPeer.id && message.sender !== localPeerId && isPrivateChatEnabled;
    useLayoutEffect(() => {
      if (rowRef.current) {
        setRowHeight(index, message.id, rowRef.current.clientHeight);
      }
    }, [index, message.id]);
    const setOpenSheet = (value, e) => {
      e == null ? void 0 : e.stopPropagation();
      setOpenSheetBare(value);
    };
    return /* @__PURE__ */ React49.createElement(
      Box,
      {
        css: {
          mb: "$5",
          pr: "$10",
          mt: "$4",
          "&:not(:hover} .chat_actions": { display: "none" },
          "&:hover .chat_actions": { display: "flex", opacity: 1 }
        },
        style
      },
      /* @__PURE__ */ React49.createElement(
        Flex,
        {
          ref: rowRef,
          align: "center",
          css: {
            flexWrap: "wrap",
            position: "relative",
            // Theme independent color, token should not be used for transparent chat
            background: getMessageBackgroundColor(messageType, selectedPeer.id, selectedRole, !!isOverlay),
            r: "$1",
            p: "$4",
            userSelect: "none",
            "@md": {
              cursor: "pointer"
            },
            "&:hover": {
              background: "linear-gradient(277deg, $surface_default 0%, $surface_dim 60.87%)"
            }
          },
          "data-testid": "chat_msg",
          onClick: (e) => {
            if (isMobile) {
              setOpenSheet(true, e);
            }
          }
        },
        /* @__PURE__ */ React49.createElement(PinnedBy, { messageId: message.id, index, rowRef }),
        /* @__PURE__ */ React49.createElement(
          Text,
          {
            css: {
              color: isOverlay ? "#FFF" : "$on_surface_high",
              fontWeight: "$semiBold",
              display: "flex",
              alignItems: "center",
              alignSelf: "stretch",
              width: "100%"
            },
            as: "div"
          },
          /* @__PURE__ */ React49.createElement(
            Flex,
            {
              align: "baseline",
              css: {
                flexWrap: "nowrap",
                maxWidth: "calc(100% - 10ch)",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }
            },
            message.senderName === "You" || !message.senderName ? /* @__PURE__ */ React49.createElement(
              SenderName,
              {
                as: "span",
                variant: "sub2",
                css: { color: isOverlay ? "#FFF" : "$on_surface_high", fontWeight: "$semiBold" }
              },
              message.senderName || "Anonymous"
            ) : /* @__PURE__ */ React49.createElement(Tooltip, { title: message.senderName, side: "top", align: "start", boxCss: { zIndex: 50 } }, /* @__PURE__ */ React49.createElement(
              SenderName,
              {
                as: "span",
                variant: "sub2",
                css: { color: isOverlay ? "#FFF" : "$on_surface_high", fontWeight: "$semiBold" }
              },
              message.sender === localPeerId ? `${message.senderName} (You)` : message.senderName
            )),
            /* @__PURE__ */ React49.createElement(
              MessageType,
              {
                hasCurrentUserSent: message.sender === localPeerId,
                receiver: message.recipientPeer,
                roles: message.recipientRoles
              }
            )
          ),
          !isOverlay ? /* @__PURE__ */ React49.createElement(
            Text,
            {
              as: "span",
              variant: "caption",
              css: {
                color: "$on_surface_medium",
                flexShrink: 0,
                position: "absolute",
                right: 0,
                zIndex: 1,
                mr: "$4",
                p: "$2"
              }
            },
            formatTime2(message.time)
          ) : null,
          /* @__PURE__ */ React49.createElement(
            ChatActions,
            {
              showPinAction,
              message,
              sentByLocalPeer: message.sender === localPeerId,
              onReply: () => {
                setRoleSelector("");
                setPeerSelector({ id: message.sender, name: message.senderName });
              },
              onReplyGroup: () => {
                if (message.senderRole) {
                  setRoleSelector(message.senderRole);
                  setPeerSelector({});
                }
              },
              showReply,
              isMobile,
              openSheet,
              setOpenSheet
            }
          )
        ),
        /* @__PURE__ */ React49.createElement(
          Text,
          {
            variant: "sm",
            css: {
              w: "100%",
              mt: "$2",
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              userSelect: "all",
              color: isOverlay ? "#FFF" : "$on_surface_high"
            },
            onClick: (e) => {
              setOpenSheet(true, e);
            }
          },
          /* @__PURE__ */ React49.createElement(AnnotisedMessage, { message: message.message })
        )
      )
    );
  }
);
var MessageWrapper = React49.memo(
  ({ index, style, data: data3 }) => {
    return /* @__PURE__ */ React49.createElement(ChatMessage, { style, index, key: data3[index].id, message: data3[index] });
  }
);
var VirtualizedChatMessages = React49.forwardRef(({ messages, scrollToBottom }, listRef) => {
  const hmsActions = useHMSActions14();
  const itemKey2 = useCallback15((index, data3) => {
    return data3[index].id;
  }, []);
  useEffect16(() => {
    requestAnimationFrame(() => scrollToBottom(1));
  }, [scrollToBottom]);
  return /* @__PURE__ */ React49.createElement(
    Box,
    {
      css: {
        mr: "-$10",
        h: "100%"
      }
    },
    /* @__PURE__ */ React49.createElement(
      AutoSizer,
      {
        style: {
          width: "90%"
        }
      },
      ({ height, width }) => /* @__PURE__ */ React49.createElement(
        VariableSizeList,
        {
          ref: (node) => {
            if (node) {
              listRef.current = node;
              listInstance = node;
            }
          },
          itemCount: messages.length,
          itemSize: getRowHeight,
          itemData: messages,
          width,
          height,
          style: {
            overflowX: "hidden"
          },
          itemKey: itemKey2,
          onItemsRendered: ({ visibleStartIndex, visibleStopIndex }) => {
            for (let i = visibleStartIndex; i <= visibleStopIndex; i++) {
              if (!messages[i].read) {
                hmsActions.setMessageRead(true, messages[i].id);
              }
            }
          }
        },
        MessageWrapper
      )
    )
  );
});
var ChatBody = React49.forwardRef(
  ({ scrollToBottom }, listRef) => {
    const messages = useHMSStore19(selectHMSMessages);
    const blacklistedMessageIDs = useHMSStore19(selectSessionStore5("chatMessageBlacklist" /* CHAT_MESSAGE_BLACKLIST */));
    const filteredMessages = useMemo6(() => {
      const blacklistedMessageIDSet = new Set(blacklistedMessageIDs || []);
      return (messages == null ? void 0 : messages.filter((message) => message.type === "chat" && !blacklistedMessageIDSet.has(message.id))) || [];
    }, [blacklistedMessageIDs, messages]);
    const vanillaStore = useHMSVanillaStore8();
    const rerenderOnFirstMount = useRef12(false);
    useEffect16(() => {
      const unsubscribe = vanillaStore.subscribe(() => {
        if (!listRef.current) {
          return;
        }
        const outerElement = listRef.current._outerRef;
        if (outerElement && outerElement.clientHeight + outerElement.scrollTop + outerElement.offsetTop >= outerElement.scrollHeight) {
          requestAnimationFrame(() => scrollToBottom(1));
        }
      }, selectUnreadHMSMessagesCount);
      return unsubscribe;
    }, [vanillaStore, listRef, scrollToBottom]);
    useEffect16(() => {
      if (filteredMessages.length > 0 && (listRef == null ? void 0 : listRef.current) && !rerenderOnFirstMount.current) {
        rerenderOnFirstMount.current = true;
        listRef.current.resetAfterIndex(0);
      }
    }, [listRef, filteredMessages]);
    return filteredMessages.length === 0 ? /* @__PURE__ */ React49.createElement(EmptyChat, null) : /* @__PURE__ */ React49.createElement(VirtualizedChatMessages, { messages: filteredMessages, ref: listRef, scrollToBottom });
  }
);
var PinnedBy = ({
  messageId,
  index,
  rowRef
}) => {
  const pinnedBy = usePinnedBy(messageId);
  const localPeerName = useHMSStore19(selectLocalPeerName2);
  useLayoutEffect(() => {
    if (rowRef == null ? void 0 : rowRef.current) {
      if (pinnedBy) {
        rowRef.current.style.background = "linear-gradient(277deg, var(--hms-ui-colors-surface_default) 0%, var(--hms-ui-colors-surface_dim) 60.87%)";
      } else {
        rowRef.current.style.background = "";
      }
      setRowHeight(index, messageId, rowRef == null ? void 0 : rowRef.current.clientHeight);
    }
  }, [index, messageId, pinnedBy, rowRef]);
  if (!pinnedBy) {
    return null;
  }
  return /* @__PURE__ */ React49.createElement(Flex, { align: "center", css: { gap: "$2", mb: "$2", color: "$on_surface_low" } }, /* @__PURE__ */ React49.createElement(SolidPinIcon, { height: 12, width: 12 }), /* @__PURE__ */ React49.createElement(Text, { variant: "xs", css: { color: "inherit" } }, "Pinned by ", localPeerName === pinnedBy ? "you" : pinnedBy));
};

// src/Prebuilt/components/PIP/PIPChat.tsx
var PIPChat = () => {
  var _a8, _b7, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const messages = useHMSStore20(selectHMSMessages2);
  const localPeerID = useHMSStore20(selectLocalPeerID3);
  const count = useHMSStore20(selectUnreadHMSMessagesCount2);
  const [unreadMessageCount, setUnreadMessageCount] = useState19(0);
  const getSenderName = useCallback16(
    (senderName, senderID) => {
      const slicedName = senderName.length > 10 ? senderName.slice(0, 10) + "..." : senderName;
      return slicedName + (senderID === localPeerID ? " (You)" : "");
    },
    [localPeerID]
  );
  useEffect17(() => {
    const timeoutId = setTimeout(() => {
      setUnreadMessageCount(count);
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [count]);
  const blacklistedMessageIDs = useHMSStore20(selectSessionStore6("chatMessageBlacklist" /* CHAT_MESSAGE_BLACKLIST */));
  const filteredMessages = useMemo7(() => {
    const blacklistedMessageIDSet = new Set(blacklistedMessageIDs || []);
    return (messages == null ? void 0 : messages.filter((message) => message.type === "chat" && !blacklistedMessageIDSet.has(message.id))) || [];
  }, [blacklistedMessageIDs, messages]);
  const { enabled: isChatEnabled = true, updatedBy: chatStateUpdatedBy = "" } = useHMSStore20(selectSessionStore6("chatState" /* CHAT_STATE */)) || {};
  const isLocalPeerBlacklisted = useIsPeerBlacklisted({ local: true });
  const { elements } = useRoomLayoutConferencingScreen();
  const message_placeholder = ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.message_placeholder) || "Send a message";
  const canSendChatMessages = !!((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.public_chat_enabled) || !!((_d = (_c = elements == null ? void 0 : elements.chat) == null ? void 0 : _c.roles_whitelist) == null ? void 0 : _d.length) || !!((_e = elements == null ? void 0 : elements.chat) == null ? void 0 : _e.private_chat_enabled);
  const getChatStatus = useCallback16(() => {
    if (isLocalPeerBlacklisted)
      return "You've been blocked from sending messages";
    if (!isChatEnabled)
      return `Chat has been paused by ${chatStateUpdatedBy.peerId === localPeerID ? "you" : chatStateUpdatedBy == null ? void 0 : chatStateUpdatedBy.userName}`;
    return message_placeholder;
  }, [
    chatStateUpdatedBy.peerId,
    chatStateUpdatedBy == null ? void 0 : chatStateUpdatedBy.userName,
    isChatEnabled,
    isLocalPeerBlacklisted,
    localPeerID,
    message_placeholder
  ]);
  return /* @__PURE__ */ React50.createElement("div", { style: { height: "100vh" } }, /* @__PURE__ */ React50.createElement(
    Box,
    {
      id: "chat-container",
      css: {
        bg: "$surface_dim",
        overflowY: "auto",
        // Subtracting height of footer
        h: canSendChatMessages ? "calc(100% - 87px)" : "100%",
        position: "relative"
      }
    },
    unreadMessageCount ? /* @__PURE__ */ React50.createElement(
      Box,
      {
        id: "new-message-notif",
        style: {
          position: "fixed",
          bottom: "76px",
          right: "4px"
        }
      },
      /* @__PURE__ */ React50.createElement(
        Text,
        {
          variant: "xs",
          css: { cursor: "pointer" },
          style: { color: "white", background: "gray", padding: "4px", borderRadius: "4px" }
        },
        unreadMessageCount === 1 ? "New message" : `${unreadMessageCount} new messages`
      )
    ) : "",
    filteredMessages.length === 0 ? /* @__PURE__ */ React50.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center"
        }
      },
      /* @__PURE__ */ React50.createElement(Text, { variant: "h5", css: { mt: "$8", c: "$on_surface_high" } }, canSendChatMessages ? "Start a conversation" : "No messages yet"),
      canSendChatMessages ? /* @__PURE__ */ React50.createElement(Text, { variant: "sm", style: { maxWidth: "80%", textAlign: "center", marginTop: "4px" } }, "There are no messages here yet. Start a conversation by sending a message.") : ""
    ) : filteredMessages.map((message) => /* @__PURE__ */ React50.createElement(Box, { className: "pip-message", key: message.id, id: message.id, style: { padding: "8px 0.75rem" } }, /* @__PURE__ */ React50.createElement(Flex, { style: { width: "100%", alignItems: "center", justifyContent: "between" } }, /* @__PURE__ */ React50.createElement(
      Text,
      {
        style: { display: "flex", justifyContent: "between", width: "100%", alignItems: "center" },
        css: {
          color: "$on_surface_high",
          fontWeight: "$semiBold"
        }
      },
      /* @__PURE__ */ React50.createElement(Flex, { style: { flexGrow: 1, gap: "2px", alignItems: "center" } }, message.senderName === "You" || !message.senderName ? /* @__PURE__ */ React50.createElement(Text, { as: "span", variant: "sub2", css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, message.senderName || "Anonymous") : /* @__PURE__ */ React50.createElement(Tooltip, { title: message.senderName, side: "top", align: "start" }, /* @__PURE__ */ React50.createElement(Text, { as: "span", variant: "sub2", css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, getSenderName(message.senderName, message == null ? void 0 : message.sender))), /* @__PURE__ */ React50.createElement(
        MessageTitle,
        {
          localPeerID,
          recipientPeer: message.recipientPeer,
          recipientRoles: message.recipientRoles
        }
      )),
      /* @__PURE__ */ React50.createElement(
        Text,
        {
          variant: "xs",
          css: {
            color: "$on_surface_medium",
            flexShrink: 0,
            p: "$2",
            whitespace: "nowrap"
          }
        },
        formatTime2(message.time)
      )
    )), /* @__PURE__ */ React50.createElement(
      Text,
      {
        variant: "sm",
        css: {
          w: "100%",
          mt: "$2",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          userSelect: "all",
          color: "$on_surface_high"
        }
      },
      /* @__PURE__ */ React50.createElement(AnnotisedMessage, { message: message.message })
    ))),
    /* @__PURE__ */ React50.createElement("div", { id: "marker", style: { height: filteredMessages.length ? "1px" : 0 } })
  ), canSendChatMessages && /* @__PURE__ */ React50.createElement(Box, { css: { bg: "$surface_dim" } }, /* @__PURE__ */ React50.createElement(Flex, { css: { px: "$4", pb: "3px", gap: "$2", alignItems: "center" } }, /* @__PURE__ */ React50.createElement(Text, { variant: "caption" }, "To:"), /* @__PURE__ */ React50.createElement(Flex, { css: { bg: "$primary_bright", color: "$on_primary_high", r: "$2" } }, /* @__PURE__ */ React50.createElement(
    "select",
    {
      id: "selector",
      style: {
        background: "inherit",
        color: "inherit",
        border: "none",
        outline: "none",
        borderRadius: "4px",
        padding: "0 2px"
      },
      defaultValue: ((_f = elements.chat) == null ? void 0 : _f.public_chat_enabled) ? "Everyone" : (_h = (_g = elements.chat) == null ? void 0 : _g.roles_whitelist) == null ? void 0 : _h[0]
    },
    (_j = (_i = elements.chat) == null ? void 0 : _i.roles_whitelist) == null ? void 0 : _j.map((role) => /* @__PURE__ */ React50.createElement("option", { key: role, value: role }, role)),
    ((_k = elements.chat) == null ? void 0 : _k.public_chat_enabled) ? /* @__PURE__ */ React50.createElement("option", { value: "Everyone" }, "Everyone") : ""
  ))), /* @__PURE__ */ React50.createElement(
    Flex,
    {
      align: "center",
      css: {
        bg: "$surface_default",
        minHeight: "$16",
        width: "100%",
        py: "$6",
        pl: "$4",
        boxSizing: "border-box",
        gap: "$2",
        r: "$2"
      }
    },
    /* @__PURE__ */ React50.createElement(
      TextArea,
      {
        id: "chat-input",
        maxLength: CHAT_MESSAGE_LIMIT,
        disabled: !isChatEnabled || isLocalPeerBlacklisted,
        rows: 1,
        css: {
          w: "100%",
          c: "$on_surface_high",
          p: "0.75rem 0.75rem !important",
          border: "none",
          resize: "none"
        },
        placeholder: getChatStatus(),
        required: true,
        autoComplete: "off",
        "aria-autocomplete": "none"
      }
    ),
    /* @__PURE__ */ React50.createElement(
      IconButton_default,
      {
        id: "send-btn",
        disabled: !isChatEnabled || isLocalPeerBlacklisted,
        title: getChatStatus(),
        css: {
          ml: "auto",
          height: "max-content",
          mr: "$4",
          "&:hover": { c: "$on_surface_medium" }
        },
        "data-testid": "send_msg_btn"
      },
      /* @__PURE__ */ React50.createElement(SendIcon, null)
    )
  )));
};
var MessageTitle = ({
  recipientPeer,
  recipientRoles,
  localPeerID
}) => {
  const peerName = useHMSStore20(selectPeerNameByID3(recipientPeer));
  return /* @__PURE__ */ React50.createElement(React50.Fragment, null, recipientRoles ? /* @__PURE__ */ React50.createElement(Text, { as: "span", variant: "sub2", css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, "to ", recipientRoles, " (Group)") : null, recipientPeer ? /* @__PURE__ */ React50.createElement(Text, { as: "span", variant: "sub2", css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, "to ", recipientPeer === localPeerID ? "You" : peerName, " (DM)") : null);
};

// src/Prebuilt/components/PIP/PIPChatOption.tsx
init_define_process_env();
import React51 from "react";
import { ExternalLinkIcon } from "@100mslive/react-icons";
var PIPChatOption = ({ openChat, showPIPChat }) => {
  if (!showPIPChat) {
    return /* @__PURE__ */ React51.createElement(React51.Fragment, null);
  }
  return /* @__PURE__ */ React51.createElement(Dropdown.Item, { onClick: openChat, "data-testid": "pip_chat_btn" }, /* @__PURE__ */ React51.createElement(ExternalLinkIcon, null), /* @__PURE__ */ React51.createElement(Text, { variant: "sm", css: { ml: "$4", color: "$on_surface_high" } }, "Pop out Chat"));
};

// src/Prebuilt/components/PIP/PIPWindow.tsx
init_define_process_env();
import { createPortal } from "react-dom";
var PIPWindow = ({ pipWindow, children }) => {
  pipWindow.document.body.style.margin = "0";
  pipWindow.document.body.style.overflow = "clip";
  return createPortal(children, pipWindow.document.body);
};

// src/Prebuilt/components/RoleChangeModal.tsx
init_define_process_env();
import React52, { useRef as useRef13, useState as useState20 } from "react";
import { useMedia as useMedia8 } from "react-use";
import { selectAvailableRoleNames as selectAvailableRoleNames3, selectPeerByID, useHMSActions as useHMSActions15, useHMSStore as useHMSStore21 } from "@100mslive/react-sdk";
import { ChevronDownIcon as ChevronDownIcon3, ChevronUpIcon as ChevronUpIcon3, CrossIcon as CrossIcon8 } from "@100mslive/react-icons";
var HighlightTerm = ({ value }) => {
  return value ? /* @__PURE__ */ React52.createElement(Tooltip, { side: "top", title: value }, /* @__PURE__ */ React52.createElement(
    Text,
    {
      variant: "body2",
      css: {
        color: "$on_surface_medium",
        fontWeight: "$semiBold"
      }
    },
    "'",
    value.slice(0, 100),
    value.length > 100 ? "..." : "",
    "'"
  )) : /* @__PURE__ */ React52.createElement(React52.Fragment, null);
};
var RoleChangeContent = ({
  peer,
  onOpenChange,
  isMobile = false
}) => {
  var _a8;
  const roles = useHMSStore21(selectAvailableRoleNames3).filter(
    (role) => role !== (peer == null ? void 0 : peer.roleName) && role !== "__internal_recorder"
  );
  const [selectedRole, setRole] = useState20(((_a8 = roles.filter((role) => role !== (peer == null ? void 0 : peer.roleName))) == null ? void 0 : _a8[0]) || (peer == null ? void 0 : peer.roleName));
  const hmsActions = useHMSActions15();
  const [open, setOpen] = useState20(false);
  const triggerRef = useRef13();
  return /* @__PURE__ */ React52.createElement(React52.Fragment, null, /* @__PURE__ */ React52.createElement(Flex, { align: "center", justify: "between", css: { w: "100%" } }, /* @__PURE__ */ React52.createElement(Text, { as: "h6", variant: "h6" }, "Switch Role"), isMobile && /* @__PURE__ */ React52.createElement(CrossIcon8, { onClick: () => onOpenChange(false) })), /* @__PURE__ */ React52.createElement(Box, null, /* @__PURE__ */ React52.createElement(
    Text,
    {
      variant: "sm",
      css: {
        mt: "$4",
        mb: "$8",
        c: "$on_surface_medium",
        display: "flex",
        flexWrap: "wrap",
        columnGap: "4px"
      }
    },
    "Switch the role of",
    /* @__PURE__ */ React52.createElement(HighlightTerm, { value: peer.name }),
    "from ",
    /* @__PURE__ */ React52.createElement(HighlightTerm, { value: peer.roleName }),
    " to"
  )), /* @__PURE__ */ React52.createElement(
    Flex,
    {
      align: "center",
      css: {
        w: "100%",
        mb: "$10"
      }
    },
    /* @__PURE__ */ React52.createElement(
      Box,
      {
        css: {
          position: "relative",
          flex: "1 1 0",
          minWidth: 0
        }
      },
      /* @__PURE__ */ React52.createElement(Dropdown.Root, { open, onOpenChange: setOpen, css: { width: "100%" } }, /* @__PURE__ */ React52.createElement(
        Dropdown.Trigger,
        {
          ref: triggerRef,
          "data-testid": "open_role_selection_dropdown",
          asChild: true,
          css: {
            bg: "$surface_default",
            r: "$1",
            p: "$6 $9"
          }
        },
        /* @__PURE__ */ React52.createElement(Flex, { align: "center", justify: "between", css: { width: "100%" } }, /* @__PURE__ */ React52.createElement(Text, null, selectedRole), open ? /* @__PURE__ */ React52.createElement(ChevronUpIcon3, null) : /* @__PURE__ */ React52.createElement(ChevronDownIcon3, null))
      ), /* @__PURE__ */ React52.createElement(Dropdown.Content, { align: "start", sideOffset: 8, css: { zIndex: 1e3, w: "100%" } }, roles.map((role) => {
        var _a9;
        return /* @__PURE__ */ React52.createElement(
          Dropdown.Item,
          {
            "data-testid": role,
            key: role,
            onSelect: () => setRole(role),
            css: { w: `${(_a9 = triggerRef.current) == null ? void 0 : _a9.clientWidth}px` }
          },
          role
        );
      })))
    )
  ), /* @__PURE__ */ React52.createElement(Flex, { justify: "center", align: "center", css: { width: "100%", gap: "$md" } }, !isMobile && /* @__PURE__ */ React52.createElement(
    Button,
    {
      variant: "standard",
      outlined: true,
      css: { width: "100%" },
      onClick: () => onOpenChange(false),
      "data-testid": "cancel_button"
    },
    "Cancel"
  ), /* @__PURE__ */ React52.createElement(
    Button,
    {
      "data-testid": "change_button",
      variant: "primary",
      css: { width: "100%" },
      onClick: () => __async(void 0, null, function* () {
        if (selectedRole) {
          yield hmsActions.changeRoleOfPeer(peer.id, selectedRole, true);
          onOpenChange(false);
        }
      })
    },
    "Switch Role"
  )));
};
var RoleChangeModal = ({
  peerId,
  onOpenChange
}) => {
  const peer = useHMSStore21(selectPeerByID(peerId));
  const isMobile = useMedia8(config.media.md);
  if (!peer) {
    return null;
  }
  if (isMobile) {
    return /* @__PURE__ */ React52.createElement(Sheet.Root, { open: true, onOpenChange, css: { borderRadius: "$0 $0 0 0" } }, /* @__PURE__ */ React52.createElement(Sheet.Content, { css: { p: "$10 $8", background: "$surface_dim", border: "1px solid $border_default" } }, /* @__PURE__ */ React52.createElement(RoleChangeContent, { peer, onOpenChange, isMobile: true })));
  }
  return /* @__PURE__ */ React52.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React52.createElement(Dialog.Portal, null, /* @__PURE__ */ React52.createElement(Dialog.Overlay, null), /* @__PURE__ */ React52.createElement(Dialog.Content, { css: { width: "min(400px,80%)", p: "$10", overflow: "visible" } }, /* @__PURE__ */ React52.createElement(RoleChangeContent, { peer, onOpenChange }))));
};

// src/Prebuilt/components/Settings/StartRecording.jsx
init_define_process_env();
import React55, { useState as useState22 } from "react";
import { selectPermissions as selectPermissions6, useHMSActions as useHMSActions16, useHMSStore as useHMSStore22, useRecordingStreaming as useRecordingStreaming5 } from "@100mslive/react-sdk";
import { AlertTriangleIcon as AlertTriangleIcon3 } from "@100mslive/react-icons";

// src/Prebuilt/components/Streaming/ResolutionInput.jsx
init_define_process_env();
import React54, { useCallback as useCallback17, useState as useState21 } from "react";
import { InfoIcon } from "@100mslive/react-icons";

// src/Prebuilt/primitives/DialogContent.jsx
init_define_process_env();
import React53, { useRef as useRef14 } from "react";
import { CheckIcon as CheckIcon2, CloudUploadIcon, CrossIcon as CrossIcon9 } from "@100mslive/react-icons";
var DialogContent = (_a8) => {
  var _b7 = _a8, { Icon: Icon4, title, closeable = true, children, css: css2, iconCSS = {} } = _b7, props = __objRest(_b7, ["Icon", "title", "closeable", "children", "css", "iconCSS"]);
  return /* @__PURE__ */ React53.createElement(Dialog.Portal, null, /* @__PURE__ */ React53.createElement(Dialog.Overlay, null), /* @__PURE__ */ React53.createElement(Dialog.Content, __spreadValues({ css: __spreadValues({ width: "min(600px, 100%)" }, css2) }, props), /* @__PURE__ */ React53.createElement(Dialog.Title, null, /* @__PURE__ */ React53.createElement(Flex, { justify: "between" }, /* @__PURE__ */ React53.createElement(Flex, { align: "center", css: { mb: "$1" } }, Icon4 ? /* @__PURE__ */ React53.createElement(Flex, { css: __spreadValues(__spreadValues({ mr: "$2", color: "$on_primary_high" }, flexCenter), iconCSS) }, /* @__PURE__ */ React53.createElement(Icon4, null)) : null, /* @__PURE__ */ React53.createElement(Text, { variant: "h6", inline: true }, title)), closeable && /* @__PURE__ */ React53.createElement(Dialog.DefaultClose, { "data-testid": "dialoge_cross_icon" }))), /* @__PURE__ */ React53.createElement(HorizontalDivider, { css: { mt: "0.8rem" } }), /* @__PURE__ */ React53.createElement(Box, null, children)));
};
var ErrorDialog = (_a8) => {
  var _b7 = _a8, { open = true, onOpenChange, title, children } = _b7, props = __objRest(_b7, ["open", "onOpenChange", "title", "children"]);
  return /* @__PURE__ */ React53.createElement(Dialog.Root, { open, onOpenChange }, /* @__PURE__ */ React53.createElement(
    DialogContent,
    __spreadValues({
      Icon: CrossIcon9,
      title,
      onInteractOutside: (e) => e.preventDefault(),
      onEscapeKeyDown: (e) => e.preventDefault(),
      onPointerDownOutside: (e) => e.preventDefault(),
      closeable: false,
      iconCSS: { color: "$alert_error_default" }
    }, props),
    /* @__PURE__ */ React53.createElement(Box, { css: { mt: "$lg" } }, children)
  ));
};
var RequestDialog = ({ open = true, onOpenChange, title, body, actionText = "Accept", onAction, Icon: Icon4 }) => /* @__PURE__ */ React53.createElement(Dialog.Root, { open, onOpenChange }, /* @__PURE__ */ React53.createElement(Dialog.Portal, null, /* @__PURE__ */ React53.createElement(Dialog.Overlay, null), /* @__PURE__ */ React53.createElement(Dialog.Content, { css: { width: "min(400px,80%)", p: "$10" } }, /* @__PURE__ */ React53.createElement(Dialog.Title, { css: { p: 0, display: "flex", flexDirection: "row", gap: "$md" } }, Icon4 ? Icon4 : null, /* @__PURE__ */ React53.createElement(Text, { variant: "h6" }, title)), typeof body === "string" ? /* @__PURE__ */ React53.createElement(
  Text,
  {
    variant: "md",
    css: {
      fontWeight: 400,
      mt: "$4",
      mb: "$10",
      c: "$on_surface_medium"
    }
  },
  body
) : /* @__PURE__ */ React53.createElement(Box, { css: { mt: "$4", mb: "$10" } }, body), /* @__PURE__ */ React53.createElement(Flex, { justify: "center", align: "center", css: { width: "100%", gap: "$md" } }, /* @__PURE__ */ React53.createElement(Box, { css: { width: "50%" } }, /* @__PURE__ */ React53.createElement(Dialog.Close, { css: { width: "100%" } }, /* @__PURE__ */ React53.createElement(Button, { variant: "standard", outlined: true, css: { width: "100%" } }, "Cancel"))), /* @__PURE__ */ React53.createElement(Box, { css: { width: "50%" } }, /* @__PURE__ */ React53.createElement(Button, { variant: "primary", css: { width: "100%" }, onClick: onAction }, actionText))))));
var DialogRow = ({ children, breakSm = false, css: css2, justify = "between" }) => {
  let finalCSS = {
    margin: "$10 0",
    w: "100%"
  };
  if (breakSm) {
    finalCSS["@sm"] = {
      flexDirection: "column",
      alignItems: "flex-start"
    };
  }
  if (css2) {
    finalCSS = Object.assign(finalCSS, css2);
  }
  return /* @__PURE__ */ React53.createElement(Flex, { align: "center", justify, css: finalCSS }, children);
};
var DialogCol = (_a8) => {
  var _b7 = _a8, { children, breakSm = false, css: css2, align = "center", justify = "between" } = _b7, props = __objRest(_b7, ["children", "breakSm", "css", "align", "justify"]);
  let finalCSS = {
    margin: "$10 0",
    w: "100%"
  };
  if (breakSm) {
    finalCSS["@sm"] = {
      alignItems: "flex-start"
    };
  }
  if (css2) {
    finalCSS = Object.assign(finalCSS, css2);
  }
  return /* @__PURE__ */ React53.createElement(Flex, __spreadValues({ direction: "column", align, justify, css: finalCSS }, props), children);
};
var DialogSelect = (_a8) => {
  var _b7 = _a8, { title, options, keyField, labelField, selected, onChange } = _b7, props = __objRest(_b7, ["title", "options", "keyField", "labelField", "selected", "onChange"]);
  return /* @__PURE__ */ React53.createElement(DialogRow, { breakSm: true }, /* @__PURE__ */ React53.createElement(Label3, null, title), /* @__PURE__ */ React53.createElement(Select.Root, __spreadValues({ "data-testid": `dialog_select_${title}`, css: { width: "70%", "@sm": { width: "100%" } } }, props), /* @__PURE__ */ React53.createElement(Select.DefaultDownIcon, null), /* @__PURE__ */ React53.createElement(Select.Select, { onChange: (e) => onChange(e.target.value), value: selected, css: { width: "100%" } }, options.map((option) => {
    const id = keyField ? option[keyField] : option;
    const label = labelField ? option[labelField] : option;
    return /* @__PURE__ */ React53.createElement("option", { value: id, key: id }, label);
  }))));
};
var DialogInputFile = (_a8) => {
  var _b7 = _a8, { value, onChange, placeholder, disabled, type } = _b7, props = __objRest(_b7, ["value", "onChange", "placeholder", "disabled", "type"]);
  const inputRef = useRef14();
  return /* @__PURE__ */ React53.createElement(
    DialogCol,
    {
      breakSm: true,
      onClick: () => {
        var _a9;
        return (_a9 = inputRef.current) == null ? void 0 : _a9.click();
      },
      css: {
        justifyContent: "center",
        position: "relative",
        cursor: "pointer",
        py: "$12",
        border: "1px dashed $border_bright",
        r: "$1",
        height: "max(140px, 30%)",
        alignItems: "center",
        m: "$6 0"
      },
      gap: "8"
    },
    /* @__PURE__ */ React53.createElement(
      IconButton,
      {
        variant: "standard",
        css: {
          border: "none",
          background: "none",
          "&:hover": {
            border: "none",
            background: "none",
            bg: "transparent !important"
          }
        }
      },
      /* @__PURE__ */ React53.createElement(
        CloudUploadIcon,
        {
          style: {
            width: "3rem",
            height: "3rem"
          }
        }
      )
    ),
    /* @__PURE__ */ React53.createElement(Flex, { direction: "row" }, /* @__PURE__ */ React53.createElement(
      Input,
      __spreadValues({
        ref: inputRef,
        css: { width: "70%", "@sm": { width: "100%" } },
        value,
        onChange: (e) => onChange(e.target),
        placeholder,
        disabled,
        type,
        hidden: true
      }, props)
    ), /* @__PURE__ */ React53.createElement(
      IconButton,
      {
        variant: "standard",
        css: {
          background: "none",
          border: "none",
          textDecoration: "underline",
          "&:hover": {
            background: "none !important",
            border: "none !important"
          }
        }
      },
      /* @__PURE__ */ React53.createElement(Text, { variant: "md" }, placeholder)
    ))
  );
};

// src/Prebuilt/components/Streaming/ResolutionInput.jsx
var ResolutionInput = ({ onResolutionChange, disabled, tooltipText, css: css2, testId }) => {
  const [resolution, setResolution] = useState21(RTMP_RECORD_DEFAULT_RESOLUTION);
  const resolutionChangeHandler = useCallback17(
    (event) => {
      const { name, value } = event.target;
      let width = name === "resWidth" ? Number(value) : resolution.width;
      let height = name === "resHeight" ? Number(value) : resolution.height;
      if (width === 0) {
        width = null;
      }
      if (height === 0) {
        height = null;
      }
      const newResolution = {
        width: !isNaN(width) ? width : RTMP_RECORD_DEFAULT_RESOLUTION.width,
        height: !isNaN(height) ? height : RTMP_RECORD_DEFAULT_RESOLUTION.height
      };
      setResolution(newResolution);
    },
    [resolution]
  );
  return /* @__PURE__ */ React54.createElement(DialogRow, { breakSm: true, css: css2 }, /* @__PURE__ */ React54.createElement(Flex, { gap: 1 }, /* @__PURE__ */ React54.createElement(Label3, { css: { mb: "$8" } }, "Resolution"), tooltipText && /* @__PURE__ */ React54.createElement(Tooltip, { title: tooltipText }, /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(InfoIcon, { color: "#B0C3DB" })))), /* @__PURE__ */ React54.createElement(
    Flex,
    {
      justify: "between",
      css: { width: !tooltipText ? "100%" : "70%", "@sm": { width: "100%" } },
      gap: 2,
      direction: "column"
    },
    /* @__PURE__ */ React54.createElement(Flex, { justify: "between", gap: 2 }, /* @__PURE__ */ React54.createElement(Flex, { direction: "column", css: { width: "50%" } }, /* @__PURE__ */ React54.createElement(Text, { variant: "xs" }, "Width"), /* @__PURE__ */ React54.createElement(
      Input,
      {
        "data-testid": `${testId}_width`,
        css: { width: "100%", mt: "$4" },
        name: "resWidth",
        value: resolution.width,
        onChange: resolutionChangeHandler,
        readOnly: disabled,
        min: RTMP_RECORD_RESOLUTION_MIN,
        max: RTMP_RECORD_RESOLUTION_MAX,
        onBlur: () => onResolutionChange(resolution),
        type: "number"
      }
    )), /* @__PURE__ */ React54.createElement(Flex, { direction: "column", css: { width: "50%" } }, /* @__PURE__ */ React54.createElement(Text, { variant: "xs" }, "Height"), /* @__PURE__ */ React54.createElement(
      Input,
      {
        "data-testid": `${testId}_height`,
        css: { width: "100%", mt: "$4" },
        name: "resHeight",
        value: resolution.height,
        onChange: resolutionChangeHandler,
        onBlur: () => onResolutionChange(resolution),
        readOnly: disabled,
        min: RTMP_RECORD_RESOLUTION_MIN,
        max: RTMP_RECORD_RESOLUTION_MAX,
        type: "number"
      }
    )))
  ));
};

// src/Prebuilt/components/Settings/StartRecording.jsx
var StartRecording = ({ open, onOpenChange }) => {
  const permissions = useHMSStore22(selectPermissions6);
  const [resolution, setResolution] = useState22(RTMP_RECORD_DEFAULT_RESOLUTION);
  const { startRecording, recordingStarted } = useRecordingHandler();
  const { isBrowserRecordingOn, isStreamingOn, isHLSRunning } = useRecordingStreaming5();
  const hmsActions = useHMSActions16();
  if (!(permissions == null ? void 0 : permissions.browserRecording) || isHLSRunning) {
    return null;
  }
  if (isBrowserRecordingOn) {
    return /* @__PURE__ */ React55.createElement(Dialog.Root, { open, onOpenChange }, /* @__PURE__ */ React55.createElement(Dialog.Portal, null, /* @__PURE__ */ React55.createElement(
      Dialog.Content,
      {
        css: {
          width: "min(400px,80%)",
          p: "$10",
          bg: "#201617"
        }
      },
      /* @__PURE__ */ React55.createElement(Dialog.Title, null, /* @__PURE__ */ React55.createElement(Flex, { gap: 2, css: { c: "$alert_error_default" } }, /* @__PURE__ */ React55.createElement(AlertTriangleIcon3, null), /* @__PURE__ */ React55.createElement(Text, { css: { c: "inherit" }, variant: "h6" }, "End Recording"))),
      /* @__PURE__ */ React55.createElement(Text, { variant: "sm", css: { c: "$on_surface_medium", my: "$8" } }, "Are you sure you want to end recording? You can\u2019t undo this action."),
      /* @__PURE__ */ React55.createElement(Flex, { justify: "end", css: { mt: "$12" } }, /* @__PURE__ */ React55.createElement(Dialog.Close, { asChild: true }, /* @__PURE__ */ React55.createElement(Button, { outlined: true, css: { borderColor: "$secondary_bright", mr: "$4" } }, "Don't end")), /* @__PURE__ */ React55.createElement(
        Button,
        {
          "data-testid": "stop_recording_confirm_mobile",
          variant: "danger",
          icon: true,
          onClick: () => __async(void 0, null, function* () {
            try {
              yield hmsActions.stopRTMPAndRecording();
            } catch (error) {
              ToastManager.addToast({
                title: error.message,
                variant: "error"
              });
            }
            onOpenChange(false);
          })
        },
        "End recording"
      ))
    )));
  }
  return /* @__PURE__ */ React55.createElement(Dialog.Root, { open, onOpenChange }, /* @__PURE__ */ React55.createElement(Dialog.Content, { css: { width: "min(400px,80%)", p: "$10" } }, /* @__PURE__ */ React55.createElement(Dialog.Title, null, /* @__PURE__ */ React55.createElement(Text, { variant: "h6" }, "Start Recording")), /* @__PURE__ */ React55.createElement(
    ResolutionInput,
    {
      testId: "recording_resolution_mobile",
      css: { flexDirection: "column", alignItems: "start" },
      onResolutionChange: setResolution
    }
  ), /* @__PURE__ */ React55.createElement(
    Button,
    {
      "data-testid": "start_recording_confirm_mobile",
      variant: "primary",
      icon: true,
      css: { ml: "auto" },
      type: "submit",
      disabled: recordingStarted || isStreamingOn,
      onClick: () => __async(void 0, null, function* () {
        yield startRecording(resolution);
        onOpenChange(false);
      })
    },
    "Start"
  )));
};
var StartRecording_default = StartRecording;

// src/Prebuilt/components/StatsForNerds.jsx
init_define_process_env();
import React56, { useEffect as useEffect18, useMemo as useMemo8, useRef as useRef15, useState as useState23 } from "react";
import { useMedia as useMedia9 } from "react-use";
import { match as match4, P as P3 } from "ts-pattern";
import {
  selectHMSStats as selectHMSStats3,
  selectLocalPeerID as selectLocalPeerID4,
  selectPeersMap,
  selectTracksMap as selectTracksMap2,
  useHMSActions as useHMSActions17,
  useHMSStatsStore as useHMSStatsStore3,
  useHMSStore as useHMSStore23
} from "@100mslive/react-sdk";
var StatsForNerds = ({ open, onOpenChange }) => {
  var _a8, _b7;
  const mediaQueryLg = config.media.md;
  const isMobile = useMedia9(mediaQueryLg);
  const tracksWithLabels = useTracksWithLabel();
  const statsOptions = useMemo8(
    () => [{ id: "local-peer", label: "Local Peer Stats" }, ...tracksWithLabels],
    [tracksWithLabels]
  );
  const hmsActions = useHMSActions17();
  const details = hmsActions.getDebugInfo();
  const [selectedStat, setSelectedStat] = useState23(statsOptions[0]);
  const [showStatsOnTiles, setShowStatsOnTiles] = useSetUiSettings(UI_SETTINGS.showStatsOnTiles);
  const [openDropdown, setOpenDropdown] = useState23(false);
  const ref = useRef15();
  const selectionBg = useDropdownSelection();
  useEffect18(() => {
    if (selectedStat.id !== "local-peer" && !tracksWithLabels.find((track) => track.id === selectedStat.id)) {
      setSelectedStat("local-peer");
    }
  }, [tracksWithLabels, selectedStat]);
  return isMobile ? /* @__PURE__ */ React56.createElement(Sheet.Root, { open, onOpenChange }, /* @__PURE__ */ React56.createElement(
    Sheet.Content,
    {
      css: {
        bg: "$surface_dim",
        px: "$4",
        pb: "$4"
      }
    },
    /* @__PURE__ */ React56.createElement(Sheet.Title, { css: { py: "$10", px: "$8", alignItems: "center" } }, /* @__PURE__ */ React56.createElement(Flex, { justify: "between" }, /* @__PURE__ */ React56.createElement(Flex, { align: "center", css: { mb: "$1" } }, /* @__PURE__ */ React56.createElement(Text, { variant: "h6", inline: true }, "Stats For Nerds")), /* @__PURE__ */ React56.createElement(Dialog.DefaultClose, { "data-testid": "stats_dialog_close_icon" }))),
    /* @__PURE__ */ React56.createElement(HorizontalDivider, null),
    /* @__PURE__ */ React56.createElement(
      Flex,
      {
        direction: "column",
        css: {
          mr: "-$2",
          overflowY: "auto",
          maxHeight: "65vh",
          pr: "$6",
          pl: "$4"
        }
      },
      /* @__PURE__ */ React56.createElement(Flex, { justify: "start", gap: 4, css: { m: "$10 0" } }, /* @__PURE__ */ React56.createElement(Switch, { checked: showStatsOnTiles, onCheckedChange: setShowStatsOnTiles }), /* @__PURE__ */ React56.createElement(Text, { variant: "body2", css: { fontWeight: "$semiBold" } }, "Show Stats on Tiles")),
      /* @__PURE__ */ React56.createElement(
        Flex,
        {
          direction: "column",
          css: {
            mb: "$12",
            position: "relative",
            minWidth: 0
          }
        },
        /* @__PURE__ */ React56.createElement(Label3, { variant: "body2", css: { c: "$on_surface_high" } }, "Stats For"),
        /* @__PURE__ */ React56.createElement(Dropdown.Root, { "data-testid": "dialog_select_Stats For", open: openDropdown, onOpenChange: setOpenDropdown }, /* @__PURE__ */ React56.createElement(
          DialogDropdownTrigger,
          {
            title: selectedStat.label || "Select Stats",
            css: { mt: "$4" },
            titleCSS: { mx: 0 },
            open: openDropdown,
            ref
          }
        ), /* @__PURE__ */ React56.createElement(Dropdown.Portal, null, /* @__PURE__ */ React56.createElement(Dropdown.Content, { align: "start", sideOffset: 8, css: { w: (_a8 = ref.current) == null ? void 0 : _a8.clientWidth, zIndex: 1e3 } }, statsOptions.map((option) => {
          const isSelected = option.id === selectedStat.id && option.layer === selectedStat.layer;
          return /* @__PURE__ */ React56.createElement(
            Dropdown.Item,
            {
              key: `${option.id}-${option.layer || ""}`,
              onClick: () => {
                setSelectedStat(option);
              },
              css: {
                px: "$9",
                bg: isSelected ? selectionBg : void 0
              }
            },
            option.label
          );
        }))))
      ),
      selectedStat.id === "local-peer" ? /* @__PURE__ */ React56.createElement(LocalPeerStats, null) : /* @__PURE__ */ React56.createElement(TrackStats, { trackID: selectedStat.id, layer: selectedStat.layer, local: selectedStat.local }),
      /* @__PURE__ */ React56.createElement(Flex, { justify: "start", gap: 4, css: { m: "$10 0", w: "100%" } }, /* @__PURE__ */ React56.createElement(DebugInfo, { details }))
    )
  )) : /* @__PURE__ */ React56.createElement(Dialog.Root, { open, onOpenChange }, /* @__PURE__ */ React56.createElement(Dialog.Portal, null, /* @__PURE__ */ React56.createElement(Dialog.Overlay, null), /* @__PURE__ */ React56.createElement(
    Dialog.Content,
    {
      css: {
        width: "min(500px, 95%)",
        height: "min(656px, 90%)",
        overflowY: "auto"
      }
    },
    /* @__PURE__ */ React56.createElement(Dialog.Title, { css: { p: "$4 0" } }, /* @__PURE__ */ React56.createElement(Flex, { justify: "between" }, /* @__PURE__ */ React56.createElement(Flex, { align: "center", css: { mb: "$1" } }, /* @__PURE__ */ React56.createElement(Text, { variant: "h6", inline: true }, "Stats For Nerds")), /* @__PURE__ */ React56.createElement(Dialog.DefaultClose, { "data-testid": "stats_dialog_close_icon" }))),
    /* @__PURE__ */ React56.createElement(HorizontalDivider, { css: { mt: "0.8rem" } }),
    /* @__PURE__ */ React56.createElement(Flex, { justify: "start", gap: 4, css: { m: "$10 0" } }, /* @__PURE__ */ React56.createElement(Switch, { checked: showStatsOnTiles, onCheckedChange: setShowStatsOnTiles }), /* @__PURE__ */ React56.createElement(Text, { variant: "body2", css: { fontWeight: "$semiBold" } }, "Show Stats on Tiles")),
    /* @__PURE__ */ React56.createElement(
      Flex,
      {
        direction: "column",
        css: {
          mb: "$12",
          position: "relative",
          minWidth: 0
        }
      },
      /* @__PURE__ */ React56.createElement(Label3, { variant: "body2", css: { c: "$on_surface_high" } }, "Stats For"),
      /* @__PURE__ */ React56.createElement(Dropdown.Root, { "data-testid": "dialog_select_Stats For", open: openDropdown, onOpenChange: setOpenDropdown }, /* @__PURE__ */ React56.createElement(
        DialogDropdownTrigger,
        {
          title: selectedStat.label || "Select Stats",
          css: { mt: "$4" },
          titleCSS: { mx: 0 },
          open: openDropdown,
          ref
        }
      ), /* @__PURE__ */ React56.createElement(Dropdown.Portal, null, /* @__PURE__ */ React56.createElement(Dropdown.Content, { align: "start", sideOffset: 8, css: { w: (_b7 = ref.current) == null ? void 0 : _b7.clientWidth, zIndex: 1e3 } }, statsOptions.map((option) => {
        const isSelected = option.id === selectedStat.id && option.layer === selectedStat.layer;
        return /* @__PURE__ */ React56.createElement(
          Dropdown.Item,
          {
            key: `${option.id}-${option.layer || ""}`,
            onClick: () => {
              setSelectedStat(option);
            },
            css: {
              px: "$9",
              bg: isSelected ? selectionBg : void 0
            }
          },
          option.label
        );
      }))))
    ),
    selectedStat.id === "local-peer" ? /* @__PURE__ */ React56.createElement(LocalPeerStats, null) : /* @__PURE__ */ React56.createElement(TrackStats, { trackID: selectedStat.id, layer: selectedStat.layer, local: selectedStat.local }),
    /* @__PURE__ */ React56.createElement(Flex, { justify: "start", gap: 4, css: { m: "$10 0", w: "100%" } }, /* @__PURE__ */ React56.createElement(DebugInfo, { details }))
  )));
};
var useTracksWithLabel = () => {
  const tracksMap = useHMSStore23(selectTracksMap2);
  const peersMap = useHMSStore23(selectPeersMap);
  const localPeerID = useHMSStore23(selectLocalPeerID4);
  const tracksWithLabels = useMemo8(
    () => Object.values(tracksMap).reduce((res, track) => {
      var _a8, _b7;
      const peerName = (_a8 = peersMap[track.peerId]) == null ? void 0 : _a8.name;
      const isLocalTrack = track.peerId === localPeerID;
      if (isLocalTrack && ((_b7 = track.layerDefinitions) == null ? void 0 : _b7.length)) {
        res = res.concat(
          track.layerDefinitions.map(({ layer }) => {
            return {
              id: track.id,
              layer,
              local: true,
              label: `${peerName} ${track.source} ${track.type} - ${layer}`
            };
          })
        );
        return res;
      }
      res.push({
        id: track.id,
        local: isLocalTrack,
        label: `${peerName} ${track.source} ${track.type}`
      });
      return res;
    }, []),
    [tracksMap, peersMap, localPeerID]
  );
  return tracksWithLabels;
};
var LocalPeerStats = () => {
  var _a8, _b7, _c, _d, _e, _f, _g, _h, _i, _j;
  const stats = useHMSStatsStore3(selectHMSStats3.localPeerStats);
  if (!stats) {
    return null;
  }
  return /* @__PURE__ */ React56.createElement(Flex, { css: { flexWrap: "wrap", gap: "$10" } }, /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Packets Lost", value: (_a8 = stats.subscribe) == null ? void 0 : _a8.packetsLost }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Jitter", value: `${(((_c = (_b7 = stats.subscribe) == null ? void 0 : _b7.jitter) != null ? _c : 0) * 1e3).toFixed(2)} ms` }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Publish Bitrate", value: formatBytes((_d = stats.publish) == null ? void 0 : _d.bitrate, "b/s") }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Subscribe Bitrate", value: formatBytes((_e = stats.subscribe) == null ? void 0 : _e.bitrate, "b/s") }), /* @__PURE__ */ React56.createElement(
    StatsRow2,
    {
      label: "Available Outgoing Bitrate",
      value: formatBytes((_f = stats.publish) == null ? void 0 : _f.availableOutgoingBitrate, "b/s")
    }
  ), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Total Bytes Sent", value: formatBytes((_g = stats.publish) == null ? void 0 : _g.bytesSent) }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Total Bytes Received", value: formatBytes((_h = stats.subscribe) == null ? void 0 : _h.bytesReceived) }), /* @__PURE__ */ React56.createElement(
    StatsRow2,
    {
      label: "Round Trip Time",
      value: `${(((((_i = stats.publish) == null ? void 0 : _i.currentRoundTripTime) || 0) + (((_j = stats.subscribe) == null ? void 0 : _j.currentRoundTripTime) || 0)) / 2).toFixed(3) * 1e3} ms`
    }
  ));
};
var TrackStats = ({ trackID, layer, local }) => {
  var _a8, _b7;
  const selector = match4({ trackID, layer, local }).with(
    {
      layer: P3.when((layer2) => !!layer2)
    },
    () => selectHMSStats3.localVideoTrackStatsByLayer(layer)(trackID)
  ).with({ local: P3.when((local2) => !!local2) }, () => selectHMSStats3.localAudioTrackStatsByID(trackID)).otherwise(() => selectHMSStats3.trackStatsByID(trackID));
  const stats = useHMSStatsStore3(selector);
  if (!stats) {
    return null;
  }
  const inbound = stats.type.includes("inbound");
  return /* @__PURE__ */ React56.createElement(Flex, { css: { flexWrap: "wrap", gap: "$10" } }, /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Type", value: stats.type + " " + stats.kind }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Bitrate", value: formatBytes(stats.bitrate, "b/s") }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Packets Lost", value: stats.packetsLost }), /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Jitter", value: `${(((_b7 = (_a8 = stats.subscribe) == null ? void 0 : _a8.jitter) != null ? _b7 : 0) * 1e3).toFixed(2)} ms` }), /* @__PURE__ */ React56.createElement(
    StatsRow2,
    {
      label: inbound ? "Bytes Received" : "Bytes Sent",
      value: formatBytes(inbound ? stats.bytesReceived : stats.bytesSent)
    }
  ), stats.kind === "video" && /* @__PURE__ */ React56.createElement(React56.Fragment, null, /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Framerate", value: stats.framesPerSecond }), !inbound && /* @__PURE__ */ React56.createElement(StatsRow2, { label: "Quality Limitation Reason", value: stats.qualityLimitationReason })), /* @__PURE__ */ React56.createElement(
    StatsRow2,
    {
      label: "Round Trip Time",
      value: stats.roundTripTime ? `${(stats.roundTripTime * 1e3).toFixed(3)} ms` : "-"
    }
  ));
};
var DebugInfo = ({ details }) => {
  var _a8;
  return /* @__PURE__ */ React56.createElement(Accordion.Root, { type: "single", collapsible: true, css: { w: "100%" } }, /* @__PURE__ */ React56.createElement(Accordion.Item, { value: "Debug Info" }, /* @__PURE__ */ React56.createElement(Accordion.Header, null, /* @__PURE__ */ React56.createElement(Label3, { variant: "body2", css: { c: "$on_surface_high" } }, "Debug Info")), /* @__PURE__ */ React56.createElement(Accordion.Content, null, /* @__PURE__ */ React56.createElement(Flex, { css: { flexWrap: "wrap", mt: "$10", gap: "$10" } }, /* @__PURE__ */ React56.createElement(StatsRow2, { css: { w: "100%" }, label: "Websocket URL", value: details == null ? void 0 : details.websocketURL }), /* @__PURE__ */ React56.createElement(StatsRow2, { css: { w: "100%" }, label: "Init Endpoint", value: details == null ? void 0 : details.initEndpoint }), /* @__PURE__ */ React56.createElement(StatsRow2, { css: { w: "100%" }, label: "Enabled flags", value: (_a8 = details == null ? void 0 : details.enabledFlags) == null ? void 0 : _a8.join(", ") })))));
};
var StatsRow2 = React56.memo(({ label, value, css: css2 }) => /* @__PURE__ */ React56.createElement(Box, { css: __spreadValues({ bg: "$surface_bright", w: "calc(50% - $6)", p: "$8", r: "$3" }, css2) }, /* @__PURE__ */ React56.createElement(
  Text,
  {
    variant: "overline",
    css: {
      fontWeight: "$semiBold",
      color: "$on_surface_medium",
      textTransform: "uppercase"
    }
  },
  label
), /* @__PURE__ */ React56.createElement(Text, { variant: "sub1", css: { fontWeight: "$semiBold", color: "$on_surface_high" } }, value || "-")));

// src/Prebuilt/components/MoreSettings/BulkRoleChangeModal.jsx
init_define_process_env();
import React57, { useCallback as useCallback18, useRef as useRef16, useState as useState24 } from "react";
import { useHMSActions as useHMSActions18 } from "@100mslive/react-sdk";
import { AlertTriangleIcon as AlertTriangleIcon4, ChangeRoleIcon, CheckIcon as CheckIcon3 } from "@100mslive/react-icons";
var BulkRoleChangeModal = ({ onOpenChange }) => {
  var _a8, _b7;
  const roles = useFilteredRoles();
  const hmsActions = useHMSActions18();
  const ref = useRef16(null);
  const roleRef = useRef16(null);
  const [selectedBulkRole, setBulkRole] = useState24([]);
  const [selectedRole, setRole] = useState24("");
  const [bulkRoleDialog, setBulkRoleDialog] = useState24(false);
  const [roleDialog, setRoleDialog] = useState24(false);
  const [errorMessage, setErrorMessage] = useState24("");
  const [isSubmiting, setIsSubmiting] = useState24(false);
  const changeBulkRole = useCallback18(() => __async(void 0, null, function* () {
    if (selectedBulkRole.length > 0 && selectedRole) {
      try {
        setIsSubmiting(true);
        yield hmsActions.changeRoleOfPeersWithRoles(selectedBulkRole, selectedRole);
        setIsSubmiting(false);
        setErrorMessage("");
        onOpenChange(false);
      } catch (err) {
        setErrorMessage((err == null ? void 0 : err.message) ? err == null ? void 0 : err.message : "Unknown error");
        setIsSubmiting(false);
      }
    }
  }), [selectedBulkRole, selectedRole, hmsActions, onOpenChange]);
  return /* @__PURE__ */ React57.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React57.createElement(DialogContent, { title: "Bulk Role Change", Icon: ChangeRoleIcon }, /* @__PURE__ */ React57.createElement(DialogRow, null, /* @__PURE__ */ React57.createElement(Text, null, "For Roles: "), /* @__PURE__ */ React57.createElement(
    Dropdown.Root,
    {
      open: bulkRoleDialog,
      onOpenChange: (value) => {
        if (value) {
          setBulkRoleDialog(value);
        }
      },
      modal: false
    },
    /* @__PURE__ */ React57.createElement(
      DialogDropdownTrigger,
      {
        ref,
        title: selectedBulkRole.length === 0 ? "Select Multiple Roles" : selectedBulkRole.toString(),
        css: {
          w: "70%",
          p: "$8"
        },
        open: bulkRoleDialog
      }
    ),
    /* @__PURE__ */ React57.createElement(
      Dropdown.Content,
      {
        css: { w: (_a8 = ref.current) == null ? void 0 : _a8.clientWidth, zIndex: 1e3 },
        onInteractOutside: () => {
          if (bulkRoleDialog) {
            setBulkRoleDialog(false);
          }
        }
      },
      roles && roles.map((role) => {
        return /* @__PURE__ */ React57.createElement(
          Dropdown.CheckboxItem,
          {
            key: role,
            checked: selectedBulkRole.includes(role),
            onCheckedChange: (value) => {
              setBulkRole((selection) => {
                return value ? [...selection, role] : selection.filter((selectedRole2) => selectedRole2 !== role);
              });
              setErrorMessage("");
            }
          },
          /* @__PURE__ */ React57.createElement(Checkbox.Root, { css: { margin: "$2" }, checked: selectedBulkRole.includes(role) }, /* @__PURE__ */ React57.createElement(Checkbox.Indicator, null, /* @__PURE__ */ React57.createElement(CheckIcon3, { width: 16, height: 16 }))),
          role
        );
      })
    )
  )), /* @__PURE__ */ React57.createElement(DialogRow, null, /* @__PURE__ */ React57.createElement(Text, null, "To Role: "), /* @__PURE__ */ React57.createElement(Dropdown.Root, { open: roleDialog, onOpenChange: (value) => setRoleDialog(value) }, /* @__PURE__ */ React57.createElement(
    DialogDropdownTrigger,
    {
      ref: roleRef,
      title: selectedRole || "Select Role",
      css: {
        w: "70%",
        p: "$8"
      },
      open: roleDialog
    }
  ), /* @__PURE__ */ React57.createElement(Dropdown.Content, { css: { w: (_b7 = roleRef.current) == null ? void 0 : _b7.clientWidth, zIndex: 1e3 } }, roles && roles.map((role) => {
    return /* @__PURE__ */ React57.createElement(
      Dropdown.Item,
      {
        key: role,
        onSelect: () => {
          setRole(role);
          setErrorMessage("");
        }
      },
      role
    );
  })))), /* @__PURE__ */ React57.createElement(DialogRow, null, errorMessage && /* @__PURE__ */ React57.createElement(Flex, { gap: 2, css: { c: "$alert_error_default", w: "70%", ml: "auto" } }, /* @__PURE__ */ React57.createElement(AlertTriangleIcon4, null), /* @__PURE__ */ React57.createElement(Text, { css: { c: "inherit" } }, errorMessage))), /* @__PURE__ */ React57.createElement(DialogRow, { justify: "end" }, /* @__PURE__ */ React57.createElement(Button, { variant: "primary", onClick: changeBulkRole, disabled: !(selectedRole && selectedBulkRole.length > 0) }, isSubmiting && /* @__PURE__ */ React57.createElement(Loading, { css: { color: "$on_primary_medium" } }), "Apply"))));
};

// src/Prebuilt/components/MoreSettings/CaptionModal.tsx
init_define_process_env();
import React59 from "react";
import { useMedia as useMedia10 } from "react-use";

// src/Prebuilt/components/MoreSettings/CaptionContent.tsx
init_define_process_env();
import React58 from "react";
import { HMSTranscriptionMode, selectIsTranscriptionEnabled as selectIsTranscriptionEnabled2, useHMSActions as useHMSActions19, useHMSStore as useHMSStore24 } from "@100mslive/react-sdk";
import { AlertTriangleIcon as AlertTriangleIcon5, CrossIcon as CrossIcon10 } from "@100mslive/react-icons";
var CaptionContent = ({ isMobile, onExit }) => {
  const DURATION = 2e3;
  const actions = useHMSActions19();
  const isTranscriptionEnabled = useHMSStore24(selectIsTranscriptionEnabled2);
  const [toastId, setToastId] = useSetAppDataByKey(CAPTION_TOAST.captionToast);
  const [isCaptionEnabled, setIsCaptionEnabled] = useSetIsCaptionEnabled();
  return /* @__PURE__ */ React58.createElement(React58.Fragment, null, /* @__PURE__ */ React58.createElement(
    Text,
    {
      variant: isMobile ? "md" : "lg",
      css: {
        color: "$on_surface_high",
        fontWeight: "$semiBold",
        display: "flex",
        "@md": { px: "$8" }
      }
    },
    isTranscriptionEnabled ? "Disable" : "Enable",
    " Closed Caption (CC) for this session?",
    /* @__PURE__ */ React58.createElement(
      Box,
      {
        css: { color: "inherit", ml: "auto", "&:hover": { color: "$on_surface_medium", cursor: "pointer" } },
        onClick: onExit
      },
      /* @__PURE__ */ React58.createElement(CrossIcon10, null)
    )
  ), !isMobile ? /* @__PURE__ */ React58.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", mt: "$4", "@md": { px: "$8" } } }, "This will ", isTranscriptionEnabled ? "disable" : "enable", " Closed Captions for everyone in this room. You can\xA0", isTranscriptionEnabled ? "enable" : "disable", " it later.") : null, /* @__PURE__ */ React58.createElement(
    Flex,
    {
      justify: "between",
      align: "center",
      css: {
        width: "100%",
        gap: "$md",
        mt: "$10",
        "@md": { px: "$4" }
      }
    },
    isMobile ? null : /* @__PURE__ */ React58.createElement(Button, { variant: "standard", css: { w: "100%" }, outlined: true, onClick: onExit }, "Cancel"),
    /* @__PURE__ */ React58.createElement(
      Flex,
      {
        direction: "column",
        justify: "between",
        align: "center",
        css: {
          width: "100%",
          "@md": { px: "$4" }
        }
      },
      isMobile && isTranscriptionEnabled ? /* @__PURE__ */ React58.createElement(
        Button,
        {
          variant: "standard",
          css: { w: "100%", mb: "$4" },
          outlined: true,
          onClick: () => {
            setIsCaptionEnabled(!isCaptionEnabled);
            onExit();
          }
        },
        isCaptionEnabled ? "Hide For Me" : "Show For Me"
      ) : null,
      /* @__PURE__ */ React58.createElement(
        Button,
        {
          variant: isTranscriptionEnabled ? "danger" : "primary",
          css: { width: "100%" },
          "data-testid": "popup_change_btn",
          onClick: () => __async(void 0, null, function* () {
            try {
              if (isTranscriptionEnabled) {
                yield actions.stopTranscription({
                  mode: HMSTranscriptionMode.CAPTION
                });
                setIsCaptionEnabled(false);
                const id2 = ToastManager.replaceToast(toastId, {
                  title: `Disabling Closed Caption for everyone.`,
                  variant: "standard",
                  duration: DURATION,
                  icon: /* @__PURE__ */ React58.createElement(Loading, { color: "currentColor" })
                });
                setToastId(id2);
                onExit();
                return;
              }
              yield actions.startTranscription({
                mode: HMSTranscriptionMode.CAPTION
              });
              const id = ToastManager.replaceToast(toastId, {
                title: `Enabling Closed Caption for everyone.`,
                variant: "standard",
                duration: DURATION,
                icon: /* @__PURE__ */ React58.createElement(Loading, { color: "currentColor" })
              });
              setToastId(id);
            } catch (err) {
              const id = ToastManager.replaceToast(toastId, {
                title: `Failed to ${isTranscriptionEnabled ? "disable" : "enable"} closed caption`,
                variant: "error",
                icon: /* @__PURE__ */ React58.createElement(AlertTriangleIcon5, { style: { marginRight: "0.5rem" } })
              });
              setToastId(id);
            } finally {
              setIsCaptionEnabled(true);
            }
            onExit();
          })
        },
        isTranscriptionEnabled ? "Disable" : "Enable",
        " for Everyone"
      )
    )
  ), isMobile && /* @__PURE__ */ React58.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", pb: "$4", mb: "$8", "@md": { px: "$8", mt: "$4" } } }, "This will ", isTranscriptionEnabled ? "disable" : "enable", " Closed Captions for everyone in this room. You can\xA0", isTranscriptionEnabled ? "enable" : "disable", " it later."));
};

// src/Prebuilt/components/MoreSettings/CaptionModal.tsx
var CaptionModal = ({ onOpenChange }) => {
  const isMobile = useMedia10(config.media.md);
  const props = {
    isMobile,
    onExit: () => {
      onOpenChange(false);
    }
  };
  if (isMobile) {
    return /* @__PURE__ */ React59.createElement(Sheet.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React59.createElement(Sheet.Content, { css: { bg: "$surface_dim", p: "$8 0" } }, /* @__PURE__ */ React59.createElement(CaptionContent, __spreadValues({}, props))));
  }
  return /* @__PURE__ */ React59.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React59.createElement(Dialog.Portal, null, /* @__PURE__ */ React59.createElement(Dialog.Overlay, null), /* @__PURE__ */ React59.createElement(Dialog.Content, { css: { bg: "$surface_dim", width: "min(400px,80%)", p: "$10" } }, /* @__PURE__ */ React59.createElement(CaptionContent, __spreadValues({}, props)))));
};

// src/Prebuilt/components/MoreSettings/FullScreenItem.tsx
init_define_process_env();
import React60 from "react";
import { ExpandIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/hooks/useFullscreen.ts
init_define_process_env();
import { useCallback as useCallback19, useEffect as useEffect19, useState as useState25 } from "react";
import screenfull from "screenfull";
var useFullscreen = () => {
  const [isFullScreenEnabled, setIsFullScreenEnabled] = useState25(screenfull.isFullscreen);
  const toggle = useCallback19(() => __async(void 0, null, function* () {
    if (!screenfull.isEnabled) {
      ToastManager.addToast({ title: "Fullscreen feature not supported" });
      return;
    }
    try {
      const container = document.querySelector(DEFAULT_PORTAL_CONTAINER);
      if (isFullScreenEnabled) {
        yield screenfull.exit();
      } else if (container) {
        yield screenfull.request(container);
      }
    } catch (err) {
      ToastManager.addToast({ title: err.message });
    }
  }), [isFullScreenEnabled]);
  useEffect19(() => {
    const onChange = () => {
      setIsFullScreenEnabled(screenfull.isFullscreen);
    };
    if (screenfull.isEnabled) {
      screenfull.on("change", onChange);
    }
    return () => {
      if (screenfull.isEnabled) {
        screenfull.off("change", onChange);
      }
    };
  }, []);
  return {
    allowed: screenfull.isEnabled,
    isFullscreen: isFullScreenEnabled,
    toggleFullscreen: toggle
  };
};

// src/Prebuilt/components/MoreSettings/FullScreenItem.tsx
var FullScreenItem = () => {
  const { allowed, isFullscreen, toggleFullscreen } = useFullscreen();
  if (!allowed) {
    return null;
  }
  return /* @__PURE__ */ React60.createElement(
    Dropdown.Item,
    {
      onClick: () => {
        toggleFullscreen();
      },
      "data-testid": "full_screen_btn"
    },
    /* @__PURE__ */ React60.createElement(ExpandIcon, null),
    /* @__PURE__ */ React60.createElement(Text, { variant: "sm", css: { ml: "$4" } }, isFullscreen ? "Exit " : "Go ", "Fullscreen")
  );
};

// src/Prebuilt/components/MoreSettings/MuteAllModal.tsx
init_define_process_env();
import React62, { useCallback as useCallback20, useState as useState26 } from "react";
import {
  selectAvailableRoleNames as selectAvailableRoleNames4,
  useHMSActions as useHMSActions20,
  useHMSStore as useHMSStore26
} from "@100mslive/react-sdk";
import { MicOffIcon as MicOffIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/MoreSettings/MuteAllContent.tsx
init_define_process_env();
import React61 from "react";
import { selectPermissions as selectPermissions7, useHMSStore as useHMSStore25 } from "@100mslive/react-sdk";
var MuteAllContent = (props) => {
  const roles = props.roles || [];
  const permissions = useHMSStore25(selectPermissions7);
  return /* @__PURE__ */ React61.createElement(React61.Fragment, null, /* @__PURE__ */ React61.createElement(
    DialogSelect,
    {
      title: "Role",
      options: [{ label: "All Roles", value: "" }, ...roles.map((role) => ({ label: role, value: role }))],
      selected: props.selectedRole,
      keyField: "value",
      labelField: "label",
      onChange: props.setRole
    }
  ), /* @__PURE__ */ React61.createElement(
    DialogSelect,
    {
      title: "Track type",
      options: trackTypeOptions,
      selected: props.trackType,
      onChange: props.setTrackType,
      keyField: "value",
      labelField: "label"
    }
  ), /* @__PURE__ */ React61.createElement(
    DialogSelect,
    {
      title: "Track source",
      options: trackSourceOptions,
      selected: props.selectedSource,
      onChange: props.setSource,
      keyField: "value",
      labelField: "label"
    }
  ), /* @__PURE__ */ React61.createElement(DialogRow, null, /* @__PURE__ */ React61.createElement(Text, { variant: "md" }, "Track status"), /* @__PURE__ */ React61.createElement(RadioGroup.Root, { value: String(props.enabled), onValueChange: (value) => props.setEnabled(value === "true") }, (permissions == null ? void 0 : permissions.mute) && /* @__PURE__ */ React61.createElement(Flex, { align: "center", css: { mr: "$8" } }, /* @__PURE__ */ React61.createElement(RadioGroup.Item, { value: "false", id: "trackDisableRadio", css: { mr: "$4" } }, /* @__PURE__ */ React61.createElement(RadioGroup.Indicator, null)), /* @__PURE__ */ React61.createElement(Label3, { htmlFor: "trackDisableRadio" }, "Mute")), (permissions == null ? void 0 : permissions.unmute) && /* @__PURE__ */ React61.createElement(Flex, { align: "center", css: { cursor: "pointer" } }, /* @__PURE__ */ React61.createElement(RadioGroup.Item, { value: "true", id: "trackEnableRadio", css: { mr: "$4" } }, /* @__PURE__ */ React61.createElement(RadioGroup.Indicator, null)), /* @__PURE__ */ React61.createElement(Label3, { htmlFor: "trackEnableRadio" }, "Request Unmute")))), /* @__PURE__ */ React61.createElement(DialogRow, { justify: "end" }, /* @__PURE__ */ React61.createElement(Button, { variant: "primary", onClick: props.muteAll, css: { w: (props == null ? void 0 : props.isMobile) ? "100%" : "" } }, "Apply")));
};

// src/Prebuilt/components/MoreSettings/MuteAllModal.tsx
var MuteAllModal = ({
  onOpenChange,
  isMobile = false
}) => {
  const roles = useHMSStore26(selectAvailableRoleNames4);
  const hmsActions = useHMSActions20();
  const [enabled, setEnabled] = useState26(false);
  const [trackType, setTrackType] = useState26();
  const [selectedRole, setRole] = useState26();
  const [selectedSource, setSource] = useState26();
  const muteAll = useCallback20(() => __async(void 0, null, function* () {
    yield hmsActions.setRemoteTracksEnabled({
      enabled,
      type: trackType,
      source: selectedSource,
      roles: selectedRole ? [selectedRole] : void 0
    });
    onOpenChange(false);
  }), [selectedRole, enabled, trackType, selectedSource, hmsActions, onOpenChange]);
  const props = {
    muteAll,
    roles,
    enabled,
    setEnabled,
    trackType,
    setTrackType,
    selectedRole,
    setRole,
    selectedSource,
    setSource,
    isMobile
  };
  if (isMobile) {
    return /* @__PURE__ */ React62.createElement(Sheet.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React62.createElement(Sheet.Content, { css: { px: "$10" } }, /* @__PURE__ */ React62.createElement(MuteAllContent, __spreadValues({}, props))));
  }
  return /* @__PURE__ */ React62.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React62.createElement(DialogContent, { title: "Mute/Unmute Remote Tracks", Icon: MicOffIcon2 }, /* @__PURE__ */ React62.createElement(MuteAllContent, __spreadValues({}, props))));
};

// src/Prebuilt/components/hooks/useMetadata.tsx
init_define_process_env();
import { useCallback as useCallback21 } from "react";
import {
  selectHasPeerHandRaised,
  selectLocalPeerID as selectLocalPeerID5,
  selectPeerMetadata as selectPeerMetadata2,
  useHMSActions as useHMSActions21,
  useHMSStore as useHMSStore27,
  useHMSVanillaStore as useHMSVanillaStore9
} from "@100mslive/react-sdk";
var useMyMetadata = () => {
  const hmsActions = useHMSActions21();
  const localPeerId = useHMSStore27(selectLocalPeerID5);
  const vanillaStore = useHMSVanillaStore9();
  const metaData = useHMSStore27(selectPeerMetadata2(localPeerId));
  const isHandRaised = useHMSStore27(selectHasPeerHandRaised(localPeerId));
  const update = (updatedFields) => __async(void 0, null, function* () {
    try {
      const currentMetadata = vanillaStore.getState(selectPeerMetadata2(localPeerId));
      yield hmsActions.changeMetadata(Object.assign(currentMetadata, updatedFields));
      return true;
    } catch (error) {
      console.error("failed to update metadata ", updatedFields);
    }
    return false;
  });
  const toggleHandRaise = useCallback21(() => __async(void 0, null, function* () {
    if (isHandRaised) {
      yield hmsActions.lowerLocalPeerHand();
      yield update({ handRaisedAt: void 0 });
    } else {
      yield hmsActions.raiseLocalPeerHand();
      yield update({ isBRBOn: false, handRaisedAt: Date.now() });
    }
  }), [isHandRaised]);
  const toggleBRB = useCallback21(() => __async(void 0, null, function* () {
    const newValue = !(metaData == null ? void 0 : metaData.isBRBOn);
    yield update({ isBRBOn: newValue });
    if (newValue) {
      yield hmsActions.lowerLocalPeerHand();
    }
  }), [metaData == null ? void 0 : metaData.isBRBOn]);
  return {
    isHandRaised,
    isBRBOn: !!(metaData == null ? void 0 : metaData.isBRBOn),
    metaData,
    updateMetaData: update,
    toggleHandRaise,
    toggleBRB
  };
};

// src/Prebuilt/components/PIP/usePIPChat.tsx
init_define_process_env();
import { useEffect as useEffect20 } from "react";
import { useHMSActions as useHMSActions22 } from "@100mslive/react-sdk";

// src/Prebuilt/components/PIP/usePIPWindow.tsx
init_define_process_env();
import { useContext as useContext4 } from "react";

// src/Prebuilt/components/PIP/context.ts
init_define_process_env();
import { createContext as createContext2 } from "react";
var PIPContext = createContext2(void 0);

// src/Prebuilt/components/PIP/usePIPWindow.tsx
var usePIPWindow = () => {
  const context = useContext4(PIPContext);
  if (context === void 0) {
    throw new Error("usePIPWindow must be used within a PIPContext");
  }
  return context;
};

// src/Prebuilt/components/PIP/usePIPChat.tsx
var usePIPChat = () => {
  const hmsActions = useHMSActions22();
  const { isSupported, requestPipWindow, pipWindow, closePipWindow } = usePIPWindow();
  useEffect20(() => {
    if (document && pipWindow) {
      const style = document.createElement("style");
      style.id = "stitches";
      style.textContent = getCssText();
      pipWindow.document.head.appendChild(style);
    }
  }, [pipWindow]);
  useEffect20(() => {
    if (pipWindow) {
      const chatContainer = pipWindow.document.getElementById("chat-container");
      const selector = pipWindow.document.getElementById("selector");
      const sendBtn = pipWindow.document.getElementById("send-btn");
      const pipChatInput = pipWindow.document.getElementById("chat-input");
      const marker = pipWindow.document.getElementById("marker");
      marker == null ? void 0 : marker.scrollIntoView({ block: "end" });
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.target.id) {
              hmsActions.setMessageRead(true, entry.target.id);
            }
          });
        },
        {
          root: chatContainer,
          threshold: 0.8
        }
      );
      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            const newMessages = mutation.addedNodes;
            newMessages.forEach((message) => {
              const messageId = message == null ? void 0 : message.id;
              if (messageId === "new-message-notif") {
                message.addEventListener(
                  "click",
                  () => setTimeout(() => marker == null ? void 0 : marker.scrollIntoView({ block: "end", behavior: "smooth" }), 0)
                );
              } else if (messageId)
                observer.observe(message);
            });
          }
        });
      });
      mutationObserver.observe(chatContainer, {
        childList: true
      });
      const sendMessage = () => __async(void 0, null, function* () {
        const selection = (selector == null ? void 0 : selector.value) || "Everyone";
        if (selection === "Everyone") {
          yield hmsActions.sendBroadcastMessage(pipChatInput.value.trim());
        } else {
          yield hmsActions.sendGroupMessage(pipChatInput.value.trim(), [selection]);
        }
        pipChatInput.value = "";
        setTimeout(() => marker == null ? void 0 : marker.scrollIntoView({ block: "end", behavior: "smooth" }), 0);
      });
      if (sendBtn && hmsActions && pipChatInput) {
        const pipMessages = pipWindow.document.getElementsByClassName("pip-message");
        [...pipMessages].forEach((message) => {
          if (message.id) {
            hmsActions.setMessageRead(true, message.id);
          }
        });
        const sendOnEnter = (e) => {
          if (e.key === "Enter")
            sendMessage();
        };
        sendBtn.addEventListener("click", sendMessage);
        pipChatInput.addEventListener("keypress", sendOnEnter);
        return () => {
          sendBtn.removeEventListener("click", sendMessage);
          pipChatInput.removeEventListener("keypress", sendOnEnter);
          mutationObserver.disconnect();
          observer.disconnect();
        };
      }
    }
  }, [pipWindow, hmsActions]);
  useEffect20(() => {
    return () => {
      pipWindow && closePipWindow();
    };
  }, [closePipWindow, pipWindow]);
  return { isSupported, requestPipWindow, pipWindow };
};

// src/Prebuilt/components/MoreSettings/SplitComponents/DesktopOptions.tsx
var MODALS = {
  CHANGE_NAME: "changeName",
  SELF_ROLE_CHANGE: "selfRoleChange",
  MORE_SETTINGS: "moreSettings",
  START_RECORDING: "startRecording",
  DEVICE_SETTINGS: "deviceSettings",
  STATS_FOR_NERDS: "statsForNerds",
  BULK_ROLE_CHANGE: "bulkRoleChange",
  MUTE_ALL: "muteAll",
  EMBED_URL: "embedUrl",
  CAPTION: "caption"
};
var DesktopOptions = ({
  elements,
  screenType
}) => {
  const localPeerId = useHMSStore28(selectLocalPeerID6);
  const hmsActions = useHMSActions23();
  const enablHlsStats = useHMSStore28(selectAppData3(APP_DATA.hlsStats));
  const [openModals, setOpenModals] = useState27(/* @__PURE__ */ new Set());
  const { isBRBOn, toggleBRB } = useMyMetadata();
  const isPipOn = PictureInPicture.isOn();
  const isBRBEnabled = !!(elements == null ? void 0 : elements.brb);
  const isTranscriptionAllowed = useHMSStore28(selectIsTranscriptionAllowedByMode(HMSTranscriptionMode2.CAPTION));
  const isTranscriptionEnabled = useHMSStore28(selectIsTranscriptionEnabled3);
  const { isSupported, pipWindow, requestPipWindow } = usePIPChat();
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  const showPipChatOption = !!(elements == null ? void 0 : elements.chat) && isSupported && !pipWindow;
  useDropdownList({ open: openModals.size > 0, name: "MoreSettings" });
  const updateState = (modalName, value) => {
    setOpenModals((modals) => {
      const copy = new Set(modals);
      if (value) {
        copy.clear();
        copy.add(modalName);
      } else {
        copy.delete(modalName);
      }
      return copy;
    });
  };
  return /* @__PURE__ */ React63.createElement(Fragment7, null, isSupported && pipWindow ? /* @__PURE__ */ React63.createElement(PIPWindow, { pipWindow }, /* @__PURE__ */ React63.createElement(PIPChat, null)) : null, /* @__PURE__ */ React63.createElement(
    Dropdown.Root,
    {
      open: openModals.has(MODALS.MORE_SETTINGS),
      onOpenChange: (value) => updateState(MODALS.MORE_SETTINGS, value),
      modal: false
    },
    /* @__PURE__ */ React63.createElement(Tooltip, { title: "More options" }, /* @__PURE__ */ React63.createElement(Dropdown.Trigger, { asChild: true, "data-testid": "more_settings_btn" }, /* @__PURE__ */ React63.createElement(IconButton_default, null, /* @__PURE__ */ React63.createElement(HamburgerMenuIcon, null)))),
    /* @__PURE__ */ React63.createElement(
      Dropdown.Content,
      {
        sideOffset: 5,
        onCloseAutoFocus: (e) => {
          e.preventDefault();
        },
        align: "end",
        css: {
          py: "$0",
          maxHeight: "unset",
          "@md": { w: "$64" },
          "div[role='separator']:first-child": {
            display: "none"
          }
        }
      },
      isBRBEnabled && screenType !== "hls_live_streaming" ? /* @__PURE__ */ React63.createElement(Dropdown.Item, { onClick: toggleBRB, "data-testid": "brb_btn" }, /* @__PURE__ */ React63.createElement(BrbIcon, null), /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4", color: "$on_surface_high" } }, "Be Right Back"), /* @__PURE__ */ React63.createElement(Flex, { justify: "end", css: { color: "$on_surface_high", flexGrow: "1" } }, isBRBOn ? /* @__PURE__ */ React63.createElement(CheckIcon4, null) : null)) : null,
      isTranscriptionAllowed ? /* @__PURE__ */ React63.createElement(
        Dropdown.Item,
        {
          "data-testid": "closed_caption_admin",
          onClick: () => {
            updateState(MODALS.CAPTION, true);
          }
        },
        /* @__PURE__ */ React63.createElement(OpenCaptionIcon2, null),
        /* @__PURE__ */ React63.createElement(Flex, { direction: "column", css: { flexGrow: "1" } }, /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4", color: "$on_surface_high" } }, "Closed Captions"), /* @__PURE__ */ React63.createElement(Text, { variant: "caption", css: { ml: "$4", color: "$on_surface_medium" } }, isTranscriptionEnabled ? "Enabled" : "Disabled")),
        /* @__PURE__ */ React63.createElement(Switch, { id: "closed_caption_start_stop", checked: isTranscriptionEnabled, disabled: false })
      ) : null,
      screenType !== "hls_live_streaming" ? /* @__PURE__ */ React63.createElement(Dropdown.Item, { css: { p: 0, "&:empty": { display: "none" } } }, /* @__PURE__ */ React63.createElement(
        PIP,
        {
          content: /* @__PURE__ */ React63.createElement(Flex, { css: { w: "100%", h: "100%", p: "$8" } }, /* @__PURE__ */ React63.createElement(PipIcon2, null), /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4" } }, isPipOn ? "Disable" : "Enable", " Picture-in-Picture"))
        }
      )) : null,
      /* @__PURE__ */ React63.createElement(
        PIPChatOption,
        {
          showPIPChat: showPipChatOption,
          openChat: () => __async(void 0, null, function* () {
            isChatOpen && toggleChat();
            yield requestPipWindow(350, 500);
          })
        }
      ),
      /* @__PURE__ */ React63.createElement(FullScreenItem, null),
      /* @__PURE__ */ React63.createElement(Dropdown.ItemSeparator, { css: { mx: 0 } }),
      /* @__PURE__ */ React63.createElement(Dropdown.Item, { onClick: () => updateState(MODALS.DEVICE_SETTINGS, true), "data-testid": "device_settings_btn" }, /* @__PURE__ */ React63.createElement(SettingsIcon3, null), /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4" } }, "Settings")),
      match5({ screenType, isSupported: HMSHLSPlayer.isSupported() }).with({ screenType: "hls_live_streaming", isSupported: false }, () => null).with({ screenType: "hls_live_streaming", isSupported: true }, () => {
        return /* @__PURE__ */ React63.createElement(
          Dropdown.Item,
          {
            onClick: () => hmsActions.setAppData(APP_DATA.hlsStats, !enablHlsStats),
            "data-testid": "hls_stats"
          },
          /* @__PURE__ */ React63.createElement(
            Checkbox.Root,
            {
              css: { margin: "$2" },
              checked: enablHlsStats,
              onCheckedChange: () => hmsActions.setAppData(APP_DATA.hlsStats, !enablHlsStats)
            },
            /* @__PURE__ */ React63.createElement(Checkbox.Indicator, null, /* @__PURE__ */ React63.createElement(CheckIcon4, { width: 16, height: 16 }))
          ),
          /* @__PURE__ */ React63.createElement(Flex, { justify: "between", css: { width: "100%" } }, /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4" } }, "Show HLS Stats"), /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4" } }, `${isMacOS ? "\u2318" : "ctrl"} + ]`))
        );
      }).otherwise(() => /* @__PURE__ */ React63.createElement(
        Dropdown.Item,
        {
          onClick: () => updateState(MODALS.STATS_FOR_NERDS, true),
          "data-testid": "stats_for_nerds_btn"
        },
        /* @__PURE__ */ React63.createElement(InfoIcon2, null),
        /* @__PURE__ */ React63.createElement(Text, { variant: "sm", css: { ml: "$4" } }, "Stats for Nerds")
      ))
    )
  ), openModals.has(MODALS.BULK_ROLE_CHANGE) && /* @__PURE__ */ React63.createElement(BulkRoleChangeModal, { onOpenChange: (value) => updateState(MODALS.BULK_ROLE_CHANGE, value) }), openModals.has(MODALS.MUTE_ALL) && /* @__PURE__ */ React63.createElement(MuteAllModal, { onOpenChange: (value) => updateState(MODALS.MUTE_ALL, value) }), openModals.has(MODALS.START_RECORDING) && /* @__PURE__ */ React63.createElement(StartRecording_default, { open: true, onOpenChange: (value) => updateState(MODALS.START_RECORDING, value) }), openModals.has(MODALS.DEVICE_SETTINGS) && /* @__PURE__ */ React63.createElement(
    SettingsModal_default,
    {
      open: true,
      onOpenChange: (value) => updateState(MODALS.DEVICE_SETTINGS, value),
      screenType
    }
  ), openModals.has(MODALS.STATS_FOR_NERDS) && /* @__PURE__ */ React63.createElement(StatsForNerds, { open: true, onOpenChange: (value) => updateState(MODALS.STATS_FOR_NERDS, value) }), openModals.has(MODALS.SELF_ROLE_CHANGE) && /* @__PURE__ */ React63.createElement(
    RoleChangeModal,
    {
      peerId: localPeerId,
      onOpenChange: (value) => updateState(MODALS.SELF_ROLE_CHANGE, value)
    }
  ), openModals.has(MODALS.CAPTION) && /* @__PURE__ */ React63.createElement(CaptionModal, { onOpenChange: (value) => updateState(MODALS.CAPTION, value) }));
};

// src/Prebuilt/components/MoreSettings/SplitComponents/MwebOptions.tsx
init_define_process_env();
import React67, { useRef as useRef19, useState as useState31 } from "react";
import { useClickAway } from "react-use";
import { match as match6 } from "ts-pattern";
import {
  HMSTranscriptionMode as HMSTranscriptionMode3,
  selectIsConnectedToRoom as selectIsConnectedToRoom7,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled4,
  selectIsTranscriptionAllowedByMode as selectIsTranscriptionAllowedByMode2,
  selectIsTranscriptionEnabled as selectIsTranscriptionEnabled4,
  selectPeerCount as selectPeerCount3,
  selectPermissions as selectPermissions9,
  useHMSActions as useHMSActions27,
  useHMSStore as useHMSStore33,
  useRecordingStreaming as useRecordingStreaming7
} from "@100mslive/react-sdk";
import {
  BrbIcon as BrbIcon2,
  ClosedCaptionIcon as ClosedCaptionIcon2,
  CrossIcon as CrossIcon13,
  EmojiIcon as EmojiIcon2,
  HamburgerMenuIcon as HamburgerMenuIcon2,
  HandIcon as HandIcon2,
  HandRaiseSlashedIcon,
  InfoIcon as InfoIcon3,
  OpenCaptionIcon as OpenCaptionIcon3,
  PeopleIcon,
  QuizActiveIcon,
  QuizIcon,
  RecordIcon as RecordIcon2,
  SettingsIcon as SettingsIcon4,
  VirtualBackgroundIcon
} from "@100mslive/react-icons";

// src/Prebuilt/components/Header/StreamActions.tsx
init_define_process_env();
import React64, { useCallback as useCallback22, useEffect as useEffect21, useRef as useRef17, useState as useState28 } from "react";
import { useMedia as useMedia11 } from "react-use";

// ../hms-video-store/dist/index.js
init_define_process_env();

// ../../node_modules/reselect/es/index.js
init_define_process_env();
function defaultEqualityCheck(a2, b2) {
  return a2 === b2;
}
function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }
  return true;
}
function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultEqualityCheck;
  var lastArgs = null;
  var lastResult = null;
  return function() {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      lastResult = func.apply(null, arguments);
    }
    lastArgs = arguments;
    return lastResult;
  };
}
function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
  if (!dependencies.every(function(dep) {
    return typeof dep === "function";
  })) {
    var dependencyTypes = dependencies.map(function(dep) {
      return typeof dep;
    }).join(", ");
    throw new Error("Selector creators expect all input-selectors to be functions, " + ("instead received the following types: [" + dependencyTypes + "]"));
  }
  return dependencies;
}
function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }
  return function() {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }
    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function() {
      recomputations++;
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));
    var selector = memoize(function() {
      var params = [];
      var length = dependencies.length;
      for (var i = 0; i < length; i++) {
        params.push(dependencies[i].apply(null, arguments));
      }
      return memoizedResultFunc.apply(null, params);
    });
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function() {
      return recomputations;
    };
    selector.resetRecomputations = function() {
      return recomputations = 0;
    };
    return selector;
  };
}
var createSelector = createSelectorCreator(defaultMemoize);

// ../hms-video-store/dist/index.js
var import_ua_parser_js = __toESM(require_ua_parser());
var import_lodash3 = __toESM(require_lodash2());
import { v4 as Po } from "uuid";
import { v4 as ko } from "uuid";

// ../../node_modules/webrtc-adapter/src/js/adapter_core.js
init_define_process_env();

// ../../node_modules/webrtc-adapter/src/js/adapter_factory.js
init_define_process_env();

// ../../node_modules/webrtc-adapter/src/js/utils.js
init_define_process_env();
var logDisabled_ = true;
var deprecationWarnings_ = true;
function extractVersion(uastring, expr, pos) {
  const match18 = uastring.match(expr);
  return match18 && match18.length >= pos && parseInt(match18[pos], 10);
}
function wrapPeerConnectionEvent(window2, eventNameToWrap, wrapper) {
  if (!window2.RTCPeerConnection) {
    return;
  }
  const proto = window2.RTCPeerConnection.prototype;
  const nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    const wrappedCallback = (e) => {
      const modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        if (cb.handleEvent) {
          cb.handleEvent(modifiedEvent);
        } else {
          cb(modifiedEvent);
        }
      }
    };
    this._eventMap = this._eventMap || {};
    if (!this._eventMap[eventNameToWrap]) {
      this._eventMap[eventNameToWrap] = /* @__PURE__ */ new Map();
    }
    this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
    return nativeAddEventListener.apply(this, [
      nativeEventName,
      wrappedCallback
    ]);
  };
  const nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    if (!this._eventMap[eventNameToWrap].has(cb)) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
    this._eventMap[eventNameToWrap].delete(cb);
    if (this._eventMap[eventNameToWrap].size === 0) {
      delete this._eventMap[eventNameToWrap];
    }
    if (Object.keys(this._eventMap).length === 0) {
      delete this._eventMap;
    }
    return nativeRemoveEventListener.apply(this, [
      nativeEventName,
      unwrappedCb
    ]);
  };
  Object.defineProperty(proto, "on" + eventNameToWrap, {
    get() {
      return this["_on" + eventNameToWrap];
    },
    set(cb) {
      if (this["_on" + eventNameToWrap]) {
        this.removeEventListener(
          eventNameToWrap,
          this["_on" + eventNameToWrap]
        );
        delete this["_on" + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(
          eventNameToWrap,
          this["_on" + eventNameToWrap] = cb
        );
      }
    },
    enumerable: true,
    configurable: true
  });
}
function disableLog(bool) {
  if (typeof bool !== "boolean") {
    return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
  }
  logDisabled_ = bool;
  return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
function disableWarnings(bool) {
  if (typeof bool !== "boolean") {
    return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
  }
  deprecationWarnings_ = !bool;
  return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function log() {
  if (typeof window === "object") {
    if (logDisabled_) {
      return;
    }
    if (typeof console !== "undefined" && typeof console.log === "function") {
      console.log.apply(console, arguments);
    }
  }
}
function deprecated(oldMethod, newMethod) {
  if (!deprecationWarnings_) {
    return;
  }
  console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
function detectBrowser(window2) {
  const result = { browser: null, version: null };
  if (typeof window2 === "undefined" || !window2.navigator || !window2.navigator.userAgent) {
    result.browser = "Not a browser.";
    return result;
  }
  const { navigator: navigator2 } = window2;
  if (navigator2.mozGetUserMedia) {
    result.browser = "firefox";
    result.version = extractVersion(
      navigator2.userAgent,
      /Firefox\/(\d+)\./,
      1
    );
  } else if (navigator2.webkitGetUserMedia || window2.isSecureContext === false && window2.webkitRTCPeerConnection) {
    result.browser = "chrome";
    result.version = extractVersion(
      navigator2.userAgent,
      /Chrom(e|ium)\/(\d+)\./,
      2
    );
  } else if (window2.RTCPeerConnection && navigator2.userAgent.match(/AppleWebKit\/(\d+)\./)) {
    result.browser = "safari";
    result.version = extractVersion(
      navigator2.userAgent,
      /AppleWebKit\/(\d+)\./,
      1
    );
    result.supportsUnifiedPlan = window2.RTCRtpTransceiver && "currentDirection" in window2.RTCRtpTransceiver.prototype;
  } else {
    result.browser = "Not a supported browser.";
    return result;
  }
  return result;
}
function isObject(val) {
  return Object.prototype.toString.call(val) === "[object Object]";
}
function compactObject(data3) {
  if (!isObject(data3)) {
    return data3;
  }
  return Object.keys(data3).reduce(function(accumulator, key) {
    const isObj = isObject(data3[key]);
    const value = isObj ? compactObject(data3[key]) : data3[key];
    const isEmptyObject = isObj && !Object.keys(value).length;
    if (value === void 0 || isEmptyObject) {
      return accumulator;
    }
    return Object.assign(accumulator, { [key]: value });
  }, {});
}
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach((name) => {
    if (name.endsWith("Id")) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith("Ids")) {
      base[name].forEach((id) => {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}
function filterStats(result, track, outbound) {
  const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
  const filteredResult = /* @__PURE__ */ new Map();
  if (track === null) {
    return filteredResult;
  }
  const trackStats = [];
  result.forEach((value) => {
    if (value.type === "track" && value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach((trackStat) => {
    result.forEach((stats) => {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}

// ../../node_modules/webrtc-adapter/src/js/chrome/chrome_shim.js
var chrome_shim_exports = {};
__export(chrome_shim_exports, {
  fixNegotiationNeeded: () => fixNegotiationNeeded,
  shimAddTrackRemoveTrack: () => shimAddTrackRemoveTrack,
  shimAddTrackRemoveTrackWithNative: () => shimAddTrackRemoveTrackWithNative,
  shimGetDisplayMedia: () => shimGetDisplayMedia,
  shimGetSendersWithDtmf: () => shimGetSendersWithDtmf,
  shimGetStats: () => shimGetStats,
  shimGetUserMedia: () => shimGetUserMedia,
  shimMediaStream: () => shimMediaStream,
  shimOnTrack: () => shimOnTrack,
  shimPeerConnection: () => shimPeerConnection,
  shimSenderReceiverGetStats: () => shimSenderReceiverGetStats
});
init_define_process_env();

// ../../node_modules/webrtc-adapter/src/js/chrome/getusermedia.js
init_define_process_env();
var logging = log;
function shimGetUserMedia(window2, browserDetails) {
  const navigator2 = window2 && window2.navigator;
  if (!navigator2.mediaDevices) {
    return;
  }
  const constraintsToChrome_ = function(c2) {
    if (typeof c2 !== "object" || c2.mandatory || c2.optional) {
      return c2;
    }
    const cc = {};
    Object.keys(c2).forEach((key) => {
      if (key === "require" || key === "advanced" || key === "mediaSource") {
        return;
      }
      const r = typeof c2[key] === "object" ? c2[key] : { ideal: c2[key] };
      if (r.exact !== void 0 && typeof r.exact === "number") {
        r.min = r.max = r.exact;
      }
      const oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return name === "deviceId" ? "sourceId" : name;
      };
      if (r.ideal !== void 0) {
        cc.optional = cc.optional || [];
        let oc = {};
        if (typeof r.ideal === "number") {
          oc[oldname_("min", key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_("max", key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_("", key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== void 0 && typeof r.exact !== "number") {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_("", key)] = r.exact;
      } else {
        ["min", "max"].forEach((mix) => {
          if (r[mix] !== void 0) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c2.advanced) {
      cc.optional = (cc.optional || []).concat(c2.advanced);
    }
    return cc;
  };
  const shimConstraints_ = function(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === "object") {
      const remap = function(obj, a2, b2) {
        if (a2 in obj && !(b2 in obj)) {
          obj[b2] = obj[a2];
          delete obj[a2];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, "autoGainControl", "googAutoGainControl");
      remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === "object") {
      let face = constraints.video.facingMode;
      face = face && (typeof face === "object" ? face : { ideal: face });
      const getSupportedFacingModeLies = browserDetails.version < 66;
      if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator2.mediaDevices.getSupportedConstraints && navigator2.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        let matches;
        if (face.exact === "environment" || face.ideal === "environment") {
          matches = ["back", "rear"];
        } else if (face.exact === "user" || face.ideal === "user") {
          matches = ["front"];
        }
        if (matches) {
          return navigator2.mediaDevices.enumerateDevices().then((devices) => {
            devices = devices.filter((d) => d.kind === "videoinput");
            let dev = devices.find((d) => matches.some((match18) => d.label.toLowerCase().includes(match18)));
            if (!dev && devices.length && matches.includes("back")) {
              dev = devices[devices.length - 1];
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? { exact: dev.deviceId } : { ideal: dev.deviceId };
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging("chrome: " + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging("chrome: " + JSON.stringify(constraints));
    return func(constraints);
  };
  const shimError_ = function(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: "NotAllowedError",
        PermissionDismissedError: "NotAllowedError",
        InvalidStateError: "NotAllowedError",
        DevicesNotFoundError: "NotFoundError",
        ConstraintNotSatisfiedError: "OverconstrainedError",
        TrackStartError: "NotReadableError",
        MediaDeviceFailedDueToShutdown: "NotAllowedError",
        MediaDeviceKillSwitchOn: "NotAllowedError",
        TabCaptureError: "AbortError",
        ScreenCaptureError: "AbortError",
        DeviceCaptureError: "AbortError"
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString() {
        return this.name + (this.message && ": ") + this.message;
      }
    };
  };
  const getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, (c2) => {
      navigator2.webkitGetUserMedia(c2, onSuccess, (e) => {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };
  navigator2.getUserMedia = getUserMedia_.bind(navigator2);
  if (navigator2.mediaDevices.getUserMedia) {
    const origGetUserMedia = navigator2.mediaDevices.getUserMedia.bind(navigator2.mediaDevices);
    navigator2.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, (c2) => origGetUserMedia(c2).then((stream) => {
        if (c2.audio && !stream.getAudioTracks().length || c2.video && !stream.getVideoTracks().length) {
          stream.getTracks().forEach((track) => {
            track.stop();
          });
          throw new DOMException("", "NotFoundError");
        }
        return stream;
      }, (e) => Promise.reject(shimError_(e))));
    };
  }
}

// ../../node_modules/webrtc-adapter/src/js/chrome/getdisplaymedia.js
init_define_process_env();
function shimGetDisplayMedia(window2, getSourceId) {
  if (window2.navigator.mediaDevices && "getDisplayMedia" in window2.navigator.mediaDevices) {
    return;
  }
  if (!window2.navigator.mediaDevices) {
    return;
  }
  if (typeof getSourceId !== "function") {
    console.error("shimGetDisplayMedia: getSourceId argument is not a function");
    return;
  }
  window2.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
    return getSourceId(constraints).then((sourceId) => {
      const widthSpecified = constraints.video && constraints.video.width;
      const heightSpecified = constraints.video && constraints.video.height;
      const frameRateSpecified = constraints.video && constraints.video.frameRate;
      constraints.video = {
        mandatory: {
          chromeMediaSource: "desktop",
          chromeMediaSourceId: sourceId,
          maxFrameRate: frameRateSpecified || 3
        }
      };
      if (widthSpecified) {
        constraints.video.mandatory.maxWidth = widthSpecified;
      }
      if (heightSpecified) {
        constraints.video.mandatory.maxHeight = heightSpecified;
      }
      return window2.navigator.mediaDevices.getUserMedia(constraints);
    });
  };
}

// ../../node_modules/webrtc-adapter/src/js/chrome/chrome_shim.js
function shimMediaStream(window2) {
  window2.MediaStream = window2.MediaStream || window2.webkitMediaStream;
}
function shimOnTrack(window2) {
  if (typeof window2 === "object" && window2.RTCPeerConnection && !("ontrack" in window2.RTCPeerConnection.prototype)) {
    Object.defineProperty(window2.RTCPeerConnection.prototype, "ontrack", {
      get() {
        return this._ontrack;
      },
      set(f) {
        if (this._ontrack) {
          this.removeEventListener("track", this._ontrack);
        }
        this.addEventListener("track", this._ontrack = f);
      },
      enumerable: true,
      configurable: true
    });
    const origSetRemoteDescription = window2.RTCPeerConnection.prototype.setRemoteDescription;
    window2.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
      if (!this._ontrackpoly) {
        this._ontrackpoly = (e) => {
          e.stream.addEventListener("addtrack", (te) => {
            let receiver;
            if (window2.RTCPeerConnection.prototype.getReceivers) {
              receiver = this.getReceivers().find((r) => r.track && r.track.id === te.track.id);
            } else {
              receiver = { track: te.track };
            }
            const event = new Event("track");
            event.track = te.track;
            event.receiver = receiver;
            event.transceiver = { receiver };
            event.streams = [e.stream];
            this.dispatchEvent(event);
          });
          e.stream.getTracks().forEach((track) => {
            let receiver;
            if (window2.RTCPeerConnection.prototype.getReceivers) {
              receiver = this.getReceivers().find((r) => r.track && r.track.id === track.id);
            } else {
              receiver = { track };
            }
            const event = new Event("track");
            event.track = track;
            event.receiver = receiver;
            event.transceiver = { receiver };
            event.streams = [e.stream];
            this.dispatchEvent(event);
          });
        };
        this.addEventListener("addstream", this._ontrackpoly);
      }
      return origSetRemoteDescription.apply(this, arguments);
    };
  } else {
    wrapPeerConnectionEvent(window2, "track", (e) => {
      if (!e.transceiver) {
        Object.defineProperty(
          e,
          "transceiver",
          { value: { receiver: e.receiver } }
        );
      }
      return e;
    });
  }
}
function shimGetSendersWithDtmf(window2) {
  if (typeof window2 === "object" && window2.RTCPeerConnection && !("getSenders" in window2.RTCPeerConnection.prototype) && "createDTMFSender" in window2.RTCPeerConnection.prototype) {
    const shimSenderWithDtmf = function(pc, track) {
      return {
        track,
        get dtmf() {
          if (this._dtmf === void 0) {
            if (track.kind === "audio") {
              this._dtmf = pc.createDTMFSender(track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        },
        _pc: pc
      };
    };
    if (!window2.RTCPeerConnection.prototype.getSenders) {
      window2.RTCPeerConnection.prototype.getSenders = function getSenders() {
        this._senders = this._senders || [];
        return this._senders.slice();
      };
      const origAddTrack = window2.RTCPeerConnection.prototype.addTrack;
      window2.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        let sender = origAddTrack.apply(this, arguments);
        if (!sender) {
          sender = shimSenderWithDtmf(this, track);
          this._senders.push(sender);
        }
        return sender;
      };
      const origRemoveTrack = window2.RTCPeerConnection.prototype.removeTrack;
      window2.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        origRemoveTrack.apply(this, arguments);
        const idx = this._senders.indexOf(sender);
        if (idx !== -1) {
          this._senders.splice(idx, 1);
        }
      };
    }
    const origAddStream = window2.RTCPeerConnection.prototype.addStream;
    window2.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      this._senders = this._senders || [];
      origAddStream.apply(this, [stream]);
      stream.getTracks().forEach((track) => {
        this._senders.push(shimSenderWithDtmf(this, track));
      });
    };
    const origRemoveStream = window2.RTCPeerConnection.prototype.removeStream;
    window2.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
      this._senders = this._senders || [];
      origRemoveStream.apply(this, [stream]);
      stream.getTracks().forEach((track) => {
        const sender = this._senders.find((s) => s.track === track);
        if (sender) {
          this._senders.splice(this._senders.indexOf(sender), 1);
        }
      });
    };
  } else if (typeof window2 === "object" && window2.RTCPeerConnection && "getSenders" in window2.RTCPeerConnection.prototype && "createDTMFSender" in window2.RTCPeerConnection.prototype && window2.RTCRtpSender && !("dtmf" in window2.RTCRtpSender.prototype)) {
    const origGetSenders = window2.RTCPeerConnection.prototype.getSenders;
    window2.RTCPeerConnection.prototype.getSenders = function getSenders() {
      const senders = origGetSenders.apply(this, []);
      senders.forEach((sender) => sender._pc = this);
      return senders;
    };
    Object.defineProperty(window2.RTCRtpSender.prototype, "dtmf", {
      get() {
        if (this._dtmf === void 0) {
          if (this.track.kind === "audio") {
            this._dtmf = this._pc.createDTMFSender(this.track);
          } else {
            this._dtmf = null;
          }
        }
        return this._dtmf;
      }
    });
  }
}
function shimGetStats(window2) {
  if (!window2.RTCPeerConnection) {
    return;
  }
  const origGetStats = window2.RTCPeerConnection.prototype.getStats;
  window2.RTCPeerConnection.prototype.getStats = function getStats() {
    const [selector, onSucc, onErr] = arguments;
    if (arguments.length > 0 && typeof selector === "function") {
      return origGetStats.apply(this, arguments);
    }
    if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== "function")) {
      return origGetStats.apply(this, []);
    }
    const fixChromeStats_ = function(response) {
      const standardReport = {};
      const reports = response.result();
      reports.forEach((report) => {
        const standardStats = {
          id: report.id,
          timestamp: report.timestamp,
          type: {
            localcandidate: "local-candidate",
            remotecandidate: "remote-candidate"
          }[report.type] || report.type
        };
        report.names().forEach((name) => {
          standardStats[name] = report.stat(name);
        });
        standardReport[standardStats.id] = standardStats;
      });
      return standardReport;
    };
    const makeMapStats = function(stats) {
      return new Map(Object.keys(stats).map((key) => [key, stats[key]]));
    };
    if (arguments.length >= 2) {
      const successCallbackWrapper_ = function(response) {
        onSucc(makeMapStats(fixChromeStats_(response)));
      };
      return origGetStats.apply(this, [
        successCallbackWrapper_,
        selector
      ]);
    }
    return new Promise((resolve, reject) => {
      origGetStats.apply(this, [
        function(response) {
          resolve(makeMapStats(fixChromeStats_(response)));
        },
        reject
      ]);
    }).then(onSucc, onErr);
  };
}
function shimSenderReceiverGetStats(window2) {
  if (!(typeof window2 === "object" && window2.RTCPeerConnection && window2.RTCRtpSender && window2.RTCRtpReceiver)) {
    return;
  }
  if (!("getStats" in window2.RTCRtpSender.prototype)) {
    const origGetSenders = window2.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window2.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender) => sender._pc = this);
        return senders;
      };
    }
    const origAddTrack = window2.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window2.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window2.RTCRtpSender.prototype.getStats = function getStats() {
      const sender = this;
      return this._pc.getStats().then((result) => (
        /* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */
        filterStats(result, sender.track, true)
      ));
    };
  }
  if (!("getStats" in window2.RTCRtpReceiver.prototype)) {
    const origGetReceivers = window2.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window2.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver) => receiver._pc = this);
        return receivers;
      };
    }
    wrapPeerConnectionEvent(window2, "track", (e) => {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window2.RTCRtpReceiver.prototype.getStats = function getStats() {
      const receiver = this;
      return this._pc.getStats().then((result) => filterStats(result, receiver.track, false));
    };
  }
  if (!("getStats" in window2.RTCRtpSender.prototype && "getStats" in window2.RTCRtpReceiver.prototype)) {
    return;
  }
  const origGetStats = window2.RTCPeerConnection.prototype.getStats;
  window2.RTCPeerConnection.prototype.getStats = function getStats() {
    if (arguments.length > 0 && arguments[0] instanceof window2.MediaStreamTrack) {
      const track = arguments[0];
      let sender;
      let receiver;
      let err;
      this.getSenders().forEach((s) => {
        if (s.track === track) {
          if (sender) {
            err = true;
          } else {
            sender = s;
          }
        }
      });
      this.getReceivers().forEach((r) => {
        if (r.track === track) {
          if (receiver) {
            err = true;
          } else {
            receiver = r;
          }
        }
        return r.track === track;
      });
      if (err || sender && receiver) {
        return Promise.reject(new DOMException(
          "There are more than one sender or receiver for the track.",
          "InvalidAccessError"
        ));
      } else if (sender) {
        return sender.getStats();
      } else if (receiver) {
        return receiver.getStats();
      }
      return Promise.reject(new DOMException(
        "There is no sender or receiver for the track.",
        "InvalidAccessError"
      ));
    }
    return origGetStats.apply(this, arguments);
  };
}
function shimAddTrackRemoveTrackWithNative(window2) {
  window2.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    return Object.keys(this._shimmedLocalStreams).map((streamId) => this._shimmedLocalStreams[streamId][0]);
  };
  const origAddTrack = window2.RTCPeerConnection.prototype.addTrack;
  window2.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
    if (!stream) {
      return origAddTrack.apply(this, arguments);
    }
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    const sender = origAddTrack.apply(this, arguments);
    if (!this._shimmedLocalStreams[stream.id]) {
      this._shimmedLocalStreams[stream.id] = [stream, sender];
    } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
      this._shimmedLocalStreams[stream.id].push(sender);
    }
    return sender;
  };
  const origAddStream = window2.RTCPeerConnection.prototype.addStream;
  window2.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    stream.getTracks().forEach((track) => {
      const alreadyExists = this.getSenders().find((s) => s.track === track);
      if (alreadyExists) {
        throw new DOMException(
          "Track already exists.",
          "InvalidAccessError"
        );
      }
    });
    const existingSenders = this.getSenders();
    origAddStream.apply(this, arguments);
    const newSenders = this.getSenders().filter((newSender) => existingSenders.indexOf(newSender) === -1);
    this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
  };
  const origRemoveStream = window2.RTCPeerConnection.prototype.removeStream;
  window2.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    delete this._shimmedLocalStreams[stream.id];
    return origRemoveStream.apply(this, arguments);
  };
  const origRemoveTrack = window2.RTCPeerConnection.prototype.removeTrack;
  window2.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    if (sender) {
      Object.keys(this._shimmedLocalStreams).forEach((streamId) => {
        const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
        if (idx !== -1) {
          this._shimmedLocalStreams[streamId].splice(idx, 1);
        }
        if (this._shimmedLocalStreams[streamId].length === 1) {
          delete this._shimmedLocalStreams[streamId];
        }
      });
    }
    return origRemoveTrack.apply(this, arguments);
  };
}
function shimAddTrackRemoveTrack(window2, browserDetails) {
  if (!window2.RTCPeerConnection) {
    return;
  }
  if (window2.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) {
    return shimAddTrackRemoveTrackWithNative(window2);
  }
  const origGetLocalStreams = window2.RTCPeerConnection.prototype.getLocalStreams;
  window2.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
    const nativeStreams = origGetLocalStreams.apply(this);
    this._reverseStreams = this._reverseStreams || {};
    return nativeStreams.map((stream) => this._reverseStreams[stream.id]);
  };
  const origAddStream = window2.RTCPeerConnection.prototype.addStream;
  window2.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    stream.getTracks().forEach((track) => {
      const alreadyExists = this.getSenders().find((s) => s.track === track);
      if (alreadyExists) {
        throw new DOMException(
          "Track already exists.",
          "InvalidAccessError"
        );
      }
    });
    if (!this._reverseStreams[stream.id]) {
      const newStream = new window2.MediaStream(stream.getTracks());
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      stream = newStream;
    }
    origAddStream.apply(this, [stream]);
  };
  const origRemoveStream = window2.RTCPeerConnection.prototype.removeStream;
  window2.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    origRemoveStream.apply(this, [this._streams[stream.id] || stream]);
    delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
    delete this._streams[stream.id];
  };
  window2.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
    if (this.signalingState === "closed") {
      throw new DOMException(
        "The RTCPeerConnection's signalingState is 'closed'.",
        "InvalidStateError"
      );
    }
    const streams = [].slice.call(arguments, 1);
    if (streams.length !== 1 || !streams[0].getTracks().find((t) => t === track)) {
      throw new DOMException(
        "The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.",
        "NotSupportedError"
      );
    }
    const alreadyExists = this.getSenders().find((s) => s.track === track);
    if (alreadyExists) {
      throw new DOMException(
        "Track already exists.",
        "InvalidAccessError"
      );
    }
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    const oldStream = this._streams[stream.id];
    if (oldStream) {
      oldStream.addTrack(track);
      Promise.resolve().then(() => {
        this.dispatchEvent(new Event("negotiationneeded"));
      });
    } else {
      const newStream = new window2.MediaStream([track]);
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      this.addStream(newStream);
    }
    return this.getSenders().find((s) => s.track === track);
  };
  function replaceInternalStreamId(pc, description) {
    let sdp2 = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach((internalId) => {
      const externalStream = pc._reverseStreams[internalId];
      const internalStream = pc._streams[externalStream.id];
      sdp2 = sdp2.replace(
        new RegExp(internalStream.id, "g"),
        externalStream.id
      );
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp2
    });
  }
  function replaceExternalStreamId(pc, description) {
    let sdp2 = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach((internalId) => {
      const externalStream = pc._reverseStreams[internalId];
      const internalStream = pc._streams[externalStream.id];
      sdp2 = sdp2.replace(
        new RegExp(externalStream.id, "g"),
        internalStream.id
      );
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp2
    });
  }
  ["createOffer", "createAnswer"].forEach(function(method) {
    const nativeMethod = window2.RTCPeerConnection.prototype[method];
    const methodObj = { [method]() {
      const args = arguments;
      const isLegacyCall = arguments.length && typeof arguments[0] === "function";
      if (isLegacyCall) {
        return nativeMethod.apply(this, [
          (description) => {
            const desc = replaceInternalStreamId(this, description);
            args[0].apply(null, [desc]);
          },
          (err) => {
            if (args[1]) {
              args[1].apply(null, err);
            }
          },
          arguments[2]
        ]);
      }
      return nativeMethod.apply(this, arguments).then((description) => replaceInternalStreamId(this, description));
    } };
    window2.RTCPeerConnection.prototype[method] = methodObj[method];
  });
  const origSetLocalDescription = window2.RTCPeerConnection.prototype.setLocalDescription;
  window2.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
    if (!arguments.length || !arguments[0].type) {
      return origSetLocalDescription.apply(this, arguments);
    }
    arguments[0] = replaceExternalStreamId(this, arguments[0]);
    return origSetLocalDescription.apply(this, arguments);
  };
  const origLocalDescription = Object.getOwnPropertyDescriptor(
    window2.RTCPeerConnection.prototype,
    "localDescription"
  );
  Object.defineProperty(
    window2.RTCPeerConnection.prototype,
    "localDescription",
    {
      get() {
        const description = origLocalDescription.get.apply(this);
        if (description.type === "") {
          return description;
        }
        return replaceInternalStreamId(this, description);
      }
    }
  );
  window2.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
    if (this.signalingState === "closed") {
      throw new DOMException(
        "The RTCPeerConnection's signalingState is 'closed'.",
        "InvalidStateError"
      );
    }
    if (!sender._pc) {
      throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
    }
    const isLocal = sender._pc === this;
    if (!isLocal) {
      throw new DOMException(
        "Sender was not created by this connection.",
        "InvalidAccessError"
      );
    }
    this._streams = this._streams || {};
    let stream;
    Object.keys(this._streams).forEach((streamid) => {
      const hasTrack = this._streams[streamid].getTracks().find((track) => sender.track === track);
      if (hasTrack) {
        stream = this._streams[streamid];
      }
    });
    if (stream) {
      if (stream.getTracks().length === 1) {
        this.removeStream(this._reverseStreams[stream.id]);
      } else {
        stream.removeTrack(sender.track);
      }
      this.dispatchEvent(new Event("negotiationneeded"));
    }
  };
}
function shimPeerConnection(window2, browserDetails) {
  if (!window2.RTCPeerConnection && window2.webkitRTCPeerConnection) {
    window2.RTCPeerConnection = window2.webkitRTCPeerConnection;
  }
  if (!window2.RTCPeerConnection) {
    return;
  }
  if (browserDetails.version < 53) {
    ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(method) {
      const nativeMethod = window2.RTCPeerConnection.prototype[method];
      const methodObj = { [method]() {
        arguments[0] = new (method === "addIceCandidate" ? window2.RTCIceCandidate : window2.RTCSessionDescription)(arguments[0]);
        return nativeMethod.apply(this, arguments);
      } };
      window2.RTCPeerConnection.prototype[method] = methodObj[method];
    });
  }
}
function fixNegotiationNeeded(window2, browserDetails) {
  wrapPeerConnectionEvent(window2, "negotiationneeded", (e) => {
    const pc = e.target;
    if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
      if (pc.signalingState !== "stable") {
        return;
      }
    }
    return e;
  });
}

// ../../node_modules/webrtc-adapter/src/js/firefox/firefox_shim.js
var firefox_shim_exports = {};
__export(firefox_shim_exports, {
  shimAddTransceiver: () => shimAddTransceiver,
  shimCreateAnswer: () => shimCreateAnswer,
  shimCreateOffer: () => shimCreateOffer,
  shimGetDisplayMedia: () => shimGetDisplayMedia2,
  shimGetParameters: () => shimGetParameters,
  shimGetUserMedia: () => shimGetUserMedia2,
  shimOnTrack: () => shimOnTrack2,
  shimPeerConnection: () => shimPeerConnection2,
  shimRTCDataChannel: () => shimRTCDataChannel,
  shimReceiverGetStats: () => shimReceiverGetStats,
  shimRemoveStream: () => shimRemoveStream,
  shimSenderGetStats: () => shimSenderGetStats
});
init_define_process_env();

// ../../node_modules/webrtc-adapter/src/js/firefox/getusermedia.js
init_define_process_env();
function shimGetUserMedia2(window2, browserDetails) {
  const navigator2 = window2 && window2.navigator;
  const MediaStreamTrack = window2 && window2.MediaStreamTrack;
  navigator2.getUserMedia = function(constraints, onSuccess, onError) {
    deprecated(
      "navigator.getUserMedia",
      "navigator.mediaDevices.getUserMedia"
    );
    navigator2.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };
  if (!(browserDetails.version > 55 && "autoGainControl" in navigator2.mediaDevices.getSupportedConstraints())) {
    const remap = function(obj, a2, b2) {
      if (a2 in obj && !(b2 in obj)) {
        obj[b2] = obj[a2];
        delete obj[a2];
      }
    };
    const nativeGetUserMedia = navigator2.mediaDevices.getUserMedia.bind(navigator2.mediaDevices);
    navigator2.mediaDevices.getUserMedia = function(c2) {
      if (typeof c2 === "object" && typeof c2.audio === "object") {
        c2 = JSON.parse(JSON.stringify(c2));
        remap(c2.audio, "autoGainControl", "mozAutoGainControl");
        remap(c2.audio, "noiseSuppression", "mozNoiseSuppression");
      }
      return nativeGetUserMedia(c2);
    };
    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function() {
        const obj = nativeGetSettings.apply(this, arguments);
        remap(obj, "mozAutoGainControl", "autoGainControl");
        remap(obj, "mozNoiseSuppression", "noiseSuppression");
        return obj;
      };
    }
    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function(c2) {
        if (this.kind === "audio" && typeof c2 === "object") {
          c2 = JSON.parse(JSON.stringify(c2));
          remap(c2, "autoGainControl", "mozAutoGainControl");
          remap(c2, "noiseSuppression", "mozNoiseSuppression");
        }
        return nativeApplyConstraints.apply(this, [c2]);
      };
    }
  }
}

// ../../node_modules/webrtc-adapter/src/js/firefox/getdisplaymedia.js
init_define_process_env();
function shimGetDisplayMedia2(window2, preferredMediaSource) {
  if (window2.navigator.mediaDevices && "getDisplayMedia" in window2.navigator.mediaDevices) {
    return;
  }
  if (!window2.navigator.mediaDevices) {
    return;
  }
  window2.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
    if (!(constraints && constraints.video)) {
      const err = new DOMException("getDisplayMedia without video constraints is undefined");
      err.name = "NotFoundError";
      err.code = 8;
      return Promise.reject(err);
    }
    if (constraints.video === true) {
      constraints.video = { mediaSource: preferredMediaSource };
    } else {
      constraints.video.mediaSource = preferredMediaSource;
    }
    return window2.navigator.mediaDevices.getUserMedia(constraints);
  };
}

// ../../node_modules/webrtc-adapter/src/js/firefox/firefox_shim.js
function shimOnTrack2(window2) {
  if (typeof window2 === "object" && window2.RTCTrackEvent && "receiver" in window2.RTCTrackEvent.prototype && !("transceiver" in window2.RTCTrackEvent.prototype)) {
    Object.defineProperty(window2.RTCTrackEvent.prototype, "transceiver", {
      get() {
        return { receiver: this.receiver };
      }
    });
  }
}
function shimPeerConnection2(window2, browserDetails) {
  if (typeof window2 !== "object" || !(window2.RTCPeerConnection || window2.mozRTCPeerConnection)) {
    return;
  }
  if (!window2.RTCPeerConnection && window2.mozRTCPeerConnection) {
    window2.RTCPeerConnection = window2.mozRTCPeerConnection;
  }
  if (browserDetails.version < 53) {
    ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(method) {
      const nativeMethod = window2.RTCPeerConnection.prototype[method];
      const methodObj = { [method]() {
        arguments[0] = new (method === "addIceCandidate" ? window2.RTCIceCandidate : window2.RTCSessionDescription)(arguments[0]);
        return nativeMethod.apply(this, arguments);
      } };
      window2.RTCPeerConnection.prototype[method] = methodObj[method];
    });
  }
  const modernStatsTypes = {
    inboundrtp: "inbound-rtp",
    outboundrtp: "outbound-rtp",
    candidatepair: "candidate-pair",
    localcandidate: "local-candidate",
    remotecandidate: "remote-candidate"
  };
  const nativeGetStats = window2.RTCPeerConnection.prototype.getStats;
  window2.RTCPeerConnection.prototype.getStats = function getStats() {
    const [selector, onSucc, onErr] = arguments;
    return nativeGetStats.apply(this, [selector || null]).then((stats) => {
      if (browserDetails.version < 53 && !onSucc) {
        try {
          stats.forEach((stat) => {
            stat.type = modernStatsTypes[stat.type] || stat.type;
          });
        } catch (e) {
          if (e.name !== "TypeError") {
            throw e;
          }
          stats.forEach((stat, i) => {
            stats.set(i, Object.assign({}, stat, {
              type: modernStatsTypes[stat.type] || stat.type
            }));
          });
        }
      }
      return stats;
    }).then(onSucc, onErr);
  };
}
function shimSenderGetStats(window2) {
  if (!(typeof window2 === "object" && window2.RTCPeerConnection && window2.RTCRtpSender)) {
    return;
  }
  if (window2.RTCRtpSender && "getStats" in window2.RTCRtpSender.prototype) {
    return;
  }
  const origGetSenders = window2.RTCPeerConnection.prototype.getSenders;
  if (origGetSenders) {
    window2.RTCPeerConnection.prototype.getSenders = function getSenders() {
      const senders = origGetSenders.apply(this, []);
      senders.forEach((sender) => sender._pc = this);
      return senders;
    };
  }
  const origAddTrack = window2.RTCPeerConnection.prototype.addTrack;
  if (origAddTrack) {
    window2.RTCPeerConnection.prototype.addTrack = function addTrack() {
      const sender = origAddTrack.apply(this, arguments);
      sender._pc = this;
      return sender;
    };
  }
  window2.RTCRtpSender.prototype.getStats = function getStats() {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(/* @__PURE__ */ new Map());
  };
}
function shimReceiverGetStats(window2) {
  if (!(typeof window2 === "object" && window2.RTCPeerConnection && window2.RTCRtpSender)) {
    return;
  }
  if (window2.RTCRtpSender && "getStats" in window2.RTCRtpReceiver.prototype) {
    return;
  }
  const origGetReceivers = window2.RTCPeerConnection.prototype.getReceivers;
  if (origGetReceivers) {
    window2.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
      const receivers = origGetReceivers.apply(this, []);
      receivers.forEach((receiver) => receiver._pc = this);
      return receivers;
    };
  }
  wrapPeerConnectionEvent(window2, "track", (e) => {
    e.receiver._pc = e.srcElement;
    return e;
  });
  window2.RTCRtpReceiver.prototype.getStats = function getStats() {
    return this._pc.getStats(this.track);
  };
}
function shimRemoveStream(window2) {
  if (!window2.RTCPeerConnection || "removeStream" in window2.RTCPeerConnection.prototype) {
    return;
  }
  window2.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    deprecated("removeStream", "removeTrack");
    this.getSenders().forEach((sender) => {
      if (sender.track && stream.getTracks().includes(sender.track)) {
        this.removeTrack(sender);
      }
    });
  };
}
function shimRTCDataChannel(window2) {
  if (window2.DataChannel && !window2.RTCDataChannel) {
    window2.RTCDataChannel = window2.DataChannel;
  }
}
function shimAddTransceiver(window2) {
  if (!(typeof window2 === "object" && window2.RTCPeerConnection)) {
    return;
  }
  const origAddTransceiver = window2.RTCPeerConnection.prototype.addTransceiver;
  if (origAddTransceiver) {
    window2.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
      this.setParametersPromises = [];
      let sendEncodings = arguments[1] && arguments[1].sendEncodings;
      if (sendEncodings === void 0) {
        sendEncodings = [];
      }
      sendEncodings = [...sendEncodings];
      const shouldPerformCheck = sendEncodings.length > 0;
      if (shouldPerformCheck) {
        sendEncodings.forEach((encodingParam) => {
          if ("rid" in encodingParam) {
            const ridRegex = /^[a-z0-9]{0,16}$/i;
            if (!ridRegex.test(encodingParam.rid)) {
              throw new TypeError("Invalid RID value provided.");
            }
          }
          if ("scaleResolutionDownBy" in encodingParam) {
            if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1)) {
              throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
          }
          if ("maxFramerate" in encodingParam) {
            if (!(parseFloat(encodingParam.maxFramerate) >= 0)) {
              throw new RangeError("max_framerate must be >= 0.0");
            }
          }
        });
      }
      const transceiver = origAddTransceiver.apply(this, arguments);
      if (shouldPerformCheck) {
        const { sender } = transceiver;
        const params = sender.getParameters();
        if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
        params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
          params.encodings = sendEncodings;
          sender.sendEncodings = sendEncodings;
          this.setParametersPromises.push(
            sender.setParameters(params).then(() => {
              delete sender.sendEncodings;
            }).catch(() => {
              delete sender.sendEncodings;
            })
          );
        }
      }
      return transceiver;
    };
  }
}
function shimGetParameters(window2) {
  if (!(typeof window2 === "object" && window2.RTCRtpSender)) {
    return;
  }
  const origGetParameters = window2.RTCRtpSender.prototype.getParameters;
  if (origGetParameters) {
    window2.RTCRtpSender.prototype.getParameters = function getParameters() {
      const params = origGetParameters.apply(this, arguments);
      if (!("encodings" in params)) {
        params.encodings = [].concat(this.sendEncodings || [{}]);
      }
      return params;
    };
  }
}
function shimCreateOffer(window2) {
  if (!(typeof window2 === "object" && window2.RTCPeerConnection)) {
    return;
  }
  const origCreateOffer = window2.RTCPeerConnection.prototype.createOffer;
  window2.RTCPeerConnection.prototype.createOffer = function createOffer() {
    if (this.setParametersPromises && this.setParametersPromises.length) {
      return Promise.all(this.setParametersPromises).then(() => {
        return origCreateOffer.apply(this, arguments);
      }).finally(() => {
        this.setParametersPromises = [];
      });
    }
    return origCreateOffer.apply(this, arguments);
  };
}
function shimCreateAnswer(window2) {
  if (!(typeof window2 === "object" && window2.RTCPeerConnection)) {
    return;
  }
  const origCreateAnswer = window2.RTCPeerConnection.prototype.createAnswer;
  window2.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
    if (this.setParametersPromises && this.setParametersPromises.length) {
      return Promise.all(this.setParametersPromises).then(() => {
        return origCreateAnswer.apply(this, arguments);
      }).finally(() => {
        this.setParametersPromises = [];
      });
    }
    return origCreateAnswer.apply(this, arguments);
  };
}

// ../../node_modules/webrtc-adapter/src/js/safari/safari_shim.js
var safari_shim_exports = {};
__export(safari_shim_exports, {
  shimAudioContext: () => shimAudioContext,
  shimCallbacksAPI: () => shimCallbacksAPI,
  shimConstraints: () => shimConstraints,
  shimCreateOfferLegacy: () => shimCreateOfferLegacy,
  shimGetUserMedia: () => shimGetUserMedia3,
  shimLocalStreamsAPI: () => shimLocalStreamsAPI,
  shimRTCIceServerUrls: () => shimRTCIceServerUrls,
  shimRemoteStreamsAPI: () => shimRemoteStreamsAPI,
  shimTrackEventTransceiver: () => shimTrackEventTransceiver
});
init_define_process_env();
function shimLocalStreamsAPI(window2) {
  if (typeof window2 !== "object" || !window2.RTCPeerConnection) {
    return;
  }
  if (!("getLocalStreams" in window2.RTCPeerConnection.prototype)) {
    window2.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
      if (!this._localStreams) {
        this._localStreams = [];
      }
      return this._localStreams;
    };
  }
  if (!("addStream" in window2.RTCPeerConnection.prototype)) {
    const _addTrack = window2.RTCPeerConnection.prototype.addTrack;
    window2.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      if (!this._localStreams) {
        this._localStreams = [];
      }
      if (!this._localStreams.includes(stream)) {
        this._localStreams.push(stream);
      }
      stream.getAudioTracks().forEach((track) => _addTrack.call(
        this,
        track,
        stream
      ));
      stream.getVideoTracks().forEach((track) => _addTrack.call(
        this,
        track,
        stream
      ));
    };
    window2.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
      if (streams) {
        streams.forEach((stream) => {
          if (!this._localStreams) {
            this._localStreams = [stream];
          } else if (!this._localStreams.includes(stream)) {
            this._localStreams.push(stream);
          }
        });
      }
      return _addTrack.apply(this, arguments);
    };
  }
  if (!("removeStream" in window2.RTCPeerConnection.prototype)) {
    window2.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
      if (!this._localStreams) {
        this._localStreams = [];
      }
      const index = this._localStreams.indexOf(stream);
      if (index === -1) {
        return;
      }
      this._localStreams.splice(index, 1);
      const tracks = stream.getTracks();
      this.getSenders().forEach((sender) => {
        if (tracks.includes(sender.track)) {
          this.removeTrack(sender);
        }
      });
    };
  }
}
function shimRemoteStreamsAPI(window2) {
  if (typeof window2 !== "object" || !window2.RTCPeerConnection) {
    return;
  }
  if (!("getRemoteStreams" in window2.RTCPeerConnection.prototype)) {
    window2.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
      return this._remoteStreams ? this._remoteStreams : [];
    };
  }
  if (!("onaddstream" in window2.RTCPeerConnection.prototype)) {
    Object.defineProperty(window2.RTCPeerConnection.prototype, "onaddstream", {
      get() {
        return this._onaddstream;
      },
      set(f) {
        if (this._onaddstream) {
          this.removeEventListener("addstream", this._onaddstream);
          this.removeEventListener("track", this._onaddstreampoly);
        }
        this.addEventListener("addstream", this._onaddstream = f);
        this.addEventListener("track", this._onaddstreampoly = (e) => {
          e.streams.forEach((stream) => {
            if (!this._remoteStreams) {
              this._remoteStreams = [];
            }
            if (this._remoteStreams.includes(stream)) {
              return;
            }
            this._remoteStreams.push(stream);
            const event = new Event("addstream");
            event.stream = stream;
            this.dispatchEvent(event);
          });
        });
      }
    });
    const origSetRemoteDescription = window2.RTCPeerConnection.prototype.setRemoteDescription;
    window2.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
      const pc = this;
      if (!this._onaddstreampoly) {
        this.addEventListener("track", this._onaddstreampoly = function(e) {
          e.streams.forEach((stream) => {
            if (!pc._remoteStreams) {
              pc._remoteStreams = [];
            }
            if (pc._remoteStreams.indexOf(stream) >= 0) {
              return;
            }
            pc._remoteStreams.push(stream);
            const event = new Event("addstream");
            event.stream = stream;
            pc.dispatchEvent(event);
          });
        });
      }
      return origSetRemoteDescription.apply(pc, arguments);
    };
  }
}
function shimCallbacksAPI(window2) {
  if (typeof window2 !== "object" || !window2.RTCPeerConnection) {
    return;
  }
  const prototype = window2.RTCPeerConnection.prototype;
  const origCreateOffer = prototype.createOffer;
  const origCreateAnswer = prototype.createAnswer;
  const setLocalDescription = prototype.setLocalDescription;
  const setRemoteDescription = prototype.setRemoteDescription;
  const addIceCandidate = prototype.addIceCandidate;
  prototype.createOffer = function createOffer(successCallback, failureCallback) {
    const options = arguments.length >= 2 ? arguments[2] : arguments[0];
    const promise = origCreateOffer.apply(this, [options]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
    const options = arguments.length >= 2 ? arguments[2] : arguments[0];
    const promise = origCreateAnswer.apply(this, [options]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  let withCallback = function(description, successCallback, failureCallback) {
    const promise = setLocalDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setLocalDescription = withCallback;
  withCallback = function(description, successCallback, failureCallback) {
    const promise = setRemoteDescription.apply(this, [description]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.setRemoteDescription = withCallback;
  withCallback = function(candidate, successCallback, failureCallback) {
    const promise = addIceCandidate.apply(this, [candidate]);
    if (!failureCallback) {
      return promise;
    }
    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };
  prototype.addIceCandidate = withCallback;
}
function shimGetUserMedia3(window2) {
  const navigator2 = window2 && window2.navigator;
  if (navigator2.mediaDevices && navigator2.mediaDevices.getUserMedia) {
    const mediaDevices = navigator2.mediaDevices;
    const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
    navigator2.mediaDevices.getUserMedia = (constraints) => {
      return _getUserMedia(shimConstraints(constraints));
    };
  }
  if (!navigator2.getUserMedia && navigator2.mediaDevices && navigator2.mediaDevices.getUserMedia) {
    navigator2.getUserMedia = function getUserMedia(constraints, cb, errcb) {
      navigator2.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }.bind(navigator2);
  }
}
function shimConstraints(constraints) {
  if (constraints && constraints.video !== void 0) {
    return Object.assign(
      {},
      constraints,
      { video: compactObject(constraints.video) }
    );
  }
  return constraints;
}
function shimRTCIceServerUrls(window2) {
  if (!window2.RTCPeerConnection) {
    return;
  }
  const OrigPeerConnection = window2.RTCPeerConnection;
  window2.RTCPeerConnection = function RTCPeerConnection2(pcConfig, pcConstraints) {
    if (pcConfig && pcConfig.iceServers) {
      const newIceServers = [];
      for (let i = 0; i < pcConfig.iceServers.length; i++) {
        let server = pcConfig.iceServers[i];
        if (server.urls === void 0 && server.url) {
          deprecated("RTCIceServer.url", "RTCIceServer.urls");
          server = JSON.parse(JSON.stringify(server));
          server.urls = server.url;
          delete server.url;
          newIceServers.push(server);
        } else {
          newIceServers.push(pcConfig.iceServers[i]);
        }
      }
      pcConfig.iceServers = newIceServers;
    }
    return new OrigPeerConnection(pcConfig, pcConstraints);
  };
  window2.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
  if ("generateCertificate" in OrigPeerConnection) {
    Object.defineProperty(window2.RTCPeerConnection, "generateCertificate", {
      get() {
        return OrigPeerConnection.generateCertificate;
      }
    });
  }
}
function shimTrackEventTransceiver(window2) {
  if (typeof window2 === "object" && window2.RTCTrackEvent && "receiver" in window2.RTCTrackEvent.prototype && !("transceiver" in window2.RTCTrackEvent.prototype)) {
    Object.defineProperty(window2.RTCTrackEvent.prototype, "transceiver", {
      get() {
        return { receiver: this.receiver };
      }
    });
  }
}
function shimCreateOfferLegacy(window2) {
  const origCreateOffer = window2.RTCPeerConnection.prototype.createOffer;
  window2.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
    if (offerOptions) {
      if (typeof offerOptions.offerToReceiveAudio !== "undefined") {
        offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
      }
      const audioTransceiver = this.getTransceivers().find((transceiver) => transceiver.receiver.track.kind === "audio");
      if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
        if (audioTransceiver.direction === "sendrecv") {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection("sendonly");
          } else {
            audioTransceiver.direction = "sendonly";
          }
        } else if (audioTransceiver.direction === "recvonly") {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection("inactive");
          } else {
            audioTransceiver.direction = "inactive";
          }
        }
      } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
        this.addTransceiver("audio", { direction: "recvonly" });
      }
      if (typeof offerOptions.offerToReceiveVideo !== "undefined") {
        offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
      }
      const videoTransceiver = this.getTransceivers().find((transceiver) => transceiver.receiver.track.kind === "video");
      if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
        if (videoTransceiver.direction === "sendrecv") {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection("sendonly");
          } else {
            videoTransceiver.direction = "sendonly";
          }
        } else if (videoTransceiver.direction === "recvonly") {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection("inactive");
          } else {
            videoTransceiver.direction = "inactive";
          }
        }
      } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
        this.addTransceiver("video", { direction: "recvonly" });
      }
    }
    return origCreateOffer.apply(this, arguments);
  };
}
function shimAudioContext(window2) {
  if (typeof window2 !== "object" || window2.AudioContext) {
    return;
  }
  window2.AudioContext = window2.webkitAudioContext;
}

// ../../node_modules/webrtc-adapter/src/js/common_shim.js
var common_shim_exports = {};
__export(common_shim_exports, {
  removeExtmapAllowMixed: () => removeExtmapAllowMixed,
  shimAddIceCandidateNullOrEmpty: () => shimAddIceCandidateNullOrEmpty,
  shimConnectionState: () => shimConnectionState,
  shimMaxMessageSize: () => shimMaxMessageSize,
  shimParameterlessSetLocalDescription: () => shimParameterlessSetLocalDescription,
  shimRTCIceCandidate: () => shimRTCIceCandidate,
  shimRTCIceCandidateRelayProtocol: () => shimRTCIceCandidateRelayProtocol,
  shimSendThrowTypeError: () => shimSendThrowTypeError
});
init_define_process_env();
var import_sdp = __toESM(require_sdp());
function shimRTCIceCandidate(window2) {
  if (!window2.RTCIceCandidate || window2.RTCIceCandidate && "foundation" in window2.RTCIceCandidate.prototype) {
    return;
  }
  const NativeRTCIceCandidate = window2.RTCIceCandidate;
  window2.RTCIceCandidate = function RTCIceCandidate(args) {
    if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
      args = JSON.parse(JSON.stringify(args));
      args.candidate = args.candidate.substring(2);
    }
    if (args.candidate && args.candidate.length) {
      const nativeCandidate = new NativeRTCIceCandidate(args);
      const parsedCandidate = import_sdp.default.parseCandidate(args.candidate);
      for (const key in parsedCandidate) {
        if (!(key in nativeCandidate)) {
          Object.defineProperty(
            nativeCandidate,
            key,
            { value: parsedCandidate[key] }
          );
        }
      }
      nativeCandidate.toJSON = function toJSON() {
        return {
          candidate: nativeCandidate.candidate,
          sdpMid: nativeCandidate.sdpMid,
          sdpMLineIndex: nativeCandidate.sdpMLineIndex,
          usernameFragment: nativeCandidate.usernameFragment
        };
      };
      return nativeCandidate;
    }
    return new NativeRTCIceCandidate(args);
  };
  window2.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
  wrapPeerConnectionEvent(window2, "icecandidate", (e) => {
    if (e.candidate) {
      Object.defineProperty(e, "candidate", {
        value: new window2.RTCIceCandidate(e.candidate),
        writable: "false"
      });
    }
    return e;
  });
}
function shimRTCIceCandidateRelayProtocol(window2) {
  if (!window2.RTCIceCandidate || window2.RTCIceCandidate && "relayProtocol" in window2.RTCIceCandidate.prototype) {
    return;
  }
  wrapPeerConnectionEvent(window2, "icecandidate", (e) => {
    if (e.candidate) {
      const parsedCandidate = import_sdp.default.parseCandidate(e.candidate.candidate);
      if (parsedCandidate.type === "relay") {
        e.candidate.relayProtocol = {
          0: "tls",
          1: "tcp",
          2: "udp"
        }[parsedCandidate.priority >> 24];
      }
    }
    return e;
  });
}
function shimMaxMessageSize(window2, browserDetails) {
  if (!window2.RTCPeerConnection) {
    return;
  }
  if (!("sctp" in window2.RTCPeerConnection.prototype)) {
    Object.defineProperty(window2.RTCPeerConnection.prototype, "sctp", {
      get() {
        return typeof this._sctp === "undefined" ? null : this._sctp;
      }
    });
  }
  const sctpInDescription = function(description) {
    if (!description || !description.sdp) {
      return false;
    }
    const sections = import_sdp.default.splitSections(description.sdp);
    sections.shift();
    return sections.some((mediaSection) => {
      const mLine = import_sdp.default.parseMLine(mediaSection);
      return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
    });
  };
  const getRemoteFirefoxVersion = function(description) {
    const match18 = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (match18 === null || match18.length < 2) {
      return -1;
    }
    const version = parseInt(match18[1], 10);
    return version !== version ? -1 : version;
  };
  const getCanSendMaxMessageSize = function(remoteIsFirefox) {
    let canSendMaxMessageSize = 65536;
    if (browserDetails.browser === "firefox") {
      if (browserDetails.version < 57) {
        if (remoteIsFirefox === -1) {
          canSendMaxMessageSize = 16384;
        } else {
          canSendMaxMessageSize = 2147483637;
        }
      } else if (browserDetails.version < 60) {
        canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
      } else {
        canSendMaxMessageSize = 2147483637;
      }
    }
    return canSendMaxMessageSize;
  };
  const getMaxMessageSize = function(description, remoteIsFirefox) {
    let maxMessageSize = 65536;
    if (browserDetails.browser === "firefox" && browserDetails.version === 57) {
      maxMessageSize = 65535;
    }
    const match18 = import_sdp.default.matchPrefix(
      description.sdp,
      "a=max-message-size:"
    );
    if (match18.length > 0) {
      maxMessageSize = parseInt(match18[0].substring(19), 10);
    } else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) {
      maxMessageSize = 2147483637;
    }
    return maxMessageSize;
  };
  const origSetRemoteDescription = window2.RTCPeerConnection.prototype.setRemoteDescription;
  window2.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
    this._sctp = null;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
      const { sdpSemantics } = this.getConfiguration();
      if (sdpSemantics === "plan-b") {
        Object.defineProperty(this, "sctp", {
          get() {
            return typeof this._sctp === "undefined" ? null : this._sctp;
          },
          enumerable: true,
          configurable: true
        });
      }
    }
    if (sctpInDescription(arguments[0])) {
      const isFirefox2 = getRemoteFirefoxVersion(arguments[0]);
      const canSendMMS = getCanSendMaxMessageSize(isFirefox2);
      const remoteMMS = getMaxMessageSize(arguments[0], isFirefox2);
      let maxMessageSize;
      if (canSendMMS === 0 && remoteMMS === 0) {
        maxMessageSize = Number.POSITIVE_INFINITY;
      } else if (canSendMMS === 0 || remoteMMS === 0) {
        maxMessageSize = Math.max(canSendMMS, remoteMMS);
      } else {
        maxMessageSize = Math.min(canSendMMS, remoteMMS);
      }
      const sctp = {};
      Object.defineProperty(sctp, "maxMessageSize", {
        get() {
          return maxMessageSize;
        }
      });
      this._sctp = sctp;
    }
    return origSetRemoteDescription.apply(this, arguments);
  };
}
function shimSendThrowTypeError(window2) {
  if (!(window2.RTCPeerConnection && "createDataChannel" in window2.RTCPeerConnection.prototype)) {
    return;
  }
  function wrapDcSend(dc, pc) {
    const origDataChannelSend = dc.send;
    dc.send = function send() {
      const data3 = arguments[0];
      const length = data3.length || data3.size || data3.byteLength;
      if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) {
        throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
      }
      return origDataChannelSend.apply(dc, arguments);
    };
  }
  const origCreateDataChannel = window2.RTCPeerConnection.prototype.createDataChannel;
  window2.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
    const dataChannel = origCreateDataChannel.apply(this, arguments);
    wrapDcSend(dataChannel, this);
    return dataChannel;
  };
  wrapPeerConnectionEvent(window2, "datachannel", (e) => {
    wrapDcSend(e.channel, e.target);
    return e;
  });
}
function shimConnectionState(window2) {
  if (!window2.RTCPeerConnection || "connectionState" in window2.RTCPeerConnection.prototype) {
    return;
  }
  const proto = window2.RTCPeerConnection.prototype;
  Object.defineProperty(proto, "connectionState", {
    get() {
      return {
        completed: "connected",
        checking: "connecting"
      }[this.iceConnectionState] || this.iceConnectionState;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(proto, "onconnectionstatechange", {
    get() {
      return this._onconnectionstatechange || null;
    },
    set(cb) {
      if (this._onconnectionstatechange) {
        this.removeEventListener(
          "connectionstatechange",
          this._onconnectionstatechange
        );
        delete this._onconnectionstatechange;
      }
      if (cb) {
        this.addEventListener(
          "connectionstatechange",
          this._onconnectionstatechange = cb
        );
      }
    },
    enumerable: true,
    configurable: true
  });
  ["setLocalDescription", "setRemoteDescription"].forEach((method) => {
    const origMethod = proto[method];
    proto[method] = function() {
      if (!this._connectionstatechangepoly) {
        this._connectionstatechangepoly = (e) => {
          const pc = e.target;
          if (pc._lastConnectionState !== pc.connectionState) {
            pc._lastConnectionState = pc.connectionState;
            const newEvent = new Event("connectionstatechange", e);
            pc.dispatchEvent(newEvent);
          }
          return e;
        };
        this.addEventListener(
          "iceconnectionstatechange",
          this._connectionstatechangepoly
        );
      }
      return origMethod.apply(this, arguments);
    };
  });
}
function removeExtmapAllowMixed(window2, browserDetails) {
  if (!window2.RTCPeerConnection) {
    return;
  }
  if (browserDetails.browser === "chrome" && browserDetails.version >= 71) {
    return;
  }
  if (browserDetails.browser === "safari" && browserDetails.version >= 605) {
    return;
  }
  const nativeSRD = window2.RTCPeerConnection.prototype.setRemoteDescription;
  window2.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
    if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
      const sdp2 = desc.sdp.split("\n").filter((line) => {
        return line.trim() !== "a=extmap-allow-mixed";
      }).join("\n");
      if (window2.RTCSessionDescription && desc instanceof window2.RTCSessionDescription) {
        arguments[0] = new window2.RTCSessionDescription({
          type: desc.type,
          sdp: sdp2
        });
      } else {
        desc.sdp = sdp2;
      }
    }
    return nativeSRD.apply(this, arguments);
  };
}
function shimAddIceCandidateNullOrEmpty(window2, browserDetails) {
  if (!(window2.RTCPeerConnection && window2.RTCPeerConnection.prototype)) {
    return;
  }
  const nativeAddIceCandidate = window2.RTCPeerConnection.prototype.addIceCandidate;
  if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) {
    return;
  }
  window2.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
    if (!arguments[0]) {
      if (arguments[1]) {
        arguments[1].apply(null);
      }
      return Promise.resolve();
    }
    if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") {
      return Promise.resolve();
    }
    return nativeAddIceCandidate.apply(this, arguments);
  };
}
function shimParameterlessSetLocalDescription(window2, browserDetails) {
  if (!(window2.RTCPeerConnection && window2.RTCPeerConnection.prototype)) {
    return;
  }
  const nativeSetLocalDescription = window2.RTCPeerConnection.prototype.setLocalDescription;
  if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) {
    return;
  }
  window2.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
    let desc = arguments[0] || {};
    if (typeof desc !== "object" || desc.type && desc.sdp) {
      return nativeSetLocalDescription.apply(this, arguments);
    }
    desc = { type: desc.type, sdp: desc.sdp };
    if (!desc.type) {
      switch (this.signalingState) {
        case "stable":
        case "have-local-offer":
        case "have-remote-pranswer":
          desc.type = "offer";
          break;
        default:
          desc.type = "answer";
          break;
      }
    }
    if (desc.sdp || desc.type !== "offer" && desc.type !== "answer") {
      return nativeSetLocalDescription.apply(this, [desc]);
    }
    const func = desc.type === "offer" ? this.createOffer : this.createAnswer;
    return func.apply(this).then((d) => nativeSetLocalDescription.apply(this, [d]));
  };
}

// ../../node_modules/webrtc-adapter/src/js/adapter_factory.js
var sdp = __toESM(require_sdp());
function adapterFactory({ window: window2 } = {}, options = {
  shimChrome: true,
  shimFirefox: true,
  shimSafari: true
}) {
  const logging2 = log;
  const browserDetails = detectBrowser(window2);
  const adapter2 = {
    browserDetails,
    commonShim: common_shim_exports,
    extractVersion,
    disableLog,
    disableWarnings,
    // Expose sdp as a convenience. For production apps include directly.
    sdp
  };
  switch (browserDetails.browser) {
    case "chrome":
      if (!chrome_shim_exports || !shimPeerConnection || !options.shimChrome) {
        logging2("Chrome shim is not included in this adapter release.");
        return adapter2;
      }
      if (browserDetails.version === null) {
        logging2("Chrome shim can not determine version, not shimming.");
        return adapter2;
      }
      logging2("adapter.js shimming chrome.");
      adapter2.browserShim = chrome_shim_exports;
      shimAddIceCandidateNullOrEmpty(window2, browserDetails);
      shimParameterlessSetLocalDescription(window2, browserDetails);
      shimGetUserMedia(window2, browserDetails);
      shimMediaStream(window2, browserDetails);
      shimPeerConnection(window2, browserDetails);
      shimOnTrack(window2, browserDetails);
      shimAddTrackRemoveTrack(window2, browserDetails);
      shimGetSendersWithDtmf(window2, browserDetails);
      shimGetStats(window2, browserDetails);
      shimSenderReceiverGetStats(window2, browserDetails);
      fixNegotiationNeeded(window2, browserDetails);
      shimRTCIceCandidate(window2, browserDetails);
      shimRTCIceCandidateRelayProtocol(window2, browserDetails);
      shimConnectionState(window2, browserDetails);
      shimMaxMessageSize(window2, browserDetails);
      shimSendThrowTypeError(window2, browserDetails);
      removeExtmapAllowMixed(window2, browserDetails);
      break;
    case "firefox":
      if (!firefox_shim_exports || !shimPeerConnection2 || !options.shimFirefox) {
        logging2("Firefox shim is not included in this adapter release.");
        return adapter2;
      }
      logging2("adapter.js shimming firefox.");
      adapter2.browserShim = firefox_shim_exports;
      shimAddIceCandidateNullOrEmpty(window2, browserDetails);
      shimParameterlessSetLocalDescription(window2, browserDetails);
      shimGetUserMedia2(window2, browserDetails);
      shimPeerConnection2(window2, browserDetails);
      shimOnTrack2(window2, browserDetails);
      shimRemoveStream(window2, browserDetails);
      shimSenderGetStats(window2, browserDetails);
      shimReceiverGetStats(window2, browserDetails);
      shimRTCDataChannel(window2, browserDetails);
      shimAddTransceiver(window2, browserDetails);
      shimGetParameters(window2, browserDetails);
      shimCreateOffer(window2, browserDetails);
      shimCreateAnswer(window2, browserDetails);
      shimRTCIceCandidate(window2, browserDetails);
      shimConnectionState(window2, browserDetails);
      shimMaxMessageSize(window2, browserDetails);
      shimSendThrowTypeError(window2, browserDetails);
      break;
    case "safari":
      if (!safari_shim_exports || !options.shimSafari) {
        logging2("Safari shim is not included in this adapter release.");
        return adapter2;
      }
      logging2("adapter.js shimming safari.");
      adapter2.browserShim = safari_shim_exports;
      shimAddIceCandidateNullOrEmpty(window2, browserDetails);
      shimParameterlessSetLocalDescription(window2, browserDetails);
      shimRTCIceServerUrls(window2, browserDetails);
      shimCreateOfferLegacy(window2, browserDetails);
      shimCallbacksAPI(window2, browserDetails);
      shimLocalStreamsAPI(window2, browserDetails);
      shimRemoteStreamsAPI(window2, browserDetails);
      shimTrackEventTransceiver(window2, browserDetails);
      shimGetUserMedia3(window2, browserDetails);
      shimAudioContext(window2, browserDetails);
      shimRTCIceCandidate(window2, browserDetails);
      shimRTCIceCandidateRelayProtocol(window2, browserDetails);
      shimMaxMessageSize(window2, browserDetails);
      shimSendThrowTypeError(window2, browserDetails);
      removeExtmapAllowMixed(window2, browserDetails);
      break;
    default:
      logging2("Unsupported browser!");
      break;
  }
  return adapter2;
}

// ../../node_modules/webrtc-adapter/src/js/adapter_core.js
var adapter = adapterFactory({ window: typeof window === "undefined" ? void 0 : window });

// ../hms-video-store/dist/index.js
var import_lodash4 = __toESM(require_lodash2());
import { v4 as Do } from "uuid";
import { v4 as Oo } from "uuid";
import { v4 as Vo } from "uuid";
import { EventEmitter2 as Fo } from "eventemitter2";
var Yt = __toESM(require_lib());
import { EventEmitter2 as Sn } from "eventemitter2";
import { v4 as Mn } from "uuid";
import { EventEmitter2 as yn } from "eventemitter2";
import En from "eventemitter2";
import { v4 as Pn } from "uuid";
import { v4 as In } from "uuid";
var co = Object.defineProperty;
var lo = Object.defineProperties;
var uo = Object.getOwnPropertyDescriptors;
var ai = Object.getOwnPropertySymbols;
var gs = Object.prototype.hasOwnProperty;
var Ts = Object.prototype.propertyIsEnumerable;
var Ss = (a2, e, t) => e in a2 ? co(a2, e, { enumerable: true, configurable: true, writable: true, value: t }) : a2[e] = t;
var m = (a2, e) => {
  for (var t in e || (e = {}))
    gs.call(e, t) && Ss(a2, t, e[t]);
  if (ai)
    for (var t of ai(e))
      Ts.call(e, t) && Ss(a2, t, e[t]);
  return a2;
};
var M = (a2, e) => lo(a2, uo(e));
var kr = (a2, e) => {
  var t = {};
  for (var i in a2)
    gs.call(a2, i) && e.indexOf(i) < 0 && (t[i] = a2[i]);
  if (a2 != null && ai)
    for (var i of ai(a2))
      e.indexOf(i) < 0 && Ts.call(a2, i) && (t[i] = a2[i]);
  return t;
};
var mo = (a2, e) => () => (e || a2((e = { exports: {} }).exports, e), e.exports);
var c = (a2, e, t) => new Promise((i, r) => {
  var s = (d) => {
    try {
      n(t.next(d));
    } catch (u) {
      r(u);
    }
  }, o = (d) => {
    try {
      n(t.throw(d));
    } catch (u) {
      r(u);
    }
  }, n = (d) => d.done ? i(d.value) : Promise.resolve(d.value).then(s, o);
  n((t = t.apply(a2, e)).next());
});
var Ir = mo((Jc, Eo) => {
  Eo.exports = { version: "0.12.33", license: "MIT", repository: { type: "git", url: "https://github.com/100mslive/web-sdks.git", directory: "packages/hms-video-store" }, main: "dist/index.cjs.js", module: "dist/index.js", typings: "dist/index.d.ts", files: ["dist", "src"], engines: { node: ">=12" }, exports: { ".": { require: "./dist/index.cjs.js", import: "./dist/index.js", default: "./dist/index.js" } }, sideEffects: false, scripts: { prestart: "rm -rf dist && yarn types:build", start: 'concurrently "yarn dev" "yarn types"', dev: "node ../../scripts/dev", "build:only": "node ../../scripts/build", build: "yarn build:only && yarn types:build", types: "tsc -w", "types:build": "tsc -p tsconfig.json", format: "prettier --write src/**/*.ts", test: "jest --maxWorkers=1", "test:watch": "jest --watch", "test:coverage": "jest --coverage", lint: "eslint -c ../../.eslintrc .", "lint:fix": "yarn lint --fix", prepare: "yarn build", size: "size-limit", analyze: "size-limit --why", docs: "rm -rf ./docs && typedoc && rm -f ./docs/README.md && mkdir ./docs/home &&mv ./docs/modules.md ./docs/home/content.md && node ../../scripts/docs-store && npx prettier --write './docs/**/*'" }, name: "@100mslive/hms-video-store", author: "100ms", dependencies: { eventemitter2: "^6.4.9", immer: "^9.0.6", "lodash.isequal": "^4.5.0", reselect: "4.0.0", "sdp-transform": "^2.14.1", "ua-parser-js": "^1.0.1", uuid: "^8.3.2", "webrtc-adapter": "^8.0.0", zustand: "3.5.7" }, devDependencies: { "@types/dom-screen-wake-lock": "^1.0.1", "@types/lodash.isequal": "^4.5.8", "@types/sdp-transform": "^2.4.4", "@types/ua-parser-js": "^0.7.36", "@types/uuid": "^8.3.0", "jest-canvas-mock": "^2.3.1", "jsdom-worker": "^0.3.0", tslib: "^2.2.0" }, description: "@100mslive Core SDK which abstracts the complexities of webRTC while providing a reactive store for data management with a unidirectional data flow", keywords: ["video", "webrtc", "conferencing", "100ms"] };
});
var Er = ((n) => (n.Disconnected = "Disconnected", n.Preview = "Preview", n.Connecting = "Connecting", n.Connected = "Connected", n.Reconnecting = "Reconnecting", n.Disconnecting = "Disconnecting", n.Failed = "Failed", n))(Er || {});
var So = ((e) => (e.CHAT = "chat", e))(So || {});
var fs = ((t) => (t.INFO = "info", t.ERROR = "error", t))(fs || {});
var Pr = ((w) => (w.PEER_JOINED = "PEER_JOINED", w.PEER_LEFT = "PEER_LEFT", w.PEER_LIST = "PEER_LIST", w.NEW_MESSAGE = "NEW_MESSAGE", w.ERROR = "ERROR", w.RECONNECTING = "RECONNECTING", w.RECONNECTED = "RECONNECTED", w.TRACK_ADDED = "TRACK_ADDED", w.TRACK_REMOVED = "TRACK_REMOVED", w.TRACK_MUTED = "TRACK_MUTED", w.TRACK_UNMUTED = "TRACK_UNMUTED", w.TRACK_DEGRADED = "TRACK_DEGRADED", w.TRACK_RESTORED = "TRACK_RESTORED", w.TRACK_DESCRIPTION_CHANGED = "TRACK_DESCRIPTION_CHANGED", w.ROLE_UPDATED = "ROLE_UPDATED", w.CHANGE_TRACK_STATE_REQUEST = "CHANGE_TRACK_STATE_REQUEST", w.CHANGE_MULTI_TRACK_STATE_REQUEST = "CHANGE_MULTI_TRACK_STATE_REQUEST", w.ROOM_ENDED = "ROOM_ENDED", w.REMOVED_FROM_ROOM = "REMOVED_FROM_ROOM", w.DEVICE_CHANGE_UPDATE = "DEVICE_CHANGE_UPDATE", w.PLAYLIST_TRACK_ENDED = "PLAYLIST_TRACK_ENDED", w.NAME_UPDATED = "NAME_UPDATED", w.METADATA_UPDATED = "METADATA_UPDATED", w.POLL_CREATED = "POLL_CREATED", w.POLL_STARTED = "POLL_STARTED", w.POLL_STOPPED = "POLL_STOPPED", w.POLL_VOTES_UPDATED = "POLL_VOTES_UPDATED", w.POLLS_LIST = "POLLS_LIST", w.HAND_RAISE_CHANGED = "HAND_RAISE_CHANGED", w.TRANSCRIPTION_STATE_UPDATED = "TRANSCRIPTION_STATE_UPDATED", w))(Pr || {});
var vs = ((t) => (t.audio = "audio", t.video = "video", t))(vs || {});
function Fe(a2, e) {
  let t, i;
  if (e)
    for (let r of e.auxiliaryTracks) {
      let s = a2[r];
      go(s) && (i = gt(s) ? s : i, t = Tt(s) ? s : t);
    }
  return { video: t, audio: i };
}
function gt(a2) {
  return a2 && a2.type === "audio";
}
function Tt(a2) {
  return a2 && a2.type === "video";
}
function go(a2) {
  return a2 && a2.source === "screen";
}
function ci(a2) {
  return a2 && a2.source === "audioplaylist";
}
function ft(a2) {
  return a2 && a2.source === "videoplaylist";
}
function Ms(a2) {
  return a2 ? !!(a2 != null && a2.degraded) : false;
}
function ze(a2, e) {
  return e && a2.tracks[e] ? a2.tracks[e].enabled : false;
}
function vt(a2) {
  var r;
  let e = false, t = false, i = false;
  return (r = a2 == null ? void 0 : a2.publishParams) != null && r.allowed && (e = a2.publishParams.allowed.includes("video"), t = a2.publishParams.allowed.includes("audio"), i = a2.publishParams.allowed.includes("screen")), { video: e, audio: t, screen: i };
}
var ks = ((d) => (d[d.VERBOSE = 0] = "VERBOSE", d[d.DEBUG = 1] = "DEBUG", d[d.INFO = 2] = "INFO", d[d.WARN = 3] = "WARN", d[d.TIME = 4] = "TIME", d[d.TIMEEND = 5] = "TIMEEND", d[d.ERROR = 6] = "ERROR", d[d.NONE = 7] = "NONE", d))(ks || {});
var To = typeof window != "undefined" && typeof window.expect != "undefined";
var l = class {
  static v(e, ...t) {
    this.log(0, e, ...t);
  }
  static d(e, ...t) {
    this.log(1, e, ...t);
  }
  static i(e, ...t) {
    this.log(2, e, ...t);
  }
  static w(e, ...t) {
    this.log(3, e, ...t);
  }
  static e(e, ...t) {
    this.log(6, e, ...t);
  }
  static time(e) {
    this.log(4, "[HMSPerformanceTiming]", e);
  }
  static timeEnd(e) {
    this.log(5, "[HMSPerformanceTiming]", e, e);
  }
  static cleanup() {
    performance.clearMarks(), performance.clearMeasures();
  }
  static log(e, t, ...i) {
    if (!(this.level.valueOf() > e.valueOf()))
      switch (e) {
        case 0: {
          console.log(t, ...i);
          break;
        }
        case 1: {
          console.debug(t, ...i);
          break;
        }
        case 2: {
          console.info(t, ...i);
          break;
        }
        case 3: {
          console.warn(t, ...i);
          break;
        }
        case 6: {
          console.error(t, ...i);
          break;
        }
        case 4: {
          performance.mark(i[0]);
          break;
        }
        case 5: {
          let r = i[0];
          try {
            let s = performance.measure(r, r);
            this.log(1, t, r, s == null ? void 0 : s.duration), performance.clearMarks(r), performance.clearMeasures(r);
          } catch (s) {
            this.log(1, t, r, s);
          }
          break;
        }
      }
  }
};
l.level = To ? 7 : 0;
var Te = new import_ua_parser_js.UAParser();
var U = typeof window != "undefined";
var Es;
var Ge = typeof window == "undefined" && !((Es = Te.getBrowser().name) != null && Es.toLowerCase().includes("electron"));
var vo = () => !Ge;
var Tc = vo();
var Ps;
var bs;
var Cs = (bs = (Ps = Te.getBrowser()) == null ? void 0 : Ps.name) == null ? void 0 : bs.toLowerCase().includes("safari");
var As;
var Is;
var di = ((Is = (As = Te.getBrowser()) == null ? void 0 : As.name) == null ? void 0 : Is.toLowerCase()) === "firefox";
var Ls = ((i) => (i.CUSTOM = "CUSTOM", i.LOCAL = "LOCAL", i.HMS = "HMS", i))(Ls || {});
function Mo() {
  if (U && window) {
    let a2 = window.location.hostname;
    return a2 === "localhost" || a2 === "127.0.0.1" ? "LOCAL" : a2.includes("app.100ms.live") ? "HMS" : "CUSTOM";
  }
  return "CUSTOM";
}
var Xe = Mo();
var P4 = { WebSocketConnectionErrors: { FAILED_TO_CONNECT: 1e3, WEBSOCKET_CONNECTION_LOST: 1003, ABNORMAL_CLOSE: 1006 }, APIErrors: { SERVER_ERRORS: 2e3, INIT_CONFIG_NOT_AVAILABLE: 2002, ENDPOINT_UNREACHABLE: 2003, INVALID_TOKEN_FORMAT: 2004 }, TracksErrors: { GENERIC_TRACK: 3e3, CANT_ACCESS_CAPTURE_DEVICE: 3001, DEVICE_NOT_AVAILABLE: 3002, DEVICE_IN_USE: 3003, DEVICE_LOST_MIDWAY: 3004, NOTHING_TO_RETURN: 3005, INVALID_VIDEO_SETTINGS: 3006, CODEC_CHANGE_NOT_PERMITTED: 3007, AUTOPLAY_ERROR: 3008, OVER_CONSTRAINED: 3009, NO_AUDIO_DETECTED: 3010, SYSTEM_DENIED_PERMISSION: 3011, CURRENT_TAB_NOT_SHARED: 3012, AUDIO_PLAYBACK_ERROR: 3013, SELECTED_DEVICE_MISSING: 3014, NO_DATA: 3015 }, WebrtcErrors: { CREATE_OFFER_FAILED: 4001, CREATE_ANSWER_FAILED: 4002, SET_LOCAL_DESCRIPTION_FAILED: 4003, SET_REMOTE_DESCRIPTION_FAILED: 4004, ICE_FAILURE: 4005, ICE_DISCONNECTED: 4006, STATS_FAILED: 4007 }, WebsocketMethodErrors: { SERVER_ERRORS: 5e3, ALREADY_JOINED: 5001, CANNOT_JOIN_PREVIEW_IN_PROGRESS: 5002 }, GenericErrors: { NOT_CONNECTED: 6e3, SIGNALLING: 6001, UNKNOWN: 6002, NOT_READY: 6003, JSON_PARSING_FAILED: 6004, TRACK_METADATA_MISSING: 6005, RTC_TRACK_MISSING: 6006, PEER_METADATA_MISSING: 6007, INVALID_ROLE: 6008, PREVIEW_IN_PROGRESS: 6009, MISSING_MEDIADEVICES: 6010, MISSING_RTCPEERCONNECTION: 6011, LOCAL_STORAGE_ACCESS_DENIED: 6012, VALIDATION_FAILED: 6013 }, PlaylistErrors: { NO_ENTRY_TO_PLAY: 8001, NO_ENTRY_IS_PLAYING: 8002 } };
var k = class a extends Error {
  constructor(t, i, r, s, o, n = false) {
    super(s);
    this.code = t;
    this.name = i;
    this.message = s;
    this.description = o;
    this.isTerminal = n;
    Object.setPrototypeOf(this, a.prototype), this.action = r.toString();
  }
  toAnalyticsProperties() {
    return { error_name: this.name, error_code: this.code, error_message: this.message, error_description: this.description, action: this.action, is_terminal: this.isTerminal };
  }
  addNativeError(t) {
    this.nativeError = t;
  }
  toString() {
    var t;
    return `{
        code: ${this.code};
        name: ${this.name};
        action: ${this.action};
        message: ${this.message};
        description: ${this.description};
        isTerminal: ${this.isTerminal};
        nativeError: ${(t = this.nativeError) == null ? void 0 : t.message};
      }`;
  }
};
var W = class extends k {
  constructor(t, i, r, s, o, n) {
    super(t, i, r, s, o, false);
    this.code = t;
    this.name = i;
    this.message = s;
    this.description = o;
    this.trackType = n;
  }
  toAnalyticsProperties() {
    return M(m({}, super.toAnalyticsProperties()), { track_type: this.trackType });
  }
  toString() {
    var t;
    return `{
        code: ${this.code};
        name: ${this.name};
        action: ${this.action};
        message: ${this.message};
        description: ${this.description};
        isTerminal: ${this.isTerminal};
        nativeError: ${(t = this.nativeError) == null ? void 0 : t.message};
        trackType: ${this.trackType};
      }`;
  }
};
var Ds = ((r) => (r.AUDIO = "audio", r.VIDEO = "video", r.AUDIO_VIDEO = "audio, video", r.SCREEN = "screen", r))(Ds || {});
var yo = ["join", "offer", "answer", "trickle", "on-error", "JOIN"];
var S = { WebSocketConnectionErrors: { FailedToConnect(a2, e = "") {
  return new k(P4.WebSocketConnectionErrors.FAILED_TO_CONNECT, "WebsocketFailedToConnect", a2, `[WS]: ${e}`, `[WS]: ${e}`);
}, WebSocketConnectionLost(a2, e = "") {
  return new k(P4.WebSocketConnectionErrors.WEBSOCKET_CONNECTION_LOST, "WebSocketConnectionLost", a2, "Network connection lost", e);
}, AbnormalClose(a2, e = "") {
  return new k(P4.WebSocketConnectionErrors.ABNORMAL_CLOSE, "WebSocketAbnormalClose", a2, "Websocket closed abnormally", e);
} }, APIErrors: { ServerErrors(a2, e, t = "", i = true) {
  return new k(a2, "ServerErrors", e, `[${e}]: Server error ${t}`, t, i);
}, EndpointUnreachable(a2, e = "") {
  return new k(P4.APIErrors.ENDPOINT_UNREACHABLE, "EndpointUnreachable", a2, `Endpoint is not reachable - ${e}`, e);
}, InvalidTokenFormat(a2, e = "") {
  return new k(P4.APIErrors.INVALID_TOKEN_FORMAT, "InvalidTokenFormat", a2, `Token is not in proper JWT format - ${e}`, e, true);
}, InitConfigNotAvailable(a2, e = "") {
  return new k(P4.APIErrors.INIT_CONFIG_NOT_AVAILABLE, "InitError", a2, `[INIT]: ${e}`, `[INIT]: ${e}`);
} }, TracksErrors: { GenericTrack(a2, e = "") {
  return new W(P4.TracksErrors.GENERIC_TRACK, "GenericTrack", a2, `[TRACK]: ${e}`, `[TRACK]: ${e}`, "audio, video");
}, CantAccessCaptureDevice(a2, e, t = "") {
  return new W(P4.TracksErrors.CANT_ACCESS_CAPTURE_DEVICE, "CantAccessCaptureDevice", a2, `User denied permission to access capture device - ${e}`, t, e);
}, DeviceNotAvailable(a2, e, t = "") {
  return new W(P4.TracksErrors.DEVICE_NOT_AVAILABLE, "DeviceNotAvailable", a2, `[TRACK]: Capture device is no longer available - ${e}`, t, e);
}, DeviceInUse(a2, e, t = "") {
  return new W(P4.TracksErrors.DEVICE_IN_USE, "DeviceInUse", a2, `[TRACK]: Capture device is in use by another application - ${e}`, t, e);
}, DeviceLostMidway(a2, e, t = "") {
  return new W(P4.TracksErrors.DEVICE_LOST_MIDWAY, "DeviceLostMidway", a2, `Lost access to capture device midway - ${e}`, t, e);
}, NothingToReturn(a2, e = "", t = "There is no media to return. Please select either video or audio or both.") {
  return new W(P4.TracksErrors.NOTHING_TO_RETURN, "NothingToReturn", a2, t, e, "audio, video");
}, InvalidVideoSettings(a2, e = "") {
  return new W(P4.TracksErrors.INVALID_VIDEO_SETTINGS, "InvalidVideoSettings", a2, "Cannot enable simulcast when no video settings are provided", e, "video");
}, AutoplayBlocked(a2, e = "") {
  return new W(P4.TracksErrors.AUTOPLAY_ERROR, "AutoplayBlocked", a2, "Autoplay blocked because the user didn't interact with the document first", e, "audio");
}, CodecChangeNotPermitted(a2, e = "") {
  return new W(P4.TracksErrors.CODEC_CHANGE_NOT_PERMITTED, "CodecChangeNotPermitted", a2, "Codec can't be changed mid call.", e, "audio, video");
}, OverConstrained(a2, e, t = "") {
  return new W(P4.TracksErrors.OVER_CONSTRAINED, "OverConstrained", a2, `[TRACK]: Requested constraints cannot be satisfied with the device hardware - ${e}`, t, e);
}, NoAudioDetected(a2, e = "Please check the mic or use another audio input") {
  return new W(P4.TracksErrors.NO_AUDIO_DETECTED, "NoAudioDetected", a2, "No audio input detected from microphone", e, "audio");
}, SystemDeniedPermission(a2, e, t = "") {
  return new W(P4.TracksErrors.SYSTEM_DENIED_PERMISSION, "SystemDeniedPermission", a2, `Operating System denied permission to access capture device - ${e}`, t, e);
}, CurrentTabNotShared() {
  return new W(P4.TracksErrors.CURRENT_TAB_NOT_SHARED, "CurrentTabNotShared", "TRACK", "The app requires you to share the current tab", "You must screen share the current tab in order to proceed", "screen");
}, AudioPlaybackError(a2) {
  return new W(P4.TracksErrors.AUDIO_PLAYBACK_ERROR, "Audio playback error", "TRACK", a2, a2, "audio");
}, SelectedDeviceMissing(a2) {
  return new W(P4.TracksErrors.SELECTED_DEVICE_MISSING, "SelectedDeviceMissing", "TRACK", `Could not detect selected ${a2} device`, `Please check connection to the ${a2} device`, a2);
}, NoDataInTrack(a2) {
  return new W(P4.TracksErrors.NO_DATA, "Track does not have any data", "TRACK", a2, "This could possibily due to another application taking priority over the access to camera or microphone or due to an incoming call", "audio, video");
} }, WebrtcErrors: { CreateOfferFailed(a2, e = "") {
  return new k(P4.WebrtcErrors.CREATE_OFFER_FAILED, "CreateOfferFailed", a2, `[${a2.toString()}]: Failed to create offer. `, e);
}, CreateAnswerFailed(a2, e = "") {
  return new k(P4.WebrtcErrors.CREATE_ANSWER_FAILED, "CreateAnswerFailed", a2, `[${a2.toString()}]: Failed to create answer. `, e);
}, SetLocalDescriptionFailed(a2, e = "") {
  return new k(P4.WebrtcErrors.SET_LOCAL_DESCRIPTION_FAILED, "SetLocalDescriptionFailed", a2, `[${a2.toString()}]: Failed to set offer. `, e);
}, SetRemoteDescriptionFailed(a2, e = "") {
  return new k(P4.WebrtcErrors.SET_REMOTE_DESCRIPTION_FAILED, "SetRemoteDescriptionFailed", a2, `[${a2.toString()}]: Failed to set answer. `, e, true);
}, ICEFailure(a2, e = "", t = false) {
  return new k(P4.WebrtcErrors.ICE_FAILURE, "ICEFailure", a2, `[${a2.toString()}]: Ice connection state FAILED`, e, t);
}, ICEDisconnected(a2, e = "") {
  return new k(P4.WebrtcErrors.ICE_DISCONNECTED, "ICEDisconnected", a2, `[${a2.toString()}]: Ice connection state DISCONNECTED`, e);
}, StatsFailed(a2, e = "") {
  return new k(P4.WebrtcErrors.STATS_FAILED, "StatsFailed", a2, `Failed to WebRTC get stats - ${e}`, e);
} }, WebsocketMethodErrors: { ServerErrors(a2, e, t) {
  return new k(a2, "ServerErrors", e, t, t, yo.includes(e));
}, AlreadyJoined(a2, e = "") {
  return new k(P4.WebsocketMethodErrors.ALREADY_JOINED, "AlreadyJoined", a2, "[JOIN]: You have already joined this room.", e);
}, CannotJoinPreviewInProgress(a2, e = "") {
  return new k(P4.WebsocketMethodErrors.CANNOT_JOIN_PREVIEW_IN_PROGRESS, "CannotJoinPreviewInProgress", a2, "[JOIN]: Cannot join if preview is in progress", e);
} }, GenericErrors: { NotConnected(a2, e = "") {
  return new k(P4.GenericErrors.NOT_CONNECTED, "NotConnected", a2, "Client is not connected", e);
}, Signalling(a2, e) {
  return new k(P4.GenericErrors.SIGNALLING, "Signalling", a2, `Unknown signalling error: ${a2.toString()} ${e} `, e);
}, Unknown(a2, e) {
  return new k(P4.GenericErrors.UNKNOWN, "Unknown", a2, `Unknown exception: ${e}`, e);
}, NotReady(a2, e = "") {
  return new k(P4.GenericErrors.NOT_READY, "NotReady", a2, e, e);
}, JsonParsingFailed(a2, e, t = "") {
  return new k(P4.GenericErrors.JSON_PARSING_FAILED, "JsonParsingFailed", a2, `Failed to parse JSON message - ${e}`, t);
}, TrackMetadataMissing(a2, e = "") {
  return new k(P4.GenericErrors.TRACK_METADATA_MISSING, "TrackMetadataMissing", a2, "Track Metadata Missing", e);
}, RTCTrackMissing(a2, e = "") {
  return new k(P4.GenericErrors.RTC_TRACK_MISSING, "RTCTrackMissing", a2, "RTC Track missing", e);
}, PeerMetadataMissing(a2, e = "") {
  return new k(P4.GenericErrors.PEER_METADATA_MISSING, "PeerMetadataMissing", a2, "Peer Metadata Missing", e);
}, ValidationFailed(a2, e) {
  return new k(P4.GenericErrors.VALIDATION_FAILED, "ValidationFailed", "VALIDATION", a2, e ? JSON.stringify(e) : "");
}, InvalidRole(a2, e) {
  return new k(P4.GenericErrors.INVALID_ROLE, "InvalidRole", a2, "Invalid role. Join with valid role", e, true);
}, PreviewAlreadyInProgress(a2, e = "") {
  return new k(P4.GenericErrors.PREVIEW_IN_PROGRESS, "PreviewAlreadyInProgress", a2, "[Preview]: Cannot join if preview is in progress", e);
}, LocalStorageAccessDenied(a2 = "Access to localStorage has been denied") {
  return new k(P4.GenericErrors.LOCAL_STORAGE_ACCESS_DENIED, "LocalStorageAccessDenied", "NONE", "LocalStorageAccessDenied", a2);
}, MissingMediaDevices() {
  return new k(P4.GenericErrors.MISSING_MEDIADEVICES, "MissingMediaDevices", "JOIN", "navigator.mediaDevices is undefined. 100ms SDK won't work on this website as WebRTC is not supported on HTTP endpoints(missing navigator.mediaDevices). Please ensure you're using the SDK either on localhost or a valid HTTPS endpoint.", "", true);
}, MissingRTCPeerConnection() {
  return new k(P4.GenericErrors.MISSING_RTCPEERCONNECTION, "MissingRTCPeerConnection", "JOIN", "RTCPeerConnection which is a core requirement for WebRTC call was not found, this could be due to an unsupported browser or browser extensions blocking WebRTC", "", true);
} }, MediaPluginErrors: { PlatformNotSupported(a2, e = "") {
  return new k(7001, "PlatformNotSupported", a2, "Check HMS Docs to see the list of supported platforms", e);
}, InitFailed(a2, e = "") {
  return new k(7002, "InitFailed", a2, "Plugin init failed", e);
}, ProcessingFailed(a2, e = "") {
  return new k(7003, "ProcessingFailed", a2, "Plugin processing failed", e);
}, AddAlreadyInProgress(a2, e = "") {
  return new k(7004, "AddAlreadyInProgress", a2, "Plugin add already in progress", e);
}, DeviceNotSupported(a2, e = "") {
  return new k(7005, "DeviceNotSupported", a2, "Check HMS Docs to see the list of supported devices", e);
} }, PlaylistErrors: { NoEntryToPlay(a2, e) {
  return new k(P4.PlaylistErrors.NO_ENTRY_TO_PLAY, "NoEntryToPlay", a2, "Reached end of playlist", e);
}, NoEntryPlaying(a2, e) {
  return new k(P4.PlaylistErrors.NO_ENTRY_IS_PLAYING, "NoEntryIsPlaying", a2, "No entry is playing at this time", e);
} } };
var Ar = class {
  constructor() {
    this.valuesMap = /* @__PURE__ */ new Map();
  }
  getItem(e) {
    return this.valuesMap.has(e) ? String(this.valuesMap.get(e)) : null;
  }
  setItem(e, t) {
    this.valuesMap.set(e, t);
  }
  removeItem(e) {
    this.valuesMap.delete(e);
  }
  clear() {
    this.valuesMap.clear();
  }
  key(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present.");
    return Array.from(this.valuesMap.keys())[e];
  }
  get length() {
    return this.valuesMap.size;
  }
};
var ws = () => {
  try {
    U && !localStorage && (window.localStorage = new Ar());
  } catch (a2) {
    l.e("Error initialising localStorage", S.GenericErrors.LocalStorageAccessDenied());
  }
};
var fe = class {
  constructor(e) {
    this.key = e;
    this.storage = null;
  }
  getStorage() {
    try {
      return U && !this.storage && (ws(), this.storage = window.localStorage), this.storage;
    } catch (e) {
      return l.e("Error initialising localStorage", S.GenericErrors.LocalStorageAccessDenied()), null;
    }
  }
  get() {
    var i;
    let e = (i = this.getStorage()) == null ? void 0 : i.getItem(this.key);
    return e ? JSON.parse(e) : void 0;
  }
  set(e) {
    var i;
    let t = JSON.stringify(e);
    (i = this.getStorage()) == null || i.setItem(this.key, t);
  }
  clear() {
    var e;
    (e = this.getStorage()) == null || e.removeItem(this.key);
  }
};
var li = () => {
  let a2, e = new fe("hms-analytics-deviceId"), t = e.get();
  return t ? a2 = t : (a2 = ko(), e.set(a2)), a2;
};
function he(a2) {
  return a2 != null;
}
var Os = Ir().version;
function Et(a2 = "prod", e) {
  let t = "web", i = Xe !== "LOCAL" && a2 === "prod" ? "prod" : "debug";
  if (Ge)
    return xs({ os: "web_nodejs", os_version: process.version, sdk: t, sdk_version: Os, env: i, domain: Xe, is_prebuilt: !!(e != null && e.isPrebuilt), framework: "node", framework_version: process.version, framework_sdk_version: e == null ? void 0 : e.sdkVersion });
  let r = Te.getOS(), s = Te.getDevice(), o = Te.getBrowser(), n = Rr(`web_${r.name}`), d = r.version || "", u = Rr(`${o.name}_${o.version}`), p = u;
  return s.type && (p = `${Rr(`${s.vendor}_${s.type}`)}/${u}`), xs({ os: n, os_version: d, sdk: t, sdk_version: Os, device_model: p, env: i, domain: Xe, is_prebuilt: !!(e != null && e.isPrebuilt), framework: e == null ? void 0 : e.type, framework_version: e == null ? void 0 : e.version, framework_sdk_version: e == null ? void 0 : e.sdkVersion });
}
function Rr(a2) {
  return a2.replace(/ /g, "_");
}
var xs = (a2, e = ",") => Object.keys(a2).filter((t) => he(a2[t])).map((t) => `${t}:${a2[t]}`).join(e);
var C = class {
  constructor({ name: e, level: t, properties: i, includesPII: r, timestamp: s }) {
    this.metadata = { peer: {}, userAgent: Et() };
    this.name = e, this.level = t, this.includesPII = r || false, this.properties = i || {}, this.timestamp = s || (/* @__PURE__ */ new Date()).getTime(), this.event_id = Po(), this.device_id = li();
  }
  toSignalParams() {
    return { name: this.name, info: M(m({}, this.properties), { timestamp: this.timestamp, domain: Xe }), timestamp: (/* @__PURE__ */ new Date()).getTime() };
  }
};
var y = class {
  static connect(e, t, i = /* @__PURE__ */ new Date(), r = /* @__PURE__ */ new Date(), s) {
    let o = this.eventNameFor("connect", e === void 0), n = e ? 2 : 1, d = this.getPropertiesWithError(M(m({}, t), { [this.KEY_REQUESTED_AT]: i == null ? void 0 : i.getTime(), [this.KEY_RESPONDED_AT]: r == null ? void 0 : r.getTime(), endpoint: s }), e);
    return new C({ name: o, level: n, properties: d });
  }
  static disconnect(e, t) {
    let i = "disconnected", r = e ? 2 : 1, s = this.getPropertiesWithError(t, e);
    return new C({ name: i, level: r, properties: s });
  }
  static preview(i) {
    var r = i, { error: e } = r, t = kr(r, ["error"]);
    let s = this.eventNameFor("preview", e === void 0), o = e ? 2 : 1, n = this.getPropertiesWithError(t, e);
    return new C({ name: s, level: o, properties: n });
  }
  static join(i) {
    var r = i, { error: e } = r, t = kr(r, ["error"]);
    let s = this.eventNameFor("join", e === void 0), o = e ? 2 : 1, n = this.getPropertiesWithError(M(m({}, t), { is_preview_called: !!t.is_preview_called }), e);
    return new C({ name: s, level: o, properties: n });
  }
  static publish({ devices: e, settings: t, error: i }) {
    let r = this.eventNameFor("publish", i === void 0), s = i ? 2 : 1, o = this.getPropertiesWithError({ devices: e, audio: t == null ? void 0 : t.audio, video: t == null ? void 0 : t.video }, i);
    return new C({ name: r, level: s, properties: o });
  }
  static hlsPlayerError(e) {
    return new C({ name: "hlsPlayerError", level: 2, properties: this.getErrorProperties(e) });
  }
  static subscribeFail(e) {
    let t = this.eventNameFor("subscribe", false), i = 2, r = this.getErrorProperties(e);
    return new C({ name: t, level: i, properties: r });
  }
  static leave() {
    return new C({ name: "leave", level: 1 });
  }
  static autoplayError() {
    return new C({ name: "autoplayError", level: 2 });
  }
  static audioPlaybackError(e) {
    return new C({ name: "audioPlaybackError", level: 2, properties: this.getErrorProperties(e) });
  }
  static audioRecovered(e) {
    return new C({ name: "audioRecovered", level: 1, properties: { message: e } });
  }
  static permissionChange(e, t) {
    return new C({ name: "permissionChanged", level: 1, properties: { message: `Perrmission for ${e} changed to ${t}` } });
  }
  static deviceChange({ isUserSelection: e, selection: t, type: i, devices: r, error: s }) {
    let o = this.eventNameFor(s ? "publish" : `device.${i}`, s === void 0), n = s ? 2 : 1, d = this.getPropertiesWithError({ selection: t, devices: r, isUserSelection: e }, s);
    return new C({ name: o, level: n, properties: d });
  }
  static performance(e) {
    let t = "perf.stats", i = 1, r = e.toAnalyticsProperties();
    return new C({ name: t, level: i, properties: r });
  }
  static rtcStats(e) {
    let t = "rtc.stats", i = 1, r = e.toAnalyticsProperties();
    return new C({ name: t, level: i, properties: r });
  }
  static rtcStatsFailed(e) {
    let t = "rtc.stats.failed", i = 2;
    return new C({ name: t, level: i, properties: this.getErrorProperties(e) });
  }
  static degradationStats(e, t) {
    let i = "video.degradation.stats", r = 1, s = { degradedAt: e.degradedAt, trackId: e.trackId };
    if (!t && e.degradedAt instanceof Date) {
      let o = /* @__PURE__ */ new Date(), n = o.valueOf() - e.degradedAt.valueOf();
      s = M(m({}, s), { duration: n, restoredAt: o });
    }
    return new C({ name: i, level: r, properties: s });
  }
  static audioDetectionFail(e, t) {
    let i = this.getPropertiesWithError({ device: t }, e), r = 2, s = "audiopresence.failed";
    return new C({ name: s, level: r, properties: i });
  }
  static previewNetworkQuality(e) {
    return new C({ name: "perf.networkquality.preview", level: e.error ? 2 : 1, properties: e });
  }
  static publishStats(e) {
    return new C({ name: "publisher.stats", level: 1, properties: e });
  }
  static subscribeStats(e) {
    return new C({ name: "subscriber.stats", level: 1, properties: e });
  }
  static getKrispUsage(e) {
    return new C({ name: "krisp.usage", level: 1, properties: { duration: e } });
  }
  static krispStart() {
    return new C({ name: "krisp.start", level: 1 });
  }
  static krispStop() {
    return new C({ name: "krisp.stop", level: 1 });
  }
  static interruption({ started: e, type: t, reason: i, deviceInfo: r }) {
    return new C({ name: `${e ? "interruption.start" : "interruption.stop"}`, level: 1, properties: m({ reason: i, type: t }, r) });
  }
  static eventNameFor(e, t) {
    return `${e}.${t ? "success" : "failed"}`;
  }
  static getPropertiesWithError(e, t) {
    let i = this.getErrorProperties(t);
    return e = m(m({}, i), e), e;
  }
  static getErrorProperties(e) {
    return e ? e instanceof k ? e.toAnalyticsProperties() : { error_name: e.name, error_message: e.message, error_description: e.cause } : {};
  }
};
y.KEY_REQUESTED_AT = "requested_at", y.KEY_RESPONDED_AT = "responded_at";
var Hr = class {
  constructor() {
    this.storage = new fe("hms-device-selection");
    this.remember = false;
    this.TAG = "[HMSDeviceStorage]";
  }
  setDevices(e) {
    this.devices = e;
  }
  rememberDevices(e) {
    this.remember = e;
  }
  updateSelection(e, { deviceId: t, groupId: i }) {
    if (!this.devices || !this.remember)
      return;
    let r = this.devices[e].find((o) => this.isSame({ deviceId: t, groupId: i }, o));
    if (!r) {
      l.w(this.TAG, `Could not find device with deviceId: ${t}, groupId: ${i}`);
      return;
    }
    let s = this.storage.get() || {};
    s[e] = r, this.storage.set(s);
  }
  getSelection() {
    if (this.remember)
      return this.storage.get();
  }
  cleanup() {
    this.remember = false, this.devices = void 0;
  }
  isSame(e, t) {
    return e.deviceId === t.deviceId && (e.groupId === t.groupId || !e.groupId);
  }
};
var Y = new Hr();
var Cr = ((t) => (t.TRANSFORM = "TRANSFORM", t.ANALYZE = "ANALYZE", t))(Cr || {});
var Lr = ((t) => (t.PLATFORM_NOT_SUPPORTED = "PLATFORM_NOT_SUPPORTED", t.DEVICE_NOT_SUPPORTED = "DEVICE_NOT_SUPPORTED", t))(Lr || {});
var _r = ((r) => (r.SPEAKERPHONE = "SPEAKERPHONE", r.WIRED = "WIRED", r.BLUETOOTH = "BLUETOOTH", r.EARPIECE = "EARPIECE", r))(_r || {});
function mi(a2, e = 300) {
  let t;
  return function(...i) {
    clearTimeout(t), t = void 0;
    let r = this;
    t = setTimeout(() => {
      a2.apply(r, i);
    }, e);
  };
}
var Or = ((t) => (t.SIP = "sip", t.REGULAR = "regular", t))(Or || {});
var Fs = ((n) => (n.NONE = "none", n.INITIALISED = "initialised", n.STARTED = "started", n.PAUSED = "paused", n.RESUMED = "resumed", n.STOPPED = "stopped", n.FAILED = "failed", n))(Fs || {});
var Gs = ((t) => (t.DVR = "dvr", t.NO_DVR = "no-dvr", t))(Gs || {});
var Ws = ((i) => (i.REGULAR = "regular", i.SCREEN = "screen", i.COMPOSITE = "composite", i))(Ws || {});
var $s = ((r) => (r.INITIALISED = "initialised", r.STARTED = "started", r.STOPPED = "stopped", r.FAILED = "failed", r))($s || {});
var Ks = ((e) => (e.CAPTION = "caption", e))(Ks || {});
var xr = ((t) => (t.VOICE = "voice", t.MUSIC = "music", t))(xr || {});
var qs = ((i) => (i.videoInput = "videoInput", i.audioInput = "audioInput", i.audioOutput = "audioOutput", i))(qs || {});
var Ur = class {
  constructor() {
    this.TAG = "[HMSIntersectionObserverWrapper]";
    this.listeners = /* @__PURE__ */ new WeakMap();
    this.observe = (e, t) => {
      var i;
      this.createObserver(), this.unobserve(e), (i = this.intersectionObserver) == null || i.observe(e), this.listeners.set(e, t);
    };
    this.unobserve = (e) => {
      var t;
      (t = this.intersectionObserver) == null || t.unobserve(e), this.listeners.delete(e);
    };
    this.createObserver = () => {
      this.isSupported() && !this.intersectionObserver && (this.intersectionObserver = new IntersectionObserver(this.handleIntersection));
    };
    this.handleIntersection = (e) => {
      var t;
      for (let i of e)
        (t = this.listeners.get(i.target)) == null || t(i);
    };
    this.createObserver();
  }
  isSupported() {
    let e = U && typeof window.IntersectionObserver != "undefined";
    return e || l.w(this.TAG, "IntersectionObserver is not supported, fallback will be used instead"), e;
  }
};
var zs = new Ur();
var Br = class {
  constructor() {
    this.TAG = "[HMSResizeObserverWrapper]";
    this.listeners = /* @__PURE__ */ new WeakMap();
    this.observe = (e, t, i = { box: "border-box" }) => {
      var r;
      this.createObserver(), this.unobserve(e), (r = this.resizeObserver) == null || r.observe(e, i), this.listeners.set(e, t);
    };
    this.unobserve = (e) => {
      var t;
      (t = this.resizeObserver) == null || t.unobserve(e), this.listeners.delete(e);
    };
    this.createObserver = () => {
      this.isSupported() && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(mi(this.handleResize, 300)));
    };
    this.handleResize = (e) => {
      var t;
      for (let i of e)
        (t = this.listeners.get(i.target)) == null || t(i);
    };
    this.createObserver();
  }
  isSupported() {
    let e = U && typeof window.ResizeObserver != "undefined";
    return e || l.w(this.TAG, "Resize Observer is not supported"), e;
  }
};
var Ys = new Br();
var Vr = ((t) => (t.TRANSFORM = "TRANSFORM", t.ANALYZE = "ANALYZE", t))(Vr || {});
var Fr = ((t) => (t["2D"] = "2d", t.WEBGL = "webgl", t.WEBGL2 = "webgl2", t))(Fr || {});
var ea = "https://event.100ms.live/v2/client/report";
var ta = "https://event-nonprod.100ms.live/v2/client/report";
var Rt = Math.pow(2, 31) - 1;
var ot = class {
};
ot.makePeerId = () => Vo();
var F = (a2) => a2.room;
var Go = (a2) => a2.errors;
var Tm = createSelector(Go, (a2) => a2.length === 0 ? null : a2.at(-1));
var fm = createSelector(F, (a2) => a2.id);
var Q = (a2) => a2.peers;
var Ai = (a2) => a2.messages.byID;
var la = (a2) => a2.messages.allIDs;
var N = (a2) => a2.tracks;
var zr = (a2) => a2.appData;
var Wo = (a2) => a2.speakers;
var Be = createSelector([F], (a2) => a2 && a2.isConnected);
var ym = createSelector([Be, F], (a2, e) => a2 ? e.peerCount !== void 0 ? e.peerCount || 1 : e.peers.length : Math.max(e.peerCount !== void 0 ? e.peerCount : e.peers.length - 1, 0));
var $o = (a2) => a2.hideLocalPeer;
var ke = createSelector([F, Q, $o], (a2, e, t) => t ? a2.peers.filter((i) => a2.localPeer !== i).map((i) => e[i]) : a2.peers.map((i) => e[i]));
var Ko = createSelector(N, (a2) => Object.values(a2));
var re = createSelector(F, Q, (a2, e) => e[a2.localPeer]);
var Ie = createSelector(F, (a2) => a2.localPeer);
var km = createSelector(re, (a2) => a2 == null ? void 0 : a2.name);
var Em = createSelector(re, (a2) => a2 == null ? void 0 : a2.roleName);
var le = createSelector(re, (a2) => a2 == null ? void 0 : a2.audioTrack);
var X = createSelector(re, (a2) => a2 == null ? void 0 : a2.videoTrack);
var qo = createSelector(re, (a2) => a2 == null ? void 0 : a2.auxiliaryTracks);
var pa = createSelector([le, X, qo], (a2, e, t) => {
  let i = t ? [...t] : [];
  return a2 && i.unshift(a2), e && i.unshift(e), i;
});
var Pm = createSelector(ke, (a2) => a2.filter((e) => !e.isLocal));
var bm = createSelector(Q, Wo, (a2, e) => {
  let t = Object.entries(e).sort((i, r) => {
    var n, d;
    let s = ((n = i[1]) == null ? void 0 : n.audioLevel) || 0;
    return (((d = r[1]) == null ? void 0 : d.audioLevel) || 0) > s ? 1 : -1;
  });
  if (t.length > 0 && t[0][1].audioLevel && t[0][1].audioLevel > 0) {
    let i = t[0][1].peerID;
    if (i in a2)
      return a2[i];
  }
  return null;
});
var Xr = createSelector(re, N, (a2, e) => {
  let { video: t, audio: i } = Fe(e, a2);
  return !!(t || i);
});
var jo = createSelector(Q, N, (a2, e) => {
  let t;
  for (let i in a2) {
    let r = a2[i], { video: s, audio: o } = Fe(e, r);
    if (s)
      return r;
    o && !t && (t = r);
  }
  return t;
});
var Im = createSelector(jo, (a2) => !!a2);
var Rm = createSelector(Q, N, (a2, e) => {
  for (let t in a2) {
    let i = a2[t], { audio: r, video: s } = Fe(e, i);
    if (!s && r)
      return i;
  }
});
var Hm = createSelector(Q, N, (a2, e) => {
  let t = [], i = [];
  for (let r in a2) {
    let s = a2[r], { video: o, audio: n } = Fe(e, s);
    o ? t.push(s) : n && i.push(s);
  }
  return t.concat(i);
});
var Cm = createSelector(Q, N, (a2, e) => {
  for (let t in e) {
    let i = e[t];
    if (ft(i) && Tt(i) && i.peerId)
      return a2[i.peerId];
  }
});
var Lm = createSelector(Q, N, (a2, e) => {
  for (let t in e) {
    let i = e[t];
    if (ci(i) && i.peerId)
      return a2[i.peerId];
  }
});
var Dm = createSelector(Ko, (a2) => a2.filter(Ms));
var wm = createSelector(la, (a2) => a2.length);
var _m = createSelector(Ai, (a2) => Object.values(a2).filter((e) => !e.read).length);
var Dt = createSelector(la, Ai, (a2, e) => {
  let t = [];
  return a2.forEach((i) => {
    t.push(e[i]);
  }), t;
});
var Jo = createSelector(Dt, (a2) => a2.filter((e) => {
  var t;
  return !e.recipientPeer && !(e.recipientRoles && ((t = e.recipientRoles) == null ? void 0 : t.length) > 0);
}));
var Nm = createSelector(Jo, (a2) => a2.filter((e) => !e.read).length);
var se = createSelector([F], (a2) => a2 && a2.roomState);
var ma = createSelector(se, (a2) => a2 === "Preview");
var Om = createSelector(F, (a2) => a2.roomState !== "Disconnected");
var xm = createSelector(F, (a2) => !a2.transcriptions || a2.transcriptions.length <= 0 ? false : a2.transcriptions.some((e) => e.mode === "caption" && e.state === "started"));
var Ee = (a2) => a2.roles;
var Um = createSelector([Ee], (a2) => Object.keys(a2));
var ct = createSelector([re, Ee], (a2, e) => a2 != null && a2.roleName ? e[a2.roleName] : null);
var Qo = (a2) => {
  var e;
  return (e = a2.preview) == null ? void 0 : e.asRole;
};
var Sa = createSelector([Qo, Ee], (a2, e) => a2 ? e[a2] : null);
var Bm = createSelector([ct], (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.subscribeParams) != null && e.subscribeToRoles ? a2.subscribeParams.subscribeToRoles.length > 0 : false;
});
var ga = createSelector(ct, (a2) => a2 == null ? void 0 : a2.permissions);
var Vm = createSelector(F, (a2) => a2.recording);
var Fm = createSelector(F, (a2) => a2.rtmp);
var Gm = createSelector(F, (a2) => a2.hls);
var Wm = createSelector(F, (a2) => a2.transcriptions);
var $m = createSelector(F, (a2) => a2.sessionId);
var Km = createSelector(F, (a2) => a2.startedAt);
var qm = createSelector(F, (a2) => !!a2.isLargeRoom);
var jm = createSelector(F, (a2) => !!a2.isEffectsEnabled);
var Jm = createSelector(F, (a2) => !!a2.isVBEnabled);
var Qm = createSelector(F, (a2) => a2.effectsKey);
var Ta = (a2) => a2.polls;
var Zm = createSelector(ke, (a2) => a2.filter((e) => e.isHandRaised));
var zo = (a2) => a2.whiteboards;
var eS = createSelector(zo, (a2) => Object.values(a2)[0]);
var va = (a2 = "audio") => (e) => e.playlist[a2].list;
var Zr = (a2 = "audio") => (e) => e.playlist[a2].selection;
var Ma = (a2 = "audio") => (e) => e.playlist[a2].progress;
var ya = (a2 = "audio") => (e) => e.playlist[a2].currentTime;
var ka = (a2 = "audio") => (e) => e.playlist[a2].playbackRate;
var Ea = (a2 = "audio") => (e) => e.playlist[a2].volume;
var Pa = (a2 = "audio") => createSelector(va(a2), (e) => Object.values(e));
var ba = (a2 = "audio") => createSelector(va(a2), Zr(a2), (e, t) => {
  if (t.id)
    return e[t.id];
});
var Aa = { selection: Zr("audio"), progress: Ma("audio"), currentTime: ya("audio"), playbackRate: ka("audio"), volume: Ea("audio"), list: Pa("audio"), selectedItem: ba("audio") };
var Ia = { selection: Zr("video"), progress: Ma("video"), currentTime: ya("video"), playbackRate: ka("video"), volume: Ea("video"), list: Pa("video"), selectedItem: ba("video") };
function H(a2) {
  return (e) => (t) => a2(t, e);
}
var wt = "HMS-Store:";
var b = class {
  static v(e, ...t) {
    this.log(0, e, ...t);
  }
  static d(...e) {
    this.log(1, ...e);
  }
  static i(...e) {
    this.log(2, ...e);
  }
  static w(...e) {
    this.log(3, ...e);
  }
  static e(...e) {
    this.log(6, ...e);
  }
  static time(e) {
    this.log(4, "[HMSPerformanceTiming]", e);
  }
  static timeEnd(e) {
    this.log(5, "[HMSPerformanceTiming]", e, e);
  }
  static cleanup() {
    performance.clearMarks(), performance.clearMeasures();
  }
  static log(e, ...t) {
    if (!(this.level.valueOf() > e.valueOf()))
      switch (e) {
        case 0: {
          console.log(wt, ...t);
          break;
        }
        case 1: {
          console.debug(wt, ...t);
          break;
        }
        case 2: {
          console.info(wt, ...t);
          break;
        }
        case 3: {
          console.warn(wt, ...t);
          break;
        }
        case 6: {
          console.error(wt, ...t);
          break;
        }
        case 4: {
          performance.mark(t[1]);
          break;
        }
        case 5: {
          let i = t[0], r = t[1];
          try {
            let s = performance.measure(r, r);
            this.log(1, i, r, s == null ? void 0 : s.duration), performance.clearMarks(r), performance.clearMeasures(r);
          } catch (s) {
            this.log(1, i, r, s);
          }
          break;
        }
      }
  }
};
b.level = 0;
var es = (a2, e) => e;
var _t = (a2, e) => e;
var Ra = (a2, e) => e;
var Yo = (a2, e) => e;
var Xo = (a2, e) => e;
var z = createSelector([Q, es], (a2, e) => e ? a2[e] : null);
var ts = createSelector([N, _t], (a2, e) => e ? a2[e] : null);
var Zo = createSelector([N, _t], (a2, e) => {
  if (!e)
    return null;
  let t = a2[e];
  return (t == null ? void 0 : t.type) === "video" ? t : null;
});
var en = createSelector([N, _t], (a2, e) => {
  if (!e)
    return null;
  let t = a2[e];
  return (t == null ? void 0 : t.type) === "audio" ? t : null;
});
var tn = createSelector([N, _t], (a2, e) => {
  if (!e)
    return null;
  let t = a2[e];
  return (t == null ? void 0 : t.type) === "audio" && (t == null ? void 0 : t.source) === "screen" ? t : null;
});
var rn = createSelector([N, _t], (a2, e) => {
  if (!e)
    return null;
  let t = a2[e];
  return (t == null ? void 0 : t.type) === "video" && (t == null ? void 0 : t.source) === "screen" ? t : null;
});
var sn = createSelector([Ta, Xo], (a2, e) => e ? a2[e] : null);
var Z = H(z);
var uS = H(createSelector([zr, Yo], (a2, e) => {
  if (a2)
    return e ? a2[e] : a2;
}));
function pS(a2) {
  return (e) => {
    if (e.sessionStore)
      return a2 ? e.sessionStore[a2] : e.sessionStore;
  };
}
var mS = H(createSelector(z, (a2) => a2 == null ? void 0 : a2.name));
var SS = H(createSelector(z, (a2) => a2 == null ? void 0 : a2.type));
var Ii = H(ts);
var Ha = H(Zo);
var gS = H(en);
var TS = H(tn);
var fS = H(rn);
var an = H((a2, e) => {
  let t = z(a2, e);
  if (t && t.videoTrack && t.videoTrack !== "")
    return a2.tracks[t.videoTrack];
});
var on = H((a2, e) => {
  let t = z(a2, e);
  if (t && t.audioTrack && t.audioTrack !== "")
    return a2.tracks[t.audioTrack];
});
var MS = H((a2, e) => {
  let t = z(a2, e);
  return (t == null ? void 0 : t.auxiliaryTracks.map((i) => a2.tracks[i])) || [];
});
var Ca = (a2, e) => e ? a2.speakers[e] : null;
var yS = H(createSelector(Ca, (a2) => (a2 == null ? void 0 : a2.audioLevel) || 0));
var nn = (a2, e) => {
  let t = on(e)(a2);
  return Ca(a2, t == null ? void 0 : t.id);
};
var kS = H(createSelector(nn, (a2) => (a2 == null ? void 0 : a2.audioLevel) || 0));
var ES = H((a2, e) => {
  if (e)
    return a2.connectionQualities[e];
});
var PS = H((a2, e) => {
  let t = z(a2, e);
  if (t) {
    let i = t == null ? void 0 : t.auxiliaryTracks.find((r) => gt(a2.tracks[r]));
    return i ? a2.tracks[i] : void 0;
  }
});
var bS = H(createSelector(N, z, (a2, e) => {
  let t = e == null ? void 0 : e.auxiliaryTracks.find((i) => {
    let r = a2[i];
    return ft(r) && Tt(r);
  });
  return t ? a2[t] : void 0;
}));
var AS = H(createSelector(N, z, (a2, e) => {
  let t = e == null ? void 0 : e.auxiliaryTracks.find((i) => {
    let r = a2[i];
    return ft(r) && gt(r);
  });
  return t ? a2[t] : void 0;
}));
var IS = H(createSelector(N, z, (a2, e) => {
  let t = e == null ? void 0 : e.auxiliaryTracks.find((i) => {
    let r = a2[i];
    return ci(r) && gt(r);
  });
  return t ? a2[t] : void 0;
}));
var La = H(createSelector(N, z, (a2, e) => Fe(a2, e)));
var Da = (a2) => createSelector(La(a2), (e) => e.audio);
var HS = H((a2, e) => {
  let t = z(a2, e);
  return ze(a2, t == null ? void 0 : t.audioTrack);
});
var CS = H((a2, e) => {
  let t = z(a2, e);
  return ze(a2, t == null ? void 0 : t.videoTrack);
});
var wa = H((a2, e) => {
  if (e && a2.tracks[e])
    return a2.tracks[e].volume === 0;
});
var LS = H((a2, e) => {
  let t = z(a2, e);
  return wa(t == null ? void 0 : t.audioTrack)(a2);
});
var DS = H((a2, e) => {
  let t = Da(e)(a2);
  return wa(t == null ? void 0 : t.id)(a2);
});
var _a7 = H((a2, e) => {
  let t = ts(a2, e);
  if (t) {
    if (t.type !== "audio") {
      b.w("Please pass audio track here");
      return;
    }
    return t.volume;
  }
});
var wS = H((a2, e) => {
  let t = z(a2, e);
  return _a7(t == null ? void 0 : t.audioTrack)(a2);
});
var _S = H((a2, e) => {
  let t = Da(e)(a2);
  return _a7(t == null ? void 0 : t.id)(a2);
});
var NS = H((a2, e) => {
  let t = ts(a2, e);
  if (t) {
    if (t.type !== "video") {
      b.w("Please pass video track here");
      return;
    }
    return t.layer;
  }
});
var Na = createSelector([Dt, Ie, es], (a2, e, t) => {
  if (t)
    return a2.filter((i) => {
      var r;
      return !i.recipientPeer && !((r = i.recipientRoles) != null && r.length) || i.sender && ![e, t].includes(i.sender) ? false : [e, t].includes(i.recipientPeer);
    });
});
var Oa = createSelector([Dt, Ra], (a2, e) => {
  if (e)
    return a2.filter((t) => {
      var i, r;
      return (i = t.recipientRoles) != null && i.length ? (r = t.recipientRoles) == null ? void 0 : r.includes(e) : false;
    });
});
var cn = createSelector(Dt, (a2) => a2.filter((e) => {
  var t;
  return !e.recipientPeer && !((t = e.recipientRoles) != null && t.length);
}));
var dn = createSelector([Oa, Ra], (a2) => a2 ? a2.filter((e) => !e.read).length : 0);
var ln = createSelector([Na, es], (a2) => a2 ? a2.filter((e) => !e.read).length : 0);
var OS = createSelector(cn, (a2) => a2.filter((e) => !e.read).length);
var xS = H(Na);
var US = H(Oa);
var BS = H(dn);
var VS = H(ln);
var xa = H(sn);
var XS = createSelector([Q, N], (a2, e) => Object.values(a2).map((i) => {
  var r;
  return { peer: i, isAudioEnabled: i.audioTrack ? (r = e[i.audioTrack]) == null ? void 0 : r.enabled : false };
}));
var un = (a2) => a2.roleChangeRequests[0] || null;
var ZS = createSelector([un, Q, Ee], (a2, e, t) => a2 ? { requestedBy: a2.requestedBy ? e[a2.requestedBy] : void 0, role: t[a2.roleName], token: a2.token } : null);
var eg = createSelector([ct], (a2) => vt(a2));
var tg = createSelector([Sa], (a2) => vt(a2));
var hn = createSelector([X, N], (a2, e) => {
  let t = null;
  return a2 && (t = e[a2]), (t == null ? void 0 : t.plugins) || [];
});
var mn = createSelector([le, N], (a2, e) => {
  let t = null;
  return a2 && (t = e[a2]), (t == null ? void 0 : t.plugins) || [];
});
var Tn = ((n) => (n[n.STARTING = 0] = "STARTING", n[n.INIT_FETCHED = 1] = "INIT_FETCHED", n[n.SIGNAL_CONNECTED = 2] = "SIGNAL_CONNECTED", n[n.ICE_ESTABLISHED = 3] = "ICE_ESTABLISHED", n[n.MEDIA_CAPTURED = 4] = "MEDIA_CAPTURED", n[n.MEDIA_PUBLISHED = 5] = "MEDIA_PUBLISHED", n[n.COMPLETED = 6] = "COMPLETED", n))(Tn || {});
var os = class {
  constructor() {
    this.TAG = "[HTTPAnalyticsTransport]";
    this.failedEvents = new fe("client-events");
    this.isConnected = true;
    this.env = null;
    this.websocketURL = "";
  }
  setEnv(e) {
    this.env = e, this.flushFailedEvents();
  }
  setWebsocketEndpoint(e) {
    this.websocketURL = e;
  }
  sendEvent(e) {
    if (!this.env) {
      this.addEventToStorage(e);
      return;
    }
    let t = { event: e.name, payload: e.properties, event_id: String(e.timestamp), peer: e.metadata.peer, timestamp: e.timestamp, device_id: e.device_id, cluster: { websocket_url: this.websocketURL } }, i = this.env === "prod" ? ea : ta;
    fetch(i, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${e.metadata.token}`, user_agent_v2: e.metadata.userAgent }, body: JSON.stringify(t) }).then((r) => {
      if (r.status === 401) {
        this.removeFromStorage(e);
        return;
      }
      if (r.status !== 200)
        throw Error(r.statusText);
      this.removeFromStorage(e);
    }).catch((r) => {
      l.v(this.TAG, "Failed to send event", r, e), this.addEventToStorage(e);
    });
  }
  flushFailedEvents() {
    let e = this.failedEvents.get();
    e == null || e.forEach((t) => this.sendEvent(t));
  }
  addEventToStorage(e) {
    let t = this.failedEvents.get() || [];
    t.find((i) => i.timestamp === e.timestamp) || (t.length === 100 && t.shift(), t.push(e), this.failedEvents.set(t));
  }
  removeFromStorage(e) {
    let t = this.failedEvents.get() || [], i = t.findIndex((r) => r.timestamp === e.timestamp);
    i > -1 && (t.splice(i, 1), this.failedEvents.set(t));
  }
};
var He = new os();
var $t = class {
  static handleError(e) {
    if (e.status === 404)
      throw S.APIErrors.EndpointUnreachable("FEEDBACK", e.statusText);
    if (e.status >= 400)
      throw S.APIErrors.ServerErrors(e.status, "FEEDBACK", e == null ? void 0 : e.statusText);
  }
  static sendFeedback(s) {
    return c(this, arguments, function* ({ token: e, eventEndpoint: t = "https://event.100ms.live", info: i, feedback: r }) {
      l.d(this.TAG, `sendFeedback: feedbackEndpoint=${t} peerId=${i.peer.peer_id} session=${i.peer.session_id} `);
      let o = new URL("v2/client/feedback", t), n = M(m({}, i), { payload: r });
      try {
        let d = yield fetch(o, { headers: { Authorization: `Bearer ${e}` }, body: JSON.stringify(n), method: "POST" });
        try {
          this.handleError(d);
          return;
        } catch (u) {
          throw l.e(this.TAG, "error", u.message, d.status), u instanceof k ? u : S.APIErrors.ServerErrors(d.status, "FEEDBACK", u.message);
        }
      } catch (d) {
        let u = d;
        throw ["Failed to fetch", "NetworkError", "ECONNRESET"].some((p) => u.message.includes(p)) ? S.APIErrors.EndpointUnreachable("FEEDBACK", u.message) : u;
      }
    });
  }
};
$t.TAG = "[FeedbackService]";
var ns = ((f) => (f.FLAG_SERVER_SUB_DEGRADATION = "subscribeDegradation", f.FLAG_SERVER_SIMULCAST = "simulcast", f.FLAG_NON_WEBRTC_DISABLE_OFFER = "nonWebRTCDisableOffer", f.FLAG_PUBLISH_STATS = "publishStats", f.FLAG_SUBSCRIBE_STATS = "subscribeStats", f.FLAG_ON_DEMAND_TRACKS = "onDemandTracks", f.FLAG_DISABLE_VIDEO_TRACK_AUTO_UNSUBSCRIBE = "disableVideoTrackAutoUnsubscribe", f.FLAG_WHITEBOARD_ENABLED = "whiteboardEnabled", f.FLAG_EFFECTS_SDK_ENABLED = "effectsSDKEnabled", f.FLAG_VB_ENABLED = "vb", f.FLAG_HIPAA_ENABLED = "hipaa", f.FLAG_NOISE_CANCELLATION = "noiseCancellation", f.FLAG_SCALE_SCREENSHARE_BASED_ON_PIXELS = "scaleScreenshareBasedOnPixels", f.FLAG_DISABLE_NONE_LAYER_REQUEST = "disableNoneLayerRequest", f))(ns || {});
var j = ((s) => (s[s.ConnectFailed = 0] = "ConnectFailed", s[s.SignalDisconnect = 1] = "SignalDisconnect", s[s.JoinWSMessageFailed = 2] = "JoinWSMessageFailed", s[s.PublishIceConnectionFailed = 3] = "PublishIceConnectionFailed", s[s.SubscribeIceConnectionFailed = 4] = "SubscribeIceConnectionFailed", s))(j || {});
var lr = ((n) => (n.Disconnected = "Disconnected", n.Connecting = "Connecting", n.Joined = "Joined", n.Preview = "Preview", n.Failed = "Failed", n.Reconnecting = "Reconnecting", n.Leaving = "Leaving", n))(lr || {});
var ht = ((t) => (t[t.Publish = 0] = "Publish", t[t.Subscribe = 1] = "Subscribe", t))(ht || {});
var Un = (a2) => a2.localPeer.id;
var Bn = (a2) => a2.localPeer.audioTrack;
var Vn = (a2) => a2.localPeer.videoTrack;
var Fn = (a2, e) => e;
var oo = (a2, e) => e;
var Gn = (a2) => a2.remoteTrackStats;
var no = (a2) => a2.peerStats;
var us = (a2) => a2.localTrackStats;
var Le = createSelector([no, Un], (a2, e) => a2[e]);
var Wn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.subscribe) == null ? void 0 : e.packetsLost;
});
var $n = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.subscribe) == null ? void 0 : e.jitter;
});
var Kn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.publish) == null ? void 0 : e.bitrate;
});
var qn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.subscribe) == null ? void 0 : e.bitrate;
});
var jn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.publish) == null ? void 0 : e.availableOutgoingBitrate;
});
var Jn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.subscribe) == null ? void 0 : e.availableIncomingBitrate;
});
var Qn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.publish) == null ? void 0 : e.bytesSent;
});
var zn = createSelector(Le, (a2) => {
  var e;
  return (e = a2 == null ? void 0 : a2.subscribe) == null ? void 0 : e.bytesReceived;
});
var Yn = createSelector([no, Fn], (a2, e) => e ? a2[e] : void 0);
var Xn = createSelector([Gn, oo], (a2, e) => e ? a2[e] : void 0);
var ps = createSelector([us, oo], (a2, e) => e ? a2[e] : void 0);
var Zn = H(Yn);
var ec = H(Xn);
var tc = createSelector([us, Bn], (a2, e) => {
  var t;
  return e ? (t = a2[e]) == null ? void 0 : t[0] : void 0;
});
var ic = H(createSelector(ps, (a2) => a2 == null ? void 0 : a2[0]));
var rc = createSelector([us, Vn], (a2, e) => {
  var t;
  return e ? (t = a2[e]) == null ? void 0 : t[0] : void 0;
});
var sc = H(createSelector(ps, (a2) => a2));

// src/Prebuilt/components/Header/StreamActions.tsx
import {
  HMSRoomState as HMSRoomState4,
  selectHLSState as selectHLSState4,
  selectIsConnectedToRoom as selectIsConnectedToRoom6,
  selectPermissions as selectPermissions8,
  selectRecordingState as selectRecordingState2,
  selectRoomState as selectRoomState4,
  useHMSActions as useHMSActions24,
  useHMSStore as useHMSStore29,
  useRecordingStreaming as useRecordingStreaming6
} from "@100mslive/react-sdk";
import { AlertTriangleIcon as AlertTriangleIcon6, CrossIcon as CrossIcon11, PauseCircleIcon, RecordIcon } from "@100mslive/react-icons";
var getRecordingText = ({
  isBrowserRecordingOn,
  isServerRecordingOn,
  isHLSRecordingOn
}, delimiter = ", ") => {
  if (!isBrowserRecordingOn && !isServerRecordingOn && !isHLSRecordingOn) {
    return "";
  }
  const title = [];
  if (isBrowserRecordingOn) {
    title.push("Browser");
  }
  if (isServerRecordingOn) {
    title.push("Server");
  }
  if (isHLSRecordingOn) {
    title.push("HLS");
  }
  return title.join(delimiter);
};
var LiveStatus = () => {
  var _a8;
  const { isHLSRunning, isRTMPRunning } = useRecordingStreaming6();
  const hlsState = useHMSStore29(selectHLSState4);
  const isMobile = useMedia11(config.media.md);
  const intervalRef = useRef17(null);
  const { screenType } = useRoomLayoutConferencingScreen();
  const [liveTime, setLiveTime] = useState28(0);
  const startTimer = useCallback22(() => {
    intervalRef.current = setInterval(() => {
      var _a9;
      const timeStamp = (_a9 = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _a9[screenType === "hls_live_streaming" ? "startedAt" : "initialisedAt"];
      if ((hlsState == null ? void 0 : hlsState.running) && timeStamp) {
        setLiveTime(Date.now() - timeStamp.getTime());
      }
    }, 1e3);
  }, [hlsState == null ? void 0 : hlsState.running, hlsState == null ? void 0 : hlsState.variants, screenType]);
  useEffect21(() => {
    if (hlsState == null ? void 0 : hlsState.running) {
      startTimer();
    }
    if (!(hlsState == null ? void 0 : hlsState.running) && intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [hlsState.running, isMobile, startTimer]);
  if (!isHLSRunning && !isRTMPRunning) {
    return null;
  }
  return /* @__PURE__ */ React64.createElement(
    Flex,
    {
      align: "center",
      gap: "1",
      css: {
        border: "1px solid $border_default",
        padding: "$4 $6 $4 $6",
        borderRadius: "$1"
      }
    },
    /* @__PURE__ */ React64.createElement(Box, { css: { w: "$4", h: "$4", r: "$round", bg: "$alert_error_default", mr: "$2" } }),
    /* @__PURE__ */ React64.createElement(Flex, { align: "center", gap: "2" }, /* @__PURE__ */ React64.createElement(Text, { variant: !isMobile ? "button" : "body2" }, "LIVE"), /* @__PURE__ */ React64.createElement(Text, { variant: "caption" }, ((_a8 = hlsState == null ? void 0 : hlsState.variants) == null ? void 0 : _a8.length) > 0 && isHLSRunning ? formatTime(liveTime) : ""))
  );
};
var RecordingStatus = () => {
  const { isBrowserRecordingOn, isServerRecordingOn, isHLSRecordingOn, isRecordingOn } = useRecordingStreaming6();
  const permissions = useHMSStore29(selectPermissions8);
  const isMobile = useMedia11(config.media.md);
  if (!isRecordingOn || // if only browser recording is enabled, stop recording is shown
  // so no need to show this as it duplicates
  [permissions == null ? void 0 : permissions.browserRecording, !isServerRecordingOn, !isHLSRecordingOn, isBrowserRecordingOn].every(
    (value) => !!value
  )) {
    if (!(isMobile && isRecordingOn))
      return null;
  }
  return /* @__PURE__ */ React64.createElement(
    Tooltip,
    {
      boxCss: { zIndex: 1 },
      title: getRecordingText({
        isBrowserRecordingOn,
        isServerRecordingOn,
        isHLSRecordingOn
      })
    },
    /* @__PURE__ */ React64.createElement(
      Flex,
      {
        css: {
          color: "$alert_error_default",
          alignItems: "center"
        }
      },
      /* @__PURE__ */ React64.createElement(RecordIcon, { width: 24, height: 24 })
    )
  );
};
var RecordingPauseStatus = () => {
  const recording = useHMSStore29(selectRecordingState2);
  if (recording.hls && recording.hls.state === Fs.PAUSED) {
    return /* @__PURE__ */ React64.createElement(
      Tooltip,
      {
        boxCss: { zIndex: 1 },
        title: getRecordingText({
          isBrowserRecordingOn: false,
          isServerRecordingOn: false,
          isHLSRecordingOn: true
        })
      },
      /* @__PURE__ */ React64.createElement(
        Flex,
        {
          css: {
            color: "$on_surface_high",
            alignItems: "center"
          }
        },
        /* @__PURE__ */ React64.createElement(PauseCircleIcon, { width: 24, height: 24 })
      )
    );
  }
  return null;
};
var StartRecording2 = () => {
  const permissions = useHMSStore29(selectPermissions8);
  const [open, setOpen] = useState28(false);
  const { startRecording, recordingStarted } = useRecordingHandler();
  const { isBrowserRecordingOn, isStreamingOn, isHLSRunning } = useRecordingStreaming6();
  const hmsActions = useHMSActions24();
  if (!(permissions == null ? void 0 : permissions.browserRecording) || isHLSRunning) {
    return null;
  }
  if (isBrowserRecordingOn) {
    return /* @__PURE__ */ React64.createElement(Popover2.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React64.createElement(Popover2.Trigger, { asChild: true }, /* @__PURE__ */ React64.createElement(Button, { variant: "danger", "data-testid": "stop_recording", icon: true, outlined: true, onClick: () => setOpen(true) }, /* @__PURE__ */ React64.createElement(RecordIcon, null), /* @__PURE__ */ React64.createElement(Text, { as: "span", css: { "@md": { display: "none" }, color: "currentColor" } }, "Stop Recording"))), /* @__PURE__ */ React64.createElement(Popover2.Portal, null, /* @__PURE__ */ React64.createElement(Popover2.Content, { align: "end", sideOffset: 8, css: { w: "$64" } }, /* @__PURE__ */ React64.createElement(Text, { variant: "body1", css: { color: "$on_surface_medium" } }, "Are you sure you want to end the recording?"), /* @__PURE__ */ React64.createElement(
      Button,
      {
        "data-testid": "stop_recording_confirm",
        variant: "danger",
        icon: true,
        css: { ml: "auto" },
        onClick: () => __async(void 0, null, function* () {
          try {
            yield hmsActions.stopRTMPAndRecording();
          } catch (error) {
            const err = error;
            ToastManager.addToast({
              title: err.message,
              variant: "error"
            });
          }
          setOpen(false);
        })
      },
      "Stop"
    ))));
  }
  return /* @__PURE__ */ React64.createElement(
    Button,
    {
      "data-testid": "start_recording",
      variant: "standard",
      icon: true,
      disabled: recordingStarted || isStreamingOn,
      onClick: () => __async(void 0, null, function* () {
        yield startRecording();
      })
    },
    recordingStarted ? /* @__PURE__ */ React64.createElement(Loading, { size: 24, color: "currentColor" }) : /* @__PURE__ */ React64.createElement(RecordIcon, null),
    /* @__PURE__ */ React64.createElement(Text, { as: "span", css: { "@md": { display: "none" }, color: "currentColor" } }, recordingStarted ? "Starting" : "Start", " Recording")
  );
};
var StreamActions = () => {
  const isConnected = useHMSStore29(selectIsConnectedToRoom6);
  const isMobile = useMedia11(config.media.md);
  const roomState = useHMSStore29(selectRoomState4);
  return /* @__PURE__ */ React64.createElement(Flex, { align: "center", css: { gap: "$4" } }, !isMobile && /* @__PURE__ */ React64.createElement(Flex, { align: "center", css: { gap: "$4" } }, /* @__PURE__ */ React64.createElement(RecordingPauseStatus, null), /* @__PURE__ */ React64.createElement(RecordingStatus, null), roomState !== HMSRoomState4.Preview ? /* @__PURE__ */ React64.createElement(LiveStatus, null) : null), isConnected && !isMobile ? /* @__PURE__ */ React64.createElement(StartRecording2, null) : null);
};
var StopRecordingInSheet = ({
  onStopRecording,
  onClose
}) => {
  return /* @__PURE__ */ React64.createElement(Sheet.Root, { open: true }, /* @__PURE__ */ React64.createElement(Sheet.Content, null, /* @__PURE__ */ React64.createElement(Sheet.Title, { css: { p: "$10" } }, /* @__PURE__ */ React64.createElement(Flex, { direction: "row", justify: "between", css: { w: "100%", c: "$alert_error_default" } }, /* @__PURE__ */ React64.createElement(Flex, { justify: "start", align: "center", gap: "3" }, /* @__PURE__ */ React64.createElement(AlertTriangleIcon6, null), /* @__PURE__ */ React64.createElement(Text, { variant: "h5", css: { c: "$alert_error_default" } }, "Stop Recording")), /* @__PURE__ */ React64.createElement(Sheet.Close, { css: { color: "white" }, onClick: onClose }, /* @__PURE__ */ React64.createElement(CrossIcon11, null)))), /* @__PURE__ */ React64.createElement(HorizontalDivider, null), /* @__PURE__ */ React64.createElement(Box, { as: "div", css: { p: "$10", overflowY: "scroll", maxHeight: "70vh" } }, /* @__PURE__ */ React64.createElement(Text, { variant: "caption", css: { c: "$on_surface_medium", pb: "$8" } }, "Are you sure you want to stop recording? You can\u2019t undo this action."), /* @__PURE__ */ React64.createElement(
    Button,
    {
      variant: "danger",
      css: { width: "100%" },
      type: "submit",
      "data-testid": "popup_change_btn",
      onClick: onStopRecording
    },
    "Stop"
  ))));
};

// src/Prebuilt/components/MoreSettings/ChangeNameModal.tsx
init_define_process_env();
import React66, { useState as useState29 } from "react";
import { useMedia as useMedia12 } from "react-use";
import { selectLocalPeerName as selectLocalPeerName3, useHMSActions as useHMSActions25, useHMSStore as useHMSStore30 } from "@100mslive/react-sdk";

// src/Prebuilt/components/MoreSettings/ChangeNameContent.tsx
init_define_process_env();
import React65, { useEffect as useEffect22, useRef as useRef18 } from "react";
import { ChevronLeftIcon as ChevronLeftIcon2, CrossIcon as CrossIcon12 } from "@100mslive/react-icons";
var ChangeNameContent = ({
  changeName,
  setCurrentName,
  currentName,
  localPeerName,
  isMobile,
  onExit,
  onBackClick
}) => {
  const inputRef = useRef18(null);
  useEffect22(() => {
    if (isMobile) {
      setTimeout(() => {
        var _a8;
        (_a8 = inputRef.current) == null ? void 0 : _a8.focus();
      }, 200);
    }
  }, [isMobile]);
  return /* @__PURE__ */ React65.createElement(
    "form",
    {
      onSubmit: (e) => __async(void 0, null, function* () {
        e.preventDefault();
        yield changeName();
      })
    },
    /* @__PURE__ */ React65.createElement(
      Text,
      {
        variant: isMobile ? "md" : "lg",
        css: {
          color: "$on_surface_high",
          fontWeight: "$semiBold",
          display: "flex",
          pb: "$4",
          "@md": { px: "$8", borderBottom: "1px solid $border_default" }
        }
      },
      isMobile ? /* @__PURE__ */ React65.createElement(ChevronLeftIcon2, { onClick: onBackClick, style: { marginRight: "0.5rem" } }) : null,
      "Change Name",
      /* @__PURE__ */ React65.createElement(
        Box,
        {
          css: { color: "inherit", ml: "auto", "&:hover": { color: "$on_surface_medium", cursor: "pointer" } },
          onClick: onExit
        },
        /* @__PURE__ */ React65.createElement(CrossIcon12, null)
      )
    ),
    /* @__PURE__ */ React65.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", pb: "$6", mb: "$8", "@md": { px: "$8", mt: "$4" } } }, "Your name will be visible to other participants in the session."),
    /* @__PURE__ */ React65.createElement(Flex, { justify: "center", align: "center", css: { my: "$8", w: "100%", "@md": { px: "$8" } } }, /* @__PURE__ */ React65.createElement(
      Input,
      {
        ref: inputRef,
        css: { width: "100%", bg: "$surface_default" },
        value: currentName,
        type: "text",
        onChange: (e) => {
          setCurrentName(e.target.value);
        },
        autoComplete: "name",
        required: true,
        "data-testid": "change_name_field",
        onKeyDown: (e) => __async(void 0, null, function* () {
          if (e.key === "Enter" && currentName && currentName.trim().length > 0 && currentName !== localPeerName) {
            e.preventDefault();
            if (isMobile) {
              return;
            }
            changeName();
          }
        })
      }
    )),
    /* @__PURE__ */ React65.createElement(
      Flex,
      {
        justify: "between",
        align: "center",
        css: {
          width: "100%",
          gap: "$md",
          mt: "$10",
          "@md": { px: "$4" }
        }
      },
      isMobile ? null : /* @__PURE__ */ React65.createElement(
        Button,
        {
          variant: "standard",
          css: { w: "100%" },
          outlined: true,
          type: "submit",
          disabled: !localPeerName,
          onClick: onExit
        },
        "Cancel"
      ),
      /* @__PURE__ */ React65.createElement(
        Button,
        {
          variant: "primary",
          css: { width: "100%" },
          type: "submit",
          disabled: !(currentName == null ? void 0 : currentName.trim()) || (currentName == null ? void 0 : currentName.trim()) === localPeerName,
          "data-testid": "popup_change_btn"
        },
        "Change"
      )
    )
  );
};

// src/Prebuilt/components/MoreSettings/ChangeNameModal.tsx
var ChangeNameModal = ({
  onOpenChange,
  openParentSheet = void 0
}) => {
  const [previewPreference, setPreviewPreference] = useUserPreferences(UserPreferencesKeys.PREVIEW);
  const hmsActions = useHMSActions25();
  const localPeerName = useHMSStore30(selectLocalPeerName3);
  const [currentName, setCurrentName] = useState29(localPeerName);
  const isMobile = useMedia12(config.media.md);
  const changeName = () => __async(void 0, null, function* () {
    const name = (currentName == null ? void 0 : currentName.trim()) || "";
    if (!name || name === localPeerName) {
      return;
    }
    try {
      yield hmsActions.changeName(name);
      setPreviewPreference(__spreadProps(__spreadValues({}, previewPreference || {}), {
        name
      }));
    } catch (error) {
      console.error("failed to update name", error);
      ToastManager.addToast({ title: error.message });
    } finally {
      onOpenChange(false);
    }
  });
  const props = {
    changeName,
    setCurrentName,
    currentName,
    localPeerName,
    isMobile,
    onExit: () => onOpenChange(false),
    onBackClick: () => {
      onOpenChange(false);
      openParentSheet == null ? void 0 : openParentSheet();
    }
  };
  if (isMobile) {
    return /* @__PURE__ */ React66.createElement(Sheet.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React66.createElement(Sheet.Content, { css: { bg: "$surface_dim", p: "$8 0" }, onOpenAutoFocus: (e) => e.preventDefault() }, /* @__PURE__ */ React66.createElement(ChangeNameContent, __spreadValues({}, props))));
  }
  return /* @__PURE__ */ React66.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React66.createElement(Dialog.Portal, null, /* @__PURE__ */ React66.createElement(Dialog.Overlay, null), /* @__PURE__ */ React66.createElement(Dialog.Content, { css: { bg: "$surface_dim", width: "min(400px,80%)", p: "$10" } }, /* @__PURE__ */ React66.createElement(ChangeNameContent, __spreadValues({}, props)))));
};

// src/Prebuilt/components/AppData/useSheet.ts
init_define_process_env();
import { useCallback as useCallback23 } from "react";
import { selectAppData as selectAppData4, useHMSActions as useHMSActions26, useHMSStore as useHMSStore31, useHMSVanillaStore as useHMSVanillaStore10 } from "@100mslive/react-sdk";
var useIsSheetTypeOpen = (sheetType) => {
  if (!sheetType) {
    throw Error("Pass one of the sheet options");
  }
  return useHMSStore31(selectAppData4(APP_DATA.sheet)) === sheetType;
};
var useSheetToggle = (sheetType) => {
  const hmsActions = useHMSActions26();
  const vanillaStore = useHMSVanillaStore10();
  const toggleSheet = useCallback23(() => {
    const isOpen = vanillaStore.getState(selectAppData4(APP_DATA.sheet)) === sheetType;
    hmsActions.setAppData(APP_DATA.sheet, !isOpen ? sheetType : "");
  }, [vanillaStore, hmsActions, sheetType]);
  return toggleSheet;
};

// src/Prebuilt/components/hooks/useUnreadPollQuizPresent.tsx
init_define_process_env();
import { useEffect as useEffect23, useState as useState30 } from "react";
import { HMSNotificationTypes, useHMSNotifications, useHMSStore as useHMSStore32 } from "@100mslive/react-sdk";
var useUnreadPollQuizPresent = () => {
  const localPeerID = useHMSStore32(Ie);
  const notification = useHMSNotifications(HMSNotificationTypes.POLL_STARTED);
  const [unreadPollQuiz, setUnreadPollQuiz] = useState30(false);
  useEffect23(() => {
    if (!notification) {
      return;
    }
    setUnreadPollQuiz(notification.data.startedBy !== localPeerID);
  }, [localPeerID, notification]);
  return { unreadPollQuiz, setUnreadPollQuiz };
};

// src/Prebuilt/components/MoreSettings/SplitComponents/MwebOptions.tsx
var MODALS2 = {
  CHANGE_NAME: "changeName",
  SELF_ROLE_CHANGE: "selfRoleChange",
  MORE_SETTINGS: "moreSettings",
  START_RECORDING: "startRecording",
  DEVICE_SETTINGS: "deviceSettings",
  STATS_FOR_NERDS: "statsForNerds",
  BULK_ROLE_CHANGE: "bulkRoleChange",
  MUTE_ALL: "muteAll",
  EMBED_URL: "embedUrl",
  CAPTION: "caption"
};
var MwebOptions = ({
  elements,
  screenType
}) => {
  const hmsActions = useHMSActions27();
  const permissions = useHMSStore33(selectPermissions9);
  const isConnected = useHMSStore33(selectIsConnectedToRoom7);
  const { isBrowserRecordingOn, isStreamingOn, isHLSRunning } = useRecordingStreaming7();
  const [openModals, setOpenModals] = useState31(/* @__PURE__ */ new Set());
  const [openOptionsSheet, setOpenOptionsSheet] = useState31(false);
  const [openSettingsSheet, setOpenSettingsSheet] = useState31(false);
  const [openStatsForNerdsSheet, setOpenStatsForNerdsSheet] = useState31(false);
  const [showEmojiCard, setShowEmojiCard] = useState31(false);
  const [showRecordingOn, setShowRecordingOn] = useState31(false);
  const toggleParticipants = useSidepaneToggle(SIDE_PANE_OPTIONS.PARTICIPANTS);
  const { showPolls } = useShowPolls();
  const togglePollView = usePollViewToggle();
  const peerCount = useHMSStore33(selectPeerCount3);
  const emojiCardRef = useRef19(null);
  const { isBRBOn, toggleBRB, isHandRaised, toggleHandRaise } = useMyMetadata();
  const { unreadPollQuiz, setUnreadPollQuiz } = useUnreadPollQuizPresent();
  const { title, description } = useRoomLayoutHeader();
  const toggleDetailsSheet = useSheetToggle(SHEET_OPTIONS.ROOM_DETAILS);
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeHLSStream = useLandscapeHLSStream();
  const toggleVB = useSidepaneToggle(SIDE_PANE_OPTIONS.VB);
  const isLocalVideoEnabled = useHMSStore33(selectIsLocalVideoEnabled4);
  const { startRecording, isRecordingLoading } = useRecordingHandler();
  const isTranscriptionAllowed = useHMSStore33(selectIsTranscriptionAllowedByMode2(HMSTranscriptionMode3.CAPTION));
  const isTranscriptionEnabled = useHMSStore33(selectIsTranscriptionEnabled4);
  const [isCaptionEnabled] = useSetIsCaptionEnabled();
  useDropdownList({ open: openModals.size > 0 || openOptionsSheet || openSettingsSheet, name: "MoreSettings" });
  const updateState = (modalName, value) => {
    setOpenModals((modals) => {
      const copy = new Set(modals);
      if (value) {
        copy.add(modalName);
      } else {
        copy.delete(modalName);
      }
      return copy;
    });
  };
  useClickAway(emojiCardRef, () => setShowEmojiCard(false));
  return /* @__PURE__ */ React67.createElement(React67.Fragment, null, /* @__PURE__ */ React67.createElement(Sheet.Root, { open: openOptionsSheet, onOpenChange: setOpenOptionsSheet }, /* @__PURE__ */ React67.createElement(Tooltip, { title: "More options" }, /* @__PURE__ */ React67.createElement(Sheet.Trigger, { asChild: true, "data-testid": "more_settings_btn" }, /* @__PURE__ */ React67.createElement(IconButton_default, { css: { bg: isMobileHLSStream || isLandscapeHLSStream ? "$surface_default" : "" } }, /* @__PURE__ */ React67.createElement(HamburgerMenuIcon2, null)))), /* @__PURE__ */ React67.createElement(Sheet.Content, { css: { bg: "$surface_dim", pb: "$14" } }, /* @__PURE__ */ React67.createElement(
    Sheet.Title,
    {
      css: {
        display: "flex",
        color: "$on_surface_high",
        w: "100%",
        justifyContent: "space-between",
        fontSize: "$md",
        mt: "$8",
        px: "$10",
        pb: "$8",
        borderBottom: "1px solid $border_default",
        mb: "$8",
        alignItems: "center"
      }
    },
    "Options",
    /* @__PURE__ */ React67.createElement(Sheet.Close, null, /* @__PURE__ */ React67.createElement(Box, { css: { color: "$on_surface_high" } }, /* @__PURE__ */ React67.createElement(CrossIcon13, null)))
  ), /* @__PURE__ */ React67.createElement(
    Box,
    {
      css: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "auto",
        gridColumnGap: "$6",
        gridRowGap: "$8",
        px: "$9"
      }
    },
    (elements == null ? void 0 : elements.participant_list) && /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          toggleParticipants();
          setOpenOptionsSheet(false);
        }
      },
      /* @__PURE__ */ React67.createElement(ActionTile.Count, null, getFormattedCount(peerCount)),
      /* @__PURE__ */ React67.createElement(PeopleIcon, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Participants")
    ),
    elements.hand_raise ? /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        active: isHandRaised,
        onClick: () => {
          toggleHandRaise();
          setOpenOptionsSheet(false);
        }
      },
      isHandRaised ? /* @__PURE__ */ React67.createElement(HandRaiseSlashedIcon, null) : /* @__PURE__ */ React67.createElement(HandIcon2, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, isHandRaised ? "Lower" : "Raise", " Hand")
    ) : null,
    /* @__PURE__ */ React67.createElement(NoiseCancellation, { setOpenOptionsSheet, actionTile: true }),
    isTranscriptionAllowed ? /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          setOpenOptionsSheet(false);
          updateState(MODALS2.CAPTION, true);
        }
      },
      isTranscriptionEnabled && isCaptionEnabled ? /* @__PURE__ */ React67.createElement(ClosedCaptionIcon2, null) : /* @__PURE__ */ React67.createElement(OpenCaptionIcon3, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Closed Caption")
    ) : null,
    isLocalVideoEnabled && !!(elements == null ? void 0 : elements.virtual_background) ? /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          toggleVB();
          setOpenOptionsSheet(false);
        }
      },
      /* @__PURE__ */ React67.createElement(VirtualBackgroundIcon, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Virtual Background")
    ) : null,
    (elements == null ? void 0 : elements.emoji_reactions) && !(isLandscapeHLSStream || isMobileHLSStream) && /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          setShowEmojiCard(true);
          setOpenOptionsSheet(false);
        }
      },
      /* @__PURE__ */ React67.createElement(EmojiIcon2, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Emoji Reactions")
    ),
    showPolls && /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          togglePollView();
          setOpenOptionsSheet(false);
          setUnreadPollQuiz(false);
        }
      },
      unreadPollQuiz ? /* @__PURE__ */ React67.createElement(QuizActiveIcon, null) : /* @__PURE__ */ React67.createElement(QuizIcon, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Polls and Quizzes")
    ),
    (elements == null ? void 0 : elements.brb) && /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        active: isBRBOn,
        onClick: () => {
          toggleBRB();
          setOpenOptionsSheet(false);
        }
      },
      /* @__PURE__ */ React67.createElement(BrbIcon2, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Be Right Back")
    ),
    /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          setOpenSettingsSheet(true);
          setOpenOptionsSheet(false);
        }
      },
      /* @__PURE__ */ React67.createElement(SettingsIcon4, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Settings")
    ),
    /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          setOpenStatsForNerdsSheet(true);
          setOpenOptionsSheet(false);
        }
      },
      /* @__PURE__ */ React67.createElement(InfoIcon3, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "Stats For Nerds")
    ),
    isConnected && (permissions == null ? void 0 : permissions.browserRecording) ? /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        disabled: isHLSRunning,
        onClick: () => __async(void 0, null, function* () {
          if (isRecordingLoading) {
            return;
          }
          if (isBrowserRecordingOn || isStreamingOn) {
            setOpenOptionsSheet(false);
            setShowRecordingOn(true);
          } else {
            yield startRecording();
            setOpenOptionsSheet(false);
          }
          if (isHLSRunning) {
            setOpenOptionsSheet(false);
          }
        })
      },
      isRecordingLoading ? /* @__PURE__ */ React67.createElement(Loading, null) : /* @__PURE__ */ React67.createElement(RecordIcon2, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, match6({ isBrowserRecordingOn, isRecordingLoading }).with({ isBrowserRecordingOn: true, isRecordingLoading: false }, () => "Recording On").with({ isRecordingLoading: true }, () => "Starting Recording").with({ isRecordingLoading: false }, () => "Start Recording").otherwise(() => null))
    ) : null,
    title || description ? /* @__PURE__ */ React67.createElement(
      ActionTile.Root,
      {
        onClick: () => {
          setOpenOptionsSheet(false);
          toggleDetailsSheet();
        }
      },
      /* @__PURE__ */ React67.createElement(InfoIcon3, null),
      /* @__PURE__ */ React67.createElement(ActionTile.Title, null, "About Session")
    ) : null
  ))), /* @__PURE__ */ React67.createElement(SettingsModal_default, { open: openSettingsSheet, onOpenChange: setOpenSettingsSheet, screenType }), openStatsForNerdsSheet && /* @__PURE__ */ React67.createElement(StatsForNerds, { open: openStatsForNerdsSheet, onOpenChange: setOpenStatsForNerdsSheet }), openModals.has(MODALS2.MUTE_ALL) && /* @__PURE__ */ React67.createElement(MuteAllModal, { onOpenChange: (value) => updateState(MODALS2.MUTE_ALL, value), isMobile: true }), openModals.has(MODALS2.CHANGE_NAME) && /* @__PURE__ */ React67.createElement(
    ChangeNameModal,
    {
      onOpenChange: (value) => updateState(MODALS2.CHANGE_NAME, value),
      openParentSheet: () => setOpenOptionsSheet(true)
    }
  ), openModals.has(MODALS2.CAPTION) && /* @__PURE__ */ React67.createElement(CaptionModal, { onOpenChange: (value) => updateState(MODALS2.CAPTION, value) }), showEmojiCard && /* @__PURE__ */ React67.createElement(
    Box,
    {
      ref: emojiCardRef,
      css: {
        maxWidth: "100%",
        w: "100%",
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "$18",
        bg: "$surface_default",
        zIndex: "10",
        p: "$8",
        pb: 0,
        r: "$1",
        mx: "$4"
      }
    },
    /* @__PURE__ */ React67.createElement(EmojiReaction, { showCard: true })
  ), showRecordingOn && /* @__PURE__ */ React67.createElement(
    StopRecordingInSheet,
    {
      onClose: () => setShowRecordingOn(false),
      onStopRecording: () => __async(void 0, null, function* () {
        try {
          yield hmsActions.stopRTMPAndRecording();
          setShowRecordingOn(false);
        } catch (error) {
          ToastManager.addToast({
            // @ts-ignore
            title: error.message,
            variant: "error"
          });
        }
      })
    }
  ));
};

// src/Prebuilt/components/MoreSettings/MoreSettings.tsx
var MoreSettings = ({
  elements,
  screenType
}) => {
  const isMobile = useMedia13(config.media.md);
  const isLandscapeHLSStream = useLandscapeHLSStream();
  return isMobile || isLandscapeHLSStream ? /* @__PURE__ */ React68.createElement(MwebOptions, { elements, screenType }) : /* @__PURE__ */ React68.createElement(DesktopOptions, { elements, screenType });
};

// src/Prebuilt/components/RaiseHand.tsx
init_define_process_env();
import React69 from "react";
import { HandIcon as HandIcon3, HandRaiseSlashedIcon as HandRaiseSlashedIcon2 } from "@100mslive/react-icons";
var RaiseHand = ({ css: css2 }) => {
  const { isHandRaised, toggleHandRaise } = useMyMetadata();
  const { elements } = useRoomLayoutConferencingScreen();
  if (!elements.hand_raise) {
    return null;
  }
  return /* @__PURE__ */ React69.createElement(Tooltip, { title: isHandRaised ? "Lower hand" : "Raise hand" }, /* @__PURE__ */ React69.createElement(
    IconButton_default,
    {
      "data-testid": "hand_raise_btn",
      css: css2,
      active: !isHandRaised,
      onClick: () => __async(void 0, null, function* () {
        return yield toggleHandRaise();
      })
    },
    isHandRaised ? /* @__PURE__ */ React69.createElement(HandRaiseSlashedIcon2, null) : /* @__PURE__ */ React69.createElement(HandIcon3, null)
  ));
};

// src/Prebuilt/components/ScreenShareToggle.jsx
init_define_process_env();
import React76, { Fragment as Fragment9 } from "react";
import { selectIsAllowedToPublish as selectIsAllowedToPublish2, useAwayNotifications, useHMSStore as useHMSStore34, useScreenShare as useScreenShare2 } from "@100mslive/react-sdk";
import { ShareScreenIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/pdfAnnotator/shareScreenOptions.jsx
init_define_process_env();
import React75, { Fragment as Fragment8, useState as useState33 } from "react";
import { useScreenShare } from "@100mslive/react-sdk";
import { StarIcon, VerticalMenuIcon as VerticalMenuIcon4 } from "@100mslive/react-icons";
import PDFShareImg from "./pdf-share.png";
import ScreenShareImg from "./screen-share.png";

// src/Prebuilt/components/ShareMenuIcon.jsx
init_define_process_env();
var ScreenShareButton = styled(IconButton_default, {
  h: "$14",
  px: "$8",
  r: "$1",
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  "@md": {
    px: "$4",
    mx: 0
  }
});
var ShareMenuIcon = styled(ScreenShareButton, {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopRightRadius: "$1",
  borderBottomRightRadius: "$1",
  borderLeftWidth: 0,
  w: "$4",
  "@md": {
    w: "unset",
    px: "$2"
  }
});

// src/Prebuilt/components/pdfAnnotator/pdfFileOptions.jsx
init_define_process_env();
import React74, { useState as useState32 } from "react";

// src/Prebuilt/components/pdfAnnotator/pdfHeader.jsx
init_define_process_env();
import React70 from "react";
var PDFHeader = () => {
  return /* @__PURE__ */ React70.createElement(
    DialogCol,
    {
      align: "start",
      css: {
        mt: 0,
        mb: "$6"
      }
    },
    /* @__PURE__ */ React70.createElement(Dialog.Title, { asChild: true }, /* @__PURE__ */ React70.createElement(Text, { as: "h6", variant: "h6" }, "Share PDF")),
    /* @__PURE__ */ React70.createElement(Dialog.Description, { asChild: true }, /* @__PURE__ */ React70.createElement(
      Text,
      {
        variant: "sm",
        css: {
          c: "$on_surface_medium"
        }
      },
      "Choose PDF you want to annotate and share"
    ))
  );
};

// src/Prebuilt/components/pdfAnnotator/submitPdf.jsx
init_define_process_env();
import React71 from "react";
var SubmitPDF = ({ pdfFile, onOpenChange }) => {
  const [, setPDFConfig] = useSetAppDataByKey(APP_DATA.pdfConfig);
  return /* @__PURE__ */ React71.createElement(
    Flex,
    {
      direction: "row",
      css: {
        mb: "0",
        mt: "auto",
        gap: "$8"
      }
    },
    /* @__PURE__ */ React71.createElement(
      Button,
      {
        variant: "standard",
        outlined: true,
        type: "submit",
        onClick: () => {
          onOpenChange(false);
        },
        css: { w: "50%" }
      },
      "Cancel"
    ),
    /* @__PURE__ */ React71.createElement(
      Button,
      {
        variant: "primary",
        type: "submit",
        onClick: () => {
          if (pdfFile) {
            setPDFConfig(pdfFile);
            onOpenChange(false);
          }
        },
        disabled: !pdfFile,
        "data-testid": "share_pdf_btn",
        css: {
          w: "50%"
        }
      },
      "Start Sharing"
    )
  );
};

// src/Prebuilt/components/pdfAnnotator/uploadedFile.jsx
init_define_process_env();
import React73 from "react";
import { TrashIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/pdfAnnotator/pdfInfo.jsx
init_define_process_env();
import React72 from "react";
import { InfoIcon as InfoIcon4 } from "@100mslive/react-icons";
var PDFInfo = () => {
  return /* @__PURE__ */ React72.createElement(
    DialogRow,
    {
      css: {
        px: "$8",
        py: "$3",
        bg: "$surface_default",
        r: "$1",
        outline: "none",
        border: "1px solid $border_bright",
        minHeight: "$11"
      }
    },
    /* @__PURE__ */ React72.createElement(
      InfoIcon4,
      {
        width: "64px",
        height: "64px",
        style: {
          paddingRight: "16px"
        }
      }
    ),
    /* @__PURE__ */ React72.createElement(Text, { variant: "caption" }, "On the next screen, ensure you select \u201CThis Tab\u201D and click on share. Only the PDF viewer will be seen by other participants")
  );
};

// src/Prebuilt/components/pdfAnnotator/uploadedFile.jsx
var UploadedFile = ({ pdfFile, setPDFFile, onOpenChange }) => {
  const [fileName, ext] = pdfFile.name.split(".");
  return /* @__PURE__ */ React73.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React73.createElement(Dialog.Portal, null, /* @__PURE__ */ React73.createElement(Dialog.Overlay, null), /* @__PURE__ */ React73.createElement(
    Dialog.Content,
    {
      css: {
        w: "min(420px,80%)",
        overflow: "auto",
        p: "$10",
        bg: "$surface_dim"
      }
    },
    /* @__PURE__ */ React73.createElement(Flex, { direction: "column" }, /* @__PURE__ */ React73.createElement(PDFHeader, null), /* @__PURE__ */ React73.createElement(
      DialogRow,
      {
        css: {
          fontFamily: "$sans",
          bg: "$surface_bright",
          r: "$1",
          outline: "none",
          border: "1px solid $border_bright",
          p: "$4 $6",
          minHeight: "$11",
          c: "$on_primary_high",
          fs: "$md",
          w: "100%",
          "&:focus": {
            boxShadow: "0 0 0 1px $colors$primary_default",
            border: "1px solid transparent"
          },
          mb: 0,
          mt: "$6"
        }
      },
      /* @__PURE__ */ React73.createElement(Flex, { direction: "row", css: { flexGrow: "1", maxWidth: "88%" } }, /* @__PURE__ */ React73.createElement(
        Text,
        {
          css: {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
          }
        },
        fileName
      ), /* @__PURE__ */ React73.createElement(Text, { css: { whiteSpace: "nowrap" } }, ".", ext)),
      /* @__PURE__ */ React73.createElement(
        TrashIcon,
        {
          onClick: () => setPDFFile(null),
          style: {
            cursor: "pointer"
          }
        }
      )
    ), /* @__PURE__ */ React73.createElement(PDFInfo, null), /* @__PURE__ */ React73.createElement(SubmitPDF, { pdfFile, onOpenChange }))
  )));
};

// src/Prebuilt/components/pdfAnnotator/pdfFileOptions.jsx
function PDFFileOptions({ onOpenChange }) {
  const [pdfFile, setPDFFile] = useState32(null);
  return !pdfFile ? /* @__PURE__ */ React74.createElement(Dialog.Root, { defaultOpen: true, onOpenChange }, /* @__PURE__ */ React74.createElement(Dialog.Portal, null, /* @__PURE__ */ React74.createElement(Dialog.Overlay, null), /* @__PURE__ */ React74.createElement(
    Dialog.Content,
    {
      css: {
        w: "min(420px,80%)",
        overflow: "auto",
        p: "$10",
        bg: "$surface_dim"
      }
    },
    /* @__PURE__ */ React74.createElement(Flex, { direction: "column" }, /* @__PURE__ */ React74.createElement(PDFHeader, null), /* @__PURE__ */ React74.createElement(
      DialogInputFile,
      {
        onChange: (target) => {
          setPDFFile(target.files[0]);
        },
        placeholder: "Click to upload",
        type: "file",
        accept: ".pdf"
      }
    ), /* @__PURE__ */ React74.createElement(SubmitPDF, { pdfFile, onOpenChange }))
  ))) : /* @__PURE__ */ React74.createElement(UploadedFile, { pdfFile, setPDFFile, onOpenChange });
}

// src/Prebuilt/components/pdfAnnotator/shareScreenOptions.jsx
var MODALS3 = {
  SHARE: "share",
  SCREEN_SHARE: "screenShare",
  PDF_SHARE: "pdfShare"
};
function ShareScreenOptions() {
  const [openModals, setOpenModals] = useState33(/* @__PURE__ */ new Set());
  const { amIScreenSharing } = useScreenShare();
  const updateState = (modalName, value) => {
    setOpenModals((modals) => {
      const copy = new Set(modals);
      if (value) {
        copy.add(modalName);
      } else {
        copy.delete(modalName);
      }
      return copy;
    });
  };
  const { toggleScreenShare } = useScreenShare();
  return /* @__PURE__ */ React75.createElement(Fragment8, null, /* @__PURE__ */ React75.createElement(
    Dropdown.Root,
    {
      open: openModals.has(MODALS3.SHARE),
      onOpenChange: (value) => updateState(MODALS3.SHARE, value),
      modal: false
    },
    /* @__PURE__ */ React75.createElement(Dropdown.Trigger, { asChild: true, "data-testid": "sharing_btn", disabled: amIScreenSharing }, /* @__PURE__ */ React75.createElement(ShareMenuIcon, { disabled: amIScreenSharing }, /* @__PURE__ */ React75.createElement(Tooltip, { title: "Share" }, /* @__PURE__ */ React75.createElement(Box, null, /* @__PURE__ */ React75.createElement(VerticalMenuIcon4, null))))),
    /* @__PURE__ */ React75.createElement(
      Dropdown.Content,
      {
        sideOffset: 5,
        css: {
          w: "$96",
          maxHeight: "$96",
          p: 0,
          bg: "$surface_dim"
        }
      },
      /* @__PURE__ */ React75.createElement(
        Dropdown.Item,
        {
          css: {
            flexDirection: "column",
            alignItems: "flex-start",
            px: "$10",
            pt: "$10",
            pb: "$6",
            "&:hover": {
              bg: "transparent",
              cursor: "default"
            }
          }
        },
        /* @__PURE__ */ React75.createElement(Text, { variant: "h6" }, "Start Sharing"),
        /* @__PURE__ */ React75.createElement(Text, { variant: "sm" }, "Choose what you want to share")
      ),
      /* @__PURE__ */ React75.createElement(
        Dropdown.Item,
        {
          css: {
            flexDirection: "row",
            alignItems: "flex-start",
            gap: "$8",
            px: "$10",
            pt: "$6",
            pb: "$10",
            "&:hover": {
              bg: "transparent",
              cursor: "default"
            }
          }
        },
        /* @__PURE__ */ React75.createElement(
          Flex,
          {
            direction: "column",
            align: "center",
            css: {
              gap: "$6"
            }
          },
          /* @__PURE__ */ React75.createElement(
            IconButton,
            {
              as: "div",
              onClick: toggleScreenShare,
              css: {
                p: "$6",
                display: "flex",
                justifyContent: "center",
                border: "1px solid $border_bright",
                r: "$2",
                bg: "$surface_brighter",
                pb: "0"
              }
            },
            /* @__PURE__ */ React75.createElement(
              "img",
              {
                src: ScreenShareImg,
                alt: "screen-share",
                width: "100%",
                height: "100%",
                style: {
                  borderTopLeftRadius: "0.5rem",
                  // TODO: create image component to solve for style hardcoding
                  borderTopRightRadius: "0.5rem"
                }
              }
            )
          ),
          /* @__PURE__ */ React75.createElement(Flex, { direction: "column", align: "center" }, /* @__PURE__ */ React75.createElement(Text, { variant: "body2" }, "Share Screen"), /* @__PURE__ */ React75.createElement(
            Text,
            {
              variant: "caption",
              css: {
                c: "$on_surface_low",
                textAlign: "center"
              }
            },
            "Share your tab, window or your entire screen"
          ))
        ),
        /* @__PURE__ */ React75.createElement(
          Flex,
          {
            direction: "column",
            align: "center",
            css: {
              gap: "$6"
            }
          },
          /* @__PURE__ */ React75.createElement(
            IconButton,
            {
              onClick: () => {
                updateState(MODALS3.PDF_SHARE, true);
              },
              disabled: amIScreenSharing,
              css: {
                p: "$6",
                display: "flex",
                justifyContent: "center",
                border: "$border_bright 1px solid",
                r: "$2",
                bg: "$surface_bright",
                pb: "0"
              }
            },
            /* @__PURE__ */ React75.createElement(
              "img",
              {
                src: PDFShareImg,
                alt: "pdf-share",
                width: "100%",
                height: "100%",
                style: {
                  borderTopLeftRadius: "0.5rem",
                  // TODO: create image component to solve for style hardcoding
                  borderTopRightRadius: "0.5rem"
                }
              }
            ),
            /* @__PURE__ */ React75.createElement(
              Flex,
              {
                direction: "row",
                align: "center",
                css: {
                  position: "absolute",
                  top: "35%",
                  left: "54%",
                  padding: "$2 $4",
                  r: "$2",
                  bg: "$primary_bright",
                  zIndex: "2",
                  gap: "$2"
                }
              },
              /* @__PURE__ */ React75.createElement(StarIcon, { height: 14, width: 14 }),
              /* @__PURE__ */ React75.createElement(
                Text,
                {
                  variant: "xs",
                  css: {
                    fontWeight: "$semiBold",
                    c: "$on_primary_high",
                    pr: "$4"
                  }
                },
                "New"
              )
            )
          ),
          /* @__PURE__ */ React75.createElement(Flex, { direction: "column", align: "center" }, /* @__PURE__ */ React75.createElement(Text, { variant: "body2" }, "Share PDF"), /* @__PURE__ */ React75.createElement(
            Text,
            {
              variant: "caption",
              css: {
                c: "$on_surface_low",
                textAlign: "center"
              }
            },
            "Annotate, draw shapes, and more over PDFs"
          ))
        )
      )
    )
  ), openModals.has(MODALS3.PDF_SHARE) && /* @__PURE__ */ React75.createElement(PDFFileOptions, { onOpenChange: (value) => updateState(MODALS3.PDF_SHARE, value) }));
}

// src/Prebuilt/components/ScreenShareToggle.jsx
var ScreenshareToggle = ({ css: css2 = {} }) => {
  const isAllowedToPublish = useHMSStore34(selectIsAllowedToPublish2);
  const isAudioOnly = useUISettings(UI_SETTINGS.isAudioOnly);
  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    toggleScreenShare
  } = useScreenShare2((error) => {
    ToastManager.addToast({
      title: error.message,
      variant: "error",
      duration: 2e3
    });
  });
  const { requestPermission } = useAwayNotifications();
  const isVideoScreenshare = amIScreenSharing && !!video;
  if (!isAllowedToPublish.screen || !isScreenshareSupported()) {
    return null;
  }
  return /* @__PURE__ */ React76.createElement(Fragment9, null, /* @__PURE__ */ React76.createElement(Flex, { direction: "row" }, /* @__PURE__ */ React76.createElement(
    ScreenShareButton,
    {
      variant: "standard",
      key: "ShareScreen",
      active: !isVideoScreenshare,
      css: css2,
      disabled: isAudioOnly,
      onClick: () => __async(void 0, null, function* () {
        yield toggleScreenShare();
        yield requestPermission();
      })
    },
    /* @__PURE__ */ React76.createElement(Tooltip, { title: `${!isVideoScreenshare ? "Start" : "Stop"} screen sharing` }, /* @__PURE__ */ React76.createElement(Box, null, /* @__PURE__ */ React76.createElement(ShareScreenIcon, null)))
  ), /* @__PURE__ */ React76.createElement(ShareScreenOptions, null)));
};

// src/Prebuilt/components/VirtualBackground/VBToggle.tsx
init_define_process_env();
import React77, { useEffect as useEffect24 } from "react";
import { HMSVirtualBackgroundTypes as HMSVirtualBackgroundTypes3 } from "@100mslive/hms-virtual-background/hmsvbplugin";
import {
  selectAppData as selectAppData5,
  selectIsEffectsEnabled,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled5,
  selectIsVBEnabled,
  useAVToggle as useAVToggle3,
  useHMSActions as useHMSActions28,
  useHMSStore as useHMSStore35
} from "@100mslive/react-sdk";
import { VirtualBackgroundIcon as VirtualBackgroundIcon2 } from "@100mslive/react-icons";
var VBToggle = () => {
  const toggleVB = useSidepaneToggle(SIDE_PANE_OPTIONS.VB);
  const isVBOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.VB);
  const isVideoOn = useHMSStore35(selectIsLocalVideoEnabled5);
  const isVBEnabled = useHMSStore35(selectIsVBEnabled);
  const isEffectsEnabled = useHMSStore35(selectIsEffectsEnabled);
  const loadingEffects = useHMSStore35(selectAppData5(APP_DATA.loadingEffects));
  const hmsActions = useHMSActions28();
  const { toggleVideo } = useAVToggle3();
  useEffect24(() => {
    var _a8;
    if (!toggleVideo) {
      (_a8 = VBHandler) == null ? void 0 : _a8.reset();
      hmsActions.setAppData(APP_DATA.background, HMSVirtualBackgroundTypes3.NONE);
    }
  }, [hmsActions, toggleVideo]);
  if (!isVideoOn || !isEffectsEnabled && isSafari || !isVBEnabled) {
    return null;
  }
  return /* @__PURE__ */ React77.createElement(Tooltip, { side: "top", disabled: isVBOpen, title: "Configure Virtual Background" }, /* @__PURE__ */ React77.createElement(IconButton_default, { active: !isVBOpen, onClick: toggleVB, "data-testid": "virtual_bg_btn" }, loadingEffects ? /* @__PURE__ */ React77.createElement(Loading, { size: 18 }) : /* @__PURE__ */ React77.createElement(VirtualBackgroundIcon2, null)));
};

// src/Prebuilt/components/Footer/ChatToggle.tsx
init_define_process_env();
import React78 from "react";
import { selectUnreadHMSMessagesCount as selectUnreadHMSMessagesCount3, useHMSStore as useHMSStore36 } from "@100mslive/react-sdk";
import { ChatIcon } from "@100mslive/react-icons";
var ChatToggle = ({ onClick }) => {
  const countUnreadMessages = useHMSStore36(selectUnreadHMSMessagesCount3);
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  return /* @__PURE__ */ React78.createElement(
    Box,
    {
      css: {
        position: "relative"
      }
    },
    /* @__PURE__ */ React78.createElement(Tooltip, { key: "chat", title: `${isChatOpen ? "Close" : "Open"} chat` }, /* @__PURE__ */ React78.createElement(
      IconButton_default,
      {
        onClick: () => onClick ? onClick() : toggleChat(),
        css: { bg: isChatOpen ? "$surface_brighter" : "" },
        "data-testid": "chat_btn"
      },
      /* @__PURE__ */ React78.createElement(ChatIcon, null)
    )),
    countUnreadMessages > 0 && /* @__PURE__ */ React78.createElement(
      Flex,
      {
        css: {
          height: "$8",
          p: "$4 4.5px",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: "-$4",
          right: "-$4",
          borderRadius: "$space$14",
          background: "$primary_default"
        }
      },
      /* @__PURE__ */ React78.createElement(Text, { variant: "overline", css: { color: "$on_primary_high" } }, countUnreadMessages > 99 ? "99+" : countUnreadMessages)
    )
  );
};

// src/Prebuilt/components/Footer/ParticipantList.tsx
init_define_process_env();
import React83, { Fragment as Fragment10, useCallback as useCallback24, useState as useState36 } from "react";
import { useDebounce, useMedia as useMedia14 } from "react-use";
import {
  HMSPeerType as HMSPeerType2,
  selectAvailableRoleNames as selectAvailableRoleNames5,
  selectHandRaisedPeers,
  selectHasPeerHandRaised as selectHasPeerHandRaised2,
  selectIsLargeRoom as selectIsLargeRoom2,
  selectIsPeerAudioEnabled,
  selectLocalPeerID as selectLocalPeerID8,
  selectPeerCount as selectPeerCount4,
  selectPermissions as selectPermissions14,
  useHMSStore as useHMSStore44
} from "@100mslive/react-sdk";
import {
  AddIcon as AddIcon2,
  CallIcon,
  ChangeRoleIcon as ChangeRoleIcon2,
  CrossIcon as CrossIcon15,
  HandIcon as HandIcon4,
  MicOffIcon as MicOffIcon4,
  PeopleIcon as PeopleIcon2,
  PersonSettingsIcon,
  SearchIcon,
  VerticalMenuIcon as VerticalMenuIcon6
} from "@100mslive/react-icons";

// src/Prebuilt/components/Connection/ConnectionIndicator.tsx
init_define_process_env();
import React79 from "react";
import { HMSPeerType, selectConnectionQualityByPeerID as selectConnectionQualityByPeerID2, selectPeerTypeByID, useHMSStore as useHMSStore37 } from "@100mslive/react-sdk";
import { PoorConnectivityIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Connection/connectionQualityUtils.js
init_define_process_env();
var connectionTooltip = {
  0: "Reconnecting",
  1: "Very Bad Connection",
  2: "Bad Connection",
  3: "Moderate Connection",
  4: "Good Connection",
  5: "Excellent Connection"
};
connectionTooltip[-1] = "Network Unknown";
var getTooltipText = (connectionScore) => {
  return connectionTooltip[connectionScore];
};
var getColor = (position, connectionScore, defaultColor, theme2) => {
  const shouldBeColored = position <= connectionScore;
  if (!shouldBeColored) {
    return defaultColor;
  }
  if (connectionScore >= 4) {
    return theme2.colors.alert_success;
  } else if (connectionScore >= 1) {
    return theme2.colors.alert_warning;
  }
  return defaultColor;
};

// src/Prebuilt/components/Connection/ConnectionIndicator.tsx
var Wrapper = styled("span", {
  width: "28px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "$round",
  variants: {
    isTile: {
      true: {
        width: "unset",
        height: "unset"
      }
    }
  }
});
var ConnectionIndicator = ({
  peerId,
  isTile = false,
  hideBg = false
}) => {
  var _a8;
  const downlinkQuality = (_a8 = useHMSStore37(selectConnectionQualityByPeerID2(peerId))) == null ? void 0 : _a8.downlinkQuality;
  const peerType = useHMSStore37(selectPeerTypeByID(peerId));
  const { theme: theme2 } = useTheme();
  const defaultColor = theme2.colors.on_surface_low;
  if (downlinkQuality === -1 || downlinkQuality === void 0 || peerType === HMSPeerType.SIP) {
    return null;
  }
  if (downlinkQuality === 0) {
    return /* @__PURE__ */ React79.createElement(Tooltip, { side: "left", title: getTooltipText(downlinkQuality) }, /* @__PURE__ */ React79.createElement(Wrapper, { isTile, css: { color: "#ED4C5A" }, "data-testid": "tile_network" }, /* @__PURE__ */ React79.createElement(PoorConnectivityIcon, null)));
  }
  const size = isTile ? 12 : 16;
  return /* @__PURE__ */ React79.createElement(Tooltip, { side: "left", title: getTooltipText(downlinkQuality) }, /* @__PURE__ */ React79.createElement(Wrapper, { isTile, "data-testid": "tile_network", css: { backgroundColor: hideBg ? "" : "$surface_bright" } }, /* @__PURE__ */ React79.createElement(
    "svg",
    {
      width: size,
      height: size,
      viewBox: "0 0 14 12",
      xmlns: "http://www.w3.org/2000/svg",
      xmlSpace: "preserve",
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2
      }
    },
    /* @__PURE__ */ React79.createElement(
      "path",
      {
        d: "M6.875 0c2.549.035 4.679.902 6.445 2.648.366.362.45.796.216 1.096-.239.306-.714.34-1.142.072a2.28 2.28 0 0 1-.341-.271C9.24.862 4.924.775 1.992 3.346c-.284.249-.594.419-.983.393-.272-.019-.49-.135-.613-.388-.125-.261-.05-.498.114-.713.073-.092.156-.177.245-.254C2.516.804 4.591.039 6.875 0Z",
        fill: getColor(4, downlinkQuality, defaultColor, theme2),
        transform: "translate(-.333)"
      }
    ),
    /* @__PURE__ */ React79.createElement(
      "path",
      {
        d: "M7.056 2.964c1.756.035 3.208.7 4.499 1.763.162.134.277.315.354.512.098.251.114.503-.075.72-.193.222-.452.259-.725.198-.293-.066-.518-.247-.738-.443a4.859 4.859 0 0 0-6.198-.26c-.166.127-.318.271-.475.409-.242.211-.513.343-.843.317-.43-.034-.679-.397-.561-.81.062-.211.181-.4.345-.546 1.265-1.162 2.733-1.836 4.417-1.86Z",
        fill: getColor(3, downlinkQuality, defaultColor, theme2),
        transform: "translate(-.333)"
      }
    ),
    /* @__PURE__ */ React79.createElement(
      "path",
      {
        d: "M7.384,6.052C8.293,6.068 9.157,6.449 9.783,7.108C10.005,7.339 10.157,7.6 10.07,7.942C9.959,8.377 9.435,8.581 9.071,8.243C7.935,7.191 6.356,7.183 5.152,8.183C4.816,8.462 4.6,8.485 4.332,8.27C4.063,8.055 3.998,7.691 4.177,7.358C4.273,7.179 4.414,7.038 4.57,6.911C5.26,6.349 6.149,6.05 7.384,6.052L7.384,6.052Z",
        fill: getColor(2, downlinkQuality, defaultColor, theme2)
      }
    ),
    /* @__PURE__ */ React79.createElement(
      "path",
      {
        d: "M8.214,9.941C8.214,10.234 8.097,10.515 7.888,10.721C7.68,10.928 7.398,11.042 7.104,11.039C6.471,11.036 5.982,10.541 5.993,9.912C6.004,9.259 6.499,8.766 7.133,8.779C7.744,8.791 8.22,9.301 8.214,9.941Z",
        fill: getColor(1, downlinkQuality, defaultColor, theme2)
      }
    )
  )));
};

// src/Prebuilt/components/RemoveParticipant.tsx
init_define_process_env();
import React80 from "react";
import { selectLocalPeerID as selectLocalPeerID7, selectPermissions as selectPermissions10, useHMSActions as useHMSActions29, useHMSStore as useHMSStore38 } from "@100mslive/react-sdk";
import { PeopleRemoveIcon as PeopleRemoveIcon3 } from "@100mslive/react-icons";
var RemoveParticipant = ({ peerId }) => {
  var _a8;
  const canRemoveOthers = (_a8 = useHMSStore38(selectPermissions10)) == null ? void 0 : _a8.removeOthers;
  const localPeerId = useHMSStore38(selectLocalPeerID7);
  const actions = useHMSActions29();
  if (peerId === localPeerId || !canRemoveOthers) {
    return null;
  }
  return /* @__PURE__ */ React80.createElement(
    Dropdown.Item,
    {
      css: { color: "$alert_error_default", bg: "$surface_default" },
      onClick: () => __async(void 0, null, function* () {
        try {
          yield actions.removePeer(peerId, "");
        } catch (error) {
          const ex = error;
          ToastManager.addToast({ title: ex.message, variant: "error" });
        }
      })
    },
    /* @__PURE__ */ React80.createElement(PeopleRemoveIcon3, null),
    /* @__PURE__ */ React80.createElement(Text, { variant: "sm", css: { ml: "$4", color: "inherit", fontWeight: "$semiBold" } }, "Remove Participant")
  );
};

// src/Prebuilt/components/Footer/RoleAccordion.tsx
init_define_process_env();
import React82, { useEffect as useEffect25 } from "react";
import { useMeasure } from "react-use";
import { FixedSizeList } from "react-window";
import { selectIsLargeRoom, useHMSStore as useHMSStore41, usePaginatedParticipants } from "@100mslive/react-sdk";
import { AddIcon, ChevronRightIcon, CrossIcon as CrossIcon14 } from "@100mslive/react-icons";

// src/Prebuilt/components/Footer/RoleOptions.tsx
init_define_process_env();
import React81, { useState as useState34 } from "react";
import { match as match7 } from "ts-pattern";
import {
  selectPermissions as selectPermissions11,
  selectRoleByRoleName,
  selectTracksMap as selectTracksMap3,
  useHMSActions as useHMSActions30,
  useHMSStore as useHMSStore39
} from "@100mslive/react-sdk";
import {
  MicOffIcon as MicOffIcon3,
  MicOnIcon as MicOnIcon3,
  PersonRectangleIcon as PersonRectangleIcon2,
  RemoveUserIcon,
  VerticalMenuIcon as VerticalMenuIcon5,
  VideoOffIcon as VideoOffIcon2,
  VideoOnIcon as VideoOnIcon3
} from "@100mslive/react-icons";
var dropdownItemCSS = { backgroundColor: "$surface_default", gap: "$4", p: "$8" };
var optionTextCSS = {
  fontWeight: "$semiBold",
  color: "$on_surface_high",
  textTransform: "none",
  whiteSpace: "nowrap"
};
var DropdownWrapper = ({ children }) => {
  const [openOptions, setOpenOptions] = useState34(false);
  if (React81.Children.toArray(children).length === 0) {
    return null;
  }
  return /* @__PURE__ */ React81.createElement(Dropdown.Root, { open: openOptions, onOpenChange: setOpenOptions }, /* @__PURE__ */ React81.createElement(
    Dropdown.Trigger,
    {
      "data-testid": "role_group_options",
      onClick: (e) => e.stopPropagation(),
      className: "role_actions",
      asChild: true,
      css: {
        p: "$1",
        r: "$0",
        c: "$on_surface_high",
        visibility: openOptions ? "visible" : "hidden",
        "&:hover": {
          c: "$on_surface_medium"
        },
        "@md": {
          visibility: "visible"
        }
      }
    },
    /* @__PURE__ */ React81.createElement(Flex, null, /* @__PURE__ */ React81.createElement(VerticalMenuIcon5, null))
  ), /* @__PURE__ */ React81.createElement(
    Dropdown.Content,
    {
      onClick: (e) => e.stopPropagation(),
      css: { w: "max-content", bg: "$surface_default", py: 0 },
      align: "end"
    },
    children
  ));
};
var RoleOptions = ({ roleName, peerList }) => {
  const permissions = useHMSStore39(selectPermissions11);
  const hmsActions = useHMSActions30();
  const { elements } = useRoomLayoutConferencingScreen();
  const { on_stage_role, off_stage_roles = [] } = (elements == null ? void 0 : elements.on_stage_exp) || {};
  const canRemoveRoleFromStage = (permissions == null ? void 0 : permissions.changeRole) && roleName === on_stage_role;
  const role = useHMSStore39(selectRoleByRoleName(roleName));
  const tracks = useHMSStore39(selectTracksMap3);
  if (!role) {
    return null;
  }
  const canPublishAudio = role.publishParams.allowed.includes("audio");
  const canPublishVideo = role.publishParams.allowed.includes("video");
  let isVideoOnForSomePeers = false;
  let isAudioOnForSomePeers = false;
  peerList.forEach((peer) => {
    var _a8, _b7;
    if (peer.isLocal) {
      return;
    }
    const isAudioOn = !!peer.audioTrack && ((_a8 = tracks[peer.audioTrack]) == null ? void 0 : _a8.enabled);
    const isVideoOn = !!peer.videoTrack && ((_b7 = tracks[peer.videoTrack]) == null ? void 0 : _b7.enabled);
    isAudioOnForSomePeers = isAudioOnForSomePeers || isAudioOn;
    isVideoOnForSomePeers = isVideoOnForSomePeers || isVideoOn;
  });
  const setTrackEnabled = (type, enabled = false) => __async(void 0, null, function* () {
    try {
      yield hmsActions.setRemoteTracksEnabled({ roles: [roleName], source: "regular", type, enabled });
    } catch (e) {
      console.error(e);
    }
  });
  const canRemoveRoleFromRoom = (permissions == null ? void 0 : permissions.removeOthers) && (on_stage_role === roleName || (off_stage_roles == null ? void 0 : off_stage_roles.includes(roleName)));
  if (peerList.length === 0 || // if only local peer is present no need to show any options
  peerList.length === 1 && peerList[0].isLocal || !role) {
    return null;
  }
  const removeAllFromStage = () => {
    peerList.forEach((peer) => {
      const prevRole = getMetadata(peer.metadata).prevRole;
      if (prevRole) {
        hmsActions.changeRoleOfPeer(peer.id, prevRole, true);
      }
    });
  };
  const removePeersFromRoom = () => __async(void 0, null, function* () {
    try {
      peerList.forEach((peer) => __async(void 0, null, function* () {
        yield hmsActions.removePeer(peer.id, "");
      }));
    } catch (e) {
      console.error(e);
    }
  });
  return /* @__PURE__ */ React81.createElement(DropdownWrapper, null, canRemoveRoleFromStage ? /* @__PURE__ */ React81.createElement(
    Dropdown.Item,
    {
      css: __spreadProps(__spreadValues({}, dropdownItemCSS), { borderBottom: "1px solid $border_bright" }),
      onClick: removeAllFromStage
    },
    /* @__PURE__ */ React81.createElement(PersonRectangleIcon2, null),
    /* @__PURE__ */ React81.createElement(Text, { variant: "sm", css: optionTextCSS }, "Remove all from Stage")
  ) : null, match7({ canPublishAudio, isAudioOnForSomePeers, canMute: permissions == null ? void 0 : permissions.mute, canUnmute: permissions == null ? void 0 : permissions.unmute }).with({ canPublishAudio: true, isAudioOnForSomePeers: true, canMute: true }, () => {
    return /* @__PURE__ */ React81.createElement(Dropdown.Item, { css: dropdownItemCSS, onClick: () => setTrackEnabled("audio", false) }, /* @__PURE__ */ React81.createElement(MicOffIcon3, null), /* @__PURE__ */ React81.createElement(Text, { variant: "sm", css: optionTextCSS }, "Mute Audio for All"));
  }).with({ canPublishAudio: true, isAudioOnForSomePeers: false, canUnmute: true }, () => {
    return /* @__PURE__ */ React81.createElement(Dropdown.Item, { css: dropdownItemCSS, onClick: () => setTrackEnabled("audio", true) }, /* @__PURE__ */ React81.createElement(MicOnIcon3, null), /* @__PURE__ */ React81.createElement(Text, { variant: "sm", css: optionTextCSS }, "Request to Unmute Audio for All"));
  }).otherwise(() => null), match7({ canPublishVideo, isVideoOnForSomePeers, canMute: permissions == null ? void 0 : permissions.mute, canUnmute: permissions == null ? void 0 : permissions.unmute }).with({ canPublishVideo: true, isVideoOnForSomePeers: true, canMute: true }, () => {
    return /* @__PURE__ */ React81.createElement(Dropdown.Item, { css: dropdownItemCSS, onClick: () => setTrackEnabled("video", false) }, /* @__PURE__ */ React81.createElement(VideoOffIcon2, null), /* @__PURE__ */ React81.createElement(Text, { variant: "sm", css: optionTextCSS }, "Mute Video for All"));
  }).with({ canPublishVideo: true, isVideoOnForSomePeers: false, canUnmute: true }, () => {
    return /* @__PURE__ */ React81.createElement(Dropdown.Item, { css: dropdownItemCSS, onClick: () => setTrackEnabled("video", true) }, /* @__PURE__ */ React81.createElement(VideoOnIcon3, null), /* @__PURE__ */ React81.createElement(Text, { variant: "sm", css: optionTextCSS }, "Request to Unmute Video for All"));
  }).otherwise(() => null), canRemoveRoleFromRoom ? /* @__PURE__ */ React81.createElement(
    Dropdown.Item,
    {
      css: __spreadProps(__spreadValues({}, dropdownItemCSS), { borderTop: "1px solid $border_bright", color: "$alert_error_default" }),
      onClick: removePeersFromRoom
    },
    /* @__PURE__ */ React81.createElement(RemoveUserIcon, null),
    /* @__PURE__ */ React81.createElement(Text, { variant: "sm", css: __spreadProps(__spreadValues({}, optionTextCSS), { color: "inherit" }) }, "Remove all from Room")
  ) : null);
};

// src/Prebuilt/components/hooks/useGroupOnStageActions.tsx
init_define_process_env();
import { match as match8, P as P5 } from "ts-pattern";
import { selectPermissions as selectPermissions12, useHMSActions as useHMSActions31, useHMSStore as useHMSStore40 } from "@100mslive/react-sdk";
var useGroupOnStageActions = ({ peers }) => {
  var _a8;
  const hmsActions = useHMSActions31();
  const { elements } = useRoomLayoutConferencingScreen();
  const {
    bring_to_stage_label,
    remove_from_stage_label,
    on_stage_role,
    off_stage_roles = [],
    skip_preview_for_role_change = false
  } = elements.on_stage_exp || {};
  const canChangeRole = (_a8 = useHMSStore40(selectPermissions12)) == null ? void 0 : _a8.changeRole;
  const offStageRolePeers = peers.filter(
    (peer) => match8({ on_stage_role, bring_to_stage_label, roleName: peer.roleName }).with(
      {
        on_stage_role: P5.when((role) => !!role),
        bring_to_stage_label: P5.when((label) => !!label),
        roleName: P5.when((role) => !!role && off_stage_roles.includes(role))
      },
      () => true
    ).otherwise(() => false)
  );
  const lowerAllHands = () => __async(void 0, null, function* () {
    return Promise.all(peers.map((peer) => hmsActions.lowerRemotePeerHand(peer.id)));
  });
  const bringAllToStage = () => {
    if (!canChangeRole || !on_stage_role) {
      return;
    }
    return Promise.all(
      offStageRolePeers.map((peer) => {
        return hmsActions.changeRoleOfPeer(peer.id, on_stage_role, skip_preview_for_role_change).then(() => {
          return skip_preview_for_role_change ? hmsActions.lowerRemotePeerHand(peer.id) : null;
        });
      })
    );
  };
  return {
    lowerAllHands,
    bringAllToStage,
    canBringToStage: canChangeRole && offStageRolePeers.length > 0,
    bring_to_stage_label,
    remove_from_stage_label
  };
};

// src/Prebuilt/components/Footer/RoleAccordion.tsx
var ROW_HEIGHT = 50;
var ITER_TIMER = 5e3;
function itemKey(index, data3) {
  var _a8;
  return (_a8 = data3.peerList[index]) == null ? void 0 : _a8.id;
}
var VirtualizedParticipantItem = React82.memo(
  ({ index, data: data3, style }) => {
    return /* @__PURE__ */ React82.createElement(
      Participant,
      {
        key: data3.peerList[index].id,
        peer: data3.peerList[index],
        isHandRaisedAccordion: data3.isHandRaisedAccordion,
        isConnected: data3.isConnected,
        style
      }
    );
  }
);
var RoleAccordion = ({
  peerList = [],
  roleName,
  isConnected,
  filter,
  isHandRaisedAccordion = false,
  offStageRoles,
  onActive
}) => {
  const [ref, { width }] = useMeasure();
  const isLargeRoom = useHMSStore41(selectIsLargeRoom);
  const { peers, total, loadPeers } = usePaginatedParticipants({ role: roleName, limit: 10 });
  const isOffStageRole = roleName && offStageRoles.includes(roleName);
  let peersInAccordion = peerList;
  if (isOffStageRole && isLargeRoom) {
    peersInAccordion = peers;
    if (filter == null ? void 0 : filter.search) {
      peersInAccordion = peersInAccordion.filter((peer) => peer.name.toLowerCase().includes(filter.search || ""));
    }
  }
  const { bringAllToStage, bring_to_stage_label, canBringToStage, lowerAllHands } = useGroupOnStageActions({
    peers: peersInAccordion
  });
  useEffect25(() => {
    if (!isOffStageRole || !isLargeRoom) {
      return;
    }
    loadPeers();
    const interval = setInterval(() => {
      loadPeers();
    }, ITER_TIMER);
    return () => clearInterval(interval);
  }, [isOffStageRole, isLargeRoom]);
  if (peersInAccordion.length === 0 || isHandRaisedAccordion && (filter == null ? void 0 : filter.search)) {
    return null;
  }
  const height = ROW_HEIGHT * peersInAccordion.length;
  const hasNext = total > peersInAccordion.length && !(filter == null ? void 0 : filter.search);
  return /* @__PURE__ */ React82.createElement(Accordion.Item, { value: roleName, css: { "&:hover .role_actions": { visibility: "visible" }, mb: "$8" }, ref }, /* @__PURE__ */ React82.createElement(
    Accordion.Header,
    {
      chevronID: `role_accordion_btn_${roleName}`,
      iconStyles: { c: "$on_surface_high" },
      css: {
        textTransform: "capitalize",
        p: "$6 $8",
        fontSize: "$sm",
        fontWeight: "$semiBold",
        c: "$on_surface_medium",
        borderRadius: "$1",
        border: "1px solid $border_default",
        '&[data-state="open"]': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },
    /* @__PURE__ */ React82.createElement(Flex, { justify: "between", align: "center", css: { flexGrow: 1, pr: "$6" } }, /* @__PURE__ */ React82.createElement(
      Text,
      {
        variant: "sm",
        css: { fontWeight: "$semiBold", textTransform: "capitalize", color: "$on_surface_medium" }
      },
      roleName,
      " ",
      `(${getFormattedCount(isLargeRoom && isOffStageRole ? total : peerList.length)})`
    ), /* @__PURE__ */ React82.createElement(RoleOptions, { roleName, peerList: peersInAccordion }))
  ), /* @__PURE__ */ React82.createElement(Accordion.Content, { contentStyles: { border: "1px solid $border_default", borderTop: "none" } }, /* @__PURE__ */ React82.createElement(
    FixedSizeList,
    {
      itemSize: ROW_HEIGHT,
      itemData: {
        peerList: isHandRaisedAccordion ? peersInAccordion.sort((a2, b2) => {
          try {
            const aHandRaisedAt = JSON.parse(a2.metadata || "{}").handRaisedAt;
            const bHandRaisedAt = JSON.parse(b2.metadata || "{}").handRaisedAt;
            return aHandRaisedAt - bHandRaisedAt;
          } catch (err) {
            return 0;
          }
        }) : peersInAccordion,
        isConnected,
        isHandRaisedAccordion
      },
      itemKey,
      itemCount: peersInAccordion.length,
      width,
      height
    },
    VirtualizedParticipantItem
  ), (offStageRoles == null ? void 0 : offStageRoles.includes(roleName)) && hasNext ? /* @__PURE__ */ React82.createElement(
    Flex,
    {
      align: "center",
      justify: "end",
      css: {
        gap: "$1",
        cursor: "pointer",
        color: "$on_surface_high",
        p: "$6",
        borderTop: "1px solid $border_default"
      },
      onClick: () => onActive == null ? void 0 : onActive(roleName)
    },
    /* @__PURE__ */ React82.createElement(Text, { variant: "sm", css: { color: "inherit" } }, "View All"),
    /* @__PURE__ */ React82.createElement(ChevronRightIcon, null)
  ) : null, isHandRaisedAccordion && canBringToStage && /* @__PURE__ */ React82.createElement(React82.Fragment, null, /* @__PURE__ */ React82.createElement(HorizontalDivider, null), /* @__PURE__ */ React82.createElement(Flex, { css: { w: "100%", p: "$6", gap: "$4" }, justify: "center" }, /* @__PURE__ */ React82.createElement(Button, { variant: "standard", onClick: lowerAllHands, icon: true, css: { pl: "$2" } }, /* @__PURE__ */ React82.createElement(CrossIcon14, null), " Lower all hands"), /* @__PURE__ */ React82.createElement(Button, { onClick: bringAllToStage, icon: true, css: { pl: "$2" } }, /* @__PURE__ */ React82.createElement(AddIcon, null), " ", bring_to_stage_label)))));
};

// src/Prebuilt/components/AppData/useSidepaneResetOnLayoutUpdate.tsx
init_define_process_env();
import { useEffect as useEffect26 } from "react";
import { selectAppData as selectAppData6, useHMSStore as useHMSStore42 } from "@100mslive/react-sdk";
var useSidepaneResetOnLayoutUpdate = (layoutKey, sidepaneOption) => {
  const { elements } = useRoomLayoutConferencingScreen();
  const sidepane = useHMSStore42(selectAppData6(APP_DATA.sidePane));
  const resetSidePane = useSidepaneReset();
  useEffect26(() => {
    if (sidepane === sidepaneOption && !(elements == null ? void 0 : elements[layoutKey])) {
      resetSidePane();
    }
  }, [elements, elements == null ? void 0 : elements[layoutKey], resetSidePane, sidepane, layoutKey, sidepaneOption]);
};

// src/Prebuilt/components/hooks/usePeerOnStageActions.tsx
init_define_process_env();
import { useState as useState35 } from "react";
import { selectPeerMetadata as selectPeerMetadata3, selectPermissions as selectPermissions13, useHMSActions as useHMSActions32, useHMSStore as useHMSStore43 } from "@100mslive/react-sdk";
var usePeerOnStageActions = ({ peerId, role }) => {
  var _a8, _b7;
  const hmsActions = useHMSActions32();
  const { elements } = useRoomLayoutConferencingScreen();
  const {
    bring_to_stage_label,
    remove_from_stage_label,
    on_stage_role,
    off_stage_roles = [],
    skip_preview_for_role_change = false
  } = elements.on_stage_exp || {};
  const isInStage = role === on_stage_role;
  const canChangeRole = (_a8 = useHMSStore43(selectPermissions13)) == null ? void 0 : _a8.changeRole;
  const shouldShowStageRoleChange = canChangeRole && (isInStage && remove_from_stage_label || (off_stage_roles == null ? void 0 : off_stage_roles.includes(role)) && bring_to_stage_label);
  const prevRole = (_b7 = useHMSStore43(selectPeerMetadata3(peerId))) == null ? void 0 : _b7.prevRole;
  const [open, setOpen] = useState35(false);
  const lowerPeerHand = () => __async(void 0, null, function* () {
    yield hmsActions.lowerRemotePeerHand(peerId);
  });
  const handleStageAction = () => __async(void 0, null, function* () {
    if (isInStage) {
      prevRole && hmsActions.changeRoleOfPeer(peerId, prevRole, true);
    } else if (on_stage_role) {
      yield hmsActions.changeRoleOfPeer(peerId, on_stage_role, skip_preview_for_role_change);
      if (skip_preview_for_role_change) {
        yield lowerPeerHand();
      }
    }
    setOpen(false);
  });
  return {
    open,
    setOpen,
    lowerPeerHand,
    handleStageAction,
    shouldShowStageRoleChange,
    isInStage,
    bring_to_stage_label,
    remove_from_stage_label
  };
};

// src/Prebuilt/components/Footer/ParticipantList.tsx
var ParticipantList = ({
  offStageRoles = [],
  onActive
}) => {
  const [filter, setFilter] = useState36();
  const { participants, isConnected, peerCount } = useParticipants(filter);
  const isLargeRoom = useHMSStore44(selectIsLargeRoom2);
  const peersOrderedByRoles = {};
  const handRaisedPeers = useHMSStore44(selectHandRaisedPeers);
  participants.forEach((participant) => {
    if (participant.roleName) {
      if (peersOrderedByRoles[participant.roleName] === void 0) {
        peersOrderedByRoles[participant.roleName] = [];
      }
      peersOrderedByRoles[participant.roleName].push(participant);
    }
  });
  if (isLargeRoom) {
    offStageRoles.forEach((role) => {
      if (!peersOrderedByRoles[role]) {
        peersOrderedByRoles[role] = [];
      }
    });
  }
  useSidepaneResetOnLayoutUpdate("participant_list", SIDE_PANE_OPTIONS.PARTICIPANTS);
  const onSearch = useCallback24((value) => {
    setFilter((filterValue) => {
      if (!filterValue) {
        filterValue = {};
      }
      filterValue.search = value.toLowerCase();
      return __spreadValues({}, filterValue);
    });
  }, []);
  if (peerCount === 0) {
    return null;
  }
  return /* @__PURE__ */ React83.createElement(Fragment10, null, /* @__PURE__ */ React83.createElement(
    Flex,
    {
      direction: "column",
      css: {
        size: "100%",
        gap: "$4"
      }
    },
    !(filter == null ? void 0 : filter.search) && participants.length === 0 ? null : /* @__PURE__ */ React83.createElement(ParticipantSearch, { onSearch, inSidePane: true }),
    /* @__PURE__ */ React83.createElement(
      VirtualizedParticipants,
      {
        peersOrderedByRoles,
        handRaisedList: handRaisedPeers,
        isConnected: !!isConnected,
        filter,
        offStageRoles,
        isLargeRoom,
        onActive
      },
      participants.length === 0 ? /* @__PURE__ */ React83.createElement(
        Flex,
        {
          align: "center",
          justify: "center",
          className: "emptyParticipants",
          css: { w: "100%", p: "$8 0", display: "none" }
        },
        /* @__PURE__ */ React83.createElement(Text, { variant: "sm" }, !filter ? "No participants" : "No matching participants")
      ) : null
    )
  ));
};
var ParticipantCount = () => {
  const peerCount = useHMSStore44(selectPeerCount4);
  const toggleSidepane = useSidepaneToggle(SIDE_PANE_OPTIONS.PARTICIPANTS);
  const isPeerListOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.PARTICIPANTS);
  if (peerCount === 0) {
    return null;
  }
  return /* @__PURE__ */ React83.createElement(
    IconButton_default,
    {
      css: {
        w: "auto",
        p: "$4",
        h: "auto",
        bg: isPeerListOpen ? "$surface_brighter" : ""
      },
      onClick: () => {
        if (peerCount > 0) {
          toggleSidepane();
        }
      },
      "data-testid": "participant_list"
    },
    /* @__PURE__ */ React83.createElement(PeopleIcon2, null),
    /* @__PURE__ */ React83.createElement(Text, { variant: "sm", css: { mx: "$4", c: "inherit" } }, getFormattedCount(peerCount))
  );
};
var Participant = ({
  peer,
  isConnected,
  isHandRaisedAccordion,
  style
}) => {
  const localPeerId = useHMSStore44(selectLocalPeerID8);
  return /* @__PURE__ */ React83.createElement(
    Flex,
    {
      key: peer.id,
      css: {
        w: "100%",
        p: "$4 $8",
        pr: "$6",
        h: "$16",
        "&:hover .participant_item": { display: "flex" }
      },
      align: "center",
      justify: "between",
      "data-testid": "participant_" + peer.name,
      style
    },
    /* @__PURE__ */ React83.createElement(
      Text,
      {
        variant: "sm",
        css: __spreadProps(__spreadValues({}, textEllipsis("100%")), { flex: "1 1 0", mr: "$8", fontWeight: "$semiBold", color: "$on_surface_high" })
      },
      peer.name,
      " ",
      localPeerId === peer.id ? "(You)" : ""
    ),
    isConnected && peer.roleName ? /* @__PURE__ */ React83.createElement(
      ParticipantActions,
      {
        peerId: peer.id,
        peerType: peer.type,
        role: peer.roleName,
        isHandRaisedAccordion
      }
    ) : null
  );
};
var VirtualizedParticipants = ({
  peersOrderedByRoles = {},
  isConnected,
  filter,
  handRaisedList = [],
  offStageRoles,
  isLargeRoom,
  onActive,
  children
}) => {
  return /* @__PURE__ */ React83.createElement(
    Flex,
    {
      direction: "column",
      css: {
        gap: "$8",
        overflowY: "auto",
        overflowX: "hidden",
        pr: "$10",
        mr: "-$10",
        flex: "1 1 0",
        "& > div:empty ~ .emptyParticipants": {
          display: "flex"
        }
      }
    },
    /* @__PURE__ */ React83.createElement(Accordion.Root, { type: isLargeRoom ? "single" : "multiple", collapsible: true }, handRaisedList.length > 0 ? /* @__PURE__ */ React83.createElement(
      RoleAccordion,
      {
        peerList: handRaisedList,
        roleName: "Hand Raised",
        filter,
        isConnected,
        isHandRaisedAccordion: true,
        offStageRoles
      }
    ) : null, Object.keys(peersOrderedByRoles).map((role) => /* @__PURE__ */ React83.createElement(
      RoleAccordion,
      {
        key: role,
        peerList: peersOrderedByRoles[role],
        roleName: role,
        isConnected,
        filter,
        offStageRoles,
        onActive
      }
    ))),
    children
  );
};
var ParticipantActions = React83.memo(
  ({
    peerId,
    peerType,
    role,
    isHandRaisedAccordion
  }) => {
    var _a8, _b7;
    const isHandRaised = useHMSStore44(selectHasPeerHandRaised2(peerId));
    const canChangeRole = (_a8 = useHMSStore44(selectPermissions14)) == null ? void 0 : _a8.changeRole;
    const canRemoveOthers = (_b7 = useHMSStore44(selectPermissions14)) == null ? void 0 : _b7.removeOthers;
    const { elements } = useRoomLayoutConferencingScreen();
    const { on_stage_exp } = elements || {};
    const shouldShowMoreActions = on_stage_exp && canChangeRole || canRemoveOthers;
    const isAudioMuted = !useHMSStore44(selectIsPeerAudioEnabled(peerId));
    return /* @__PURE__ */ React83.createElement(
      Flex,
      {
        align: "center",
        css: {
          flexShrink: 0,
          gap: "$8"
        }
      },
      isHandRaisedAccordion ? /* @__PURE__ */ React83.createElement(HandRaisedAccordionParticipantActions, { peerId, role }) : /* @__PURE__ */ React83.createElement(React83.Fragment, null, /* @__PURE__ */ React83.createElement(ConnectionIndicator, { peerId }), peerType === HMSPeerType2.SIP && /* @__PURE__ */ React83.createElement(
        Flex,
        {
          align: "center",
          justify: "center",
          css: { p: "$1", c: "$on_surface_high", bg: "$surface_bright", borderRadius: "$round" }
        },
        /* @__PURE__ */ React83.createElement(CallIcon, { width: 19, height: 19 })
      ), isHandRaised && /* @__PURE__ */ React83.createElement(
        Flex,
        {
          align: "center",
          justify: "center",
          css: { p: "$1", c: "$on_surface_high", bg: "$surface_bright", borderRadius: "$round" }
        },
        /* @__PURE__ */ React83.createElement(HandIcon4, { height: 19, width: 19 })
      ), isAudioMuted ? /* @__PURE__ */ React83.createElement(
        Flex,
        {
          align: "center",
          justify: "center",
          css: { p: "$2", c: "$on_surface_high", bg: "$surface_bright", borderRadius: "$round" }
        },
        /* @__PURE__ */ React83.createElement(MicOffIcon4, { height: 19, width: 19 })
      ) : null, shouldShowMoreActions ? /* @__PURE__ */ React83.createElement(ParticipantMoreActions, { peerId, role }) : null)
    );
  }
);
var quickActionStyle = { p: "$1", borderRadius: "$round" };
var HandRaisedAccordionParticipantActions = ({ peerId, role }) => {
  const { handleStageAction, lowerPeerHand, shouldShowStageRoleChange, isInStage } = usePeerOnStageActions({
    peerId,
    role
  });
  if (!shouldShowStageRoleChange) {
    return null;
  }
  return /* @__PURE__ */ React83.createElement(React83.Fragment, null, /* @__PURE__ */ React83.createElement(Button, { variant: "standard", css: quickActionStyle, onClick: lowerPeerHand }, /* @__PURE__ */ React83.createElement(CrossIcon15, { height: 18, width: 18 })), !isInStage && /* @__PURE__ */ React83.createElement(Button, { variant: "primary", onClick: handleStageAction, css: quickActionStyle }, /* @__PURE__ */ React83.createElement(AddIcon2, { height: 18, width: 18 })));
};
var ParticipantMoreActions = ({ peerId, role }) => {
  var _a8;
  const {
    open,
    setOpen,
    bring_to_stage_label,
    remove_from_stage_label,
    handleStageAction,
    isInStage,
    shouldShowStageRoleChange
  } = usePeerOnStageActions({ peerId, role });
  const canChangeRole = !!((_a8 = useHMSStore44(selectPermissions14)) == null ? void 0 : _a8.changeRole);
  const [openRoleChangeModal, setOpenRoleChangeModal] = useState36(false);
  const roles = useHMSStore44(selectAvailableRoleNames5);
  return /* @__PURE__ */ React83.createElement(React83.Fragment, null, /* @__PURE__ */ React83.createElement(Dropdown.Root, { open, onOpenChange: (value) => setOpen(value), modal: false }, /* @__PURE__ */ React83.createElement(
    Dropdown.Trigger,
    {
      asChild: true,
      "data-testid": "participant_more_actions",
      className: "participant_item",
      css: {
        p: "$1",
        r: "$0",
        c: "$on_surface_high",
        display: open ? "flex" : "none",
        "&:hover": {
          bg: "$surface_bright"
        },
        "@md": {
          display: "flex"
        }
      },
      tabIndex: 0
    },
    /* @__PURE__ */ React83.createElement(Box, { css: { my: "auto" } }, /* @__PURE__ */ React83.createElement(VerticalMenuIcon6, null))
  ), /* @__PURE__ */ React83.createElement(Dropdown.Portal, null, /* @__PURE__ */ React83.createElement(Dropdown.Content, { align: "end", sideOffset: 8, css: { w: "$64", bg: "$surface_default" } }, shouldShowStageRoleChange ? /* @__PURE__ */ React83.createElement(Dropdown.Item, { css: { bg: "$surface_default" }, onClick: () => handleStageAction() }, /* @__PURE__ */ React83.createElement(ChangeRoleIcon2, null), /* @__PURE__ */ React83.createElement(Text, { variant: "sm", css: { ml: "$4", fontWeight: "$semiBold", c: "$on_surface_high" } }, isInStage ? remove_from_stage_label : bring_to_stage_label)) : null, canChangeRole && roles.length > 1 ? /* @__PURE__ */ React83.createElement(Dropdown.Item, { css: { bg: "$surface_default" }, onClick: () => setOpenRoleChangeModal(true) }, /* @__PURE__ */ React83.createElement(PersonSettingsIcon, null), /* @__PURE__ */ React83.createElement(Text, { variant: "sm", css: { ml: "$4", fontWeight: "$semiBold", c: "$on_surface_high" } }, "Switch Role")) : null, /* @__PURE__ */ React83.createElement(RemoveParticipant, { peerId })))), openRoleChangeModal && /* @__PURE__ */ React83.createElement(RoleChangeModal, { peerId, onOpenChange: setOpenRoleChangeModal }));
};
var ParticipantSearch = ({
  onSearch,
  placeholder = "Search for participants",
  inSidePane = false
}) => {
  const [value, setValue] = React83.useState("");
  const isMobile = useMedia14(config.media.md);
  useDebounce(
    () => {
      onSearch(value);
    },
    300,
    [value, onSearch]
  );
  return /* @__PURE__ */ React83.createElement(
    Flex,
    {
      align: "center",
      css: {
        p: isMobile ? "0" : "$2 0",
        mb: "$2",
        position: "relative",
        color: "$on_surface_medium",
        mt: inSidePane ? "$4" : ""
      },
      onClick: (e) => e.stopPropagation()
    },
    /* @__PURE__ */ React83.createElement(SearchIcon, { style: { position: "absolute", left: "0.5rem" } }),
    /* @__PURE__ */ React83.createElement(
      Input,
      {
        type: "text",
        placeholder,
        css: { w: "100%", p: "$6", pl: "$14", bg: inSidePane ? "$surface_default" : "$surface_dim" },
        value,
        onKeyDown: (event) => {
          event.stopPropagation();
        },
        onChange: (event) => {
          setValue(event.currentTarget.value);
        },
        autoComplete: "off",
        "aria-autocomplete": "none"
      }
    )
  );
};

// src/Prebuilt/components/Footer/PollsToggle.tsx
init_define_process_env();
import React84, { useEffect as useEffect27 } from "react";
import { QuizActiveIcon as QuizActiveIcon2, QuizIcon as QuizIcon2 } from "@100mslive/react-icons";
var PollsToggle = () => {
  const isPollsOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.POLLS);
  const togglePollView = usePollViewToggle();
  const { unreadPollQuiz, setUnreadPollQuiz } = useUnreadPollQuizPresent();
  useEffect27(() => {
    if (unreadPollQuiz && isPollsOpen) {
      setUnreadPollQuiz(false);
    }
  }, [isPollsOpen, unreadPollQuiz, setUnreadPollQuiz]);
  return /* @__PURE__ */ React84.createElement(Tooltip, { key: "polls", title: `${isPollsOpen ? "Close" : "Open"} polls and quizzes` }, /* @__PURE__ */ React84.createElement(
    IconButton_default,
    {
      onClick: () => {
        togglePollView();
        setUnreadPollQuiz(false);
      },
      css: { bg: isPollsOpen ? "$surface_brighter" : "" },
      "data-testid": "polls_btn"
    },
    unreadPollQuiz ? /* @__PURE__ */ React84.createElement(QuizActiveIcon2, null) : /* @__PURE__ */ React84.createElement(QuizIcon2, null)
  ));
};

// src/Prebuilt/components/Footer/WhiteboardToggle.tsx
init_define_process_env();
import React85, { useState as useState37 } from "react";
import { selectPeerScreenSharing, useHMSStore as useHMSStore45, useWhiteboard } from "@100mslive/react-sdk";
import { PencilDrawIcon } from "@100mslive/react-icons";
var WhiteboardToggle = () => {
  const { toggle, open, isOwner } = useWhiteboard();
  const peerSharing = useHMSStore45(selectPeerScreenSharing);
  const disabled = !!peerSharing || open && !isOwner;
  const [isLoading, setLoading] = useState37(false);
  if (!toggle) {
    return null;
  }
  return /* @__PURE__ */ React85.createElement(
    Tooltip,
    {
      key: "whiteboard",
      title: peerSharing ? "Cannot open whiteboard when viewing a shared screen" : `${open ? "Close" : "Open"} Whiteboard`
    },
    /* @__PURE__ */ React85.createElement(
      IconButton_default,
      {
        onClick: () => __async(void 0, null, function* () {
          if (disabled || isLoading) {
            return;
          }
          try {
            if (!open) {
              setLoading(true);
              yield toggle();
              setTimeout(() => setLoading(false), 500);
            } else {
              yield toggle();
            }
          } catch (error) {
            ToastManager.addToast({ title: error.message, variant: "error" });
          }
        }),
        active: !open,
        disabled: disabled || isLoading,
        "data-testid": "whiteboard_btn"
      },
      /* @__PURE__ */ React85.createElement(PencilDrawIcon, null)
    )
  );
};

// src/Prebuilt/components/Footer/Footer.tsx
var Footer2 = ({
  screenType,
  elements
}) => {
  var _a8, _b7;
  const isMobile = useMedia15(config.media.md);
  const isOverlayChat = !!((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.is_overlay);
  const openByDefault = ((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.initial_state) === Chat_ChatState.CHAT_STATE_OPEN;
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  const { showPolls } = useShowPolls();
  useEffect28(() => {
    if (!isChatOpen && openByDefault) {
      toggleChat();
    }
  }, [toggleChat, openByDefault]);
  return /* @__PURE__ */ React86.createElement(
    Footer.Root,
    {
      css: {
        flexWrap: "nowrap",
        "@md": {
          justifyContent: "center",
          gap: "$10",
          position: "relative",
          // To prevent it from showing over the sidepane if chat type is not overlay
          zIndex: isOverlayChat && isChatOpen ? 20 : 1
        }
      }
    },
    /* @__PURE__ */ React86.createElement(
      Footer.Left,
      {
        css: {
          "@md": {
            w: "unset",
            p: "0",
            gap: "$10"
          }
        }
      },
      isMobile ? /* @__PURE__ */ React86.createElement(LeaveRoom, { screenType }) : null,
      /* @__PURE__ */ React86.createElement(AudioVideoToggle, null),
      !isMobile && elements.virtual_background ? /* @__PURE__ */ React86.createElement(VBToggle, null) : null
    ),
    /* @__PURE__ */ React86.createElement(
      Footer.Center,
      {
        css: {
          "@md": {
            w: "unset",
            gap: "$10"
          }
        }
      },
      isMobile ? /* @__PURE__ */ React86.createElement(React86.Fragment, null, /* @__PURE__ */ React86.createElement(ScreenshareToggle, null), /* @__PURE__ */ React86.createElement(RaiseHand, null), (elements == null ? void 0 : elements.chat) && /* @__PURE__ */ React86.createElement(ChatToggle, null), /* @__PURE__ */ React86.createElement(MoreSettings, { elements, screenType })) : /* @__PURE__ */ React86.createElement(React86.Fragment, null, /* @__PURE__ */ React86.createElement(ScreenshareToggle, null), /* @__PURE__ */ React86.createElement(RaiseHand, null), screenType !== "hls_live_streaming" && /* @__PURE__ */ React86.createElement(CaptionIcon, null), (elements == null ? void 0 : elements.emoji_reactions) && /* @__PURE__ */ React86.createElement(EmojiReaction, null), /* @__PURE__ */ React86.createElement(LeaveRoom, { screenType }))
    ),
    /* @__PURE__ */ React86.createElement(Footer.Right, null, /* @__PURE__ */ React86.createElement(WhiteboardToggle, null), showPolls && /* @__PURE__ */ React86.createElement(PollsToggle, null), !isMobile && (elements == null ? void 0 : elements.chat) && /* @__PURE__ */ React86.createElement(ChatToggle, null), (elements == null ? void 0 : elements.participant_list) && /* @__PURE__ */ React86.createElement(ParticipantCount, null), /* @__PURE__ */ React86.createElement(MoreSettings, { elements, screenType }))
  );
};

// src/Prebuilt/components/Notifications/HLSFailureModal.tsx
init_define_process_env();
import React87, { useCallback as useCallback25, useState as useState38 } from "react";
import { selectHLSState as selectHLSState5, useHMSActions as useHMSActions33, useHMSStore as useHMSStore46, useRecordingStreaming as useRecordingStreaming8 } from "@100mslive/react-sdk";
function HLSFailureModal() {
  const hlsError = useHMSStore46(selectHLSState5).error || false;
  const [openModal, setOpenModal] = useState38(!!hlsError);
  const hmsActions = useHMSActions33();
  const { isRTMPRunning } = useRecordingStreaming8();
  const [isHLSStarted, setHLSStarted] = useSetAppDataByKey(APP_DATA.hlsStarted);
  const startHLS = useCallback25(() => __async(this, null, function* () {
    try {
      if (isHLSStarted || isRTMPRunning) {
        return;
      }
      setHLSStarted(true);
      yield hmsActions.startHLSStreaming({});
    } catch (error) {
      console.error(error);
      setHLSStarted(false);
    }
  }), [hmsActions, isHLSStarted, setHLSStarted, isRTMPRunning]);
  return hlsError ? /* @__PURE__ */ React87.createElement(
    Dialog.Root,
    {
      open: openModal,
      onOpenChange: (value) => {
        if (!value) {
          setOpenModal(false);
        }
      }
    },
    /* @__PURE__ */ React87.createElement(Dialog.Portal, null, /* @__PURE__ */ React87.createElement(Dialog.Overlay, null), /* @__PURE__ */ React87.createElement(Dialog.Content, { css: { w: "min(360px, 90%)" } }, /* @__PURE__ */ React87.createElement(
      Dialog.Title,
      {
        css: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid $border_default",
          mt: "$4"
        }
      },
      /* @__PURE__ */ React87.createElement(Text, { variant: "h6", css: { fontWeight: "$semiBold" } }, "Failed to Go Live")
    ), /* @__PURE__ */ React87.createElement(Text, { variant: "sm", css: { mb: "$10", color: "$on_surface_medium" } }, "Something went wrong and your live broadcast failed. Please try again."), /* @__PURE__ */ React87.createElement(Flex, { align: "center", justify: "between", css: { w: "100%", gap: "$8" } }, /* @__PURE__ */ React87.createElement(Button, { outlined: true, variant: "standard", css: { w: "100%" }, onClick: () => setOpenModal(false) }, "Dismiss"), /* @__PURE__ */ React87.createElement(Button, { css: { w: "100%" }, onClick: startHLS }, "Go Live"))))
  ) : null;
}

// src/Prebuilt/components/RoleChangeRequest/RoleChangeRequestModal.tsx
init_define_process_env();
import React138, { useEffect as useEffect44 } from "react";
import {
  selectIsInPreview,
  selectLocalPeerName as selectLocalPeerName4,
  selectLocalPeerRoleName as selectLocalPeerRoleName4,
  selectRoleChangeRequest,
  useCustomEvent as useCustomEvent3,
  useHMSActions as useHMSActions46,
  useHMSStore as useHMSStore72
} from "@100mslive/react-sdk";

// src/Prebuilt/components/Preview/PreviewJoin.tsx
init_define_process_env();
import React136, { Fragment as Fragment12, useCallback as useCallback33, useEffect as useEffect43, useMemo as useMemo15, useState as useState58 } from "react";
import { useMeasure as useMeasure4, useMedia as useMedia27 } from "react-use";
import {
  HMSRoomState as HMSRoomState7,
  selectAppData as selectAppData9,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled7,
  selectIsVBEnabled as selectIsVBEnabled2,
  selectLocalPeer as selectLocalPeer9,
  selectRoomState as selectRoomState7,
  selectVideoTrackByID as selectVideoTrackByID5,
  useAVToggle as useAVToggle4,
  useAwayNotifications as useAwayNotifications2,
  useHMSStore as useHMSStore71,
  useParticipants as useParticipants2,
  usePreviewJoin,
  useRecordingStreaming as useRecordingStreaming11
} from "@100mslive/react-sdk";
import { MicOffIcon as MicOffIcon7, SettingsIcon as SettingsIcon6 } from "@100mslive/react-icons";

// src/Prebuilt/layouts/SidePane.tsx
init_define_process_env();
import React132, { useEffect as useEffect42 } from "react";
import { useMedia as useMedia25 } from "react-use";
import { match as match12 } from "ts-pattern";
import { selectAppData as selectAppData8, selectVideoTrackByPeerID as selectVideoTrackByPeerID4, useHMSStore as useHMSStore70 } from "@100mslive/react-sdk";

// src/Prebuilt/components/Polls/Polls.tsx
init_define_process_env();
import React109 from "react";

// src/Prebuilt/components/Polls/CreatePollQuiz/PollsQuizMenu.tsx
init_define_process_env();
import React90, { useEffect as useEffect29, useMemo as useMemo9, useRef as useRef20, useState as useState39 } from "react";
import {
  selectLocalPeerRoleName as selectLocalPeerRoleName2,
  selectPermissions as selectPermissions16,
  selectPolls as selectPolls2,
  useHMSActions as useHMSActions34,
  useHMSStore as useHMSStore48
} from "@100mslive/react-sdk";
import { QuestionIcon, StatsIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Streaming/Common.jsx
init_define_process_env();
import React88 from "react";
import { selectPermissions as selectPermissions15, useHMSStore as useHMSStore47 } from "@100mslive/react-sdk";
import { ChevronLeftIcon as ChevronLeftIcon3, ChevronRightIcon as ChevronRightIcon2, CrossIcon as CrossIcon16, RecordIcon as RecordIcon3 } from "@100mslive/react-icons";
var ContentHeader = ({ onBack, onClose, title = "", content }) => {
  return /* @__PURE__ */ React88.createElement(
    Flex,
    {
      css: { w: "100%", py: "$8", px: "$10", cursor: "pointer", borderBottom: "1px solid $border_bright", mb: "$8" }
    },
    onBack ? /* @__PURE__ */ React88.createElement(
      Flex,
      {
        align: "center",
        css: {
          mr: "$8",
          color: "$on_surface_high"
        },
        onClick: onBack,
        "data-testid": "go_back"
      },
      /* @__PURE__ */ React88.createElement(ChevronLeftIcon3, null)
    ) : null,
    /* @__PURE__ */ React88.createElement(Box, { css: { flex: "1 1 0", display: "flex", alignItems: "center" } }, title ? /* @__PURE__ */ React88.createElement(
      Text,
      {
        variant: "tiny",
        css: {
          textTransform: "uppercase",
          fontWeight: "$semiBold",
          color: "$on_surface_medium"
        }
      },
      title
    ) : null, /* @__PURE__ */ React88.createElement(Text, { variant: "h6" }, content)),
    onClose ? /* @__PURE__ */ React88.createElement(IconButton, { onClick: onClose, css: { alignSelf: "flex-start" }, "data-testid": "close_stream_section" }, /* @__PURE__ */ React88.createElement(CrossIcon16, null)) : null
  );
};
var Container3 = ({ children, rounded = false }) => {
  return /* @__PURE__ */ React88.createElement(
    Box,
    {
      css: {
        size: "100%",
        zIndex: 2,
        position: "absolute",
        top: 0,
        left: 0,
        bg: "$surface_dim",
        transform: "translateX(10%)",
        animation: `${slideLeftAndFade("10%")} 100ms ease-out forwards`,
        display: "flex",
        flexDirection: "column",
        borderRadius: rounded ? "$2" : "0"
      }
    },
    children
  );
};
var ErrorText = ({ error }) => {
  if (!error) {
    return null;
  }
  return /* @__PURE__ */ React88.createElement(Text, { variant: "sm", css: { my: "$4", color: "$alert_error_default" } }, error);
};

// src/Prebuilt/components/Polls/common/StatusIndicator.tsx
init_define_process_env();
import React89 from "react";
var statusMap = {
  created: "DRAFT" /* DRAFT */,
  started: "LIVE" /* LIVE */,
  stopped: "ENDED" /* ENDED */
};
var StatusIndicator = ({ status }) => {
  if (!status)
    return null;
  return /* @__PURE__ */ React89.createElement(Flex, { align: "center" }, /* @__PURE__ */ React89.createElement(
    Flex,
    {
      css: {
        backgroundColor: statusMap[status] === "LIVE" /* LIVE */ ? "$alert_error_default" : "$secondary_default",
        p: "$2 $4",
        borderRadius: "$0"
      }
    },
    /* @__PURE__ */ React89.createElement(
      Text,
      {
        variant: "caption",
        css: {
          fontWeight: "$semiBold",
          color: "$on_primary_high"
        }
      },
      statusMap[status]
    )
  ));
};

// src/Prebuilt/components/Polls/CreatePollQuiz/PollsQuizMenu.tsx
var PollsQuizMenu = () => {
  const togglePollView = usePollViewToggle();
  const permissions = useHMSStore48(selectPermissions16);
  return /* @__PURE__ */ React90.createElement(Container3, { rounded: true }, /* @__PURE__ */ React90.createElement(ContentHeader, { content: "Polls and Quizzes", onClose: togglePollView }), /* @__PURE__ */ React90.createElement(Flex, { direction: "column", css: { px: "$10", pb: "$10", overflowY: "auto" } }, (permissions == null ? void 0 : permissions.pollWrite) && /* @__PURE__ */ React90.createElement(AddMenu, null), /* @__PURE__ */ React90.createElement(PrevMenu, null)));
};
function InteractionSelectionCard({
  title,
  icon,
  active,
  onClick
}) {
  const activeBorderStyle = active ? "$space$px solid $primary_default" : "$space$px solid $border_bright";
  return /* @__PURE__ */ React90.createElement(
    Flex,
    {
      onClick,
      css: {
        border: activeBorderStyle,
        p: "$4",
        r: "$2",
        w: "100%",
        cursor: "pointer"
      },
      align: "center"
    },
    /* @__PURE__ */ React90.createElement(
      Flex,
      {
        css: {
          border: activeBorderStyle,
          p: "$4",
          bg: "$surface_bright",
          c: "$on_surface_high",
          r: "$0"
        }
      },
      icon
    ),
    /* @__PURE__ */ React90.createElement(Text, { variant: "sub1", css: { ml: "$md" } }, title)
  );
}
var AddMenu = () => {
  const actions = useHMSActions34();
  const [title, setTitle] = useState39("");
  const localPeerRoleName = useHMSStore48(selectLocalPeerRoleName2);
  const [hideVoteCount, setHideVoteCount] = useState39(false);
  const [error, setError] = useState39();
  const [titleError, setTitleError] = useState39("");
  const { setPollState } = usePollViewState();
  const [interactionType, setInteractionType] = useState39("Poll" /* POLL */);
  const inputRef = useRef20(null);
  useEffect29(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [interactionType]);
  const handleCreate = (id) => {
    setPollState({
      [POLL_STATE.pollInView]: id,
      [POLL_STATE.view]: POLL_VIEWS.CREATE_QUESTIONS
    });
  };
  const validateTitle = useMemo9(() => {
    if (!isValidTextInput(title)) {
      if (title) {
        setTitleError("The title should have between 2-100 characters");
      }
      return true;
    } else {
      setTitleError("");
      return false;
    }
  }, [title]);
  return /* @__PURE__ */ React90.createElement(React90.Fragment, null, /* @__PURE__ */ React90.createElement(Text, { variant: "caption", css: { c: "$on_surface_medium", mb: "$md" } }, "Select the type you want to continue with"), /* @__PURE__ */ React90.createElement(Flex, { css: { w: "100%", gap: "$10", mb: "$md" } }, /* @__PURE__ */ React90.createElement(
    InteractionSelectionCard,
    {
      title: "Poll" /* POLL */,
      icon: /* @__PURE__ */ React90.createElement(StatsIcon, { width: 32, height: 32 }),
      onClick: () => setInteractionType("Poll" /* POLL */),
      active: interactionType === "Poll" /* POLL */
    }
  ), /* @__PURE__ */ React90.createElement(
    InteractionSelectionCard,
    {
      title: "Quiz" /* QUIZ */,
      icon: /* @__PURE__ */ React90.createElement(QuestionIcon, { width: 32, height: 32 }),
      onClick: () => setInteractionType("Quiz" /* QUIZ */),
      active: interactionType === "Quiz" /* QUIZ */
    }
  )), /* @__PURE__ */ React90.createElement(Flex, { direction: "column", css: { mb: "$10" } }, /* @__PURE__ */ React90.createElement(Text, { variant: "body2", css: { mb: "$4" } }, `Name this ${interactionType.toLowerCase()}`), /* @__PURE__ */ React90.createElement(
    Input,
    {
      ref: inputRef,
      type: "text",
      placeholder: "Enter a name to continue",
      value: title,
      onChange: (event) => setTitle(event.target.value.trimStart()),
      css: {
        backgroundColor: "$surface_bright",
        border: "1px solid $border_default"
      }
    }
  ), /* @__PURE__ */ React90.createElement(Flex, { align: "center", css: { mt: "$10" } }, /* @__PURE__ */ React90.createElement(Switch, { onCheckedChange: (value) => setHideVoteCount(value), css: { mr: "$6" } }), /* @__PURE__ */ React90.createElement(Text, { variant: "body2", css: { c: "$on_surface_medium" } }, "Hide Vote Count")), /* @__PURE__ */ React90.createElement(
    Button,
    {
      variant: "primary",
      disabled: validateTitle,
      css: { mt: "$10" },
      onClick: () => __async(void 0, null, function* () {
        const id = Date.now().toString();
        yield actions.interactivityCenter.createPoll({
          id,
          title,
          anonymous: false,
          rolesThatCanViewResponses: hideVoteCount && localPeerRoleName ? [localPeerRoleName] : void 0,
          // @ts-ignore
          type: interactionType.toLowerCase()
        }).then(() => handleCreate(id)).catch((err) => setError(err.message));
      })
    },
    "Create ",
    interactionType
  ), /* @__PURE__ */ React90.createElement(ErrorText, { error: error || titleError })));
};
var PrevMenu = () => {
  const hmsActions = useHMSActions34();
  const polls = useHMSStore48(selectPolls2);
  const sortedPolls = useMemo9(
    () => {
      var _a8;
      return (_a8 = polls == null ? void 0 : polls.sort((a2, b2) => {
        var _a9, _b7, _c, _d;
        return (((_b7 = (_a9 = b2 == null ? void 0 : b2.createdAt) == null ? void 0 : _a9.getTime) == null ? void 0 : _b7.call(_a9)) || 0) - (((_d = (_c = a2 == null ? void 0 : a2.createdAt) == null ? void 0 : _c.getTime) == null ? void 0 : _d.call(_c)) || 0);
      })) == null ? void 0 : _a8.sort((a2, b2) => ((b2 == null ? void 0 : b2.state) === "started" ? 1 : 0) - ((a2 == null ? void 0 : a2.state) === "started" ? 1 : 0));
    },
    [polls]
  );
  const permissions = useHMSStore48(selectPermissions16);
  useEffect29(() => {
    const updatePolls = () => __async(void 0, null, function* () {
      yield hmsActions.interactivityCenter.getPolls();
    });
    updatePolls();
  }, [hmsActions.interactivityCenter]);
  return (polls == null ? void 0 : polls.length) ? /* @__PURE__ */ React90.createElement(
    Flex,
    {
      direction: "column",
      css: __spreadValues({
        width: "100%"
      }, (permissions == null ? void 0 : permissions.pollWrite) ? { borderTop: "$space$px solid $border_bright", paddingTop: "$10" } : {})
    },
    /* @__PURE__ */ React90.createElement(Text, { variant: "h6", css: { c: "$on_surface_high" } }, "Previous Polls and Quizzes"),
    /* @__PURE__ */ React90.createElement(Flex, { direction: "column", css: { gap: "$10", mt: "$8" } }, sortedPolls == null ? void 0 : sortedPolls.map((poll) => /* @__PURE__ */ React90.createElement(InteractionCard, { key: poll.id, id: poll.id, title: poll.title, status: poll.state })))
  ) : null;
};
var InteractionCard = ({ id, title, status }) => {
  const { setPollState } = usePollViewState();
  return /* @__PURE__ */ React90.createElement(Flex, { direction: "column", css: { backgroundColor: "$surface_bright", borderRadius: "$1", p: "$8" } }, /* @__PURE__ */ React90.createElement(Flex, { css: { w: "100%", justifyContent: "space-between", mb: "$sm" } }, /* @__PURE__ */ React90.createElement(Text, { variant: "sub1", css: { c: "$on_surface_high", fontWeight: "$semiBold" } }, title), /* @__PURE__ */ React90.createElement(StatusIndicator, { status })), /* @__PURE__ */ React90.createElement(Flex, { css: { w: "100%", gap: "$4" }, justify: "end" }, /* @__PURE__ */ React90.createElement(
    Button,
    {
      variant: "primary",
      onClick: () => setPollState({
        [POLL_STATE.pollInView]: id,
        [POLL_STATE.view]: status === "created" ? POLL_VIEWS.CREATE_QUESTIONS : POLL_VIEWS.VOTE
      })
    },
    "View"
  )));
};

// src/Prebuilt/components/Polls/CreateQuestions/CreateQuestions.jsx
init_define_process_env();
import React100, { useMemo as useMemo11, useState as useState41 } from "react";
import { v4 as uuid2 } from "uuid";
import { selectPollByID, useHMSActions as useHMSActions35, useHMSStore as useHMSStore49, useRecordingStreaming as useRecordingStreaming9 } from "@100mslive/react-sdk";
import { AddCircleIcon as AddCircleIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/Polls/CreateQuestions/QuestionForm.tsx
init_define_process_env();
import React98, { useCallback as useCallback26, useRef as useRef21, useState as useState40 } from "react";
import { AddCircleIcon, TrashIcon as TrashIcon3 } from "@100mslive/react-icons";

// src/Prebuilt/components/Polls/CreateQuestions/DeleteQuestionModal.tsx
init_define_process_env();
import React91 from "react";
import { AlertTriangleIcon as AlertTriangleIcon7, CrossIcon as CrossIcon17 } from "@100mslive/react-icons";
var DeleteQuestionModal = ({
  open,
  setOpen,
  removeQuestion
}) => {
  return /* @__PURE__ */ React91.createElement(Dialog.Root, { open }, /* @__PURE__ */ React91.createElement(Dialog.Overlay, null), /* @__PURE__ */ React91.createElement(Dialog.Portal, null, /* @__PURE__ */ React91.createElement(Dialog.Content, { css: { p: "$10" } }, /* @__PURE__ */ React91.createElement(Box, null, /* @__PURE__ */ React91.createElement(
    Flex,
    {
      css: {
        color: "$alert_error_default",
        display: "flex",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React91.createElement(AlertTriangleIcon7, { style: { marginRight: "0.5rem" } }),
    /* @__PURE__ */ React91.createElement(Text, { variant: "lg", css: { color: "inherit", fontWeight: "$semiBold" } }, "Delete Question?"),
    /* @__PURE__ */ React91.createElement(
      Box,
      {
        css: {
          ml: "auto",
          color: "$on_surface_medium",
          "&:hover": { color: "$on_surface_high", cursor: "pointer" }
        },
        onClick: () => setOpen(false)
      },
      /* @__PURE__ */ React91.createElement(CrossIcon17, null)
    )
  ), /* @__PURE__ */ React91.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", mb: "$8", mt: "$4" } }, "The question will be deleted. You can't undo this action."), /* @__PURE__ */ React91.createElement(Flex, { css: { w: "100%", mt: "$12", gap: "$md" } }, /* @__PURE__ */ React91.createElement(
    Button,
    {
      variant: "standard",
      outlined: true,
      onClick: () => setOpen(false),
      css: { w: "100%", fontSize: "$md", fontWeight: "$semiBold" }
    },
    "Cancel"
  ), /* @__PURE__ */ React91.createElement(
    Button,
    {
      css: { w: "100%", fontSize: "$md", fontWeight: "$semiBold" },
      variant: "danger",
      onClick: () => {
        removeQuestion();
        setOpen(false);
      }
    },
    "Delete"
  ))))));
};

// src/Prebuilt/components/Polls/common/Line.tsx
init_define_process_env();
import React92 from "react";
var Line = () => /* @__PURE__ */ React92.createElement(Flex, { css: { w: "100%", borderBottom: "1px solid $border_bright", h: "1px", my: "$8" } });

// src/Prebuilt/components/Polls/common/MultipleChoiceOptions.jsx
init_define_process_env();
import React96 from "react";
import { CheckCircleIcon, CheckIcon as CheckIcon5 } from "@100mslive/react-icons";

// src/Prebuilt/components/Polls/common/OptionInputWithDelete.tsx
init_define_process_env();
import React93 from "react";
import { TrashIcon as TrashIcon2 } from "@100mslive/react-icons";
var OptionInputWithDelete = ({
  index,
  option,
  handleOptionTextChange,
  removeOption
}) => {
  return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(
    Input,
    {
      placeholder: `Option ${index + 1}`,
      css: {
        w: "100%",
        backgroundColor: "$surface_bright",
        border: "1px solid $border_bright"
      },
      value: (option == null ? void 0 : option.text) || "",
      key: index,
      onChange: (event) => handleOptionTextChange(index, event.target.value.trimStart()),
      maxLength: 250
    }
  ), /* @__PURE__ */ React93.createElement(IconButton_default, { onClick: () => removeOption(index), css: { bg: "transparent", border: "none" } }, /* @__PURE__ */ React93.createElement(TrashIcon2, null)));
};

// src/Prebuilt/components/Polls/common/VoteCount.tsx
init_define_process_env();
import React94 from "react";
var VoteCount = ({ voteCount }) => {
  return /* @__PURE__ */ React94.createElement(Flex, { css: { alignItems: "center" } }, voteCount ? /* @__PURE__ */ React94.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium" } }, voteCount, "\xA0", voteCount === 1 ? "vote" : "votes") : null);
};

// src/Prebuilt/components/Polls/common/VoteProgress.tsx
init_define_process_env();
import React95 from "react";
var VoteProgress = ({ option, totalResponses }) => {
  const showProgress = typeof option.voteCount === "number" && typeof totalResponses === "number" && totalResponses > 0;
  const progressValue = 100 * (option.voteCount || 0) / totalResponses;
  return showProgress ? /* @__PURE__ */ React95.createElement(Progress.Root, { value: progressValue, css: { mt: "$4" } }, /* @__PURE__ */ React95.createElement(
    Progress.Content,
    {
      style: {
        transform: `translateX(-${100 - progressValue}%)`
      }
    }
  )) : null;
};

// src/Prebuilt/components/Polls/common/MultipleChoiceOptions.jsx
var MultipleChoiceOptions = ({
  questionIndex,
  options,
  canRespond,
  totalResponses,
  selectedOptions,
  setSelectedOptions,
  showVoteCount,
  isQuiz,
  correctOptionIndexes,
  localPeerResponse,
  isStopped
}) => {
  const handleCheckedChange = (checked, index) => {
    const newSelected = new Set(selectedOptions);
    if (checked) {
      newSelected.add(index);
    } else {
      newSelected.delete(index);
    }
    setSelectedOptions(newSelected);
  };
  return /* @__PURE__ */ React96.createElement(Flex, { direction: "column", css: { gap: "$md", w: "100%", mb: "$md" } }, options.map((option) => {
    var _a8;
    return /* @__PURE__ */ React96.createElement(Flex, { align: "center", key: `${questionIndex}-${option.index}`, css: { w: "100%", gap: "$4" } }, !isStopped || !isQuiz ? /* @__PURE__ */ React96.createElement(
      Checkbox.Root,
      {
        id: `${questionIndex}-${option.index}`,
        disabled: !canRespond,
        checked: (_a8 = localPeerResponse == null ? void 0 : localPeerResponse.options) == null ? void 0 : _a8.includes(option.index),
        onCheckedChange: (checked) => handleCheckedChange(checked, option.index),
        css: {
          cursor: canRespond ? "pointer" : "not-allowed",
          flexShrink: 0
        }
      },
      /* @__PURE__ */ React96.createElement(Checkbox.Indicator, null, /* @__PURE__ */ React96.createElement(CheckIcon5, { width: 16, height: 16 }))
    ) : null, isStopped && (correctOptionIndexes == null ? void 0 : correctOptionIndexes.includes(option.index)) ? /* @__PURE__ */ React96.createElement(Flex, { align: "center", css: { color: "$on_surface_high" } }, /* @__PURE__ */ React96.createElement(CheckCircleIcon, { height: 20, width: 20 })) : null, /* @__PURE__ */ React96.createElement(Flex, { direction: "column", css: { flexGrow: "1" } }, /* @__PURE__ */ React96.createElement(Flex, { css: { w: "100%" } }, /* @__PURE__ */ React96.createElement(Text, { css: { display: "flex", flexGrow: "1" } }, /* @__PURE__ */ React96.createElement(Label3, { htmlFor: `${questionIndex}-${option.index}`, css: { color: "inherit" } }, option.text)), showVoteCount && /* @__PURE__ */ React96.createElement(VoteCount, { voteCount: option.voteCount })), showVoteCount && /* @__PURE__ */ React96.createElement(VoteProgress, { option, totalResponses })), isStopped && isQuiz && (localPeerResponse == null ? void 0 : localPeerResponse.options.includes(option.index)) ? /* @__PURE__ */ React96.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", maxWidth: "max-content" } }, "Your Answer") : null);
  }));
};
var MultipleChoiceOptionInputs = ({ isQuiz, options, selectAnswer, handleOptionTextChange, removeOption }) => {
  return /* @__PURE__ */ React96.createElement(Flex, { direction: "column", css: { gap: "$md", w: "100%", mb: "$md" } }, options.map((option, index) => {
    return /* @__PURE__ */ React96.createElement(Flex, { align: "center", key: index, css: { w: "100%", gap: "$4" } }, isQuiz && /* @__PURE__ */ React96.createElement(
      Checkbox.Root,
      {
        onCheckedChange: (checked) => selectAnswer(checked, index),
        checked: option.isCorrectAnswer,
        css: {
          cursor: "pointer",
          width: "$9"
        }
      },
      /* @__PURE__ */ React96.createElement(Checkbox.Indicator, null, /* @__PURE__ */ React96.createElement(CheckIcon5, { width: 16, height: 16 }))
    ), /* @__PURE__ */ React96.createElement(
      OptionInputWithDelete,
      {
        index,
        option,
        handleOptionTextChange,
        removeOption
      }
    ));
  }));
};

// src/Prebuilt/components/Polls/common/SingleChoiceOptions.jsx
init_define_process_env();
import React97 from "react";
import { CheckCircleIcon as CheckCircleIcon2 } from "@100mslive/react-icons";
var SingleChoiceOptions = ({
  questionIndex,
  options,
  canRespond,
  setAnswer,
  totalResponses,
  showVoteCount,
  correctOptionIndex,
  isStopped,
  isQuiz,
  localPeerResponse
}) => {
  return /* @__PURE__ */ React97.createElement(RadioGroup.Root, { value: localPeerResponse == null ? void 0 : localPeerResponse.option, onValueChange: (value) => setAnswer(value) }, /* @__PURE__ */ React97.createElement(Flex, { direction: "column", css: { gap: "$md", w: "100%", mb: "$md" } }, options.map((option) => {
    return /* @__PURE__ */ React97.createElement(Flex, { align: "center", key: `${questionIndex}-${option.index}`, css: { w: "100%", gap: "$4" } }, !isStopped || !isQuiz ? /* @__PURE__ */ React97.createElement(
      RadioGroup.Item,
      {
        css: {
          background: "none",
          h: "$9",
          w: "$9",
          border: "2px solid",
          borderColor: "$on_surface_high",
          display: "flex",
          flexShrink: 0,
          pt: "$1",
          justifyContent: "center",
          alignItems: "center",
          cursor: canRespond ? "pointer" : "not-allowed",
          '&[data-state="checked"]': {
            borderColor: "$primary_bright",
            borderWidth: "2px"
          }
        },
        disabled: !canRespond,
        value: option.index,
        id: `${questionIndex}-${option.index}`
      },
      /* @__PURE__ */ React97.createElement(
        RadioGroup.Indicator,
        {
          css: {
            h: "80%",
            w: "80%",
            background: "$primary_bright",
            borderRadius: "$round"
          }
        }
      )
    ) : null, isStopped && correctOptionIndex === option.index && isQuiz ? /* @__PURE__ */ React97.createElement(Flex, { css: { color: "$on_surface_high" } }, /* @__PURE__ */ React97.createElement(CheckCircleIcon2, { height: 20, width: 20 })) : null, /* @__PURE__ */ React97.createElement(Flex, { direction: "column", css: { flexGrow: "1" } }, /* @__PURE__ */ React97.createElement(Flex, { css: { w: "100%" } }, /* @__PURE__ */ React97.createElement(Text, { css: { display: "flex", flexGrow: "1", color: "$on_surface_high" } }, /* @__PURE__ */ React97.createElement(Label3, { style: { color: "inherit" }, htmlFor: `${questionIndex}-${option.index}` }, option.text)), showVoteCount && /* @__PURE__ */ React97.createElement(VoteCount, { voteCount: option.voteCount })), showVoteCount && /* @__PURE__ */ React97.createElement(VoteProgress, { option, totalResponses })), isStopped && isQuiz && (localPeerResponse == null ? void 0 : localPeerResponse.option) === option.index ? /* @__PURE__ */ React97.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", maxWidth: "max-content" } }, "Your Answer") : null);
  })));
};
var SingleChoiceOptionInputs = ({ isQuiz, options, selectAnswer, handleOptionTextChange, removeOption }) => {
  const correctOptionIndex = options.findIndex((option) => option.isCorrectAnswer);
  return /* @__PURE__ */ React97.createElement(RadioGroup.Root, { value: correctOptionIndex, onValueChange: selectAnswer }, /* @__PURE__ */ React97.createElement(Flex, { direction: "column", css: { gap: "$md", w: "100%", mb: "$md" } }, options.map((option, index) => {
    return /* @__PURE__ */ React97.createElement(Flex, { align: "center", key: `option-${index}`, css: { w: "100%", gap: "$4" } }, isQuiz && /* @__PURE__ */ React97.createElement(
      RadioGroup.Item,
      {
        css: {
          background: "none",
          w: "$9",
          border: "2px solid",
          borderColor: "$on_surface_high",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          '&[data-state="checked"]': {
            borderColor: "$primary_bright",
            borderWidth: "2px"
          }
        },
        value: index
      },
      /* @__PURE__ */ React97.createElement(
        RadioGroup.Indicator,
        {
          css: {
            h: "80%",
            w: "80%",
            background: "$primary_bright",
            borderRadius: "$round"
          }
        }
      )
    ), /* @__PURE__ */ React97.createElement(
      OptionInputWithDelete,
      {
        index,
        option,
        handleOptionTextChange,
        removeOption
      }
    ));
  })));
};

// src/Prebuilt/components/Polls/CreateQuestions/QuestionForm.tsx
var QuestionForm = ({
  question,
  index,
  length,
  onSave,
  removeQuestion,
  isQuiz
}) => {
  var _a8;
  const ref = useRef21(null);
  const selectionBg = useDropdownSelection();
  const [openDelete, setOpenDelete] = useState40(false);
  const [open, setOpen] = useState40(false);
  const [type, setType] = useState40(question.type || "single-choice" /* SINGLE_CHOICE */);
  const [text, setText] = useState40(question.text);
  const [weight, setWeight] = useState40(isQuiz ? 10 : 1);
  const [options, setOptions] = useState40(
    (question == null ? void 0 : question.options) || [
      { text: "", isCorrectAnswer: false },
      { text: "", isCorrectAnswer: false }
    ]
  );
  const isValid = isValidQuestion({
    text,
    type,
    options,
    weight,
    isQuiz
  });
  const handleOptionTextChange = useCallback26(
    (index2, text2) => {
      setOptions((options2) => [...options2.slice(0, index2), __spreadProps(__spreadValues({}, options2[index2]), { text: text2 }), ...options2.slice(index2 + 1)]);
    },
    [setOptions]
  );
  const removeOption = useCallback26(
    (index2) => setOptions((options2) => {
      const newOptions = [...options2];
      newOptions.splice(index2, 1);
      return newOptions;
    }),
    [setOptions]
  );
  const selectSingleChoiceAnswer = useCallback26(
    (answerIndex) => {
      if (!isQuiz) {
        return;
      }
      setOptions(
        (options2) => options2.map((option, index2) => __spreadProps(__spreadValues({}, option), {
          isCorrectAnswer: index2 === answerIndex
        }))
      );
    },
    [setOptions, isQuiz]
  );
  const selectMultipleChoiceAnswer = useCallback26(
    (checked, index2) => {
      if (!isQuiz) {
        return;
      }
      setOptions((options2) => [
        ...options2.slice(0, index2),
        __spreadProps(__spreadValues({}, options2[index2]), { isCorrectAnswer: checked }),
        ...options2.slice(index2 + 1)
      ]);
    },
    [setOptions, isQuiz]
  );
  return /* @__PURE__ */ React98.createElement(React98.Fragment, null, /* @__PURE__ */ React98.createElement(Text, { variant: "overline", css: { c: "$on_surface_low", textTransform: "uppercase" } }, "Question ", index + 1, " of ", length), /* @__PURE__ */ React98.createElement(Text, { variant: "body2", css: { mt: "$4", mb: "$md" } }, "Question Type"), /* @__PURE__ */ React98.createElement(Dropdown.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React98.createElement(
    DialogDropdownTrigger,
    {
      ref,
      title: QUESTION_TYPE_TITLE[type],
      css: {
        backgroundColor: "$surface_bright",
        border: "1px solid $border_bright"
      },
      open
    }
  ), /* @__PURE__ */ React98.createElement(Dropdown.Portal, null, /* @__PURE__ */ React98.createElement(Dropdown.Content, { align: "start", sideOffset: 8, css: { w: (_a8 = ref.current) == null ? void 0 : _a8.clientWidth, zIndex: 1e3 } }, Object.keys(QUESTION_TYPE_TITLE).map((value) => {
    return /* @__PURE__ */ React98.createElement(
      Dropdown.Item,
      {
        key: value,
        onSelect: () => setType(value),
        css: {
          px: "$9",
          bg: type === value ? selectionBg : void 0
        }
      },
      QUESTION_TYPE_TITLE[value]
    );
  })))), /* @__PURE__ */ React98.createElement(
    TextArea,
    {
      maxLength: 1024,
      placeholder: "Ask a question",
      css: {
        mt: "$md",
        backgroundColor: "$surface_bright",
        border: "1px solid $border_bright",
        minHeight: "$14",
        resize: "vertical",
        maxHeight: "$32"
      },
      value: text,
      onChange: (event) => setText(event.target.value.trimStart())
    }
  ), /* @__PURE__ */ React98.createElement(Text, { variant: "xs", css: { color: "$on_surface_medium", textAlign: "end", mt: "$4" } }, (text == null ? void 0 : text.length) || 0, "/1024"), /* @__PURE__ */ React98.createElement(Line, null), type === "single-choice" /* SINGLE_CHOICE */ || type === "multiple-choice" /* MULTIPLE_CHOICE */ ? /* @__PURE__ */ React98.createElement(React98.Fragment, null, /* @__PURE__ */ React98.createElement(Text, { variant: "body2", css: { mb: "$6", c: "$on_surface_medium" } }, "Options"), isQuiz && /* @__PURE__ */ React98.createElement(Text, { variant: "xs", css: { c: "$on_surface_medium", mb: "$md" } }, type === "single-choice" /* SINGLE_CHOICE */ ? "Use the radio buttons to indicate the correct answer" : "Use the checkboxes to indicate the correct answer(s)"), type === "single-choice" /* SINGLE_CHOICE */ && /* @__PURE__ */ React98.createElement(
    SingleChoiceOptionInputs,
    {
      isQuiz,
      options,
      selectAnswer: selectSingleChoiceAnswer,
      handleOptionTextChange,
      removeOption
    }
  ), type === "multiple-choice" /* MULTIPLE_CHOICE */ && /* @__PURE__ */ React98.createElement(
    MultipleChoiceOptionInputs,
    {
      isQuiz,
      options,
      selectAnswer: selectMultipleChoiceAnswer,
      handleOptionTextChange,
      removeOption
    }
  ), (options == null ? void 0 : options.length) < 20 && /* @__PURE__ */ React98.createElement(
    Flex,
    {
      css: {
        c: "$on_surface_medium",
        cursor: "pointer",
        "&:hover": { c: "$on_surface_high" }
      },
      onClick: () => setOptions([...options, { text: "", isCorrectAnswer: false }])
    },
    /* @__PURE__ */ React98.createElement(AddCircleIcon, { style: { position: "relative", left: "-2px" } }),
    /* @__PURE__ */ React98.createElement(
      Text,
      {
        variant: "sm",
        css: {
          ml: "$4",
          c: "inherit"
        }
      },
      "Add an option"
    )
  ), /* @__PURE__ */ React98.createElement(Line, null), isQuiz ? /* @__PURE__ */ React98.createElement(React98.Fragment, null, /* @__PURE__ */ React98.createElement(Flex, { justify: "between", align: "center", css: { gap: "$6", w: "100%" } }, /* @__PURE__ */ React98.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium" } }, "Point Weightage"), /* @__PURE__ */ React98.createElement(
    Input,
    {
      type: "number",
      value: weight,
      min: 1,
      max: 999,
      onChange: (e) => setWeight(Math.min(Number(e.target.value), 999)),
      css: {
        backgroundColor: "$surface_bright",
        border: "1px solid $border_bright",
        maxWidth: "$20"
      }
    }
  ))) : null) : null, /* @__PURE__ */ React98.createElement(Flex, { justify: "end", align: "center", css: { mt: "$12", gap: "$8" } }, /* @__PURE__ */ React98.createElement(IconButton, { css: { border: "1px solid $border_bright" } }, /* @__PURE__ */ React98.createElement(TrashIcon3, { onClick: () => setOpenDelete(!open) })), /* @__PURE__ */ React98.createElement(
    Tooltip,
    {
      disabled: isValid,
      title: options.length < 2 ? "At least two options must be added" : `Please fill all the fields ${isQuiz ? "and mark the correct answer(s)" : ""} to continue`,
      boxCss: { maxWidth: "$40" }
    },
    /* @__PURE__ */ React98.createElement(
      Button,
      {
        variant: "standard",
        disabled: !isValid,
        onClick: () => {
          onSave({
            saved: true,
            text,
            type,
            options,
            skippable: false,
            draftID: question.draftID,
            weight
          });
        }
      },
      "Save"
    )
  )), /* @__PURE__ */ React98.createElement(DeleteQuestionModal, { open: openDelete, setOpen: setOpenDelete, removeQuestion }));
};
var isValidQuestion = ({
  text,
  type,
  options,
  weight,
  isQuiz = false
}) => {
  if (!isValidTextInput(text) || !type) {
    return false;
  }
  const everyOptionHasText = options.length > 1 && options.every((option) => option && isValidTextInput(option.text, 1));
  const hasCorrectAnswer = options.some((option) => option.isCorrectAnswer);
  if (!isQuiz) {
    return everyOptionHasText;
  }
  if (isQuiz && weight < 1) {
    return false;
  }
  return everyOptionHasText && hasCorrectAnswer;
};

// src/Prebuilt/components/Polls/CreateQuestions/SavedQuestion.tsx
init_define_process_env();
import React99, { useMemo as useMemo10 } from "react";
import { CheckCircleIcon as CheckCircleIcon3 } from "@100mslive/react-icons";
var SavedQuestion = ({
  question,
  index,
  length,
  convertToDraft
}) => {
  var _a8;
  const answerArray = useMemo10(() => {
    var _a9;
    const updatedAnswerArray = [];
    const { option, options } = (_a9 = question == null ? void 0 : question.answer) != null ? _a9 : {};
    if (option) {
      updatedAnswerArray.push(option);
    }
    if (options) {
      updatedAnswerArray.push(...options);
    }
    return updatedAnswerArray;
  }, [question == null ? void 0 : question.answer]);
  return /* @__PURE__ */ React99.createElement(React99.Fragment, null, /* @__PURE__ */ React99.createElement(Text, { variant: "overline", css: { c: "$on_surface_low", textTransform: "uppercase" } }, "Question ", index + 1, " of ", length, ": ", QUESTION_TYPE_TITLE[question.type]), /* @__PURE__ */ React99.createElement(Text, { variant: "body2", css: { mt: "$4", mb: "$md" } }, question.text), (_a8 = question.options) == null ? void 0 : _a8.map((option, index2) => /* @__PURE__ */ React99.createElement(Flex, { key: `${option.text}-${index2}`, css: { alignItems: "center", my: "$xs" } }, /* @__PURE__ */ React99.createElement(Text, { variant: "body2", css: { c: "$on_surface_medium" } }, option.text), (answerArray.includes(index2 + 1) || option.isCorrectAnswer) && /* @__PURE__ */ React99.createElement(Flex, { css: { color: "$alert_success", mx: "$xs" } }, /* @__PURE__ */ React99.createElement(CheckCircleIcon3, { height: 24, width: 24 })))), question.skippable ? /* @__PURE__ */ React99.createElement(Text, { variant: "sm", css: { color: "$on_surface_low", my: "$md" } }, "Not required to answer") : null, /* @__PURE__ */ React99.createElement(Flex, { justify: "end", css: { w: "100%", alignItems: "center" } }, /* @__PURE__ */ React99.createElement(Button, { variant: "standard", css: { fontWeight: "$semiBold" }, onClick: () => convertToDraft(question.draftID) }, "Edit")));
};

// src/Prebuilt/components/Polls/CreateQuestions/CreateQuestions.jsx
var getEditableFormat = (questions) => {
  const editableQuestions = questions.map((question) => {
    return __spreadProps(__spreadValues({}, question), { saved: true, draftID: uuid2() });
  });
  return editableQuestions;
};
function CreateQuestions() {
  var _a8, _b7, _c, _d;
  const actions = useHMSActions35();
  const { isHLSRunning } = useRecordingStreaming9();
  const togglePollView = usePollViewToggle();
  const { pollInView: id, setPollView } = usePollViewState();
  const interaction = useHMSStore49(selectPollByID(id));
  const [questions, setQuestions] = useState41(
    ((_a8 = interaction.questions) == null ? void 0 : _a8.length) ? getEditableFormat(interaction.questions) : [{ draftID: uuid2() }]
  );
  const isValidPoll = useMemo11(() => questions.length > 0 && questions.every(isValidQuestion), [questions]);
  const launchPoll = () => __async(this, null, function* () {
    yield actions.interactivityCenter.startPoll(id);
    yield sendTimedMetadata(id);
    setPollView(POLL_VIEWS.VOTE);
  });
  const sendTimedMetadata = (poll_id) => __async(this, null, function* () {
    if (poll_id && isHLSRunning) {
      try {
        yield actions.sendHLSTimedMetadata([
          {
            payload: `poll:${poll_id}`,
            duration: 100
          }
        ]);
      } catch (e) {
        console.error(e);
      }
    }
  });
  const headingTitle = (interaction == null ? void 0 : interaction.type) ? ((_c = (_b7 = interaction == null ? void 0 : interaction.type) == null ? void 0 : _b7[0]) == null ? void 0 : _c.toUpperCase()) + ((_d = interaction == null ? void 0 : interaction.type) == null ? void 0 : _d.slice(1)) : "Polls and Quizzes";
  const isQuiz = (interaction == null ? void 0 : interaction.type) === "quiz";
  return /* @__PURE__ */ React100.createElement(Container3, { rounded: true }, /* @__PURE__ */ React100.createElement(
    ContentHeader,
    {
      content: headingTitle,
      onClose: togglePollView,
      onBack: () => setPollView(POLL_VIEWS.CREATE_POLL_QUIZ)
    }
  ), /* @__PURE__ */ React100.createElement(Flex, { direction: "column", css: { p: "$10", overflowY: "auto" } }, /* @__PURE__ */ React100.createElement(Flex, { direction: "column" }, questions.map((question, index) => /* @__PURE__ */ React100.createElement(
    QuestionCard,
    {
      key: question.draftID,
      question,
      index,
      length: questions.length,
      onSave: (questionParams) => __async(this, null, function* () {
        const updatedQuestions = [...questions.slice(0, index), questionParams, ...questions.slice(index + 1)];
        setQuestions(updatedQuestions);
        const validQuestions = updatedQuestions.filter((question2) => isValidQuestion(question2));
        yield actions.interactivityCenter.addQuestionsToPoll(id, validQuestions);
      }),
      isQuiz,
      removeQuestion: (questionID) => __async(this, null, function* () {
        const updatedQuestions = questions.filter((questionFromSet) => questionID !== (questionFromSet == null ? void 0 : questionFromSet.draftID));
        setQuestions(updatedQuestions);
        const validQuestions = updatedQuestions.filter((question2) => isValidQuestion(question2));
        yield actions.interactivityCenter.addQuestionsToPoll(id, validQuestions);
      }),
      convertToDraft: (questionID) => setQuestions((prev) => {
        const copyOfQuestions = [...prev];
        copyOfQuestions.forEach((question2) => {
          if (questionID && question2.draftID === questionID) {
            question2.saved = false;
          }
        });
        return copyOfQuestions;
      })
    }
  ))), /* @__PURE__ */ React100.createElement(
    Flex,
    {
      css: {
        c: "$on_surface_low",
        my: "$sm",
        cursor: "pointer",
        "&:hover": { c: "$on_surface_medium" }
      },
      onClick: () => setQuestions([...questions, { draftID: uuid2() }])
    },
    /* @__PURE__ */ React100.createElement(AddCircleIcon2, null),
    /* @__PURE__ */ React100.createElement(Text, { variant: "body1", css: { ml: "$md", c: "$inherit" } }, "Add another question")
  ), /* @__PURE__ */ React100.createElement(Flex, { css: { w: "100%" }, justify: "end" }, /* @__PURE__ */ React100.createElement(Button, { disabled: !isValidPoll, onClick: () => __async(this, null, function* () {
    return launchPoll();
  }) }, "Launch ", interaction == null ? void 0 : interaction.type))));
}
var QuestionCard = ({ question, onSave, index, length, removeQuestion, isQuiz, convertToDraft }) => {
  return /* @__PURE__ */ React100.createElement(Flex, { direction: "column", css: { p: "$md", bg: "$surface_default", r: "$1", mb: "$sm" } }, question.saved ? /* @__PURE__ */ React100.createElement(SavedQuestion, { question, index, length, convertToDraft }) : /* @__PURE__ */ React100.createElement(
    QuestionForm,
    {
      question,
      removeQuestion: () => removeQuestion(question.draftID),
      onSave: (params) => onSave(params),
      index,
      length,
      isQuiz
    }
  ));
};

// src/Prebuilt/components/Polls/Voting/LeaderboardSummary.tsx
init_define_process_env();
import React104, { useState as useState43 } from "react";
import { selectPollByID as selectPollByID3, useHMSStore as useHMSStore52 } from "@100mslive/react-sdk";
import { ChevronLeftIcon as ChevronLeftIcon4, ChevronRightIcon as ChevronRightIcon3, CrossIcon as CrossIcon18 } from "@100mslive/react-icons";

// src/Prebuilt/components/Polls/Voting/LeaderboardEntry.tsx
init_define_process_env();
import React101 from "react";
import { CheckCircleIcon as CheckCircleIcon4, ClockIcon, TrophyFilledIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Polls/common/utils.ts
init_define_process_env();
var getFormattedTime = (milliseconds, precise = true) => {
  if (!milliseconds)
    return "-";
  const totalSeconds = milliseconds / 1e3;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  let formattedTime = "";
  if (hours) {
    formattedTime += `${hours}h `;
  }
  if (minutes || hours) {
    formattedTime += `${minutes}m `;
  }
  if (!precise && (hours || minutes)) {
    return formattedTime;
  }
  formattedTime += `${precise ? seconds.toFixed(3) : Math.floor(seconds)}s`;
  return formattedTime;
};

// src/Prebuilt/components/Polls/Voting/LeaderboardEntry.tsx
var positionColorMap = { 1: "#D69516", 2: "#3E3E3E", 3: "#583B0F" };
var LeaderboardEntry = ({
  position,
  score,
  questionCount,
  correctResponses,
  userName,
  maxPossibleScore,
  duration
}) => {
  return /* @__PURE__ */ React101.createElement(Flex, { align: "center", justify: "between", css: { my: "$8" } }, /* @__PURE__ */ React101.createElement(Flex, { align: "center", css: { gap: "$6" } }, /* @__PURE__ */ React101.createElement(
    Flex,
    {
      align: "center",
      justify: "center",
      css: {
        backgroundColor: positionColorMap[position] || "",
        h: "$10",
        w: "$10",
        borderRadius: "$round",
        color: position > 3 ? "$on_surface_low" : "#FFF",
        fontSize: "$xs",
        fontWeight: "$semiBold"
      }
    },
    position
  ), /* @__PURE__ */ React101.createElement(Box, null, /* @__PURE__ */ React101.createElement(Text, { variant: "sm", css: { fontWeight: "$semiBold", color: "$on_surface_high" } }, userName), /* @__PURE__ */ React101.createElement(Text, { variant: "sm", css: { mt: "$1" } }, score, " / ", maxPossibleScore, " points"))), /* @__PURE__ */ React101.createElement(Flex, { align: "center", css: { gap: "$4", color: "$on_surface_medium" } }, position === 1 && score ? /* @__PURE__ */ React101.createElement(TrophyFilledIcon, { height: 16, width: 16 }) : null, questionCount ? /* @__PURE__ */ React101.createElement(React101.Fragment, null, /* @__PURE__ */ React101.createElement(CheckCircleIcon4, { height: 16, width: 16 }), /* @__PURE__ */ React101.createElement(Text, { variant: "xs" }, correctResponses, "/", questionCount)) : null, duration ? /* @__PURE__ */ React101.createElement(Flex, { align: "center", css: { gap: "$2", color: "$on_surface_medium" } }, /* @__PURE__ */ React101.createElement(ClockIcon, { height: 16, width: 16 }), /* @__PURE__ */ React101.createElement(Text, { variant: "xs" }, getFormattedTime(duration))) : null));
};

// src/Prebuilt/components/Polls/Voting/PeerParticipationSummary.tsx
init_define_process_env();
import React103 from "react";
import { selectLocalPeerID as selectLocalPeerID9, useHMSStore as useHMSStore51 } from "@100mslive/react-sdk";

// src/Prebuilt/components/Polls/Voting/StatisticBox.tsx
init_define_process_env();
import React102 from "react";
var StatisticBox = ({ title, value = 0 }) => {
  if (!value && !(typeof value === "number")) {
    return /* @__PURE__ */ React102.createElement(React102.Fragment, null);
  }
  return /* @__PURE__ */ React102.createElement(Box, { css: { p: "$8", background: "$surface_default", borderRadius: "$1", w: "100%" } }, /* @__PURE__ */ React102.createElement(
    Text,
    {
      variant: "tiny",
      css: { textTransform: "uppercase", color: "$on_surface_medium", fontWeight: "$semiBold", my: "$4" }
    },
    title
  ), /* @__PURE__ */ React102.createElement(Text, { css: { fontWeight: "$semiBold" } }, value));
};

// src/Prebuilt/components/Polls/Voting/useQuizSummary.tsx
init_define_process_env();
import { useEffect as useEffect30, useState as useState42 } from "react";
import {
  selectPollByID as selectPollByID2,
  useHMSActions as useHMSActions36,
  useHMSStore as useHMSStore50
} from "@100mslive/react-sdk";
var useQuizSummary = (quizID) => {
  const hmsActions = useHMSActions36();
  const quiz = useHMSStore50(selectPollByID2(quizID));
  const [quizLeaderboard, setQuizLeaderboard] = useState42();
  const summary = (quizLeaderboard == null ? void 0 : quizLeaderboard.summary) || {
    totalUsers: 0,
    votedUsers: 0,
    avgScore: 0,
    avgTime: 0,
    correctUsers: 0
  };
  const [calculations, setCalculations] = useState42({ maxPossibleScore: 0, totalResponses: 0 });
  useEffect30(() => {
    const fetchLeaderboardData = () => __async(void 0, null, function* () {
      var _a8;
      if (!quizLeaderboard && quiz && !(quiz == null ? void 0 : quiz.anonymous) && quiz.state === "stopped") {
        const leaderboardData = yield hmsActions.interactivityCenter.fetchLeaderboard(quiz.id, 0, 50);
        const { maxPossibleScore, totalResponses } = ((_a8 = quiz == null ? void 0 : quiz.questions) == null ? void 0 : _a8.reduce((accumulator, question) => {
          var _a9;
          accumulator.maxPossibleScore += question.weight || 0;
          accumulator.totalResponses += ((_a9 = question == null ? void 0 : question.responses) == null ? void 0 : _a9.length) || 0;
          return accumulator;
        }, calculations)) || calculations;
        setQuizLeaderboard(leaderboardData);
        setCalculations({ maxPossibleScore, totalResponses });
      }
    });
    fetchLeaderboardData();
  }, [quiz, hmsActions.interactivityCenter, quizLeaderboard, calculations]);
  return {
    quizLeaderboard,
    summary,
    maxPossibleScore: calculations.maxPossibleScore,
    totalResponses: calculations.totalResponses
  };
};

// src/Prebuilt/components/Polls/Voting/PeerParticipationSummary.tsx
var PeerParticipationSummary = ({ quiz }) => {
  const localPeerId = useHMSStore51(selectLocalPeerID9);
  const { quizLeaderboard, summary } = useQuizSummary(quiz.id);
  if (quiz.state !== "stopped") {
    return /* @__PURE__ */ React103.createElement(React103.Fragment, null);
  }
  const isLocalPeerQuizCreator = localPeerId === quiz.startedBy;
  const peerEntry = quizLeaderboard == null ? void 0 : quizLeaderboard.entries.find((entry) => {
    var _a8;
    return ((_a8 = entry.peer) == null ? void 0 : _a8.peerid) === localPeerId;
  });
  const boxes = isLocalPeerQuizCreator ? [
    {
      title: "Voted",
      value: `${summary.totalUsers ? (100 * summary.votedUsers / summary.totalUsers).toFixed(0) : 0}% (${summary.votedUsers}/${summary.totalUsers})`
    },
    {
      title: "Correct Answers",
      value: `${summary.totalUsers ? (100 * summary.correctUsers / summary.totalUsers).toFixed(0) : 0}% (${summary.correctUsers}/${summary.totalUsers})`
    },
    // Time in ms
    { title: "Avg. Time Taken", value: getFormattedTime(summary.avgTime) },
    {
      title: "Avg. Score",
      value: Number.isInteger(summary.avgScore) ? summary.avgScore : summary.avgScore.toFixed(2)
    }
  ] : [
    { title: "Your rank", value: (peerEntry == null ? void 0 : peerEntry.position) || "-" },
    { title: "Points", value: (peerEntry == null ? void 0 : peerEntry.score) || 0 },
    // Time in ms
    { title: "Time Taken", value: getFormattedTime(peerEntry == null ? void 0 : peerEntry.duration) },
    {
      title: "Correct Answers",
      value: (peerEntry == null ? void 0 : peerEntry.totalResponses) ? `${peerEntry == null ? void 0 : peerEntry.correctResponses}/${peerEntry.totalResponses}` : "-"
    }
  ];
  return /* @__PURE__ */ React103.createElement(Box, null, /* @__PURE__ */ React103.createElement(Text, { css: { fontWeight: "$semiBold", my: "$8" } }, "Participation Summary"), /* @__PURE__ */ React103.createElement(Box, { css: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "$4" } }, boxes.map((box) => /* @__PURE__ */ React103.createElement(StatisticBox, { key: box.title, title: box.title, value: box.value }))));
};

// src/Prebuilt/components/Polls/Voting/LeaderboardSummary.tsx
var LeaderboardSummary = ({ pollID }) => {
  var _a8, _b7;
  const quiz = useHMSStore52(selectPollByID3(pollID));
  const { quizLeaderboard, maxPossibleScore } = useQuizSummary(pollID);
  const [viewAllEntries, setViewAllEntries] = useState43(false);
  const { setPollView } = usePollViewState();
  const toggleSidepane = useSidepaneToggle();
  if (!quiz || !quizLeaderboard)
    return /* @__PURE__ */ React104.createElement(Flex, { align: "center", justify: "center", css: { size: "100%" } }, /* @__PURE__ */ React104.createElement(Loading, null));
  const questionCount = ((_a8 = quiz.questions) == null ? void 0 : _a8.length) || 0;
  return /* @__PURE__ */ React104.createElement(Container3, { rounded: true }, /* @__PURE__ */ React104.createElement(Flex, { direction: "column", css: { size: "100%", p: "$8" } }, /* @__PURE__ */ React104.createElement(Flex, { justify: "between", align: "center", css: { pb: "$6", borderBottom: "1px solid $border_bright", mb: "$8" } }, /* @__PURE__ */ React104.createElement(Flex, { align: "center", css: { gap: "$4" } }, /* @__PURE__ */ React104.createElement(
    Flex,
    {
      css: { color: "$on_surface_medium", "&:hover": { color: "$on_surface_high", cursor: "pointer" } },
      onClick: () => setPollView(POLL_VIEWS.VOTE)
    },
    /* @__PURE__ */ React104.createElement(ChevronLeftIcon4, null)
  ), /* @__PURE__ */ React104.createElement(Text, { variant: "lg", css: { fontWeight: "$semiBold" } }, quiz.title), /* @__PURE__ */ React104.createElement(StatusIndicator, { status: quiz.state })), /* @__PURE__ */ React104.createElement(
    Flex,
    {
      css: { color: "$on_surface_medium", "&:hover": { color: "$on_surface_high", cursor: "pointer" } },
      onClick: toggleSidepane
    },
    /* @__PURE__ */ React104.createElement(CrossIcon18, null)
  )), /* @__PURE__ */ React104.createElement(Box, { css: { overflowY: "auto", mr: "-$4", pr: "$4" } }, !viewAllEntries ? /* @__PURE__ */ React104.createElement(PeerParticipationSummary, { quiz }) : null, /* @__PURE__ */ React104.createElement(Text, { variant: "sm", css: { fontWeight: "$semiBold", mt: "$4" } }, "Leaderboard"), /* @__PURE__ */ React104.createElement(Text, { variant: "xs", css: { color: "$on_surface_medium" } }, "Based on score and time taken to cast the correct answer"), /* @__PURE__ */ React104.createElement(
    Box,
    {
      css: {
        mt: "$8",
        overflowY: "auto",
        flex: viewAllEntries ? "1 1 0" : "unset",
        mr: viewAllEntries ? "-$6" : "unset",
        px: viewAllEntries ? "0" : "$4",
        pr: viewAllEntries ? "$6" : "$4",
        backgroundColor: viewAllEntries ? "" : "$surface_default",
        borderRadius: "$1"
      }
    },
    (quizLeaderboard == null ? void 0 : quizLeaderboard.entries) && quizLeaderboard.entries.slice(0, viewAllEntries ? void 0 : 5).map((question) => /* @__PURE__ */ React104.createElement(
      LeaderboardEntry,
      {
        key: question.position,
        position: question.position,
        score: question.score,
        questionCount,
        correctResponses: question.correctResponses,
        userName: question.peer.username || "",
        maxPossibleScore,
        duration: question.duration
      }
    )),
    ((_b7 = quizLeaderboard == null ? void 0 : quizLeaderboard.entries) == null ? void 0 : _b7.length) > 5 && !viewAllEntries ? /* @__PURE__ */ React104.createElement(
      Flex,
      {
        align: "center",
        justify: "end",
        css: {
          w: "100%",
          borderTop: "1px solid $border_bright",
          cursor: "pointer",
          color: "$on_surface_high",
          p: "$6 $2"
        },
        onClick: () => setViewAllEntries(true)
      },
      /* @__PURE__ */ React104.createElement(Text, { variant: "sm" }, "View All"),
      " ",
      /* @__PURE__ */ React104.createElement(ChevronRightIcon3, null)
    ) : null
  ))));
};

// src/Prebuilt/components/Polls/Voting/Voting.tsx
init_define_process_env();
import React108, { useEffect as useEffect33, useRef as useRef23, useState as useState46 } from "react";
import {
  selectLocalPeer as selectLocalPeer4,
  selectPeerNameByID as selectPeerNameByID4,
  selectPermissions as selectPermissions17,
  selectPollByID as selectPollByID4,
  useHMSActions as useHMSActions38,
  useHMSStore as useHMSStore54
} from "@100mslive/react-sdk";
import { ChevronLeftIcon as ChevronLeftIcon5, CrossIcon as CrossIcon19 } from "@100mslive/react-icons";

// src/Prebuilt/components/Polls/Voting/StandardVoting.tsx
init_define_process_env();
import React106 from "react";

// src/Prebuilt/components/Polls/Voting/QuestionCard.jsx
init_define_process_env();
import React105, { useCallback as useCallback27, useEffect as useEffect31, useMemo as useMemo12, useRef as useRef22, useState as useState44 } from "react";
import { match as match9 } from "ts-pattern";
import {
  HMSRoomState as HMSRoomState5,
  selectLocalPeer as selectLocalPeer3,
  selectLocalPeerRoleName as selectLocalPeerRoleName3,
  selectRoomState as selectRoomState5,
  useHMSActions as useHMSActions37,
  useHMSStore as useHMSStore53
} from "@100mslive/react-sdk";
import { CheckCircleIcon as CheckCircleIcon5, ChevronDownIcon as ChevronDownIcon4, CrossCircleIcon as CrossCircleIcon2 } from "@100mslive/react-icons";
var QuestionCard2 = ({
  pollID,
  isQuiz,
  startedBy,
  pollState,
  index,
  totalQuestions,
  result,
  type,
  text,
  options = [],
  answer,
  localPeerResponse,
  updateSavedResponses,
  rolesThatCanViewResponses
}) => {
  const actions = useHMSActions37();
  const localPeer = useHMSStore53(selectLocalPeer3);
  const roomState = useHMSStore53(selectRoomState5);
  const isLocalPeerCreator = (localPeer == null ? void 0 : localPeer.id) === startedBy;
  const localPeerRoleName = useHMSStore53(selectLocalPeerRoleName3);
  const roleCanViewResponse = !rolesThatCanViewResponses || rolesThatCanViewResponses.length === 0 || rolesThatCanViewResponses.includes(localPeerRoleName || "");
  const [localPeerChoice, setLocalPeerChoice] = useState44(localPeerResponse);
  useEffect31(() => {
    setLocalPeerChoice(localPeerResponse);
  }, [localPeerResponse]);
  const showVoteCount = roleCanViewResponse && (localPeerChoice || isLocalPeerCreator && pollState === "stopped") && !isQuiz;
  const isLive = pollState === "started";
  const pollEnded = pollState === "stopped";
  const canRespond = isLive && !localPeerChoice;
  const startTime = useRef22(Date.now());
  const isCorrectAnswer = checkCorrectAnswer(answer, localPeerChoice, type);
  const [singleOptionAnswer, setSingleOptionAnswer] = useState44();
  const [multipleOptionAnswer, setMultipleOptionAnswer] = useState44(/* @__PURE__ */ new Set());
  const [showOptions, setShowOptions] = useState44(true);
  const respondedToQuiz = isQuiz && localPeerChoice && !localPeerChoice.skipped;
  const isValidVote = useMemo12(() => {
    if (type === "single-choice" /* SINGLE_CHOICE */) {
      return singleOptionAnswer !== void 0;
    } else if (type === "multiple-choice" /* MULTIPLE_CHOICE */) {
      return multipleOptionAnswer.size > 0;
    }
  }, [singleOptionAnswer, multipleOptionAnswer, type]);
  const handleVote = useCallback27(() => __async(void 0, null, function* () {
    if (!isValidVote) {
      return;
    }
    const submittedResponse = {
      questionIndex: index,
      option: singleOptionAnswer,
      options: Array.from(multipleOptionAnswer),
      duration: Date.now() - startTime.current
    };
    yield actions.interactivityCenter.addResponsesToPoll(pollID, [submittedResponse]);
    updateSavedResponses((prev) => {
      const prevCopy = __spreadValues({}, prev);
      prevCopy[index] = { option: singleOptionAnswer, options: Array.from(multipleOptionAnswer) };
      return prevCopy;
    });
    startTime.current = Date.now();
  }), [
    isValidVote,
    index,
    singleOptionAnswer,
    multipleOptionAnswer,
    actions.interactivityCenter,
    pollID,
    updateSavedResponses
  ]);
  return /* @__PURE__ */ React105.createElement(
    Box,
    {
      css: {
        backgroundColor: "$surface_bright",
        borderRadius: "$1",
        p: "$md",
        mt: "$md",
        border: respondedToQuiz && !isLive ? `1px solid ${isCorrectAnswer ? "$alert_success" : "$alert_error_default"}` : "none"
      }
    },
    /* @__PURE__ */ React105.createElement(Flex, { align: "center", justify: "between" }, /* @__PURE__ */ React105.createElement(
      Text,
      {
        variant: "caption",
        css: {
          color: match9({ respondedToQuiz, isLive, isCorrectAnswer }).when(
            ({ respondedToQuiz: respondedToQuiz2, isLive: isLive2 }) => respondedToQuiz2 && !isLive2,
            ({ isCorrectAnswer: isCorrectAnswer2 }) => isCorrectAnswer2 ? "$alert_success" : "$alert_error_default"
          ).otherwise(() => "$on_surface_low"),
          fontWeight: "$semiBold",
          display: "flex",
          alignItems: "center",
          gap: "$4"
        }
      },
      match9({ respondedToQuiz, pollEnded, isCorrectAnswer }).when(
        ({ respondedToQuiz: respondedToQuiz2, pollEnded: pollEnded2 }) => respondedToQuiz2 && pollEnded2,
        ({ isCorrectAnswer: isCorrectAnswer2 }) => {
          return isCorrectAnswer2 ? /* @__PURE__ */ React105.createElement(CheckCircleIcon5, { height: 16, width: 16 }) : /* @__PURE__ */ React105.createElement(CrossCircleIcon2, { height: 16, width: 16 });
        }
      ).otherwise(() => null),
      "QUESTION ",
      index,
      " OF ",
      totalQuestions,
      ": ",
      type.toUpperCase()
    )),
    /* @__PURE__ */ React105.createElement(Flex, { justify: "between", css: { my: "$md" } }, /* @__PURE__ */ React105.createElement(Text, { css: { color: "$on_surface_high" } }, text), /* @__PURE__ */ React105.createElement(
      Box,
      {
        css: { color: "$on_surface_medium", "&:hover": { color: "$on_surface_high", cursor: "pointer" } },
        onClick: () => setShowOptions((prev) => !prev)
      },
      /* @__PURE__ */ React105.createElement(
        ChevronDownIcon4,
        {
          style: { transform: showOptions ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease" }
        }
      )
    )),
    /* @__PURE__ */ React105.createElement(
      Box,
      {
        css: { maxHeight: showOptions ? "$80" : "0", transition: "max-height 0.3s ease", overflowY: "auto", mb: "$4" }
      },
      type === "single-choice" /* SINGLE_CHOICE */ ? /* @__PURE__ */ React105.createElement(
        SingleChoiceOptions,
        {
          key: index,
          questionIndex: index,
          isQuiz,
          canRespond,
          correctOptionIndex: answer == null ? void 0 : answer.option,
          options,
          setAnswer: setSingleOptionAnswer,
          totalResponses: result == null ? void 0 : result.totalResponses,
          showVoteCount,
          localPeerResponse: localPeerChoice,
          isStopped: pollState === "stopped"
        }
      ) : null,
      type === "multiple-choice" /* MULTIPLE_CHOICE */ ? /* @__PURE__ */ React105.createElement(
        MultipleChoiceOptions,
        {
          questionIndex: index,
          isQuiz,
          canRespond,
          correctOptionIndexes: answer == null ? void 0 : answer.options,
          options,
          selectedOptions: multipleOptionAnswer,
          setSelectedOptions: setMultipleOptionAnswer,
          totalResponses: result == null ? void 0 : result.totalResponses,
          showVoteCount,
          localPeerResponse: localPeerChoice,
          isStopped: pollState === "stopped"
        }
      ) : null
    ),
    isLive && /* @__PURE__ */ React105.createElement(
      QuestionActions,
      {
        disableVote: roomState !== HMSRoomState5.Connected,
        isValidVote,
        onVote: handleVote,
        response: localPeerChoice,
        isQuiz
      }
    )
  );
};
var QuestionActions = ({ isValidVote, response, isQuiz, onVote, disableVote }) => {
  return /* @__PURE__ */ React105.createElement(Flex, { align: "center", justify: "end", css: { gap: "$4", w: "100%" } }, response ? /* @__PURE__ */ React105.createElement(Text, { css: { fontWeight: "$semiBold", color: "$on_surface_medium" } }, response.skipped ? "Skipped" : null, isQuiz && !response.skipped ? "Answered" : null, !isQuiz && !response.skipped ? "Voted" : null) : /* @__PURE__ */ React105.createElement(Button, { css: { p: "$xs $10", fontWeight: "$semiBold" }, disabled: !isValidVote || disableVote, onClick: onVote }, isQuiz ? "Answer" : "Vote"));
};

// src/Prebuilt/components/Polls/Voting/StandardVoting.tsx
var StandardView = ({
  poll,
  localPeerResponses,
  updateSavedResponses
}) => {
  var _a8;
  if (!(poll == null ? void 0 : poll.questions)) {
    return null;
  }
  const isQuiz = poll.type === "quiz";
  const isStopped = poll.state === "stopped";
  return /* @__PURE__ */ React106.createElement(React106.Fragment, null, isQuiz && isStopped ? /* @__PURE__ */ React106.createElement(PeerParticipationSummary, { quiz: poll }) : null, (_a8 = poll.questions) == null ? void 0 : _a8.map((question, index) => {
    var _a9;
    return /* @__PURE__ */ React106.createElement(
      QuestionCard2,
      {
        pollID: poll.id,
        isQuiz,
        startedBy: poll.startedBy,
        pollState: poll.state,
        key: `${question.text}-${index}`,
        index: question.index,
        text: question.text,
        type: question.type,
        result: question.result,
        totalQuestions: ((_a9 = poll.questions) == null ? void 0 : _a9.length) || 0,
        options: question.options,
        localPeerResponse: localPeerResponses == null ? void 0 : localPeerResponses[question.index],
        answer: question.answer,
        updateSavedResponses,
        rolesThatCanViewResponses: poll.rolesThatCanViewResponses
      }
    );
  }));
};

// src/Prebuilt/components/Polls/Voting/TimedVoting.tsx
init_define_process_env();
import React107, { useEffect as useEffect32, useState as useState45 } from "react";
var TimedView = ({
  poll,
  localPeerResponses,
  updateSavedResponses
}) => {
  var _a8, _b7, _c;
  const [currentIndex, setCurrentIndex] = useState45(getIndexToShow(localPeerResponses));
  const activeQuestion = (_a8 = poll.questions) == null ? void 0 : _a8.find((question) => question.index === currentIndex);
  const attemptedAll = (((_b7 = poll.questions) == null ? void 0 : _b7.length) || 0) < currentIndex;
  useEffect32(() => {
    setCurrentIndex(getIndexToShow(localPeerResponses));
  }, [localPeerResponses]);
  if (!activeQuestion && !attemptedAll || !((_c = poll.questions) == null ? void 0 : _c.length)) {
    return null;
  }
  return /* @__PURE__ */ React107.createElement(React107.Fragment, null, poll.questions.map((question) => {
    var _a9;
    return attemptedAll || (activeQuestion == null ? void 0 : activeQuestion.index) === question.index ? /* @__PURE__ */ React107.createElement(
      QuestionCard2,
      {
        key: question.index,
        pollID: poll.id,
        isQuiz: poll.type === "quiz",
        startedBy: poll.startedBy,
        pollState: poll.state,
        index: question.index,
        text: question.text,
        type: question.type,
        result: question == null ? void 0 : question.result,
        totalQuestions: ((_a9 = poll.questions) == null ? void 0 : _a9.length) || 0,
        options: question.options,
        localPeerResponse: localPeerResponses == null ? void 0 : localPeerResponses[question.index],
        answer: question.answer,
        rolesThatCanViewResponses: poll.rolesThatCanViewResponses,
        updateSavedResponses
      }
    ) : null;
  }));
};

// src/Prebuilt/components/Polls/Voting/Voting.tsx
var Voting = ({ id, toggleVoting }) => {
  const actions = useHMSActions38();
  const poll = useHMSStore54(selectPollByID4(id));
  const pollCreatorName = useHMSStore54(selectPeerNameByID4(poll == null ? void 0 : poll.createdBy));
  const permissions = useHMSStore54(selectPermissions17);
  const canEndActivity = !!(permissions == null ? void 0 : permissions.pollWrite);
  const { setPollView } = usePollViewState();
  const showSingleView = (poll == null ? void 0 : poll.type) === "quiz" && poll.state === "started";
  const fetchedInitialResponses = useRef23(false);
  const [savedResponses, setSavedResponses] = useState46({});
  const localPeer = useHMSStore54(selectLocalPeer4);
  const localPeerId = localPeer == null ? void 0 : localPeer.id;
  const customerUserId = localPeer == null ? void 0 : localPeer.customerUserId;
  useEffect33(() => {
    fetchedInitialResponses.current = false;
    setSavedResponses({});
  }, [id, setSavedResponses]);
  useEffect33(() => {
    const getResponses = () => __async(void 0, null, function* () {
      if (poll && actions.interactivityCenter && !fetchedInitialResponses.current) {
        yield actions.interactivityCenter.getPollResponses(poll, true);
        fetchedInitialResponses.current = true;
      }
    });
    getResponses();
  }, [poll, actions.interactivityCenter]);
  useEffect33(() => {
    if (poll == null ? void 0 : poll.questions) {
      const localPeerResponses = getPeerResponses(poll.questions, localPeerId, customerUserId);
      localPeerResponses == null ? void 0 : localPeerResponses.forEach((response) => {
        if (response) {
          setSavedResponses((prev) => {
            var _a8, _b7, _c;
            const prevCopy = __spreadValues({}, prev);
            prevCopy[(_a8 = response[0]) == null ? void 0 : _a8.questionIndex] = { option: (_b7 = response[0]) == null ? void 0 : _b7.option, options: (_c = response[0]) == null ? void 0 : _c.options };
            return prevCopy;
          });
        }
      });
    }
  }, [localPeerId, poll == null ? void 0 : poll.questions, id, customerUserId]);
  if (!poll) {
    return null;
  }
  const canViewLeaderboard = poll.type === "quiz" && poll.state === "stopped" && !poll.anonymous;
  return /* @__PURE__ */ React108.createElement(Container3, { rounded: true }, /* @__PURE__ */ React108.createElement(
    Flex,
    {
      align: "center",
      css: {
        gap: "$4",
        py: "$6",
        px: "$8",
        my: "$4",
        w: "100%",
        color: "$on_surface_high",
        borderBottom: "1px solid $border_default"
      }
    },
    /* @__PURE__ */ React108.createElement(
      Flex,
      {
        onClick: () => setPollView(POLL_VIEWS.CREATE_POLL_QUIZ),
        css: { cursor: "pointer", c: "$on_surface_medium", "&:hover": { color: "$on_surface_high" } }
      },
      /* @__PURE__ */ React108.createElement(ChevronLeftIcon5, null)
    ),
    /* @__PURE__ */ React108.createElement(Text, { variant: "h6" }, poll.title),
    /* @__PURE__ */ React108.createElement(StatusIndicator, { status: poll.state }),
    /* @__PURE__ */ React108.createElement(
      Box,
      {
        css: {
          marginLeft: "auto",
          cursor: "pointer",
          "&:hover": { opacity: "0.8" },
          height: "fit-content"
        }
      },
      /* @__PURE__ */ React108.createElement(CrossIcon19, { onClick: toggleVoting })
    )
  ), /* @__PURE__ */ React108.createElement(Flex, { direction: "column", css: { p: "$8 $10", flex: "1 1 0", overflowY: "auto" } }, poll.state === "started" ? /* @__PURE__ */ React108.createElement(Text, { css: { color: "$on_surface_medium", fontWeight: "$semiBold" } }, pollCreatorName || "Participant", " started a ", poll.type) : null, showSingleView ? /* @__PURE__ */ React108.createElement(TimedView, { poll, localPeerResponses: savedResponses, updateSavedResponses: setSavedResponses }) : /* @__PURE__ */ React108.createElement(StandardView, { poll, localPeerResponses: savedResponses, updateSavedResponses: setSavedResponses })), /* @__PURE__ */ React108.createElement(
    Flex,
    {
      css: { w: "100%", justifyContent: "end", alignItems: "center", p: "$8", borderTop: "1px solid $border_bright" }
    },
    poll.state === "started" && canEndActivity && /* @__PURE__ */ React108.createElement(
      Button,
      {
        variant: "danger",
        css: { fontWeight: "$semiBold", w: "max-content" },
        onClick: () => actions.interactivityCenter.stopPoll(id)
      },
      "End ",
      poll.type
    ),
    canViewLeaderboard ? /* @__PURE__ */ React108.createElement(Button, { css: { fontWeight: "$semiBold", w: "max-content" }, onClick: () => setPollView(POLL_VIEWS.RESULTS) }, "View Leaderboard") : null
  ));
};

// src/Prebuilt/components/Polls/Polls.tsx
var Polls = () => {
  const togglePollView = usePollViewToggle();
  const { pollInView: pollID, view } = usePollViewState();
  if (view === POLL_VIEWS.CREATE_POLL_QUIZ) {
    return /* @__PURE__ */ React109.createElement(PollsQuizMenu, null);
  } else if (view === POLL_VIEWS.CREATE_QUESTIONS) {
    return /* @__PURE__ */ React109.createElement(CreateQuestions, null);
  } else if (view === POLL_VIEWS.VOTE) {
    return /* @__PURE__ */ React109.createElement(Voting, { toggleVoting: togglePollView, id: pollID });
  } else if (view === POLL_VIEWS.RESULTS) {
    return /* @__PURE__ */ React109.createElement(LeaderboardSummary, { pollID });
  } else {
    return null;
  }
};

// src/Prebuilt/components/RoomDetails/RoomDetailsPane.tsx
init_define_process_env();
import React113 from "react";
import { CrossIcon as CrossIcon20 } from "@100mslive/react-icons";

// src/Prebuilt/components/Header/HeaderComponents.jsx
init_define_process_env();
import React110, { useEffect as useEffect34, useState as useState47 } from "react";
import { selectDominantSpeaker, useHMSStore as useHMSStore55 } from "@100mslive/react-sdk";
import { VolumeOneIcon } from "@100mslive/react-icons";
var SpeakerTag = () => {
  const dominantSpeaker = useHMSStore55(selectDominantSpeaker);
  return dominantSpeaker && dominantSpeaker.name && /* @__PURE__ */ React110.createElement(
    Flex,
    {
      align: "center",
      justify: "center",
      css: { flex: "1 1 0", color: "$on_surface_high", "@md": { display: "none" } }
    },
    /* @__PURE__ */ React110.createElement(VolumeOneIcon, null),
    /* @__PURE__ */ React110.createElement(Text, { variant: "sm", css: __spreadProps(__spreadValues({}, textEllipsis(200)), { ml: "$2" }), title: dominantSpeaker.name }, dominantSpeaker.name)
  );
};
var LogoImg = styled("img", {
  maxHeight: "$14",
  w: "auto",
  objectFit: "contain",
  "@md": {
    maxHeight: "$12"
  }
});
var Logo = () => {
  var _a8;
  const roomLayout = useRoomLayout();
  const logo = (_a8 = roomLayout == null ? void 0 : roomLayout.logo) == null ? void 0 : _a8.url;
  const [hideImage, setHideImage] = useState47(false);
  useEffect34(() => {
    if (hideImage) {
      setHideImage(false);
    }
  }, [logo]);
  return logo && !hideImage ? /* @__PURE__ */ React110.createElement(
    LogoImg,
    {
      src: logo,
      alt: "Brand Logo",
      onError: (e) => {
        e.target.onerror = null;
        setHideImage(true);
      }
    }
  ) : null;
};

// src/Prebuilt/components/RoomDetails/RoomDetailsRow.tsx
init_define_process_env();
import React112 from "react";

// src/Prebuilt/components/RoomDetails/Duration.tsx
init_define_process_env();
import React111, { useEffect as useEffect35, useState as useState48 } from "react";
var Duration = ({ timestamp }) => {
  const [elapsedTime, setElapsedTime] = useState48(getFormattedTime(Date.now() - timestamp.getTime(), false));
  useEffect35(() => {
    const timerAdded = setInterval(() => {
      setElapsedTime(getFormattedTime(Date.now() - timestamp.getTime(), false));
    }, 1e3);
    return () => {
      clearInterval(timerAdded);
    };
  }, [timestamp]);
  return /* @__PURE__ */ React111.createElement(Flex, { css: { color: "$on_surface_medium" } }, /* @__PURE__ */ React111.createElement(Text, { variant: "xs", css: { color: "inherit" } }, "Started ", elapsedTime, " ago"));
};

// src/Prebuilt/components/RoomDetails/RoomDetailsRow.tsx
var RoomDetailsRow = ({ details }) => {
  return /* @__PURE__ */ React112.createElement(Flex, { align: "center", css: { w: "100%" } }, details.map((detail, index) => /* @__PURE__ */ React112.createElement(React112.Fragment, { key: detail.toString() }, index > 0 && /* @__PURE__ */ React112.createElement(Box, { css: { h: "$2", w: "$2", r: "$round", bg: "$on_surface_medium", m: "0 $2" } }), typeof detail !== "string" ? /* @__PURE__ */ React112.createElement(Duration, { timestamp: detail }) : /* @__PURE__ */ React112.createElement(Text, { variant: "xs", css: { c: "$on_surface_medium" } }, detail))));
};

// src/Prebuilt/components/RoomDetails/RoomDetailsPane.tsx
var RoomDetailsPane = () => {
  const { description } = useRoomLayoutHeader();
  const isMwebHLSStream = useMobileHLSStream();
  return /* @__PURE__ */ React113.createElement(Box, { css: { flex: "1 1 0", position: "relative" } }, isMwebHLSStream ? /* @__PURE__ */ React113.createElement(Flex, { direction: "row", align: "center", gap: "2" }, /* @__PURE__ */ React113.createElement(Logo, null), /* @__PURE__ */ React113.createElement(ShowRoomDetailHeader, null)) : /* @__PURE__ */ React113.createElement(ShowRoomDetailHeader, null), /* @__PURE__ */ React113.createElement(Box, { css: { mt: "$10" } }, /* @__PURE__ */ React113.createElement(Text, { css: { color: "$on_surface_high", fontWeight: "$semiBold", display: isMwebHLSStream ? "none" : "" } }, "Description"), /* @__PURE__ */ React113.createElement(Text, { variant: "sm", css: { c: "$on_surface_medium" } }, description)));
};
var ShowRoomDetailHeader = () => {
  const { title, details } = useRoomLayoutHeader();
  const toggleDetailsPane = useSidepaneToggle(SIDE_PANE_OPTIONS.ROOM_DETAILS);
  const isMwebHLSStream = useMobileHLSStream();
  return /* @__PURE__ */ React113.createElement(Flex, { direction: "column", css: { position: "sticky", top: 0, bg: "$surface_dim" } }, /* @__PURE__ */ React113.createElement(Flex, { justify: "between", align: "center", css: { w: "100%" } }, /* @__PURE__ */ React113.createElement(Text, { variant: "h6" }, title), !isMwebHLSStream && /* @__PURE__ */ React113.createElement(
    Flex,
    {
      onClick: toggleDetailsPane,
      css: {
        color: "$on_surface_high",
        cursor: "pointer",
        "&:hover": { opacity: "0.8" }
      }
    },
    /* @__PURE__ */ React113.createElement(CrossIcon20, null)
  )), /* @__PURE__ */ React113.createElement(RoomDetailsRow, { details }));
};

// src/Prebuilt/components/SidePaneTabs.tsx
init_define_process_env();
import React124, { useEffect as useEffect40, useState as useState54 } from "react";
import { useMedia as useMedia21 } from "react-use";
import { match as match11 } from "ts-pattern";
import { selectPeerCount as selectPeerCount5, useHMSStore as useHMSStore64 } from "@100mslive/react-sdk";
import { CrossIcon as CrossIcon23 } from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/Chat.tsx
init_define_process_env();
import React121, { useCallback as useCallback31, useRef as useRef26 } from "react";
import { useMedia as useMedia20 } from "react-use";
import { match as match10 } from "ts-pattern";
import { selectHMSMessagesCount, useHMSActions as useHMSActions42, useHMSStore as useHMSStore61, useHMSVanillaStore as useHMSVanillaStore11 } from "@100mslive/react-sdk";
import { ChevronDownIcon as ChevronDownIcon7 } from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/ChatFooter.tsx
init_define_process_env();
import React116, { useCallback as useCallback29, useEffect as useEffect37, useRef as useRef25, useState as useState51 } from "react";
import { useMedia as useMedia18 } from "react-use";
import data2 from "@emoji-mart/data/sets/14/apple.json";
import Picker from "@emoji-mart/react";
import { selectLocalPeer as selectLocalPeer5, useHMSActions as useHMSActions40, useHMSStore as useHMSStore58 } from "@100mslive/react-sdk";
import { EmojiIcon as EmojiIcon3, PauseCircleIcon as PauseCircleIcon2, SendIcon as SendIcon2, VerticalMenuIcon as VerticalMenuIcon7 } from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/ChatSelectorContainer.tsx
init_define_process_env();
import React115, { useState as useState50 } from "react";
import { useMedia as useMedia17 } from "react-use";
import { ChevronDownIcon as ChevronDownIcon5, ChevronUpIcon as ChevronUpIcon4, CrossIcon as CrossIcon21, GroupIcon, PersonIcon as PersonIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/ChatSelector.tsx
init_define_process_env();
import React114, { useMemo as useMemo13, useState as useState49 } from "react";
import { useMedia as useMedia16 } from "react-use";
import {
  HMSPeerType as HMSPeerType3,
  selectMessagesUnreadCountByPeerID,
  selectMessagesUnreadCountByRole,
  selectRemotePeers as selectRemotePeers2,
  selectUnreadHMSMessagesCount as selectUnreadHMSMessagesCount4,
  useHMSStore as useHMSStore56
} from "@100mslive/react-sdk";
import { CheckIcon as CheckIcon6, PeopleIcon as PeopleIcon3 } from "@100mslive/react-icons";
var ChatDotIcon = () => {
  return /* @__PURE__ */ React114.createElement(Box, { css: { size: "$6", bg: "$primary_default", mx: "$2", r: "$round" } });
};
var SelectorItem = ({
  value,
  active,
  onClick,
  unreadCount,
  icon = void 0
}) => {
  const isMobile = useMedia16(config.media.md);
  const Root28 = !isMobile ? Dropdown.Item : (_a8) => {
    var _b7 = _a8, { children } = _b7, rest = __objRest(_b7, ["children"]);
    return /* @__PURE__ */ React114.createElement(Flex, __spreadProps(__spreadValues({}, rest), { css: __spreadValues({ p: "$6 $8" }, rest.css) }), children);
  };
  return /* @__PURE__ */ React114.createElement(
    Root28,
    {
      "data-testid": "chat_members",
      css: { align: "center", px: "$10", py: "$4", bg: "$surface_default" },
      onClick
    },
    /* @__PURE__ */ React114.createElement(
      Text,
      {
        variant: "sm",
        css: { display: "flex", alignItems: "center", gap: "$4", fontWeight: "$semiBold", color: "$on_surface_high" }
      },
      icon,
      value
    ),
    /* @__PURE__ */ React114.createElement(Flex, { align: "center", css: { ml: "auto", color: "$on_primary_high" } }, unreadCount > 0 && /* @__PURE__ */ React114.createElement(Tooltip, { title: `${unreadCount} unread` }, /* @__PURE__ */ React114.createElement(Box, { css: { mr: active ? "$3" : 0 } }, /* @__PURE__ */ React114.createElement(ChatDotIcon, null))), active && /* @__PURE__ */ React114.createElement(CheckIcon6, { width: 16, height: 16 }))
  );
};
var SelectorHeader = React114.memo(
  ({ isHorizontalDivider = true, children }) => {
    return /* @__PURE__ */ React114.createElement(Box, { css: { flexShrink: 0 } }, isHorizontalDivider && /* @__PURE__ */ React114.createElement(HorizontalDivider, { space: 4 }), /* @__PURE__ */ React114.createElement(
      Text,
      {
        variant: "overline",
        css: { p: "$4 $10", fontWeight: "$semiBold", textTransform: "uppercase", color: "$on_surface_medium" }
      },
      children
    ));
  }
);
var Everyone = React114.memo(({ active }) => {
  const unreadCount = useHMSStore56(selectUnreadHMSMessagesCount4);
  const [, setPeerSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.PEER);
  const [, setRoleSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.ROLE);
  return /* @__PURE__ */ React114.createElement(
    SelectorItem,
    {
      value: "Everyone",
      icon: /* @__PURE__ */ React114.createElement(PeopleIcon3, null),
      active,
      unreadCount,
      onClick: () => {
        setPeerSelector({});
        setRoleSelector("");
      }
    }
  );
});
var RoleItem = React114.memo(({ role, active }) => {
  const unreadCount = useHMSStore56(selectMessagesUnreadCountByRole(role));
  const [, setPeerSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.PEER);
  const [, setRoleSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.ROLE);
  return /* @__PURE__ */ React114.createElement(
    SelectorItem,
    {
      value: role,
      active,
      unreadCount,
      onClick: () => {
        setPeerSelector({});
        setRoleSelector(role);
      }
    }
  );
});
var PeerItem = ({ peerId, name, active }) => {
  const unreadCount = useHMSStore56(selectMessagesUnreadCountByPeerID(peerId));
  const [, setPeerSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.PEER);
  const [, setRoleSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.ROLE);
  return /* @__PURE__ */ React114.createElement(
    SelectorItem,
    {
      value: name,
      active,
      unreadCount,
      onClick: () => {
        setPeerSelector({ id: peerId, name });
        setRoleSelector("");
      }
    }
  );
};
var VirtualizedSelectItemList = ({
  peers,
  selectedRole,
  selectedPeerId,
  searchValue,
  isPublicChatEnabled
}) => {
  const roles = useFilteredRoles();
  const filteredPeers = useMemo13(
    () => peers.filter(
      // search should be empty or search phrase should be included in name
      (peer) => (!searchValue || peer.name.toLowerCase().includes(searchValue.toLowerCase())) && peer.type !== HMSPeerType3.SIP
    ),
    [peers, searchValue]
  );
  const listItems = useMemo13(() => {
    let selectItems = [];
    if (isPublicChatEnabled && !searchValue) {
      selectItems = [/* @__PURE__ */ React114.createElement(Everyone, { active: !selectedRole && !selectedPeerId })];
    }
    if (roles.length > 0 && !searchValue) {
      selectItems.push(/* @__PURE__ */ React114.createElement(SelectorHeader, { isHorizontalDivider: isPublicChatEnabled }, "Roles"));
      roles.forEach(
        (userRole) => selectItems.push(/* @__PURE__ */ React114.createElement(RoleItem, { key: userRole, active: selectedRole === userRole, role: userRole }))
      );
    }
    if (filteredPeers.length > 0) {
      selectItems.push(
        /* @__PURE__ */ React114.createElement(SelectorHeader, { isHorizontalDivider: isPublicChatEnabled || roles.length > 0 }, "Participants")
      );
    }
    filteredPeers.forEach(
      (peer) => selectItems.push(
        /* @__PURE__ */ React114.createElement(PeerItem, { key: peer.id, name: peer.name, peerId: peer.id, active: peer.id === selectedPeerId })
      )
    );
    return selectItems;
  }, [isPublicChatEnabled, searchValue, selectedRole, selectedPeerId, roles, filteredPeers]);
  return /* @__PURE__ */ React114.createElement(Dropdown.Group, { css: { overflowY: "auto", maxHeight: "$64", bg: "$surface_default" } }, listItems.map((item, index) => /* @__PURE__ */ React114.createElement(Box, { key: index }, item)));
};
var ChatSelector = ({ role, peerId }) => {
  var _a8, _b7;
  const { elements } = useRoomLayoutConferencingScreen();
  const peers = useHMSStore56(selectRemotePeers2);
  const [search, setSearch] = useState49("");
  const isPrivateChatEnabled = !!((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.private_chat_enabled);
  const isPublicChatEnabled = !!((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.public_chat_enabled);
  return /* @__PURE__ */ React114.createElement(React114.Fragment, null, peers.length > 0 && isPrivateChatEnabled && /* @__PURE__ */ React114.createElement(Box, { css: { px: "$4" } }, /* @__PURE__ */ React114.createElement(ParticipantSearch, { onSearch: setSearch, placeholder: "Search for participants" })), /* @__PURE__ */ React114.createElement(
    VirtualizedSelectItemList,
    {
      selectedRole: role,
      selectedPeerId: peerId,
      peers: isPrivateChatEnabled ? peers : [],
      isPublicChatEnabled,
      searchValue: search
    }
  ));
};

// src/Prebuilt/components/Chat/ChatSelectorContainer.tsx
var ChatSelectorContainer = () => {
  var _a8, _b7;
  const [open, setOpen] = useState50(false);
  const isMobile = useMedia17(config.media.md);
  const { elements } = useRoomLayoutConferencingScreen();
  const isPrivateChatEnabled = !!((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.private_chat_enabled);
  const isPublicChatEnabled = !!((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.public_chat_enabled);
  const roles = useFilteredRoles();
  const selectedPeer = useSubscribeChatSelector(CHAT_SELECTOR.PEER);
  const selectedRole = useSubscribeChatSelector(CHAT_SELECTOR.ROLE);
  const defaultSelection = useDefaultChatSelection();
  const selection = selectedPeer.name || selectedRole || defaultSelection;
  if (!(isPrivateChatEnabled || isPublicChatEnabled || roles.length > 0) && !isPrivateChatEnabled && !selection) {
    return null;
  }
  return /* @__PURE__ */ React115.createElement(React115.Fragment, null, /* @__PURE__ */ React115.createElement(Flex, { align: "center", css: { mb: "$8", flex: "1 1 0", pl: "$2" } }, /* @__PURE__ */ React115.createElement(Text, { variant: "xs", css: { color: "$on_surface_medium" } }, selection ? "To" : "Choose Participant"), isMobile ? /* @__PURE__ */ React115.createElement(
    Flex,
    {
      align: "center",
      css: { c: "$on_surface_medium", border: "1px solid $border_bright", r: "$0", p: "$1 $2", ml: "$6" },
      gap: "1",
      onClick: (e) => {
        setOpen((value) => !value);
        e.stopPropagation();
      }
    },
    /* @__PURE__ */ React115.createElement(
      Text,
      {
        variant: "caption",
        css: {
          c: "$on_surface_high",
          pr: "$2",
          display: "flex",
          alignItems: "center",
          gap: "$1",
          textTransform: selection !== selectedPeer.name ? "capitalize" : void 0
        }
      },
      selection === CHAT_SELECTOR.EVERYONE ? /* @__PURE__ */ React115.createElement(GroupIcon, { width: 16, height: 16 }) : /* @__PURE__ */ React115.createElement(PersonIcon2, { width: 16, height: 16 }),
      selection || "Search"
    ),
    selection && (open ? /* @__PURE__ */ React115.createElement(ChevronUpIcon4, { width: 16, height: 16 }) : /* @__PURE__ */ React115.createElement(ChevronDownIcon5, { width: 16, height: 16 }))
  ) : /* @__PURE__ */ React115.createElement(Dropdown.Root, { open, onOpenChange: (value) => setOpen(value) }, /* @__PURE__ */ React115.createElement(
    Dropdown.Trigger,
    {
      asChild: true,
      "data-testid": "participant_list_filter",
      css: {
        background: "$primary_default",
        c: "$on_primary_high",
        r: "$0",
        p: "$1 $2",
        ml: "$6"
      },
      tabIndex: 0
    },
    /* @__PURE__ */ React115.createElement(Flex, { align: "center", gap: "1" }, /* @__PURE__ */ React115.createElement(
      Text,
      {
        variant: "caption",
        css: {
          c: "inherit",
          pr: "$2",
          display: "flex",
          alignItems: "center",
          gap: "$1",
          textTransform: selection !== selectedPeer.name ? "capitalize" : void 0
        }
      },
      selection === CHAT_SELECTOR.EVERYONE ? /* @__PURE__ */ React115.createElement(GroupIcon, { width: 16, height: 16 }) : /* @__PURE__ */ React115.createElement(PersonIcon2, { width: 16, height: 16 }),
      selection || "Search"
    ), selection && /* @__PURE__ */ React115.createElement(
      ChevronDownIcon5,
      {
        style: { transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 150ms ease" },
        width: 12,
        height: 12
      }
    ))
  ), /* @__PURE__ */ React115.createElement(
    Dropdown.Content,
    {
      css: {
        w: "$64",
        overflow: "hidden",
        maxHeight: "unset",
        bg: "$surface_default"
      },
      align: "start",
      sideOffset: 8
    },
    /* @__PURE__ */ React115.createElement(ChatSelector, { role: selectedRole, peerId: selectedPeer.id })
  ))), isMobile ? /* @__PURE__ */ React115.createElement(Sheet.Root, { open, onOpenChange: (value) => setOpen(value) }, /* @__PURE__ */ React115.createElement(Sheet.Content, { css: { pt: "$8" } }, /* @__PURE__ */ React115.createElement(
    Sheet.Title,
    {
      css: {
        display: "flex",
        w: "100%",
        justifyContent: "space-between",
        px: "$10",
        pb: "$4",
        mb: "$8",
        borderBottom: "1px solid $border_bright"
      }
    },
    /* @__PURE__ */ React115.createElement(Text, { css: { color: "$on_surface_medium", fontWeight: "$semiBold" } }, "Chat with"),
    /* @__PURE__ */ React115.createElement(Sheet.Close, { css: { color: "$on_surface_medium" } }, /* @__PURE__ */ React115.createElement(CrossIcon21, null))
  ), /* @__PURE__ */ React115.createElement(
    Box,
    {
      onClick: () => {
        setOpen(false);
      }
    },
    /* @__PURE__ */ React115.createElement(ChatSelector, { role: selectedRole, peerId: selectedPeer.id })
  ))) : null);
};

// src/Prebuilt/components/AppData/useChatState.js
init_define_process_env();
import { useCallback as useCallback28 } from "react";
import { selectAppData as selectAppData7, useHMSActions as useHMSActions39, useHMSStore as useHMSStore57 } from "@100mslive/react-sdk";
var useChatDraftMessage = () => {
  const hmsActions = useHMSActions39();
  let chatDraftMessage = useHMSStore57(selectAppData7(APP_DATA.chatDraft));
  if (chatDraftMessage === void 0 || chatDraftMessage === null) {
    chatDraftMessage = "";
  }
  const setDraftMessage = useCallback28(
    (message) => {
      hmsActions.setAppData(APP_DATA.chatDraft, message, true);
    },
    [hmsActions]
  );
  return [chatDraftMessage, setDraftMessage];
};

// src/Prebuilt/components/Chat/useEmojiPickerStyles.js
init_define_process_env();
import { useEffect as useEffect36, useRef as useRef24 } from "react";
var useEmojiPickerStyles = (showing) => {
  const ref = useRef24(null);
  useEffect36(() => {
    if (showing) {
      setTimeout(() => {
        var _a8, _b7;
        const root = (_b7 = (_a8 = ref.current) == null ? void 0 : _a8.querySelector("em-emoji-picker")) == null ? void 0 : _b7.shadowRoot;
        const style = document.createElement("style");
        style.textContent = `
          #root {
            --em-rgb-color: var(--hms-ui-colors-on_surface_high);
            --em-rgb-input: var(--hms-ui-colors-on_primary_high);
            --em-color-border: var(--hms-ui-colors-surface_bright);
            --color-b: var(--hms-ui-colors-on_surface_high);
            --rgb-background: transparent;
            color: var(--hms-ui-colors-on_surface_high);
            font-family: var(--hms-ui-fonts-sans);
          }
          .sticky {
            top: 0.25rem;
            background-color: var(--hms-ui-colors-surface_bright);
            margin-top: 0.5rem;
          }
        `;
        root == null ? void 0 : root.appendChild(style);
      }, 0);
    }
  }, [showing]);
  return ref;
};

// src/Prebuilt/components/Chat/ChatFooter.tsx
var TextArea2 = styled("textarea", {
  width: "100%",
  bg: "transparent",
  color: "$on_primary_high",
  resize: "none",
  lineHeight: "1rem",
  position: "relative",
  fontFamily: "$sans",
  fontSize: "100%",
  margin: 0,
  padding: 0,
  top: "$3",
  "&:focus": {
    boxShadow: "none",
    outline: "none"
  }
});
function EmojiPicker({ onSelect }) {
  const [showEmoji, setShowEmoji] = useState51(false);
  const ref = useEmojiPickerStyles(showEmoji);
  return /* @__PURE__ */ React116.createElement(Popover2.Root, { open: showEmoji, onOpenChange: setShowEmoji }, /* @__PURE__ */ React116.createElement(Popover2.Trigger, { asChild: true, css: { appearance: "none" } }, /* @__PURE__ */ React116.createElement(IconButton, { as: "div" }, /* @__PURE__ */ React116.createElement(EmojiIcon3, null))), /* @__PURE__ */ React116.createElement(Popover2.Portal, null, /* @__PURE__ */ React116.createElement(
    Popover2.Content,
    {
      alignOffset: -40,
      sideOffset: 16,
      align: "end",
      css: {
        p: 0
      }
    },
    /* @__PURE__ */ React116.createElement(
      Box,
      {
        css: {
          minWidth: 352,
          minHeight: 435
        },
        ref
      },
      /* @__PURE__ */ React116.createElement(Picker, { onEmojiSelect: onSelect, data: data2, previewPosition: "none", skinPosition: "search" })
    )
  )));
}
var ChatFooter = ({ onSend, children }) => {
  var _a8, _b7, _c, _d, _e;
  const hmsActions = useHMSActions40();
  const inputRef = useRef25(null);
  const [draftMessage, setDraftMessage] = useChatDraftMessage();
  const isMobile = useMedia18(config.media.md);
  const { elements, screenType } = useRoomLayoutConferencingScreen();
  const message_placeholder = ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.message_placeholder) || "Send a message";
  const localPeer = useHMSStore58(selectLocalPeer5);
  const isOverlayChat = (_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.is_overlay;
  const canDisableChat = !!((_d = (_c = elements == null ? void 0 : elements.chat) == null ? void 0 : _c.real_time_controls) == null ? void 0 : _d.can_disable_chat);
  const selectedPeer = useSubscribeChatSelector(CHAT_SELECTOR.PEER);
  const [selectedRole, setRoleSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.ROLE);
  const defaultSelection = useDefaultChatSelection();
  const selection = selectedPeer.name || selectedRole || defaultSelection;
  const isLocalPeerBlacklisted = useIsPeerBlacklisted({ local: true });
  const isMwebHLSStream = useMobileHLSStream();
  const [messageLengthExceeded, setMessageLengthExceeded] = useState51(false);
  const isLandscapeHLSStream = useLandscapeHLSStream();
  useEffect37(() => {
    var _a9, _b8;
    if (!selectedPeer.id && !selectedRole && !["Everyone", ""].includes(defaultSelection)) {
      setRoleSelector(defaultSelection);
    } else {
      if (!(isMobile || isLandscapeHLSStream) && !((_a9 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a9.disable_autofocus)) {
        (_b8 = inputRef.current) == null ? void 0 : _b8.focus();
      }
    }
  }, [defaultSelection, selectedPeer, selectedRole, setRoleSelector, isMobile, isLandscapeHLSStream, elements == null ? void 0 : elements.chat]);
  const resetInputHeight = useCallback29(() => {
    if (inputRef.current) {
      inputRef.current.style.height = `${Math.max(
        32,
        inputRef.current.value ? Math.min(inputRef.current.scrollHeight, 24 * 4) : 0
      )}px`;
    }
  }, []);
  const updateInputHeight = useCallback29(() => {
    if (inputRef.current) {
      inputRef.current.style.height = `${Math.max(32, Math.min(inputRef.current.scrollHeight, 24 * 4))}px`;
    }
  }, []);
  const sendMessage = useCallback29(() => __async(void 0, null, function* () {
    var _a9;
    const message = (_a9 = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a9.value;
    if (!message || !message.trim().length) {
      return;
    }
    try {
      if (selectedRole) {
        yield hmsActions.sendGroupMessage(message, [selectedRole]);
      } else if (selectedPeer.id) {
        yield hmsActions.sendDirectMessage(message, selectedPeer.id);
      } else {
        yield hmsActions.sendBroadcastMessage(message);
      }
      inputRef.current.value = "";
      resetInputHeight();
      setTimeout(() => {
        onSend(1);
      }, 0);
    } catch (error) {
      const err = error;
      ToastManager.addToast({
        title: err.message.startsWith("Invalid peer") ? `${selectedPeer.name} is not in this room` : err.message
      });
    }
  }), [selectedRole, selectedPeer, hmsActions, onSend]);
  useEffect37(() => {
    const messageElement = inputRef.current;
    if (messageElement) {
      messageElement.value = draftMessage;
      updateInputHeight();
      setMessageLengthExceeded(draftMessage.length > CHAT_MESSAGE_LIMIT);
    }
  }, [draftMessage]);
  useEffect37(() => {
    const messageElement = inputRef.current;
    return () => {
      setDraftMessage((messageElement == null ? void 0 : messageElement.value) || "");
    };
  }, [setDraftMessage]);
  if (isLocalPeerBlacklisted) {
    return null;
  }
  return /* @__PURE__ */ React116.createElement(Box, { css: { position: "relative" } }, /* @__PURE__ */ React116.createElement(Flex, null, /* @__PURE__ */ React116.createElement(ChatSelectorContainer, null), canDisableChat && isMobile && isOverlayChat ? /* @__PURE__ */ React116.createElement(Flex, { align: "center", justify: "end", css: { mb: "$4" }, onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React116.createElement(Popover2.Root, null, /* @__PURE__ */ React116.createElement(Popover2.Trigger, { asChild: true }, /* @__PURE__ */ React116.createElement(IconButton, { css: { border: "1px solid $border_bright" } }, /* @__PURE__ */ React116.createElement(VerticalMenuIcon7, { height: "16", width: "16" }))), /* @__PURE__ */ React116.createElement(Popover2.Portal, null, /* @__PURE__ */ React116.createElement(
    Popover2.Content,
    {
      align: "end",
      side: "top",
      onClick: () => {
        const chatState = {
          enabled: false,
          updatedBy: {
            peerId: localPeer == null ? void 0 : localPeer.id,
            userId: localPeer == null ? void 0 : localPeer.customerUserId,
            userName: localPeer == null ? void 0 : localPeer.name
          },
          updatedAt: Date.now()
        };
        hmsActions.sessionStore.set("chatState" /* CHAT_STATE */, chatState);
      },
      css: {
        backgroundColor: "$surface_default",
        display: "flex",
        alignItems: "center",
        gap: "$4",
        borderRadius: "$1",
        color: "$on_surface_high",
        cursor: "pointer",
        "&:hover": { backgroundColor: "$surface_dim" }
      }
    },
    /* @__PURE__ */ React116.createElement(PauseCircleIcon2, null),
    /* @__PURE__ */ React116.createElement(Text, { variant: "sm", css: { fontWeight: "$semiBold" } }, "Pause Chat")
  )))) : null), selection && /* @__PURE__ */ React116.createElement(Flex, { align: ((_e = inputRef.current) == null ? void 0 : _e.scrollHeight) === 32 ? "center" : "end", css: { gap: "$4", w: "100%" } }, /* @__PURE__ */ React116.createElement(
    Flex,
    {
      align: "end",
      css: __spreadValues({
        bg: isOverlayChat && isMobile ? "$surface_dim" : "$surface_default",
        minHeight: "$16",
        position: "relative",
        py: isOverlayChat && isMobile ? "$2" : "$6",
        pl: "$8",
        flexGrow: 1,
        r: "$1",
        "@md": {
          minHeight: "$14",
          boxSizing: "border-box"
        }
      }, isLandscapeHLSStream ? { minHeight: "$14", py: 0 } : {})
    },
    children,
    /* @__PURE__ */ React116.createElement(
      TextArea2,
      {
        maxLength: CHAT_MESSAGE_LIMIT + 10,
        css: {
          c: "$on_surface_high",
          "&:valid ~ .send-msg": { color: "$on_surface_high" },
          "& ~ .send-msg": { color: "$on_surface_low" },
          "&::placeholder": { color: "$on_surface_medium" },
          border: "none"
        },
        placeholder: message_placeholder,
        ref: inputRef,
        required: true,
        autoFocus: !(isMobile || isLandscapeHLSStream),
        onKeyPress: (event) => __async(void 0, null, function* () {
          if (event.key === "Enter") {
            if (!event.shiftKey && !messageLengthExceeded) {
              event.preventDefault();
              yield sendMessage();
            }
          }
        }),
        autoComplete: "off",
        "aria-autocomplete": "none",
        onChange: (e) => {
          updateInputHeight();
          setMessageLengthExceeded(e.target.value.length > CHAT_MESSAGE_LIMIT);
        },
        onBlur: resetInputHeight,
        onPaste: (e) => e.stopPropagation(),
        onCut: (e) => e.stopPropagation(),
        onCopy: (e) => e.stopPropagation()
      }
    ),
    !isMobile && !isLandscapeHLSStream ? /* @__PURE__ */ React116.createElement(
      EmojiPicker,
      {
        onSelect: (emoji) => {
          if (inputRef.current) {
            inputRef.current.value += ` ${emoji.native} `;
          }
        }
      }
    ) : null,
    /* @__PURE__ */ React116.createElement(
      IconButton,
      {
        className: "send-msg",
        onClick: sendMessage,
        disabled: messageLengthExceeded,
        css: {
          ml: "auto",
          height: "max-content",
          mr: "$4",
          "&:hover": { c: isMobile ? "" : "$on_surface_medium" }
        },
        "data-testid": "send_msg_btn"
      },
      /* @__PURE__ */ React116.createElement(SendIcon2, null)
    )
  ), (isMwebHLSStream || isLandscapeHLSStream) && /* @__PURE__ */ React116.createElement(React116.Fragment, null, /* @__PURE__ */ React116.createElement(
    Flex,
    {
      css: {
        alignItems: "center"
      },
      gap: "2"
    },
    /* @__PURE__ */ React116.createElement(RaiseHand, { css: { bg: "$surface_default" } }),
    /* @__PURE__ */ React116.createElement(MoreSettings, { elements, screenType })
  ))), messageLengthExceeded && /* @__PURE__ */ React116.createElement(Text, { variant: "xs", css: { color: "$alert_error_default", fontWeight: "$semiBold", mt: "$1", ml: "$7" } }, "Message cannot exceed 2000 characters"));
};

// src/Prebuilt/components/Chat/ChatStates.tsx
init_define_process_env();
import React117, { useCallback as useCallback30 } from "react";
import { selectLocalPeer as selectLocalPeer6, selectSessionStore as selectSessionStore7, useHMSActions as useHMSActions41, useHMSStore as useHMSStore59 } from "@100mslive/react-sdk";
var ChatPaused = () => {
  var _a8, _b7;
  const hmsActions = useHMSActions41();
  const { elements } = useRoomLayoutConferencingScreen();
  const can_disable_chat = !!((_b7 = (_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.real_time_controls) == null ? void 0 : _b7.can_disable_chat);
  const { enabled: isChatEnabled = true, updatedBy: chatStateUpdatedBy = "" } = useHMSStore59(selectSessionStore7("chatState" /* CHAT_STATE */)) || {};
  const localPeer = useHMSStore59(selectLocalPeer6);
  const unPauseChat = useCallback30(
    () => __async(void 0, null, function* () {
      return yield hmsActions.sessionStore.set("chatState" /* CHAT_STATE */, {
        enabled: true,
        updatedBy: { userName: localPeer == null ? void 0 : localPeer.name, userId: localPeer == null ? void 0 : localPeer.customerUserId, peerId: localPeer == null ? void 0 : localPeer.id },
        updatedAt: Date.now()
      });
    }),
    [hmsActions, localPeer]
  );
  return isChatEnabled ? null : /* @__PURE__ */ React117.createElement(
    Flex,
    {
      align: "center",
      justify: "between",
      css: { borderRadius: "$1", bg: "$surface_default", p: "$2 $4 $2 $8", w: "100%" }
    },
    /* @__PURE__ */ React117.createElement(Box, null, /* @__PURE__ */ React117.createElement(Text, { variant: "sm", css: { fontWeight: "$semiBold", color: "$on_surface_high" } }, "Chat paused"), /* @__PURE__ */ React117.createElement(
      Text,
      {
        variant: "xs",
        css: { color: "$on_surface_medium", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis" }
      },
      "Chat has been paused by ",
      (chatStateUpdatedBy == null ? void 0 : chatStateUpdatedBy.peerId) === (localPeer == null ? void 0 : localPeer.id) ? "you" : chatStateUpdatedBy == null ? void 0 : chatStateUpdatedBy.userName
    )),
    can_disable_chat ? /* @__PURE__ */ React117.createElement(Button, { css: { fontWeight: "$semiBold", fontSize: "$sm", borderRadius: "$2" }, onClick: unPauseChat }, "Resume") : /* @__PURE__ */ React117.createElement(React117.Fragment, null)
  );
};
var ChatBlocked = () => {
  const isLocalPeerBlacklisted = useIsPeerBlacklisted({ local: true });
  if (!isLocalPeerBlacklisted) {
    return null;
  }
  return /* @__PURE__ */ React117.createElement(
    Flex,
    {
      align: "center",
      justify: "between",
      css: { borderRadius: "$1", bg: "$surface_default", p: "$4 $4 $4 $8", w: "100%" }
    },
    /* @__PURE__ */ React117.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", textAlign: "center", w: "100%" } }, "You've been blocked from sending messages")
  );
};

// src/Prebuilt/components/Chat/PinnedMessage.tsx
init_define_process_env();
import React120, { useEffect as useEffect38, useState as useState52 } from "react";
import { useSwipeable } from "react-swipeable";
import { useMedia as useMedia19 } from "react-use";
import { selectSessionStore as selectSessionStore8, useHMSStore as useHMSStore60 } from "@100mslive/react-sdk";
import { PinIcon as PinIcon2, UnpinIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/Chat/ArrowNavigation.tsx
init_define_process_env();
import React118 from "react";
import { ChevronDownIcon as ChevronDownIcon6, ChevronUpIcon as ChevronUpIcon5 } from "@100mslive/react-icons";
var ArrowNavigation = ({
  total,
  index,
  showPrevious,
  showNext
}) => {
  if (total < 2) {
    return null;
  }
  return /* @__PURE__ */ React118.createElement(Flex, { direction: "column", css: { gap: "$1" } }, /* @__PURE__ */ React118.createElement(
    Flex,
    {
      onClick: showPrevious,
      css: index === 0 ? { cursor: "not-allowed", color: "$on_surface_low" } : { cursor: "pointer", color: "$on_surface_medium" }
    },
    /* @__PURE__ */ React118.createElement(ChevronUpIcon5, { height: 20, width: 20 })
  ), /* @__PURE__ */ React118.createElement(
    Flex,
    {
      onClick: showNext,
      css: index === total - 1 ? { cursor: "not-allowed", color: "$on_surface_low" } : { cursor: "pointer", color: "$on_surface_medium" }
    },
    /* @__PURE__ */ React118.createElement(ChevronDownIcon6, { height: 20, width: 20 })
  ));
};

// src/Prebuilt/components/Chat/StickIndicator.tsx
init_define_process_env();
import React119 from "react";
var StickIndicator = ({ total, index }) => {
  const sticksCount = Math.min(3, total);
  if (total < 2) {
    return null;
  }
  return /* @__PURE__ */ React119.createElement(Flex, { direction: "column", css: { gap: "$1" } }, [...Array(sticksCount)].map((_, i) => /* @__PURE__ */ React119.createElement(
    Box,
    {
      css: {
        borderLeft: "2px solid",
        height: "$4",
        borderColor: i === index ? "$on_surface_high" : "$on_surface_low"
      }
    }
  )));
};

// src/Prebuilt/components/Chat/PinnedMessage.tsx
var PINNED_MESSAGE_LENGTH = 75;
var PinnedMessage = () => {
  var _a8, _b7, _c, _d;
  const pinnedMessages = useHMSStore60(selectSessionStore8("pinnedMessages" /* PINNED_MESSAGES */));
  const [pinnedMessageIndex, setPinnedMessageIndex] = useState52(0);
  const { removePinnedMessage } = usePinnedMessages();
  const isMobile = useMedia19(config.media.md);
  const { elements } = useRoomLayoutConferencingScreen();
  const canUnpinMessage = !!((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.allow_pinning_messages);
  const [hideOverflow, setHideOverflow] = useState52(true);
  const currentPinnedMessage = ((_b7 = pinnedMessages == null ? void 0 : pinnedMessages[pinnedMessageIndex]) == null ? void 0 : _b7.text) || "";
  const canOverflow = currentPinnedMessage.length > PINNED_MESSAGE_LENGTH;
  const showPreviousPinnedMessage = () => {
    const previousIndex = Math.max(pinnedMessageIndex - 1, 0);
    setHideOverflow(pinnedMessages[previousIndex].text.length > PINNED_MESSAGE_LENGTH);
    setPinnedMessageIndex(previousIndex);
  };
  const showNextPinnedMessage = () => {
    const nextIndex = Math.min(pinnedMessageIndex + 1, pinnedMessages.length - 1);
    setHideOverflow(pinnedMessages[nextIndex].text.length > PINNED_MESSAGE_LENGTH);
    setPinnedMessageIndex(nextIndex);
  };
  const swipeHandlers = useSwipeable({
    onSwipedUp: () => showNextPinnedMessage(),
    onSwipedDown: () => showPreviousPinnedMessage()
  });
  useEffect38(() => {
    const count = (pinnedMessages == null ? void 0 : pinnedMessages.length) || 1;
    if (pinnedMessageIndex >= count) {
      setPinnedMessageIndex(count - 1);
    }
  }, [pinnedMessageIndex, pinnedMessages]);
  if (!pinnedMessages || pinnedMessages.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React120.createElement(Flex, { align: "center", css: { w: "100%", gap: "$4" } }, !isMobile ? /* @__PURE__ */ React120.createElement(
    ArrowNavigation,
    {
      index: pinnedMessageIndex,
      total: pinnedMessages.length,
      showPrevious: showPreviousPinnedMessage,
      showNext: showNextPinnedMessage
    }
  ) : null, /* @__PURE__ */ React120.createElement(
    Flex,
    {
      css: {
        p: "$4",
        color: "$on_surface_high",
        bg: isMobile && ((_c = elements == null ? void 0 : elements.chat) == null ? void 0 : _c.is_overlay) ? "rgba(0, 0, 0, 0.64)" : "$surface_brighter",
        r: "$1",
        gap: "$4",
        mb: "$8",
        mt: "$8",
        flexGrow: 1,
        border: "1px solid $border_bright"
      },
      align: "center",
      justify: "between"
    },
    isMobile ? /* @__PURE__ */ React120.createElement(StickIndicator, { index: pinnedMessageIndex, total: pinnedMessages.length }) : null,
    /* @__PURE__ */ React120.createElement(
      Box,
      {
        css: {
          w: "100%",
          maxHeight: "$18",
          overflowY: "auto",
          overflowX: "hidden",
          wordBreak: "break-word",
          "& p span": {
            color: "$primary_default"
          }
        }
      },
      /* @__PURE__ */ React120.createElement(
        Text,
        __spreadProps(__spreadValues({
          variant: "sm",
          css: { color: "$on_surface_high" }
        }, swipeHandlers), {
          title: (_d = pinnedMessages[pinnedMessageIndex]) == null ? void 0 : _d.text
        }),
        /* @__PURE__ */ React120.createElement(
          AnnotisedMessage,
          {
            message: currentPinnedMessage,
            length: hideOverflow ? PINNED_MESSAGE_LENGTH : currentPinnedMessage.length
          }
        ),
        canOverflow ? /* @__PURE__ */ React120.createElement("span", { style: { cursor: "pointer" }, onClick: () => setHideOverflow((prev) => !prev) }, "\xA0", hideOverflow ? "... See more" : "Collapse") : null
      )
    ),
    canUnpinMessage ? /* @__PURE__ */ React120.createElement(
      Flex,
      {
        onClick: () => {
          removePinnedMessage(pinnedMessageIndex);
          setPinnedMessageIndex(Math.max(0, pinnedMessageIndex - 1));
        },
        css: {
          cursor: "pointer",
          color: "$on_surface_medium",
          "&:hover": { color: "$on_surface_high" },
          "&:hover .hide-on-hover": { display: "none !important" },
          "&:hover .show-on-hover": { display: "block !important" }
        },
        title: "Unpin Message"
      },
      /* @__PURE__ */ React120.createElement(UnpinIcon, { className: "show-on-hover", style: { display: "none" }, height: 20, width: 20 }),
      /* @__PURE__ */ React120.createElement(PinIcon2, { className: "hide-on-hover", style: { display: "block" }, height: 20, width: 20 })
    ) : null
  ));
};

// src/Prebuilt/components/Chat/Chat.tsx
var Chat = () => {
  var _a8, _b7;
  const { elements, screenType } = useRoomLayoutConferencingScreen();
  const listRef = useRef26(null);
  const hmsActions = useHMSActions42();
  const vanillaStore = useHMSVanillaStore11();
  const { enabled: isChatEnabled = true } = useHMSStore61(pS("chatState" /* CHAT_STATE */)) || {};
  const isMobile = useMedia20(config.media.md);
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeStream = useLandscapeHLSStream();
  useSidepaneResetOnLayoutUpdate("chat", SIDE_PANE_OPTIONS.CHAT);
  const isLocalPeerBlacklisted = useIsPeerBlacklisted({ local: true });
  const scrollToBottom = useCallback31(
    (unreadCount = 0) => {
      var _a9;
      if (listRef.current && listRef.current.scrollToItem && unreadCount > 0) {
        const messagesCount = vanillaStore.getState(selectHMSMessagesCount);
        (_a9 = listRef.current) == null ? void 0 : _a9.scrollToItem(messagesCount, "end");
        requestAnimationFrame(() => {
          var _a10;
          (_a10 = listRef.current) == null ? void 0 : _a10.scrollToItem(messagesCount, "end");
        });
        hmsActions.setMessageRead(true);
      }
    },
    [hmsActions, vanillaStore]
  );
  const streaming = isMobileHLSStream || isLandscapeStream;
  return /* @__PURE__ */ React121.createElement(
    Flex,
    {
      direction: "column",
      justify: "end",
      css: {
        size: "100%",
        gap: "$4"
      }
    },
    isMobile && ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.is_overlay) && !streaming ? null : /* @__PURE__ */ React121.createElement(PinnedMessage, null),
    /* @__PURE__ */ React121.createElement(ChatBody, { ref: listRef, scrollToBottom }),
    /* @__PURE__ */ React121.createElement(Flex, { align: "center", css: { w: "100%", gap: "$2" } }, /* @__PURE__ */ React121.createElement(ChatPaused, null), /* @__PURE__ */ React121.createElement(ChatBlocked, null), streaming && (!isChatEnabled || isLocalPeerBlacklisted) && /* @__PURE__ */ React121.createElement(React121.Fragment, null, /* @__PURE__ */ React121.createElement(RaiseHand, { css: { bg: "$surface_default" } }), /* @__PURE__ */ React121.createElement(MoreSettings, { elements, screenType }))),
    isMobile && ((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.is_overlay) && !streaming ? /* @__PURE__ */ React121.createElement(PinnedMessage, null) : null,
    isChatEnabled ? /* @__PURE__ */ React121.createElement(ChatFooter, { onSend: scrollToBottom }, /* @__PURE__ */ React121.createElement(NewMessageIndicator, { scrollToBottom, listRef })) : null,
    streaming && /* @__PURE__ */ React121.createElement(
      Box,
      {
        css: __spreadValues({
          position: "absolute"
        }, match10({ isLandscapeStream, isMobileHLSStream, isChatEnabled, isLocalPeerBlacklisted }).with(
          {
            isLandscapeStream: true,
            isChatEnabled: true
          },
          () => ({ bottom: "$19", right: "$10" })
        ).with(
          {
            isLandscapeStream: true,
            isChatEnabled: false
          },
          () => ({ bottom: "$20", right: "$10" })
        ).with(
          {
            isMobileHLSStream: true,
            isChatEnabled: false
          },
          () => ({ bottom: "$19", right: "$8" })
        ).with(
          {
            isMobileHLSStream: true,
            isChatEnabled: true,
            isLocalPeerBlacklisted: false
          },
          () => ({ bottom: "$17", right: "$8" })
        ).with(
          {
            isLandscapeStream: false,
            isChatEnabled: true,
            isLocalPeerBlacklisted: true
          },
          () => ({ bottom: "$18", right: "$8" })
        ).with(
          {
            isMobileHLSStream: true,
            isLocalPeerBlacklisted: true
          },
          () => ({ bottom: "$20", right: "$8" })
        ).otherwise(() => ({})))
      },
      /* @__PURE__ */ React121.createElement(EmojiReaction, null)
    )
  );
};
var NewMessageIndicator = ({
  scrollToBottom,
  listRef
}) => {
  const unreadCount = useHMSStore61(_m);
  if (!unreadCount || !listRef.current) {
    return null;
  }
  const outerElement = listRef.current._outerRef;
  if (outerElement && outerElement.clientHeight + outerElement.scrollTop + outerElement.offsetTop >= outerElement.scrollHeight) {
    return null;
  }
  return /* @__PURE__ */ React121.createElement(
    Flex,
    {
      justify: "center",
      css: {
        width: "100%",
        left: 0,
        bottom: "$28",
        position: "absolute"
      }
    },
    /* @__PURE__ */ React121.createElement(
      Button,
      {
        variant: "standard",
        onClick: () => {
          scrollToBottom(unreadCount);
        },
        icon: true,
        css: {
          p: "$3 $4",
          pl: "$6",
          "& > svg": { ml: "$4" },
          borderRadius: "$round",
          fontSize: "$xs",
          fontWeight: "$semiBold",
          c: "$on_secondary_high"
        }
      },
      "New ",
      unreadCount === 1 ? "message" : "messages",
      /* @__PURE__ */ React121.createElement(ChevronDownIcon7, { height: 16, width: 16 })
    )
  );
};

// src/Prebuilt/components/Footer/PaginatedParticipants.tsx
init_define_process_env();
import React122, { useEffect as useEffect39, useState as useState53 } from "react";
import { useInView } from "react-intersection-observer";
import { useMeasure as useMeasure2 } from "react-use";
import { VariableSizeList as VariableSizeList2 } from "react-window";
import { selectIsConnectedToRoom as selectIsConnectedToRoom8, useHMSStore as useHMSStore62, usePaginatedParticipants as usePaginatedParticipants2 } from "@100mslive/react-sdk";
import { ChevronLeftIcon as ChevronLeftIcon6, CrossIcon as CrossIcon22 } from "@100mslive/react-icons";
var LoadMoreParticipants = ({
  hasNext,
  loadMore,
  style
}) => {
  const { ref, inView } = useInView();
  const [inProgress, setInProgress] = useState53(false);
  useEffect39(() => {
    if (hasNext && inView && !inProgress) {
      setInProgress(true);
      loadMore().catch(console.error).finally(() => setInProgress(false));
    }
  }, [hasNext, loadMore, inView, inProgress]);
  return /* @__PURE__ */ React122.createElement(Flex, { ref, style, align: "center", justify: "center" }, inProgress ? /* @__PURE__ */ React122.createElement(Loading, { size: 16 }) : null);
};
var VirtualizedParticipantItem2 = React122.memo(
  ({
    index,
    data: data3,
    style
  }) => {
    if (!data3.peerList[index]) {
      return /* @__PURE__ */ React122.createElement(LoadMoreParticipants, { hasNext: data3.hasNext, loadMore: data3.loadMorePeers, style });
    }
    return /* @__PURE__ */ React122.createElement(
      Participant,
      {
        key: data3.peerList[index].id,
        peer: data3.peerList[index],
        isConnected: data3.isConnected,
        style
      }
    );
  }
);
var PaginatedParticipants = ({ roleName, onBack }) => {
  const { peers, total, hasNext, loadPeers, loadMorePeers } = usePaginatedParticipants2({ role: roleName, limit: 20 });
  const [search, setSearch] = useState53("");
  const filteredPeers = peers.filter((p) => {
    var _a8;
    return (_a8 = p.name) == null ? void 0 : _a8.toLowerCase().includes(search == null ? void 0 : search.toLowerCase());
  });
  const isConnected = useHMSStore62(selectIsConnectedToRoom8);
  const [ref, { width }] = useMeasure2();
  const height = ROW_HEIGHT * (filteredPeers.length + 1);
  const resetSidePane = useSidepaneReset();
  useEffect39(() => {
    loadPeers();
  }, []);
  return /* @__PURE__ */ React122.createElement(Flex, { ref, direction: "column", css: { size: "100%", gap: "$4" } }, /* @__PURE__ */ React122.createElement(Flex, { align: "center" }, /* @__PURE__ */ React122.createElement(Flex, { align: "center", css: { flex: "1 1 0", cursor: "pointer" }, onClick: onBack }, /* @__PURE__ */ React122.createElement(ChevronLeftIcon6, null), /* @__PURE__ */ React122.createElement(Text, { variant: "lg", css: { flex: "1 1 0" } }, "Participants")), /* @__PURE__ */ React122.createElement(
    IconButton,
    {
      onClick: (e) => {
        e.stopPropagation();
        resetSidePane();
      },
      "data-testid": "close_sidepane"
    },
    /* @__PURE__ */ React122.createElement(CrossIcon22, null)
  )), /* @__PURE__ */ React122.createElement(ParticipantSearch, { onSearch: (search2) => setSearch(search2), placeholder: `Search for ${roleName}` }), /* @__PURE__ */ React122.createElement(Flex, { direction: "column", css: { border: "1px solid $border_default", borderRadius: "$1", flex: "1 1 0" } }, /* @__PURE__ */ React122.createElement(Flex, { align: "center", css: { height: ROW_HEIGHT, borderBottom: "1px solid $border_default", px: "$8" } }, /* @__PURE__ */ React122.createElement(Text, { css: { fontSize: "$space$7" } }, roleName, "(", getFormattedCount(peers.length), "/", getFormattedCount(total), ")")), /* @__PURE__ */ React122.createElement(Box, { css: { flex: "1 1 0", overflowY: "auto", overflowX: "hidden", mr: "-$10" } }, /* @__PURE__ */ React122.createElement(
    VariableSizeList2,
    {
      itemSize: (index) => index === filteredPeers.length + 1 ? 16 : ROW_HEIGHT,
      itemData: { peerList: filteredPeers, hasNext: hasNext(), loadMorePeers, isConnected: isConnected === true },
      itemKey,
      itemCount: filteredPeers.length + 1,
      width,
      height
    },
    VirtualizedParticipantItem2
  ))));
};

// src/Prebuilt/components/ChatSettings.tsx
init_define_process_env();
import React123 from "react";
import { selectLocalPeer as selectLocalPeer7, selectSessionStore as selectSessionStore9, useHMSActions as useHMSActions43, useHMSStore as useHMSStore63 } from "@100mslive/react-sdk";
import { PauseCircleIcon as PauseCircleIcon3, SettingsIcon as SettingsIcon5 } from "@100mslive/react-icons";
var ChatSettings = () => {
  var _a8, _b7;
  const hmsActions = useHMSActions43();
  const localPeer = useHMSStore63(selectLocalPeer7);
  const { elements } = useRoomLayoutConferencingScreen();
  const canPauseChat = !!((_b7 = (_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.real_time_controls) == null ? void 0 : _b7.can_disable_chat);
  const { enabled: isChatEnabled = true } = useHMSStore63(selectSessionStore9("chatState" /* CHAT_STATE */)) || {};
  const showPause = canPauseChat && isChatEnabled;
  if (!showPause) {
    return null;
  }
  return /* @__PURE__ */ React123.createElement(Popover2.Root, null, /* @__PURE__ */ React123.createElement(Popover2.Trigger, { asChild: true, css: { px: "$4" } }, /* @__PURE__ */ React123.createElement(
    Flex,
    {
      align: "center",
      css: { color: "$on_surface_medium", "&:hover": { color: "$on_surface_high" }, cursor: "pointer" }
    },
    /* @__PURE__ */ React123.createElement(SettingsIcon5, null)
  )), /* @__PURE__ */ React123.createElement(Popover2.Portal, null, /* @__PURE__ */ React123.createElement(
    Popover2.Content,
    {
      align: "end",
      side: "bottom",
      sideOffset: 2,
      onClick: () => {
        const chatState = {
          enabled: false,
          updatedBy: {
            peerId: localPeer == null ? void 0 : localPeer.id,
            userId: localPeer == null ? void 0 : localPeer.customerUserId,
            userName: localPeer == null ? void 0 : localPeer.name
          },
          updatedAt: Date.now()
        };
        hmsActions.sessionStore.set("chatState" /* CHAT_STATE */, chatState);
      },
      css: {
        backgroundColor: "$surface_default",
        display: "flex",
        alignItems: "center",
        gap: "$4",
        borderRadius: "$1",
        color: "$on_surface_high",
        cursor: "pointer",
        "&:hover": { backgroundColor: "$surface_dim" }
      }
    },
    /* @__PURE__ */ React123.createElement(PauseCircleIcon3, null),
    /* @__PURE__ */ React123.createElement(Text, { variant: "sm", css: { fontWeight: "$semiBold" } }, "Pause Chat")
  )));
};

// src/Prebuilt/components/SidePaneTabs.tsx
var tabTriggerCSS = {
  color: "$on_surface_low",
  p: "$4",
  fontWeight: "$semiBold",
  fontSize: "$sm",
  w: "100%",
  justifyContent: "center",
  '&[data-state="active"]': {
    color: "$on_surface_high"
  }
};
var ParticipantCount2 = ({ count }) => {
  return count < 1e3 ? /* @__PURE__ */ React124.createElement("span", null, "(", count, ")") : /* @__PURE__ */ React124.createElement(Tooltip, { title: count }, /* @__PURE__ */ React124.createElement("span", null, "(", getFormattedCount(count), ")"));
};
var SidePaneTabs = React124.memo(({ active = SIDE_PANE_OPTIONS.CHAT, hideTab = false }) => {
  var _a8, _b7;
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  const toggleParticipants = useSidepaneToggle(SIDE_PANE_OPTIONS.PARTICIPANTS);
  const resetSidePane = useSidepaneReset();
  const [activeTab, setActiveTab] = useState54(active);
  const [activeRole, setActiveRole] = useState54("");
  const peerCount = useHMSStore64(selectPeerCount5);
  const { elements, screenType } = useRoomLayoutConferencingScreen();
  const chat_title = ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.chat_title) || "Chat";
  const showChat = !!(elements == null ? void 0 : elements.chat);
  const showParticipants = !!(elements == null ? void 0 : elements.participant_list);
  const hideTabs = !(showChat && showParticipants) || hideTab;
  const isMobile = useMedia21(config.media.md);
  const isOverlayChat = !!((_b7 = elements == null ? void 0 : elements.chat) == null ? void 0 : _b7.is_overlay) && isMobile;
  const { off_stage_roles = [] } = (elements == null ? void 0 : elements.on_stage_exp) || {};
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  const showChatSettings = showChat && isChatOpen && (!isMobile || !isOverlayChat);
  useEffect40(() => {
    match11({ activeTab, showChat, showParticipants }).with({ activeTab: SIDE_PANE_OPTIONS.CHAT, showChat: false, showParticipants: true }, () => {
      setActiveTab(SIDE_PANE_OPTIONS.PARTICIPANTS);
    }).with({ activeTab: SIDE_PANE_OPTIONS.PARTICIPANTS, showChat: true, showParticipants: false }, () => {
      setActiveTab(SIDE_PANE_OPTIONS.CHAT);
    }).with({ showChat: false, showParticipants: false }, () => {
      resetSidePane();
    });
  }, [showChat, activeTab, showParticipants, resetSidePane]);
  useEffect40(() => {
    setActiveTab(active);
  }, [active]);
  if (activeRole) {
    return /* @__PURE__ */ React124.createElement(
      Flex,
      {
        direction: "column",
        css: {
          color: "$on_primary_high",
          h: "100%",
          transition: "margin 0.3s ease-in-out",
          position: "relative"
        }
      },
      /* @__PURE__ */ React124.createElement(Box, { css: { position: "absolute", left: 0, top: 0, size: "100%", zIndex: 21, bg: "$surface_dim" } }, /* @__PURE__ */ React124.createElement(PaginatedParticipants, { roleName: activeRole, onBack: () => setActiveRole("") }))
    );
  }
  return /* @__PURE__ */ React124.createElement(
    Flex,
    {
      direction: "column",
      css: {
        color: "$on_primary_high",
        h: "100%",
        transition: "margin 0.3s ease-in-out"
      }
    },
    match11({ isOverlayChat, isChatOpen, showChat, hideTabs }).with({ isOverlayChat: true, isChatOpen: true, showChat: true }, () => /* @__PURE__ */ React124.createElement(Chat, null)).with({ hideTabs: true }, () => {
      return /* @__PURE__ */ React124.createElement(React124.Fragment, null, /* @__PURE__ */ React124.createElement(Flex, { justify: "between", css: { w: "100%", "&:empty": { display: "none" } } }, /* @__PURE__ */ React124.createElement(
        Text,
        {
          variant: "sm",
          css: {
            fontWeight: "$semiBold",
            p: "$4",
            c: "$on_surface_high",
            pr: "$12",
            "&:empty": { display: "none" }
          }
        },
        activeTab === SIDE_PANE_OPTIONS.CHAT ? screenType !== "hls_live_streaming" && chat_title : /* @__PURE__ */ React124.createElement("span", null, "Participants\xA0", /* @__PURE__ */ React124.createElement(ParticipantCount2, { count: peerCount }))
      ), /* @__PURE__ */ React124.createElement(Flex, null, showChatSettings ? /* @__PURE__ */ React124.createElement(ChatSettings, null) : null, isOverlayChat && isChatOpen ? null : /* @__PURE__ */ React124.createElement(
        IconButton,
        {
          css: {
            my: "$1",
            color: "$on_surface_medium",
            "&:hover": { color: "$on_surface_high" },
            "&:empty": { display: "none" }
          },
          onClick: (e) => {
            e.stopPropagation();
            if (activeTab === SIDE_PANE_OPTIONS.CHAT) {
              toggleChat();
            } else {
              toggleParticipants();
            }
          },
          "data-testid": "close_chat"
        },
        screenType === "hls_live_streaming" && isChatOpen ? null : /* @__PURE__ */ React124.createElement(CrossIcon23, null)
      ))), activeTab === SIDE_PANE_OPTIONS.CHAT ? /* @__PURE__ */ React124.createElement(Chat, null) : /* @__PURE__ */ React124.createElement(ParticipantList, { offStageRoles: off_stage_roles, onActive: setActiveRole }));
    }).otherwise(() => {
      return /* @__PURE__ */ React124.createElement(
        Tabs.Root,
        {
          value: activeTab,
          onValueChange: setActiveTab,
          css: {
            flexDirection: "column",
            size: "100%"
          }
        },
        /* @__PURE__ */ React124.createElement(Flex, { css: { w: "100%" } }, /* @__PURE__ */ React124.createElement(Tabs.List, { css: { flexGrow: 1, borderRadius: "$2", bg: "$surface_default" } }, /* @__PURE__ */ React124.createElement(Tabs.Trigger, { value: SIDE_PANE_OPTIONS.CHAT, onClick: toggleChat, css: tabTriggerCSS }, chat_title), /* @__PURE__ */ React124.createElement(Tabs.Trigger, { value: SIDE_PANE_OPTIONS.PARTICIPANTS, onClick: toggleParticipants, css: tabTriggerCSS }, "Participants\xA0", /* @__PURE__ */ React124.createElement(ParticipantCount2, { count: peerCount }))), showChatSettings ? /* @__PURE__ */ React124.createElement(ChatSettings, null) : null, isOverlayChat && isChatOpen ? null : /* @__PURE__ */ React124.createElement(
          IconButton,
          {
            css: { my: "$1", color: "$on_surface_medium", "&:hover": { color: "$on_surface_high" } },
            onClick: (e) => {
              e.stopPropagation();
              if (activeTab === SIDE_PANE_OPTIONS.CHAT) {
                toggleChat();
              } else {
                toggleParticipants();
              }
            },
            "data-testid": "close_chat"
          },
          /* @__PURE__ */ React124.createElement(CrossIcon23, null)
        )),
        /* @__PURE__ */ React124.createElement(Tabs.Content, { value: SIDE_PANE_OPTIONS.PARTICIPANTS, css: { p: 0 } }, /* @__PURE__ */ React124.createElement(ParticipantList, { offStageRoles: off_stage_roles, onActive: setActiveRole })),
        /* @__PURE__ */ React124.createElement(Tabs.Content, { value: SIDE_PANE_OPTIONS.CHAT, css: { p: 0 } }, /* @__PURE__ */ React124.createElement(Chat, null))
      );
    })
  );
});

// src/Prebuilt/components/VideoTile.tsx
init_define_process_env();
import React128, { useCallback as useCallback32, useMemo as useMemo14, useState as useState56 } from "react";
import { useMeasure as useMeasure3 } from "react-use";
import {
  selectAudioTrackByPeerID as selectAudioTrackByPeerID2,
  selectHasPeerHandRaised as selectHasPeerHandRaised3,
  selectIsPeerAudioEnabled as selectIsPeerAudioEnabled2,
  selectLocalPeerID as selectLocalPeerID11,
  selectPeerMetadata as selectPeerMetadata4,
  selectPeerNameByID as selectPeerNameByID5,
  selectVideoTrackByID as selectVideoTrackByID3,
  selectVideoTrackByPeerID as selectVideoTrackByPeerID3,
  useHMSStore as useHMSStore68
} from "@100mslive/react-sdk";
import { BrbTileIcon, HandIcon as HandIcon5, MicOffIcon as MicOffIcon6 } from "@100mslive/react-icons";

// src/Prebuilt/components/Connection/TileConnection.tsx
init_define_process_env();
import React125 from "react";
import {
  HMSPeerType as HMSPeerType4,
  selectPeerTypeByID as selectPeerTypeByID2,
  selectScreenShareByPeerID,
  selectSessionStore as selectSessionStore10,
  useHMSStore as useHMSStore65
} from "@100mslive/react-sdk";
import { CallIcon as CallIcon2, PinIcon as PinIcon3, ShareScreenIcon as ShareScreenIcon2, SpotlightIcon } from "@100mslive/react-icons";
var TileConnection = ({
  name,
  peerId,
  hideLabel,
  width,
  pinned
}) => {
  const spotlighted = useHMSStore65(selectSessionStore10("spotlight" /* SPOTLIGHT */)) === peerId;
  const isPeerScreenSharing = !!useHMSStore65(selectScreenShareByPeerID(peerId));
  const peerType = useHMSStore65(selectPeerTypeByID2(peerId));
  return /* @__PURE__ */ React125.createElement(Wrapper2, null, !hideLabel ? /* @__PURE__ */ React125.createElement(React125.Fragment, null, name ? /* @__PURE__ */ React125.createElement(Flex, { align: "center" }, peerType === HMSPeerType4.SIP && /* @__PURE__ */ React125.createElement(IconWrapper, null, /* @__PURE__ */ React125.createElement(CallIcon2, { width: "15", height: "15" })), isPeerScreenSharing && /* @__PURE__ */ React125.createElement(IconWrapper, null, /* @__PURE__ */ React125.createElement(ShareScreenIcon2, { width: "15", height: "15" })), pinned && /* @__PURE__ */ React125.createElement(IconWrapper, null, /* @__PURE__ */ React125.createElement(PinIcon3, { width: "15", height: "15" })), spotlighted && /* @__PURE__ */ React125.createElement(IconWrapper, null, /* @__PURE__ */ React125.createElement(SpotlightIcon, { width: "15", height: "15" })), /* @__PURE__ */ React125.createElement(
    Text,
    {
      css: __spreadValues({
        c: "$on_surface_high",
        verticalAlign: "baseline"
      }, width ? textEllipsis(width - 60) : {}),
      variant: "xs"
    },
    name
  )) : null, /* @__PURE__ */ React125.createElement(ConnectionIndicator, { isTile: true, peerId, hideBg: true })) : null);
};
var IconWrapper = styled("div", { c: "$on_surface_high", ml: "$3", mt: "$1", display: "flex" });
var Wrapper2 = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "absolute",
  bottom: "$2",
  left: "$2",
  backgroundColor: "$background_dim",
  borderRadius: "$1",
  maxWidth: "85%",
  zIndex: 1,
  "& p,span": {
    p: "$2 $3"
  }
});
var TileConnection_default = TileConnection;

// src/Prebuilt/components/TileMenu/TileMenu.tsx
init_define_process_env();
import React127, { useState as useState55 } from "react";
import { useMedia as useMedia23 } from "react-use";
import {
  selectLocalPeerID as selectLocalPeerID10,
  selectPeerByID as selectPeerByID2,
  selectPermissions as selectPermissions19,
  selectTrackByID as selectTrackByID3,
  selectVideoTrackByPeerID as selectVideoTrackByPeerID2,
  useHMSStore as useHMSStore67,
  useRemoteAVToggle as useRemoteAVToggle2
} from "@100mslive/react-sdk";
import { CrossIcon as CrossIcon24, VerticalMenuIcon as VerticalMenuIcon8 } from "@100mslive/react-icons";

// src/Prebuilt/components/peerTileUtils.tsx
init_define_process_env();
var PEER_NAME_PLACEHOLDER = "peerName";
var labelMap = /* @__PURE__ */ new Map([
  [[true, "screen"].toString(), "Your Screen"],
  [[true, "regular"].toString(), `You (${PEER_NAME_PLACEHOLDER})`],
  [[false, "screen"].toString(), `${PEER_NAME_PLACEHOLDER}'s Screen`],
  [[false, "regular"].toString(), PEER_NAME_PLACEHOLDER],
  [[true, void 0].toString(), `You (${PEER_NAME_PLACEHOLDER})`],
  [[false, void 0].toString(), `${PEER_NAME_PLACEHOLDER}`]
]);
var getVideoTileLabel = ({
  peerName,
  isLocal,
  videoTrack,
  audioTrack
}) => {
  const isPeerPresent = peerName !== void 0;
  if (!isPeerPresent || !videoTrack) {
    const label2 = labelMap.get([isLocal, void 0].toString());
    return isPeerPresent && label2 ? label2.replace(PEER_NAME_PLACEHOLDER, peerName) : "";
  }
  const isLocallyMuted = (audioTrack == null ? void 0 : audioTrack.volume) === 0;
  let label = labelMap.get([isLocal, videoTrack.source].toString());
  if (label) {
    label = label.replace(PEER_NAME_PLACEHOLDER, peerName);
  } else {
    label = `${peerName} ${videoTrack.source}`;
  }
  return `${label}${isLocallyMuted ? " (Muted for you)" : ""}`;
};

// src/Prebuilt/components/TileMenu/TileMenuContent.tsx
init_define_process_env();
import React126, { Fragment as Fragment11 } from "react";
import { useMedia as useMedia22 } from "react-use";
import {
  selectAvailableRoleNames as selectAvailableRoleNames6,
  selectPermissions as selectPermissions18,
  selectSessionStore as selectSessionStore11,
  selectTrackByID as selectTrackByID2,
  useCustomEvent as useCustomEvent2,
  useHMSActions as useHMSActions44,
  useHMSStore as useHMSStore66,
  useRemoteAVToggle
} from "@100mslive/react-sdk";
import {
  MicOffIcon as MicOffIcon5,
  MicOnIcon as MicOnIcon4,
  PencilIcon,
  PersonSettingsIcon as PersonSettingsIcon2,
  PinIcon as PinIcon4,
  RemoveUserIcon as RemoveUserIcon2,
  ShareScreenIcon as ShareScreenIcon3,
  ShrinkIcon,
  SpeakerIcon as SpeakerIcon3,
  StarIcon as StarIcon2,
  VideoOffIcon as VideoOffIcon3,
  VideoOnIcon as VideoOnIcon4
} from "@100mslive/react-icons";

// src/Prebuilt/components/TileMenu/utils.ts
init_define_process_env();
var getDragClassName = () => {
  return (navigator == null ? void 0 : navigator.maxTouchPoints) > 0 ? "__cancel-drag-event" : "";
};

// src/Prebuilt/components/TileMenu/TileMenuContent.tsx
var isSameTile = ({
  trackId,
  videoTrackID,
  audioTrackID
}) => !!trackId && (!!videoTrackID && videoTrackID === trackId || !!audioTrackID && audioTrackID === trackId);
var spacingCSS = { "@md": { my: "$8", fontWeight: "$semiBold", fontSize: "sm" } };
var SpotlightActions = ({
  peerId,
  onSpotLightClick = () => {
    return;
  }
}) => {
  const hmsActions = useHMSActions44();
  const spotlightPeerId = useHMSStore66(selectSessionStore11("spotlight" /* SPOTLIGHT */));
  const isTileSpotlighted = spotlightPeerId === peerId;
  const dragClassName = getDragClassName();
  const setSpotlightPeerId = (peerIdToSpotlight) => hmsActions.sessionStore.set("spotlight" /* SPOTLIGHT */, peerIdToSpotlight).catch((err) => ToastManager.addToast({ title: err.description }));
  return /* @__PURE__ */ React126.createElement(
    StyledMenuTile.ItemButton,
    {
      className: dragClassName,
      css: spacingCSS,
      onClick: () => {
        if (isTileSpotlighted) {
          setSpotlightPeerId();
        } else {
          setSpotlightPeerId(peerId);
        }
        onSpotLightClick();
      }
    },
    /* @__PURE__ */ React126.createElement(StarIcon2, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, isTileSpotlighted ? "Remove from Spotlight" : "Spotlight Tile for everyone")
  );
};
var PinActions = ({ audioTrackID, videoTrackID }) => {
  const [pinnedTrackId, setPinnedTrackId] = useSetAppDataByKey(APP_DATA.pinnedTrackId);
  const dragClassName = getDragClassName();
  const isTilePinned = isSameTile({
    trackId: pinnedTrackId,
    videoTrackID,
    audioTrackID
  });
  return /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement(
    StyledMenuTile.ItemButton,
    {
      className: dragClassName,
      css: spacingCSS,
      onClick: () => isTilePinned ? setPinnedTrackId() : setPinnedTrackId(videoTrackID || audioTrackID)
    },
    /* @__PURE__ */ React126.createElement(PinIcon4, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, isTilePinned ? "Unpin" : "Pin", " Tile for myself")
  ));
};
var MinimiseInset = () => {
  const [minimised, setMinimised] = useSetAppDataByKey(APP_DATA.minimiseInset);
  const dragClassName = getDragClassName();
  return /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement(StyledMenuTile.ItemButton, { className: dragClassName, css: spacingCSS, onClick: () => setMinimised(!minimised) }, /* @__PURE__ */ React126.createElement(ShrinkIcon, { height: 20, width: 20 }), /* @__PURE__ */ React126.createElement("span", null, minimised ? "Show" : "Minimise", " your video")));
};
var SimulcastLayers = ({ trackId }) => {
  var _a8;
  const track = useHMSStore66(selectTrackByID2(trackId));
  const actions = useHMSActions44();
  const bg2 = useDropdownSelection();
  if (!((_a8 = track == null ? void 0 : track.layerDefinitions) == null ? void 0 : _a8.length) || track.degraded || !track.enabled) {
    return null;
  }
  const currentLayer = track.layerDefinitions.find((layer) => layer.layer === track.layer);
  const dragClassName = getDragClassName();
  return /* @__PURE__ */ React126.createElement(Fragment11, null, /* @__PURE__ */ React126.createElement(StyledMenuTile.ItemButton, { className: dragClassName, css: { color: "$on_surface_medium", cursor: "default" } }, "Select maximum resolution"), track.layerDefinitions.map((layer) => {
    return /* @__PURE__ */ React126.createElement(
      StyledMenuTile.ItemButton,
      {
        className: dragClassName,
        key: layer.layer,
        onClick: () => __async(void 0, null, function* () {
          yield actions.setPreferredLayer(trackId, layer.layer);
        }),
        css: {
          justifyContent: "space-between",
          bg: track.preferredLayer === layer.layer ? bg2 : void 0,
          "&:hover": {
            bg: track.preferredLayer === layer.layer ? bg2 : void 0
          }
        }
      },
      /* @__PURE__ */ React126.createElement(
        Text,
        {
          as: "span",
          css: {
            textTransform: "capitalize",
            mr: "$2",
            fontWeight: track.preferredLayer === layer.layer ? "$semiBold" : "$regular",
            color: track.preferredLayer === layer.layer ? "$on_primary_high" : "$on_surface_high"
          }
        },
        layer.layer
      ),
      /* @__PURE__ */ React126.createElement(
        Text,
        {
          as: "span",
          variant: "xs",
          css: {
            color: track.preferredLayer === layer.layer ? "$on_primary_high" : "$on_surface_high"
          }
        },
        layer.resolution.width,
        "x",
        layer.resolution.height
      )
    );
  }), /* @__PURE__ */ React126.createElement(StyledMenuTile.ItemButton, { className: dragClassName }, /* @__PURE__ */ React126.createElement(Text, { as: "span", variant: "xs", css: { color: "$on_surface_medium" } }, "Currently streaming:", /* @__PURE__ */ React126.createElement(
    Text,
    {
      as: "span",
      variant: "xs",
      css: {
        fontWeight: "$semiBold",
        textTransform: "capitalize",
        color: "$on_surface_medium",
        ml: "$2"
      }
    },
    currentLayer ? /* @__PURE__ */ React126.createElement(React126.Fragment, null, track.layer, " (", currentLayer.resolution.width, "x", currentLayer.resolution.height, ")") : "-"
  ))));
};
var TileMenuContent = ({
  videoTrackID,
  audioTrackID,
  isLocal,
  isScreenshare,
  showSpotlight,
  showPinAction,
  peerID,
  canMinimise,
  closeSheetOnClick = () => {
    return;
  },
  openNameChangeModal = () => {
    return;
  },
  openRoleChangeModal = () => {
    return;
  }
}) => {
  const actions = useHMSActions44();
  const dragClassName = getDragClassName();
  const permissions = useHMSStore66(selectPermissions18);
  const canChangeRole = !!(permissions == null ? void 0 : permissions.changeRole);
  const removeOthers = !!(permissions == null ? void 0 : permissions.removeOthers);
  const { userName } = useHMSPrebuiltContext();
  const roles = useHMSStore66(selectAvailableRoleNames6);
  const { isAudioEnabled, isVideoEnabled, setVolume, toggleAudio, toggleVideo, volume } = useRemoteAVToggle(
    audioTrackID,
    videoTrackID
  );
  const { sendEvent } = useCustomEvent2({
    type: REMOTE_STOP_SCREENSHARE_TYPE
  });
  const isMobile = useMedia22(config.media.md);
  if (isLocal) {
    return showPinAction || canMinimise || !userName || showSpotlight ? /* @__PURE__ */ React126.createElement(React126.Fragment, null, showPinAction && /* @__PURE__ */ React126.createElement(PinActions, { audioTrackID, videoTrackID }), showSpotlight && /* @__PURE__ */ React126.createElement(SpotlightActions, { peerId: peerID, onSpotLightClick: () => closeSheetOnClick() }), canMinimise && /* @__PURE__ */ React126.createElement(MinimiseInset, null), !userName && /* @__PURE__ */ React126.createElement(
      StyledMenuTile.ItemButton,
      {
        className: dragClassName,
        onClick: () => {
          openNameChangeModal();
          closeSheetOnClick();
        }
      },
      /* @__PURE__ */ React126.createElement(PencilIcon, { height: 20, width: 20 }),
      /* @__PURE__ */ React126.createElement(Text, { variant: "sm", css: { "@md": { fontWeight: "$semiBold" }, c: "$on_surface_high" } }, "Change Name")
    )) : null;
  }
  return /* @__PURE__ */ React126.createElement(React126.Fragment, null, toggleVideo ? /* @__PURE__ */ React126.createElement(
    StyledMenuTile.ItemButton,
    {
      className: dragClassName,
      css: spacingCSS,
      onClick: () => {
        toggleVideo();
        closeSheetOnClick();
      },
      "data-testid": isVideoEnabled ? "mute_video_participant_btn" : "unmute_video_participant_btn"
    },
    isVideoEnabled ? /* @__PURE__ */ React126.createElement(VideoOnIcon4, { height: 20, width: 20 }) : /* @__PURE__ */ React126.createElement(VideoOffIcon3, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, isVideoEnabled ? "Mute Video" : "Request to Unmute Video")
  ) : null, toggleAudio ? /* @__PURE__ */ React126.createElement(
    StyledMenuTile.ItemButton,
    {
      css: spacingCSS,
      className: dragClassName,
      onClick: () => {
        toggleAudio();
        closeSheetOnClick();
      },
      "data-testid": isAudioEnabled ? "mute_audio_participant_btn" : "unmute_audio_participant_btn"
    },
    isAudioEnabled ? /* @__PURE__ */ React126.createElement(MicOnIcon4, { height: 20, width: 20 }) : /* @__PURE__ */ React126.createElement(MicOffIcon5, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, isAudioEnabled ? "Mute Audio" : "Request to Unmute Audio")
  ) : null, !isScreenshare && canChangeRole && roles.length > 1 ? /* @__PURE__ */ React126.createElement(
    StyledMenuTile.ItemButton,
    {
      className: dragClassName,
      css: spacingCSS,
      onClick: () => {
        openRoleChangeModal();
        closeSheetOnClick();
      },
      "data-testid": "change_role_btn"
    },
    /* @__PURE__ */ React126.createElement(PersonSettingsIcon2, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, "Switch Role")
  ) : null, !isIOS && audioTrackID ? /* @__PURE__ */ React126.createElement(StyledMenuTile.VolumeItem, { "data-testid": "participant_volume_slider", css: __spreadProps(__spreadValues({}, spacingCSS), { mb: "$0" }) }, /* @__PURE__ */ React126.createElement(Flex, { align: "center", gap: 1 }, /* @__PURE__ */ React126.createElement(SpeakerIcon3, { height: 20, width: 20 }), /* @__PURE__ */ React126.createElement(Box, { as: "span", css: { ml: "$4" } }, "Volume (", volume, ")")), /* @__PURE__ */ React126.createElement(
    Slider,
    {
      css: { my: "0.5rem" },
      step: 5,
      value: [typeof volume === "number" ? volume : 100],
      onValueChange: (e) => setVolume == null ? void 0 : setVolume(e[0])
    }
  )) : null, showPinAction && /* @__PURE__ */ React126.createElement(React126.Fragment, null, /* @__PURE__ */ React126.createElement(PinActions, { audioTrackID, videoTrackID }), showSpotlight && /* @__PURE__ */ React126.createElement(SpotlightActions, { peerId: peerID, onSpotLightClick: () => closeSheetOnClick() })), isMobile ? null : /* @__PURE__ */ React126.createElement(SimulcastLayers, { trackId: videoTrackID }), removeOthers ? /* @__PURE__ */ React126.createElement(
    StyledMenuTile.RemoveItem,
    {
      css: __spreadProps(__spreadValues({}, spacingCSS), { borderTop: "none" }),
      onClick: () => __async(void 0, null, function* () {
        try {
          yield actions.removePeer(peerID, "");
        } catch (error) {
        }
        closeSheetOnClick();
      }),
      "data-testid": "remove_participant_btn"
    },
    /* @__PURE__ */ React126.createElement(RemoveUserIcon2, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, "Remove Participant")
  ) : null, removeOthers && isScreenshare ? /* @__PURE__ */ React126.createElement(
    StyledMenuTile.RemoveItem,
    {
      onClick: () => {
        sendEvent({});
        closeSheetOnClick();
      },
      css: spacingCSS
    },
    /* @__PURE__ */ React126.createElement(ShareScreenIcon3, { height: 20, width: 20 }),
    /* @__PURE__ */ React126.createElement("span", null, "Stop Screenshare")
  ) : null);
};

// src/Prebuilt/components/TileMenu/TileMenu.tsx
var TileMenu = ({
  audioTrackID,
  videoTrackID,
  peerID,
  isScreenshare = false,
  canMinimise,
  enableSpotlightingPeer = true
}) => {
  var _a8, _b7;
  const [open, setOpen] = useState55(false);
  const { theme: theme2 } = useTheme();
  const localPeerID = useHMSStore67(selectLocalPeerID10);
  const isLocal = localPeerID === peerID;
  const { removeOthers } = useHMSStore67(selectPermissions19) || {};
  const { setVolume, toggleAudio, toggleVideo } = useRemoteAVToggle2(audioTrackID, videoTrackID);
  const showSpotlight = enableSpotlightingPeer;
  const isPrimaryVideoTrack = ((_a8 = useHMSStore67(selectVideoTrackByPeerID2(peerID))) == null ? void 0 : _a8.id) === videoTrackID;
  const showPinAction = !!(audioTrackID || videoTrackID && isPrimaryVideoTrack);
  const track = useHMSStore67(selectTrackByID3(videoTrackID));
  const audioTrack = useHMSStore67(selectTrackByID3(audioTrackID));
  const hideSimulcastLayers = !((_b7 = track == null ? void 0 : track.layerDefinitions) == null ? void 0 : _b7.length) || track.degraded || !track.enabled;
  const isMobile = useMedia23(config.media.md);
  const peer = useHMSStore67(selectPeerByID2(peerID));
  const [showNameChangeModal, setShowNameChangeModal] = useState55(false);
  const [showRoleChangeModal, setShowRoleChangeModal] = useState55(false);
  useDropdownList({ open, name: "TileMenu" });
  const dragClassName = getDragClassName();
  if (!peer || !(removeOthers || toggleAudio || toggleVideo || setVolume || showPinAction) && hideSimulcastLayers) {
    return null;
  }
  const openNameChangeModal = () => setShowNameChangeModal(true);
  const openRoleChangeModal = () => setShowRoleChangeModal(true);
  const props = {
    isLocal,
    isScreenshare,
    audioTrackID,
    videoTrackID,
    peerID,
    showSpotlight,
    showPinAction,
    canMinimise,
    openNameChangeModal,
    openRoleChangeModal
  };
  return /* @__PURE__ */ React127.createElement(React127.Fragment, null, /* @__PURE__ */ React127.createElement(StyledMenuTile.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React127.createElement(
    StyledMenuTile.Trigger,
    {
      "data-testid": "participant_menu_btn",
      css: { bg: `${theme2.colors.background_dim.value}A3`, p: "$2", w: "unset", h: "unset" },
      onClick: (e) => e.stopPropagation(),
      className: dragClassName
    },
    /* @__PURE__ */ React127.createElement(VerticalMenuIcon8, { width: 20, height: 20 })
  ), isMobile ? /* @__PURE__ */ React127.createElement(Sheet.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React127.createElement(Sheet.Content, { css: { bg: "$surface_dim", pt: "$8" } }, /* @__PURE__ */ React127.createElement(
    Flex,
    {
      css: {
        color: "$on_surface_high",
        display: "flex",
        w: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        px: "$10",
        pb: "$8",
        borderBottom: "1px solid $border_default"
      }
    },
    /* @__PURE__ */ React127.createElement(Box, null, /* @__PURE__ */ React127.createElement(Text, { css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, getVideoTileLabel({ peerName: peer == null ? void 0 : peer.name, isLocal, audioTrack, videoTrack: track })), (peer == null ? void 0 : peer.roleName) ? /* @__PURE__ */ React127.createElement(Text, { variant: "xs", css: { color: "$on_surface_low", mt: "$2" } }, peer.roleName) : null),
    /* @__PURE__ */ React127.createElement(Sheet.Close, { css: { color: "inherit" } }, /* @__PURE__ */ React127.createElement(CrossIcon24, null))
  ), /* @__PURE__ */ React127.createElement(Box, { css: { px: "$8", pb: "$8", maxHeight: "80vh", overflowY: "auto" } }, /* @__PURE__ */ React127.createElement(TileMenuContent, __spreadProps(__spreadValues({}, props), { closeSheetOnClick: () => setOpen(false) }))))) : /* @__PURE__ */ React127.createElement(StyledMenuTile.Content, { side: "top", align: "end", css: { maxHeight: "$80", overflowY: "auto" } }, /* @__PURE__ */ React127.createElement(TileMenuContent, __spreadValues({}, props)))), showNameChangeModal && /* @__PURE__ */ React127.createElement(ChangeNameModal, { onOpenChange: setShowNameChangeModal }), showRoleChangeModal && /* @__PURE__ */ React127.createElement(RoleChangeModal, { peerId: peerID, onOpenChange: setShowRoleChangeModal }));
};
var TileMenu_default = TileMenu;

// src/Prebuilt/components/VideoTile.tsx
var PeerMetadata = ({ peerId, size }) => {
  const metaData = useHMSStore68(selectPeerMetadata4(peerId));
  const isBRB = (metaData == null ? void 0 : metaData.isBRBOn) || false;
  const isHandRaised = useHMSStore68(selectHasPeerHandRaised3(peerId));
  return /* @__PURE__ */ React128.createElement(React128.Fragment, null, isHandRaised ? /* @__PURE__ */ React128.createElement(StyledVideoTile.AttributeBox, { size, "data-testid": "raiseHand_icon_onTile" }, /* @__PURE__ */ React128.createElement(HandIcon5, { width: 24, height: 24 })) : null, isBRB ? /* @__PURE__ */ React128.createElement(StyledVideoTile.AttributeBox, { size, "data-testid": "brb_icon_onTile" }, /* @__PURE__ */ React128.createElement(BrbTileIcon, { width: 22, height: 22 })) : null);
};
var Tile = ({
  peerId = "",
  trackId = "",
  width,
  height,
  objectFit = "cover",
  canMinimise = false,
  isDragabble = false,
  rootCSS = {},
  containerCSS = {},
  enableSpotlightingPeer = true,
  hideParticipantNameOnTile = false,
  roundedVideoTile = true,
  hideAudioMuteOnTile = false,
  hideMetadataOnTile = false
}) => {
  const trackSelector = trackId ? selectVideoTrackByID3(trackId) : selectVideoTrackByPeerID3(peerId);
  const track = useHMSStore68(trackSelector);
  const peerName = useHMSStore68(selectPeerNameByID5(peerId));
  const audioTrack = useHMSStore68(selectAudioTrackByPeerID2(peerId));
  const localPeerID = useHMSStore68(selectLocalPeerID11);
  const isAudioOnly = useUISettings(UI_SETTINGS.isAudioOnly);
  const mirrorLocalVideo = useUISettings(UI_SETTINGS.mirrorLocalVideo);
  const showStatsOnTiles = useUISettings(UI_SETTINGS.showStatsOnTiles);
  const isAudioMuted = !useHMSStore68(selectIsPeerAudioEnabled2(peerId));
  const isVideoMuted = !(track == null ? void 0 : track.enabled);
  const [isMouseHovered, setIsMouseHovered] = useState56(false);
  const isVideoDegraded = track == null ? void 0 : track.degraded;
  const isLocal = localPeerID === peerId;
  const [pinnedTrackId] = useSetAppDataByKey(APP_DATA.pinnedTrackId);
  const pinned = isSameTile({
    trackId: pinnedTrackId,
    videoTrackID: track == null ? void 0 : track.id,
    audioTrackID: audioTrack == null ? void 0 : audioTrack.id
  });
  const label = getVideoTileLabel({
    peerName,
    isLocal,
    videoTrack: track,
    audioTrack
  });
  const onHoverHandler = useCallback32((event) => {
    setIsMouseHovered(event.type === "mouseenter");
  }, []);
  const [ref, { width: calculatedWidth, height: calculatedHeight }] = useMeasure3();
  const isTileBigEnoughToShowStats = calculatedHeight >= 180 && calculatedWidth >= 180;
  const [avatarSize, attribBoxSize] = useMemo14(
    () => calculateAvatarAndAttribBoxSize(calculatedWidth, calculatedHeight),
    [calculatedWidth, calculatedHeight]
  );
  return /* @__PURE__ */ React128.createElement(
    StyledVideoTile.Root,
    {
      ref,
      css: __spreadValues({
        width,
        height
      }, rootCSS),
      "data-testid": `participant_tile_${peerName}`
    },
    peerName !== void 0 ? /* @__PURE__ */ React128.createElement(
      StyledVideoTile.Container,
      {
        onMouseEnter: onHoverHandler,
        onMouseLeave: onHoverHandler,
        noRadius: !roundedVideoTile,
        css: containerCSS
      },
      showStatsOnTiles && isTileBigEnoughToShowStats ? /* @__PURE__ */ React128.createElement(VideoTileStats, { audioTrackID: audioTrack == null ? void 0 : audioTrack.id, videoTrackID: track == null ? void 0 : track.id, peerID: peerId, isLocal }) : null,
      /* @__PURE__ */ React128.createElement(
        Video,
        {
          trackId: track == null ? void 0 : track.id,
          attach: isLocal ? void 0 : !isAudioOnly,
          mirror: mirrorLocalVideo && peerId === localPeerID && (track == null ? void 0 : track.source) === "regular" && (track == null ? void 0 : track.facingMode) !== "environment",
          noRadius: !roundedVideoTile,
          "data-testid": "participant_video_tile",
          css: {
            objectFit,
            filter: isVideoDegraded ? "blur($space$2)" : void 0,
            bg: "transparent"
          }
        }
      ),
      calculatedWidth > 0 && calculatedHeight > 0 ? /* @__PURE__ */ React128.createElement(React128.Fragment, null, isVideoMuted || !isLocal && isAudioOnly ? /* @__PURE__ */ React128.createElement(StyledVideoTile.AvatarContainer, null, /* @__PURE__ */ React128.createElement(Avatar, { name: peerName || "", "data-testid": "participant_avatar_icon", size: avatarSize })) : null, !hideAudioMuteOnTile && isAudioMuted ? /* @__PURE__ */ React128.createElement(StyledVideoTile.AudioIndicator, { "data-testid": "participant_audio_mute_icon", size: attribBoxSize }, /* @__PURE__ */ React128.createElement(MicOffIcon6, null)) : null, !hideAudioMuteOnTile && !isAudioMuted ? /* @__PURE__ */ React128.createElement(StyledVideoTile.AudioIndicator, { size: attribBoxSize }, /* @__PURE__ */ React128.createElement(AudioLevel, { trackId: audioTrack == null ? void 0 : audioTrack.id, size: attribBoxSize })) : null, !hideMetadataOnTile && /* @__PURE__ */ React128.createElement(PeerMetadata, { peerId, size: attribBoxSize })) : null,
      isMouseHovered || isDragabble && navigator.maxTouchPoints > 0 ? /* @__PURE__ */ React128.createElement(
        TileMenu_default,
        {
          peerID: peerId,
          audioTrackID: (audioTrack == null ? void 0 : audioTrack.id) || "",
          videoTrackID: (track == null ? void 0 : track.id) || "",
          canMinimise,
          enableSpotlightingPeer
        }
      ) : null,
      /* @__PURE__ */ React128.createElement(
        TileConnection_default,
        {
          hideLabel: hideParticipantNameOnTile,
          name: label,
          peerId,
          width,
          pinned
        }
      )
    ) : null
  );
};
var VideoTile = React128.memo(Tile);
var VideoTile_default = VideoTile;

// src/Prebuilt/components/VirtualBackground/VBPicker.tsx
init_define_process_env();
import React131, { useEffect as useEffect41, useRef as useRef27, useState as useState57 } from "react";
import { useMedia as useMedia24 } from "react-use";
import { HMSVirtualBackgroundTypes as HMSVirtualBackgroundTypes5 } from "@100mslive/hms-virtual-background/hmsvbplugin";
import {
  HMSRoomState as HMSRoomState6,
  selectIsLargeRoom as selectIsLargeRoom3,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled6,
  selectIsLocalVideoPluginPresent,
  selectLocalPeer as selectLocalPeer8,
  selectRoomState as selectRoomState6,
  selectVideoTrackByID as selectVideoTrackByID4,
  useHMSActions as useHMSActions45,
  useHMSStore as useHMSStore69
} from "@100mslive/react-sdk";
import { BlurPersonHighIcon, CrossCircleIcon as CrossCircleIcon3, CrossIcon as CrossIcon25 } from "@100mslive/react-icons";

// src/Prebuilt/components/VirtualBackground/VBCollection.tsx
init_define_process_env();
import React130 from "react";
import { HMSVirtualBackgroundTypes as HMSVirtualBackgroundTypes4 } from "@100mslive/hms-virtual-background/hmsvbplugin";

// src/Prebuilt/components/VirtualBackground/VBOption.tsx
init_define_process_env();
import React129 from "react";
var Root25 = ({
  onClick,
  mediaURL,
  isActive,
  children,
  testid = ""
}) => /* @__PURE__ */ React129.createElement(
  Flex,
  {
    "data-testid": testid,
    direction: "column",
    align: "center",
    css: __spreadValues({
      p: "$5",
      borderRadius: "$1",
      bg: "$surface_bright",
      border: `4px solid ${isActive ? "$primary_default" : "$surface_dim"}`,
      cursor: "pointer",
      "@media (hover:hover)": {
        "&:hover": { border: "4px solid $primary_dim" }
      }
    }, mediaURL ? { height: "$20", backgroundImage: `url("${mediaURL}")`, backgroundSize: "cover" } : {}),
    onClick: () => __async(void 0, null, function* () {
      yield onClick == null ? void 0 : onClick();
    })
  },
  children
);
var Title4 = ({ children }) => {
  return children ? /* @__PURE__ */ React129.createElement(Text, { variant: "xs", css: { color: "$on_surface_medium" } }, children) : null;
};
var Icon3 = ({ children }) => {
  return children ? /* @__PURE__ */ React129.createElement(Box, { css: { color: "$on_surface_high" } }, children) : null;
};
var VBOption = {
  Root: Root25,
  Title: Title4,
  Icon: Icon3
};

// src/Prebuilt/components/VirtualBackground/VBCollection.tsx
var VBCollection = ({
  options,
  title,
  activeBackground = ""
}) => {
  if (options.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React130.createElement(Box, { css: { mt: "$10" } }, /* @__PURE__ */ React130.createElement(Text, { variant: "sm", css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, title), /* @__PURE__ */ React130.createElement(Box, { css: { py: "$4", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "$8" } }, options.map(
    (option, index) => option.supported ? /* @__PURE__ */ React130.createElement(
      VBOption.Root,
      __spreadProps(__spreadValues({
        key: option.value,
        testid: option.value === HMSVirtualBackgroundTypes4.IMAGE ? `virtual_bg_option-${index}` : option.value
      }, option), {
        isActive: activeBackground === option.value
      }),
      /* @__PURE__ */ React130.createElement(VBOption.Icon, null, option == null ? void 0 : option.icon),
      /* @__PURE__ */ React130.createElement(VBOption.Title, null, option == null ? void 0 : option.title)
    ) : ""
  )));
};

// src/Prebuilt/components/VirtualBackground/VBPicker.tsx
var iconDims = { height: "40px", width: "40px" };
var VBPicker = ({ backgroundMedia = [] }) => {
  var _a8, _b7;
  const toggleVB = useSidepaneToggle(SIDE_PANE_OPTIONS.VB);
  const hmsActions = useHMSActions45();
  const localPeer = useHMSStore69(selectLocalPeer8);
  const role = useHMSStore69(ct);
  const isVideoOn = useHMSStore69(selectIsLocalVideoEnabled6);
  const mirrorLocalVideo = useUISettings(UI_SETTINGS.mirrorLocalVideo);
  const trackSelector = selectVideoTrackByID4(localPeer == null ? void 0 : localPeer.videoTrack);
  const track = useHMSStore69(trackSelector);
  const [blurAmount, setBlurAmount] = useState57(VBHandler.getBlurAmount() || 0.5);
  const roomState = useHMSStore69(selectRoomState6);
  const isLargeRoom = useHMSStore69(selectIsLargeRoom3);
  const isEffectsSupported = VBHandler.isEffectsSupported();
  const isEffectsEnabled = useHMSStore69(jm);
  const effectsKey = useHMSStore69(Qm);
  const isMobile = useMedia24(config.media.md);
  const [loadingEffects, setLoadingEffects] = useSetAppDataByKey(APP_DATA.loadingEffects);
  const isPluginAdded = useHMSStore69(selectIsLocalVideoPluginPresent(((_a8 = VBHandler) == null ? void 0 : _a8.getName()) || ""));
  const background = useHMSStore69(uS(APP_DATA.background));
  const mediaList = backgroundMedia.map((media) => media.url || "");
  const pluginLoadingRef = useRef27(false);
  const isBlurSupported = (_b7 = VBHandler) == null ? void 0 : _b7.isBlurSupported();
  const inPreview = roomState === HMSRoomState6.Preview;
  const showVideoTile = isVideoOn && isLargeRoom && !inPreview;
  useEffect41(() => {
    const addHMSVBPlugin = () => __async(void 0, null, function* () {
      setLoadingEffects(false);
      if (!role) {
        return;
      }
      yield VBHandler.initialisePlugin();
      yield hmsActions.addPluginToVideoTrack(
        VBHandler.getVBObject(),
        Math.floor(role.publishParams.video.frameRate / 2)
      );
    });
    const initializeVirtualBackground = () => __async(void 0, null, function* () {
      if (!(track == null ? void 0 : track.id) || pluginLoadingRef.current || isPluginAdded) {
        return;
      }
      try {
        pluginLoadingRef.current = true;
        if (isEffectsEnabled && isEffectsSupported && effectsKey) {
          setLoadingEffects(true);
          yield VBHandler.initialisePlugin(effectsKey, () => {
            setLoadingEffects(false);
          });
          const vbInstance = VBHandler.getVBObject();
          if (vbInstance.getName() === "HMSEffects") {
            hmsActions.addPluginsToVideoStream([VBHandler.getVBObject()]);
          } else {
            yield addHMSVBPlugin();
          }
        } else {
          yield addHMSVBPlugin();
        }
        const handleDefaultBackground = () => __async(void 0, null, function* () {
          switch (background) {
            case HMSVirtualBackgroundTypes5.NONE:
              break;
            case HMSVirtualBackgroundTypes5.BLUR:
              yield VBHandler.setBlur(blurAmount);
              break;
            default:
              yield VBHandler.setBackground(background);
          }
        });
        yield handleDefaultBackground();
      } catch (error) {
        console.error("Error initializing virtual background:", error);
        setLoadingEffects(false);
      }
    });
    initializeVirtualBackground();
  }, [
    hmsActions,
    role,
    isPluginAdded,
    isEffectsEnabled,
    isEffectsSupported,
    effectsKey,
    track == null ? void 0 : track.id,
    background,
    blurAmount,
    setLoadingEffects
  ]);
  useEffect41(() => {
    if (!isVideoOn) {
      toggleVB();
    }
    return () => setLoadingEffects(false);
  }, [isVideoOn, setLoadingEffects, toggleVB]);
  useSidepaneResetOnLayoutUpdate("virtual_background", SIDE_PANE_OPTIONS.VB);
  return /* @__PURE__ */ React131.createElement(Flex, { css: { pr: "$6", size: "100%" }, direction: "column" }, /* @__PURE__ */ React131.createElement(Flex, { align: "center", justify: "between", css: { w: "100%", background: "$surface_dim", pb: "$4" } }, /* @__PURE__ */ React131.createElement(Text, { variant: "h6", css: { color: "$on_surface_high", display: "flex", alignItems: "center" } }, "Virtual Background ", isMobile && loadingEffects ? /* @__PURE__ */ React131.createElement(Loading, { size: 18, style: { marginLeft: "0.5rem" } }) : ""), /* @__PURE__ */ React131.createElement(
    Box,
    {
      css: { color: "$on_surface_high", "&:hover": { color: "$on_surface_medium" }, cursor: "pointer" },
      onClick: toggleVB
    },
    /* @__PURE__ */ React131.createElement(CrossIcon25, null)
  )), showVideoTile ? /* @__PURE__ */ React131.createElement(
    Video,
    {
      mirror: (track == null ? void 0 : track.facingMode) !== "environment" && mirrorLocalVideo,
      trackId: localPeer == null ? void 0 : localPeer.videoTrack,
      "data-testid": "preview_tile",
      css: { width: "100%", height: "16rem" }
    }
  ) : null, /* @__PURE__ */ React131.createElement(
    Box,
    {
      css: {
        mt: "$4",
        overflowY: "auto",
        flex: "1 1 0",
        mr: "-$10",
        pr: "$10"
      }
    },
    /* @__PURE__ */ React131.createElement(
      VBCollection,
      {
        title: "Effects",
        options: [
          {
            title: "No effect",
            icon: /* @__PURE__ */ React131.createElement(CrossCircleIcon3, { style: iconDims }),
            value: HMSVirtualBackgroundTypes5.NONE,
            onClick: () => __async(void 0, null, function* () {
              yield VBHandler.removeEffects();
              hmsActions.setAppData(APP_DATA.background, HMSVirtualBackgroundTypes5.NONE);
              if (isMobile) {
                toggleVB();
              }
            }),
            supported: true
          },
          {
            title: "Blur",
            icon: /* @__PURE__ */ React131.createElement(BlurPersonHighIcon, { style: iconDims }),
            value: HMSVirtualBackgroundTypes5.BLUR,
            onClick: () => __async(void 0, null, function* () {
              var _a9;
              yield (_a9 = VBHandler) == null ? void 0 : _a9.setBlur(blurAmount);
              hmsActions.setAppData(APP_DATA.background, HMSVirtualBackgroundTypes5.BLUR);
            }),
            supported: isBlurSupported
          }
        ],
        activeBackground: background
      }
    ),
    /* @__PURE__ */ React131.createElement(Flex, { direction: "column", css: { w: "100%", gap: "$8", mt: "$8" } }, background === HMSVirtualBackgroundTypes5.BLUR && isBlurSupported ? /* @__PURE__ */ React131.createElement(Box, null, /* @__PURE__ */ React131.createElement(Text, { variant: "sm", css: { color: "$on_surface_high", fontWeight: "$semiBold", mb: "$4" } }, "Blur intensity"), /* @__PURE__ */ React131.createElement(Flex, { css: { w: "100%", justifyContent: "space-between", alignItems: "center", gap: "$4" } }, /* @__PURE__ */ React131.createElement(Text, { variant: "caption", css: { fontWeight: "$medium", color: "$on_surface_medium" } }, "Low"), /* @__PURE__ */ React131.createElement(
      Slider,
      {
        showTooltip: false,
        value: [blurAmount],
        onValueChange: (e) => __async(void 0, null, function* () {
          setBlurAmount(e[0]);
          yield VBHandler.setBlur(e[0]);
        }),
        step: 0.1,
        min: 0.1,
        max: 1
      }
    ), /* @__PURE__ */ React131.createElement(Text, { variant: "caption", css: { fontWeight: "$medium", color: "$on_surface_medium" } }, "High"))) : null),
    /* @__PURE__ */ React131.createElement(
      VBCollection,
      {
        title: "Backgrounds",
        options: mediaList.map((mediaURL) => ({
          mediaURL,
          value: mediaURL,
          onClick: () => __async(void 0, null, function* () {
            var _a9;
            yield (_a9 = VBHandler) == null ? void 0 : _a9.setBackground(mediaURL);
            hmsActions.setAppData(APP_DATA.background, mediaURL);
            if (isMobile) {
              toggleVB();
            }
          }),
          supported: true
        })),
        activeBackground: background
      }
    )
  ));
};

// src/Prebuilt/layouts/SidePane.tsx
var Wrapper3 = styled("div", {
  w: "$100",
  h: "100%",
  p: "$10",
  flex: "1 1 0",
  background: "$surface_dim",
  r: "$1",
  position: "relative",
  "@lg": {
    w: "100%",
    h: "100%",
    ml: 0,
    right: 0,
    position: "fixed",
    bottom: 0,
    borderRadius: 0,
    zIndex: 10
  },
  "@md": {
    p: "$6 $8",
    animation: `${translateAcross({ yFrom: "100%" })} 150ms cubic-bezier(0.22, 1, 0.36, 1)`
  },
  variants: {
    landscapeStream: {
      true: {
        "@lg": {
          position: "unset",
          minHeight: "100%"
        }
      }
    },
    mobileStream: {
      true: {
        "@md": {
          position: "unset"
        }
      }
    },
    overlayChat: {
      true: {
        "@lg": {
          maxHeight: "300px",
          background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 35.94%, rgba(0, 0, 0, 0.64) 100%)",
          position: "fixed",
          zIndex: 12,
          bottom: 0
        }
      }
    },
    roomDescription: {
      true: {
        overflowY: "auto"
      }
    },
    hideControls: {
      true: {}
    },
    virtualBackground: {
      true: {
        maxHeight: "100%",
        background: "$surface_dim"
      }
    }
  },
  compoundVariants: [
    {
      landscapeStream: true,
      overlayChat: true,
      css: {
        position: "unset",
        height: "100%",
        maxHeight: "unset",
        "@md": {
          pb: 0
        }
      }
    },
    {
      mobileStream: true,
      overlayChat: true,
      css: {
        position: "unset",
        height: "100%",
        maxHeight: "unset"
      }
    },
    {
      hideControls: false,
      overlayChat: true,
      css: {
        pb: "$17"
      }
    }
  ]
});
var SidePane = ({
  tileProps,
  hideControls = false
}) => {
  var _a8, _b7, _c, _d, _e, _f, _g;
  const isMobile = useMedia25(config.media.md);
  const sidepane = useHMSStore70(selectAppData8(APP_DATA.sidePane));
  const activeScreensharePeerId = useHMSStore70(selectAppData8(APP_DATA.activeScreensharePeerId));
  const trackId = (_a8 = useHMSStore70(selectVideoTrackByPeerID4(activeScreensharePeerId))) == null ? void 0 : _a8.id;
  const { elements } = useRoomLayoutConferencingScreen();
  const { elements: preview_elements } = useRoomLayoutPreviewScreen();
  const layoutMode = useUISettings(UI_SETTINGS.layoutMode);
  const isLandscapeHLSStream = useLandscapeHLSStream();
  const isMobileHLSStream = useMobileHLSStream();
  const backgroundMedia = ((_c = (_b7 = preview_elements == null ? void 0 : preview_elements.virtual_background) == null ? void 0 : _b7.background_media) == null ? void 0 : _c.length) ? (_d = preview_elements == null ? void 0 : preview_elements.virtual_background) == null ? void 0 : _d.background_media : ((_e = elements == null ? void 0 : elements.virtual_background) == null ? void 0 : _e.background_media) || [];
  const tileLayout = {
    hideParticipantNameOnTile: tileProps == null ? void 0 : tileProps.hide_participant_name_on_tile,
    roundedVideoTile: tileProps == null ? void 0 : tileProps.rounded_video_tile,
    hideAudioMuteOnTile: tileProps == null ? void 0 : tileProps.hide_audio_mute_on_tile,
    hideMetadataOnTile: tileProps == null ? void 0 : tileProps.hide_metadata_on_tile,
    objectFit: tileProps == null ? void 0 : tileProps.video_object_fit
  };
  const mwebStreamingChat = isMobile && sidepane === SIDE_PANE_OPTIONS.CHAT && ((_f = elements == null ? void 0 : elements.chat) == null ? void 0 : _f.is_overlay);
  const commonProps = {
    landscapeStream: isLandscapeHLSStream,
    mobileStream: isMobileHLSStream,
    hideControls,
    overlayChat: !!((_g = elements == null ? void 0 : elements.chat) == null ? void 0 : _g.is_overlay),
    roomDescription: sidepane === SIDE_PANE_OPTIONS.ROOM_DETAILS,
    virtualBackground: sidepane === SIDE_PANE_OPTIONS.VB
  };
  const SidepaneComponent = match12(sidepane).with(SIDE_PANE_OPTIONS.POLLS, () => /* @__PURE__ */ React132.createElement(
    Wrapper3,
    __spreadValues({
      css: {
        "@md": {
          borderTopLeftRadius: "$2",
          borderTopRightRadius: "$2"
        }
      }
    }, commonProps),
    /* @__PURE__ */ React132.createElement(Polls, null)
  )).with(SIDE_PANE_OPTIONS.VB, () => /* @__PURE__ */ React132.createElement(Wrapper3, __spreadValues({ css: { p: "$10 $6 $10 $10" } }, commonProps), /* @__PURE__ */ React132.createElement(VBPicker, { backgroundMedia }))).with(SIDE_PANE_OPTIONS.CHAT, SIDE_PANE_OPTIONS.PARTICIPANTS, () => /* @__PURE__ */ React132.createElement(Wrapper3, __spreadProps(__spreadValues({}, commonProps), { overlayChat: mwebStreamingChat }), /* @__PURE__ */ React132.createElement(SidePaneTabs, { active: sidepane, hideTab: isMobileHLSStream || isLandscapeHLSStream }))).with(SIDE_PANE_OPTIONS.ROOM_DETAILS, () => /* @__PURE__ */ React132.createElement(Wrapper3, __spreadValues({}, commonProps), /* @__PURE__ */ React132.createElement(RoomDetailsPane, null))).otherwise(() => {
    return null;
  });
  const resetSidePane = useSidepaneReset();
  useEffect42(() => {
    return () => {
      resetSidePane();
    };
  }, [resetSidePane]);
  if (!SidepaneComponent && !trackId) {
    return null;
  }
  return /* @__PURE__ */ React132.createElement(
    Flex,
    {
      direction: "column",
      justify: "center",
      css: {
        w: match12({ isMobileHLSStream, isLandscapeHLSStream }).with({ isLandscapeHLSStream: true }, () => "340px").with({ isMobileHLSStream: true }, () => "100%").otherwise(() => "$100"),
        h: "100%",
        flexShrink: 0,
        gap: "$4",
        position: "relative",
        "&:empty": { display: "none" },
        "@md": {
          position: "absolute",
          zIndex: 12
        }
      }
    },
    trackId && layoutMode === LayoutMode.GALLERY && /* @__PURE__ */ React132.createElement(
      VideoTile_default,
      __spreadValues({
        peerId: activeScreensharePeerId,
        trackId,
        width: "100%",
        height: 225,
        rootCSS: { p: 0, alignSelf: "start", flexShrink: 0 }
      }, tileLayout)
    ),
    SidepaneComponent
  );
};
var SidePane_default = SidePane;

// src/Prebuilt/components/Chip.tsx
init_define_process_env();
import React133 from "react";
var Chip = ({
  icon = /* @__PURE__ */ React133.createElement(React133.Fragment, null),
  content = "",
  backgroundColor = "$surface_default",
  textColor = "$on_surface_high",
  hideIfNoContent = false,
  onClick,
  css: css2 = {}
}) => {
  if (hideIfNoContent && !content) {
    return null;
  }
  return /* @__PURE__ */ React133.createElement(
    Flex,
    {
      align: "center",
      css: __spreadValues({ backgroundColor, p: "$4 $6", gap: "$2", borderRadius: "$4" }, css2),
      onClick: () => onClick == null ? void 0 : onClick()
    },
    icon,
    /* @__PURE__ */ React133.createElement(Text, { variant: "sm", css: { fontWeight: "$semiBold", color: textColor } }, content)
  );
};
var Chip_default = Chip;

// src/Prebuilt/components/FullPageProgress.tsx
init_define_process_env();
import React134 from "react";
var FullPageProgress = ({
  loaderColor = "$primary_default",
  text = "",
  css: css2 = {}
}) => /* @__PURE__ */ React134.createElement(Flex, { direction: "column", justify: "center", align: "center", css: __spreadValues({ size: "100%", color: loaderColor }, css2) }, /* @__PURE__ */ React134.createElement(Loading, { color: "currentColor", size: 100 }), text ? /* @__PURE__ */ React134.createElement(Text, { css: { mt: "$10", color: "$on_surface_high" } }, text) : null);
var FullPageProgress_default = FullPageProgress;

// src/Prebuilt/components/Preview/PreviewForm.tsx
init_define_process_env();
import React135 from "react";
import { useMedia as useMedia26 } from "react-use";
import { JoinForm_JoinBtnType as JoinForm_JoinBtnType3 } from "@100mslive/types-prebuilt/elements/join_form";
import { useRecordingStreaming as useRecordingStreaming10 } from "@100mslive/react-sdk";
import { GoLiveIcon } from "@100mslive/react-icons";
var PreviewForm = ({
  name,
  disabled,
  onChange,
  onJoin,
  enableJoin,
  cannotPublishVideo = false,
  cannotPublishAudio = false
}) => {
  var _a8, _b7, _c;
  const formSubmit = (e) => {
    e.preventDefault();
  };
  const isMobile = useMedia26(config.media.md);
  const { isHLSRunning, isRTMPRunning, isHLSRecordingOn, isBrowserRecordingOn } = useRecordingStreaming10();
  const layout = useRoomLayout();
  const { join_form: joinForm = {} } = ((_c = (_b7 = (_a8 = layout == null ? void 0 : layout.screens) == null ? void 0 : _a8.preview) == null ? void 0 : _b7.default) == null ? void 0 : _c.elements) || {};
  const showGoLive = (joinForm == null ? void 0 : joinForm.join_btn_type) === JoinForm_JoinBtnType3.JOIN_BTN_TYPE_JOIN_AND_GO_LIVE && !isHLSRunning && !isRTMPRunning && !isHLSRecordingOn && !isBrowserRecordingOn;
  return /* @__PURE__ */ React135.createElement(
    Form,
    {
      css: { flexDirection: cannotPublishVideo ? "column" : "row", "@md": { flexDirection: "row" } },
      onSubmit: formSubmit
    },
    /* @__PURE__ */ React135.createElement(Flex, { align: "center", css: { gap: "$8", w: "100%" } }, /* @__PURE__ */ React135.createElement(
      Input,
      {
        required: true,
        id: "name",
        disabled,
        css: { w: "100%", boxSizing: "border-box" },
        value: name,
        onChange: (e) => onChange(e.target.value.trimStart()),
        placeholder: "Enter name",
        autoFocus: true,
        autoComplete: "name",
        onKeyDown: (e) => {
          if (e.key === "Enter" && name.trim().length > 0) {
            e.preventDefault();
            if (isMobile) {
              return;
            }
            onJoin();
          }
        }
      }
    ), cannotPublishAudio && cannotPublishVideo && !isMobile ? /* @__PURE__ */ React135.createElement(PreviewSettings, null) : null),
    /* @__PURE__ */ React135.createElement(Button, { type: "submit", icon: true, disabled: !name || !enableJoin, onClick: onJoin }, showGoLive ? /* @__PURE__ */ React135.createElement(GoLiveIcon, { height: 18, width: 18 }) : null, showGoLive ? joinForm.go_live_btn_label : joinForm.join_btn_label)
  );
};
var Form = styled("form", {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "$8",
  mt: "$10",
  mb: "$10",
  "@md": {
    gap: "$4"
  }
});
var PreviewForm_default = PreviewForm;

// src/Prebuilt/components/Preview/PreviewJoin.tsx
var getParticipantChipContent = (peerCount = 0) => {
  if (peerCount === 0) {
    return "You are the first to join";
  }
  const formattedNum = getFormattedCount(peerCount);
  return `${formattedNum} other${parseInt(formattedNum) === 1 ? "" : "s"} in the session`;
};
var useLocalTileAspectRatio = () => {
  const localPeer = useHMSStore71(selectLocalPeer9);
  const videoTrack = useHMSStore71(selectVideoTrackByID5(localPeer == null ? void 0 : localPeer.videoTrack));
  const isMobile = useMedia27(config.media.md);
  let aspectRatio = 0;
  if ((videoTrack == null ? void 0 : videoTrack.width) && (videoTrack == null ? void 0 : videoTrack.height)) {
    aspectRatio = videoTrack.width / videoTrack.height;
  } else {
    aspectRatio = isMobile ? 9 / 16 : 16 / 9;
  }
  return aspectRatio.toString();
};
var PreviewJoin = ({
  skipPreview,
  initialName,
  asRole
}) => {
  const [previewPreference, setPreviewPreference] = useUserPreferences(
    UserPreferencesKeys.PREVIEW,
    defaultPreviewPreference
  );
  const { isStreamingOn } = useRecordingStreaming11();
  const authToken = useAuthToken();
  const [name, setName] = useState58(initialName || previewPreference.name);
  const { toggleAudio, toggleVideo } = useAVToggle4();
  const [previewError, setPreviewError] = useState58(false);
  const { endpoints } = useHMSPrebuiltContext();
  const { peerCount } = useParticipants2();
  const loadingEffects = useHMSStore71(selectAppData9(APP_DATA.loadingEffects));
  const { enableJoin, preview, join } = usePreviewJoin({
    name,
    token: authToken,
    initEndpoint: endpoints == null ? void 0 : endpoints.init,
    initialSettings: {
      isAudioMuted: skipPreview || previewPreference.isAudioMuted,
      isVideoMuted: skipPreview || previewPreference.isVideoMuted,
      speakerAutoSelectionBlacklist: ["Yeti Stereo Microphone"]
    },
    captureNetworkQualityInPreview: true,
    handleError: (_, method) => {
      if (method === "preview") {
        setPreviewError(true);
      }
    },
    asRole
  });
  const { requestPermission } = useAwayNotifications2();
  const roomState = useHMSStore71(selectRoomState7);
  const savePreferenceAndJoin = useCallback33(() => {
    setPreviewPreference({
      name
    });
    join();
  }, [join, name, setPreviewPreference]);
  const { elements = {} } = useRoomLayoutPreviewScreen();
  const { preview_header: previewHeader = {}, virtual_background } = elements || {};
  const aspectRatio = useLocalTileAspectRatio();
  useEffect43(() => {
    if (authToken) {
      if (skipPreview) {
        savePreferenceAndJoin();
      } else {
        preview().then(() => requestPermission());
      }
    }
  }, [authToken, skipPreview]);
  useEffect43(() => {
    if (initialName) {
      setName(initialName);
    }
  }, [initialName]);
  return roomState === HMSRoomState7.Preview ? /* @__PURE__ */ React136.createElement(Flex, { justify: "center", css: { size: "100%", position: "relative" } }, /* @__PURE__ */ React136.createElement(Container4, { css: { h: "100%", pt: "$6", "@md": { justifyContent: "space-between", pt: "$10" } } }, toggleVideo ? null : /* @__PURE__ */ React136.createElement(Box, null), /* @__PURE__ */ React136.createElement(Flex, { direction: "column", justify: "center", css: { w: "100%", maxWidth: "600px", gap: "$8" } }, /* @__PURE__ */ React136.createElement(Logo, null), /* @__PURE__ */ React136.createElement(Text, { variant: "h4", css: { wordBreak: "break-word", textAlign: "center" } }, previewHeader.title), /* @__PURE__ */ React136.createElement(
    Text,
    {
      css: { c: "$on_surface_medium", textAlign: "center", maxWidth: "100%", wordWrap: "break-word" },
      variant: "sm"
    },
    previewHeader.sub_title
  ), /* @__PURE__ */ React136.createElement(Flex, { justify: "center", css: { gap: "$4" } }, isStreamingOn ? /* @__PURE__ */ React136.createElement(
    Chip_default,
    {
      content: "LIVE",
      backgroundColor: "$alert_error_default",
      textColor: "#FFF",
      icon: /* @__PURE__ */ React136.createElement(Box, { css: { h: "$sm", w: "$sm", backgroundColor: "$on_primary_high", borderRadius: "$round" } })
    }
  ) : null, /* @__PURE__ */ React136.createElement(Chip_default, { content: getParticipantChipContent(peerCount), hideIfNoContent: true }))), toggleVideo ? /* @__PURE__ */ React136.createElement(PreviewTile, { name, error: previewError }) : null, /* @__PURE__ */ React136.createElement(Box, { css: { w: "100%", maxWidth: `${Math.max(parseFloat(aspectRatio), 1) * 340}px` } }, /* @__PURE__ */ React136.createElement(PreviewControls, { hideSettings: !toggleVideo && !toggleAudio, vbEnabled: !!virtual_background }), /* @__PURE__ */ React136.createElement(
    PreviewForm_default,
    {
      name,
      disabled: !!initialName,
      onChange: setName,
      enableJoin: enableJoin && !loadingEffects,
      onJoin: savePreferenceAndJoin,
      cannotPublishVideo: !toggleVideo,
      cannotPublishAudio: !toggleAudio
    }
  ))), /* @__PURE__ */ React136.createElement(Box, { css: { position: "absolute", right: "0", top: 0, height: "100%", overflow: "hidden" } }, /* @__PURE__ */ React136.createElement(SidePane_default, null))) : /* @__PURE__ */ React136.createElement(FullPageProgress_default, null);
};
var Container4 = styled("div", __spreadProps(__spreadValues({
  width: "100%"
}, flexCenter), {
  flexDirection: "column",
  px: "$10"
}));
var PreviewTile = ({ name, error }) => {
  const localPeer = useHMSStore71(selectLocalPeer9);
  const { isLocalAudioEnabled, toggleAudio } = useAVToggle4();
  const isVideoOn = useHMSStore71(selectIsLocalVideoEnabled7);
  const mirrorLocalVideo = useUISettings(UI_SETTINGS.mirrorLocalVideo);
  const trackSelector = selectVideoTrackByID5(localPeer == null ? void 0 : localPeer.videoTrack);
  const track = useHMSStore71(trackSelector);
  const showMuteIcon = !isLocalAudioEnabled || !toggleAudio;
  const aspectRatio = useLocalTileAspectRatio();
  const [ref, { width: calculatedWidth, height: calculatedHeight }] = useMeasure4();
  const [avatarSize, attribBoxSize] = useMemo15(
    () => calculateAvatarAndAttribBoxSize(calculatedWidth, calculatedHeight),
    [calculatedWidth, calculatedHeight]
  );
  return /* @__PURE__ */ React136.createElement(
    StyledVideoTile.Container,
    {
      ref,
      css: {
        bg: "$surface_default",
        aspectRatio,
        height: "min(340px, 70vh)",
        width: "auto",
        maxWidth: "600px",
        overflow: "clip",
        mt: "$10",
        "@md": {
          mt: 0,
          width: "min(220px, 70vw)",
          maxWidth: "100%",
          my: "$4"
        }
      }
    },
    localPeer ? /* @__PURE__ */ React136.createElement(React136.Fragment, null, /* @__PURE__ */ React136.createElement(TileConnection_default, { name: "", peerId: localPeer.id, hideLabel: false }), /* @__PURE__ */ React136.createElement(
      Video,
      {
        mirror: (track == null ? void 0 : track.facingMode) !== "environment" && mirrorLocalVideo,
        trackId: localPeer.videoTrack,
        "data-testid": "preview_tile"
      }
    ), !isVideoOn ? /* @__PURE__ */ React136.createElement(StyledVideoTile.AvatarContainer, null, /* @__PURE__ */ React136.createElement(Avatar, { name, "data-testid": "preview_avatar_tile", size: avatarSize })) : null) : null,
    !localPeer && !error ? /* @__PURE__ */ React136.createElement(FullPageProgress_default, null) : null,
    showMuteIcon ? /* @__PURE__ */ React136.createElement(StyledVideoTile.AudioIndicator, { size: attribBoxSize }, /* @__PURE__ */ React136.createElement(MicOffIcon7, null)) : /* @__PURE__ */ React136.createElement(StyledVideoTile.AudioIndicator, { size: attribBoxSize }, /* @__PURE__ */ React136.createElement(AudioLevel, { trackId: localPeer == null ? void 0 : localPeer.audioTrack }))
  );
};
var PreviewControls = ({ hideSettings, vbEnabled }) => {
  const isMobile = useMedia27(config.media.md);
  const isVBEnabledForUser = useHMSStore71(selectIsVBEnabled2);
  return /* @__PURE__ */ React136.createElement(
    Flex,
    {
      justify: hideSettings && isMobile ? "center" : "between",
      css: {
        width: "100%",
        mt: "$6"
      }
    },
    /* @__PURE__ */ React136.createElement(Flex, { css: { gap: "$4" } }, /* @__PURE__ */ React136.createElement(AudioVideoToggle, null), vbEnabled && isVBEnabledForUser ? /* @__PURE__ */ React136.createElement(VBToggle, null) : null),
    /* @__PURE__ */ React136.createElement(Flex, { align: "center", gap: "1" }, isMobile && /* @__PURE__ */ React136.createElement(NoiseCancellation, { iconOnly: true }), !hideSettings ? /* @__PURE__ */ React136.createElement(PreviewSettings, null) : null)
  );
};
var PreviewSettings = React136.memo(() => {
  const [open, setOpen] = useState58(false);
  return /* @__PURE__ */ React136.createElement(Fragment12, null, /* @__PURE__ */ React136.createElement(IconButton_default, { "data-testid": "preview_setting_btn", css: { flexShrink: 0 }, onClick: () => setOpen((value) => !value) }, /* @__PURE__ */ React136.createElement(SettingsIcon6, null)), open && /* @__PURE__ */ React136.createElement(SettingsModal_default, { open, onOpenChange: setOpen }));
});
var PreviewJoin_default = PreviewJoin;

// src/Prebuilt/components/RoleChangeRequest/RequestPrompt.tsx
init_define_process_env();
import React137 from "react";
import { useMedia as useMedia28 } from "react-use";
var RequestPrompt = ({
  open = true,
  onOpenChange,
  title,
  body,
  actionText = "Accept",
  onAction,
  disableActions = false
}) => {
  const isMobile = useMedia28(config.media.md);
  if (isMobile) {
    return /* @__PURE__ */ React137.createElement(Sheet.Root, { open, onOpenChange }, /* @__PURE__ */ React137.createElement(Sheet.Content, { css: { py: "$8" } }, /* @__PURE__ */ React137.createElement(Text, { css: { fontWeight: "$semiBold", c: "$on_surface_high", "@md": { px: "$8" } } }, title), body, /* @__PURE__ */ React137.createElement(RequestActions, { actionText, onAction, disabled: disableActions })));
  }
  return /* @__PURE__ */ React137.createElement(Dialog.Root, { open, modal: false, onOpenChange }, /* @__PURE__ */ React137.createElement(Dialog.Portal, null, /* @__PURE__ */ React137.createElement(Dialog.Content, { css: { p: "$10" }, onInteractOutside: (e) => e.preventDefault() }, /* @__PURE__ */ React137.createElement(Dialog.Title, { css: { p: 0, display: "flex", flexDirection: "row", gap: "$md", justifyContent: "center" } }, /* @__PURE__ */ React137.createElement(Text, { variant: "h6" }, title)), /* @__PURE__ */ React137.createElement(Box, { css: { mt: "$4", mb: "$10" } }, body), /* @__PURE__ */ React137.createElement(RequestActions, { actionText, onAction, disabled: disableActions }))));
};
var RequestActions = ({
  onAction,
  actionText,
  disabled = false
}) => /* @__PURE__ */ React137.createElement(Flex, { justify: "center", align: "center", css: { width: "100%", gap: "$md", "@md": { mt: "$8", px: "$8" } } }, /* @__PURE__ */ React137.createElement(Box, { css: { width: "50%" } }, /* @__PURE__ */ React137.createElement(Dialog.Close, { css: { width: "100%", height: "100%" }, asChild: true }, /* @__PURE__ */ React137.createElement(Button, { variant: "standard", outlined: true, css: { width: "100%", p: "$4 $8" }, disabled }, "Decline"))), /* @__PURE__ */ React137.createElement(Box, { css: { width: "50%" } }, /* @__PURE__ */ React137.createElement(Button, { variant: "primary", css: { width: "100%" }, onClick: onAction, disabled }, actionText)));

// src/Prebuilt/components/RoleChangeRequest/RoleChangeRequestModal.tsx
var RoleChangeRequestModal = () => {
  const hmsActions = useHMSActions46();
  const { updateMetaData } = useMyMetadata();
  const isPreview = useHMSStore72(selectIsInPreview);
  const currentRole = useHMSStore72(selectLocalPeerRoleName4);
  const roleChangeRequest = useHMSStore72(selectRoleChangeRequest);
  const name = useHMSStore72(selectLocalPeerName4);
  const { sendEvent } = useCustomEvent3({ type: ROLE_CHANGE_DECLINED });
  const { elements = {} } = useRoomLayoutPreviewScreen();
  const { virtual_background } = elements || {};
  useEffect44(() => {
    if (!(roleChangeRequest == null ? void 0 : roleChangeRequest.role)) {
      return;
    }
    (() => __async(void 0, null, function* () {
      yield hmsActions.preview({ asRole: roleChangeRequest.role.name });
    }))();
  }, [hmsActions, roleChangeRequest, currentRole, updateMetaData]);
  if (!(roleChangeRequest == null ? void 0 : roleChangeRequest.role)) {
    return null;
  }
  const body = /* @__PURE__ */ React138.createElement(React138.Fragment, null, /* @__PURE__ */ React138.createElement(
    Text,
    {
      variant: "xs",
      css: {
        c: "$on_surface_medium",
        textAlign: "center",
        "@md": { textAlign: "left", borderBottom: "1px solid $border_bright", pb: "$4", px: "$8" }
      }
    },
    "Setup your audio and video before joining"
  ), /* @__PURE__ */ React138.createElement(
    Flex,
    {
      align: "center",
      justify: "center",
      css: {
        "@sm": { width: "100%" },
        flexDirection: "column",
        mt: "$6",
        "@md": { px: "$8" }
      }
    },
    /* @__PURE__ */ React138.createElement(PreviewTile, { name: name || "" }),
    /* @__PURE__ */ React138.createElement(PreviewControls, { hideSettings: true, vbEnabled: !!virtual_background })
  ));
  return /* @__PURE__ */ React138.createElement(
    RequestPrompt,
    {
      title: "You're invited to join the stage",
      onOpenChange: (value) => __async(void 0, null, function* () {
        var _a8;
        if (!value) {
          hmsActions.rejectChangeRole(roleChangeRequest);
          sendEvent(__spreadProps(__spreadValues({}, roleChangeRequest), { peerName: name }), { peerId: (_a8 = roleChangeRequest.requestedBy) == null ? void 0 : _a8.id });
          yield hmsActions.cancelMidCallPreview();
          yield hmsActions.lowerLocalPeerHand();
        }
      }),
      body,
      onAction: () => __async(void 0, null, function* () {
        yield hmsActions.acceptChangeRole(roleChangeRequest);
        yield updateMetaData({ prevRole: currentRole });
        yield hmsActions.lowerLocalPeerHand();
      }),
      actionText: "Accept",
      disableActions: !isPreview
    }
  );
};

// src/Prebuilt/layouts/VideoStreamingSection.tsx
init_define_process_env();
import React172, { useEffect as useEffect62, useState as useState73 } from "react";
import { useMedia as useMedia42 } from "react-use";
import { match as match14 } from "ts-pattern";
import {
  selectIsConnectedToRoom as selectIsConnectedToRoom9,
  selectIsLocalScreenShared as selectIsLocalScreenShared2,
  selectLocalPeerRoleName as selectLocalPeerRoleName6,
  useHMSActions as useHMSActions49,
  useHMSStore as useHMSStore84
} from "@100mslive/react-sdk";
import { PeopleAddIcon as PeopleAddIcon3, ShareScreenIcon as ShareScreenIcon5 } from "@100mslive/react-icons";

// src/Prebuilt/components/VideoLayouts/GridLayout.tsx
init_define_process_env();
import React153, { useEffect as useEffect53, useMemo as useMemo20, useState as useState66 } from "react";
import {
  selectLocalPeerID as selectLocalPeerID13,
  selectLocalPeerRoleName as selectLocalPeerRoleName5,
  selectPeers as selectPeers3,
  selectPeerScreenSharing as selectPeerScreenSharing2,
  selectWhiteboard as selectWhiteboard2,
  useHMSStore as useHMSStore79,
  useHMSVanillaStore as useHMSVanillaStore13
} from "@100mslive/react-sdk";

// src/Prebuilt/components/VideoLayouts/EqualProminence.tsx
init_define_process_env();
import React144, { useEffect as useEffect48, useState as useState60 } from "react";
import { useMedia as useMedia31 } from "react-use";
import { PeopleAddIcon as PeopleAddIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/layouts/WaitingView.tsx
init_define_process_env();
import React139 from "react";
var WaitingView = React139.memo(
  ({ icon, title, subtitle }) => {
    return /* @__PURE__ */ React139.createElement(
      Flex,
      {
        align: "center",
        direction: "column",
        css: {
          textAlign: "center",
          margin: "auto",
          h: "100%",
          justifyContent: "center",
          gap: "$8"
        }
      },
      /* @__PURE__ */ React139.createElement(
        Box,
        {
          css: {
            backgroundColor: "$surface_default",
            display: "flex",
            alignItems: "center",
            gap: "$4",
            size: "$20",
            r: "$round",
            justifyContent: "center"
          }
        },
        icon
      ),
      /* @__PURE__ */ React139.createElement(
        Flex,
        {
          direction: "column",
          css: {
            p: "$1",
            gap: "$4"
          }
        },
        /* @__PURE__ */ React139.createElement(Text, { variant: "h4", css: { "@md": { fontSize: "$lg", color: "$on_surface_high" } } }, title),
        /* @__PURE__ */ React139.createElement(
          Text,
          {
            variant: "body1",
            css: { fontWeight: "$regular", color: "$on_surface_medium", "@md": { fontSize: "$md" } }
          },
          subtitle
        )
      )
    );
  }
);

// src/Prebuilt/components/InsetTile.tsx
init_define_process_env();
import React141, { useEffect as useEffect45, useRef as useRef28 } from "react";
import Draggable from "react-draggable";
import { useMedia as useMedia29 } from "react-use";
import {
  selectIsAllowedToPublish as selectIsAllowedToPublish3,
  selectLocalPeer as selectLocalPeer10,
  selectPeerByID as selectPeerByID3,
  selectVideoTrackByID as selectVideoTrackByID6,
  useHMSStore as useHMSStore73
} from "@100mslive/react-sdk";
import { ExpandIcon as ExpandIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/hooks/useVideoTileLayout.ts
init_define_process_env();
import React140, { useContext as useContext5 } from "react";
var VideoTileContext = React140.createContext({
  enableSpotlightingPeer: true,
  hideParticipantNameOnTile: false,
  roundedVideoTile: true,
  hideAudioMuteOnTile: false,
  hideAudioLevelOnTile: false,
  objectFit: "contain",
  hideMetadataOnTile: false
});
var useVideoTileContext = () => {
  const context = useContext5(VideoTileContext);
  return context;
};

// src/Prebuilt/components/InsetTile.tsx
var MinimisedTile = ({ setMinimised }) => {
  return /* @__PURE__ */ React141.createElement(Flex, { align: "center", css: { gap: "$6", r: "$1", bg: "$surface_default", p: "$4", color: "$on_surface_high" } }, /* @__PURE__ */ React141.createElement(AudioVideoToggle, { hideOptions: true }), /* @__PURE__ */ React141.createElement(Text, null, "You"), /* @__PURE__ */ React141.createElement(
    IconButton_default,
    {
      className: "__cancel-drag-event",
      onClick: () => setMinimised(false),
      css: { bg: "transparent", border: "transparent" }
    },
    /* @__PURE__ */ React141.createElement(ExpandIcon2, null)
  ));
};
var insetHeightPx = 180;
var insetMaxWidthPx = 240;
var defaultMobileAspectRatio = 9 / 16;
var desktopAspectRatio = 1 / defaultMobileAspectRatio;
var InsetTile = ({ peerId }) => {
  const isMobile = useMedia29(config.media.md);
  const isLandscape = useMedia29(config.media.ls);
  const selector = peerId ? selectPeerByID3(peerId) : selectLocalPeer10;
  const peer = useHMSStore73(selector);
  const [minimised, setMinimised] = useSetAppDataByKey(APP_DATA.minimiseInset);
  const videoTrack = useHMSStore73(selectVideoTrackByID6(peer == null ? void 0 : peer.videoTrack));
  const isAllowedToPublish = useHMSStore73(selectIsAllowedToPublish3);
  const videoTileProps = useVideoTileContext();
  let aspectRatio = isMobile ? defaultMobileAspectRatio : desktopAspectRatio;
  if ((videoTrack == null ? void 0 : videoTrack.width) && (videoTrack == null ? void 0 : videoTrack.height) && !isMobile) {
    aspectRatio = videoTrack.width / videoTrack.height;
  }
  let height = insetHeightPx;
  let width = height * aspectRatio;
  if (isLandscape && width > insetMaxWidthPx) {
    width = 240;
    height = width / aspectRatio;
  }
  const nodeRef = useRef28(null);
  useEffect45(() => {
    const node = nodeRef.current;
    if (!node || !window.ResizeObserver) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === node.parentElement) {
          node.style.transform = `translate(0,0)`;
        }
      });
    });
    node.parentElement && resizeObserver.observe(node.parentElement);
    return () => {
      (node == null ? void 0 : node.parentElement) && (resizeObserver == null ? void 0 : resizeObserver.unobserve(node.parentElement));
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
    };
  }, []);
  if (!isAllowedToPublish.video && !isAllowedToPublish.audio) {
    return null;
  }
  return /* @__PURE__ */ React141.createElement(Draggable, { bounds: "parent", nodeRef, cancel: ".__cancel-drag-event" }, /* @__PURE__ */ React141.createElement(
    Box,
    {
      ref: nodeRef,
      css: __spreadValues({
        position: "absolute",
        bottom: 0,
        right: 0,
        zIndex: 10,
        boxShadow: "0 0 8px 0 rgba(0,0,0,0.3)",
        r: "$2"
      }, !minimised ? {
        aspectRatio: `${aspectRatio}`,
        h: height
      } : {})
    },
    minimised ? /* @__PURE__ */ React141.createElement(MinimisedTile, { setMinimised }) : /* @__PURE__ */ React141.createElement(
      VideoTile_default,
      __spreadProps(__spreadValues({
        peerId: peer == null ? void 0 : peer.id,
        trackId: peer == null ? void 0 : peer.videoTrack,
        rootCSS: {
          size: "100%",
          padding: 0
        },
        width,
        height,
        containerCSS: { background: "$surface_default" },
        canMinimise: true,
        isDragabble: true
      }, videoTileProps), {
        hideParticipantNameOnTile: true
      })
    )
  ));
};

// src/Prebuilt/components/Pagination.tsx
init_define_process_env();
import React142, { useEffect as useEffect46 } from "react";
import { ChevronLeftIcon as ChevronLeftIcon7, ChevronRightIcon as ChevronRightIcon4 } from "@100mslive/react-icons";
var Pagination = ({
  page,
  onPageChange,
  numPages
}) => {
  const disableLeft = page === 0;
  const disableRight = page === numPages - 1;
  const nextPage = (e) => {
    e.stopPropagation();
    onPageChange(Math.min(page + 1, numPages - 1));
  };
  const prevPage = (e) => {
    e.stopPropagation();
    onPageChange(Math.max(page - 1, 0));
  };
  useEffect46(() => {
    if (page >= numPages) {
      onPageChange(Math.max(0, numPages - 1));
    }
  }, [numPages, onPageChange, page]);
  if (numPages <= 1) {
    return null;
  }
  return /* @__PURE__ */ React142.createElement(StyledPagination.Root, { css: { flexShrink: 0 } }, /* @__PURE__ */ React142.createElement(StyledPagination.Chevron, { disabled: disableLeft, onClick: prevPage }, /* @__PURE__ */ React142.createElement(ChevronLeftIcon7, { width: 16, height: 16, style: { cursor: disableLeft ? "not-allowed" : "pointer" } })), numPages <= 5 ? /* @__PURE__ */ React142.createElement(StyledPagination.Dots, null, [...Array(numPages)].map((_, i) => /* @__PURE__ */ React142.createElement(
    StyledPagination.Dot,
    {
      key: i,
      active: page === i,
      onClick: (e) => {
        e.stopPropagation();
        onPageChange(i);
      }
    }
  ))) : null, /* @__PURE__ */ React142.createElement(StyledPagination.Chevron, { disabled: disableRight, onClick: nextPage }, /* @__PURE__ */ React142.createElement(ChevronRightIcon4, { width: 16, height: 16, style: { cursor: disableRight ? "not-allowed" : "pointer" } })));
};

// src/Prebuilt/components/VideoLayouts/Grid.tsx
init_define_process_env();
import React143 from "react";
var Grid = React143.forwardRef(
  ({ tiles, edgeToEdge }, ref) => {
    const videoTileProps = useVideoTileContext();
    return /* @__PURE__ */ React143.createElement(
      Box,
      {
        ref,
        css: {
          flex: "1 1 0",
          gap: "$4",
          display: "flex",
          placeContent: "center",
          alignItems: "center",
          justifyContent: "center",
          flexFlow: "row wrap",
          minHeight: 0,
          "@lg": { gap: edgeToEdge ? 0 : "$4" }
        }
      },
      tiles == null ? void 0 : tiles.map((tile) => {
        var _a8, _b7, _c, _d;
        return /* @__PURE__ */ React143.createElement(
          VideoTile_default,
          __spreadValues({
            key: ((_a8 = tile.track) == null ? void 0 : _a8.id) || ((_b7 = tile.peer) == null ? void 0 : _b7.id),
            width: tile.width,
            height: tile.height,
            peerId: (_c = tile.peer) == null ? void 0 : _c.id,
            trackId: (_d = tile.track) == null ? void 0 : _d.id,
            rootCSS: { padding: 0 },
            objectFit: "contain"
          }, videoTileProps)
        );
      })
    );
  }
);

// src/Prebuilt/components/hooks/useTileLayout.tsx
init_define_process_env();
import { useEffect as useEffect47, useMemo as useMemo16, useState as useState59 } from "react";
import { useMeasure as useMeasure5, useMedia as useMedia30 } from "react-use";
import {
  getPeersWithTiles,
  selectTracksMap as selectTracksMap4,
  useHMSVanillaStore as useHMSVanillaStore12
} from "@100mslive/react-sdk";
var aspectRatioConfig = { default: [1 / 1, 4 / 3, 16 / 9], mobile: [1 / 1, 3 / 4, 9 / 16] };
var usePagesWithTiles = ({ peers, maxTileCount }) => {
  const vanillaStore = useHMSVanillaStore12();
  const tracksMap = vanillaStore.getState(selectTracksMap4);
  const peersWithTiles = useMemo16(
    () => getPeersWithTiles(peers, tracksMap, () => false),
    [peers, tracksMap]
  );
  const noOfPages = Math.ceil(peersWithTiles.length / maxTileCount);
  const pagesList = useMemo16(() => {
    let sliceStart = 0;
    let remaining = peersWithTiles.length;
    const list = [];
    for (let i = 0; i < noOfPages; i++) {
      const count = Math.min(remaining, maxTileCount);
      list.push(peersWithTiles.slice(sliceStart, sliceStart + count));
      remaining = remaining - count;
      sliceStart += count;
    }
    return list;
  }, [peersWithTiles, noOfPages, maxTileCount]);
  return pagesList;
};
var useTileLayout = ({
  pageList,
  maxTileCount,
  edgeToEdge = false
}) => {
  const vanillaStore = useHMSVanillaStore12();
  const [ref, { width, height }] = useMeasure5();
  const isMobile = useMedia30(config.media.lg);
  const [pagesWithTiles, setPagesWithTiles] = useState59([]);
  useEffect47(() => {
    if (width === 0 || height === 0) {
      return;
    }
    for (const page of pageList) {
      const noOfTilesInPage = page.length;
      let maxCols = noOfTilesInPage > 2 && noOfTilesInPage < 9 ? Math.ceil(noOfTilesInPage / 2) : Math.ceil(Math.sqrt(noOfTilesInPage));
      if (isMobile) {
        maxCols = noOfTilesInPage < 4 ? 1 : Math.min(maxCols, 2);
      }
      const maxRows = Math.ceil(noOfTilesInPage / maxCols);
      let index = 0;
      const matrix = new Array(maxRows).fill(null).map((_, i) => {
        const numCols = Math.min(maxCols, noOfTilesInPage - i * maxCols);
        const rowElements = [];
        for (let j2 = 0; j2 < numCols; j2++) {
          if (index < page.length) {
            rowElements.push(page[index++]);
          }
        }
        return rowElements;
      });
      const gap = edgeToEdge && isMobile ? 0 : 8;
      const maxHeight = height - (maxRows - 1) * gap;
      const maxRowHeight = maxHeight / matrix.length;
      const aspectRatios = isMobile && (noOfTilesInPage === 1 || noOfTilesInPage > 3) ? aspectRatioConfig.mobile : aspectRatioConfig.default;
      for (const row of matrix) {
        let tileWidth = (width - (row.length - 1) * gap) / row.length;
        let tileHeight = 0;
        if (edgeToEdge) {
          tileHeight = maxRowHeight;
        } else {
          const calcHeights = aspectRatios.map((aR) => tileWidth / aR);
          for (const h of calcHeights) {
            if (h < maxRowHeight) {
              if (tileHeight < h) {
                tileHeight = h;
              }
            }
          }
          if (tileHeight === 0) {
            tileHeight = maxRowHeight;
            const calcWidths = aspectRatios.map((aR) => tileHeight * aR);
            tileWidth = 0;
            for (const w of calcWidths) {
              if (w < width) {
                if (tileWidth < w) {
                  tileWidth = w;
                }
              }
            }
          }
        }
        for (let i = 0; i < row.length; i++) {
          row[i].width = tileWidth;
          row[i].height = tileHeight;
        }
      }
    }
    setPagesWithTiles([...pageList]);
  }, [width, height, maxTileCount, pageList, vanillaStore, isMobile, edgeToEdge]);
  return { pagesWithTiles, ref };
};

// src/Prebuilt/components/VideoLayouts/EqualProminence.tsx
function EqualProminence({ isInsetEnabled = false, peers, onPageChange, onPageSize, edgeToEdge }) {
  var _a8;
  const isMobile = useMedia31(config.media.md);
  let maxTileCount = useUISettings(UI_SETTINGS.maxTileCount);
  maxTileCount = isMobile ? Math.min(maxTileCount, 6) : maxTileCount;
  const pageList = usePagesWithTiles({
    peers,
    maxTileCount
  });
  const { ref, pagesWithTiles } = useTileLayout({
    pageList,
    maxTileCount,
    edgeToEdge
  });
  const [page, setPage] = useState60(0);
  const pageSize = ((_a8 = pagesWithTiles[0]) == null ? void 0 : _a8.length) || 0;
  useEffect48(() => {
    if (pageSize > 0) {
      onPageSize == null ? void 0 : onPageSize(pageSize);
    }
  }, [pageSize, onPageSize]);
  return /* @__PURE__ */ React144.createElement(Flex, { direction: "column", css: { flex: "1 1 0", h: "100%", position: "relative", minWidth: 0 } }, /* @__PURE__ */ React144.createElement(Grid, { tiles: pagesWithTiles[page], ref, edgeToEdge }), !edgeToEdge && /* @__PURE__ */ React144.createElement(
    Pagination,
    {
      page,
      onPageChange: (page2) => {
        setPage(page2);
        onPageChange == null ? void 0 : onPageChange(page2);
      },
      numPages: pagesWithTiles.length
    }
  ), pageList.length === 0 ? /* @__PURE__ */ React144.createElement(
    WaitingView,
    {
      title: "You're the only one here",
      subtitle: "Sit back and relax till others join",
      icon: /* @__PURE__ */ React144.createElement(PeopleAddIcon2, { width: "56px", height: "56px", style: { color: "white" } })
    }
  ) : null, isInsetEnabled && /* @__PURE__ */ React144.createElement(InsetTile, null));
}

// src/Prebuilt/components/VideoLayouts/RoleProminence.tsx
init_define_process_env();
import React147, { useEffect as useEffect50, useState as useState62 } from "react";
import { useMedia as useMedia33 } from "react-use";
import { selectLocalPeer as selectLocalPeer11, useHMSStore as useHMSStore75 } from "@100mslive/react-sdk";

// src/Prebuilt/components/SecondaryTiles.tsx
init_define_process_env();
import React146, { useEffect as useEffect49, useRef as useRef29, useState as useState61 } from "react";
import { useMedia as useMedia32 } from "react-use";
import { selectAppData as selectAppData10, selectSessionStore as selectSessionStore12, selectTrackByID as selectTrackByID4, useHMSStore as useHMSStore74 } from "@100mslive/react-sdk";

// src/Prebuilt/components/VideoLayouts/ProminenceLayout.tsx
init_define_process_env();
import React145 from "react";
var Root26 = ({
  children,
  edgeToEdge,
  hasSidebar
}) => {
  return /* @__PURE__ */ React145.createElement(
    Flex,
    {
      direction: hasSidebar ? "row" : "column",
      css: { h: "100%", flex: "1 1 0", minWidth: 0, gap: "$6", "@md": { gap: edgeToEdge ? 0 : "$6" } }
    },
    children
  );
};
var ProminentSection = ({ children, css: css2 = {} }) => {
  return /* @__PURE__ */ React145.createElement(Flex, { direction: "column", css: __spreadValues({ flex: "1 1 0", gap: "$2", minHeight: 0 }, css2) }, children);
};
var SecondarySection = ({
  tiles,
  children,
  edgeToEdge,
  hasSidebar
}) => {
  const tileLayoutProps = useVideoTileContext();
  if (!(tiles == null ? void 0 : tiles.length)) {
    return null;
  }
  const gridStyles = hasSidebar ? {
    gridTemplateColumns: "1fr",
    gridTemplateRows: `repeat(${tiles.length}, minmax(0, 1fr))`,
    maxHeight: "100%",
    width: 240
  } : {
    gridTemplateRows: React145.Children.count(children) > 0 ? "136px auto" : "154px",
    gridTemplateColumns: `repeat(${tiles.length}, minmax(0, 1fr))`
  };
  return /* @__PURE__ */ React145.createElement(
    Box,
    {
      css: __spreadProps(__spreadValues({
        display: "grid",
        margin: "auto",
        gap: hasSidebar ? "$8" : "$2 $4",
        placeItems: "center"
      }, gridStyles), {
        "@md": { gap: edgeToEdge ? 0 : "$4" }
      })
    },
    tiles.map((tile) => {
      var _a8, _b7, _c, _d;
      return /* @__PURE__ */ React145.createElement(
        VideoTile_default,
        __spreadValues({
          key: ((_a8 = tile.track) == null ? void 0 : _a8.id) || ((_b7 = tile.peer) == null ? void 0 : _b7.id),
          peerId: (_c = tile.peer) == null ? void 0 : _c.id,
          trackId: (_d = tile.track) == null ? void 0 : _d.id,
          rootCSS: __spreadProps(__spreadValues({
            padding: 0,
            maxWidth: 240,
            aspectRatio: "16 / 9"
          }, hasSidebar ? { w: "100%" } : { h: "100%" }), {
            "@md": { aspectRatio: "1" }
          }),
          objectFit: "contain"
        }, tileLayoutProps)
      );
    }),
    children && /* @__PURE__ */ React145.createElement(Box, { css: { gridColumn: hasSidebar ? 1 : `1/span ${tiles.length}` } }, children)
  );
};
var ProminenceLayout = {
  Root: Root26,
  ProminentSection,
  SecondarySection
};

// src/Prebuilt/components/SecondaryTiles.tsx
var SecondaryTiles = ({ peers, onPageChange, onPageSize, edgeToEdge, hasSidebar }) => {
  var _a8, _b7;
  const isMobile = useMedia32(config.media.md);
  const maxTileCount = isMobile ? 2 : 4;
  const [page, setPage] = useState61(0);
  const pinnedTrackId = useHMSStore74(selectAppData10(APP_DATA.pinnedTrackId));
  const spotlightPeerId = useHMSStore74(selectSessionStore12("spotlight" /* SPOTLIGHT */));
  const activeScreensharePeerId = useHMSStore74(selectAppData10(APP_DATA.activeScreensharePeerId));
  const pinnedPeer = (_a8 = useHMSStore74(selectTrackByID4(pinnedTrackId))) == null ? void 0 : _a8.peerId;
  const pageChangedAfterPinning = useRef29(false);
  const pagesWithTiles = usePagesWithTiles({
    peers: spotlightPeerId || pinnedPeer ? [...peers].sort((p1, p2) => {
      if (activeScreensharePeerId === p1.id) {
        return -1;
      }
      if (activeScreensharePeerId === p2.id) {
        return 1;
      }
      const peerIdList = [pinnedPeer, spotlightPeerId];
      if (peerIdList.includes(p1.id)) {
        return -1;
      }
      if (peerIdList.includes(p2.id)) {
        return 1;
      }
      return 0;
    }) : peers,
    maxTileCount
  });
  const pageSize = ((_b7 = pagesWithTiles[0]) == null ? void 0 : _b7.length) || 0;
  useEffect49(() => {
    var _a9;
    if (peers.length > 0 && !((_a9 = pagesWithTiles[page]) == null ? void 0 : _a9.length)) {
      setPage(Math.max(0, page - 1));
    }
  }, [peers, page, pagesWithTiles]);
  useEffect49(() => {
    if (pageSize > 0) {
      onPageSize == null ? void 0 : onPageSize(pageSize);
    }
  }, [pageSize, onPageSize]);
  useEffect49(() => {
    if ((pinnedPeer || spotlightPeerId) && page !== 0 && !pageChangedAfterPinning.current) {
      setPage(0);
      pageChangedAfterPinning.current = true;
    } else if (!pinnedPeer && !spotlightPeerId) {
      pageChangedAfterPinning.current = false;
    }
  }, [pinnedPeer, spotlightPeerId, page]);
  return /* @__PURE__ */ React146.createElement(ProminenceLayout.SecondarySection, { tiles: pagesWithTiles[page], edgeToEdge, hasSidebar }, !edgeToEdge && /* @__PURE__ */ React146.createElement(
    Pagination,
    {
      page,
      onPageChange: (page2) => {
        setPage(page2);
        onPageChange == null ? void 0 : onPageChange(page2);
      },
      numPages: pagesWithTiles.length
    }
  ));
};

// src/Prebuilt/components/hooks/useRoleProminencePeers.tsx
init_define_process_env();
import { useMemo as useMemo17 } from "react";
var useRoleProminencePeers = (prominentRoles, peers, isInsetEnabled) => {
  const pinnedTrack = usePinnedTrack();
  const [prominentPeers, secondaryPeers] = useMemo17(() => {
    return peers.reduce(
      (acc, peer) => {
        if (pinnedTrack) {
          if (pinnedTrack.peerId === peer.id) {
            acc[0].push(peer);
          } else if (!(isInsetEnabled && peer.isLocal)) {
            acc[1].push(peer);
          }
          return acc;
        }
        if (peer.isLocal && isInsetEnabled && !(prominentRoles == null ? void 0 : prominentRoles.includes(peer.roleName || ""))) {
          return acc;
        }
        if (prominentRoles == null ? void 0 : prominentRoles.includes(peer.roleName || "")) {
          acc[0].push(peer);
        } else {
          acc[1].push(peer);
        }
        return acc;
      },
      [[], []]
    );
  }, [peers, isInsetEnabled, prominentRoles, pinnedTrack]);
  return {
    prominentPeers,
    secondaryPeers
  };
};

// src/Prebuilt/components/VideoLayouts/RoleProminence.tsx
function RoleProminence({
  isInsetEnabled = false,
  prominentRoles = [],
  peers,
  onPageChange,
  onPageSize,
  edgeToEdge
}) {
  var _a8;
  const { prominentPeers, secondaryPeers } = useRoleProminencePeers(prominentRoles, peers, isInsetEnabled);
  const localPeer = useHMSStore75(selectLocalPeer11);
  const isMobile = useMedia33(config.media.md);
  let maxTileCount = useUISettings(UI_SETTINGS.maxTileCount);
  maxTileCount = isMobile ? 4 : maxTileCount;
  const pageList = usePagesWithTiles({
    peers: prominentPeers,
    maxTileCount
  });
  const { ref, pagesWithTiles } = useTileLayout({
    pageList,
    maxTileCount
  });
  const [page, setPage] = useState62(0);
  const pageSize = ((_a8 = pagesWithTiles[0]) == null ? void 0 : _a8.length) || 0;
  useEffect50(() => {
    if (pageSize > 0) {
      onPageSize == null ? void 0 : onPageSize(pageSize);
    }
  }, [pageSize, onPageSize]);
  return /* @__PURE__ */ React147.createElement(ProminenceLayout.Root, null, /* @__PURE__ */ React147.createElement(ProminenceLayout.ProminentSection, null, /* @__PURE__ */ React147.createElement(Grid, { ref, tiles: pagesWithTiles[page] })), !edgeToEdge && /* @__PURE__ */ React147.createElement(
    Pagination,
    {
      page,
      onPageChange: (page2) => {
        setPage(page2);
        onPageChange == null ? void 0 : onPageChange(page2);
      },
      numPages: pagesWithTiles.length
    }
  ), /* @__PURE__ */ React147.createElement(SecondaryTiles, { peers: secondaryPeers, isInsetEnabled, edgeToEdge }), isInsetEnabled && localPeer && prominentPeers.length > 0 && !prominentPeers.includes(localPeer) && /* @__PURE__ */ React147.createElement(InsetTile, null));
}

// src/Prebuilt/components/VideoLayouts/ScreenshareLayout.tsx
init_define_process_env();
import React151, { useEffect as useEffect51, useMemo as useMemo18, useState as useState65 } from "react";
import { useMedia as useMedia35 } from "react-use";
import { selectPeersScreenSharing, useHMSStore as useHMSStore77 } from "@100mslive/react-sdk";

// src/Prebuilt/components/ScreenshareTile.tsx
init_define_process_env();
import React150, { useRef as useRef30, useState as useState64 } from "react";
import { useFullscreen as useFullscreen2, useMedia as useMedia34 } from "react-use";
import screenfull2 from "screenfull";
import {
  selectLocalPeerID as selectLocalPeerID12,
  selectPeerByID as selectPeerByID4,
  selectScreenShareAudioByPeerID,
  selectScreenShareByPeerID as selectScreenShareByPeerID2,
  useHMSStore as useHMSStore76
} from "@100mslive/react-sdk";
import { ExpandIcon as ExpandIcon3, ShrinkIcon as ShrinkIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/LayoutModeSelector.tsx
init_define_process_env();
import React148, { useCallback as useCallback34, useState as useState63 } from "react";
import { CheckIcon as CheckIcon7, ChevronDownIcon as ChevronDownIcon8, ChevronUpIcon as ChevronUpIcon6 } from "@100mslive/react-icons";
var LayoutModeSelector = () => {
  const [open, setOpen] = useState63(false);
  const [layoutMode, setLayoutMode] = useSetUiSettings(UI_SETTINGS.layoutMode);
  const updateLayoutMode = useCallback34(
    (value) => {
      setLayoutMode(value);
      setOpen(false);
    },
    [setLayoutMode, setOpen]
  );
  return /* @__PURE__ */ React148.createElement(Popover2.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React148.createElement(Popover2.Trigger, { asChild: true }, /* @__PURE__ */ React148.createElement(
    Flex,
    {
      align: "center",
      css: {
        gap: "$4",
        color: open ? "$on_surface_low" : "$on_surface_medium",
        r: "$1",
        p: "$2 $4",
        height: "100%"
      }
    },
    /* @__PURE__ */ React148.createElement(
      Flex,
      {
        align: "center",
        justify: "center",
        css: {
          color: "inherit",
          "& > svg": {
            w: "$9",
            h: "$9"
          }
        }
      },
      LayoutModeIconMapping[layoutMode]
    ),
    /* @__PURE__ */ React148.createElement(Text, { variant: "caption", css: { color: "inherit", lineHeight: "$sm" } }, layoutMode),
    open ? /* @__PURE__ */ React148.createElement(ChevronUpIcon6, { width: 16, height: 16 }) : /* @__PURE__ */ React148.createElement(ChevronDownIcon8, { width: 16, height: 16 })
  )), /* @__PURE__ */ React148.createElement(
    Popover2.Content,
    {
      css: {
        w: "10.75rem",
        r: "$1",
        py: "$4",
        px: 0,
        backgroundColor: "$surface_default",
        overflowY: "auto",
        boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
        fontFamily: "$sans",
        color: "$on_surface_high"
      },
      side: "bottom",
      sideOffset: 8,
      align: "end"
    },
    Object.keys(LayoutMode).map((key) => {
      const value = LayoutMode[key];
      return /* @__PURE__ */ React148.createElement(
        Flex,
        {
          key,
          onClick: () => updateLayoutMode(value),
          align: "center",
          css: {
            gap: "$4",
            borderBottom: "1px solid $border_bright",
            p: "$8",
            "&:hover": {
              cursor: "pointer",
              bg: "$surface_bright"
            },
            "&:focus-visible": {
              bg: "$surface_bright"
            }
          }
        },
        /* @__PURE__ */ React148.createElement(
          Flex,
          {
            align: "center",
            justify: "center",
            css: {
              color: "$on_surface_medium",
              "& > svg": {
                w: "$9",
                h: "$9"
              }
            }
          },
          LayoutModeIconMapping[value]
        ),
        /* @__PURE__ */ React148.createElement(Text, { variant: "caption", css: { lineHeight: "$sm" } }, value),
        value === layoutMode ? /* @__PURE__ */ React148.createElement(CheckIcon7, { width: 20, height: 20, style: { marginLeft: "auto" } }) : null
      );
    })
  ));
};

// src/Prebuilt/components/ScreenshareDisplay.tsx
init_define_process_env();
import React149 from "react";
import { useHMSActions as useHMSActions47 } from "@100mslive/react-sdk";
import { CrossIcon as CrossIcon26, ShareScreenIcon as ShareScreenIcon4 } from "@100mslive/react-icons";
var ScreenshareDisplay = () => {
  const hmsActions = useHMSActions47();
  return /* @__PURE__ */ React149.createElement(
    Flex,
    {
      direction: "column",
      align: "center",
      justify: "center",
      css: {
        size: "100%",
        bg: "$background_default",
        color: "$on_surface_high"
      }
    },
    /* @__PURE__ */ React149.createElement(ShareScreenIcon4, { width: 48, height: 48 }),
    /* @__PURE__ */ React149.createElement(Text, { variant: "h5", css: { m: "$8 0" } }, "You are sharing your screen"),
    /* @__PURE__ */ React149.createElement(
      Button,
      {
        variant: "danger",
        css: { fontWeight: "$semiBold" },
        onClick: () => __async(void 0, null, function* () {
          yield hmsActions.setScreenShareEnabled(false);
        }),
        "data-testid": "stop_screen_share_btn"
      },
      /* @__PURE__ */ React149.createElement(CrossIcon26, { width: 18, height: 18 }),
      "\xA0 Stop screen share"
    )
  );
};

// src/Prebuilt/components/ScreenshareTile.tsx
var labelStyles = {
  position: "unset",
  width: "100%",
  textAlign: "center",
  c: "$on_surface_high",
  transform: "none",
  flexShrink: 0
};
var Tile2 = ({ peerId, width = "100%", height = "100%" }) => {
  const isLocal = useHMSStore76(selectLocalPeerID12) === peerId;
  const track = useHMSStore76(selectScreenShareByPeerID2(peerId));
  const { theme: theme2 } = useTheme();
  const peer = useHMSStore76(selectPeerByID4(peerId));
  const isAudioOnly = useUISettings(UI_SETTINGS.isAudioOnly);
  const [isMouseHovered, setIsMouseHovered] = useState64(false);
  const isMobile = useMedia34(config.media.md);
  const showStatsOnTiles = useUISettings(UI_SETTINGS.showStatsOnTiles);
  const fullscreenRef = useRef30(null);
  const [fullscreen, setFullscreen] = useState64(false);
  const isFullscreen = useFullscreen2(fullscreenRef, fullscreen, {
    onClose: () => setFullscreen(false)
  });
  const isFullScreenSupported = screenfull2.isEnabled;
  const audioTrack = useHMSStore76(selectScreenShareAudioByPeerID(peer == null ? void 0 : peer.id));
  if (isLocal && (track == null ? void 0 : track.displaySurface) && !["browser", "window", "application"].includes(track.displaySurface)) {
    return /* @__PURE__ */ React150.createElement(ScreenshareDisplay, null);
  }
  if (!peer) {
    return null;
  }
  const label = getVideoTileLabel({
    peerName: peer == null ? void 0 : peer.name,
    isLocal: false,
    videoTrack: track,
    audioTrack
  });
  return /* @__PURE__ */ React150.createElement(
    StyledVideoTile.Root,
    {
      css: {
        width,
        height,
        p: 0,
        minHeight: 0
      },
      "data-testid": "screenshare_tile"
    },
    /* @__PURE__ */ React150.createElement(
      StyledVideoTile.Container,
      {
        transparentBg: true,
        ref: fullscreenRef,
        css: { flexDirection: "column", gap: "$2" },
        onMouseEnter: () => setIsMouseHovered(true),
        onMouseLeave: () => {
          setIsMouseHovered(false);
        }
      },
      showStatsOnTiles ? /* @__PURE__ */ React150.createElement(VideoTileStats, { audioTrackID: audioTrack == null ? void 0 : audioTrack.id, videoTrackID: track == null ? void 0 : track.id, peerID: peerId, isLocal }) : null,
      isFullScreenSupported && isMouseHovered ? /* @__PURE__ */ React150.createElement(
        StyledVideoTile.FullScreenButton,
        {
          css: { bg: `${theme2.colors.background_dim.value}A3` },
          onClick: () => setFullscreen(!fullscreen)
        },
        isFullscreen ? /* @__PURE__ */ React150.createElement(ShrinkIcon2, null) : /* @__PURE__ */ React150.createElement(ExpandIcon3, null)
      ) : null,
      !isMobile && isMouseHovered && !isFullscreen && /* @__PURE__ */ React150.createElement(
        Box,
        {
          css: {
            position: "absolute",
            top: "$2",
            r: "$1",
            h: "$14",
            right: isFullScreenSupported ? "$17" : "$2",
            zIndex: 5,
            bg: `${theme2.colors.background_dim.value}A3`
          }
        },
        /* @__PURE__ */ React150.createElement(LayoutModeSelector, null)
      ),
      track ? /* @__PURE__ */ React150.createElement(Video, { screenShare: true, mirror: false, attach: !isAudioOnly, trackId: track.id, css: { minHeight: 0 } }) : null,
      /* @__PURE__ */ React150.createElement(StyledVideoTile.Info, { css: labelStyles }, label),
      isMouseHovered && !peer.isLocal ? /* @__PURE__ */ React150.createElement(
        TileMenu_default,
        {
          isScreenshare: true,
          peerID: peer.id,
          audioTrackID: audioTrack == null ? void 0 : audioTrack.id,
          videoTrackID: track == null ? void 0 : track.id,
          enableSpotlightingPeer: false
        }
      ) : null
    )
  );
};
var ScreenshareTile = React150.memo(Tile2);
var ScreenshareTile_default = ScreenshareTile;

// src/Prebuilt/components/VideoLayouts/ScreenshareLayout.tsx
var ScreenshareLayout = ({ peers, onPageChange, onPageSize, edgeToEdge }) => {
  var _a8;
  const peersSharing = useHMSStore77(selectPeersScreenSharing);
  const [, setActiveScreenSharePeer] = useSetAppDataByKey(APP_DATA.activeScreensharePeerId);
  const [page, setPage] = useState65(0);
  const [layoutMode, setLayoutMode] = useSetUiSettings(UI_SETTINGS.layoutMode);
  const activeSharePeer = peersSharing[page];
  const isMobile = useMedia35(config.media.md);
  const hasSidebar = !isMobile && layoutMode === LayoutMode.SIDEBAR;
  const secondaryPeers = useMemo18(() => {
    if (layoutMode === LayoutMode.SPOTLIGHT) {
      return [];
    }
    if (isMobile || layoutMode === LayoutMode.SIDEBAR) {
      return activeSharePeer ? [activeSharePeer, ...peers.filter((p) => p.id !== (activeSharePeer == null ? void 0 : activeSharePeer.id))] : peers;
    }
    return peers.filter((p) => p.id !== (activeSharePeer == null ? void 0 : activeSharePeer.id));
  }, [activeSharePeer, peers, isMobile, layoutMode]);
  useEffect51(() => {
    if (isMobile) {
      setLayoutMode(LayoutMode.GALLERY);
      return;
    }
    if (layoutMode === LayoutMode.SIDEBAR) {
      return;
    }
    setLayoutMode(LayoutMode.SIDEBAR);
    return () => {
      setLayoutMode(LayoutMode.GALLERY);
    };
  }, [isMobile]);
  useEffect51(() => {
    setActiveScreenSharePeer(activeSharePeer == null ? void 0 : activeSharePeer.id);
    return () => {
      setActiveScreenSharePeer("");
    };
  }, [activeSharePeer == null ? void 0 : activeSharePeer.id, setActiveScreenSharePeer]);
  return /* @__PURE__ */ React151.createElement(ProminenceLayout.Root, { edgeToEdge, hasSidebar }, /* @__PURE__ */ React151.createElement(ProminenceLayout.ProminentSection, null, /* @__PURE__ */ React151.createElement(ScreenshareTile_default, { peerId: (_a8 = peersSharing[page]) == null ? void 0 : _a8.id }), !edgeToEdge && /* @__PURE__ */ React151.createElement(Pagination, { page, onPageChange: setPage, numPages: peersSharing.length })), /* @__PURE__ */ React151.createElement(
    SecondaryTiles,
    {
      peers: secondaryPeers,
      onPageChange,
      onPageSize,
      edgeToEdge,
      hasSidebar
    }
  ), layoutMode === LayoutMode.SPOTLIGHT && activeSharePeer && /* @__PURE__ */ React151.createElement(InsetTile, { peerId: activeSharePeer == null ? void 0 : activeSharePeer.id }));
};

// src/Prebuilt/components/VideoLayouts/WhiteboardLayout.tsx
init_define_process_env();
import React152, { useEffect as useEffect52, useMemo as useMemo19 } from "react";
import { useMedia as useMedia36 } from "react-use";
import { Whiteboard } from "@100mslive/hms-whiteboard";
import { selectPeerByCondition, selectWhiteboard, useHMSStore as useHMSStore78, useWhiteboard as useWhiteboard2 } from "@100mslive/react-sdk";
var WhiteboardEmbed = () => {
  const isMobile = useMedia36(config.media.md);
  const { token, endpoint, zoomToContent } = useWhiteboard2(isMobile);
  if (!token) {
    return null;
  }
  return /* @__PURE__ */ React152.createElement(
    Box,
    {
      css: {
        mx: "$8",
        flex: "3 1 0",
        "@lg": {
          flex: "2 1 0",
          display: "flex",
          alignItems: "center"
        }
      }
    },
    /* @__PURE__ */ React152.createElement(Box, { css: { size: "100%" } }, /* @__PURE__ */ React152.createElement(Whiteboard, { token, endpoint: `https://${endpoint}`, zoomToContent }))
  );
};
var WhiteboardLayout = ({ peers, onPageChange, onPageSize, edgeToEdge }) => {
  const whiteboard = useHMSStore78(selectWhiteboard);
  const whiteboardOwner = useHMSStore78(selectPeerByCondition((peer) => peer.customerUserId === (whiteboard == null ? void 0 : whiteboard.owner)));
  const [layoutMode, setLayoutMode] = useSetUiSettings(UI_SETTINGS.layoutMode);
  const isMobile = useMedia36(config.media.md);
  const hasSidebar = !isMobile && layoutMode === LayoutMode.SIDEBAR;
  const secondaryPeers = useMemo19(() => {
    if (layoutMode === LayoutMode.SPOTLIGHT) {
      return [];
    }
    if (isMobile || layoutMode === LayoutMode.SIDEBAR) {
      return whiteboardOwner ? [whiteboardOwner, ...peers.filter((p) => p.id !== (whiteboardOwner == null ? void 0 : whiteboardOwner.id))] : peers;
    }
    return peers.filter((p) => p.id !== (whiteboardOwner == null ? void 0 : whiteboardOwner.id));
  }, [whiteboardOwner, peers, isMobile, layoutMode]);
  useEffect52(() => {
    if (isMobile) {
      setLayoutMode(LayoutMode.GALLERY);
      return;
    }
    if (layoutMode === LayoutMode.SIDEBAR) {
      return;
    }
    setLayoutMode(LayoutMode.SIDEBAR);
    return () => {
      setLayoutMode(LayoutMode.GALLERY);
    };
  }, [isMobile]);
  return /* @__PURE__ */ React152.createElement(ProminenceLayout.Root, { edgeToEdge, hasSidebar }, /* @__PURE__ */ React152.createElement(ProminenceLayout.ProminentSection, null, /* @__PURE__ */ React152.createElement(WhiteboardEmbed, null)), /* @__PURE__ */ React152.createElement(
    SecondaryTiles,
    {
      peers: secondaryPeers,
      onPageChange,
      onPageSize,
      edgeToEdge,
      hasSidebar
    }
  ), layoutMode === LayoutMode.SPOTLIGHT && whiteboardOwner && /* @__PURE__ */ React152.createElement(InsetTile, { peerId: whiteboardOwner == null ? void 0 : whiteboardOwner.id }));
};

// src/Prebuilt/common/PeersSorter.ts
init_define_process_env();
import { selectDominantSpeaker as selectDominantSpeaker2 } from "@100mslive/react-sdk";
var PeersSorter = class {
  constructor(store) {
    this.storeUnsubscribe = void 0;
    this.setPeersAndTilesPerPage = ({ peers, tilesPerPage }) => {
      this.speaker = void 0;
      this.tilesPerPage = tilesPerPage;
      const peerIds = new Set(peers.map((peer) => peer.id));
      this.peers.forEach((_, key) => {
        if (!peerIds.has(key)) {
          this.peers.delete(key);
        }
      });
      this.lruPeers = new Set([...this.lruPeers].filter((peerId) => peerIds.has(peerId)));
      peers.forEach((peer) => {
        this.peers.set(peer.id, peer);
        if (this.lruPeers.size < tilesPerPage) {
          this.lruPeers.add(peer.id);
        }
      });
      if (!this.storeUnsubscribe) {
        this.storeUnsubscribe = this.store.subscribe(this.onDominantSpeakerChange, selectDominantSpeaker2);
      }
      this.moveSpeakerToFront(this.speaker);
    };
    this.onUpdate = (cb) => {
      this.listeners.add(cb);
    };
    this.stop = () => {
      var _a8;
      this.updateListeners();
      this.listeners.clear();
      (_a8 = this.storeUnsubscribe) == null ? void 0 : _a8.call(this);
      this.storeUnsubscribe = void 0;
      this.speaker = void 0;
    };
    this.moveSpeakerToFront = (speaker) => {
      if (!speaker) {
        this.maintainLruSize(this.tilesPerPage);
        this.updateListeners();
        return;
      }
      if (this.lruPeers.has(speaker.id) && this.lruPeers.size <= this.tilesPerPage) {
        this.updateListeners();
        return;
      }
      this.lruPeers.delete(speaker.id);
      this.maintainLruSize(this.tilesPerPage - 1);
      this.lruPeers = /* @__PURE__ */ new Set([speaker.id, ...this.lruPeers]);
      this.updateListeners();
    };
    this.onDominantSpeakerChange = (speaker) => {
      var _a8;
      if (!speaker || speaker.id === ((_a8 = this.speaker) == null ? void 0 : _a8.id)) {
        return;
      }
      if (!this.peers.has(speaker.id)) {
        return;
      }
      this.speaker = speaker;
      this.moveSpeakerToFront(speaker);
    };
    this.updateListeners = () => {
      const orderedPeers = [];
      this.lruPeers.forEach((key) => {
        const peer = this.peers.get(key);
        if (peer) {
          orderedPeers.push(peer);
        }
      });
      this.peers.forEach((peer) => {
        if (!this.lruPeers.has(peer.id) && peer) {
          orderedPeers.push(peer);
        }
      });
      this.listeners.forEach((listener) => listener == null ? void 0 : listener(orderedPeers));
    };
    this.maintainLruSize = (size) => {
      const lruPeerArray = Array.from(this.lruPeers);
      while (lruPeerArray.length > size && lruPeerArray.length) {
        lruPeerArray.pop();
      }
      this.lruPeers = new Set(lruPeerArray);
    };
    this.store = store;
    this.peers = /* @__PURE__ */ new Map();
    this.lruPeers = /* @__PURE__ */ new Set();
    this.speaker = void 0;
    this.listeners = /* @__PURE__ */ new Set();
  }
};
var PeersSorter_default = PeersSorter;

// src/Prebuilt/components/VideoLayouts/GridLayout.tsx
var GridLayout = ({
  enable_local_tile_inset: isInsetEnabled = false,
  prominent_roles: prominentRoles = [],
  enable_spotlighting_peer = false,
  hide_participant_name_on_tile = false,
  rounded_video_tile = true,
  hide_audio_mute_on_tile = false,
  video_object_fit = "contain",
  edge_to_edge = false,
  hide_metadata_on_tile = false
}) => {
  const peerSharing = useHMSStore79(selectPeerScreenSharing2);
  const whiteboard = useHMSStore79(selectWhiteboard2);
  const pinnedTrack = usePinnedTrack();
  const peers = useHMSStore79(selectPeers3);
  const localPeerRole = useHMSStore79(selectLocalPeerRoleName5);
  const localPeerID = useHMSStore79(selectLocalPeerID13);
  const [activeScreensharePeerId] = useSetAppDataByKey(APP_DATA.activeScreensharePeerId);
  const isRoleProminence = prominentRoles.length && peers.some(
    (peer) => peer.roleName && prominentRoles.includes(peer.roleName) && (peer.videoTrack || peer.audioTrack)
  ) || pinnedTrack;
  const updatedPeers = useMemo20(() => {
    if (activeScreensharePeerId || (whiteboard == null ? void 0 : whiteboard.open)) {
      return peers.filter((peer) => peer.id !== activeScreensharePeerId || peer.customerUserId !== (whiteboard == null ? void 0 : whiteboard.owner));
    }
    if (isInsetEnabled) {
      const isLocalPeerPinned = localPeerID === (pinnedTrack == null ? void 0 : pinnedTrack.peerId);
      if (localPeerRole && prominentRoles.includes(localPeerRole) || isLocalPeerPinned) {
        return peers;
      } else {
        return peers.filter((peer) => !peer.isLocal);
      }
    }
    return peers;
  }, [
    isInsetEnabled,
    whiteboard,
    activeScreensharePeerId,
    localPeerRole,
    localPeerID,
    prominentRoles,
    peers,
    pinnedTrack
  ]);
  const vanillaStore = useHMSVanillaStore13();
  const [sortedPeers, setSortedPeers] = useState66(updatedPeers);
  const peersSorter = useMemo20(() => new PeersSorter_default(vanillaStore), [vanillaStore]);
  const [pageSize, setPageSize] = useState66(0);
  const [mainPage, setMainPage] = useState66(0);
  const tileLayout = {
    enableSpotlightingPeer: enable_spotlighting_peer,
    hideParticipantNameOnTile: hide_participant_name_on_tile,
    roundedVideoTile: rounded_video_tile,
    hideAudioMuteOnTile: hide_audio_mute_on_tile,
    hideMetadataOnTile: hide_metadata_on_tile,
    objectFit: video_object_fit
  };
  useEffect53(() => {
    if (mainPage !== 0) {
      return;
    }
    peersSorter.setPeersAndTilesPerPage({
      peers: updatedPeers,
      tilesPerPage: pageSize
    });
    peersSorter.onUpdate(setSortedPeers);
  }, [mainPage, peersSorter, updatedPeers, pageSize]);
  if (peerSharing) {
    return /* @__PURE__ */ React153.createElement(VideoTileContext.Provider, { value: tileLayout }, /* @__PURE__ */ React153.createElement(
      ScreenshareLayout,
      {
        peers: sortedPeers,
        onPageSize: setPageSize,
        onPageChange: setMainPage,
        edgeToEdge: edge_to_edge
      }
    ));
  } else if (whiteboard == null ? void 0 : whiteboard.open) {
    return /* @__PURE__ */ React153.createElement(VideoTileContext.Provider, { value: tileLayout }, /* @__PURE__ */ React153.createElement(
      WhiteboardLayout,
      {
        peers: sortedPeers,
        onPageSize: setPageSize,
        onPageChange: setMainPage,
        edgeToEdge: edge_to_edge
      }
    ));
  } else if (isRoleProminence) {
    return /* @__PURE__ */ React153.createElement(VideoTileContext.Provider, { value: tileLayout }, /* @__PURE__ */ React153.createElement(
      RoleProminence,
      {
        peers: sortedPeers,
        onPageSize: setPageSize,
        onPageChange: setMainPage,
        prominentRoles,
        isInsetEnabled,
        edgeToEdge: edge_to_edge
      }
    ));
  }
  return /* @__PURE__ */ React153.createElement(VideoTileContext.Provider, { value: tileLayout }, /* @__PURE__ */ React153.createElement(
    EqualProminence,
    {
      peers: sortedPeers,
      onPageSize: setPageSize,
      onPageChange: setMainPage,
      isInsetEnabled,
      edgeToEdge: edge_to_edge
    }
  ));
};

// src/Prebuilt/layouts/EmbedView.jsx
init_define_process_env();
import React154, { useEffect as useEffect54, useMemo as useMemo21 } from "react";
import { selectAppData as selectAppData11, selectPeers as selectPeers4, selectPeerScreenSharing as selectPeerScreenSharing3, useEmbedShare, useHMSStore as useHMSStore80 } from "@100mslive/react-sdk";
var EmbedView = () => {
  return /* @__PURE__ */ React154.createElement(EmbedScreenShareView, null, /* @__PURE__ */ React154.createElement(EmbedComponent, null));
};
var EmbedScreenShareView = ({ children }) => {
  const peers = useHMSStore80(selectPeers4);
  const peerPresenting = useHMSStore80(selectPeerScreenSharing3);
  const [, setActiveScreenSharePeer] = useSetAppDataByKey(APP_DATA.activeScreensharePeerId);
  const smallTilePeers = useMemo21(() => {
    const smallTilePeers2 = peers.filter((peer) => peer.id !== (peerPresenting == null ? void 0 : peerPresenting.id));
    return smallTilePeers2;
  }, [peers, peerPresenting]);
  useEffect54(() => {
    setActiveScreenSharePeer(peerPresenting == null ? void 0 : peerPresenting.id);
    return () => {
      setActiveScreenSharePeer("");
    };
  }, [peerPresenting == null ? void 0 : peerPresenting.id, setActiveScreenSharePeer]);
  return /* @__PURE__ */ React154.createElement(ProminenceLayout.Root, null, /* @__PURE__ */ React154.createElement(ProminenceLayout.ProminentSection, null, children), /* @__PURE__ */ React154.createElement(SecondaryTiles, { peers: smallTilePeers }));
};
var EmbedComponent = () => {
  const embedConfig = useHMSStore80(selectAppData11(APP_DATA.embedConfig));
  const resetConfig = useResetEmbedConfig();
  const { iframeRef, startEmbedShare, isEmbedShareInProgress } = useEmbedShare(resetConfig);
  useEffect54(() => {
    (() => __async(void 0, null, function* () {
      if (embedConfig && !isEmbedShareInProgress) {
        try {
          yield startEmbedShare(embedConfig);
        } catch (err) {
          resetConfig();
          ToastManager.addToast({
            title: `Error while sharing embed url ${err.message || ""}`,
            variant: "error"
          });
        }
      }
    }))();
  }, [isEmbedShareInProgress, embedConfig, startEmbedShare, resetConfig]);
  return /* @__PURE__ */ React154.createElement(
    Box,
    {
      css: {
        mx: "$8",
        flex: "3 1 0",
        "@lg": {
          flex: "2 1 0",
          display: "flex",
          alignItems: "center"
        }
      }
    },
    /* @__PURE__ */ React154.createElement(
      "iframe",
      {
        title: "Embed View",
        ref: iframeRef,
        style: {
          width: "100%",
          height: "100%",
          border: 0,
          borderRadius: "0.75rem"
        },
        allow: "autoplay; clipboard-write;",
        referrerPolicy: "no-referrer"
      }
    )
  );
};

// src/Prebuilt/layouts/HLSView.jsx
init_define_process_env();
import React169, { useCallback as useCallback37, useEffect as useEffect58, useRef as useRef31, useState as useState71 } from "react";
import { useFullscreen as useFullscreen3, useMedia as useMedia40, usePrevious as usePrevious2, useToggle } from "react-use";
import { HLSPlaybackState, HMSHLSPlayer as HMSHLSPlayer2, HMSHLSPlayerEvents as HMSHLSPlayerEvents2 } from "@100mslive/hls-player";
import screenfull3 from "screenfull";
import { match as match13, P as P6 } from "ts-pattern";
import {
  HLSPlaylistType,
  HMSNotificationTypes as HMSNotificationTypes2,
  selectAppData as selectAppData12,
  selectHLSState as selectHLSState6,
  selectPeerNameByID as selectPeerNameByID6,
  selectPollByID as selectPollByID5,
  useHMSActions as useHMSActions48,
  useHMSNotifications as useHMSNotifications2,
  useHMSStore as useHMSStore81,
  useHMSVanillaStore as useHMSVanillaStore14
} from "@100mslive/react-sdk";
import { ColoredHandIcon, GoLiveIcon as GoLiveIcon2 } from "@100mslive/react-icons";

// src/Prebuilt/components/HlsStatsOverlay.jsx
init_define_process_env();
import React155, { memo } from "react";
import { CrossIcon as CrossIcon27 } from "@100mslive/react-icons";
function HlsStatsOverlay({ hlsStatsState, onClose }) {
  var _a8, _b7, _c;
  return /* @__PURE__ */ React155.createElement(
    Flex,
    {
      css: {
        position: "absolute",
        width: "$80",
        marginLeft: "$8",
        padding: "$8 $8 $10",
        zIndex: 10,
        backgroundColor: "$surface_brighter",
        borderRadius: "$1"
      },
      direction: "column"
    },
    /* @__PURE__ */ React155.createElement(IconButton_default, { css: { position: "absolute", top: "$2", right: "$2" }, onClick: onClose }, /* @__PURE__ */ React155.createElement(CrossIcon27, null)),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "URL" }, /* @__PURE__ */ React155.createElement(Flex, { align: "center" }, /* @__PURE__ */ React155.createElement(
      "a",
      {
        style: { cursor: "pointer", textDecoration: "underline" },
        href: hlsStatsState == null ? void 0 : hlsStatsState.url,
        target: "_blank",
        rel: "noreferrer"
      },
      "Stream url"
    ))),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "Video size" }, ` ${(_a8 = hlsStatsState == null ? void 0 : hlsStatsState.videoSize) == null ? void 0 : _a8.width}x${(_b7 = hlsStatsState == null ? void 0 : hlsStatsState.videoSize) == null ? void 0 : _b7.height}`),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "Buffer duration" }, (_c = hlsStatsState == null ? void 0 : hlsStatsState.bufferedDuration) == null ? void 0 : _c.toFixed(2), " "),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "Connection speed" }, `${((hlsStatsState == null ? void 0 : hlsStatsState.bandwidthEstimate) / (1e3 * 1e3)).toFixed(2)} Mbps`),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "Bitrate" }, `${((hlsStatsState == null ? void 0 : hlsStatsState.bitrate) / (1e3 * 1e3)).toFixed(2)} Mbps`),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "distance from live" }, getDurationFromSeconds(hlsStatsState.distanceFromLive / 1e3)),
    /* @__PURE__ */ React155.createElement(HlsStatsRow, { label: "Dropped frames" }, hlsStatsState == null ? void 0 : hlsStatsState.droppedFrames)
  );
}
function getDurationFromSeconds(timeInSeconds) {
  let time = Math.floor(timeInSeconds);
  const hours = Math.floor(time / 3600);
  time = time - hours * 3600;
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time - minutes * 60);
  const prefixedMinutes = `${minutes < 10 ? "0" + minutes : minutes}`;
  const prefixedSeconds = `${seconds < 10 ? "0" + seconds : seconds}`;
  let videoTimeStr = `${prefixedMinutes}:${prefixedSeconds}`;
  if (hours) {
    const prefixedHours = `${hours < 10 ? "0" + hours : hours}`;
    videoTimeStr = `${prefixedHours}:${prefixedMinutes}:${prefixedSeconds}`;
  }
  return videoTimeStr;
}
var HlsStatsRow = memo(({ label, children }) => {
  return /* @__PURE__ */ React155.createElement(Flex, { gap: 4, justify: "center", css: { width: "100%" } }, /* @__PURE__ */ React155.createElement(
    Text,
    {
      css: {
        width: "50%",
        "@md": { fontSize: "$md" },
        "@sm": { fontSize: "$sm" }
        // textAlign: "right",
      }
    },
    label
  ), /* @__PURE__ */ React155.createElement(
    Text,
    {
      css: {
        "@md": { fontSize: "$md" },
        "@sm": { fontSize: "$sm" },
        width: "50%",
        overflowWrap: "break-word"
        // textAlign: "left",
      }
    },
    children
  ));
});

// src/Prebuilt/components/HMSVideo/index.ts
init_define_process_env();

// src/Prebuilt/components/HMSVideo/Controls.jsx
init_define_process_env();
var VideoControls = styled(Flex, {
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "stretch",
  width: "100%",
  gap: "$2"
});
var LeftControls = styled(Flex, {
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  gap: "$4"
});
var RightControls = styled(Flex, {
  justifyContent: "flex-end",
  alignItems: "center",
  width: "100%",
  gap: "$4"
});

// src/Prebuilt/components/HMSVideo/HMSVideo.jsx
init_define_process_env();
import React156, { forwardRef, useEffect as useEffect55, useState as useState67 } from "react";
var HMSVideo = forwardRef((_a8, videoRef) => {
  var _b7 = _a8, { children, isFullScreen } = _b7, props = __objRest(_b7, ["children", "isFullScreen"]);
  const [width, setWidth] = useState67("auto");
  useEffect55(() => {
    const updatingVideoWidth = () => {
      const videoEl2 = videoRef.current;
      if (!videoEl2) {
        return;
      }
      if (videoEl2.videoWidth > videoEl2.videoHeight && width !== "100%") {
        setWidth("100%");
      }
    };
    const videoEl = videoRef.current;
    if (!videoEl) {
      return;
    }
    videoEl.addEventListener("loadedmetadata", updatingVideoWidth);
    return () => {
      videoEl.removeEventListener("loadedmetadata", updatingVideoWidth);
    };
  }, [videoRef, width]);
  return /* @__PURE__ */ React156.createElement(
    Flex,
    __spreadValues({
      "data-testid": "hms-video",
      css: {
        size: "100%",
        position: "relative",
        justifyContent: "center",
        transition: "all 0.3s ease-in-out",
        "@md": {
          "& video": {
            height: isFullScreen ? "" : "$60 !important"
          }
        },
        "& video::cue": {
          // default for on-surface-high
          color: "#EFF0FA",
          whiteSpace: "pre-line",
          fontSize: "$sm",
          fontStyle: "normal",
          fontWeight: "$regular",
          lineHeight: "$sm",
          letterSpacing: "0.25px"
        },
        "& video::-webkit-media-text-track-display": {
          padding: "0 $4",
          boxShadow: "0px 1px 3px 0px #000000A3"
        },
        "& video::-webkit-media-text-track-container": {
          fontSize: "$space$10 !important"
        }
      },
      direction: "column"
    }, props),
    /* @__PURE__ */ React156.createElement(
      "video",
      {
        style: {
          margin: "0 auto",
          objectFit: "contain",
          width,
          height: "100%",
          maxWidth: "100%"
        },
        ref: videoRef,
        playsInline: true,
        disablePictureInPicture: true
      }
    ),
    children
  );
});

// src/Prebuilt/components/HMSVideo/PlayPauseSeekControls.tsx
init_define_process_env();
import React160 from "react";
import { useMedia as useMedia37 } from "react-use";
import { BackwardArrowIcon, ForwardArrowIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/HMSVideo/PlayPauseButton.tsx
init_define_process_env();
import React158 from "react";
import { PauseIcon, PlayIcon } from "@100mslive/react-icons";

// src/Prebuilt/components/HMSVideo/PlayerContext.tsx
init_define_process_env();
import React157, { useContext as useContext6 } from "react";
var HMSPlayerContext = React157.createContext({
  hlsPlayer: void 0
});
var useHMSPlayerContext = () => {
  const context = useContext6(HMSPlayerContext);
  return context;
};

// src/Prebuilt/components/HMSVideo/PlayPauseButton.tsx
var PlayPauseButton = ({
  isPaused,
  width = 20,
  height = 20
}) => {
  const { hlsPlayer: hlsPlayer2 } = useHMSPlayerContext();
  const onClick = (event) => __async(void 0, null, function* () {
    event == null ? void 0 : event.stopPropagation();
    isPaused ? yield hlsPlayer2 == null ? void 0 : hlsPlayer2.play() : hlsPlayer2 == null ? void 0 : hlsPlayer2.pause();
  });
  return /* @__PURE__ */ React158.createElement(Tooltip, { title: isPaused ? "Play" : "Pause", side: "top" }, /* @__PURE__ */ React158.createElement(IconButton, { onClick, "data-testid": "play_pause_btn" }, isPaused ? /* @__PURE__ */ React158.createElement(PlayIcon, { width, height }) : /* @__PURE__ */ React158.createElement(PauseIcon, { width, height })));
};

// src/Prebuilt/components/HMSVideo/SeekControl.tsx
init_define_process_env();
import React159 from "react";
var SeekControl = ({
  title,
  onClick,
  children,
  css: css2
}) => {
  return /* @__PURE__ */ React159.createElement(Tooltip, { title, side: "top" }, /* @__PURE__ */ React159.createElement(IconButton, { onClick, "data-testid": "backward_forward_arrow_btn", css: css2 }, children));
};

// src/Prebuilt/components/HMSVideo/PlayPauseSeekControls.tsx
var PlayPauseSeekControls = ({
  isPaused,
  onSeekTo
}) => {
  return /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(
    SeekControl,
    {
      onClick: (e) => {
        e.stopPropagation();
        onSeekTo(-10);
      },
      title: "backward"
    },
    /* @__PURE__ */ React160.createElement(BackwardArrowIcon, { width: 20, height: 20 })
  ), /* @__PURE__ */ React160.createElement(PlayPauseButton, { isPaused }), /* @__PURE__ */ React160.createElement(
    SeekControl,
    {
      onClick: (e) => {
        e.stopPropagation();
        onSeekTo(10);
      },
      title: "forward"
    },
    /* @__PURE__ */ React160.createElement(ForwardArrowIcon, { width: 20, height: 20 })
  ));
};
var PlayPauseSeekOverlayControls = ({
  isPaused,
  showControls,
  hoverControlsVisible
}) => {
  const isMobile = useMedia37(config.media.md);
  const isLandscape = useIsLandscape();
  if (!isMobile && !isLandscape) {
    return /* @__PURE__ */ React160.createElement(React160.Fragment, null, /* @__PURE__ */ React160.createElement(
      Flex,
      {
        css: {
          bg: "rgba(0, 0, 0, 0.6)",
          r: "$round",
          size: "$24",
          visibility: hoverControlsVisible.seekBackward ? `` : `hidden`,
          opacity: hoverControlsVisible.seekBackward ? `1` : "0"
        },
        direction: "column",
        align: "center"
      },
      /* @__PURE__ */ React160.createElement(SeekControl, { title: "backward" }, /* @__PURE__ */ React160.createElement(BackwardArrowIcon, { width: 52, height: 52 })),
      /* @__PURE__ */ React160.createElement(Text, { variant: "body2", css: { fontWeight: "$regular" } }, "10 secs")
    ), /* @__PURE__ */ React160.createElement(
      Box,
      {
        css: {
          bg: "rgba(0, 0, 0, 0.6)",
          r: "$round",
          visibility: hoverControlsVisible.pausePlay ? `` : `hidden`,
          opacity: hoverControlsVisible.pausePlay ? `1` : "0"
        }
      },
      /* @__PURE__ */ React160.createElement(PlayPauseButton, { isPaused, width: 48, height: 48 })
    ), /* @__PURE__ */ React160.createElement(
      Flex,
      {
        css: {
          bg: "rgba(0, 0, 0, 0.6)",
          r: "$round",
          size: "$24",
          visibility: hoverControlsVisible.seekForward ? `` : `hidden`,
          opacity: hoverControlsVisible.seekForward ? `1` : "0"
        },
        direction: "column",
        align: "center"
      },
      /* @__PURE__ */ React160.createElement(SeekControl, { title: "forward" }, /* @__PURE__ */ React160.createElement(ForwardArrowIcon, { width: 52, height: 52 })),
      /* @__PURE__ */ React160.createElement(Text, { variant: "body2", css: { fontWeight: "$regular" } }, "10 secs")
    ));
  }
  return /* @__PURE__ */ React160.createElement(
    Flex,
    {
      align: "center",
      justify: "center",
      css: {
        position: "absolute",
        bg: "#00000066",
        display: "inline-flex",
        gap: "$2",
        zIndex: 1,
        size: "100%",
        visibility: showControls ? `` : `hidden`,
        opacity: showControls ? `1` : "0"
      }
    },
    /* @__PURE__ */ React160.createElement(
      SeekControl,
      {
        title: "backward",
        css: {
          visibility: hoverControlsVisible.seekBackward ? `` : `hidden`,
          opacity: hoverControlsVisible.seekBackward ? `1` : "0"
        }
      },
      /* @__PURE__ */ React160.createElement(BackwardArrowIcon, { width: 32, height: 32 })
    ),
    /* @__PURE__ */ React160.createElement(
      Box,
      {
        css: {
          bg: "rgba(0, 0, 0, 0.6)",
          r: "$round"
        }
      },
      /* @__PURE__ */ React160.createElement(PlayPauseButton, { isPaused, width: 48, height: 48 })
    ),
    /* @__PURE__ */ React160.createElement(
      SeekControl,
      {
        title: "forward",
        css: {
          visibility: hoverControlsVisible.seekForward ? `` : `hidden`,
          opacity: hoverControlsVisible.seekForward ? `1` : "0"
        }
      },
      /* @__PURE__ */ React160.createElement(ForwardArrowIcon, { width: 32, height: 32 })
    )
  );
};

// src/Prebuilt/components/HMSVideo/VideoProgress.tsx
init_define_process_env();
import React161, { useCallback as useCallback35, useEffect as useEffect56, useState as useState68 } from "react";

// src/Prebuilt/components/HMSVideo/utils.ts
init_define_process_env();
function getPercentage(a2, b2) {
  return a2 / b2 * 100;
}
function getDurationFromSeconds2(timeInSeconds) {
  let time = Math.floor(timeInSeconds);
  const hours = Math.floor(time / 3600);
  time = time - hours * 3600;
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time - minutes * 60);
  const prefixedMinutes = `${minutes < 10 ? `0${minutes}` : minutes}`;
  const prefixedSeconds = `${seconds < 10 ? `0${seconds}` : seconds}`;
  let videoTimeStr = `${prefixedMinutes}:${prefixedSeconds}`;
  if (hours) {
    const prefixedHours = `${hours < 10 ? `0${hours}` : hours}`;
    videoTimeStr = `${prefixedHours}:${prefixedMinutes}:${prefixedSeconds}`;
  }
  return videoTimeStr;
}
function getDuration(videoEl) {
  if (isFinite(videoEl.duration)) {
    return videoEl.duration;
  }
  if (videoEl.seekable.length > 0) {
    return videoEl.seekable.end(0);
  }
  return 0;
}

// src/Prebuilt/components/HMSVideo/VideoProgress.tsx
var VideoProgress = ({
  seekProgress,
  setSeekProgress
}) => {
  const { hlsPlayer: hlsPlayer2 } = useHMSPlayerContext();
  const [videoProgress, setVideoProgress] = useState68(0);
  const [bufferProgress, setBufferProgress] = useState68(0);
  const videoEl = hlsPlayer2 == null ? void 0 : hlsPlayer2.getVideoElement();
  const setProgress = useCallback35(() => {
    var _a8;
    if (!videoEl) {
      return;
    }
    const duration = getDuration(videoEl);
    const videoProgress2 = Math.floor(getPercentage(videoEl.currentTime, duration));
    let bufferProgress2 = 0;
    if (videoEl.buffered.length > 0) {
      bufferProgress2 = Math.floor(getPercentage((_a8 = videoEl.buffered) == null ? void 0 : _a8.end(0), duration));
    }
    if (!isNaN(videoProgress2)) {
      setVideoProgress(videoProgress2);
    }
    if (!isNaN(bufferProgress2)) {
      setBufferProgress(bufferProgress2);
    }
  }, [videoEl]);
  const timeupdateHandler = useCallback35(() => {
    if (!videoEl || seekProgress) {
      return;
    }
    setProgress();
  }, [seekProgress, setProgress, videoEl]);
  useEffect56(() => {
    if (!videoEl) {
      return;
    }
    setProgress();
    videoEl.addEventListener("timeupdate", timeupdateHandler);
    return function cleanup() {
      videoEl == null ? void 0 : videoEl.removeEventListener("timeupdate", timeupdateHandler);
    };
  }, [setProgress, timeupdateHandler, videoEl]);
  const onProgress = (progress) => {
    var _a8;
    const progress1 = Math.floor(getPercentage(progress[0], 100));
    const videoEl2 = hlsPlayer2 == null ? void 0 : hlsPlayer2.getVideoElement();
    if (!videoEl2) {
      return;
    }
    const duration = isFinite(videoEl2.duration) ? videoEl2.duration : ((_a8 = videoEl2.seekable) == null ? void 0 : _a8.end(0)) || 0;
    const currentTime = progress1 * duration / 100;
    hlsPlayer2 == null ? void 0 : hlsPlayer2.seekTo(currentTime);
    setProgress();
  };
  if (!videoEl) {
    return null;
  }
  return /* @__PURE__ */ React161.createElement(Flex, { align: "center", css: { cursor: "pointer", h: "$2", alignSelf: "stretch" } }, /* @__PURE__ */ React161.createElement(
    Slider,
    {
      id: "video-actual-rest",
      css: {
        cursor: "pointer",
        h: "$2",
        zIndex: 1,
        transition: `all .2s ease .5s`
      },
      min: 0,
      max: 100,
      step: 1,
      value: [videoProgress],
      showTooltip: false,
      onValueChange: onProgress,
      onPointerDown: () => setSeekProgress(true),
      onPointerUp: () => setSeekProgress(false),
      thumbStyles: { w: "$6", h: "$6" }
    }
  ), /* @__PURE__ */ React161.createElement(
    Box,
    {
      id: "video-buffer",
      css: {
        h: "$2",
        width: `${bufferProgress - videoProgress}%`,
        background: "$on_surface_high",
        position: "absolute",
        left: `${videoProgress}%`,
        opacity: "25%"
      }
    }
  ));
};

// src/Prebuilt/components/HMSVideo/VideoTime.tsx
init_define_process_env();
import React162, { useCallback as useCallback36, useEffect as useEffect57, useState as useState69 } from "react";
import { HMSHLSPlayerEvents } from "@100mslive/hls-player";
var VideoTime = () => {
  const { hlsPlayer: hlsPlayer2 } = useHMSPlayerContext();
  const [videoTime, setVideoTime] = useState69(getDurationFromSeconds2(0));
  const updateTime = useCallback36(
    (currentTime) => {
      const videoEl = hlsPlayer2 == null ? void 0 : hlsPlayer2.getVideoElement();
      if (videoEl) {
        const duration = getDuration(videoEl);
        setVideoTime(getDurationFromSeconds2(duration - currentTime));
      } else {
        setVideoTime(getDurationFromSeconds2(currentTime));
      }
    },
    [hlsPlayer2]
  );
  useEffect57(() => {
    const timeupdateHandler = (currentTime) => {
      updateTime(currentTime);
    };
    if (hlsPlayer2) {
      hlsPlayer2.on(HMSHLSPlayerEvents.CURRENT_TIME, timeupdateHandler);
      const videoEl = hlsPlayer2 == null ? void 0 : hlsPlayer2.getVideoElement();
      updateTime(videoEl.currentTime);
    }
    return function cleanup() {
      hlsPlayer2 == null ? void 0 : hlsPlayer2.off(HMSHLSPlayerEvents.CURRENT_TIME, timeupdateHandler);
    };
  }, [hlsPlayer2, updateTime]);
  return hlsPlayer2 ? /* @__PURE__ */ React162.createElement(
    Text,
    {
      variant: "body1",
      css: {
        minWidth: "$16",
        c: "$on_surface_medium",
        display: "flex",
        justifyContent: "center",
        fontWeight: "$regular"
      }
    },
    "-",
    videoTime
  ) : null;
};

// src/Prebuilt/components/HMSVideo/VolumeControl.tsx
init_define_process_env();
import React163, { useState as useState70 } from "react";
import { VolumeOneIcon as VolumeOneIcon2, VolumeTwoIcon, VolumeZeroIcon } from "@100mslive/react-icons";
var VolumeControl = () => {
  var _a8;
  const { hlsPlayer: hlsPlayer2 } = useHMSPlayerContext();
  const [volume, setVolume] = useState70((_a8 = hlsPlayer2 == null ? void 0 : hlsPlayer2.volume) != null ? _a8 : 100);
  const [showSlider, setShowSlider] = useState70(false);
  return /* @__PURE__ */ React163.createElement(
    Flex,
    {
      align: "center",
      css: { color: "$on_surface_high" },
      onMouseOver: (event) => {
        event.stopPropagation();
        setShowSlider(true);
      },
      onMouseLeave: (event) => {
        event.stopPropagation();
        setShowSlider(false);
      }
    },
    /* @__PURE__ */ React163.createElement(
      VolumeIcon,
      {
        volume,
        onClick: () => {
          if (volume > 0) {
            setVolume(0);
            hlsPlayer2 == null ? void 0 : hlsPlayer2.setVolume(0);
          } else {
            setVolume(100);
            hlsPlayer2 == null ? void 0 : hlsPlayer2.setVolume(100);
          }
        }
      }
    ),
    /* @__PURE__ */ React163.createElement(
      Slider,
      {
        css: {
          mx: "$4",
          w: "$20",
          cursor: "pointer",
          "@sm": { w: "$14" },
          "@xs": { w: "$14" },
          opacity: showSlider ? "1" : "0",
          display: showSlider ? "" : "none",
          transition: `all .2s ease .5s`
        },
        min: 0,
        max: 100,
        step: 1,
        value: [volume],
        onValueChange: (volume2) => {
          hlsPlayer2 == null ? void 0 : hlsPlayer2.setVolume(volume2[0]);
          setVolume(volume2[0]);
        },
        thumbStyles: { w: "$6", h: "$6" }
      }
    )
  );
};
var VolumeIcon = ({ volume, onClick }) => {
  if (volume === 0) {
    return /* @__PURE__ */ React163.createElement(VolumeZeroIcon, { style: { cursor: "pointer", transition: "color 0.3s" }, onClick });
  }
  return volume < 50 ? /* @__PURE__ */ React163.createElement(VolumeOneIcon2, { style: { cursor: "pointer", transition: "color 0.3s" }, onClick }) : /* @__PURE__ */ React163.createElement(VolumeTwoIcon, { style: { cursor: "pointer", transition: "color 0.3s" }, onClick });
};

// src/Prebuilt/components/HMSVideo/index.ts
var HMSVideoPlayer = {
  Root: HMSVideo,
  Progress: VideoProgress,
  Duration: VideoTime,
  Volume: VolumeControl,
  Controls: {
    Root: VideoControls,
    Left: LeftControls,
    Right: RightControls
  },
  PlayPauseSeekControls: {
    Overlay: PlayPauseSeekOverlayControls,
    Button: PlayPauseSeekControls
  }
};

// src/Prebuilt/components/HMSVideo/FullscreenButton.tsx
init_define_process_env();
import React164 from "react";
import { ExpandIcon as ExpandIcon4, ShrinkIcon as ShrinkIcon3 } from "@100mslive/react-icons";
var FullScreenButton2 = ({ isFullScreen, onToggle }) => {
  return /* @__PURE__ */ React164.createElement(Tooltip, { title: `${isFullScreen ? "Exit" : "Go"} fullscreen`, side: "top" }, /* @__PURE__ */ React164.createElement(IconButton, { css: { margin: "0px" }, onClick: onToggle, key: "fullscreen_btn", "data-testid": "fullscreen_btn" }, /* @__PURE__ */ React164.createElement(Flex, null, isFullScreen ? /* @__PURE__ */ React164.createElement(ShrinkIcon3, null) : /* @__PURE__ */ React164.createElement(ExpandIcon4, null))));
};

// src/Prebuilt/components/HMSVideo/HLSAutoplayBlockedPrompt.tsx
init_define_process_env();
import React165 from "react";
import { useMedia as useMedia38 } from "react-use";
import { VolumeTwoIcon as VolumeTwoIcon2 } from "@100mslive/react-icons";
function HLSAutoplayBlockedPrompt({
  open,
  unblockAutoPlay
}) {
  const isLandscape = useIsLandscape();
  const isMobile = useMedia38(config.media.md);
  if ((isMobile || isLandscape) && open) {
    return /* @__PURE__ */ React165.createElement(
      IconButton,
      {
        css: {
          border: "1px solid white",
          bg: "white",
          color: "#000",
          r: "$2"
        },
        onClick: () => __async(this, null, function* () {
          return yield unblockAutoPlay();
        })
      },
      /* @__PURE__ */ React165.createElement(VolumeTwoIcon2, { width: "32", height: "32" }),
      /* @__PURE__ */ React165.createElement(
        Text,
        {
          variant: "body1",
          css: {
            fontWeight: "$semiBold",
            px: "$2",
            color: "#000"
          }
        },
        "Tap To Unmute"
      )
    );
  }
  return /* @__PURE__ */ React165.createElement(
    Dialog.Root,
    {
      open,
      onOpenChange: (value) => __async(this, null, function* () {
        if (!value) {
          yield unblockAutoPlay();
        }
      })
    },
    /* @__PURE__ */ React165.createElement(DialogContent, { title: "Attention", closeable: false }, /* @__PURE__ */ React165.createElement(DialogRow, null, /* @__PURE__ */ React165.createElement(Text, { variant: "md" }, 'The browser wants us to get a confirmation for playing the HLS Stream. Please click "play stream" to proceed.')), /* @__PURE__ */ React165.createElement(DialogRow, { justify: "end" }, /* @__PURE__ */ React165.createElement(
      Button,
      {
        variant: "primary",
        onClick: () => __async(this, null, function* () {
          yield unblockAutoPlay();
        })
      },
      "Play stream"
    )))
  );
}

// src/Prebuilt/components/HMSVideo/HLSCaptionSelector.tsx
init_define_process_env();
import React166 from "react";
import { ClosedCaptionIcon as ClosedCaptionIcon3, OpenCaptionIcon as OpenCaptionIcon4 } from "@100mslive/react-icons";
function HLSCaptionSelector({ isEnabled }) {
  const { hlsPlayer: hlsPlayer2 } = useHMSPlayerContext();
  return /* @__PURE__ */ React166.createElement(Tooltip, { title: "Subtitles/closed captions", side: "top" }, /* @__PURE__ */ React166.createElement(IconButton, { css: { p: "$2" }, onClick: () => hlsPlayer2 == null ? void 0 : hlsPlayer2.toggleCaption() }, isEnabled ? /* @__PURE__ */ React166.createElement(ClosedCaptionIcon3, { width: "20", height: "20px" }) : /* @__PURE__ */ React166.createElement(OpenCaptionIcon4, { width: "20", height: "20px" })));
}

// src/Prebuilt/components/HMSVideo/HLSQualitySelector.tsx
init_define_process_env();
import React167 from "react";
import { useMedia as useMedia39 } from "react-use";
import { CheckIcon as CheckIcon8, CrossIcon as CrossIcon28, SettingsIcon as SettingsIcon7 } from "@100mslive/react-icons";
function HLSQualitySelector({
  open,
  onOpenChange,
  layers,
  onQualityChange,
  selection,
  isAuto,
  containerRef
}) {
  const isMobile = useMedia39(config.media.md);
  const isLandscape = useIsLandscape();
  if (layers.length === 0) {
    return null;
  }
  if (isMobile || isLandscape) {
    return /* @__PURE__ */ React167.createElement(Sheet.Root, { open, onOpenChange }, /* @__PURE__ */ React167.createElement(Sheet.Trigger, { asChild: true, "data-testid": "quality_selector" }, /* @__PURE__ */ React167.createElement(
      Flex,
      {
        css: {
          color: "$on_primary_high",
          r: "$1",
          cursor: "pointer",
          p: "$2"
        }
      },
      /* @__PURE__ */ React167.createElement(SettingsIcon7, null)
    )), /* @__PURE__ */ React167.createElement(
      Sheet.Content,
      {
        container: containerRef,
        css: { bg: "$surface_default", pb: "$1" },
        onClick: () => onOpenChange(false)
      },
      /* @__PURE__ */ React167.createElement(
        Sheet.Title,
        {
          css: {
            display: "flex",
            color: "$on_surface_high",
            w: "100%",
            justifyContent: "space-between",
            mt: "$8",
            fontSize: "$md",
            px: "$10",
            pb: "$8",
            borderBottom: "1px solid $border_bright",
            alignItems: "center"
          }
        },
        "Quality",
        /* @__PURE__ */ React167.createElement(Sheet.Close, { css: { color: "$on_surface_high" }, onClick: () => onOpenChange(false) }, /* @__PURE__ */ React167.createElement(CrossIcon28, null))
      ),
      layers.map((layer) => {
        return /* @__PURE__ */ React167.createElement(
          Flex,
          {
            align: "center",
            css: {
              w: "100%",
              bg: "$surface_default",
              "&:hover": {
                bg: "$surface_brighter"
              },
              cursor: "pointer",
              gap: "$4",
              py: "$8",
              px: "$10"
            },
            key: layer.width,
            onClick: () => onQualityChange(layer)
          },
          /* @__PURE__ */ React167.createElement(Text, { variant: "caption", css: { fontWeight: "$semiBold" } }, getQualityText(layer)),
          /* @__PURE__ */ React167.createElement(Text, { variant: "caption", css: { flex: "1 1 0", c: "$on_surface_low", pl: "$2" } }, getBitrateText(layer)),
          !isAuto && layer.width === (selection == null ? void 0 : selection.width) && layer.height === (selection == null ? void 0 : selection.height) && /* @__PURE__ */ React167.createElement(CheckIcon8, { width: "16px", height: "16px" })
        );
      }),
      /* @__PURE__ */ React167.createElement(
        Flex,
        {
          align: "center",
          css: {
            w: "100%",
            bg: "$surface_default",
            "&:hover": {
              bg: "$surface_brighter"
            },
            cursor: "pointer",
            gap: "$4",
            py: "$8",
            px: "$10"
          },
          key: "auto",
          onClick: () => onQualityChange({ height: "auto" })
        },
        /* @__PURE__ */ React167.createElement(Text, { variant: "caption", css: { fontWeight: "$semiBold", flex: "1 1 0" } }, "Auto"),
        isAuto && /* @__PURE__ */ React167.createElement(CheckIcon8, { width: "16px", height: "16px" })
      )
    ));
  }
  return /* @__PURE__ */ React167.createElement(Dropdown.Root, { open, onOpenChange: (value) => onOpenChange(value), modal: false }, /* @__PURE__ */ React167.createElement(Dropdown.Trigger, { asChild: true, "data-testid": "quality_selector" }, /* @__PURE__ */ React167.createElement(
    Flex,
    {
      css: {
        color: "$on_primary_high",
        r: "$1",
        cursor: "pointer",
        p: "$2"
      }
    },
    /* @__PURE__ */ React167.createElement(Tooltip, { title: "Select Quality", side: "top" }, /* @__PURE__ */ React167.createElement(Flex, { align: "center" }, /* @__PURE__ */ React167.createElement(
      Box,
      {
        css: {
          w: "$9",
          h: "$9",
          display: "inline-flex",
          alignItems: "center",
          c: "$on_surface_high"
        }
      },
      /* @__PURE__ */ React167.createElement(SettingsIcon7, null)
    ), /* @__PURE__ */ React167.createElement(
      Text,
      {
        variant: {
          "@md": "sm",
          "@sm": "xs",
          "@xs": "tiny"
        },
        css: { display: "flex", alignItems: "center", ml: "$2", c: "$on_surface_medium" }
      },
      isAuto && /* @__PURE__ */ React167.createElement(React167.Fragment, null, "Auto", /* @__PURE__ */ React167.createElement(
        Box,
        {
          css: {
            mx: "$2",
            w: "$2",
            h: "$2",
            background: "$on_surface_medium",
            r: "$1"
          }
        }
      )),
      selection && Math.min(selection.width || 0, selection.height || 0),
      "p"
    )))
  )), /* @__PURE__ */ React167.createElement(Dropdown.Portal, { container: containerRef }, /* @__PURE__ */ React167.createElement(
    Dropdown.Content,
    {
      sideOffset: 5,
      align: "end",
      css: {
        height: "auto",
        maxHeight: "$52",
        w: "$40",
        bg: "$surface_bright",
        py: "$4",
        gap: "$4",
        display: "grid"
      }
    },
    layers.map((layer) => {
      return /* @__PURE__ */ React167.createElement(
        Dropdown.Item,
        {
          onClick: () => onQualityChange(layer),
          key: layer.width,
          css: {
            bg: !isAuto && layer.width === (selection == null ? void 0 : selection.width) && layer.height === (selection == null ? void 0 : selection.height) ? "$surface_default" : "$surface_bright",
            "&:hover": {
              bg: "$surface_brighter"
            },
            p: "$2 $4 $2 $8",
            h: "$12",
            gap: "$2"
          }
        },
        /* @__PURE__ */ React167.createElement(Text, { variant: "caption", css: { fontWeight: "$semiBold" } }, getQualityText(layer)),
        /* @__PURE__ */ React167.createElement(Text, { variant: "caption", css: { flex: "1 1 0", c: "$on_surface_low", pl: "$2" } }, getBitrateText(layer)),
        !isAuto && layer.width === (selection == null ? void 0 : selection.width) && layer.height === (selection == null ? void 0 : selection.height) && /* @__PURE__ */ React167.createElement(CheckIcon8, { width: "16px", height: "16px" })
      );
    }),
    /* @__PURE__ */ React167.createElement(
      Dropdown.Item,
      {
        onClick: () => onQualityChange({ height: "auto" }),
        key: "auto",
        css: {
          bg: !isAuto ? "$surface_bright" : "$surface_default",
          "&:hover": {
            bg: "$surface_brighter"
          },
          p: "$2 $4 $2 $8",
          h: "$12",
          gap: "$2"
        }
      },
      /* @__PURE__ */ React167.createElement(Text, { variant: "caption", css: { fontWeight: "$semiBold", flex: "1 1 0" } }, "Auto"),
      isAuto && /* @__PURE__ */ React167.createElement(CheckIcon8, { width: "16px", height: "16px" })
    )
  )));
}
var getQualityText = (layer) => `${Math.min(layer.height || 0, layer.width || 0)}p `;
var getBitrateText = (layer) => `(${(Number(layer.bitrate / 1e3) / 1e3).toFixed(2)} Mbps)`;

// src/Prebuilt/components/HMSVideo/MwebHLSViewTitle.tsx
init_define_process_env();
import React168 from "react";
import { ChevronDownIcon as ChevronDownIcon9 } from "@100mslive/react-icons";
var HLSViewTitle = () => {
  const { title, details, description } = useRoomLayoutHeader();
  const toggleDetailsPane = useSidepaneToggle(SIDE_PANE_OPTIONS.ROOM_DETAILS);
  const isDetailSidepaneOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.ROOM_DETAILS);
  if (isDetailSidepaneOpen) {
    return /* @__PURE__ */ React168.createElement(
      Flex,
      {
        gap: "4",
        align: "center",
        justify: "between",
        css: {
          position: "relative",
          h: "fit-content",
          w: "100%",
          borderBottom: "1px solid $border_bright",
          p: "$8",
          backgroundColor: "$surface_dim"
        }
      },
      /* @__PURE__ */ React168.createElement(Text, { variant: "sub2", css: { fontWeight: "$semiBold" } }, "About Session"),
      /* @__PURE__ */ React168.createElement(
        Flex,
        {
          onClick: toggleDetailsPane,
          css: {
            color: "$on_surface_high",
            cursor: "pointer",
            "&:hover": { opacity: "0.8" }
          }
        },
        /* @__PURE__ */ React168.createElement(ChevronDownIcon9, null)
      )
    );
  }
  return /* @__PURE__ */ React168.createElement(
    Flex,
    {
      gap: "4",
      align: "center",
      css: {
        position: "relative",
        h: "fit-content",
        w: "100%",
        borderBottom: "1px solid $border_bright",
        p: "$8",
        backgroundColor: "$surface_dim"
      }
    },
    /* @__PURE__ */ React168.createElement(Logo, null),
    /* @__PURE__ */ React168.createElement(Flex, { direction: "column" }, title ? /* @__PURE__ */ React168.createElement(Text, { variant: "sub2", css: { fontWeight: "$semiBold" } }, title) : null, /* @__PURE__ */ React168.createElement(Flex, null, /* @__PURE__ */ React168.createElement(RoomDetailsRow, { details }), description ? /* @__PURE__ */ React168.createElement(Text, { variant: "caption", css: { color: "$on_surface_medium" }, onClick: toggleDetailsPane }, "\xA0...more") : null))
  );
};

// src/Prebuilt/layouts/HLSView.jsx
var hlsPlayer;
var toastMap = {};
var ToggleChat = ({ isFullScreen = false }) => {
  const { elements } = useRoomLayoutConferencingScreen();
  const sidepane = useHMSStore81(selectAppData12(APP_DATA.sidePane));
  const showChat = !!(elements == null ? void 0 : elements.chat);
  const isMobile = useMedia40(config.media.md);
  const hmsActions = useHMSActions48();
  useEffect58(() => {
    match13({ sidepane, isMobile, showChat, isFullScreen }).with({ isFullScreen: true }, () => {
      hmsActions.setAppData(APP_DATA.sidePane, "");
    }).with({ isMobile: true, showChat: true, sidepane: P6.when((value) => !value) }, () => {
      hmsActions.setAppData(APP_DATA.sidePane, SIDE_PANE_OPTIONS.CHAT);
    }).with({ showChat: false, isMobile: true, sidepane: SIDE_PANE_OPTIONS.CHAT }, () => {
      hmsActions.setAppData(APP_DATA.sidePane, "");
    }).otherwise(() => {
    });
  }, [sidepane, isMobile, showChat, hmsActions, isFullScreen]);
  return null;
};
var HLSView = () => {
  var _a8, _b7, _c, _d, _e, _f, _g;
  const videoRef = useRef31(null);
  const hlsViewRef = useRef31();
  const { elements } = useRoomLayoutConferencingScreen();
  const hlsState = useHMSStore81(selectHLSState6);
  const enablHlsStats = useHMSStore81(selectAppData12(APP_DATA.hlsStats));
  const notification = useHMSNotifications2(HMSNotificationTypes2.POLL_STOPPED);
  const hmsActions = useHMSActions48();
  const { themeType } = useTheme();
  const [streamEnded, setStreamEnded] = useState71(false);
  let [hlsStatsState, setHlsStatsState] = useState71(null);
  const hlsUrl = (_a8 = hlsState.variants[0]) == null ? void 0 : _a8.url;
  const [availableLayers, setAvailableLayers] = useState71([]);
  const [isVideoLive, setIsVideoLive] = useState71(true);
  const [isCaptionEnabled, setIsCaptionEnabled] = useState71(true);
  const [hasCaptions, setHasCaptions] = useState71(false);
  const [currentSelectedQuality, setCurrentSelectedQuality] = useState71(null);
  const [isHlsAutoplayBlocked, setIsHlsAutoplayBlocked] = useState71(false);
  const [hoverControlsVisible, setHoverControlsVisible] = useState71({
    seekForward: false,
    pausePlay: false,
    seekBackward: false
  });
  const [isPaused, setIsPaused] = useState71(false);
  const [show, toggle] = useToggle(false);
  const lastHlsUrl = usePrevious2(hlsUrl);
  const vanillaStore = useHMSVanillaStore14();
  const [controlsVisible, setControlsVisible] = useState71(true);
  const [isUserSelectedAuto, setIsUserSelectedAuto] = useState71(true);
  const [qualityDropDownOpen, setQualityDropDownOpen] = useState71(false);
  const controlsRef = useRef31(null);
  const controlsTimerRef = useRef31();
  const [seekProgress, setSeekProgress] = useState71(false);
  const isFullScreenSupported = screenfull3.isEnabled;
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  const showChat = !!(elements == null ? void 0 : elements.chat);
  const isMobile = useMedia40(config.media.md);
  const isLandscape = useIsLandscape();
  const isFullScreen = useFullscreen3(hlsViewRef, show, {
    onClose: () => toggle(false)
  });
  const [showLoader, setShowLoader] = useState71(false);
  useEffect58(() => {
    const videoEl = videoRef.current;
    const showLoader2 = () => setShowLoader(true);
    const hideLoader = () => setShowLoader(false);
    videoEl == null ? void 0 : videoEl.addEventListener("playing", hideLoader);
    videoEl == null ? void 0 : videoEl.addEventListener("waiting", showLoader2);
    return () => {
      videoEl == null ? void 0 : videoEl.removeEventListener("playing", hideLoader);
      videoEl == null ? void 0 : videoEl.removeEventListener("waiting", showLoader2);
    };
  }, []);
  useEffect58(() => {
    if (streamEnded && lastHlsUrl !== hlsUrl) {
      setStreamEnded(false);
    }
  }, [hlsUrl, streamEnded, lastHlsUrl]);
  useEffect58(() => {
    if (!notification)
      return;
    const toastID = toastMap == null ? void 0 : toastMap[notification.data.id];
    if (toastID) {
      ToastManager.removeToast(toastMap[notification.data.id]);
      delete toastMap[notification.data.id];
    }
  }, [notification]);
  useEffect58(() => {
    const videoElem = videoRef.current;
    const setStreamEndedCallback = () => {
      setStreamEnded(true);
      videoElem == null ? void 0 : videoElem.removeEventListener("ended", setStreamEndedCallback);
    };
    videoElem == null ? void 0 : videoElem.addEventListener("ended", setStreamEndedCallback);
    return () => {
      videoElem == null ? void 0 : videoElem.removeEventListener("ended", setStreamEndedCallback);
    };
  }, [hlsUrl]);
  const handleQuality = useCallback37(
    (quality) => {
      var _a9;
      if (hlsPlayer) {
        setIsUserSelectedAuto(((_a9 = quality.height) == null ? void 0 : _a9.toString().toLowerCase()) === "auto");
        hlsPlayer == null ? void 0 : hlsPlayer.setLayer(quality);
      }
    },
    [availableLayers]
    //eslint-disable-line
  );
  useEffect58(() => {
    let videoEl = videoRef.current;
    const manifestLoadedHandler = ({ layers }) => {
      setAvailableLayers(layers);
      setHasCaptions(hlsPlayer == null ? void 0 : hlsPlayer.hasCaptions());
    };
    const layerUpdatedHandler = ({ layer }) => {
      setCurrentSelectedQuality(layer);
    };
    const metadataLoadedHandler = (_a9) => {
      var _b8 = _a9, { payload } = _b8, rest = __objRest(_b8, ["payload"]);
      var _a10;
      const parsePayload = (str) => {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      };
      const duration = rest.duration;
      const parsedPayload = parsePayload(payload);
      if (parsedPayload.startsWith("poll:")) {
        const pollId = parsedPayload.substr(parsedPayload.indexOf(":") + 1);
        const poll = vanillaStore.getState(selectPollByID5(pollId));
        const pollStartedBy = vanillaStore.getState(selectPeerNameByID6(poll.startedBy)) || "Participant";
        if (!toastMap[pollId]) {
          const toastID = ToastManager.addToast({
            title: `${pollStartedBy} started a ${poll.type}: ${poll.title}`,
            action: /* @__PURE__ */ React169.createElement(
              Button,
              {
                onClick: () => {
                  hmsActions.setAppData(APP_DATA.pollState, {
                    [POLL_STATE.pollInView]: pollId,
                    [POLL_STATE.view]: POLL_VIEWS.VOTE
                  });
                  hmsActions.setAppData(APP_DATA.sidePane, SIDE_PANE_OPTIONS.POLLS);
                },
                variant: "standard",
                css: {
                  backgroundColor: "$surface_bright",
                  fontWeight: "$semiBold",
                  color: "$on_surface_high",
                  p: "$xs $md"
                }
              },
              poll.type === "quiz" ? "Answer" : "Vote"
            ),
            duration: Infinity
          });
          toastMap[pollId] = toastID;
        }
        return;
      }
      switch (parsedPayload.type) {
        case EMOJI_REACTION_TYPE:
          (_a10 = window.showFlyingEmoji) == null ? void 0 : _a10.call(window, { emojiId: parsedPayload == null ? void 0 : parsedPayload.emojiId, senderId: parsedPayload == null ? void 0 : parsedPayload.senderId });
          break;
        default: {
          const toast = {
            title: `Payload from timed Metadata ${parsedPayload}`,
            duration: duration || 3e3
          };
          console.debug("Added toast ", JSON.stringify(toast));
          ToastManager.addToast(toast);
          break;
        }
      }
    };
    const handleError = (data3) => {
      console.error("[HLSView] error in hls", `${data3}`);
    };
    const handleNoLongerLive = ({ isLive }) => {
      setIsVideoLive(isLive);
    };
    const playbackEventHandler = (data3) => {
      setIsPaused(data3.state === HLSPlaybackState.paused);
      setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
        pausePlay: true
      }));
      setTimeout(() => {
        setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
          pausePlay: false
        }));
      }, 2e3);
    };
    const captionEnabledEventHandler = (isCaptionEnabled2) => {
      setIsCaptionEnabled(isCaptionEnabled2);
    };
    const handleAutoplayBlock = (data3) => setIsHlsAutoplayBlocked(!!data3);
    if (videoEl && hlsUrl) {
      hlsPlayer = new HMSHLSPlayer2(hlsUrl, videoEl);
      hlsPlayer.on(HMSHLSPlayerEvents2.SEEK_POS_BEHIND_LIVE_EDGE, handleNoLongerLive);
      hlsPlayer.on(HMSHLSPlayerEvents2.TIMED_METADATA_LOADED, metadataLoadedHandler);
      hlsPlayer.on(HMSHLSPlayerEvents2.ERROR, handleError);
      hlsPlayer.on(HMSHLSPlayerEvents2.PLAYBACK_STATE, playbackEventHandler);
      hlsPlayer.on(HMSHLSPlayerEvents2.CAPTION_ENABLED, captionEnabledEventHandler);
      hlsPlayer.on(HMSHLSPlayerEvents2.AUTOPLAY_BLOCKED, handleAutoplayBlock);
      hlsPlayer.on(HMSHLSPlayerEvents2.MANIFEST_LOADED, manifestLoadedHandler);
      hlsPlayer.on(HMSHLSPlayerEvents2.LAYER_UPDATED, layerUpdatedHandler);
      return () => {
        hlsPlayer.off(HMSHLSPlayerEvents2.SEEK_POS_BEHIND_LIVE_EDGE, handleNoLongerLive);
        hlsPlayer.off(HMSHLSPlayerEvents2.ERROR, handleError);
        hlsPlayer.off(HMSHLSPlayerEvents2.TIMED_METADATA_LOADED, metadataLoadedHandler);
        hlsPlayer.off(HMSHLSPlayerEvents2.PLAYBACK_STATE, playbackEventHandler);
        hlsPlayer.off(HMSHLSPlayerEvents2.CAPTION_ENABLED, captionEnabledEventHandler);
        hlsPlayer.off(HMSHLSPlayerEvents2.AUTOPLAY_BLOCKED, handleAutoplayBlock);
        hlsPlayer.off(HMSHLSPlayerEvents2.MANIFEST_LOADED, manifestLoadedHandler);
        hlsPlayer.off(HMSHLSPlayerEvents2.LAYER_UPDATED, layerUpdatedHandler);
        hlsPlayer.reset();
      };
    }
  }, [hlsUrl, vanillaStore, hmsActions]);
  useEffect58(() => {
    const onHLSStats = (state) => setHlsStatsState(state);
    if (enablHlsStats) {
      hlsPlayer == null ? void 0 : hlsPlayer.on(HMSHLSPlayerEvents2.STATS, onHLSStats);
    } else {
      hlsPlayer == null ? void 0 : hlsPlayer.off(HMSHLSPlayerEvents2.STATS, onHLSStats);
    }
    return () => {
      hlsPlayer == null ? void 0 : hlsPlayer.off(HMSHLSPlayerEvents2.STATS, onHLSStats);
    };
  }, [enablHlsStats]);
  const unblockAutoPlay = () => __async(void 0, null, function* () {
    try {
      yield hlsPlayer.play();
      setIsHlsAutoplayBlocked(false);
    } catch (error) {
      console.error("Tried to unblock Autoplay failed with", error.message);
    }
  });
  const sfnOverlayClose = () => {
    hmsActions.setAppData(APP_DATA.hlsStats, !enablHlsStats);
  };
  useEffect58(() => {
    if (controlsVisible && isFullScreen && !qualityDropDownOpen) {
      if (controlsTimerRef.current) {
        clearTimeout(controlsTimerRef.current);
      }
    }
    if (!isFullScreen && controlsTimerRef.current) {
      clearTimeout(controlsTimerRef.current);
    }
    controlsTimerRef.current = setTimeout(() => {
      if (!seekProgress) {
        setControlsVisible(false);
      }
    }, 5e3);
    return () => {
      if (controlsTimerRef.current) {
        clearTimeout(controlsTimerRef.current);
      }
    };
  }, [controlsVisible, isFullScreen, seekProgress, qualityDropDownOpen]);
  const onSeekTo = useCallback37(
    (seek) => {
      var _a9;
      match13({ isLandscape, isMobile, seek }).with({ seek: -10, isMobile: false, isLandscape: false }, () => {
        setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), { seekBackward: true }));
        setTimeout(() => {
          setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
            seekBackward: false
          }));
        }, 1e3);
      }).with({ seek: 10, isMobile: false, isLandscape: false }, () => {
        setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), { seekForward: true }));
        setTimeout(() => {
          setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
            seekForward: false
          }));
        }, 1e3);
      }).otherwise(() => null);
      hlsPlayer == null ? void 0 : hlsPlayer.seekTo(((_a9 = videoRef.current) == null ? void 0 : _a9.currentTime) + seek);
    },
    [hoverControlsVisible, isLandscape, isMobile]
  );
  const onDoubleClickHandler = useCallback37(
    (event) => {
      var _a9;
      if (!(isMobile || isLandscape) || ((_a9 = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _a9.playlist_type) !== HLSPlaylistType.DVR) {
        return;
      }
      const sidePercentage = event.screenX * 100 / event.target.clientWidth;
      if (sidePercentage < 45) {
        setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
          seekBackward: true
        }));
        onSeekTo(-10);
      } else {
        setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
          seekForward: true
        }));
        onSeekTo(10);
      }
      setTimeout(() => {
        setHoverControlsVisible(__spreadProps(__spreadValues({}, hoverControlsVisible), {
          seekForward: false,
          seekBackward: false
        }));
      }, 1e3);
    },
    [hlsState == null ? void 0 : hlsState.variants, hoverControlsVisible, isLandscape, isMobile, onSeekTo]
  );
  const onClickHandler = useCallback37(() => __async(void 0, null, function* () {
    var _a9;
    match13({ isMobile, isLandscape, playlist_type: (_a9 = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _a9.playlist_type }).with({ playlist_type: HLSPlaylistType.DVR, isMobile: false, isLandscape: false }, () => __async(void 0, null, function* () {
      if (isPaused) {
        yield hlsPlayer == null ? void 0 : hlsPlayer.play();
      } else {
        hlsPlayer == null ? void 0 : hlsPlayer.pause();
      }
    })).when(
      ({ isMobile: isMobile2, isLandscape: isLandscape2 }) => isMobile2 || isLandscape2,
      () => {
        setControlsVisible((value) => !value);
        if (controlsTimerRef.current) {
          clearTimeout(controlsTimerRef.current);
        }
      }
    ).otherwise(() => null);
  }), [hlsState == null ? void 0 : hlsState.variants, isLandscape, isMobile, isPaused]);
  const onHoverHandler = useCallback37(
    (event) => {
      event.preventDefault();
      if (isMobile || isLandscape) {
        return;
      }
      if (event.type === "mouseenter" || qualityDropDownOpen) {
        setControlsVisible(true);
        return;
      }
      if (event.type === "mouseleave" && !seekProgress) {
        setControlsVisible(false);
      } else if (!controlsVisible && event.type === "mousemove") {
        setControlsVisible(true);
        if (controlsTimerRef.current) {
          clearTimeout(controlsTimerRef.current);
        }
      }
    },
    [controlsVisible, isLandscape, isMobile, qualityDropDownOpen, seekProgress]
  );
  const keyHandler = useKeyboardHandler(isPaused, hlsPlayer);
  if (!hlsUrl || streamEnded) {
    return /* @__PURE__ */ React169.createElement(React169.Fragment, null, /* @__PURE__ */ React169.createElement(ToggleChat, null), hlsViewRef.current && (isMobile || isLandscape) && /* @__PURE__ */ React169.createElement(Box, { css: { position: "fixed", left: "$4", top: "$4", zIndex: 11 } }, /* @__PURE__ */ React169.createElement(LeaveRoom, { screenType: "hls_live_streaming", container: hlsViewRef.current })), /* @__PURE__ */ React169.createElement(
      Flex,
      {
        key: "hls-viewer",
        id: `hls-viewer-${themeType}`,
        ref: hlsViewRef,
        direction: isMobile || isLandscape ? "column" : "row",
        justify: "center",
        css: {
          flex: isLandscape ? "2 1 0" : "1 1 0"
        }
      },
      streamEnded ? /* @__PURE__ */ React169.createElement(
        WaitingView,
        {
          icon: /* @__PURE__ */ React169.createElement(ColoredHandIcon, { height: 56, width: 56 }),
          title: "Stream has ended",
          subtitle: "Have a nice day!"
        }
      ) : /* @__PURE__ */ React169.createElement(
        WaitingView,
        {
          icon: /* @__PURE__ */ React169.createElement(GoLiveIcon2, { height: 56, width: 56, style: { color: "white" } }),
          title: "Stream yet to start",
          subtitle: "Sit back and relax"
        }
      )
    ));
  }
  return /* @__PURE__ */ React169.createElement(
    Flex,
    {
      key: "hls-viewer",
      id: `hls-viewer-${themeType}`,
      ref: hlsViewRef,
      direction: isMobile || isLandscape ? "column" : "row",
      justify: "center",
      css: {
        flex: isLandscape ? "2 1 0" : "1 1 0",
        transition: "all 0.3s ease-in-out"
      }
    },
    hlsViewRef.current && (isMobile || isLandscape) && /* @__PURE__ */ React169.createElement(Box, { css: { position: "fixed", left: "$4", top: "$4", zIndex: 11 } }, /* @__PURE__ */ React169.createElement(LeaveRoom, { screenType: "hls_live_streaming", container: hlsViewRef.current })),
    /* @__PURE__ */ React169.createElement(HMSPlayerContext.Provider, { value: { hlsPlayer } }, (hlsStatsState == null ? void 0 : hlsStatsState.url) && enablHlsStats && !(isMobile || isLandscape) ? /* @__PURE__ */ React169.createElement(HlsStatsOverlay, { hlsStatsState, onClose: sfnOverlayClose }) : null, /* @__PURE__ */ React169.createElement(
      Flex,
      {
        id: "hls-player-container",
        align: "center",
        justify: "center",
        css: {
          size: "100%",
          margin: "0 auto",
          "@md": {
            height: "auto"
          },
          outline: "none"
        },
        onKeyDown: (event) => __async(void 0, null, function* () {
          var _a9;
          if (((_a9 = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _a9.playlist_type) === HLSPlaylistType.DVR) {
            yield keyHandler(event);
          }
        }),
        tabIndex: "0"
      },
      !(isMobile || isLandscape) && /* @__PURE__ */ React169.createElement(HLSAutoplayBlockedPrompt, { open: isHlsAutoplayBlocked, unblockAutoPlay }),
      showLoader && /* @__PURE__ */ React169.createElement(
        Flex,
        {
          align: "center",
          justify: "center",
          css: {
            position: "absolute"
          }
        },
        /* @__PURE__ */ React169.createElement(Loading, { width: 72, height: 72 })
      ),
      /* @__PURE__ */ React169.createElement(
        HMSVideoPlayer.Root,
        {
          ref: videoRef,
          onMouseEnter: onHoverHandler,
          onMouseMove: onHoverHandler,
          onMouseLeave: onHoverHandler,
          onClick: onClickHandler,
          isFullScreen,
          onDoubleClick: (e) => {
            onDoubleClickHandler(e);
          }
        },
        /* @__PURE__ */ React169.createElement(React169.Fragment, null, !(isMobile || isLandscape) && /* @__PURE__ */ React169.createElement(
          Flex,
          {
            align: "center",
            justify: "between",
            css: {
              position: "absolute",
              bg: `${hoverControlsVisible.pausePlay || hoverControlsVisible.seekBackward || hoverControlsVisible.seekForward ? "#00000066" : ""}`,
              display: "inline-flex",
              gap: "$2",
              zIndex: 1,
              size: "100%"
            }
          },
          !showLoader && ((_b7 = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _b7.playlist_type) === HLSPlaylistType.DVR && /* @__PURE__ */ React169.createElement(
            HMSVideoPlayer.PlayPauseSeekControls.Overlay,
            {
              isPaused,
              showControls: controlsVisible,
              hoverControlsVisible
            }
          )
        ), isMobile || isLandscape ? /* @__PURE__ */ React169.createElement(React169.Fragment, null, !showLoader && ((_c = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _c.playlist_type) === HLSPlaylistType.DVR && /* @__PURE__ */ React169.createElement(
          HMSVideoPlayer.PlayPauseSeekControls.Overlay,
          {
            isPaused,
            showControls: controlsVisible,
            hoverControlsVisible
          }
        ), /* @__PURE__ */ React169.createElement(
          Flex,
          {
            ref: controlsRef,
            direction: "column",
            justify: "start",
            align: "start",
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              flexShrink: 0,
              zIndex: 1,
              visibility: controlsVisible ? `` : `hidden`,
              opacity: controlsVisible ? `1` : "0"
            }
          },
          /* @__PURE__ */ React169.createElement(
            HMSVideoPlayer.Controls.Root,
            {
              css: {
                p: "$4 $8"
              },
              onClick: (e) => e.stopPropagation()
            },
            /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Controls.Right, null, (isLandscape || isMobile && isFullScreen) && showChat && /* @__PURE__ */ React169.createElement(
              ChatToggle,
              {
                onClick: () => {
                  if (isFullScreen) {
                    toggle();
                  }
                  setTimeout(() => {
                    toggleChat();
                  }, 0);
                }
              }
            ), hasCaptions && !isHlsAutoplayBlocked && /* @__PURE__ */ React169.createElement(HLSCaptionSelector, { isEnabled: isCaptionEnabled }), hlsViewRef.current && availableLayers.length > 0 && !isHlsAutoplayBlocked ? /* @__PURE__ */ React169.createElement(
              HLSQualitySelector,
              {
                layers: availableLayers,
                onOpenChange: setQualityDropDownOpen,
                open: qualityDropDownOpen,
                selection: currentSelectedQuality,
                onQualityChange: handleQuality,
                isAuto: isUserSelectedAuto,
                containerRef: hlsViewRef.current
              }
            ) : null, /* @__PURE__ */ React169.createElement(HLSAutoplayBlockedPrompt, { open: isHlsAutoplayBlocked, unblockAutoPlay }))
          )
        )) : null, controlsVisible && /* @__PURE__ */ React169.createElement(
          Flex,
          {
            ref: controlsRef,
            direction: isMobile ? "columnReverse" : "column",
            justify: "end",
            align: "start",
            css: {
              position: "absolute",
              bottom: isFullScreen && ((_d = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _d.playlist_type) === HLSPlaylistType.DVR ? "$8" : "0",
              left: "0",
              zIndex: 1,
              background: isMobile || isLandscape ? "" : `linear-gradient(180deg, ${theme.colors.background_dim.value}00 29.46%, ${theme.colors.background_dim.value}A3 100%);`,
              width: "100%",
              pt: "$8",
              flexShrink: 0,
              transition: "visibility 0s 0.5s, opacity 0.5s linear"
            }
          },
          ((_e = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _e.playlist_type) === HLSPlaylistType.DVR ? /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Progress, { seekProgress, setSeekProgress }) : null,
          /* @__PURE__ */ React169.createElement(
            HMSVideoPlayer.Controls.Root,
            {
              css: {
                p: "$4 $8"
              },
              onClick: (e) => e.stopPropagation()
            },
            /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Controls.Left, null, !(isMobile || isLandscape) && /* @__PURE__ */ React169.createElement(React169.Fragment, null, ((_f = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _f.playlist_type) === HLSPlaylistType.DVR ? /* @__PURE__ */ React169.createElement(React169.Fragment, null, /* @__PURE__ */ React169.createElement(HMSVideoPlayer.PlayPauseSeekControls.Button, { isPaused, onSeekTo }), !isVideoLive ? /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Duration, null) : null) : null, /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Volume, null)), /* @__PURE__ */ React169.createElement(
              IconButton,
              {
                css: { px: "$2" },
                onClick: (e) => __async(void 0, null, function* () {
                  e.stopPropagation();
                  yield hlsPlayer == null ? void 0 : hlsPlayer.seekToLivePosition();
                  setIsVideoLive(true);
                }),
                key: "jump-to-live_btn",
                "data-testid": "jump-to-live_btn"
              },
              /* @__PURE__ */ React169.createElement(Tooltip, { title: isVideoLive ? "Live" : "Go to Live", side: "top" }, /* @__PURE__ */ React169.createElement(Flex, { justify: "center", gap: 2, align: "center" }, /* @__PURE__ */ React169.createElement(
                Box,
                {
                  css: {
                    height: "$4",
                    width: "$4",
                    background: isVideoLive ? "$alert_error_default" : "$on_primary_medium",
                    r: "$1"
                  }
                }
              ), /* @__PURE__ */ React169.createElement(
                Text,
                {
                  variant: "$body1",
                  css: {
                    c: isVideoLive ? "$on_surface_high" : "$on_surface_medium",
                    fontWeight: "$semiBold"
                  }
                },
                isVideoLive ? "LIVE" : "GO LIVE"
              )))
            ), (isMobile || isLandscape) && !isVideoLive && ((_g = hlsState == null ? void 0 : hlsState.variants[0]) == null ? void 0 : _g.playlist_type) === HLSPlaylistType.DVR ? /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Duration, null) : null),
            /* @__PURE__ */ React169.createElement(HMSVideoPlayer.Controls.Right, null, hasCaptions && !(isMobile || isLandscape) && /* @__PURE__ */ React169.createElement(HLSCaptionSelector, { isEnabled: isCaptionEnabled }), availableLayers.length > 0 && !(isMobile || isLandscape) ? /* @__PURE__ */ React169.createElement(
              HLSQualitySelector,
              {
                layers: availableLayers,
                onOpenChange: setQualityDropDownOpen,
                open: qualityDropDownOpen,
                selection: currentSelectedQuality,
                onQualityChange: handleQuality,
                isAuto: isUserSelectedAuto,
                containerRef: hlsViewRef.current
              }
            ) : null, isFullScreenSupported ? /* @__PURE__ */ React169.createElement(FullScreenButton2, { isFullScreen, onToggle: toggle }) : null)
          )
        ))
      )
    )),
    /* @__PURE__ */ React169.createElement(ToggleChat, { isFullScreen }),
    isMobile && !isFullScreen && /* @__PURE__ */ React169.createElement(HLSViewTitle, null)
  );
};
var HLSView_default = HLSView;

// src/Prebuilt/layouts/PDFView.jsx
init_define_process_env();
import React170, { useEffect as useEffect59 } from "react";
import { usePDFShare } from "@100mslive/react-sdk";
var PDFView = () => {
  const pdfConfig = usePDFConfig();
  const resetConfig = useResetPDFConfig();
  const { iframeRef, startPDFShare, isPDFShareInProgress } = usePDFShare(resetConfig);
  useEffect59(() => {
    return () => {
      resetConfig();
    };
  }, []);
  useEffect59(() => {
    (() => __async(void 0, null, function* () {
      try {
        if (!isPDFShareInProgress && pdfConfig) {
          yield startPDFShare(pdfConfig);
        }
      } catch (err) {
        resetConfig();
        ToastManager.addToast({
          title: `Error while sharing annotator ${err.message || ""}`,
          variant: "error"
        });
      }
    }))();
  }, [isPDFShareInProgress, pdfConfig, resetConfig, startPDFShare]);
  return /* @__PURE__ */ React170.createElement(EmbedScreenShareView, null, /* @__PURE__ */ React170.createElement(
    Box,
    {
      css: {
        mx: "$8",
        flex: "3 1 0",
        "@lg": {
          flex: "2 1 0",
          display: "flex",
          alignItems: "center"
        }
      }
    },
    /* @__PURE__ */ React170.createElement(
      "iframe",
      {
        title: "Embed View",
        ref: iframeRef,
        style: {
          width: "100%",
          height: "100%",
          border: 0,
          borderRadius: "0.75rem"
        },
        allow: "autoplay; clipboard-write;",
        referrerPolicy: "no-referrer"
      }
    )
  ));
};

// src/Prebuilt/plugins/CaptionsViewer.tsx
init_define_process_env();
import React171, { useEffect as useEffect60, useRef as useRef32, useState as useState72 } from "react";
import Draggable2 from "react-draggable";
import { useMedia as useMedia41 } from "react-use";
import {
  selectIsTranscriptionEnabled as selectIsTranscriptionEnabled5,
  selectPeerNameByID as selectPeerNameByID7,
  useHMSStore as useHMSStore82,
  useTranscript
} from "@100mslive/react-sdk";
var SimpleQueue = class {
  constructor(capacity = 3, MAX_STORAGE_TIME = 5e3) {
    this.capacity = capacity;
    this.MAX_STORAGE_TIME = MAX_STORAGE_TIME;
    this.storage = [];
  }
  enqueue(data3) {
    var _a8;
    if (!data3.transcript.trim()) {
      return;
    }
    if (this.size() === this.capacity && this.storage[this.size() - 1].final) {
      this.dequeue(this.storage[this.size() - 1]);
    }
    if (this.size() === 0) {
      this.storage.push(data3);
      this.addTimeout(this.storage[this.size() - 1], data3.final);
      return;
    }
    if (this.size() > 0 && ((_a8 = this.storage[this.size() - 1]) == null ? void 0 : _a8.final) === true) {
      this.storage.push(data3);
      this.addTimeout(this.storage[this.size() - 1], data3.final);
      return;
    }
    this.storage[this.size() - 1].transcript = data3.transcript;
    this.storage[this.size() - 1].final = data3.final;
    this.storage[this.size() - 1].end = data3.end;
    this.addTimeout(this.storage[this.size() - 1], data3.final);
  }
  addTimeout(item, isFinal) {
    if (!isFinal) {
      return;
    }
    item.timeout = setTimeout(() => {
      this.dequeue(item);
    }, this.MAX_STORAGE_TIME);
  }
  dequeue(item) {
    const index = this.storage.indexOf(item);
    if (index === -1) {
      return void 0;
    }
    const removedItem = this.storage.splice(index, 1);
    if (removedItem.length <= 0) {
      return void 0;
    }
    this.clearTimeout(removedItem[0]);
    return item;
  }
  clearTimeout(item) {
    if (!item.timeout) {
      return;
    }
    clearTimeout(item.timeout);
  }
  peek() {
    if (this.size() <= 0) {
      return void 0;
    }
    return this.storage[0];
  }
  getTranscription() {
    let script = "";
    this.storage.forEach((value) => script += value.transcript + " ");
    return script;
  }
  reset() {
    this.storage.length = 0;
  }
  size() {
    return this.storage.length;
  }
};
var Queue = class {
  constructor(capacity = 3) {
    this.capacity = capacity;
    this.storage = {};
  }
  enqueue(data3) {
    if (this.size() === this.capacity) {
      this.dequeue();
    }
    if (!this.storage[data3.peer_id]) {
      this.storage[data3.peer_id] = {
        peer_id: data3.peer_id,
        transcript: data3.transcript,
        final: data3.final,
        transcriptQueue: new SimpleQueue(),
        start: data3.start,
        end: data3.end
      };
      this.storage[data3.peer_id].transcriptQueue.enqueue(data3);
      return;
    }
    this.storage[data3.peer_id].transcriptQueue.enqueue(data3);
  }
  dequeue() {
    const key = Object.keys(this.storage).shift() || "";
    const captionData = this.storage[key];
    captionData.transcriptQueue.reset();
    delete this.storage[key];
    return captionData;
  }
  peek() {
    if (this.size() <= 0)
      return void 0;
    const key = Object.keys(this.storage).shift() || "";
    return this.storage[key];
  }
  findPeerData() {
    const keys = Object.keys(this.storage);
    const data3 = keys.map((key) => {
      const data4 = this.storage[key];
      const word = data4.transcriptQueue.getTranscription();
      return { [key]: word };
    });
    return data3;
  }
  size() {
    return Object.keys(this.storage).length;
  }
};
var CaptionMaintainerQueue = class {
  constructor() {
    this.captionData = new Queue();
  }
  push(data3 = []) {
    data3.forEach((value) => {
      this.captionData.enqueue(value);
    });
  }
};
var TranscriptView = ({ peer_id, data: data3 }) => {
  const peerName = useHMSStore82(selectPeerNameByID7(peer_id)) || "Participant";
  data3 = data3.trim();
  if (!data3)
    return null;
  return /* @__PURE__ */ React171.createElement(
    Text,
    {
      variant: "body2",
      css: {
        fontWeight: "$normal",
        color: "inherit"
      }
    },
    /* @__PURE__ */ React171.createElement("b", null, peerName, ": "),
    data3
  );
};
var CaptionsViewer = ({
  defaultPosition,
  setDefaultPosition
}) => {
  var _a8;
  const { elements, screenType } = useRoomLayoutConferencingScreen();
  const isMobile = useMedia41(config.media.md);
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  const showCaptionAtTop = ((_a8 = elements == null ? void 0 : elements.chat) == null ? void 0 : _a8.is_overlay) && isChatOpen && isMobile;
  const [captionQueue] = useState72(new CaptionMaintainerQueue());
  const [currentData, setCurrentData] = useState72([]);
  const isCaptionEnabled = useIsCaptionEnabled();
  const isTranscriptionEnabled = useHMSStore82(selectIsTranscriptionEnabled5);
  const nodeRef = useRef32(null);
  useEffect60(() => {
    const timeInterval = setInterval(() => {
      var _a9;
      if (!captionQueue) {
        return;
      }
      const data3 = (_a9 = captionQueue.captionData) == null ? void 0 : _a9.findPeerData();
      setCurrentData(data3);
    }, 1e3);
    return () => clearInterval(timeInterval);
  }, [captionQueue]);
  useTranscript({
    onTranscript: (data3) => {
      captionQueue && captionQueue.push(data3);
    }
  });
  const dataToShow = currentData.filter((data3) => {
    const key = Object.keys(data3)[0];
    if (data3[key]) {
      return true;
    }
    return false;
  });
  if (dataToShow.length <= 0 || screenType === "hls_live_streaming" || !isCaptionEnabled || !isTranscriptionEnabled) {
    return null;
  }
  return /* @__PURE__ */ React171.createElement(
    Draggable2,
    {
      bounds: "parent",
      nodeRef,
      defaultPosition,
      onStop: (_, data3) => {
        setDefaultPosition({ x: data3.lastX, y: data3.lastY });
      }
    },
    /* @__PURE__ */ React171.createElement(
      Box,
      {
        ref: nodeRef,
        css: {
          position: "absolute",
          w: isMobile ? "100%" : "40%",
          bottom: showCaptionAtTop ? "" : "0",
          top: showCaptionAtTop ? "0" : "",
          left: isMobile ? 0 : "50%",
          transform: isMobile ? "" : "translateX(-50%)",
          background: "#000000A3",
          overflow: "clip",
          zIndex: 10,
          color: "$on_primary_high",
          height: "fit-content",
          r: "$1",
          p: "$6",
          transition: "bottom 0.3s ease-in-out",
          "&:empty": { display: "none" }
        }
      },
      /* @__PURE__ */ React171.createElement(Flex, { direction: "column" }, dataToShow.map((data3, index) => {
        const key = Object.keys(data3)[0];
        return /* @__PURE__ */ React171.createElement(TranscriptView, { key: index, peer_id: key, data: data3[key] });
      }))
    )
  );
};

// src/Prebuilt/components/hooks/useCloseScreenshareWhiteboard.tsx
init_define_process_env();
import { useEffect as useEffect61 } from "react";
import { selectPeerScreenSharing as selectPeerScreenSharing4, useHMSStore as useHMSStore83, useWhiteboard as useWhiteboard3 } from "@100mslive/react-sdk";
var useCloseScreenshareWhiteboard = () => {
  const peerSharing = useHMSStore83(selectPeerScreenSharing4);
  const { isOwner: isWhiteboardOwner, toggle: toggleWhiteboard } = useWhiteboard3();
  useEffect61(() => {
    if (isWhiteboardOwner && peerSharing) {
      toggleWhiteboard == null ? void 0 : toggleWhiteboard();
    }
  }, [isWhiteboardOwner, toggleWhiteboard, peerSharing]);
};

// src/Prebuilt/layouts/VideoStreamingSection.tsx
var VideoStreamingSection = ({
  screenType,
  elements,
  hideControls = false
}) => {
  var _a8;
  const localPeerRoleName = useHMSStore84(selectLocalPeerRoleName6);
  const isConnected = useHMSStore84(selectIsConnectedToRoom9);
  const isSharingScreen = useHMSStore84(selectIsLocalScreenShared2);
  const hmsActions = useHMSActions49();
  const urlToIframe = useUrlToEmbed();
  const pdfAnnotatorActive = usePDFConfig();
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeHLSStream = useLandscapeHLSStream();
  const isMobile = useMedia42(config.media.md);
  const [captionPosition, setCaptionPosition] = useState73({ x: isMobile ? 0 : -200, y: 0 });
  useCloseScreenshareWhiteboard();
  const { isNotAllowedToPublish, isScreenOnlyPublishParams, hasSubscribedRolePublishing } = useWaitingRoomInfo();
  useEffect62(() => {
    if (!isConnected) {
      return;
    }
    hmsActions.sessionStore.observe([
      "pinnedMessages" /* PINNED_MESSAGES */,
      "spotlight" /* SPOTLIGHT */,
      "chatState" /* CHAT_STATE */,
      "chatMessageBlacklist" /* CHAT_MESSAGE_BLACKLIST */,
      "chatPeerBlacklist" /* CHAT_PEER_BLACKLIST */
    ]);
  }, [isConnected, hmsActions]);
  if (!localPeerRoleName) {
    return null;
  }
  return /* @__PURE__ */ React172.createElement(
    Flex,
    {
      css: {
        size: "100%",
        position: "relative",
        gap: isMobileHLSStream || isLandscapeHLSStream ? "0" : "$4"
      },
      direction: match14({ isLandscapeHLSStream, isMobileHLSStream }).with({ isLandscapeHLSStream: true }, () => "row").with({ isMobileHLSStream: true }, () => "column").otherwise(() => "row")
    },
    match14({
      screenType,
      isNotAllowedToPublish,
      isScreenOnlyPublishParams,
      hasSubscribedRolePublishing,
      isSharingScreen,
      pdfAnnotatorActive,
      urlToIframe
    }).with(
      {
        screenType: "hls_live_streaming"
      },
      () => /* @__PURE__ */ React172.createElement(HLSView_default, null)
    ).when(
      ({ isNotAllowedToPublish: isNotAllowedToPublish2, hasSubscribedRolePublishing: hasSubscribedRolePublishing2 }) => isNotAllowedToPublish2 && !hasSubscribedRolePublishing2,
      () => /* @__PURE__ */ React172.createElement(
        WaitingView,
        {
          title: "Waiting for Host to join",
          subtitle: "Sit back and relax",
          icon: /* @__PURE__ */ React172.createElement(PeopleAddIcon3, { width: "56px", height: "56px", style: { color: "white" } })
        }
      )
    ).when(
      ({ isScreenOnlyPublishParams: isScreenOnlyPublishParams2, isSharingScreen: isSharingScreen2, hasSubscribedRolePublishing: hasSubscribedRolePublishing2 }) => isScreenOnlyPublishParams2 && !isSharingScreen2 && !hasSubscribedRolePublishing2,
      () => /* @__PURE__ */ React172.createElement(
        WaitingView,
        {
          title: "Ready to present",
          subtitle: "Select the Screenshare button to start presenting",
          icon: /* @__PURE__ */ React172.createElement(ShareScreenIcon5, { width: "56px", height: "56px", style: { color: "white" } })
        }
      )
    ).when(
      ({ pdfAnnotatorActive: pdfAnnotatorActive2 }) => !!pdfAnnotatorActive2,
      () => /* @__PURE__ */ React172.createElement(PDFView, null)
    ).when(
      ({ urlToIframe: urlToIframe2 }) => !!urlToIframe2,
      () => /* @__PURE__ */ React172.createElement(EmbedView, null)
    ).otherwise(() => {
      var _a9;
      return /* @__PURE__ */ React172.createElement(GridLayout, __spreadValues({}, (_a9 = elements == null ? void 0 : elements.video_tile_layout) == null ? void 0 : _a9.grid));
    }),
    /* @__PURE__ */ React172.createElement(CaptionsViewer, { setDefaultPosition: setCaptionPosition, defaultPosition: captionPosition }),
    /* @__PURE__ */ React172.createElement(
      Box,
      {
        css: {
          flex: match14({ isLandscapeHLSStream, isMobileHLSStream }).with({ isLandscapeHLSStream: true }, () => "1  1 0").with({ isMobileHLSStream: true }, () => "2 1 0").otherwise(() => void 0),
          position: "relative",
          height: !isMobileHLSStream ? "100%" : void 0,
          maxHeight: "100%",
          "&:empty": { display: "none" },
          overflowY: "clip"
        }
      },
      /* @__PURE__ */ React172.createElement(
        SidePane_default,
        {
          screenType,
          tileProps: (_a8 = elements == null ? void 0 : elements.video_tile_layout) == null ? void 0 : _a8.grid,
          hideControls
        }
      )
    )
  );
};

// src/Prebuilt/components/Header/index.tsx
init_define_process_env();

// src/Prebuilt/components/Header/Header.tsx
init_define_process_env();
import React175 from "react";
import { useMedia as useMedia44 } from "react-use";
import { HMSRoomState as HMSRoomState8, selectRoomState as selectRoomState8, useHMSStore as useHMSStore86 } from "@100mslive/react-sdk";

// src/Prebuilt/components/Header/RoomDetailsHeader.tsx
init_define_process_env();
import React173 from "react";
import { useMedia as useMedia43 } from "react-use";
import { ChevronRightIcon as ChevronRightIcon5 } from "@100mslive/react-icons";
var RoomDetailsHeader = () => {
  const { title, description } = useRoomLayoutHeader();
  const isMobile = useMedia43(config.media.md);
  const clipLength = 30;
  const toggleDetailsPane = useSidepaneToggle(SIDE_PANE_OPTIONS.ROOM_DETAILS);
  const toggleDetailsSheet = useSheetToggle(SHEET_OPTIONS.ROOM_DETAILS);
  if (!title && !description || isMobile && !title) {
    return null;
  }
  return /* @__PURE__ */ React173.createElement(Flex, { direction: isMobile ? "row" : "column", css: { ml: "$8", alignItems: isMobile ? "center" : "start" } }, /* @__PURE__ */ React173.createElement(Text, { variant: "sm", css: { c: "$on_surface_high", fontWeight: "$semiBold" } }, title), !isMobile && /* @__PURE__ */ React173.createElement(Flex, { align: "end", css: { color: "$on_surface_high" } }, /* @__PURE__ */ React173.createElement(Text, { variant: "xs", css: { c: "$on_surface_medium" } }, description.slice(0, clipLength)), description.length > clipLength ? /* @__PURE__ */ React173.createElement(
    "span",
    {
      style: { fontWeight: "600", fontSize: "12px", cursor: "pointer", lineHeight: "1rem" },
      onClick: toggleDetailsPane
    },
    "\xA0...more"
  ) : null), isMobile && description ? /* @__PURE__ */ React173.createElement(Flex, { css: { color: "$on_surface_medium" } }, /* @__PURE__ */ React173.createElement(ChevronRightIcon5, { height: 16, width: 16, onClick: toggleDetailsSheet })) : null);
};

// src/Prebuilt/components/Header/common.jsx
init_define_process_env();
import React174 from "react";
import {
  DeviceType as DeviceType3,
  getAudioDeviceCategory,
  HMSAudioDeviceCategory,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled8,
  selectLocalVideoTrackID as selectLocalVideoTrackID3,
  selectVideoTrackByID as selectVideoTrackByID7,
  useDevices as useDevices3,
  useHMSActions as useHMSActions50,
  useHMSStore as useHMSStore85
} from "@100mslive/react-sdk";
import {
  BluetoothIcon,
  CameraFlipIcon as CameraFlipIcon2,
  CheckIcon as CheckIcon9,
  CrossIcon as CrossIcon29,
  HeadphonesIcon,
  SpeakerIcon as SpeakerIcon4,
  TelePhoneIcon
} from "@100mslive/react-icons";
var CamaraFlipActions = () => {
  const actions = useHMSActions50();
  const { allDevices } = useDevices3();
  const { videoInput } = allDevices;
  const isVideoOn = useHMSStore85(selectIsLocalVideoEnabled8);
  const videoTrackId = useHMSStore85(selectLocalVideoTrackID3);
  const localVideoTrack = useHMSStore85(selectVideoTrackByID7(videoTrackId));
  if (!videoInput || !(videoInput == null ? void 0 : videoInput.length) || !(localVideoTrack == null ? void 0 : localVideoTrack.facingMode)) {
    return null;
  }
  return /* @__PURE__ */ React174.createElement(Box, null, /* @__PURE__ */ React174.createElement(
    IconButton_default,
    {
      disabled: !isVideoOn,
      onClick: () => __async(void 0, null, function* () {
        try {
          yield actions.switchCamera();
        } catch (e) {
          ToastManager.addToast({
            title: `Error while flipping camera ${e.message || ""}`,
            variant: "error"
          });
        }
      })
    },
    /* @__PURE__ */ React174.createElement(CameraFlipIcon2, null)
  ));
};
var AudioActions = () => {
  const { allDevices, selectedDeviceIDs, updateDevice } = useDevices3();
  const shouldShowAudioOutput = "setSinkId" in HTMLMediaElement.prototype;
  const { audioInput, audioOutput } = allDevices;
  let availableAudioDevices = audioInput;
  let selectedAudio = selectedDeviceIDs.audioInput;
  if (shouldShowAudioOutput) {
    availableAudioDevices = audioOutput;
    selectedAudio = selectedDeviceIDs.audioOutput;
  }
  const hmsActions = useHMSActions50();
  const audioFiltered = availableAudioDevices == null ? void 0 : availableAudioDevices.find((item) => !!item.label);
  const currentSelection = availableAudioDevices == null ? void 0 : availableAudioDevices.find((item) => item.deviceId === selectedAudio);
  if (!audioFiltered) {
    return null;
  }
  const deviceCategory = getAudioDeviceCategory(currentSelection == null ? void 0 : currentSelection.label);
  let AudioIcon = /* @__PURE__ */ React174.createElement(SpeakerIcon4, null);
  if (deviceCategory === HMSAudioDeviceCategory.BLUETOOTH) {
    AudioIcon = /* @__PURE__ */ React174.createElement(BluetoothIcon, null);
  } else if (deviceCategory === HMSAudioDeviceCategory.WIRED) {
    AudioIcon = /* @__PURE__ */ React174.createElement(HeadphonesIcon, null);
  } else if (deviceCategory === HMSAudioDeviceCategory.EARPIECE) {
    AudioIcon = /* @__PURE__ */ React174.createElement(TelePhoneIcon, null);
  }
  return /* @__PURE__ */ React174.createElement(
    AudioSelectionSheet,
    {
      audioDevices: availableAudioDevices,
      audioSelected: selectedAudio,
      onChange: (deviceId) => __async(void 0, null, function* () {
        try {
          yield updateDevice({
            deviceId,
            deviceType: shouldShowAudioOutput ? DeviceType3.audioOutput : DeviceType3.audioInput
          });
        } catch (e) {
          ToastManager.addToast({
            title: `Error while changing audio device ${e.message || ""}`,
            variant: "error"
          });
        }
      })
    },
    /* @__PURE__ */ React174.createElement(
      Box,
      {
        onClick: () => __async(void 0, null, function* () {
          yield hmsActions.refreshDevices();
        })
      },
      /* @__PURE__ */ React174.createElement(IconButton_default, null, AudioIcon)
    )
  );
};
var AudioSelectionSheet = ({ audioDevices, audioSelected, onChange, children }) => {
  return /* @__PURE__ */ React174.createElement(Sheet.Root, null, /* @__PURE__ */ React174.createElement(Sheet.Trigger, { asChild: true }, children), /* @__PURE__ */ React174.createElement(Sheet.Content, null, /* @__PURE__ */ React174.createElement(Sheet.Title, { css: { py: "$10", px: "$8", alignItems: "center" } }, /* @__PURE__ */ React174.createElement(Flex, { direction: "row", justify: "between", css: { w: "100%" } }, /* @__PURE__ */ React174.createElement(Text, { variant: "h6", css: { display: "flex" } }, "Audio"), /* @__PURE__ */ React174.createElement(Sheet.Close, null, /* @__PURE__ */ React174.createElement(IconButton_default, { as: "div", "data-testid": "dialog_cross_icon" }, /* @__PURE__ */ React174.createElement(CrossIcon29, null))))), /* @__PURE__ */ React174.createElement(HorizontalDivider, null), /* @__PURE__ */ React174.createElement(
    Flex,
    {
      direction: "column",
      css: {
        px: "$8",
        maxHeight: "80vh",
        overflowY: "auto"
      }
    },
    audioDevices.map((audioDevice) => {
      return /* @__PURE__ */ React174.createElement(
        SelectWithLabel,
        {
          key: audioDevice.deviceId,
          label: audioDevice.label,
          id: audioDevice.deviceId,
          checked: audioDevice.deviceId === audioSelected,
          onChange: () => onChange(audioDevice.deviceId)
        }
      );
    })
  )));
};
var SelectWithLabel = ({ label, icon = /* @__PURE__ */ React174.createElement(React174.Fragment, null), checked, id, onChange }) => {
  return /* @__PURE__ */ React174.createElement(
    Flex,
    {
      align: "center",
      css: {
        my: "$2",
        py: "$8",
        w: "100%",
        borderBottom: "1px solid $border_default"
      },
      onClick: onChange
    },
    /* @__PURE__ */ React174.createElement(
      Label3,
      {
        htmlFor: id,
        css: {
          fontSize: "$md",
          fontWeight: "$semiBold",
          color: "$on_surface_high",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "$8",
          flex: "1 1 0"
        }
      },
      icon,
      label
    ),
    checked && /* @__PURE__ */ React174.createElement(CheckIcon9, { width: 24, height: 24 })
  );
};

// src/Prebuilt/components/Header/Header.tsx
var Header2 = () => {
  const roomState = useHMSStore86(selectRoomState8);
  const isMobile = useMedia44(config.media.md);
  if (roomState !== HMSRoomState8.Connected) {
    return /* @__PURE__ */ React175.createElement(React175.Fragment, null);
  }
  return /* @__PURE__ */ React175.createElement(Flex, { justify: "between", align: "center", css: { position: "relative", height: "100%" } }, /* @__PURE__ */ React175.createElement(Flex, { align: "center", gap: "2", css: { position: "absolute", left: "$10" } }, /* @__PURE__ */ React175.createElement(Logo, null), /* @__PURE__ */ React175.createElement(RoomDetailsHeader, null), /* @__PURE__ */ React175.createElement(SpeakerTag, null), isMobile && /* @__PURE__ */ React175.createElement(Flex, { align: "center", css: { gap: "$4" } }, /* @__PURE__ */ React175.createElement(LiveStatus, null), /* @__PURE__ */ React175.createElement(RecordingStatus, null), /* @__PURE__ */ React175.createElement(RecordingPauseStatus, null))), /* @__PURE__ */ React175.createElement(
    Flex,
    {
      align: "center",
      css: {
        position: "absolute",
        right: "$10",
        gap: "$4"
      }
    },
    /* @__PURE__ */ React175.createElement(StreamActions, null),
    isMobile ? /* @__PURE__ */ React175.createElement(React175.Fragment, null, /* @__PURE__ */ React175.createElement(CamaraFlipActions, null), /* @__PURE__ */ React175.createElement(AudioActions, null)) : null
  ));
};

// src/Prebuilt/components/PreviousRoleInMetadata.tsx
init_define_process_env();
import { useEffect as useEffect63 } from "react";
import { selectLocalPeerRoleName as selectLocalPeerRoleName7, useHMSVanillaStore as useHMSVanillaStore15 } from "@100mslive/react-sdk";
var PreviousRoleInMetadata = () => {
  const vanillaStore = useHMSVanillaStore15();
  const { updateMetaData } = useMyMetadata();
  useEffect63(() => {
    let previousRole = vanillaStore.getState(selectLocalPeerRoleName7);
    const unsubscribe = vanillaStore.subscribe((currentRole) => {
      if (previousRole !== currentRole && currentRole) {
        updateMetaData({ prevRole: previousRole });
        previousRole = currentRole;
      }
    }, selectLocalPeerRoleName7);
    return unsubscribe;
  }, [vanillaStore]);
  return null;
};

// src/Prebuilt/components/ConferenceScreen.tsx
var ConferenceScreen = () => {
  var _a8, _b7, _c, _d, _e, _f;
  const { userName, endpoints, onJoin: onJoinFunc } = useHMSPrebuiltContext();
  const screenProps = useRoomLayoutConferencingScreen();
  const { isPreviewScreenEnabled } = useRoomLayoutPreviewScreen();
  const roomState = useHMSStore87(selectRoomState9);
  const isConnectedToRoom = useHMSStore87(selectIsConnectedToRoom10);
  const hmsActions = useHMSActions51();
  const authTokenInAppData = useAuthToken();
  const headerRef = useRef33(null);
  const footerRef = useRef33(null);
  const [isHLSStarted] = useSetAppDataByKey(APP_DATA.hlsStarted);
  const { requestPermission } = useAwayNotifications3();
  const showChat = !!((_a8 = screenProps.elements) == null ? void 0 : _a8.chat);
  const autoRoomJoined = useRef33(isPreviewScreenEnabled);
  const isMobileHLSStream = useMobileHLSStream();
  const isLandscapeHLSStream = useLandscapeHLSStream();
  const isMwebHLSStream = isMobileHLSStream || isLandscapeHLSStream;
  useEffect64(() => {
    if (authTokenInAppData && !isConnectedToRoom && !isPreviewScreenEnabled && roomState !== HMSRoomState9.Connecting && !autoRoomJoined.current) {
      hmsActions.join({
        userName: userName || uuid3(),
        authToken: authTokenInAppData,
        initEndpoint: endpoints == null ? void 0 : endpoints.init,
        rememberDeviceSelection: true,
        settings: {
          isAudioMuted: !isPreviewScreenEnabled,
          isVideoMuted: !isPreviewScreenEnabled,
          speakerAutoSelectionBlacklist: ["Yeti Stereo Microphone"]
        }
      }).then(() => requestPermission()).catch(console.error);
      autoRoomJoined.current = true;
    }
  }, [
    authTokenInAppData,
    endpoints == null ? void 0 : endpoints.init,
    hmsActions,
    isConnectedToRoom,
    isPreviewScreenEnabled,
    roomState,
    userName,
    requestPermission
  ]);
  useEffect64(() => {
    onJoinFunc == null ? void 0 : onJoinFunc();
    return () => {
      PictureInPicture.stop().catch((error) => console.error("stopping pip", error.message));
    };
  }, [onJoinFunc]);
  if (!isConnectedToRoom && ![HMSRoomState9.Reconnecting, HMSRoomState9.Disconnected].includes(roomState)) {
    return /* @__PURE__ */ React176.createElement(FullPageProgress_default, { text: roomState === HMSRoomState9.Connecting ? "Joining..." : "" });
  }
  return /* @__PURE__ */ React176.createElement(React176.Fragment, null, isHLSStarted ? /* @__PURE__ */ React176.createElement(Box, { css: { position: "fixed", zIndex: 100, w: "100%", h: "100%", left: 0, top: 0 } }, /* @__PURE__ */ React176.createElement(FullPageProgress_default, { text: "Starting live stream...", css: { opacity: 0.8, bg: "$background_dim" } })) : null, /* @__PURE__ */ React176.createElement(Flex, { css: { size: "100%", overflow: "hidden" }, direction: "column" }, !(screenProps.hideSections.includes("header") || isMwebHLSStream) && /* @__PURE__ */ React176.createElement(
    Box,
    {
      ref: headerRef,
      css: {
        h: "$18",
        transition: "margin 0.3s ease-in-out",
        marginTop: isMwebHLSStream ? `-${(_b7 = headerRef.current) == null ? void 0 : _b7.clientHeight}px` : "none",
        "@md": {
          h: "$17"
        }
      },
      "data-testid": "header"
    },
    /* @__PURE__ */ React176.createElement(Header2, null)
  ), /* @__PURE__ */ React176.createElement(
    Box,
    {
      css: {
        w: "100%",
        flex: "1 1 0",
        minHeight: 0,
        // @ts-ignore
        px: ((_e = (_d = (_c = screenProps == null ? void 0 : screenProps.elements) == null ? void 0 : _c.video_tile_layout) == null ? void 0 : _d.grid) == null ? void 0 : _e.edge_to_edge) ? 0 : "$10",
        // TODO: padding to be controlled by section/element
        paddingBottom: "env(safe-area-inset-bottom)",
        "@lg": {
          px: 0
        }
      },
      id: "conferencing",
      "data-testid": "conferencing"
    },
    screenProps.elements ? /* @__PURE__ */ React176.createElement(
      VideoStreamingSection,
      {
        screenType: screenProps.screenType,
        elements: screenProps.elements,
        hideControls: isMwebHLSStream
      }
    ) : null
  ), !screenProps.hideSections.includes("footer") && screenProps.elements && !isMwebHLSStream && /* @__PURE__ */ React176.createElement(
    Box,
    {
      ref: footerRef,
      css: {
        flexShrink: 0,
        maxHeight: "$24",
        transition: "margin 0.3s ease-in-out",
        bg: "$background_dim",
        marginBottom: isMwebHLSStream ? `-${(_f = footerRef.current) == null ? void 0 : _f.clientHeight}px` : void 0,
        "@md": {
          maxHeight: "unset",
          bg: screenProps.screenType === "hls_live_streaming" ? "transparent" : "$background_dim"
        }
      },
      "data-testid": "footer"
    },
    /* @__PURE__ */ React176.createElement(Footer2, { elements: screenProps.elements, screenType: screenProps.screenType })
  ), isMwebHLSStream && !showChat && /* @__PURE__ */ React176.createElement(
    Flex,
    {
      css: {
        alignItems: "center",
        pr: "$4",
        pb: "$4",
        position: "relative"
      },
      justify: "end",
      gap: "2"
    },
    /* @__PURE__ */ React176.createElement(RaiseHand, null),
    /* @__PURE__ */ React176.createElement(MoreSettings, { elements: screenProps.elements, screenType: screenProps.screenType }),
    /* @__PURE__ */ React176.createElement(
      Box,
      {
        css: {
          position: "absolute",
          bottom: "100%",
          mb: "$4"
        }
      },
      /* @__PURE__ */ React176.createElement(EmojiReaction, null)
    )
  ), /* @__PURE__ */ React176.createElement(RoleChangeRequestModal, null), /* @__PURE__ */ React176.createElement(HLSFailureModal, null), /* @__PURE__ */ React176.createElement(ActivatedPIP, null), /* @__PURE__ */ React176.createElement(PreviousRoleInMetadata, null)));
};

// src/Prebuilt/components/ErrorBoundary.jsx
init_define_process_env();
import React177, { Component } from "react";
import { CopyIcon as CopyIcon3 } from "@100mslive/react-icons";
var ErrorBoundary = class extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, isErrorCopied: false };
  }
  componentDidCatch(error, errorInfo) {
    console.error(`react error boundary - ${error.message}`, error, errorInfo);
    this.setState({
      error: error == null ? void 0 : error.message,
      errorInfo
    });
  }
  render() {
    if (this.state.errorInfo) {
      return /* @__PURE__ */ React177.createElement(
        Flex,
        {
          align: "center",
          justify: "center",
          css: {
            size: "100%",
            height: "100vh",
            width: "100%",
            color: "$on_primary_high",
            backgroundColor: "$background_default"
          }
        },
        /* @__PURE__ */ React177.createElement(Box, { css: { position: "relative", overflow: "hidden", r: "$3", height: "100%", width: "100%" } }, /* @__PURE__ */ React177.createElement(
          Flex,
          {
            direction: "column",
            css: {
              position: "absolute",
              size: "100%",
              top: "33.33%",
              left: 0
            }
          },
          /* @__PURE__ */ React177.createElement("div", { style: { margin: "1.5rem", width: "100%" } }, /* @__PURE__ */ React177.createElement(Text, null, "Something went wrong"), /* @__PURE__ */ React177.createElement(Text, null, "Message: $", this.state.error), /* @__PURE__ */ React177.createElement("br", null), "Please reload to see if it works. If you think this is a mistake on our side, please reach out to us on\xA0", /* @__PURE__ */ React177.createElement("a", { href: "https://dashboard.100ms.live/dashboard", target: "_blank", rel: "noreferrer" }, "Dashboard")),
          /* @__PURE__ */ React177.createElement(Flex, null, /* @__PURE__ */ React177.createElement(Tooltip, { title: "Reload page" }, /* @__PURE__ */ React177.createElement(
            Button,
            {
              onClick: () => {
                window.location.reload();
              },
              css: { mx: "$8" },
              "data-testid": "join_again_btn"
            },
            "Reload"
          )), /* @__PURE__ */ React177.createElement(Tooltip, { title: "Copy error details to clipboard" }, /* @__PURE__ */ React177.createElement(
            Button,
            {
              onClick: () => {
                const { error, errorInfo } = this.state;
                navigator.clipboard.writeText(
                  JSON.stringify({
                    error,
                    errorInfo
                  })
                );
                this.setState({ isErrorCopied: true });
              },
              css: { mx: "$8" },
              "data-testid": "join_again_btn"
            },
            /* @__PURE__ */ React177.createElement(CopyIcon3, null),
            " ",
            this.state.isErrorCopied ? "Copied" : "Copy Details"
          ))),
          /* @__PURE__ */ React177.createElement("details", { style: { whiteSpace: "pre-wrap", margin: "1.5rem" } }, /* @__PURE__ */ React177.createElement(Text, null, this.state.error && this.state.error.toString()), /* @__PURE__ */ React177.createElement("br", null), /* @__PURE__ */ React177.createElement(Text, null, JSON.stringify(this.state.errorInfo)))
        ))
      );
    }
    return this.props.children;
  }
};

// src/Prebuilt/components/init/Init.jsx
init_define_process_env();
import React178, { useEffect as useEffect66 } from "react";

// src/Prebuilt/services/FeatureFlags.jsx
init_define_process_env();
import { useEffect as useEffect65 } from "react";
import { selectRoomID, useHMSStore as useHMSStore88 } from "@100mslive/react-sdk";
var FeatureFlags = class {
  static init(roomId) {
    if (!window.HMS) {
      window.HMS = {};
    }
    window.HMS.OPTIMISE_HLS_LATENCY = false;
    window.HMS.ALWAYS_REQUEST_PERMISSIONS = false;
    window.HMS.SHOW_NS = define_process_env_default.REACT_APP_ENV !== "prod";
    this.enableTranscription = define_process_env_default.REACT_APP_TRANSCRIPTION_ROOM_ID === roomId;
  }
  static showNS() {
    return window.HMS.SHOW_NS;
  }
  static optimiseHLSLatency() {
    return window.HMS.OPTIMISE_HLS_LATENCY;
  }
  static alwaysRequestPermissions() {
    return window.HMS.ALWAYS_REQUEST_PERMISSIONS;
  }
};
__publicField(FeatureFlags, "enableTranscription", define_process_env_default.REACT_APP_ENABLE_TRANSCRIPTION === "true");
__publicField(FeatureFlags, "enableStatsForNerds", define_process_env_default.REACT_APP_ENABLE_STATS_FOR_NERDS === "true");
__publicField(FeatureFlags, "enableWhiteboard", define_process_env_default.REACT_APP_ENABLE_WHITEBOARD && define_process_env_default.REACT_APP_PUSHER_APP_KEY && define_process_env_default.REACT_APP_PUSHER_AUTHENDPOINT);
function FeatureFlagsInit() {
  const roomId = useHMSStore88(selectRoomID);
  useEffect65(() => {
    if (roomId) {
      FeatureFlags.init(roomId);
    }
  }, [roomId]);
  return null;
}

// src/Prebuilt/components/init/Init.jsx
var Init = () => {
  const { toggleTheme } = useTheme();
  useEffect66(() => {
    window.toggleUiTheme = toggleTheme;
  }, [toggleTheme]);
  useEffect66(() => {
    function resetHeight() {
      var _a8;
      document.body.style.height = `${((_a8 = window.visualViewport) == null ? void 0 : _a8.height) || window.innerHeight}px`;
    }
    window.addEventListener("resize", resetHeight);
    resetHeight();
    return () => {
      window.removeEventListener("resize", resetHeight);
    };
  }, []);
  return /* @__PURE__ */ React178.createElement(FeatureFlagsInit, null);
};

// src/Prebuilt/components/Input/KeyboardInputManager.js
init_define_process_env();
import { useEffect as useEffect67 } from "react";
import {
  selectAppData as selectAppData13,
  selectIsLocalAudioEnabled as selectIsLocalAudioEnabled2,
  selectIsLocalVideoEnabled as selectIsLocalVideoEnabled9,
  useHMSActions as useHMSActions52,
  useHMSVanillaStore as useHMSVanillaStore16
} from "@100mslive/react-sdk";
var isEvenListenersAttached = false;
var _actions, _store, _toggleAudio, _toggleVideo, _hideSidepane, _toggleStatsForNerds, _toggleHlsStats, _keyDownHandler, _bind, _unbind;
var KeyboardInputManager = class {
  constructor(store, actions) {
    __privateAdd(this, _actions, void 0);
    __privateAdd(this, _store, void 0);
    __privateAdd(this, _toggleAudio, () => __async(this, null, function* () {
      const enabled = __privateGet(this, _store).getState(selectIsLocalAudioEnabled2);
      yield __privateGet(this, _actions).setLocalAudioEnabled(!enabled);
    }));
    __privateAdd(this, _toggleVideo, () => __async(this, null, function* () {
      const enabled = __privateGet(this, _store).getState(selectIsLocalVideoEnabled9);
      yield __privateGet(this, _actions).setLocalVideoEnabled(!enabled);
    }));
    __privateAdd(this, _hideSidepane, () => {
      if (__privateGet(this, _store).getState(selectAppData13(APP_DATA.sidePane))) {
        __privateGet(this, _actions).setAppData(APP_DATA.sidePane, "");
      }
    });
    __privateAdd(this, _toggleStatsForNerds, () => {
      const uiSettings = __privateGet(this, _store).getState(selectAppData13(APP_DATA.uiSettings));
      const statsEnabled = uiSettings.showStatsOnTiles;
      __privateGet(this, _actions).setAppData(APP_DATA.uiSettings, __spreadProps(__spreadValues({}, uiSettings), {
        showStatsOnTiles: !statsEnabled
      }));
    });
    __privateAdd(this, _toggleHlsStats, () => {
      __privateGet(this, _actions).setAppData(APP_DATA.hlsStats, !__privateGet(this, _store).getState(selectAppData13(APP_DATA.hlsStats)));
    });
    // eslint-disable-next-line complexity
    __privateAdd(this, _keyDownHandler, (e) => __async(this, null, function* () {
      const CONTROL_KEY = isMacOS ? e.metaKey : e.ctrlKey;
      const D_KEY = e.key === "d" || e.key === "D";
      const E_KEY = e.key === "e" || e.key === "E";
      const SNF_KEY = e.key === "]" || e.key === "}";
      const SHORTCUT_TOGGLE_AUDIO = CONTROL_KEY && D_KEY;
      const SHORTCUT_TOGGLE_VIDEO = CONTROL_KEY && E_KEY;
      const SHORTCUT_SIDEPANE_CLOSE = e.key === "Escape";
      const SHORTCUT_STATS_FOR_NERDS = CONTROL_KEY && SNF_KEY;
      if (SHORTCUT_TOGGLE_AUDIO) {
        e.preventDefault();
        yield __privateGet(this, _toggleAudio).call(this);
      } else if (SHORTCUT_TOGGLE_VIDEO) {
        e.preventDefault();
        yield __privateGet(this, _toggleVideo).call(this);
      } else if (SHORTCUT_SIDEPANE_CLOSE) {
        __privateGet(this, _hideSidepane).call(this);
      } else if (SHORTCUT_STATS_FOR_NERDS) {
        __privateGet(this, _toggleHlsStats).call(this);
        __privateGet(this, _toggleStatsForNerds).call(this);
      }
    }));
    __privateAdd(this, _bind, () => {
      document.addEventListener("keydown", __privateGet(this, _keyDownHandler), false);
    });
    __privateAdd(this, _unbind, () => {
      document.removeEventListener("keydown", __privateGet(this, _keyDownHandler), false);
    });
    __publicField(this, "bindAllShortcuts", () => {
      if (!isEvenListenersAttached) {
        __privateGet(this, _bind).call(this);
        isEvenListenersAttached = true;
      }
    });
    __publicField(this, "unbindAllShortcuts", () => {
      if (isEvenListenersAttached) {
        __privateGet(this, _unbind).call(this);
        isEvenListenersAttached = false;
      }
    });
    __privateSet(this, _actions, actions);
    __privateSet(this, _store, store);
  }
};
_actions = new WeakMap();
_store = new WeakMap();
_toggleAudio = new WeakMap();
_toggleVideo = new WeakMap();
_hideSidepane = new WeakMap();
_toggleStatsForNerds = new WeakMap();
_toggleHlsStats = new WeakMap();
_keyDownHandler = new WeakMap();
_bind = new WeakMap();
_unbind = new WeakMap();
var KeyboardHandler = () => {
  const store = useHMSVanillaStore16();
  const actions = useHMSActions52();
  useEffect67(() => {
    const keyboardManager = new KeyboardInputManager(store, actions);
    keyboardManager.bindAllShortcuts();
    return keyboardManager.unbindAllShortcuts;
  }, [actions, store]);
  return null;
};

// src/Prebuilt/components/LeaveScreen.tsx
init_define_process_env();
import React182 from "react";
import { ExitIcon as ExitIcon3 } from "@100mslive/react-icons";

// src/Prebuilt/components/EndCallFeedback/Feedback.tsx
init_define_process_env();
import React181, { useState as useState76 } from "react";
import { useMedia as useMedia47 } from "react-use";

// src/Prebuilt/components/EndCallFeedback/FeedbackForm.tsx
init_define_process_env();
import React179, { useState as useState74 } from "react";
import { useMedia as useMedia45 } from "react-use";
import { useHMSActions as useHMSActions53 } from "@100mslive/react-sdk";
import { CheckIcon as CheckIcon10, CrossIcon as CrossIcon30 } from "@100mslive/react-icons";
var FEEBACK_INDEX = {
  THANK_YOU: -10,
  INIT: -1
};
var FeedbackModal = ({
  ratings,
  index,
  setIndex
}) => {
  const isMobile = useMedia45(config.media.md);
  const onOpenChange = () => {
    setIndex(FEEBACK_INDEX.INIT);
  };
  const avoidDefaultDomBehavior = (e) => {
    e.preventDefault();
  };
  if (isMobile) {
    return /* @__PURE__ */ React179.createElement(Sheet.Root, { open: index !== FEEBACK_INDEX.INIT, onOpenChange }, /* @__PURE__ */ React179.createElement(
      Sheet.Content,
      {
        css: { bg: "$surface_dim", p: "$10", overflowY: "auto" },
        onPointerDownOutside: avoidDefaultDomBehavior,
        onInteractOutside: avoidDefaultDomBehavior
      },
      /* @__PURE__ */ React179.createElement(FeedbackContent, { ratings, indexSelected: index, setIndex })
    ));
  }
  return /* @__PURE__ */ React179.createElement(Dialog.Root, { open: index !== FEEBACK_INDEX.INIT, onOpenChange }, /* @__PURE__ */ React179.createElement(Dialog.Portal, null, /* @__PURE__ */ React179.createElement(Dialog.Overlay, null), /* @__PURE__ */ React179.createElement(
    Dialog.Content,
    {
      css: { bg: "$surface_dim", width: "528px", p: "$12" },
      onPointerDownOutside: avoidDefaultDomBehavior,
      onInteractOutside: avoidDefaultDomBehavior
    },
    /* @__PURE__ */ React179.createElement(FeedbackContent, { ratings, indexSelected: index, setIndex })
  )));
};
var FeedbackContent = ({
  ratings,
  indexSelected,
  setIndex
}) => {
  const { feedback } = useRoomLayoutLeaveScreen();
  const { endpoints } = useHMSPrebuiltContext();
  const isMobile = useMedia45(config.media.md);
  const hmsActions = useHMSActions53();
  const [comment, setComment] = useState74("");
  const [selectedReasons, setSelectedReasons] = useState74(/* @__PURE__ */ new Set());
  const handleCheckedChange = (checked, index) => {
    const newSelected = new Set(selectedReasons);
    if (checked) {
      newSelected.add(index);
    } else {
      newSelected.delete(index);
    }
    setSelectedReasons(newSelected);
  };
  const submitFeedback = () => __async(void 0, null, function* () {
    if (indexSelected < 0 || ratings.length <= indexSelected) {
      return;
    }
    try {
      const reasons = [...selectedReasons].map((value) => {
        var _a8, _b7;
        return ((_b7 = (_a8 = ratings[indexSelected]) == null ? void 0 : _a8.reasons) == null ? void 0 : _b7[value]) || "";
      });
      yield hmsActions.submitSessionFeedback(
        {
          question: `${feedback == null ? void 0 : feedback.title} | ${ratings[indexSelected].question || ""}`,
          rating: ratings[indexSelected].value || 1,
          min_rating: 1,
          max_rating: ratings.length,
          reasons: selectedReasons.size === 0 ? [] : reasons,
          comment
        },
        endpoints == null ? void 0 : endpoints.event
      );
    } catch (e) {
      console.error(e);
    }
    setIndex(FEEBACK_INDEX.THANK_YOU);
  });
  return /* @__PURE__ */ React179.createElement(
    Flex,
    {
      css: {
        p: indexSelected === FEEBACK_INDEX.INIT ? "$12 !important" : "0",
        bg: "$surface_dim",
        r: "$3",
        gap: "$10"
      },
      direction: "column"
    },
    /* @__PURE__ */ React179.createElement(
      FeedbackHeader,
      {
        ratings,
        indexSelected,
        onEmojiClicked: (value) => {
          setSelectedReasons(/* @__PURE__ */ new Set());
          setIndex(value);
        }
      }
    ),
    /* @__PURE__ */ React179.createElement(
      FeedbackForm,
      {
        rating: ratings[indexSelected],
        comment,
        setComment,
        selectedReasons,
        handleCheckedChange
      }
    ),
    /* @__PURE__ */ React179.createElement(
      Button,
      {
        type: "submit",
        icon: true,
        css: {
          alignSelf: isMobile ? "" : "end"
        },
        onClick: submitFeedback
      },
      (feedback == null ? void 0 : feedback.submit_btn_label) || "Submit Feedback"
    )
  );
};
var FeedbackHeader = ({
  onEmojiClicked,
  ratings,
  indexSelected = FEEBACK_INDEX.INIT
}) => {
  const isMobile = useMedia45(config.media.md);
  const { feedback } = useRoomLayoutLeaveScreen();
  return /* @__PURE__ */ React179.createElement(React179.Fragment, null, /* @__PURE__ */ React179.createElement(Flex, { align: "center" }, /* @__PURE__ */ React179.createElement(
    Flex,
    {
      direction: "column",
      css: {
        flex: "1 1 0"
      }
    },
    /* @__PURE__ */ React179.createElement(
      Text,
      {
        variant: isMobile ? "h6" : "h5",
        css: {
          c: "$on_surface_high",
          fontStyle: "normal"
        }
      },
      (feedback == null ? void 0 : feedback.title) || "How was your experience?"
    ),
    /* @__PURE__ */ React179.createElement(
      Text,
      {
        variant: isMobile ? "body2" : "body1",
        css: {
          c: "$on_surface_medium",
          opacity: 0.9,
          fontWeight: "$regular"
        }
      },
      (feedback == null ? void 0 : feedback.sub_title) || "Your answers help us improve the quality."
    )
  ), indexSelected !== FEEBACK_INDEX.INIT ? /* @__PURE__ */ React179.createElement(CrossIcon30, { width: "24px", height: "24px", color: "white", onClick: () => onEmojiClicked(FEEBACK_INDEX.INIT) }) : null), /* @__PURE__ */ React179.createElement(
    Flex,
    {
      justify: "between",
      css: {
        gap: "$17",
        c: "$on_surface_high",
        "@md": {
          gap: "0"
        }
      }
    },
    ratings.map((element, index) => {
      return /* @__PURE__ */ React179.createElement(
        Flex,
        {
          align: "center",
          direction: "column",
          css: {
            c: indexSelected === index || indexSelected === FEEBACK_INDEX.INIT ? "$on_surface_high" : "$on_surface_default",
            gap: "$4"
          },
          onClick: () => onEmojiClicked(index),
          key: `${index}`
        },
        /* @__PURE__ */ React179.createElement(
          Text,
          {
            css: {
              fontWeight: "$semiBold",
              fontSize: "$h4",
              pb: "$1",
              cursor: "pointer",
              opacity: indexSelected === index || indexSelected === FEEBACK_INDEX.INIT ? 1 : 0.2,
              "@md": {
                fontSize: "$h5"
              }
            }
          },
          element.emoji
        ),
        /* @__PURE__ */ React179.createElement(
          Text,
          {
            variant: isMobile ? "body2" : "body1",
            css: {
              c: indexSelected === index || indexSelected === FEEBACK_INDEX.INIT ? "$on_surface_medium" : "$on_surface_low",
              fontWeight: "$regular"
            }
          },
          element.label
        )
      );
    })
  ));
};
var FeedbackForm = ({
  rating,
  comment,
  setComment,
  selectedReasons,
  handleCheckedChange
}) => {
  const { feedback } = useRoomLayoutLeaveScreen();
  return /* @__PURE__ */ React179.createElement(React179.Fragment, null, rating.reasons && rating.reasons.length > 0 && /* @__PURE__ */ React179.createElement(
    Flex,
    {
      direction: "column",
      css: {
        gap: "$4"
      }
    },
    /* @__PURE__ */ React179.createElement(
      Text,
      {
        variant: "sub2",
        css: {
          c: "$on_surface_high",
          fontWeight: "$semiBold",
          fontSize: "$sm",
          px: "$2"
        }
      },
      rating.question || "What do you like/dislike here?"
    ),
    /* @__PURE__ */ React179.createElement(
      Flex,
      {
        css: {
          alignItems: "flex-start",
          alignSelf: "stretch",
          flexWrap: "wrap",
          gap: "$6",
          flex: "1 1 calc(25% - 12px)",
          "@md": {
            flex: "1 1 calc(50% - 12px)"
          },
          "@sm": {
            flex: "1 1 100%"
          }
        }
      },
      rating.reasons.map((option, index) => {
        return /* @__PURE__ */ React179.createElement(
          Flex,
          {
            align: "center",
            gap: "2",
            key: index,
            css: {
              border: "1px solid $border_bright",
              r: "$1",
              p: "$6"
            }
          },
          /* @__PURE__ */ React179.createElement(
            Checkbox.Root,
            {
              id: `${option}-${index}`,
              checked: selectedReasons.has(index),
              onCheckedChange: (checked) => handleCheckedChange(checked, index),
              css: {
                cursor: "pointer",
                flexShrink: 0,
                bg: "$on_secondary_low",
                border: "1px solid $border_bright"
              }
            },
            /* @__PURE__ */ React179.createElement(Checkbox.Indicator, null, /* @__PURE__ */ React179.createElement(CheckIcon10, { width: 12, height: 12 }))
          ),
          /* @__PURE__ */ React179.createElement(
            Label3,
            {
              htmlFor: `${option}-${index}`,
              css: {
                color: "$on_surface_high",
                fontSize: "$sm",
                fontWeight: "$regular",
                lineHeight: "20px"
              }
            },
            option
          )
        );
      })
    )
  ), (feedback == null ? void 0 : feedback.comment) && /* @__PURE__ */ React179.createElement(
    Flex,
    {
      direction: "column",
      css: {
        gap: "$4"
      }
    },
    /* @__PURE__ */ React179.createElement(
      Text,
      {
        variant: "body2",
        css: {
          c: "$on_surface_high",
          fontWeight: "$regular",
          fontSize: "$sm"
        }
      },
      (feedback == null ? void 0 : feedback.comment.label) || "Additional comments (optional)"
    ),
    /* @__PURE__ */ React179.createElement(
      TextArea,
      {
        maxLength: 1024,
        placeholder: (feedback == null ? void 0 : feedback.comment.placeholder) || "Tell us more...",
        css: {
          backgroundColor: "$surface_bright",
          border: "1px solid $border_bright",
          resize: "none",
          height: "$36",
          display: "flex"
        },
        value: comment,
        onChange: (event) => setComment(event.target.value.trimStart())
      }
    )
  ));
};

// src/Prebuilt/components/EndCallFeedback/ThankyouView.tsx
init_define_process_env();
import React180, { useState as useState75 } from "react";
import { useMedia as useMedia46 } from "react-use";
import { CrossIcon as CrossIcon31, UserMusicIcon } from "@100mslive/react-icons";
var ThankyouView = () => {
  const [isVisible, setIsVisible] = useState75(true);
  const isMobile = useMedia46(config.media.md);
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ React180.createElement(
    Flex,
    {
      direction: isMobile ? "column" : "row",
      align: "center",
      css: {
        gap: "$10",
        border: "1px solid $border_default",
        borderRadius: !isMobile ? "$3" : "$3 $3 0 0",
        bg: "$surface_dim",
        w: !isMobile ? "528px" : "410px",
        p: "$12",
        pb: isMobile ? "$16" : "$12",
        "@md": {
          position: "absolute",
          bottom: "0"
        }
      }
    },
    isMobile && /* @__PURE__ */ React180.createElement(
      CrossIcon31,
      {
        width: "24px",
        height: "24px",
        color: "white",
        onClick: () => setIsVisible(false),
        style: {
          position: "absolute",
          top: "8px",
          right: "16px",
          cursor: "pointer"
        }
      }
    ),
    /* @__PURE__ */ React180.createElement(UserMusicIcon, { width: "64px", height: "64px" }),
    /* @__PURE__ */ React180.createElement(Flex, { direction: "column", align: isMobile ? "center" : "start" }, /* @__PURE__ */ React180.createElement(Text, { variant: "h5" }, "Thank you for your feedback"), /* @__PURE__ */ React180.createElement(
      Text,
      {
        variant: "body1",
        css: {
          fontWeight: "$regular",
          fontSize: "$md",
          opacity: "0.9"
        }
      },
      "Your answers help us improve."
    ))
  );
};

// src/Prebuilt/components/EndCallFeedback/Feedback.tsx
var Feedback = () => {
  const { feedback } = useRoomLayoutLeaveScreen();
  const [index, setIndex] = useState76(FEEBACK_INDEX.INIT);
  const isMobile = useMedia47(config.media.md);
  if (!feedback) {
    return null;
  }
  const { ratings } = feedback;
  if (!ratings) {
    return null;
  }
  ratings.sort((a2, b2) => {
    if (!a2.value || !b2.value) {
      return 0;
    }
    return a2.value - b2.value;
  });
  if (index === FEEBACK_INDEX.THANK_YOU) {
    return /* @__PURE__ */ React181.createElement(
      Flex,
      {
        justify: "center",
        css: {
          pt: "$16"
        }
      },
      /* @__PURE__ */ React181.createElement(ThankyouView, null)
    );
  }
  return /* @__PURE__ */ React181.createElement(
    Flex,
    {
      justify: "center",
      css: {
        pt: "$16",
        w: isMobile ? "100%" : "528px"
      }
    },
    index === FEEBACK_INDEX.INIT ? /* @__PURE__ */ React181.createElement(
      Flex,
      {
        css: {
          p: isMobile ? "$10" : "$12",
          border: "1px solid $border_default",
          bg: "$surface_dim",
          borderRadius: !isMobile ? "$3" : "$3 $3 0 0",
          gap: "$10",
          "@md": {
            position: "absolute",
            bottom: "0",
            w: "100%"
          }
        },
        direction: "column"
      },
      /* @__PURE__ */ React181.createElement(FeedbackHeader, { ratings, onEmojiClicked: setIndex })
    ) : /* @__PURE__ */ React181.createElement(FeedbackModal, { ratings, index, setIndex })
  );
};

// src/Prebuilt/components/LeaveScreen.tsx
var LeaveScreen = () => {
  const { rejoin } = useHMSAppStateContext();
  const [previewPreference] = useUserPreferences(UserPreferencesKeys.PREVIEW, defaultPreviewPreference);
  return /* @__PURE__ */ React182.createElement(Flex, { direction: "column", css: { size: "100%" } }, /* @__PURE__ */ React182.createElement(Box, { css: { h: "$18", "@md": { h: "$17" } }, "data-testid": "header" }, /* @__PURE__ */ React182.createElement(Header2, null)), /* @__PURE__ */ React182.createElement(
    Flex,
    {
      justify: "center",
      direction: "column",
      align: "center",
      css: { bg: "$background_dim", flex: "1 1 0", position: "relative" }
    },
    /* @__PURE__ */ React182.createElement(Text, { variant: "h2", css: { fontWeight: "$semiBold" } }, "\u{1F44B}"),
    /* @__PURE__ */ React182.createElement(Text, { variant: "h4", css: { color: "$on_surface_high", fontWeight: "$semiBold", mt: "$12" } }, "You left the room"),
    /* @__PURE__ */ React182.createElement(
      Text,
      {
        variant: "body1",
        css: {
          color: "$on_surface_medium",
          mt: "$8",
          fontWeight: "$regular",
          textAlign: "center"
        }
      },
      "Have a nice day",
      previewPreference.name && /* @__PURE__ */ React182.createElement(Box, { as: "span", css: __spreadValues({}, textEllipsis(100)) }, ", ", previewPreference.name),
      "!"
    ),
    /* @__PURE__ */ React182.createElement(Flex, { css: { mt: "$14", gap: "$10", alignItems: "center" } }, /* @__PURE__ */ React182.createElement(Text, { variant: "body1", css: { color: "$on_surface_medium", fontWeight: "$regular" } }, "Left by mistake?"), /* @__PURE__ */ React182.createElement(
      Button,
      {
        onClick: () => {
          rejoin();
          ToastManager.clearAllToast();
        },
        "data-testid": "join_again_btn"
      },
      /* @__PURE__ */ React182.createElement(ExitIcon3, null),
      /* @__PURE__ */ React182.createElement(Text, { css: { ml: "$3", fontWeight: "$semiBold", color: "inherit" } }, "Rejoin")
    )),
    /* @__PURE__ */ React182.createElement(Feedback, null)
  ));
};

// src/Prebuilt/components/MwebLandscapePrompt.tsx
init_define_process_env();
import React183, { useEffect as useEffect68, useState as useState77 } from "react";
import { useMedia as useMedia48 } from "react-use";
import { match as match15, P as P7 } from "ts-pattern";
import { RefreshIcon } from "@100mslive/react-icons";
var MwebLandscapePrompt = () => {
  const [showMwebLandscapePrompt, setShowMwebLandscapePrompt] = useState77(false);
  const isLandscape = useMedia48(config.media.ls);
  const isLandscapeHLSStream = useLandscapeHLSStream();
  useEffect68(() => {
    var _a8;
    if (!isMobileUserAgent) {
      setShowMwebLandscapePrompt(false);
      return;
    }
    if (!((_a8 = window.screen) == null ? void 0 : _a8.orientation)) {
      setShowMwebLandscapePrompt(isLandscape && !isLandscapeHLSStream);
      return;
    }
    const handleRotation = () => {
      const angle = window.screen.orientation.angle;
      const type = window.screen.orientation.type || "";
      setShowMwebLandscapePrompt(
        match15({ angle, isLandscapeHLSStream, isLandscape, type }).with({ isLandscapeHLSStream: true }, () => false).with({ angle: P7.when((angle2) => angle2 && angle2 >= 90) }, ({ type: type2 }) => type2.includes("landscape")).otherwise(() => isLandscape)
      );
    };
    handleRotation();
    window.screen.orientation.addEventListener("change", handleRotation);
    return () => {
      window.screen.orientation.removeEventListener("change", handleRotation);
    };
  }, [isLandscape, isLandscapeHLSStream]);
  if (isLandscapeHLSStream) {
    return null;
  }
  return /* @__PURE__ */ React183.createElement(Dialog.Root, { open: showMwebLandscapePrompt, onOpenChange: setShowMwebLandscapePrompt }, /* @__PURE__ */ React183.createElement(Dialog.Portal, null, /* @__PURE__ */ React183.createElement(Dialog.Overlay, null), /* @__PURE__ */ React183.createElement(Dialog.Content, { css: { w: "min(420px, 90%)", p: "$8", bg: "$surface_dim" } }, /* @__PURE__ */ React183.createElement(Box, null, /* @__PURE__ */ React183.createElement(
    Flex,
    {
      css: {
        color: "$primary_default",
        display: "flex",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React183.createElement(RefreshIcon, { style: { marginRight: "0.5rem" } }),
    /* @__PURE__ */ React183.createElement(Text, { variant: "lg", css: { color: "$on_surface_high", fontWeight: "$semiBold" } }, "Please rotate your device")
  ), /* @__PURE__ */ React183.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", mb: "$8", mt: "$4" } }, "We do not support landscape mode as of now, please use the app in portrait mode for the best experience."), /* @__PURE__ */ React183.createElement(Flex, { align: "center", justify: "between", css: { w: "100%", gap: "$8" } }, /* @__PURE__ */ React183.createElement(Button, { outlined: true, variant: "standard", css: { w: "100%" }, onClick: () => setShowMwebLandscapePrompt(false) }, "Continue anyway"))))));
};

// src/Prebuilt/components/Notifications/index.tsx
init_define_process_env();

// src/Prebuilt/components/Notifications/Notifications.tsx
init_define_process_env();
import React195, { useCallback as useCallback39 } from "react";
import { HMSRoomState as HMSRoomState11, selectRoomState as selectRoomState11, useCustomEvent as useCustomEvent4, useHMSStore as useHMSStore94 } from "@100mslive/react-sdk";

// src/Prebuilt/components/Notifications/AutoplayBlockedModal.tsx
init_define_process_env();
import React184 from "react";
import { useAutoplayError } from "@100mslive/react-sdk";
function AutoplayBlockedModal() {
  const { error, resetError, unblockAudio } = useAutoplayError();
  return /* @__PURE__ */ React184.createElement(
    Dialog.Root,
    {
      open: !!error,
      onOpenChange: (value) => __async(this, null, function* () {
        if (!value) {
          yield unblockAudio();
        }
        resetError();
      })
    },
    /* @__PURE__ */ React184.createElement(DialogContent, { title: "Permission Error", closeable: false }, /* @__PURE__ */ React184.createElement(DialogRow, null, /* @__PURE__ */ React184.createElement(Text, { variant: "md" }, "The browser wants us to get a confirmation for playing the Audio. Please allow audio to proceed.")), /* @__PURE__ */ React184.createElement(DialogRow, { justify: "end" }, /* @__PURE__ */ React184.createElement(
      Button,
      {
        variant: "primary",
        onClick: () => __async(this, null, function* () {
          yield unblockAudio();
          resetError();
        })
      },
      "Allow Audio"
    )))
  );
}

// src/Prebuilt/components/Notifications/ChatNotifications.tsx
init_define_process_env();
import React185, { useEffect as useEffect69 } from "react";
import { v4 as uuid4 } from "uuid";
import { selectLocalPeerID as selectLocalPeerID14, selectSessionStore as selectSessionStore13, useHMSStore as useHMSStore89 } from "@100mslive/react-sdk";
import { ChatIcon as ChatIcon2, ChatUnreadIcon } from "@100mslive/react-icons";
var NOTIFICATION_TIME_DIFFERENCE = 5e3;
var ChatNotifications = () => {
  const chatState = useHMSStore89(selectSessionStore13("chatState" /* CHAT_STATE */));
  const localPeerId = useHMSStore89(selectLocalPeerID14);
  useEffect69(() => {
    var _a8, _b7;
    if (!chatState || ((_a8 = chatState.updatedBy) == null ? void 0 : _a8.peerId) === localPeerId) {
      return;
    }
    const showToast = Date.now() - chatState.updatedAt < NOTIFICATION_TIME_DIFFERENCE;
    if (!showToast) {
      return;
    }
    const notification = {
      id: uuid4(),
      icon: chatState.enabled ? /* @__PURE__ */ React185.createElement(ChatUnreadIcon, null) : /* @__PURE__ */ React185.createElement(ChatIcon2, null),
      title: `Chat ${chatState.enabled ? "resumed" : "paused"} by ${(_b7 = chatState.updatedBy) == null ? void 0 : _b7.userName}`
    };
    ToastManager.addToast(notification);
  }, [chatState, localPeerId]);
  return /* @__PURE__ */ React185.createElement(React185.Fragment, null);
};

// src/Prebuilt/components/Notifications/DeviceChangeNotifications.tsx
init_define_process_env();
import { useEffect as useEffect70 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes3, useHMSNotifications as useHMSNotifications3 } from "@100mslive/react-sdk";
var DeviceChangeNotifications = () => {
  const notification = useHMSNotifications3(HMSNotificationTypes3.DEVICE_CHANGE_UPDATE);
  useEffect70(() => {
    if (notification) {
      ToastManager.addToast({
        title: notification.message
      });
    }
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/DeviceInUseError.tsx
init_define_process_env();
import React186, { useEffect as useEffect71, useState as useState78 } from "react";
import {
  HMSNotificationTypes as HMSNotificationTypes4,
  HMSTrackExceptionTrackType,
  useHMSNotifications as useHMSNotifications4
} from "@100mslive/react-sdk";
var Instruction = ({ description }) => /* @__PURE__ */ React186.createElement("li", null, /* @__PURE__ */ React186.createElement(DialogRow, { css: { ml: "$4" } }, /* @__PURE__ */ React186.createElement(Text, { variant: "body2" }, description)));
function DeviceInUseError() {
  const notification = useHMSNotifications4(HMSNotificationTypes4.ERROR);
  const [showDeviceInUseModal, setShowDeviceInUseModal] = useState78(false);
  const [deviceType, setDeviceType] = useState78("");
  useEffect71(() => {
    const error = notification == null ? void 0 : notification.data;
    if (!error || error.code !== 3003) {
      return;
    }
    const errorTrackExceptionType = error == null ? void 0 : error.trackType;
    const hasAudio = errorTrackExceptionType === HMSTrackExceptionTrackType.AUDIO;
    const hasVideo = errorTrackExceptionType === HMSTrackExceptionTrackType.VIDEO;
    const hasAudioVideo = errorTrackExceptionType === HMSTrackExceptionTrackType.AUDIO_VIDEO;
    const hasScreen = errorTrackExceptionType === HMSTrackExceptionTrackType.SCREEN;
    const errorMessage = error == null ? void 0 : error.message;
    ToastManager.addToast({
      title: `Error: ${errorMessage} - ${error == null ? void 0 : error.description}`,
      action: /* @__PURE__ */ React186.createElement(Button, { outlined: true, variant: "standard", css: { w: "max-content" }, onClick: () => setShowDeviceInUseModal(true) }, "Help")
    });
    if (hasAudioVideo) {
      setDeviceType("camera and microphone");
    } else if (hasAudio) {
      setDeviceType("microphone");
    } else if (hasVideo) {
      setDeviceType("camera");
    } else if (hasScreen) {
      setDeviceType("screen");
    }
  }, [notification]);
  return /* @__PURE__ */ React186.createElement(
    Dialog.Root,
    {
      open: showDeviceInUseModal,
      onOpenChange: () => {
        setShowDeviceInUseModal(false);
      }
    },
    /* @__PURE__ */ React186.createElement(DialogContent, { title: "Device Access Error" }, /* @__PURE__ */ React186.createElement(DialogRow, null, /* @__PURE__ */ React186.createElement(Text, { variant: "body2" }, "We weren't able to access your ", deviceType, " since it's either in use by another application or is not configured properly. Please follow the following instructions to resolve this issue.")), /* @__PURE__ */ React186.createElement("ol", null, /* @__PURE__ */ React186.createElement(
      Instruction,
      {
        description: `Please check if the ${deviceType} device(s) are in use by another browser or application and close it.`
      }
    ), /* @__PURE__ */ React186.createElement(
      Instruction,
      {
        description: `Go to Browser Settings > Privacy and security > Site settings > ${deviceType} and check if your preferred device is selected as default.`
      }
    ), /* @__PURE__ */ React186.createElement(Instruction, { description: "Try restarting the browser." }), /* @__PURE__ */ React186.createElement(Instruction, { description: "Try disconnecting and reconnecting the external device if your intention is to use one." })))
  );
}

// src/Prebuilt/components/Notifications/ErrorNotifications.tsx
init_define_process_env();
import React187, { useEffect as useEffect72 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes5, useHMSNotifications as useHMSNotifications5 } from "@100mslive/react-sdk";
import { GroupIcon as GroupIcon2 } from "@100mslive/react-icons";
var ErrorNotifications = () => {
  const notification = useHMSNotifications5(HMSNotificationTypes5.ERROR);
  const subscribedNotifications = useSubscribedNotifications() || {};
  useEffect72(() => {
    if (!notification || !notification.data)
      return;
    const { isTerminal, action, code, message, description } = notification.data;
    if (isTerminal && action !== "INIT") {
      if ([500, 6008].includes(code)) {
        ToastManager.addToast({
          title: `Error: ${message}`
        });
      } else if (message === "role limit reached") {
        ToastManager.addToast({
          title: "The room is currently full, try joining later",
          close: true,
          icon: /* @__PURE__ */ React187.createElement(Box, { css: { color: "$alert_error_default" } }, /* @__PURE__ */ React187.createElement(GroupIcon2, null))
        });
      } else {
        ToastManager.addToast({
          title: message || "We couldn\u2019t reconnect you. When you\u2019re back online, try joining the room.",
          close: false
        });
      }
      return;
    }
    if ([3008, 3001, 3011].includes(code)) {
      return;
    }
    if (action === "INIT") {
      return;
    }
    if (!subscribedNotifications.ERROR)
      return;
    ToastManager.addToast({
      title: `Error: ${message} - ${description}`
    });
  }, [notification, subscribedNotifications.ERROR]);
  return null;
};

// src/Prebuilt/components/Notifications/HandRaisedNotifications.tsx
init_define_process_env();
import { useEffect as useEffect73 } from "react";
import { useDebounce as useDebounce2 } from "react-use";
import {
  HMSNotificationTypes as HMSNotificationTypes6,
  HMSRoomState as HMSRoomState10,
  selectHandRaisedPeers as selectHandRaisedPeers2,
  selectHasPeerHandRaised as selectHasPeerHandRaised4,
  selectIsLocalScreenShared as selectIsLocalScreenShared3,
  selectPeerByID as selectPeerByID6,
  selectRoomState as selectRoomState10,
  useAwayNotifications as useAwayNotifications4,
  useHMSNotifications as useHMSNotifications6,
  useHMSStore as useHMSStore91,
  useHMSVanillaStore as useHMSVanillaStore17
} from "@100mslive/react-sdk";

// src/Prebuilt/components/Toast/ToastBatcher.js
init_define_process_env();

// src/Prebuilt/components/Toast/ToastConfig.jsx
init_define_process_env();
import React188, { useCallback as useCallback38 } from "react";
import { selectPeerByID as selectPeerByID5, useHMSActions as useHMSActions54, useHMSStore as useHMSStore90 } from "@100mslive/react-sdk";
import {
  ChatUnreadIcon as ChatUnreadIcon2,
  ConnectivityIcon,
  HandIcon as HandIcon6,
  PeopleAddIcon as PeopleAddIcon4,
  PeopleRemoveIcon as PeopleRemoveIcon4,
  PoorConnectivityIcon as PoorConnectivityIcon2
} from "@100mslive/react-icons";
var ChatAction = React188.forwardRef((_, ref) => {
  const toggleChat = useSidepaneToggle(SIDE_PANE_OPTIONS.CHAT);
  const isChatOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.CHAT);
  if (isChatOpen) {
    return null;
  }
  return /* @__PURE__ */ React188.createElement(Button, { outlined: true, as: "div", variant: "standard", css: { w: "max-content" }, onClick: toggleChat, ref }, "Open Chat");
});
var HandRaiseAction = React188.forwardRef(({ id = "", isSingleHandRaise = true }, ref) => {
  var _a8, _b7, _c;
  const hmsActions = useHMSActions54();
  const toggleSidepane = useSidepaneToggle(SIDE_PANE_OPTIONS.PARTICIPANTS);
  const isParticipantsOpen = useIsSidepaneTypeOpen(SIDE_PANE_OPTIONS.PARTICIPANTS);
  const peer = useHMSStore90(selectPeerByID5(id));
  const layout = useRoomLayout();
  const {
    bring_to_stage_label,
    on_stage_role,
    off_stage_roles = [],
    skip_preview_for_role_change = false
  } = ((_c = (_b7 = (_a8 = layout == null ? void 0 : layout.screens) == null ? void 0 : _a8.conferencing) == null ? void 0 : _b7.default) == null ? void 0 : _c.elements.on_stage_exp) || {};
  const onClickHandler = useCallback38(() => __async(void 0, null, function* () {
    if (isSingleHandRaise) {
      hmsActions.changeRoleOfPeer(id, on_stage_role, skip_preview_for_role_change);
      if (skip_preview_for_role_change) {
        yield hmsActions.lowerRemotePeerHand(id);
      }
    } else {
      !isParticipantsOpen && toggleSidepane();
    }
  }), [
    hmsActions,
    id,
    isParticipantsOpen,
    isSingleHandRaise,
    on_stage_role,
    toggleSidepane,
    skip_preview_for_role_change
  ]);
  if (isSingleHandRaise && (!peer || !off_stage_roles.includes(peer.roleName))) {
    return null;
  }
  return /* @__PURE__ */ React188.createElement(Button, { outlined: true, as: "div", variant: "standard", css: { w: "max-content" }, onClick: onClickHandler, ref }, isSingleHandRaise ? bring_to_stage_label : "View");
});
var ToastConfig = {
  PEER_JOINED: {
    single: function(notification) {
      var _a8;
      return {
        title: `${(_a8 = notification.data) == null ? void 0 : _a8.name} joined`,
        icon: /* @__PURE__ */ React188.createElement(PeopleAddIcon4, null)
      };
    },
    multiple: function(notifications) {
      return {
        title: `${notifications[notifications.length - 1].data.name} and ${notifications.length - 1} others joined`,
        icon: /* @__PURE__ */ React188.createElement(PeopleAddIcon4, null)
      };
    }
  },
  PEER_LEFT: {
    single: function(notification) {
      var _a8;
      return {
        title: `${(_a8 = notification.data) == null ? void 0 : _a8.name} left`,
        icon: /* @__PURE__ */ React188.createElement(PeopleRemoveIcon4, null)
      };
    },
    multiple: function(notifications) {
      return {
        title: `${notifications[notifications.length - 1].data.name} and ${notifications.length - 1} others left`,
        icon: /* @__PURE__ */ React188.createElement(PeopleRemoveIcon4, null)
      };
    }
  },
  RAISE_HAND: {
    single: (notification) => {
      var _a8;
      return {
        title: `${(_a8 = notification.data) == null ? void 0 : _a8.name} raised hand`,
        icon: /* @__PURE__ */ React188.createElement(HandIcon6, null)
      };
    },
    multiple: (notifications) => {
      var _a8;
      const count = new Set(notifications.map((notification) => {
        var _a9;
        return (_a9 = notification.data) == null ? void 0 : _a9.id;
      })).size;
      return {
        title: `${(_a8 = notifications[notifications.length - 1].data) == null ? void 0 : _a8.name} ${count > 1 ? `and ${count} others` : ""} raised hand`,
        icon: /* @__PURE__ */ React188.createElement(HandIcon6, null)
      };
    }
  },
  RAISE_HAND_HLS: {
    single: (notification) => {
      var _a8, _b7;
      return {
        title: `${(_a8 = notification.data) == null ? void 0 : _a8.name} raised hand`,
        icon: /* @__PURE__ */ React188.createElement(HandIcon6, null),
        action: /* @__PURE__ */ React188.createElement(HandRaiseAction, { id: (_b7 = notification.data) == null ? void 0 : _b7.id })
      };
    },
    multiple: (notifications) => {
      var _a8;
      const count = new Set(notifications.map((notification) => {
        var _a9;
        return (_a9 = notification.data) == null ? void 0 : _a9.id;
      })).size;
      return {
        title: `${(_a8 = notifications[notifications.length - 1].data) == null ? void 0 : _a8.name} ${count > 1 ? `and ${count} others` : ""} raised hand`,
        icon: /* @__PURE__ */ React188.createElement(HandIcon6, null),
        action: /* @__PURE__ */ React188.createElement(HandRaiseAction, { isSingleHandRaise: false })
      };
    }
  },
  NEW_MESSAGE: {
    single: (notification) => {
      var _a8;
      return {
        title: `New message from ${(_a8 = notification.data) == null ? void 0 : _a8.senderName}`,
        icon: /* @__PURE__ */ React188.createElement(ChatUnreadIcon2, null),
        action: /* @__PURE__ */ React188.createElement(ChatAction, null)
      };
    },
    multiple: (notifications) => {
      return {
        title: `${notifications.length} new messages`,
        icon: /* @__PURE__ */ React188.createElement(ChatUnreadIcon2, null),
        action: /* @__PURE__ */ React188.createElement(ChatAction, null)
      };
    }
  },
  RECONNECTED: {
    single: (online) => {
      return {
        title: `You are now ${online ? "online" : "connected"}`,
        icon: /* @__PURE__ */ React188.createElement(ConnectivityIcon, null),
        variant: "success",
        duration: 3e3
      };
    }
  },
  RECONNECTING: {
    single: (message) => {
      return {
        title: `You are offline for now. while we try to reconnect, please check
        your internet connection. ${message}.
      `,
        icon: /* @__PURE__ */ React188.createElement(PoorConnectivityIcon2, null),
        variant: "warning",
        duration: 3e4
      };
    }
  }
};

// src/Prebuilt/components/Toast/ToastBatcher.js
var ToastBatcher = {
  toastsType: /* @__PURE__ */ new Map(),
  toastCache: {},
  showToastInternal({ notification, duration, type }) {
    let notificationType = type;
    if (!type) {
      notificationType = notification.type;
    }
    const toastType = this.toastsType.has(notificationType);
    if (toastType) {
      let { notifications } = this.toastsType.get(notificationType);
      const { id } = this.toastsType.get(notificationType);
      notifications.push(notification);
      const toastObject = ToastConfig[notificationType].multiple(notifications);
      const toastId = ToastManager.replaceToast(id, __spreadProps(__spreadValues({}, toastObject), {
        duration
      }));
      this.toastsType.set(notificationType, {
        id: toastId,
        notifications,
        duration
      });
    } else {
      const toastObject = ToastConfig[notificationType].single(notification);
      const toastId = ToastManager.addToast(__spreadProps(__spreadValues({}, toastObject), {
        duration
      }));
      let notifications = [];
      notifications.push(notification);
      this.toastsType.set(notificationType, {
        id: toastId,
        notifications: [...notifications],
        duration
      });
    }
  },
  showToast({ notification, duration = 3e3, type }) {
    try {
      if (!this.toastCache[notification.id]) {
        this.showToastInternal({ notification, duration, type });
      }
      this.toastCache[notification.id] = true;
      if (Object.keys(this.toastCache).length > 100) {
        this.toastCache = {};
      }
    } catch (err) {
      console.debug("Notifications", err);
    }
  },
  syncUItoast(toastsDisplaying) {
    for (const [toastType, toastInfo] of this.toastsType.entries()) {
      if (!toastsDisplaying.find((toast) => toast.id === toastInfo.id)) {
        this.toastsType.delete(toastType);
      }
    }
  }
};
ToastManager.addListener(ToastBatcher.syncUItoast.bind(ToastBatcher));

// src/Prebuilt/components/Notifications/HandRaisedNotifications.tsx
var HandRaisedNotifications = () => {
  var _a8, _b7;
  const notification = useHMSNotifications6(HMSNotificationTypes6.HAND_RAISE_CHANGED);
  const roomState = useHMSStore91(selectRoomState10);
  const vanillaStore = useHMSVanillaStore17();
  const { on_stage_exp } = useRoomLayoutConferencingScreen().elements || {};
  const isSubscribing = !!useSubscribedNotifications(SUBSCRIBED_NOTIFICATIONS.METADATA_UPDATED);
  const amIScreenSharing = useHMSStore91(selectIsLocalScreenShared3);
  const { showNotification } = useAwayNotifications4();
  const logoURL = (_b7 = (_a8 = useRoomLayout()) == null ? void 0 : _a8.logo) == null ? void 0 : _b7.url;
  useEffect73(() => {
    var _a9;
    if (!(notification == null ? void 0 : notification.data)) {
      return;
    }
    if (roomState !== HMSRoomState10.Connected || notification.data.isLocal || !isSubscribing) {
      return;
    }
    const hasPeerHandRaised = vanillaStore.getState(selectHasPeerHandRaised4(notification.data.id));
    const peer = vanillaStore.getState(selectPeerByID6(notification.data.id));
    if (hasPeerHandRaised) {
      const showCTA = (peer == null ? void 0 : peer.roleName) && ((_a9 = (on_stage_exp == null ? void 0 : on_stage_exp.off_stage_roles) || []) == null ? void 0 : _a9.includes(peer.roleName));
      ToastBatcher.showToast({ notification, type: showCTA ? "RAISE_HAND_HLS" : "RAISE_HAND" });
      console.debug("Metadata updated", notification.data);
    }
  }, [isSubscribing, notification, on_stage_exp, roomState, vanillaStore]);
  useDebounce2(
    () => {
      if (!(notification == null ? void 0 : notification.data)) {
        return;
      }
      if (roomState !== HMSRoomState10.Connected || notification.data.isLocal || !isSubscribing) {
        return;
      }
      const hasPeerHandRaised = vanillaStore.getState(selectHasPeerHandRaised4(notification.data.id));
      const peer = vanillaStore.getState(selectPeerByID6(notification.data.id));
      const handRaisedPeers = vanillaStore.getState(selectHandRaisedPeers2);
      if (amIScreenSharing && hasPeerHandRaised) {
        const title = `${peer == null ? void 0 : peer.name} ${handRaisedPeers.length > 1 ? `and ${handRaisedPeers.length - 1} others` : ""} raised hand`;
        showNotification(title, { icon: logoURL });
      }
    },
    1e3,
    [isSubscribing, notification, roomState, vanillaStore, amIScreenSharing]
  );
  return null;
};

// src/Prebuilt/components/Notifications/InitErrorModal.tsx
init_define_process_env();
import React189, { useEffect as useEffect74, useState as useState79 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes7, useHMSNotifications as useHMSNotifications7 } from "@100mslive/react-sdk";
var InitErrorModal = () => {
  const notification = useHMSNotifications7(HMSNotificationTypes7.ERROR);
  const [showModal, setShowModal] = useState79(false);
  const [info, setInfo] = useState79({ title: "Init Error", description: "" });
  useEffect74(() => {
    const data3 = notification == null ? void 0 : notification.data;
    if (!data3 || data3.action !== "INIT") {
      return;
    }
    let description;
    let title;
    if (data3.description.includes("role is invalid")) {
      description = "This role does not exist for the given room. Try again with a valid role.";
      title = "Invalid Role";
    } else if (data3.description.includes("room is not active")) {
      title = "Room is disabled";
      description = "This room is disabled and cannot be joined. To enable the room, use the 100ms dashboard or the API.";
    } else {
      description = data3.description;
      title = "Init Error";
    }
    setInfo({ title, description });
    setShowModal(true);
  }, [notification]);
  return /* @__PURE__ */ React189.createElement(ErrorDialog, { open: showModal, onOpenChange: setShowModal, title: info.title }, /* @__PURE__ */ React189.createElement(Text, { variant: "sm", css: { wordBreak: "break-word" } }, info.description, " ", /* @__PURE__ */ React189.createElement("br", null), "Current URL - ", window.location.href));
};

// src/Prebuilt/components/Notifications/MessageNotifications.tsx
init_define_process_env();
import { useEffect as useEffect75 } from "react";
import { useAwayNotifications as useAwayNotifications5, useHMSNotifications as useHMSNotifications8, useHMSStore as useHMSStore92 } from "@100mslive/react-sdk";
var MessageNotifications = () => {
  var _a8, _b7;
  const notification = useHMSNotifications8(Pr.NEW_MESSAGE);
  const amIScreenSharing = useHMSStore92(Xr);
  const logoURL = (_b7 = (_a8 = useRoomLayout()) == null ? void 0 : _a8.logo) == null ? void 0 : _b7.url;
  const { pipWindow } = usePIPWindow();
  const { showNotification } = useAwayNotifications5();
  useEffect75(() => {
    var _a9;
    if (notification && amIScreenSharing && !((_a9 = notification.data) == null ? void 0 : _a9.ignored) && !pipWindow) {
      showNotification(`New message from ${notification.data.senderName}`, {
        body: notification.data.message,
        icon: logoURL
      });
    }
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/PeerNotifications.tsx
init_define_process_env();
import { useEffect as useEffect76 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes8, useHMSNotifications as useHMSNotifications9 } from "@100mslive/react-sdk";
var notificationTypes = [
  HMSNotificationTypes8.PEER_JOINED,
  HMSNotificationTypes8.PEER_LEFT,
  HMSNotificationTypes8.NAME_UPDATED
];
var PeerNotifications = () => {
  const notification = useHMSNotifications9(notificationTypes);
  const isPeerJoinSubscribed = useSubscribedNotifications(SUBSCRIBED_NOTIFICATIONS.PEER_JOINED);
  const isPeerLeftSubscribed = useSubscribedNotifications(SUBSCRIBED_NOTIFICATIONS.PEER_LEFT);
  const [selectedPeer, setPeerSelector] = useSetSubscribedChatSelector(CHAT_SELECTOR.PEER);
  useEffect76(() => {
    if (!(notification == null ? void 0 : notification.data)) {
      return;
    }
    console.debug(`[${notification.type}]`, notification);
    switch (notification.type) {
      case HMSNotificationTypes8.PEER_JOINED:
        if (!isPeerJoinSubscribed) {
          return;
        }
        break;
      case HMSNotificationTypes8.PEER_LEFT:
        if (selectedPeer.id === notification.data.id) {
          setPeerSelector({});
        }
        if (!isPeerLeftSubscribed) {
          return;
        }
        break;
      case HMSNotificationTypes8.NAME_UPDATED:
        console.log(notification.data.id + " changed their name to " + notification.data.name);
        return;
      default:
        return;
    }
    ToastBatcher.showToast({ notification });
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/PermissionErrorModal.tsx
init_define_process_env();
import React190, { useEffect as useEffect77, useState as useState80 } from "react";
import { useMedia as useMedia49 } from "react-use";
import {
  HMSNotificationTypes as HMSNotificationTypes9,
  HMSTrackExceptionTrackType as HMSTrackExceptionTrackType2,
  useHMSNotifications as useHMSNotifications10
} from "@100mslive/react-sdk";
import androidPermissionAlert from "./android-perm-1.png";
import iosPermissions from "./ios-perm-0.png";
function PermissionErrorNotificationModal() {
  const notification = useHMSNotifications10(HMSNotificationTypes9.ERROR);
  return /* @__PURE__ */ React190.createElement(PermissionErrorModal, { error: notification == null ? void 0 : notification.data });
}
var PermissionErrorModal = ({ error }) => {
  const [deviceType, setDeviceType] = useState80("");
  const [isSystemError, setIsSystemError] = useState80(false);
  const isMobile = useMedia49(config.media.md);
  useEffect77(() => {
    if (!error || (error == null ? void 0 : error.code) !== 3001 && (error == null ? void 0 : error.code) !== 3011 || (error == null ? void 0 : error.code) === 3001 && (error == null ? void 0 : error.message.includes("screen"))) {
      return;
    }
    const errorTrackExceptionType = error == null ? void 0 : error.trackType;
    const hasAudio = errorTrackExceptionType === HMSTrackExceptionTrackType2.AUDIO;
    const hasVideo = errorTrackExceptionType === HMSTrackExceptionTrackType2.VIDEO;
    const hasAudioVideo = errorTrackExceptionType === HMSTrackExceptionTrackType2.AUDIO_VIDEO;
    const hasScreen = errorTrackExceptionType === HMSTrackExceptionTrackType2.SCREEN;
    if (hasAudioVideo) {
      setDeviceType("camera and microphone");
    } else if (hasAudio) {
      setDeviceType("microphone");
    } else if (hasVideo) {
      setDeviceType("camera");
    } else if (hasScreen) {
      setDeviceType("screen");
    }
    setIsSystemError(error.code === 3011);
  }, [error]);
  return deviceType ? /* @__PURE__ */ React190.createElement(Dialog.Root, { open: !!deviceType }, /* @__PURE__ */ React190.createElement(Dialog.Portal, null, /* @__PURE__ */ React190.createElement(Dialog.Overlay, null), /* @__PURE__ */ React190.createElement(
    Dialog.Content,
    {
      css: {
        w: "min(380px, 90%)",
        p: "$8",
        // overlay over Sheet.tsx
        zIndex: 23
      }
    },
    /* @__PURE__ */ React190.createElement(
      Dialog.Title,
      {
        css: {
          borderBottom: "1px solid $border_default"
        }
      },
      isMobile && isIOS ? /* @__PURE__ */ React190.createElement("img", { style: { maxWidth: "100%", maxHeight: "100%" }, src: iosPermissions, alt: "iOS Permission flow" }) : null,
      isMobile && isAndroid ? /* @__PURE__ */ React190.createElement(
        "img",
        {
          src: androidPermissionAlert,
          style: { maxWidth: "100%", maxHeight: "100%" },
          alt: "Android Permission flow "
        }
      ) : null,
      /* @__PURE__ */ React190.createElement(Text, { variant: "h6" }, "We can't access your ", deviceType)
    ),
    /* @__PURE__ */ React190.createElement(Text, { variant: "sm", css: { pt: "$4", pb: "$10", color: "$on_surface_medium" } }, isMobile && isIOS ? 'Enable permissions by reloading this page and clicking "Allow" on the pop-up, or change settings from the address bar.' : null, isMobile && isAndroid ? `To allow other users to see and hear you, click the blocked camera icon in your browser's address bar.` : null, !isMobile ? `Access to ${deviceType} is required. ` : null, isSystemError && !isMobile ? `Enable permissions for ${deviceType}${deviceType === "screen" ? "share" : ""} from sytem settings` : null, !isSystemError && !isMobile ? `Enable permissions for ${deviceType}${deviceType === "screen" ? "share" : ""} from address bar or browser settings.` : null),
    isMobile && isIOS ? /* @__PURE__ */ React190.createElement(React190.Fragment, null, /* @__PURE__ */ React190.createElement(Button, { onClick: () => window.location.reload(), css: { w: "100%", mb: "$6" } }, "Reload"), /* @__PURE__ */ React190.createElement(Button, { outlined: true, variant: "standard", onClick: () => setDeviceType(""), css: { w: "100%" } }, "Continue anyway")) : null,
    isMobile && isAndroid ? /* @__PURE__ */ React190.createElement(React190.Fragment, null, /* @__PURE__ */ React190.createElement(Button, { onClick: () => setDeviceType(""), css: { w: "100%", mb: "$6" } }, "I've allowed access"), /* @__PURE__ */ React190.createElement(Button, { outlined: true, variant: "standard", onClick: () => setDeviceType(""), css: { w: "100%" } }, "Continue anyway")) : null,
    !isMobile ? /* @__PURE__ */ React190.createElement(Flex, { justify: "end", css: { w: "100%" } }, /* @__PURE__ */ React190.createElement(Button, { outlined: true, variant: "standard", onClick: () => setDeviceType("") }, "Dismiss")) : null
  ))) : null;
};

// src/Prebuilt/components/Notifications/PollNotificationModal.tsx
init_define_process_env();
import React191, { useEffect as useEffect78 } from "react";
import {
  HMSNotificationTypes as HMSNotificationTypes10,
  selectLocalPeerID as selectLocalPeerID15,
  selectPeerNameByID as selectPeerNameByID8,
  useHMSNotifications as useHMSNotifications11,
  useHMSStore as useHMSStore93,
  useHMSVanillaStore as useHMSVanillaStore18
} from "@100mslive/react-sdk";
var notificationTypes2 = [HMSNotificationTypes10.POLL_STARTED, HMSNotificationTypes10.POLL_STOPPED];
var pollToastKey = {};
var PollNotificationModal = () => {
  const togglePollView = usePollViewToggle();
  const localPeerID = useHMSStore93(selectLocalPeerID15);
  const vanillaStore = useHMSVanillaStore18();
  const screenProps = useRoomLayoutConferencingScreen();
  const notification = useHMSNotifications11(notificationTypes2);
  useEffect78(() => {
    switch (notification == null ? void 0 : notification.type) {
      case HMSNotificationTypes10.POLL_STARTED:
        if (notification.data.startedBy !== localPeerID && screenProps.screenType !== "hls_live_streaming") {
          const pollStartedBy = vanillaStore.getState(selectPeerNameByID8(notification.data.startedBy)) || "Participant";
          const pollToastID = ToastManager.addToast({
            title: `${pollStartedBy} started a ${notification.data.type}: ${notification.data.title}`,
            action: /* @__PURE__ */ React191.createElement(
              Button,
              {
                onClick: () => togglePollView(notification.data.id),
                variant: "standard",
                css: {
                  backgroundColor: "$surface_bright",
                  fontWeight: "$semiBold",
                  color: "$on_surface_high",
                  p: "$xs $md"
                }
              },
              notification.data.type === "quiz" ? "Answer" : "Vote"
            ),
            duration: Infinity
          });
          pollToastKey[notification.data.id] = pollToastID;
        }
        break;
      case HMSNotificationTypes10.POLL_STOPPED:
        {
          const pollID = notification == null ? void 0 : notification.data.id;
          if (pollID && (pollToastKey == null ? void 0 : pollToastKey[pollID])) {
            ToastManager.removeToast(pollToastKey == null ? void 0 : pollToastKey[notification.data.id]);
            delete pollToastKey[notification == null ? void 0 : notification.data.id];
          }
        }
        break;
      default:
        break;
    }
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/ReconnectNotifications.tsx
init_define_process_env();
import { useEffect as useEffect79, useRef as useRef34 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes11, useHMSNotifications as useHMSNotifications12 } from "@100mslive/react-sdk";
var notificationTypes3 = [HMSNotificationTypes11.RECONNECTED, HMSNotificationTypes11.RECONNECTING];
var notificationId = null;
var ReconnectNotifications = () => {
  const notification = useHMSNotifications12(notificationTypes3);
  const prevErrorCode = useRef34(0);
  useEffect79(() => {
    var _a8, _b7;
    if (!notification) {
      return;
    }
    if (notification.type === HMSNotificationTypes11.RECONNECTED) {
      notificationId = ToastManager.replaceToast(
        notificationId,
        ToastConfig.RECONNECTED.single([4005, 4006].includes(prevErrorCode.current))
      );
    } else if (notification.type === HMSNotificationTypes11.RECONNECTING) {
      prevErrorCode.current = ((_a8 = notification.data) == null ? void 0 : _a8.code) || 0;
      notificationId = ToastManager.replaceToast(
        notificationId,
        ToastConfig.RECONNECTING.single((_b7 = notification.data) == null ? void 0 : _b7.message)
      );
    }
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/RoleChangeNotification.tsx
init_define_process_env();
import { useEffect as useEffect80 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes12, useHMSNotifications as useHMSNotifications13 } from "@100mslive/react-sdk";
var RoleChangeNotification = () => {
  const notification = useHMSNotifications13(HMSNotificationTypes12.ROLE_UPDATED);
  const updateRoomLayoutForRole = useUpdateRoomLayout();
  useEffect80(() => {
    var _a8, _b7;
    if (!(notification == null ? void 0 : notification.data)) {
      return;
    }
    if (((_a8 = notification.data) == null ? void 0 : _a8.isLocal) && ((_b7 = notification.data) == null ? void 0 : _b7.roleName)) {
      ToastManager.addToast({
        title: `You are now a ${notification.data.roleName}`
      });
      updateRoomLayoutForRole == null ? void 0 : updateRoomLayoutForRole(notification.data.roleName);
    }
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/TrackBulkUnmuteModal.tsx
init_define_process_env();
import React192, { useEffect as useEffect81, useState as useState81 } from "react";
import {
  HMSNotificationTypes as HMSNotificationTypes13,
  useHMSActions as useHMSActions55,
  useHMSNotifications as useHMSNotifications14
} from "@100mslive/react-sdk";
import { MicOnIcon as MicOnIcon5 } from "@100mslive/react-icons";
var notificationTypes4 = [
  HMSNotificationTypes13.CHANGE_MULTI_TRACK_STATE_REQUEST,
  HMSNotificationTypes13.ROOM_ENDED,
  HMSNotificationTypes13.REMOVED_FROM_ROOM
];
var TrackBulkUnmuteModal = () => {
  const hmsActions = useHMSActions55();
  const [muteNotification, setMuteNotification] = useState81(null);
  const notification = useHMSNotifications14(notificationTypes4);
  useEffect81(() => {
    switch (notification == null ? void 0 : notification.type) {
      case HMSNotificationTypes13.REMOVED_FROM_ROOM:
      case HMSNotificationTypes13.ROOM_ENDED:
        setMuteNotification(null);
        break;
      case HMSNotificationTypes13.CHANGE_MULTI_TRACK_STATE_REQUEST:
        if (notification == null ? void 0 : notification.data.enabled) {
          setMuteNotification(notification.data);
        }
        break;
      default:
        return;
    }
  }, [notification]);
  if (!muteNotification) {
    return null;
  }
  const { requestedBy: peer, tracks, enabled } = muteNotification;
  const types = new Set(tracks.map((track) => track.type));
  return /* @__PURE__ */ React192.createElement(
    RequestDialog,
    {
      title: "Unmute request",
      body: `${peer == null ? void 0 : peer.name} is requesting you to unmute your ${Array.from(types).join(",")}`,
      onOpenChange: (value) => !value && setMuteNotification(null),
      onAction: () => {
        tracks.forEach((track) => {
          hmsActions.setEnabledTrack(track.id, enabled);
        });
        setMuteNotification(null);
      },
      Icon: MicOnIcon5
    }
  );
};

// src/Prebuilt/components/Notifications/TrackNotifications.tsx
init_define_process_env();
import { useEffect as useEffect82 } from "react";
import { HMSNotificationTypes as HMSNotificationTypes14, useHMSNotifications as useHMSNotifications15 } from "@100mslive/react-sdk";
var notificationTypes5 = [
  HMSNotificationTypes14.TRACK_ADDED,
  HMSNotificationTypes14.TRACK_REMOVED,
  HMSNotificationTypes14.TRACK_MUTED,
  HMSNotificationTypes14.TRACK_UNMUTED,
  HMSNotificationTypes14.CHANGE_TRACK_STATE_REQUEST
];
var TrackNotifications = () => {
  const notification = useHMSNotifications15(notificationTypes5);
  useEffect82(() => {
    var _a8, _b7;
    if (notification) {
      switch (notification.type) {
        case HMSNotificationTypes14.TRACK_ADDED:
        case HMSNotificationTypes14.TRACK_REMOVED:
        case HMSNotificationTypes14.TRACK_MUTED:
        case HMSNotificationTypes14.TRACK_UNMUTED:
          console.debug(`[${notification.type}]`, notification);
          break;
        case HMSNotificationTypes14.CHANGE_TRACK_STATE_REQUEST:
          {
            const track = (_a8 = notification.data) == null ? void 0 : _a8.track;
            if (!notification.data.enabled) {
              ToastManager.addToast({
                title: `Your ${track.source} ${track.type} was muted by
                  ${(_b7 = notification.data.requestedBy) == null ? void 0 : _b7.name}.`
              });
            }
          }
          break;
      }
    }
  }, [notification]);
  return null;
};

// src/Prebuilt/components/Notifications/TrackUnmuteModal.tsx
init_define_process_env();
import React193, { useEffect as useEffect83, useState as useState82 } from "react";
import {
  HMSNotificationTypes as HMSNotificationTypes15,
  useHMSActions as useHMSActions56,
  useHMSNotifications as useHMSNotifications16
} from "@100mslive/react-sdk";
import { MicOnIcon as MicOnIcon6 } from "@100mslive/react-icons";
var notificationTypes6 = [
  HMSNotificationTypes15.CHANGE_TRACK_STATE_REQUEST,
  HMSNotificationTypes15.ROOM_ENDED,
  HMSNotificationTypes15.REMOVED_FROM_ROOM
];
var TrackUnmuteModal = () => {
  const hmsActions = useHMSActions56();
  const notification = useHMSNotifications16(notificationTypes6);
  const [muteNotification, setMuteNotification] = useState82(null);
  useEffect83(() => {
    switch (notification == null ? void 0 : notification.type) {
      case HMSNotificationTypes15.REMOVED_FROM_ROOM:
      case HMSNotificationTypes15.ROOM_ENDED:
        ToastManager.addToast({
          title: `${notification.message}. 
              ${notification.data.reason && `Reason: ${notification.data.reason}`}`
        });
        setMuteNotification(null);
        break;
      case HMSNotificationTypes15.CHANGE_TRACK_STATE_REQUEST:
        if (notification == null ? void 0 : notification.data.enabled) {
          setMuteNotification(notification.data);
        }
        break;
      default:
        return;
    }
  }, [notification]);
  if (!muteNotification) {
    return null;
  }
  const { requestedBy: peer, track, enabled } = muteNotification;
  return /* @__PURE__ */ React193.createElement(
    RequestDialog,
    {
      title: `Unmute your ${track.type}?`,
      onOpenChange: (value) => !value && setMuteNotification(null),
      body: `${peer == null ? void 0 : peer.name} is requesting you to unmute your ${track == null ? void 0 : track.type}.`,
      onAction: () => {
        hmsActions.setEnabledTrack(track.id, enabled);
        setMuteNotification(null);
      },
      Icon: MicOnIcon6
    }
  );
};

// src/Prebuilt/components/Notifications/TranscriptionNotifications.tsx
init_define_process_env();
import React194, { useEffect as useEffect84 } from "react";
import { match as match16 } from "ts-pattern";
import { HMSNotificationTypes as HMSNotificationTypes16, HMSTranscriptionState, useHMSNotifications as useHMSNotifications17 } from "@100mslive/react-sdk";
import { AlertTriangleIcon as AlertTriangleIcon8, ClosedCaptionIcon as ClosedCaptionIcon4, OpenCaptionIcon as OpenCaptionIcon5 } from "@100mslive/react-icons";
var TranscriptionNotifications = () => {
  const notification = useHMSNotifications17(HMSNotificationTypes16.TRANSCRIPTION_STATE_UPDATED);
  const [toastId, setToastId] = useSetAppDataByKey(CAPTION_TOAST.captionToast);
  useEffect84(() => {
    if (!(notification == null ? void 0 : notification.data)) {
      return;
    }
    console.debug(`[${notification.type}]`, notification);
    const transcriptionStates = notification.data;
    if (transcriptionStates.length > 0) {
      let id = "";
      match16({ state: transcriptionStates[0].state, error: transcriptionStates[0].error }).when(
        ({ error }) => !!error,
        () => {
          id = ToastManager.replaceToast(toastId, {
            title: `Failed to enable Closed Caption`,
            variant: "error",
            icon: /* @__PURE__ */ React194.createElement(AlertTriangleIcon8, { style: { marginRight: "0.5rem" } })
          });
        }
      ).with({ state: HMSTranscriptionState.STARTED }, () => {
        id = ToastManager.replaceToast(toastId, {
          title: `Closed Captioning enabled for everyone`,
          variant: "standard",
          duration: 2e3,
          icon: /* @__PURE__ */ React194.createElement(ClosedCaptionIcon4, { style: { marginRight: "0.5rem" } })
        });
      }).with({ state: HMSTranscriptionState.STOPPED }, () => {
        id = ToastManager.replaceToast(toastId, {
          title: `Closed Captioning disabled for everyone`,
          variant: "standard",
          duration: 2e3,
          icon: /* @__PURE__ */ React194.createElement(OpenCaptionIcon5, { style: { marginRight: "0.5rem" } })
        });
      }).otherwise(() => null);
      setToastId(id);
    }
  }, [notification, setToastId]);
  return null;
};

// src/Prebuilt/components/Notifications/Notifications.tsx
function Notifications() {
  const roomState = useHMSStore94(selectRoomState11);
  const isNotificationDisabled = useIsNotificationDisabled();
  const handleRoleChangeDenied = useCallback39((request) => {
    ToastManager.addToast({
      title: `${request.peerName} denied your request to join the ${request.role.name} role`,
      variant: "error"
    });
  }, []);
  useCustomEvent4({ type: ROLE_CHANGE_DECLINED, onEvent: handleRoleChangeDenied });
  if (isNotificationDisabled) {
    return null;
  }
  return /* @__PURE__ */ React195.createElement(React195.Fragment, null, /* @__PURE__ */ React195.createElement(TrackUnmuteModal, null), /* @__PURE__ */ React195.createElement(TrackBulkUnmuteModal, null), /* @__PURE__ */ React195.createElement(TrackNotifications, null), roomState === HMSRoomState11.Connected ? /* @__PURE__ */ React195.createElement(PeerNotifications, null) : null, /* @__PURE__ */ React195.createElement(RoleChangeNotification, null), /* @__PURE__ */ React195.createElement(PollNotificationModal, null), /* @__PURE__ */ React195.createElement(MessageNotifications, null), /* @__PURE__ */ React195.createElement(DeviceChangeNotifications, null), /* @__PURE__ */ React195.createElement(ReconnectNotifications, null), /* @__PURE__ */ React195.createElement(ErrorNotifications, null), /* @__PURE__ */ React195.createElement(AutoplayBlockedModal, null), /* @__PURE__ */ React195.createElement(PermissionErrorNotificationModal, null), /* @__PURE__ */ React195.createElement(InitErrorModal, null), /* @__PURE__ */ React195.createElement(ChatNotifications, null), /* @__PURE__ */ React195.createElement(HandRaisedNotifications, null), /* @__PURE__ */ React195.createElement(TranscriptionNotifications, null), /* @__PURE__ */ React195.createElement(DeviceInUseError, null));
}

// src/Prebuilt/components/PIP/PIPProvider.tsx
init_define_process_env();
import React196, { useCallback as useCallback40, useMemo as useMemo22, useState as useState83 } from "react";
var PIPProvider = ({ children }) => {
  const isSupported = "documentPictureInPicture" in window;
  const [pipWindow, setPipWindow] = useState83(null);
  const closePipWindow = useCallback40(() => {
    if (pipWindow != null) {
      pipWindow.close();
      setPipWindow(null);
    }
  }, [pipWindow]);
  const requestPipWindow = useCallback40(
    (width, height) => __async(void 0, null, function* () {
      if (pipWindow != null) {
        return;
      }
      const pip = yield window.documentPictureInPicture.requestWindow({
        width,
        height
      });
      pip.addEventListener("pagehide", () => {
        setPipWindow(null);
      });
      setPipWindow(pip);
    }),
    [pipWindow]
  );
  const value = useMemo22(() => {
    return {
      isSupported,
      pipWindow,
      requestPipWindow,
      closePipWindow
    };
  }, [closePipWindow, isSupported, pipWindow, requestPipWindow]);
  return /* @__PURE__ */ React196.createElement(PIPContext.Provider, { value }, children);
};

// src/Prebuilt/components/Preview/PreviewScreen.tsx
init_define_process_env();
import React197 from "react";
import { useSearchParam } from "react-use";
var PreviewScreen = () => {
  var _a8, _b7, _c;
  const { isPreviewScreenEnabled } = useRoomLayoutPreviewScreen();
  const skipPreview = !isPreviewScreenEnabled;
  const previewAsRole = useSearchParam(QUERY_PARAM_PREVIEW_AS_ROLE);
  const { userName } = useHMSPrebuiltContext();
  const initialName = userName || (skipPreview ? "Beam" : "");
  const authToken = useAuthToken();
  const roomLayout = useRoomLayout();
  const { preview_header: previewHeader = {} } = ((_c = (_b7 = (_a8 = roomLayout == null ? void 0 : roomLayout.screens) == null ? void 0 : _a8.preview) == null ? void 0 : _b7.default) == null ? void 0 : _c.elements) || {};
  return /* @__PURE__ */ React197.createElement(Flex, { direction: "column", css: { size: "100%" } }, /* @__PURE__ */ React197.createElement(
    Flex,
    {
      css: { flex: "1 1 0", position: "relative", overflowY: "auto", color: "$primary_default" },
      justify: "center",
      align: "center"
    },
    authToken && Object.keys(previewHeader).length > 0 ? /* @__PURE__ */ React197.createElement(PreviewJoin_default, { initialName, skipPreview, asRole: previewAsRole != null ? previewAsRole : void 0 }) : /* @__PURE__ */ React197.createElement(FullPageProgress_default, null)
  ));
};

// src/Prebuilt/components/Toast/ToastContainer.jsx
init_define_process_env();
import React199, { useEffect as useEffect85, useState as useState84 } from "react";
import { selectIsConnectedToRoom as selectIsConnectedToRoom11, useHMSStore as useHMSStore95 } from "@100mslive/react-sdk";

// src/Prebuilt/components/Toast/Toast.jsx
init_define_process_env();
import React198 from "react";
var Toast2 = (_a8) => {
  var _b7 = _a8, { title, description, close = true, open, duration, onOpenChange, icon } = _b7, props = __objRest(_b7, ["title", "description", "close", "open", "duration", "onOpenChange", "icon"]);
  return /* @__PURE__ */ React198.createElement(
    Toast.HMSToast,
    __spreadValues({
      title,
      description,
      open,
      isClosable: close,
      onOpenChange,
      duration: !close ? 6e5 : duration,
      icon
    }, props)
  );
};

// src/Prebuilt/components/Toast/ToastContainer.jsx
var ToastContainer = () => {
  const isConnected = useHMSStore95(selectIsConnectedToRoom11);
  const [toasts, setToast] = useState84([]);
  useEffect85(() => {
    ToastManager.addListener(setToast);
    return () => {
      ToastManager.removeListener(setToast);
    };
  }, []);
  return /* @__PURE__ */ React199.createElement(Toast.Provider, { swipeDirection: "left", duration: 3e3 }, toasts.slice(0, MAX_TOASTS).map((toast) => {
    return /* @__PURE__ */ React199.createElement(Toast2, __spreadProps(__spreadValues({ key: toast.id }, toast), { onOpenChange: (value) => !value && ToastManager.removeToast(toast.id) }));
  }), /* @__PURE__ */ React199.createElement(
    Toast.Viewport,
    {
      css: __spreadValues({
        position: "absolute"
      }, !isConnected ? {} : { bottom: "$24" })
    }
  ));
};

// src/Prebuilt/layouts/Sheet.tsx
init_define_process_env();
import React201 from "react";
import { selectAppData as selectAppData14, useHMSStore as useHMSStore96 } from "@100mslive/react-sdk";

// src/Prebuilt/components/RoomDetails/RoomDetailsSheet.tsx
init_define_process_env();
import React200 from "react";
import { CrossIcon as CrossIcon32 } from "@100mslive/react-icons";
var RoomDetailsSheet = () => {
  const { title, description, details } = useRoomLayoutHeader();
  const toggleSheet = useSheetToggle(SHEET_OPTIONS.ROOM_DETAILS);
  const showRoomDetailsSheet = useIsSheetTypeOpen(SHEET_OPTIONS.ROOM_DETAILS);
  return /* @__PURE__ */ React200.createElement(Sheet.Root, { open: showRoomDetailsSheet, onOpenChange: toggleSheet }, /* @__PURE__ */ React200.createElement(Sheet.Content, { css: { py: "$8", pb: "$12" } }, /* @__PURE__ */ React200.createElement(
    Flex,
    {
      justify: "between",
      align: "center",
      css: { w: "100%", borderBottom: "1px solid $border_bright", pb: "$4", mb: "$4", px: "$8" }
    },
    /* @__PURE__ */ React200.createElement(Text, { css: { fontWeight: "$semiBold", color: "$on_surface_high" } }, "Description"),
    /* @__PURE__ */ React200.createElement(Sheet.Close, { css: { color: "$on_surface_high" } }, /* @__PURE__ */ React200.createElement(CrossIcon32, null))
  ), /* @__PURE__ */ React200.createElement(Flex, { align: "center", css: { w: "100%", gap: "$4", pb: "$8", px: "$8" } }, /* @__PURE__ */ React200.createElement(Logo, null), /* @__PURE__ */ React200.createElement(Box, null, /* @__PURE__ */ React200.createElement(Text, { variant: "sm", css: { c: "$on_secondary_high", fontWeight: "$semiBold" } }, title), /* @__PURE__ */ React200.createElement(RoomDetailsRow, { details }))), /* @__PURE__ */ React200.createElement(Text, { variant: "sm", css: { color: "$on_surface_medium", px: "$8" } }, description)));
};

// src/Prebuilt/layouts/Sheet.tsx
var Sheet2 = () => {
  const sheet = useHMSStore96(selectAppData14(APP_DATA.sheet));
  let ViewComponent;
  if (sheet === SHEET_OPTIONS.ROOM_DETAILS) {
    ViewComponent = /* @__PURE__ */ React201.createElement(RoomDetailsSheet, null);
  }
  return /* @__PURE__ */ React201.createElement(Box, null, ViewComponent);
};

// src/Prebuilt/plugins/FlyingEmoji.jsx
init_define_process_env();
import React202, { useCallback as useCallback41, useEffect as useEffect86, useMemo as useMemo23, useState as useState85 } from "react";
import { useMedia as useMedia50 } from "react-use";
import {
  selectIsLargeRoom as selectIsLargeRoom4,
  selectLocalPeerID as selectLocalPeerID16,
  selectPeerNameByID as selectPeerNameByID9,
  useCustomEvent as useCustomEvent5,
  useHMSActions as useHMSActions57,
  useHMSStore as useHMSStore97,
  useHMSVanillaStore as useHMSVanillaStore19
} from "@100mslive/react-sdk";
var emojiCount = 1;
var flyAndFade = keyframes({
  "20%": { opacity: 1 },
  "100%": { bottom: "60%", opacity: 0 }
});
var wiggleLeftRight = keyframes({
  "0%": { marginLeft: "-50px" },
  "100%": { marginLeft: "50px" }
});
var wiggleRightLeft = keyframes({
  "0%": { marginLeft: "50px" },
  "100%": { marginLeft: "-50px" }
});
var getStartingPoints = (isMobile) => {
  let arr = [];
  const min = 5;
  const max = isMobile ? 30 : 20;
  const inc = isMobile ? 8 : 5;
  for (let i = min; i <= max; i += inc) {
    arr.push(i);
  }
  return arr;
};
function FlyingEmoji() {
  const localPeerId = useHMSStore97(selectLocalPeerID16);
  const vanillaStore = useHMSVanillaStore19();
  const hmsActions = useHMSActions57();
  const [emojis, setEmojis] = useState85([]);
  const isMobile = useMedia50(config.media.md);
  const isLargeRoom = useHMSStore97(selectIsLargeRoom4);
  const startingPoints = useMemo23(() => getStartingPoints(isMobile), [isMobile]);
  const showFlyingEmoji = useCallback41(
    (_0) => __async(this, [_0], function* ({ emojiId, senderId }) {
      if (!emojiId || !senderId || document.hidden) {
        return;
      }
      let senderPeerName = vanillaStore.getState(selectPeerNameByID9(senderId));
      if (!senderPeerName && isLargeRoom) {
        const sender = yield hmsActions.getPeer(senderId);
        senderPeerName = sender == null ? void 0 : sender.name;
      }
      const nameToShow = localPeerId === senderId ? "You" : senderPeerName;
      const startingPoint = startingPoints[emojiCount % startingPoints.length];
      const id = emojiCount++;
      setEmojis((emojis2) => {
        return [
          ...emojis2,
          {
            id,
            emojiId,
            senderName: nameToShow,
            startingPoint: `${startingPoint}%`,
            wiggleType: Math.random() < 0.5 ? 0 : 1
          }
        ];
      });
    }),
    [vanillaStore, isLargeRoom, localPeerId, startingPoints, hmsActions]
  );
  useCustomEvent5({
    type: EMOJI_REACTION_TYPE,
    onEvent: showFlyingEmoji
  });
  useEffect86(() => {
    window.showFlyingEmoji = showFlyingEmoji;
  }, [showFlyingEmoji]);
  return /* @__PURE__ */ React202.createElement(
    Box,
    {
      css: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        overflow: "hidden",
        pointerEvents: "none",
        userSelect: "none",
        zIndex: 999
      }
    },
    emojis.map((emoji) => {
      return /* @__PURE__ */ React202.createElement(
        Flex,
        {
          key: emoji.id,
          css: {
            left: emoji.startingPoint,
            flexDirection: "column",
            alignItems: "center",
            position: "absolute",
            bottom: 0,
            animation: `${flyAndFade()} 5s forwards, ${emoji.wiggleType === 0 ? wiggleLeftRight() : wiggleRightLeft()} 1s ease-in-out infinite alternate`
          },
          onAnimationEnd: () => setEmojis(emojis.filter((item) => item.id !== emoji.id))
        },
        /* @__PURE__ */ React202.createElement(Box, null, /* @__PURE__ */ React202.createElement("em-emoji", { id: emoji.emojiId, size: "48px", set: "apple" })),
        emoji.senderName ? /* @__PURE__ */ React202.createElement(
          Box,
          {
            css: {
              width: "fit-content",
              padding: "$2 $4",
              background: "$surface_bright",
              borderRadius: "$1"
            }
          },
          /* @__PURE__ */ React202.createElement(
            Text,
            {
              css: {
                fontSize: "$space$6",
                lineHeight: "$xs",
                color: "$on_surface_high"
              }
            },
            emoji.senderName
          )
        ) : ""
      );
    })
  );
}

// src/Prebuilt/plugins/RemoteStopScreenshare.jsx
init_define_process_env();
import React203, { useCallback as useCallback42 } from "react";
import { useCustomEvent as useCustomEvent6, useHMSActions as useHMSActions58 } from "@100mslive/react-sdk";
function RemoteStopScreenshare() {
  const actions = useHMSActions58();
  const onRemoteStopScreenshare = useCallback42(() => __async(this, null, function* () {
    yield actions.setScreenShareEnabled(false);
  }), [actions]);
  useCustomEvent6({
    type: REMOTE_STOP_SCREENSHARE_TYPE,
    onEvent: onRemoteStopScreenshare
  });
  return /* @__PURE__ */ React203.createElement(React203.Fragment, null);
}

// src/Prebuilt/components/hooks/useAutoStartStreaming.tsx
init_define_process_env();
import { useCallback as useCallback43, useEffect as useEffect87, useRef as useRef35 } from "react";
import {
  selectIsConnectedToRoom as selectIsConnectedToRoom12,
  selectPermissions as selectPermissions20,
  useHMSActions as useHMSActions59,
  useHMSStore as useHMSStore98,
  useRecordingStreaming as useRecordingStreaming12
} from "@100mslive/react-sdk";
var useAutoStartStreaming = () => {
  const [isHLSStarted, setHLSStarted] = useSetAppDataByKey(APP_DATA.hlsStarted);
  const permissions = useHMSStore98(selectPermissions20);
  const showStreamingUI = useShowStreamingUI();
  const hmsActions = useHMSActions59();
  const isConnected = useHMSStore98(selectIsConnectedToRoom12);
  const { isHLSRunning, isRTMPRunning, isHLSRecordingOn, isBrowserRecordingOn } = useRecordingStreaming12();
  const streamStartedRef = useRef35(false);
  const startHLS = useCallback43(() => __async(void 0, null, function* () {
    try {
      if (isHLSStarted || !showStreamingUI || isHLSRunning || isRTMPRunning || isHLSRecordingOn || isBrowserRecordingOn) {
        return;
      }
      setHLSStarted(true);
      streamStartedRef.current = true;
      yield hmsActions.startHLSStreaming();
    } catch (error) {
      console.error(error);
      streamStartedRef.current = false;
      setHLSStarted(false);
    }
  }), [
    hmsActions,
    isHLSRunning,
    isHLSStarted,
    setHLSStarted,
    showStreamingUI,
    isRTMPRunning,
    isHLSRecordingOn,
    isBrowserRecordingOn
  ]);
  useEffect87(() => {
    if (!isHLSStarted && !isHLSRunning) {
      streamStartedRef.current = false;
    }
  }, [isHLSStarted, isHLSRunning]);
  useEffect87(() => {
    if (!isConnected || streamStartedRef.current || !(permissions == null ? void 0 : permissions.hlsStreaming)) {
      return;
    }
    startHLS();
  }, [isConnected]);
};

// src/Prebuilt/App.tsx
var HMSPrebuilt = React204.forwardRef(
  ({
    roomCode = "",
    authToken = "",
    containerSelector = DEFAULT_PORTAL_CONTAINER,
    logo,
    typography,
    themes,
    options: { userName = "", userId = "", endpoints } = {},
    screens,
    leaveOnUnload = true,
    onLeave,
    onJoin
  }, ref) => {
    var _a8, _b7, _c, _d;
    const reactiveStore = useRef36();
    const [hydrated, setHydrated] = React204.useState(false);
    useEffect88(() => {
      setHydrated(true);
      const hms = new HMSReactiveStore();
      const hmsStore = hms.getStore();
      const hmsActions = hms.getActions();
      const hmsNotifications = hms.getNotifications();
      const hmsStats = hms.getStats();
      hms.triggerOnSubscribe();
      reactiveStore.current = {
        hmsActions,
        hmsStats,
        hmsStore,
        hmsNotifications
      };
    }, []);
    useEffect88(() => {
      if (!ref || !reactiveStore.current) {
        return;
      }
      ref.current = __spreadValues({}, reactiveStore.current);
    }, [ref]);
    useEffect88(() => {
      return () => {
        var _a9;
        (_a9 = reactiveStore == null ? void 0 : reactiveStore.current) == null ? void 0 : _a9.hmsActions.leave();
      };
    }, []);
    const endpointsObj = endpoints;
    const tokenByRoomCodeEndpoint = endpointsObj == null ? void 0 : endpointsObj.tokenByRoomCode;
    const initEndpoint = endpointsObj == null ? void 0 : endpointsObj.init;
    const eventEndpoint = endpointsObj == null ? void 0 : endpointsObj.event;
    const roomLayoutEndpoint = endpointsObj == null ? void 0 : endpointsObj.roomLayout;
    const overrideLayout = {
      logo,
      themes,
      typography,
      screens
    };
    if (!roomCode && !authToken) {
      console.error(`
          HMSPrebuilt can be initialised by providing: 
          either "roomCode" or "authToken".
          Please check if you are providing the above values for initialising prebuilt.
        `);
      throw Error("Incorrect initializing params for HMSPrebuilt component");
    }
    if (!hydrated) {
      return null;
    }
    globalStyles();
    return /* @__PURE__ */ React204.createElement(ErrorBoundary, null, /* @__PURE__ */ React204.createElement(
      HMSPrebuiltContext.Provider,
      {
        value: {
          roomCode,
          containerSelector,
          onLeave,
          onJoin,
          userName,
          userId,
          endpoints: {
            tokenByRoomCode: tokenByRoomCodeEndpoint,
            init: initEndpoint,
            roomLayout: roomLayoutEndpoint,
            event: eventEndpoint
          }
        }
      },
      /* @__PURE__ */ React204.createElement(
        HMSRoomProvider,
        {
          isHMSStatsOn: FeatureFlags.enableStatsForNerds,
          actions: (_a8 = reactiveStore.current) == null ? void 0 : _a8.hmsActions,
          store: (_b7 = reactiveStore.current) == null ? void 0 : _b7.hmsStore,
          notifications: (_c = reactiveStore.current) == null ? void 0 : _c.hmsNotifications,
          stats: (_d = reactiveStore.current) == null ? void 0 : _d.hmsStats,
          leaveOnUnload
        },
        /* @__PURE__ */ React204.createElement(RoomLayoutProvider, { roomLayoutEndpoint, overrideLayout }, /* @__PURE__ */ React204.createElement(RoomLayoutContext.Consumer, null, (data3) => {
          var _a9;
          const layout = data3 == null ? void 0 : data3.layout;
          const theme2 = ((_a9 = layout == null ? void 0 : layout.themes) == null ? void 0 : _a9[0]) || {};
          const { typography: typography2 } = layout || {};
          let fontFamily = ["sans-serif"];
          if (typography2 == null ? void 0 : typography2.font_family) {
            fontFamily = [`${typography2 == null ? void 0 : typography2.font_family}`, ...fontFamily];
          }
          return /* @__PURE__ */ React204.createElement(
            HMSThemeProvider,
            {
              themeType: `${theme2.name}-${Date.now()}`,
              theme: {
                //@ts-ignore: Prebuilt theme to match stitches theme
                colors: theme2.palette,
                fonts: {
                  //@ts-ignore: font list to match token types of stitches
                  sans: fontFamily
                }
              }
            },
            /* @__PURE__ */ React204.createElement(PIPProvider, null, /* @__PURE__ */ React204.createElement(Init, null), /* @__PURE__ */ React204.createElement(DialogContainerProvider, { dialogContainerSelector: containerSelector }, /* @__PURE__ */ React204.createElement(
              Box,
              {
                className: DEFAULT_PORTAL_CONTAINER.slice(1),
                css: {
                  bg: "$background_dim",
                  size: "100%",
                  lineHeight: "1.5",
                  "-webkit-text-size-adjust": "100%",
                  position: "relative"
                }
              },
              /* @__PURE__ */ React204.createElement(
                AppRoutes,
                {
                  authTokenByRoomCodeEndpoint: tokenByRoomCodeEndpoint,
                  defaultAuthToken: authToken
                }
              )
            )))
          );
        }))
      )
    ));
  }
);
HMSPrebuilt.displayName = "HMSPrebuilt";
var AppStates = ({ activeState }) => {
  const { isPreviewScreenEnabled } = useRoomLayoutPreviewScreen();
  const { isLeaveScreenEnabled } = useRoomLayoutLeaveScreen();
  useAutoStartStreaming();
  return match17({ activeState, isPreviewScreenEnabled, isLeaveScreenEnabled }).with({ activeState: "preview" /* PREVIEW */, isPreviewScreenEnabled: true }, () => /* @__PURE__ */ React204.createElement(PreviewScreen, null)).with({ activeState: "leave" /* LEAVE */, isLeaveScreenEnabled: true }, () => /* @__PURE__ */ React204.createElement(LeaveScreen, null)).otherwise(() => /* @__PURE__ */ React204.createElement(ConferenceScreen, null));
};
var BackSwipe = () => {
  const isConnectedToRoom = useHMSStore99(selectIsConnectedToRoom13);
  const hmsActions = useHMSActions60();
  useEffect88(() => {
    const onRouteLeave = () => __async(void 0, null, function* () {
      if (isConnectedToRoom) {
        yield hmsActions.leave();
      }
    });
    window.addEventListener("popstate", onRouteLeave);
    return () => {
      window.removeEventListener("popstate", onRouteLeave);
    };
  }, [hmsActions, isConnectedToRoom]);
  return null;
};
function AppRoutes({
  authTokenByRoomCodeEndpoint,
  defaultAuthToken
}) {
  const roomLayout = useRoomLayout();
  const isNotificationsDisabled = useIsNotificationDisabled();
  const { activeState, rejoin } = useAppStateManager();
  return /* @__PURE__ */ React204.createElement(AppStateContext.Provider, { value: { rejoin } }, /* @__PURE__ */ React204.createElement(React204.Fragment, null, activeState !== "leave" /* LEAVE */ && /* @__PURE__ */ React204.createElement(AppData, null), /* @__PURE__ */ React204.createElement(ToastContainer, null), /* @__PURE__ */ React204.createElement(Notifications, null), /* @__PURE__ */ React204.createElement(MwebLandscapePrompt, null), /* @__PURE__ */ React204.createElement(Sheet2, null), /* @__PURE__ */ React204.createElement(BackSwipe, null), !isNotificationsDisabled && /* @__PURE__ */ React204.createElement(FlyingEmoji, null), /* @__PURE__ */ React204.createElement(RemoteStopScreenshare, null), /* @__PURE__ */ React204.createElement(KeyboardHandler, null), /* @__PURE__ */ React204.createElement(
    AuthToken_default,
    {
      authTokenByRoomCodeEndpoint,
      defaultAuthToken,
      activeState
    }
  ), roomLayout && activeState && /* @__PURE__ */ React204.createElement(AppStates, { activeState })));
}

// src/Progress/index.tsx
init_define_process_env();
import { Indicator as Indicator3, Root as Root27 } from "@radix-ui/react-progress";
var StyledIndicator = styled(Indicator3, { h: "$4", backgroundColor: "$primary_default" });
var StyledRoot2 = styled(Root27, {
  w: "100%",
  h: "$4",
  borderRadius: "$round",
  backgroundColor: "$secondary_dim",
  overflow: "hidden"
});
var Progress = {
  Root: StyledRoot2,
  Content: StyledIndicator
};

// src/Diagnostics/index.ts
init_define_process_env();

// src/Diagnostics/Diagnostics.tsx
init_define_process_env();
import React212, { useCallback as useCallback45, useRef as useRef38, useState as useState91 } from "react";
import { HMSRoomProvider as HMSRoomProvider2, useHMSActions as useHMSActions62 } from "@100mslive/react-sdk";
import {
  CheckCircleIcon as CheckCircleIcon7,
  ConnectivityIcon as ConnectivityIcon2,
  CrossCircleIcon as CrossCircleIcon5,
  GlobeIcon,
  MicOnIcon as MicOnIcon8,
  VideoOnIcon as VideoOnIcon6
} from "@100mslive/react-icons";

// src/Diagnostics/AudioTest.tsx
init_define_process_env();
import React208, { useCallback as useCallback44, useEffect as useEffect89, useState as useState87 } from "react";
import {
  selectDevices,
  selectLocalAudioTrackID as selectLocalAudioTrackID2,
  selectLocalMediaSettings,
  selectTrackAudioByID as selectTrackAudioByID2,
  useHMSActions as useHMSActions61,
  useHMSStore as useHMSStore100
} from "@100mslive/react-sdk";
import { MicOnIcon as MicOnIcon7, SpeakerIcon as SpeakerIcon5, StopIcon as StopIcon3 } from "@100mslive/react-icons";

// src/Diagnostics/components.tsx
init_define_process_env();
import React206 from "react";

// src/Diagnostics/DiagnosticsContext.ts
init_define_process_env();
import React205, { useContext as useContext7 } from "react";
var DiagnosticsStep = /* @__PURE__ */ ((DiagnosticsStep2) => {
  DiagnosticsStep2[DiagnosticsStep2["BROWSER"] = 0] = "BROWSER";
  DiagnosticsStep2[DiagnosticsStep2["VIDEO"] = 1] = "VIDEO";
  DiagnosticsStep2[DiagnosticsStep2["AUDIO"] = 2] = "AUDIO";
  DiagnosticsStep2[DiagnosticsStep2["CONNECTIVITY"] = 3] = "CONNECTIVITY";
  return DiagnosticsStep2;
})(DiagnosticsStep || {});
var initialSteps = {
  [0 /* BROWSER */]: { name: "Browser Support" },
  [1 /* VIDEO */]: { name: "Test Video" },
  [2 /* AUDIO */]: { name: "Test Audio" },
  [3 /* CONNECTIVITY */]: { name: "Connection Quality" }
};
var DiagnosticsContext = React205.createContext({
  activeStepIndex: 0,
  setActiveStep: () => {
    return;
  },
  steps: initialSteps,
  updateStep: () => {
    return;
  }
});
var useDiagnostics = () => {
  const context = useContext7(DiagnosticsContext);
  const activeStep = context.steps[context.activeStepIndex];
  return __spreadProps(__spreadValues({}, context), { activeStep });
};

// src/Diagnostics/components.tsx
var TestContainer = ({ css: css2, children }) => {
  return /* @__PURE__ */ React206.createElement(Box, { css: __spreadValues({ p: "$10" }, css2) }, children);
};
var TestFooter = ({
  error,
  ctaText,
  children
}) => {
  const { hmsDiagnostics, activeStepIndex: activeStep, setActiveStep } = useDiagnostics();
  const onNextStep = () => {
    if (activeStep === 2 /* AUDIO */) {
      hmsDiagnostics == null ? void 0 : hmsDiagnostics.stopMicCheck();
    } else if (activeStep === 1 /* VIDEO */) {
      hmsDiagnostics == null ? void 0 : hmsDiagnostics.stopCameraCheck();
    } else if (activeStep === 3 /* CONNECTIVITY */) {
      hmsDiagnostics == null ? void 0 : hmsDiagnostics.stopConnectivityCheck();
    }
    setActiveStep((step) => step + 1);
  };
  return /* @__PURE__ */ React206.createElement(
    Flex,
    {
      css: {
        py: "$8",
        px: "$10",
        background: "$background_dim",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: "1px solid $border_default",
        fontSize: "$sm",
        borderBottomLeftRadius: "$1",
        borderBottomRightRadius: "$1",
        lineHeight: "$sm",
        zIndex: 1001,
        "@lg": { flexDirection: "column", gap: "$8" }
      }
    },
    /* @__PURE__ */ React206.createElement(Box, null, error && /* @__PURE__ */ React206.createElement(Text, { css: { c: "$alert_error_default" } }, "Error: ", error.message)),
    children ? children : /* @__PURE__ */ React206.createElement(Flex, { align: "center", css: { gap: "$8", "@lg": { flexDirection: "column" } } }, /* @__PURE__ */ React206.createElement(Text, { css: { c: "$on_primary_medium" } }, ctaText), /* @__PURE__ */ React206.createElement(Flex, { align: "center", gap: "4" }, /* @__PURE__ */ React206.createElement(Button, { onClick: onNextStep, variant: "standard", outlined: true }, "Skip"), /* @__PURE__ */ React206.createElement(Button, { disabled: !!error, onClick: onNextStep }, "Yes")))
  );
};

// src/Diagnostics/DeviceSelector.jsx
init_define_process_env();
var import_prop_types = __toESM(require_prop_types());
import React207, { useRef as useRef37, useState as useState86 } from "react";
var DeviceSelector2 = ({ title, devices, selection, onChange, icon, children = null }) => {
  var _a8, _b7;
  const [open, setOpen] = useState86(false);
  const ref = useRef37(null);
  return /* @__PURE__ */ React207.createElement(Box, { css: { mb: "$6" } }, /* @__PURE__ */ React207.createElement(Text, { css: { mb: "$4" } }, title), /* @__PURE__ */ React207.createElement(
    Flex,
    {
      align: "center",
      css: {
        gap: "$4",
        "@md": {
          flexDirection: children ? "column" : "row",
          alignItems: children ? "start" : "center"
        }
      }
    },
    /* @__PURE__ */ React207.createElement(Dropdown.Root, { open, onOpenChange: setOpen }, /* @__PURE__ */ React207.createElement(
      DialogDropdownTrigger,
      {
        ref,
        icon,
        title: ((_a8 = devices.find(({ deviceId }) => deviceId === selection)) == null ? void 0 : _a8.label) || "Select device from list",
        open
      }
    ), /* @__PURE__ */ React207.createElement(Dropdown.Portal, null, /* @__PURE__ */ React207.createElement(
      Dropdown.Content,
      {
        align: "start",
        sideOffset: 8,
        css: {
          w: (
            // @ts-ignore
            (_b7 = ref.current) == null ? void 0 : _b7.clientWidth
          ),
          zIndex: 1001
        }
      },
      devices.map((device) => {
        return /* @__PURE__ */ React207.createElement(
          Dropdown.Item,
          {
            key: device.label,
            onSelect: () => onChange(device.deviceId),
            css: {
              px: "$9"
            }
          },
          device.label
        );
      })
    ))),
    children
  ));
};
DeviceSelector2.propTypes = {
  title: import_prop_types.default.string.isRequired,
  devices: import_prop_types.default.array.isRequired,
  selection: import_prop_types.default.string,
  onChange: import_prop_types.default.func.isRequired,
  icon: import_prop_types.default.node,
  children: import_prop_types.default.node
};

// src/Diagnostics/AudioTest.tsx
var SelectContainer = ({ children }) => /* @__PURE__ */ React208.createElement(Box, { css: { w: "calc(50% - 0.75rem)", "@lg": { w: "100%" } } }, children);
var MicTest = ({ setError }) => {
  var _a8, _b7;
  const { hmsDiagnostics } = useDiagnostics();
  const devices = useHMSStore100(selectDevices);
  const [isRecording, setIsRecording] = useState87(false);
  const [selectedMic, setSelectedMic] = useState87(((_a8 = devices.audioInput[0]) == null ? void 0 : _a8.deviceId) || "default");
  const trackID = useHMSStore100(selectLocalAudioTrackID2);
  const audioLevel = useHMSStore100(selectTrackAudioByID2(trackID));
  const { audioOutputDeviceId } = useHMSStore100(selectLocalMediaSettings);
  const { playing, setPlaying, audioRef } = useAudioOutputTest({
    deviceId: audioOutputDeviceId || ((_b7 = devices.audioOutput[0]) == null ? void 0 : _b7.deviceId)
  });
  return /* @__PURE__ */ React208.createElement(SelectContainer, null, /* @__PURE__ */ React208.createElement(
    DeviceSelector2,
    {
      title: "Microphone (Input)",
      devices: devices.audioInput,
      selection: selectedMic,
      icon: /* @__PURE__ */ React208.createElement(MicOnIcon7, null),
      onChange: (deviceId) => {
        setError(void 0);
        setSelectedMic(deviceId);
        hmsDiagnostics == null ? void 0 : hmsDiagnostics.stopMicCheck();
      }
    }
  ), /* @__PURE__ */ React208.createElement(Flex, { css: { gap: "$6", alignItems: "center" } }, /* @__PURE__ */ React208.createElement(
    Button,
    {
      variant: "standard",
      icon: true,
      onClick: () => {
        isRecording ? hmsDiagnostics == null ? void 0 : hmsDiagnostics.stopMicCheck() : hmsDiagnostics == null ? void 0 : hmsDiagnostics.startMicCheck({
          inputDevice: selectedMic,
          onError: (err) => {
            setError(err);
          },
          onStop: () => {
            setIsRecording(false);
          }
        }).then(() => {
          setIsRecording(true);
        });
      },
      disabled: devices.audioInput.length === 0 || playing
    },
    isRecording ? /* @__PURE__ */ React208.createElement(StopIcon3, null) : /* @__PURE__ */ React208.createElement(MicOnIcon7, null),
    isRecording ? "Stop Recording" : "Record"
  ), /* @__PURE__ */ React208.createElement(
    Button,
    {
      icon: true,
      variant: "standard",
      outlined: (hmsDiagnostics == null ? void 0 : hmsDiagnostics.getRecordedAudio()) === TEST_AUDIO_URL,
      onClick: () => {
        if (audioRef.current) {
          audioRef.current.src = (hmsDiagnostics == null ? void 0 : hmsDiagnostics.getRecordedAudio()) || "";
          audioRef.current.play();
        }
      },
      disabled: playing || (hmsDiagnostics == null ? void 0 : hmsDiagnostics.getRecordedAudio()) === TEST_AUDIO_URL
    },
    /* @__PURE__ */ React208.createElement(SpeakerIcon5, null),
    playing ? "Playing..." : "Playback"
  ), /* @__PURE__ */ React208.createElement(
    "audio",
    {
      ref: audioRef,
      onEnded: () => setPlaying(false),
      onPlay: () => setPlaying(true),
      style: { display: "none" }
    }
  )), /* @__PURE__ */ React208.createElement(Flex, { align: "center", css: { mt: "$4", maxWidth: "10rem", opacity: isRecording ? "1" : "0", gap: "$4" } }, /* @__PURE__ */ React208.createElement(Text, null, /* @__PURE__ */ React208.createElement(MicOnIcon7, null)), /* @__PURE__ */ React208.createElement(Progress.Root, { value: audioLevel, css: { h: "$2" } }, /* @__PURE__ */ React208.createElement(
    Progress.Content,
    {
      style: {
        transform: `translateX(-${100 - audioLevel}%)`,
        transition: "transform 0.3s"
      }
    }
  ))));
};
var SpeakerTest = () => {
  var _a8;
  const actions = useHMSActions61();
  const devices = useHMSStore100(selectDevices);
  const { audioOutputDeviceId } = useHMSStore100(selectLocalMediaSettings);
  if (devices.audioOutput.length === 0) {
    return /* @__PURE__ */ React208.createElement(React208.Fragment, null);
  }
  return /* @__PURE__ */ React208.createElement(SelectContainer, null, /* @__PURE__ */ React208.createElement(
    DeviceSelector2,
    {
      title: "Speaker (Output)",
      devices: devices.audioOutput,
      selection: audioOutputDeviceId || ((_a8 = devices.audioOutput[0]) == null ? void 0 : _a8.deviceId),
      icon: /* @__PURE__ */ React208.createElement(SpeakerIcon5, null),
      onChange: (deviceId) => {
        actions.setAudioOutputDevice(deviceId);
      }
    }
  ));
};
var AudioTest = () => {
  const { hmsDiagnostics, updateStep } = useDiagnostics();
  const [error, setErrorAlone] = useState87();
  const setError = useCallback44(
    (err) => {
      updateStep(2 /* AUDIO */, { hasFailed: !!err });
      setErrorAlone(err);
    },
    [updateStep, setErrorAlone]
  );
  useEffect89(() => {
    hmsDiagnostics == null ? void 0 : hmsDiagnostics.requestPermission({ audio: true }).catch((error2) => setError(error2));
  }, [hmsDiagnostics, setError]);
  return /* @__PURE__ */ React208.createElement(React208.Fragment, null, /* @__PURE__ */ React208.createElement(TestContainer, null, /* @__PURE__ */ React208.createElement(Text, { variant: "body2", css: { c: "$on_primary_medium" } }, "Record a 10 second audio clip and play it back to check that your microphone and speaker are working. If they aren't, make sure your volume is turned up, try a different speaker or microphone, or check your bluetooth settings."), /* @__PURE__ */ React208.createElement(
    Flex,
    {
      css: {
        mt: "$10",
        gap: "$10",
        "@lg": {
          flexDirection: "column",
          gap: "$8"
        }
      }
    },
    /* @__PURE__ */ React208.createElement(MicTest, { setError }),
    /* @__PURE__ */ React208.createElement(SpeakerTest, null)
  )), /* @__PURE__ */ React208.createElement(TestFooter, { error, ctaText: "Does your audio sound good?" }), /* @__PURE__ */ React208.createElement(PermissionErrorModal, { error }));
};

// src/Diagnostics/BrowserTest.tsx
init_define_process_env();
import React209, { useEffect as useEffect90, useState as useState88 } from "react";
import { parsedUserAgent as parsedUserAgent4 } from "@100mslive/react-sdk";
var CMS_MEDIA_SERVER = "https://storage.googleapis.com/100ms-cms-prod/";
var operatingSystemIconInfo = {
  tizen: {
    key: "tizen",
    val: "Tizen",
    icon: `${CMS_MEDIA_SERVER}cms/Tizen_b99350214e/Tizen_b99350214e.svg`
  },
  "mac os": {
    key: "macos",
    val: "Mac OS",
    icon: `${CMS_MEDIA_SERVER}cms/mac_OS_804456afd8/mac_OS_804456afd8.png`
  },
  windows: {
    key: "windows",
    val: "Windows",
    icon: `${CMS_MEDIA_SERVER}cms/Windows_fdfe6749b6/Windows_fdfe6749b6.svg`
  },
  linux: {
    key: "linux",
    val: "Linux",
    icon: `${CMS_MEDIA_SERVER}cms/Linux_31f8353a2e/Linux_31f8353a2e.svg`
  },
  chromium: {
    key: "chromium",
    val: "Chromium",
    icon: `${CMS_MEDIA_SERVER}cms/Chromium_3df17710bd/Chromium_3df17710bd.svg`
  },
  ubuntu: {
    key: "ubuntu",
    val: "Ubuntu",
    icon: `${CMS_MEDIA_SERVER}cms/Ubuntu_966dd923c5/Ubuntu_966dd923c5.svg`
  },
  ios: {
    key: "ios",
    val: "iOS",
    icon: `${CMS_MEDIA_SERVER}cms/i_OS_3cdc9d9b71/i_OS_3cdc9d9b71.svg`
  },
  android: {
    key: "android",
    val: "Android",
    icon: `${CMS_MEDIA_SERVER}cms/Android_49dcfdc934/Android_49dcfdc934.svg`
  }
};
var browserTypeIconInfo = {
  brave: {
    key: "brave",
    val: "Brave",
    icon: `${CMS_MEDIA_SERVER}cms/Brave_7e66131f09/Brave_7e66131f09.svg`
  },
  chrome: {
    key: "chrome",
    val: "Chrome",
    icon: `${CMS_MEDIA_SERVER}cms/Chrome_7bf77fbdd7/Chrome_7bf77fbdd7.svg`
  },
  firefox: {
    key: "firefox",
    val: "Firefox",
    icon: `${CMS_MEDIA_SERVER}cms/Firefox_30f3976fb8/Firefox_30f3976fb8.svg`
  },
  safari: {
    key: "safari",
    val: "Safari",
    icon: `${CMS_MEDIA_SERVER}cms/Safari_254e74ed94/Safari_254e74ed94.svg`
  },
  "mobile safari": {
    key: "safari",
    val: "Safari",
    icon: `${CMS_MEDIA_SERVER}cms/Safari_254e74ed94/Safari_254e74ed94.svg`
  },
  edge: {
    key: "edge",
    val: "Edge",
    icon: `${CMS_MEDIA_SERVER}cms/Edge_23add4a83f/Edge_23add4a83f.svg`
  },
  opera: {
    key: "opera",
    val: "Opera",
    icon: `${CMS_MEDIA_SERVER}cms/Opera_0f3bf4eb19/Opera_0f3bf4eb19.svg`
  }
};
var CheckDetails = ({ title, value, iconURL }) => /* @__PURE__ */ React209.createElement(Box, { css: { w: "100%", my: "$10", p: "$10", r: "$1", bg: "$surface_default", "@lg": { w: "auto" } } }, /* @__PURE__ */ React209.createElement(Text, { css: { c: "$on_primary_medium", mb: "$6" } }, title), /* @__PURE__ */ React209.createElement(Flex, { align: "center" }, iconURL && /* @__PURE__ */ React209.createElement(Box, { css: { size: "2rem", r: "$round", bg: "$surface_brighter", mr: "$4" } }, /* @__PURE__ */ React209.createElement("img", { style: { objectFit: "contain", width: "2rem" }, src: iconURL, alt: value })), /* @__PURE__ */ React209.createElement(Text, null, value)));
var BrowserTest = () => {
  var _a8, _b7, _c, _d;
  const { hmsDiagnostics, updateStep } = useDiagnostics();
  const [error, setError] = useState88();
  useEffect90(() => {
    try {
      hmsDiagnostics == null ? void 0 : hmsDiagnostics.checkBrowserSupport();
    } catch (err) {
      updateStep(0 /* BROWSER */, { hasFailed: true });
      setError(err);
    }
  }, [hmsDiagnostics, updateStep]);
  return /* @__PURE__ */ React209.createElement(React209.Fragment, null, /* @__PURE__ */ React209.createElement(TestContainer, { css: { display: "flex", gap: "$8", "@lg": { display: "block" } } }, /* @__PURE__ */ React209.createElement(
    CheckDetails,
    {
      title: "Browser",
      iconURL: parsedUserAgent4.getBrowser().name && ((_b7 = browserTypeIconInfo[(_a8 = parsedUserAgent4.getBrowser().name) == null ? void 0 : _a8.toLowerCase()]) == null ? void 0 : _b7.icon),
      value: `${parsedUserAgent4.getBrowser().name} ${parsedUserAgent4.getBrowser().version}`
    }
  ), /* @__PURE__ */ React209.createElement(
    CheckDetails,
    {
      title: "Operating system",
      iconURL: parsedUserAgent4.getOS().name && ((_d = operatingSystemIconInfo[(_c = parsedUserAgent4.getOS().name) == null ? void 0 : _c.toLowerCase()]) == null ? void 0 : _d.icon),
      value: `${parsedUserAgent4.getOS().name} ${parsedUserAgent4.getOS().version}`
    }
  )), /* @__PURE__ */ React209.createElement(TestFooter, { error, ctaText: "Is your device information correct?" }));
};

// src/Diagnostics/ConnectivityTest.tsx
init_define_process_env();
import React210, { useState as useState89 } from "react";
import { ConnectivityState } from "@100mslive/react-sdk";
import { CheckCircleIcon as CheckCircleIcon6, CrossCircleIcon as CrossCircleIcon4, EyeCloseIcon as EyeCloseIcon3, EyeOpenIcon as EyeOpenIcon2, LinkIcon } from "@100mslive/react-icons";
var Regions = {
  in: "India",
  us: "United States"
};
var ConnectivityStateMessage = {
  [ConnectivityState.STARTING]: "Fetching Init",
  [ConnectivityState.INIT_FETCHED]: "Connecting to signal server",
  [ConnectivityState.SIGNAL_CONNECTED]: "Establishing ICE connection",
  [ConnectivityState.ICE_ESTABLISHED]: "Capturing Media",
  [ConnectivityState.MEDIA_CAPTURED]: "Publishing Media",
  [ConnectivityState.MEDIA_PUBLISHED]: "Finishing Up",
  [ConnectivityState.COMPLETED]: "Completed"
};
var ConnectivityTestStepResult = ({
  title,
  status = "Connected",
  success,
  children
}) => {
  const [hideDetails, setHideDetails] = useState89(true);
  return /* @__PURE__ */ React210.createElement(Box, { css: { my: "$10", p: "$10", r: "$1", bg: "$surface_bright" } }, /* @__PURE__ */ React210.createElement(Text, { css: { c: "$on_primary_medium", mb: "$6" } }, title), success ? /* @__PURE__ */ React210.createElement(Flex, null, /* @__PURE__ */ React210.createElement(Text, { css: { c: "$alert_success" } }, /* @__PURE__ */ React210.createElement(CheckCircleIcon6, { width: "1.5rem", height: "1.5rem" })), /* @__PURE__ */ React210.createElement(Text, { variant: "lg", css: { ml: "$4" } }, status)) : /* @__PURE__ */ React210.createElement(Flex, null, /* @__PURE__ */ React210.createElement(Text, { css: { c: "$alert_error_bright" } }, /* @__PURE__ */ React210.createElement(CrossCircleIcon4, { width: "1.5rem", height: "1.5rem" })), /* @__PURE__ */ React210.createElement(Text, { variant: "lg", css: { ml: "$4" } }, "Failed")), /* @__PURE__ */ React210.createElement(
    Flex,
    {
      onClick: () => setHideDetails(!hideDetails),
      align: "center",
      gap: "2",
      css: {
        color: "$primary_bright"
      }
    },
    hideDetails ? /* @__PURE__ */ React210.createElement(EyeOpenIcon2, null) : /* @__PURE__ */ React210.createElement(EyeCloseIcon3, null),
    /* @__PURE__ */ React210.createElement(
      Text,
      {
        variant: "caption",
        css: {
          color: "$primary_bright"
        }
      },
      hideDetails ? "View" : "Hide",
      " detailed information"
    )
  ), !hideDetails ? /* @__PURE__ */ React210.createElement(Box, null, children) : null);
};
var DetailedInfo = ({
  title,
  value,
  Icon: Icon4
}) => {
  return /* @__PURE__ */ React210.createElement(Box, { css: { flex: "50%", mt: "$6" } }, /* @__PURE__ */ React210.createElement(Text, { variant: "caption", css: { fontWeight: "$semiBold", c: "$on_primary_medium" } }, title), /* @__PURE__ */ React210.createElement(Flex, { css: { mt: "$xs", alignItems: "flex-start" } }, Icon4 && /* @__PURE__ */ React210.createElement(Text, { css: { mr: "$4" } }, /* @__PURE__ */ React210.createElement(Icon4, { width: "1rem", height: "1rem" })), /* @__PURE__ */ React210.createElement(Text, { variant: "caption" }, value)));
};
var MediaServerResult = ({ result }) => {
  var _a8, _b7, _c, _d;
  return /* @__PURE__ */ React210.createElement(
    ConnectivityTestStepResult,
    {
      title: "Media server connection test",
      success: (result == null ? void 0 : result.isPublishICEConnected) && result.isSubscribeICEConnected
    },
    /* @__PURE__ */ React210.createElement(Flex, { css: { flexWrap: "wrap" } }, /* @__PURE__ */ React210.createElement(
      DetailedInfo,
      {
        title: "Media Captured",
        value: ((_a8 = result == null ? void 0 : result.stats) == null ? void 0 : _a8.audio.bytesSent) ? "Yes" : "No",
        Icon: ((_b7 = result == null ? void 0 : result.stats) == null ? void 0 : _b7.audio.bytesSent) ? CheckCircleIcon6 : CrossCircleIcon4
      }
    ), /* @__PURE__ */ React210.createElement(
      DetailedInfo,
      {
        title: "Media Published",
        value: ((_c = result == null ? void 0 : result.stats) == null ? void 0 : _c.audio.bitrateSent) ? "Yes" : "No",
        Icon: ((_d = result == null ? void 0 : result.stats) == null ? void 0 : _d.audio.bytesSent) ? CheckCircleIcon6 : CrossCircleIcon4
      }
    ), (result == null ? void 0 : result.connectionQualityScore) ? /* @__PURE__ */ React210.createElement(
      DetailedInfo,
      {
        title: "Connection Quality Score (CQS)",
        value: `${result.connectionQualityScore.toFixed(2)} (out of 5)`
      }
    ) : null)
  );
};
var SignallingResult = ({ result }) => {
  return /* @__PURE__ */ React210.createElement(ConnectivityTestStepResult, { title: "Signalling server connection test", success: result == null ? void 0 : result.isConnected }, /* @__PURE__ */ React210.createElement(Flex, { css: { flexWrap: "wrap" } }, /* @__PURE__ */ React210.createElement(
    DetailedInfo,
    {
      title: "Signalling Gateway",
      value: (result == null ? void 0 : result.isConnected) ? "Reachable" : "Unreachable",
      Icon: (result == null ? void 0 : result.isConnected) ? CheckCircleIcon6 : CrossCircleIcon4
    }
  ), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Websocket URL", value: (result == null ? void 0 : result.websocketUrl) || "N/A", Icon: LinkIcon })));
};
var AudioStats = ({ stats }) => {
  return /* @__PURE__ */ React210.createElement(ConnectivityTestStepResult, { title: "Audio", status: "Received", success: !!(stats == null ? void 0 : stats.bytesSent) }, stats && /* @__PURE__ */ React210.createElement(Flex, { css: { flexWrap: "wrap" } }, /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bytes Sent", value: formatBytes(stats.bytesSent) }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bytes Received", value: formatBytes(stats.bytesReceived) }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Packets Received", value: stats.packetsReceived.toString() }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Packets Lost", value: stats.packetsLost.toString() }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bitrate Sent", value: formatBytes(stats.bitrateSent, "b/s") }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bitrate Received", value: formatBytes(stats.bitrateReceived, "b/s") }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Round Trip Time", value: `${stats.roundTripTime} ms` }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Jitter", value: `${stats.jitter * 1e3} ms` })));
};
var VideoStats = ({ stats }) => {
  return /* @__PURE__ */ React210.createElement(ConnectivityTestStepResult, { title: "Video", status: "Received", success: !!(stats == null ? void 0 : stats.bytesSent) }, stats && /* @__PURE__ */ React210.createElement(Flex, { css: { flexWrap: "wrap" } }, /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bytes Sent", value: formatBytes(stats.bytesSent) }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bytes Received", value: formatBytes(stats.bytesReceived) }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Packets Received", value: stats.packetsReceived.toString() }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Packets Lost", value: stats.packetsLost.toString() }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bitrate Sent", value: formatBytes(stats.bitrateSent, "b/s") }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Bitrate Received", value: formatBytes(stats.bitrateReceived, "b/s") }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Round Trip Time", value: `${stats.roundTripTime} ms` }), /* @__PURE__ */ React210.createElement(DetailedInfo, { title: "Jitter", value: `${stats.jitter * 1e3} ms` })));
};
var Footer3 = ({
  error,
  result,
  restart
}) => {
  return /* @__PURE__ */ React210.createElement(TestFooter, { error }, /* @__PURE__ */ React210.createElement(Flex, { css: { gap: "$8", "@lg": { flexDirection: "column" } } }, /* @__PURE__ */ React210.createElement(Button, { variant: "standard", onClick: restart }, "Restart Test"), /* @__PURE__ */ React210.createElement(Button, { disabled: !result, onClick: () => result && downloadJson(result, "hms_diagnostics_results") }, "Download Test Report")));
};
var ConnectivityTestReport = ({
  error,
  result,
  progress,
  startTest
}) => {
  var _a8, _b7, _c, _d;
  if (error) {
    return /* @__PURE__ */ React210.createElement(React210.Fragment, null, /* @__PURE__ */ React210.createElement(TestContainer, { css: { textAlign: "center" } }, /* @__PURE__ */ React210.createElement(Text, { css: { c: "$alert_error_default", mb: "$4" } }, /* @__PURE__ */ React210.createElement(CrossCircleIcon4, null)), /* @__PURE__ */ React210.createElement(Text, { variant: "h6" }, "Connectivity Test Failed"), /* @__PURE__ */ React210.createElement(Text, { variant: "body2", css: { c: "$on_primary_medium" } }, error.message)), /* @__PURE__ */ React210.createElement(Footer3, { restart: startTest, error }));
  }
  if (result) {
    console.log(result);
    return /* @__PURE__ */ React210.createElement(React210.Fragment, null, /* @__PURE__ */ React210.createElement(TestContainer, null, /* @__PURE__ */ React210.createElement(Text, { css: { c: "$on_primary_medium" } }, "Connectivity test has been completed."), /* @__PURE__ */ React210.createElement(SignallingResult, { result: result == null ? void 0 : result.signallingReport }), /* @__PURE__ */ React210.createElement(MediaServerResult, { result: result == null ? void 0 : result.mediaServerReport }), /* @__PURE__ */ React210.createElement(AudioStats, { stats: (_b7 = (_a8 = result == null ? void 0 : result.mediaServerReport) == null ? void 0 : _a8.stats) == null ? void 0 : _b7.audio }), /* @__PURE__ */ React210.createElement(VideoStats, { stats: (_d = (_c = result == null ? void 0 : result.mediaServerReport) == null ? void 0 : _c.stats) == null ? void 0 : _d.video })), /* @__PURE__ */ React210.createElement(Footer3, { result, restart: startTest, error }));
  }
  if (progress !== void 0) {
    return /* @__PURE__ */ React210.createElement(TestContainer, { css: { textAlign: "center" } }, /* @__PURE__ */ React210.createElement(Text, { css: { c: "$primary_bright", display: "flex", justifyContent: "center" } }, /* @__PURE__ */ React210.createElement(Loading, { size: "3.5rem", color: "currentColor" })), /* @__PURE__ */ React210.createElement(Text, { variant: "h6", css: { mt: "$8" } }, "Checking your connection..."), /* @__PURE__ */ React210.createElement(
      Text,
      {
        variant: "body2",
        css: { c: "$on_primary_medium", mt: "$4" }
      },
      `${ConnectivityStateMessage[progress]}...`
    ));
  }
  return null;
};
var RegionSelector = ({
  region,
  setRegion,
  startTest
}) => {
  return /* @__PURE__ */ React210.createElement(TestContainer, { css: { borderBottom: "1px solid $border_default" } }, /* @__PURE__ */ React210.createElement(Text, { variant: "body1" }, "Select a region"), /* @__PURE__ */ React210.createElement(Text, { variant: "body2", css: { c: "$on_secondary_low" } }, "Select the closest region for best results"), /* @__PURE__ */ React210.createElement(
    Flex,
    {
      justify: "between",
      css: {
        mt: "$md",
        "@lg": {
          flexDirection: "column",
          gap: "$8"
        }
      }
    },
    /* @__PURE__ */ React210.createElement(
      Flex,
      {
        css: {
          gap: "$4",
          "@lg": {
            flexDirection: "column"
          }
        }
      },
      Object.entries(Regions).map(([key, value]) => /* @__PURE__ */ React210.createElement(
        Button,
        {
          key,
          outlined: region !== key,
          variant: region === key ? "primary" : "standard",
          css: region === key ? { bg: "$primary_dim" } : {},
          onClick: () => setRegion(key)
        },
        value
      ))
    ),
    /* @__PURE__ */ React210.createElement(Flex, { css: { "@lg": { flexDirection: "column" } } }, /* @__PURE__ */ React210.createElement(Button, { variant: "primary", onClick: startTest, disabled: !startTest }, startTest ? "Start Test" : "Testing..."))
  ));
};
var ConnectivityTest = () => {
  const { hmsDiagnostics, updateStep } = useDiagnostics();
  const [region, setRegion] = useState89(Object.keys(Regions)[0]);
  const [error, setError] = useState89();
  const [progress, setProgress] = useState89();
  const [result, setResult] = useState89();
  const startTest = () => {
    updateStep(3 /* CONNECTIVITY */, { hasFailed: false, isCompleted: false });
    setError(void 0);
    setResult(void 0);
    hmsDiagnostics == null ? void 0 : hmsDiagnostics.startConnectivityCheck(
      (state) => {
        setProgress(state);
      },
      (result2) => {
        updateStep(3 /* CONNECTIVITY */, { isCompleted: true });
        setResult(result2);
      },
      region
    ).catch((error2) => {
      updateStep(3 /* CONNECTIVITY */, { hasFailed: true });
      setError(error2);
    });
  };
  return /* @__PURE__ */ React210.createElement(React210.Fragment, null, /* @__PURE__ */ React210.createElement(
    RegionSelector,
    {
      region,
      setRegion,
      startTest: progress === void 0 || progress === ConnectivityState.COMPLETED ? startTest : void 0
    }
  ), /* @__PURE__ */ React210.createElement(ConnectivityTestReport, { error, result, progress, startTest }));
};
var downloadJson = (obj, fileName) => {
  const a2 = document.createElement("a");
  const file = new Blob([JSON.stringify(obj, null, 2)], {
    type: "application/json"
  });
  a2.href = URL.createObjectURL(file);
  a2.download = `${fileName}.json`;
  a2.click();
};

// src/Diagnostics/VideoTest.tsx
init_define_process_env();
import React211, { useEffect as useEffect91, useState as useState90 } from "react";
import {
  selectDevices as selectDevices2,
  selectLocalMediaSettings as selectLocalMediaSettings2,
  selectLocalVideoTrackID as selectLocalVideoTrackID4,
  useHMSStore as useHMSStore101
} from "@100mslive/react-sdk";
import { VideoOnIcon as VideoOnIcon5 } from "@100mslive/react-icons";
var VideoTest = () => {
  const { hmsDiagnostics, updateStep } = useDiagnostics();
  const allDevices = useHMSStore101(selectDevices2);
  const { videoInput } = allDevices;
  const trackID = useHMSStore101(selectLocalVideoTrackID4);
  const sdkSelectedDevices = useHMSStore101(selectLocalMediaSettings2);
  const [error, setError] = useState90();
  useEffect91(() => {
    hmsDiagnostics == null ? void 0 : hmsDiagnostics.startCameraCheck().catch((err) => {
      updateStep(1 /* VIDEO */, { hasFailed: true });
      setError(err);
    });
  }, [hmsDiagnostics, updateStep]);
  return /* @__PURE__ */ React211.createElement(React211.Fragment, null, /* @__PURE__ */ React211.createElement(TestContainer, { css: { display: "flex", "@lg": { flexDirection: "column", alignItems: "center" } } }, trackID && /* @__PURE__ */ React211.createElement(
    StyledVideoTile.Container,
    {
      css: {
        width: "90%",
        aspectRatio: "16/9",
        mr: "$10",
        "@lg": { mr: 0, mb: "$10", aspectRatio: "1/1" }
      }
    },
    /* @__PURE__ */ React211.createElement(Video, { mirror: true, trackId: trackID })
  ), /* @__PURE__ */ React211.createElement(Flex, { direction: "column", css: { w: "100%" } }, /* @__PURE__ */ React211.createElement(Text, { variant: "body2", css: { c: "$on_primary_medium", mb: "$10" } }, "Move in front of your camera to make sure it's working. If you don't see your video, try changing the selected camera. If the camera isn't part of your computer, check your settings to make sure your system recognizes it."), /* @__PURE__ */ React211.createElement(
    DeviceSelector2,
    {
      title: "Video",
      devices: videoInput || [],
      icon: /* @__PURE__ */ React211.createElement(VideoOnIcon5, null),
      selection: sdkSelectedDevices.videoInputDeviceId,
      onChange: (deviceId) => __async(void 0, null, function* () {
        hmsDiagnostics == null ? void 0 : hmsDiagnostics.stopCameraCheck();
        hmsDiagnostics == null ? void 0 : hmsDiagnostics.startCameraCheck(deviceId);
      })
    }
  ))), /* @__PURE__ */ React211.createElement(TestFooter, { error, ctaText: "Does your video look good?" }), /* @__PURE__ */ React211.createElement(PermissionErrorModal, { error }));
};

// src/Diagnostics/Diagnostics.tsx
var DiagnosticsStepIcon = {
  [1 /* VIDEO */]: /* @__PURE__ */ React212.createElement(VideoOnIcon6, { width: "2rem", height: "2rem" }),
  [2 /* AUDIO */]: /* @__PURE__ */ React212.createElement(MicOnIcon8, { width: "2rem", height: "2rem" }),
  [0 /* BROWSER */]: /* @__PURE__ */ React212.createElement(GlobeIcon, { width: "2rem", height: "2rem" }),
  [3 /* CONNECTIVITY */]: /* @__PURE__ */ React212.createElement(ConnectivityIcon2, { width: "2rem", height: "2rem" })
};
var Container5 = ({ children }) => /* @__PURE__ */ React212.createElement(
  Box,
  {
    css: {
      px: "120px",
      pt: "120px",
      pb: "24px",
      bg: "$background_dim",
      lineHeight: "1.5",
      "-webkit-text-size-adjust": "100%",
      position: "relative",
      h: "100%",
      "@lg": {
        p: "$12"
      },
      overflowY: "auto",
      boxSizing: "border-box",
      "& *": {
        boxSizing: "border-box"
      },
      "::-webkit-scrollbar-track": {
        WebkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
        boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
        backgroundColor: "transparent"
      },
      "::-webkit-scrollbar": {
        width: "6px",
        height: "6px",
        backgroundColor: "transparent"
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#657080",
        borderRadius: "5px"
      }
    }
  },
  children
);
var DiagnosticsStepTest = () => {
  const { activeStepIndex } = useDiagnostics();
  let TestComponent = () => /* @__PURE__ */ React212.createElement(React212.Fragment, null);
  if (activeStepIndex === 2 /* AUDIO */) {
    TestComponent = AudioTest;
  } else if (activeStepIndex === 1 /* VIDEO */) {
    TestComponent = VideoTest;
  } else if (activeStepIndex === 0 /* BROWSER */) {
    TestComponent = BrowserTest;
  } else if (activeStepIndex === 3 /* CONNECTIVITY */) {
    TestComponent = ConnectivityTest;
  }
  return /* @__PURE__ */ React212.createElement(TestComponent, { key: activeStepIndex });
};
var DiagnosticsStepHeader = () => {
  const { activeStepIndex, activeStep } = useDiagnostics();
  return /* @__PURE__ */ React212.createElement(Flex, { css: { py: "$8", px: "$10", alignItems: "center", borderBottom: "1px solid $border_default" } }, /* @__PURE__ */ React212.createElement(Text, { css: { c: "$primary_bright", mt: "$xs" } }, DiagnosticsStepIcon[activeStepIndex]), /* @__PURE__ */ React212.createElement(Text, { css: { fontSize: "$h6", ml: "$9" } }, activeStep.name));
};
var DiagnosticsStepContainer = () => {
  return /* @__PURE__ */ React212.createElement(Box, { css: { border: "1px solid $border_default", r: "$1", w: "75%", maxWidth: "65rem", "@lg": { w: "100%" } } }, /* @__PURE__ */ React212.createElement(DiagnosticsStepHeader, null), /* @__PURE__ */ React212.createElement(DiagnosticsStepTest, null));
};
var DiagnosticsStepsList = () => {
  const { activeStepIndex, activeStep, steps } = useDiagnostics();
  return /* @__PURE__ */ React212.createElement(Box, { css: { w: "25%", "@lg": { display: "none" } } }, Object.keys(DiagnosticsStep).filter((key) => !isNaN(Number(key))).map((key) => {
    const keyIndex = Number(key);
    const step = steps[keyIndex];
    const isStepCompleted = activeStepIndex > keyIndex || activeStep.isCompleted;
    let color = "$on_primary_low";
    let icon = /* @__PURE__ */ React212.createElement(Text, { css: { c: color, fontSize: "1.75rem" } }, "\u2022");
    if (activeStepIndex === keyIndex) {
      color = "$on_primary_high";
      icon = /* @__PURE__ */ React212.createElement(Text, { css: { c: color, fontSize: "1.75rem" } }, "\u2022");
    }
    if (isStepCompleted) {
      color = "$primary_bright";
      icon = /* @__PURE__ */ React212.createElement(CheckCircleIcon7, { width: "1rem", height: "1rem" });
    }
    if (step.hasFailed) {
      color = "$alert_error_default";
      icon = /* @__PURE__ */ React212.createElement(CrossCircleIcon5, { width: "1rem", height: "1rem" });
    }
    return /* @__PURE__ */ React212.createElement(Flex, { key, css: { mb: "$10", c: color, gap: "$4", alignItems: "center" } }, icon, /* @__PURE__ */ React212.createElement(Text, { css: { c: color } }, step.name));
  }));
};
var DiagnosticsProvider = () => {
  const actions = useHMSActions62();
  const [activeStep, setActiveStep] = useState91(0);
  const [steps, setSteps] = useState91(initialSteps);
  const diagnosticsRef = useRef38(actions.initDiagnostics());
  const updateStep = useCallback45((step, value) => {
    setSteps((prevSteps) => __spreadProps(__spreadValues({}, prevSteps), { [step]: __spreadValues(__spreadValues({}, prevSteps[step]), value) }));
  }, []);
  return /* @__PURE__ */ React212.createElement(
    DiagnosticsContext.Provider,
    {
      value: {
        hmsDiagnostics: diagnosticsRef.current,
        activeStepIndex: activeStep,
        setActiveStep,
        steps,
        updateStep
      }
    },
    /* @__PURE__ */ React212.createElement(Container5, null, /* @__PURE__ */ React212.createElement(Text, { variant: "h4" }, "Pre-call Test"), /* @__PURE__ */ React212.createElement(Text, { variant: "md", css: { c: "$on_primary_medium" } }, "Make sure your devices and network are good to go, let's get started."), /* @__PURE__ */ React212.createElement(Flex, { css: { direction: "column", mt: "$12", justifyItems: "center" } }, /* @__PURE__ */ React212.createElement(DiagnosticsStepsList, null), /* @__PURE__ */ React212.createElement(DiagnosticsStepContainer, null)))
  );
};
var Diagnostics = () => {
  return /* @__PURE__ */ React212.createElement(HMSRoomProvider2, null, /* @__PURE__ */ React212.createElement(HMSThemeProvider, { themeType: "default" }, /* @__PURE__ */ React212.createElement(DiagnosticsProvider, null)));
};
export {
  Accordion,
  AudioLevel,
  Avatar,
  Box,
  Button,
  Checkbox,
  Collapsible,
  Diagnostics,
  Dialog,
  DialogContainerContext,
  DialogContainerProvider,
  Dropdown,
  Fieldset,
  Flex,
  Footer,
  HMSPrebuilt,
  ReactSelect_exports as HMSSelect,
  HMSThemeProvider,
  HorizontalDivider,
  IconButton,
  Input,
  Label3 as Label,
  Link,
  Loading,
  PasswordInput,
  Popover2 as Popover,
  Progress,
  QRCode,
  RadioGroup,
  Select,
  Slider,
  StyledAvatar,
  StyledMenuTile,
  StyledPagination,
  StyledVideo,
  StyledVideoList,
  StyledVideoTile,
  Switch,
  Tabs,
  Text,
  TextArea,
  ThemeContext,
  ThemeTypes,
  Toast,
  Tooltip,
  VerticalDivider,
  Video,
  VideoTileStats,
  config,
  createTheme,
  createThemeBase,
  css,
  flexCenter,
  formatBytes,
  getCssText,
  getLeft,
  globalCss,
  globalStyles,
  keyframes,
  slideLeftAndFade,
  styled,
  textEllipsis,
  theme,
  useBorderAudioLevel,
  useTheme
};
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/
//# sourceMappingURL=index.js.map
